window.KCC_V2 = 'restock-xlsx + ms-fixed + cliente-contacto (2026-09-04)';
// ══ FACTURAS ══
// Scroll infinito: las paginas se van acumulando y se cargan solas al llegar
// al final de la lista. Antes habia botones de pagina que ademas no siempre
// respondian.
var FAC_ROWS=[], FAC_FIN=false, FAC_CARGANDO=false, FAC_OBS=null;

function facFiltro(offset){
  var f='select=docnum,docdate,docduedate,cardname,doctotal,paidtodate,docstatus'
    +'&order=docdate.desc&limit='+(PAGE_SIZE+1)+'&offset='+offset;
  if(facQ){
    var q2=encodeURIComponent(facQ);
    var num=(isNaN(facQ)||facQ.trim()==='')?0:parseInt(facQ,10);
    f+='&or=(cardname.ilike.*'+q2+'*,cardcode.ilike.*'+q2+'*,docnum.eq.'+num+')';
  }
  if(facDesde) f+='&docdate=gte.'+facDesde;
  if(facHasta) f+='&docdate=lte.'+facHasta;
  if(CU.rol==='cliente') f+='&cardcode=eq.'+CU.cardcode;
  return f;
}

// `mas` = true cuando lo dispara el scroll; false cuando se cambia un filtro.
async function loadFacturas(mas){
  if(FAC_CARGANDO) return;
  if(mas && FAC_FIN) return;
  FAC_CARGANDO=true;

  if(!mas){
    FAC_ROWS=[]; FAC_FIN=false; facPage=0;
    if($('fac-table')) $('fac-table').innerHTML=loading();
  }
  facPieEstado(mas ? 'cargando' : '');

  try{
    var data = await q('vista_facturas', facFiltro(facPage*PAGE_SIZE)) || [];
    FAC_FIN = data.length <= PAGE_SIZE;
    if(!FAC_FIN) data = data.slice(0, PAGE_SIZE);
    FAC_ROWS = FAC_ROWS.concat(data);
    facPage++;
    if($('fac-table')) $('fac-table').innerHTML = tablFacturas(FAC_ROWS);
    facPieEstado('');
  }catch(e){
    facPieEstado('error');
  }finally{
    FAC_CARGANDO=false;
  }
  facObservar();
}

// El pie hace de centinela: cuando entra en pantalla, se pide la pagina
// siguiente. Asi no hace falta escuchar el scroll de ningun contenedor.
function facPieEstado(modo){
  var p=$('fac-pager'); if(!p) return;
  if(modo==='cargando'){
    p.innerHTML='<div style="padding:14px;text-align:center;color:var(--text3);'
      +'font-size:12.5px">Cargando m\u00e1s facturas\u2026</div>';
  } else if(modo==='error'){
    p.innerHTML='<div style="padding:14px;text-align:center;font-size:12.5px">'
      +'<span style="color:var(--red)">No se pudieron cargar m\u00e1s.</span> '
      +'<button class="btn btn-sm" onclick="loadFacturas(true)">Reintentar</button></div>';
  } else if(FAC_FIN){
    p.innerHTML = FAC_ROWS.length
      ? ('<div style="padding:14px;text-align:center;color:var(--text3);font-size:12px">'
         +FAC_ROWS.length+' factura(s) \u00b7 no hay m\u00e1s</div>')
      : '';
  } else {
    p.innerHTML='<div id="fac-centinela" style="height:1px"></div>';
  }
}

function facObservar(){
  if(FAC_OBS){ FAC_OBS.disconnect(); FAC_OBS=null; }
  if(FAC_FIN) return;
  var c=document.getElementById('fac-centinela'); if(!c) return;
  if(!('IntersectionObserver' in window)){
    // Navegador antiguo: un boton normal y listo.
    var p=$('fac-pager');
    if(p) p.innerHTML='<div style="padding:12px;text-align:center">'
      +'<button class="btn btn-sm" onclick="loadFacturas(true)">Cargar m\u00e1s</button></div>';
    return;
  }
  // rootMargin: se pide la siguiente pagina ANTES de llegar al borde, para que
  // la lista no se quede en blanco mientras carga.
  FAC_OBS=new IntersectionObserver(function(e){
    if(e[0] && e[0].isIntersecting) loadFacturas(true);
  }, {rootMargin:'400px'});
  FAC_OBS.observe(c);
}

let facTimer2=null;
function searchFacturas(v){facQ=v;clearTimeout(facTimer2);
  facTimer2=setTimeout(function(){ loadFacturas(false); },400);}
function facFecha(){facDesde=($('fac-desde')||{}).value||'';
  facHasta=($('fac-hasta')||{}).value||''; loadFacturas(false);}
function facLimpiar(){facQ='';facDesde='';facHasta='';facPage=0;var s=$('fac-search');if(s)s.value='';var d=$('fac-desde');if(d)d.value='';var h=$('fac-hasta');if(h)h.value='';loadFacturas(false);}

// ══ INVENTARIO ══
let invCats=[], invHasNew=null;
// Detecta si la vista ya tiene las columnas nuevas (subg, numinbuy, bajostock)
async function invCols(){
  // Sin red no hay columnas extra que consultar: se responde ya.
  if(!navigator.onLine) return false;
  if(invHasNew!==null) return invHasNew;
  try{
    const r=await fetch(`${SB}/rest/v1/vista_inventario?select=subg,numinbuy,bajostock&limit=1`,{headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK()}});
    invHasNew=r.ok;
  }catch(e){ invHasNew=false; }
  return invHasNew;
}
var TIPOS_OCULTOS=['zapatilla','bota','sandalia','zapato','bailarina','tacon','mocasine','chancleta','pantunfla'];
function tipoVisible(code){
  var label=subgLabel(code);
  if(!label||label==='—') return false;
  if(label===String(code).trim()) return false; // codigo crudo no traducido (029, ABAN, MOST...)
  var low=label.toLowerCase();
  for(var i=0;i<TIPOS_OCULTOS.length;i++){ if(low.indexOf(TIPOS_OCULTOS[i])>=0) return false; }
  return true;
}
var COL_LISTA=null, COL_ITEMS={};
async function cargarColecciones(){
  if(COL_LISTA!==null) return COL_LISTA;
  try{ var r=await q('lista_colecciones','select=coleccion,items&order=coleccion'); COL_LISTA=r||[]; }
  catch(e){ COL_LISTA=[]; }
  COL_NORM={}; COL_LISTA.forEach(function(c){ COL_NORM[arbNorm(c.coleccion)]=c.coleccion; });
  return COL_LISTA;
}
async function coleccionItemcodes(col){
  if(!col) return null;
  if(COL_ITEMS[col]) return COL_ITEMS[col];
  try{
    var r=await q('colecciones','select=itemcode&coleccion=eq.'+encodeURIComponent(col)+'&limit=20000');
    COL_ITEMS[col]=(r||[]).map(function(x){return x.itemcode;});
  }catch(e){ COL_ITEMS[col]=[]; }
  return COL_ITEMS[col];
}
function llenarSelectColecciones(selId){
  var sel=document.getElementById(selId); if(!sel||sel.dataset.listo) return;
  cargarColecciones().then(function(list){
    if(!list || !list.length) return;
    list.forEach(function(c){ var o=document.createElement('option'); o.value=c.coleccion; o.textContent=c.coleccion+' ('+c.items+')'; sel.appendChild(o); });
    sel.dataset.listo='1';
  });
}
function invColeccion(v){ invColF=v; invPage=0; invRenderTipos(); loadInventario(); }
function catColeccion(v){ catColF=v; catPage=0; catRenderTipos(); catCargar(); }
function panelItem(label,activo,onclick,acentoRojo){
  var col=acentoRojo?'#e85424':'var(--blue)';
  return '<div onclick="'+onclick+'" title="'+String(label).replace(/"/g,'&quot;')+'" style="padding:7px 10px;font-size:12px;border-radius:8px;cursor:pointer;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'
    +(activo?'background:'+col+';color:#fff;font-weight:600':'color:var(--text2)')+'">'+label+'</div>';
}
function panelHeader(txt){
  return '<div style="font-size:10px;font-weight:700;color:var(--text3);text-transform:uppercase;letter-spacing:.06em;padding:8px 8px 6px">'+txt+'</div>';
}
// ── Arbol de colecciones (menu de Shopify) ──
var ARBOL_COL = [{"n": "HOGAR", "c": [{"n": "COCINA", "c": [{"n": "Organizador de Cocina"}, {"n": "Juegos de Cuchillo"}, {"n": "Hornear"}, {"n": "Utensilios y Gadgets"}, {"n": "Dispensador"}, {"n": "Escurridores"}, {"n": "Coladores"}, {"n": "Picadores y Ralladores"}, {"n": "Sartenes y Ollas"}, {"n": "Saleros y Pimenteros"}, {"n": "Envase"}, {"n": "Guantes"}, {"n": "Tabla de Picar"}, {"n": "Moldes"}]}, {"n": "MESA", "c": [{"n": "Vajillas"}, {"n": "Manteles e Individuales"}, {"n": "Porcelana"}, {"n": "Cristalería Vasos y Copas"}, {"n": "Bowl y Ensaladeras"}, {"n": "Bandeja de Servir"}, {"n": "Cubertería"}, {"n": "Floreros"}, {"n": "Teteras Y Cafeteras"}, {"n": "Servilleteros"}, {"n": "Jarras"}, {"n": "Cuchillo"}, {"n": "Botella"}]}, {"n": "DECORACIÓN", "c": [{"n": "Storage"}, {"n": "Rieles de Cortinas"}, {"n": "Cuadros"}, {"n": "Porta Retratos"}, {"n": "Cojines"}, {"n": "Candelabros"}, {"n": "Ganchos"}, {"n": "Adornos"}, {"n": "Espejos Decorativos"}, {"n": "Reloj y Arte de Pared"}, {"n": "Floreros"}, {"n": "Flores Artificiales"}, {"n": "Macetero"}, {"n": "Tiradores"}, {"n": "Estante"}, {"n": "Cortinas"}, {"n": "Baul"}]}, {"n": "BAÑO", "c": [{"n": "Organizador de Baño"}, {"n": "Cortina para Baño"}, {"n": "Toallas"}, {"n": "Auxiliares de Baño"}, {"n": "Ducha"}, {"n": "Tendedero"}, {"n": "Tabla de Planchar"}, {"n": "Articulos de Limpieza"}, {"n": "Basurero"}]}, {"n": "MARCAS", "c": [{"n": "BETTY CROCKER"}, {"n": "JOSEPH & JOSEPH"}, {"n": "PROGRESSIVE"}, {"n": "KITCHEN DETAILS"}, {"n": "KITCHEN HELPER"}, {"n": "BATH BLISS"}, {"n": "SIMPLIFY"}, {"n": "KENNEDY HOME COLLECTION"}, {"n": "OREO"}]}]}, {"n": "ALFOMBRAS", "c": [{"n": "AREA", "c": [{"n": "SALA"}, {"n": "COMEDOR"}, {"n": "DORMITORIO"}, {"n": "PASILLOS"}, {"n": "EXTERIORES"}]}, {"n": "BAÑO", "c": [{"n": "ALFOMBRAS DE BAÑO"}, {"n": "JUEGOS DE BAÑO"}]}, {"n": "COCINA", "c": [{"n": "ALFOMBRAS DE COCINA"}, {"n": "JUEGOS DE COCINA"}]}, {"n": "ENTRADA", "c": [{"n": "SINTETICO"}, {"n": "NATURAL"}]}, {"n": "NIÑOS", "c": [{"n": "DIDACTICO"}, {"n": "DECORATIVO"}]}, {"n": "DISPLAY BOX"}, {"n": "EXHIBIDORES"}]}, {"n": "MUEBLES", "c": [{"n": "SALA", "c": [{"n": "Sofa"}, {"n": "Seccionales"}, {"n": "Butaca - Silla"}, {"n": "Mesita"}, {"n": "TV Stand"}, {"n": "Consola"}, {"n": "Sofa Cama"}, {"n": "Bar"}, {"n": "Librero"}]}, {"n": "CUARTO", "c": [{"n": "Cama"}, {"n": "Mesita de Noche"}, {"n": "Armario"}, {"n": "Colchones"}, {"n": "Camarote"}, {"n": "Cuna"}, {"n": "Perchero"}]}, {"n": "OFICINA", "c": [{"n": "Silla de Oficina"}, {"n": "Escritorio"}, {"n": "Librero de Oficina"}, {"n": "Mesa de Oficina"}, {"n": "Gavetero"}]}, {"n": "EXTERIOR", "c": [{"n": "Mesa de Exterior"}, {"n": "Silla de Exterior"}, {"n": "Paragua"}, {"n": "Tolda"}, {"n": "Sofa de Exterior"}, {"n": "Juego de Comedor"}]}, {"n": "COMEDOR", "c": [{"n": "Silla de Comedor"}, {"n": "Juego de Comedor"}, {"n": "Mesa de Comedor"}, {"n": "Bufetera"}]}, {"n": "COCINA", "c": [{"n": "Silla de Bar"}, {"n": "Cocineta"}, {"n": "Organizador"}, {"n": "Carrito para Servir"}]}]}, {"n": "BEDDING", "c": [{"n": "COLCHONES", "c": [{"n": "VER TODOS"}, {"n": "KING KOIL"}, {"n": "SOHO"}, {"n": "AIRLOOM"}, {"n": "KINGSDOWN"}]}, {"n": "CAMA", "c": [{"n": "JUEGO DE SABANAS"}, {"n": "JUEGOS DE DUVET"}, {"n": "ALMOHADAS"}, {"n": "PROTECTOR DE COLCHON"}, {"n": "FUNDA PARA ALMOHADAS"}]}]}, {"n": "ELECTRÓNICA", "c": [{"n": "AUDIO Y VIDEO", "c": [{"n": "Televisores Smart TV"}, {"n": "Televisores LED"}, {"n": "Bocinas Bluetooth"}, {"n": "Bocinas amplIficadas"}, {"n": "Accesorios A/V"}, {"n": "Gaming"}]}, {"n": "ELECTRODOMESTICOS", "c": [{"n": "LICUADORAS"}, {"n": "CAFETERAS"}, {"n": "OLLAS DE COCCIÓN LENTA"}, {"n": "TOSTAHORNOS"}, {"n": "FREIDORAS"}, {"n": "OLLAS ARROCERAS"}, {"n": "ESTUFAS"}]}, {"n": "SALUD Y BELLEZA", "c": [{"n": "SECADORAS DE PELO"}]}, {"n": "FERRETERIA Y MUEBLES", "c": [{"n": "MUEBLES DE TELEVISOR"}, {"n": "SOPORTES PARA TELEVISION/MONITOR"}, {"n": "SOPORTE DVD"}]}, {"n": "LINEA BLANCA", "c": [{"n": "REFRIGERADORAS"}, {"n": "CONGELADORES"}, {"n": "ABANICOS"}, {"n": "AIRE ACONDICIONADO"}]}]}, {"n": "FERRETERÍA Y ALMACENAMIENTO", "c": [{"n": "MALETAS"}, {"n": "HERRAMIENTAS MANUALES"}, {"n": "PINTURA"}, {"n": "JARDIN"}, {"n": "ALMACENAMIENTO Y ORGANIZACIÓN"}, {"n": "INSTALACIONES, ACCESORIOS Y ADHESIVOS"}, {"n": "EXTENSIONES ELÉCTRICAS Y ADAPTADORES"}, {"n": "SEGURIDAD"}]}, {"n": "ROPA", "c": [{"n": "HOMBRE", "c": [{"n": "Camisa"}, {"n": "Corbata"}, {"n": "Correa"}, {"n": "Gorra"}, {"n": "Jacket"}, {"n": "Jeans"}, {"n": "Medias"}, {"n": "Pantalon"}, {"n": "Pijama"}, {"n": "Polos"}, {"n": "Sacos"}, {"n": "Short"}, {"n": "Sweater"}, {"n": "T-Shirt"}, {"n": "Vestido De Bano"}]}, {"n": "DAMA", "c": [{"n": "Blusa"}, {"n": "Camisa"}, {"n": "Capri"}, {"n": "Falda"}, {"n": "Jacket"}, {"n": "Jeans"}, {"n": "Legging"}, {"n": "Pantalon"}, {"n": "Panty"}, {"n": "Pijama"}, {"n": "Polos"}, {"n": "Short"}, {"n": "Sudaderas"}, {"n": "T-Shirt"}, {"n": "Top"}]}, {"n": "NIÑA", "c": [{"n": "Jacket"}, {"n": "Jeans"}, {"n": "Legging"}, {"n": "Medias"}, {"n": "Pantalon"}, {"n": "Short"}]}, {"n": "NIÑO", "c": [{"n": "Calzoncillo"}, {"n": "Camisa"}, {"n": "Corbata"}, {"n": "Correa"}, {"n": "Jeans"}, {"n": "Medias"}, {"n": "Pantalon"}, {"n": "Polos"}, {"n": "Sacos"}, {"n": "Sweater"}, {"n": "T-Shirt"}, {"n": "Vestido De Bano"}]}, {"n": "BEBE", "c": [{"n": "Pijama"}]}]}, {"n": "HOME DECO", "c": [{"n": "MUEBLES", "c": [{"n": "Otomanos"}, {"n": "Bancos"}, {"n": "Auxiliares"}, {"n": "Sofas Deco"}, {"n": "Mesas de Centro"}, {"n": "Consolas"}, {"n": "Gabinetes"}, {"n": "Sillas / Potronas"}, {"n": "Camas Deco"}]}, {"n": "DECORACION", "c": [{"n": "Cuadros"}, {"n": "Reloj y Arte de Pared"}, {"n": "Baul"}, {"n": "Flores"}, {"n": "Cojines"}, {"n": "Portaretratos"}, {"n": "Bandejas"}, {"n": "Adornos"}, {"n": "Maceteros/Floreros"}, {"n": "Espejos"}, {"n": "Candelabros"}, {"n": "Comida Artificial"}, {"n": "Storage"}]}]}, {"n": "CAMPAMENTO"}];
var ARB_NODES = {}, ARB_EXP = {}, arbSelInv = '', arbSelCat = '', COL_NORM = {};
var invTipos = null, catTipos = null;
(function(){ var asg=function(arr,pre){ if(!arr)return; arr.forEach(function(nd,i){ var id=pre+'_'+i; nd._id=id; ARB_NODES[id]=nd; if(nd.c) asg(nd.c,id); }); }; asg(ARBOL_COL,'a'); })();
function arbNorm(s){ return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim(); }
function arbNombres(nd){ var out=[nd.n]; if(nd.c) nd.c.forEach(function(x){ out=out.concat(arbNombres(x)); }); return out; }
async function arbolItemcodes(nd){
  if(!navigator.onLine) return null;   // sin red no hay colecciones: no se filtra
  var nombres=arbNombres(nd), reales={};

  // El nombre del arbol no siempre coincide con el de la tabla: el arbol dice
  // "JUEGO DE SABANAS" y la coleccion se llama "Sabanas". Se intenta primero
  // la coincidencia exacta y, si falla, se busca por la parte significativa.
  nombres.forEach(function(nm){
    var k = arbNorm(nm);
    if(COL_NORM[k]){ reales[COL_NORM[k]] = 1; return; }

    // Se quitan las palabras de relleno y se prueba con lo que queda.
    var limpio = k.replace(/\b(juego|juegos|set|sets|de|del|la|el|los|las|y|con|para|por)\b/g,' ')
                  .replace(/\s+/g,' ').trim();
    if(limpio && COL_NORM[limpio]){ reales[COL_NORM[limpio]] = 1; return; }

    // Y si tampoco, cualquier coleccion que contenga esa palabra o al reves.
    // Se exige 4 letras o mas para no cazar cosas por casualidad.
    if(limpio.length >= 4){
      Object.keys(COL_NORM).forEach(function(ck){
        if(ck.indexOf(limpio) >= 0 || limpio.indexOf(ck) >= 0){
          reales[COL_NORM[ck]] = 1;
        }
      });
    }
  });

  if(!Object.keys(reales).length){
    console.warn('[colecciones] ningun nombre del arbol existe en la tabla:', nombres);
  }
  var set={}, keys=Object.keys(reales);
  for(var i=0;i<keys.length;i++){ var codes=await coleccionItemcodes(keys[i]); if(codes) codes.forEach(function(c){set[c]=1;}); }
  return Object.keys(set);
}
function arbToggle(id){ ARB_EXP[id]=!ARB_EXP[id]; var inv=document.getElementById('page-inventario'); if(inv&&inv.classList.contains('active')) invRenderTipos(); else catRenderTipos(); }
function arbHTML(selId, fnSel, acento){
  function nodo(nd,niv){
    var tiene=nd.c&&nd.c.length, exp=ARB_EXP[nd._id], activo=(selId===nd._id);
    var cls='arb-row'+(niv===0?' lvl0':'')+(activo?' sel':'');
    var stylesel=activo?'background:'+acento+';color:#fff;':'';
    var marca=tiene
      ? '<span class="arb-tri'+(exp?' open':'')+'">▶</span>'
      : (niv===0?'<span class="arb-dept-dot"></span>':'<span class="arb-dot"></span>');
    var dept=(niv===0&&tiene)?'<span class="arb-dept-dot"></span>':'';
    // Solo las HOJAS filtran. Un padre agrupa colecciones que pueden no tener
    // nada que ver entre si, y al pulsarlo salia una mezcla sin sentido: se
    // limita a abrirse y cerrarse.
    var accion = tiene
      ? ('arbToggle(\''+nd._id+'\')')
      : (fnSel+'(\''+nd._id+'\')');
    var titulo = tiene
      ? (npEsc(nd.n)+' \u00b7 pulsa para desplegar')
      : npEsc(nd.n);
    var row='<div class="'+cls+'" onclick="'+accion+'" title="'+titulo+'" style="'+stylesel
      +(tiene?';font-weight:600':'')+'">'+marca+dept+'<span class="arb-nm">'+npEsc(nd.n)+'</span></div>';
    var hijos=(tiene&&exp)?'<div class="arb-children">'+nd.c.map(function(x){return nodo(x,niv+1);}).join('')+'</div>':'';
    return '<div class="arb-node">'+row+hijos+'</div>';
  }
  return ARBOL_COL.map(function(nd){return nodo(nd,0);}).join('');
}
function invSelArbol(id){
  // Por si acaso: si llegara el id de un padre (por un enlace viejo o el
  // teclado), no se filtra. Los padres solo despliegan.
  var nd = ARB_NODES[id];
  if(nd && nd.c && nd.c.length){ arbToggle(id); return; }
  arbSelInv=(arbSelInv===id?'':id); invPage=0; invRenderTipos(); loadInventario();
}
function catSelArbol(id){
  var nd = ARB_NODES[id];
  if(nd && nd.c && nd.c.length){ arbToggle(id); return; }
  arbSelCat=(arbSelCat===id?'':id); catPage=0; catRenderTipos(); catCargar();
}
function tiposDedup(cats){
  var map={}, orden=[];
  (cats||[]).forEach(function(c){ var lab=subgLabel(c); if(!map[lab]){ map[lab]=[]; orden.push(lab); } map[lab].push(c); });
  orden.sort(function(a,b){return a.localeCompare(b);});
  return {map:map, labels:orden};
}
async function obtenerTipos(){
  // 1) Intentar la vista de tipos (rapida y completa)
  try{
    const v=await q('tipos_inventario','select=subg&limit=5000');
    if(v && v.length){
      const s=[...new Set(v.map(c=>c.subg).filter(x=>x!=null&&x!==''))].filter(tipoVisible);
      if(s.length) return s;
    }
  }catch(e){}
  // 2) Respaldo: muestrear el inventario directamente
  try{
    const v=await q('vista_inventario','select=subg&subg=not.is.null&limit=60000');
    return [...new Set((v||[]).map(c=>c.subg).filter(x=>x!=null&&x!==''))].filter(tipoVisible);
  }catch(e){ return []; }
}
// ══ MULTI-SELECT DE GRUPOS (dropdown con checkboxes + buscador) ══
// Componente reutilizable. Guarda el estado en window._msGrupos[id] = { sel:Set, grupos:[], onChange }
// [FIX SAFARI/iOS] Ver notas al final del bloque.
window._msGrupos = window._msGrupos || {};
function _msLbl(g){ return String(g).replace(/^[.\s]+/,''); }
// Escapa para usar dentro de un atributo HTML (npEsc no escapa comillas).
function _msAttr(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
// Construye/actualiza el dropdown dentro del contenedor con id dado.
function msGruposInit(contId, grupos, onChange){
  var cont=document.getElementById(contId); if(!cont) return;
  var st=window._msGrupos[contId] || { sel:new Set(), grupos:[], onChange:onChange, open:false };
  st.grupos=grupos||st.grupos||[]; st.onChange=onChange||st.onChange;
  window._msGrupos[contId]=st;
  msGruposRender(contId);
}
function msGruposRender(contId){
  var cont=document.getElementById(contId); if(!cont) return;
  var st=window._msGrupos[contId]; if(!st) return;

  // [FIX iOS] Si el buscador de ESTE dropdown tiene el foco, lo restauramos
  // después del re-render; si no, el teclado del iPhone se cierra a cada letra.
  var ae=document.activeElement, refoc=false, caret=null;
  if(ae && ae.classList && ae.classList.contains('ms-q') && cont.contains(ae)){
    refoc=true; try{ caret=ae.selectionStart; }catch(_e){}
  }

  var n=st.sel.size;
  var btnTxt = n===0 ? 'Todos los grupos' : (n===1 ? _msLbl([...st.sel][0]) : (n+' grupos'));
  var q=(st.query||'').toLowerCase();
  var lista=st.grupos.filter(function(g){ return !q || _msLbl(g).toLowerCase().indexOf(q)>=0; });
  var items=lista.map(function(g){
    var on=st.sel.has(g);
    // [FIX SAFARI] Antes era <label> + <input type=checkbox style="display:none">.
    // WebKit no reenvía el clic del label a un control con display:none, así que
    // en Safari nunca se disparaba el onchange. Ahora es un div con onclick propio.
    return '<div class="ms-item" data-g="'+_msAttr(g)+'" onclick="msGruposToggle(\''+contId+'\',this.getAttribute(\'data-g\'))" '
      +'style="display:flex;align-items:center;gap:8px;padding:9px 12px;cursor:pointer;font-size:13px;border-radius:8px;-webkit-tap-highlight-color:transparent;touch-action:manipulation">'
      +'<span class="ms-chk" style="width:18px;height:18px;border-radius:5px;border:2px solid '+(on?'var(--blue,#2563eb)':'var(--border,#d1d5db)')+';background:'+(on?'var(--blue,#2563eb)':'transparent')+';display:flex;align-items:center;justify-content:center;flex:0 0 auto;transition:all .12s;pointer-events:none">'
      +(on?'<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" style="pointer-events:none"><polyline points="20 6 9 17 4 12"/></svg>':'')
      +'</span>'
      +'<span style="flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none">'+npEsc(_msLbl(g))+'</span>'
      +'</div>';
  }).join('');

  cont.innerHTML=''
    +'<div style="position:relative;display:inline-block">'
    // [FIX SAFARI] class="ms-btn" para identificarlo sin depender del atributo onclick,
    // y pointer-events:none en los iconos para que e.target sea siempre el botón.
    +'<button type="button" class="ms-btn" onclick="msGruposOpen(\''+contId+'\')" style="display:flex;align-items:center;gap:6px;padding:6px 12px;border:1px solid var(--border,#d1d5db);border-radius:20px;font-size:12px;background:var(--surface,#fff);color:var(--text2,#374151);outline:none;cursor:pointer;white-space:nowrap;-webkit-tap-highlight-color:transparent;touch-action:manipulation">'
      +'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="pointer-events:none"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>'
      +'<span style="pointer-events:none">'+npEsc(btnTxt)+'</span>'
      +(n>0?'<span style="background:var(--blue,#2563eb);color:#fff;border-radius:10px;padding:0 6px;font-size:10px;font-weight:700;min-width:16px;text-align:center;pointer-events:none">'+n+'</span>':'')
      +'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="pointer-events:none"><polyline points="6 9 12 15 18 9"/></svg>'
      +'</button>'
    +'<div class="ms-pop" style="display:'+(st.open?'flex':'none')+';flex-direction:column;position:fixed;left:0;top:0;z-index:99999;width:280px;max-width:calc(100vw - 24px);background:var(--surface,#fff);border:1px solid var(--border,#e5e7eb);border-radius:12px;box-shadow:0 10px 40px rgba(0,0,0,.15);overflow:hidden">'
      +'<div style="padding:10px;border-bottom:1px solid var(--border,#eee)">'
        +'<input type="text" class="ms-q" placeholder="Buscar grupo..." value="'+_msAttr(st.query||'')+'" oninput="msGruposSearch(\''+contId+'\',this.value)" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" style="width:100%;padding:8px 10px;border:1px solid var(--border,#d1d5db);border-radius:8px;font-size:16px;outline:none;box-sizing:border-box">'
      +'</div>'
      +'<div style="display:flex;gap:6px;padding:8px 10px;border-bottom:1px solid var(--border,#eee)">'
        +'<button type="button" onclick="msGruposTodos(\''+contId+'\')" style="flex:1;padding:7px;border:1px solid var(--border,#d1d5db);border-radius:7px;background:var(--surface,#fff);font-size:11px;cursor:pointer;color:var(--text2,#374151);-webkit-tap-highlight-color:transparent">Seleccionar todos</button>'
        +'<button type="button" onclick="msGruposLimpiar(\''+contId+'\')" style="flex:1;padding:7px;border:1px solid var(--border,#d1d5db);border-radius:7px;background:var(--surface,#fff);font-size:11px;cursor:pointer;color:var(--text2,#374151);-webkit-tap-highlight-color:transparent">Limpiar</button>'
      +'</div>'
      +'<div class="ms-list" style="flex:1 1 auto;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:6px">'+(items||'<div style="padding:14px;text-align:center;color:var(--text3,#9ca3af);font-size:12px">Sin resultados</div>')+'</div>'
      +'<div style="padding:8px 10px;border-top:1px solid var(--border,#eee);display:flex;justify-content:flex-end;flex:0 0 auto">'
        +'<button type="button" onclick="msGruposAplicar(\''+contId+'\')" style="padding:8px 16px;border:none;border-radius:8px;background:var(--blue,#2563eb);color:#fff;font-size:12px;font-weight:600;cursor:pointer;-webkit-tap-highlight-color:transparent">Aplicar</button>'
      +'</div>'
    +'</div>'
    +'</div>';

  // [FIX SAFARI] Si este componente queda dentro de un <label> (como pasa en
  // el liquid: "Grupo" envuelve al menu), WebKit reenvia el clic al primer
  // control del label -- que es nuestro propio boton -- y msGruposOpen se
  // ejecuta DOS veces: st.open se invierte dos veces y el menu abre y cierra
  // en el mismo toque. Cancelar la accion por defecto desactiva ese reenvio.
  var root=cont.firstChild;
  if(root && root.addEventListener){
    root.addEventListener('click', function(e){ e.preventDefault(); }, false);
    // Y en mousedown el label tambien roba el foco hacia el boton; lo evitamos
    // salvo cuando el clic va de verdad a un campo de texto.
    root.addEventListener('mousedown', function(e){
      if(e.target && e.target.closest && e.target.closest('input,textarea,select')) return;
      e.preventDefault();
    }, false);
  }

  if(refoc){
    var inp=cont.querySelector('.ms-q');
    if(inp){ inp.focus(); if(caret!=null){ try{ inp.setSelectionRange(caret,caret); }catch(_e){} } }
  }

  if(st.open) _msPosicionar(contId);
}

// [FIX IPAD] El menu era position:absolute dentro de la tarjeta. En iPad y
// iPhone, kennedy-ipad.css aplica `.card{overflow-x:auto}` por debajo de
// 1366px, y por especificacion CSS eso convierte tambien overflow-y en auto:
// la tarjeta pasa a recortar y el pie del menu -- el boton Aplicar -- quedaba
// fuera y no se veia. En escritorio no ocurria porque esa regla no entra.
//
// Con position:fixed ningun ancestro puede recortarlo, pero hay que calcular
// las coordenadas a mano respecto al boton.
function _msPosicionar(contId){
  var cont=document.getElementById(contId); if(!cont) return;
  var btn=cont.querySelector('.ms-btn'), pop=cont.querySelector('.ms-pop');
  if(!btn||!pop) return;

  var r=btn.getBoundingClientRect();
  var vw=window.innerWidth, vh=window.innerHeight, M=10;

  // Ancho real disponible (en pantallas estrechas el max-width manda).
  var w=Math.min(280, vw-2*M);
  pop.style.width=w+'px';

  var left=Math.min(Math.max(M, r.left), vw-w-M);
  pop.style.left=left+'px';

  // Hueco real por debajo y por encima del boton.
  var abajo = vh - r.bottom - 6 - M;
  var arriba = r.top - 6 - M;

  // Se abre hacia abajo si entra comodo; si no, hacia el lado con mas sitio.
  // El max-height es EXACTAMENTE el hueco disponible, sin minimos: si se le
  // pone un suelo mayor que el hueco, el pie con Aplicar vuelve a salirse.
  // Lo que no entra se desplaza dentro de la lista, que es flex:1.
  if(abajo >= 240 || abajo >= arriba){
    pop.style.maxHeight = Math.max(120, abajo)+'px';
    pop.style.top = (r.bottom+6)+'px';
  } else {
    pop.style.maxHeight = Math.max(120, arriba)+'px';
    // Se mide DESPUES de aplicar el max-height: offsetHeight ya viene
    // recortado, asi que el menu queda anclado justo encima del boton.
    var h = pop.offsetHeight;
    pop.style.top = Math.max(M, r.top - 6 - h)+'px';
  }
}

// Al desplazar o girar el iPad, el boton se mueve y el menu (fijo) se queda.
// Se recoloca mientras haya alguno abierto.
(function(){
  function recolocar(){
    var abiertos=Object.keys(window._msGrupos||{}).filter(function(k){
      return window._msGrupos[k] && window._msGrupos[k].open;
    });
    abiertos.forEach(_msPosicionar);
  }
  window.addEventListener('scroll', recolocar, true);   // true: tambien en contenedores internos
  window.addEventListener('resize', recolocar);
  window.addEventListener('orientationchange', function(){ setTimeout(recolocar,150); });
})();
function msGruposOpen(contId){
  var st=window._msGrupos[contId]; if(!st) return;
  // Cerrar otros abiertos
  Object.keys(window._msGrupos).forEach(function(k){ if(k!==contId) window._msGrupos[k].open=false; });
  st.open=!st.open;
  Object.keys(window._msGrupos).forEach(function(k){ msGruposRender(k); });
}
function msGruposSearch(contId,v){ var st=window._msGrupos[contId]; if(!st)return; st.query=v; msGruposRender(contId); }
function msGruposToggle(contId,g){ var st=window._msGrupos[contId]; if(!st)return; if(st.sel.has(g))st.sel.delete(g); else st.sel.add(g); msGruposRender(contId); }
function msGruposTodos(contId){ var st=window._msGrupos[contId]; if(!st)return; var q=(st.query||'').toLowerCase(); st.grupos.filter(function(g){return !q||_msLbl(g).toLowerCase().indexOf(q)>=0;}).forEach(function(g){st.sel.add(g);}); msGruposRender(contId); }
function msGruposLimpiar(contId){ var st=window._msGrupos[contId]; if(!st)return; st.sel.clear(); msGruposRender(contId); }
function msGruposAplicar(contId){ var st=window._msGrupos[contId]; if(!st)return; st.open=false; st.query=''; msGruposRender(contId); if(typeof st.onChange==='function') st.onChange([...st.sel]); }
function msGruposGet(contId){ var st=window._msGrupos[contId]; return st?[...st.sel]:[]; }

// ── Cerrar al hacer clic fuera ──────────────────────────────────────────────
// [FIX SAFARI — este era el motivo de que el menú no abriera en Safari/iPhone]
// Antes el listener corría en fase de BURBUJA, o sea DESPUÉS del onclick del
// botón. Ese onclick ya había hecho cont.innerHTML=... y destruido el botón,
// así que e.target llegaba aquí desprendido del DOM y su .closest() devolvía
// null en WebKit => se interpretaba como "clic fuera" y cerraba el menú en el
// mismo clic que lo abría (por eso parecía que no abría nunca).
// Ahora corre en fase de CAPTURA (tercer argumento true): se ejecuta ANTES del
// onclick, con el DOM todavía intacto, así que closest() acierta siempre.
function _msFueraHandler(e){
  var t=e.target;
  var dentro = (t && t.closest) ? t.closest('.ms-pop, .ms-btn') : null;
  if(dentro) return;
  var cambio=false;
  Object.keys(window._msGrupos||{}).forEach(function(k){
    if(window._msGrupos[k].open){ window._msGrupos[k].open=false; cambio=true; }
  });
  if(cambio) Object.keys(window._msGrupos).forEach(function(k){ msGruposRender(k); });
}
document.addEventListener('click', _msFueraHandler, true);
// [FIX iOS] En iPhone un toque sobre un elemento no interactivo puede no generar
// evento 'click', así que el menú no se cerraría al tocar fuera. touchstart sí llega.
document.addEventListener('touchstart', _msFueraHandler, true);

var invGrupoF='', invGruposLoaded=false, invGrupoCache={}, invGruposSel=[];
function invGrupo(v){ invGrupoF=v||''; invPage=0; loadInventario(); }
var invMarcaF='', invMarcasLoaded=false, invMarcaCache={};
function invMarca(v){ invMarcaF=v||''; invPage=0; loadInventario(); }
async function invCargarMarcas(){
  if(invMarcasLoaded) return; invMarcasLoaded=true;
  var sel=document.getElementById('inv-marca'); if(!sel) return;
  var marcas=[];
  // Fuente rápida: vista de marcas distintas (una sola consulta) -> instantáneo
  try{ var rows=await q('marcas_inventario','select=marca&order=marca'); marcas=(rows||[]).map(function(r){return (r.marca||'').trim();}).filter(Boolean); }catch(e){}
  // Respaldo (si la vista aún no existe): marcas distintas desde la columna
  if(!marcas.length){
    try{ var rs=await q('inventario','select=marca&marca=not.is.null&limit=20000'); var st={}; (rs||[]).forEach(function(r){ var m=(r.marca||'').trim(); if(m) st[m]=1; }); marcas=Object.keys(st); }catch(e){}
  }
  marcas=marcas.sort(function(a,b){return a.localeCompare(b,'es',{sensitivity:'base'});});
  if(!marcas.length){ invMarcasLoaded=false; return; }
  var cur=sel.value;
  sel.innerHTML='<option value="">Todas las marcas</option>'+marcas.map(function(m){ return '<option value="'+npEsc(m)+'">'+npEsc(m)+'</option>'; }).join('');
  sel.value=cur;
}
async function invMarcaCodes(m){
  if(!navigator.onLine) return [];
  if(invMarcaCache[m]) return invMarcaCache[m];
  var codes=[], seen={};
  try{ var rows=await qAll('inventario','select=itemcode&marca=eq.'+encodeURIComponent(m)+'&order=itemcode');
    (rows||[]).forEach(function(r){ var c=r.itemcode; if(c && !seen[c]){ seen[c]=1; codes.push(c); } }); }catch(e){}
  invMarcaCache[m]=codes; return codes;
}
async function invCargarGrupos(){
  if(invGruposLoaded) return; invGruposLoaded=true;
  var cont=document.getElementById('inv-grupo-ms'); if(!cont) return;
  var grupos=[];
  try{ var rows=await q('grupos_inventario','select=grupo&order=grupo'); grupos=(rows||[]).map(function(r){return r.grupo;}).filter(Boolean); }catch(e){}
  if(!grupos.length){
    try{ var rs=await q('inventario','select=grupo&grupo=not.is.null&limit=8000'); var st={}; (rs||[]).forEach(function(r){ if(r.grupo) st[r.grupo]=1; }); grupos=Object.keys(st).sort(); }catch(e){}
  }
  if(!grupos.length){ invGruposLoaded=false; return; }
  msGruposInit('inv-grupo-ms', grupos, function(sel){ invGruposSel=sel; invPage=0; loadInventario(); });
}
async function invGrupoCodes(g){
  if(invGrupoCache[g]) return invGrupoCache[g];
  var codes=[], seen={};
  try{
    var rows=await qAll('inventario','select=itemcode&grupo=eq.'+encodeURIComponent(g)+'&order=itemcode');
    (rows||[]).forEach(function(r){ var c=r.itemcode; if(c && !seen[c]){ seen[c]=1; codes.push(c); } });
  }catch(e){}
  invGrupoCache[g]=codes; return codes;
}
async function loadInventario(append){
  if(!append){ invPage=0; $('inv-grid').innerHTML=loading(); try{histRender('inv');}catch(e){} }
  const ext=await invCols();
  // Panel de tipos (campo subg de SAP) + colecciones de Shopify
  if(!append){
  if(ext){
    if(!invCats.length){
      const codes=await obtenerTipos();
      invCats=codes.sort((a,b)=>subgLabel(a).localeCompare(subgLabel(b)));
    }
    invTipos=tiposDedup(invCats);
    if(COL_LISTA===null) await cargarColecciones();
    invRenderTipos();
  }
  invLlenarAnios();
  invCargarGrupos();
  invCargarMarcas();
  invRenderCampos();
  }
  // Itemcodes de la coleccion seleccionada (viajan en el body, no en la URL)
  let colCodes=null;
  if(arbSelInv && ARB_NODES[arbSelInv]){
    colCodes=await arbolItemcodes(ARB_NODES[arbSelInv]);
    if(!colCodes || !colCodes.length) colCodes=['__ninguno__'];
  }
  // Filtro por Marca: intersecta con la colección seleccionada (si hay)
  if(invMarcaF){
    var _mc=await invMarcaCodes(invMarcaF);
    if(!_mc.length) _mc=['__ninguno__'];
    if(colCodes && colCodes.length && colCodes[0]!=='__ninguno__'){
      var _set={}; _mc.forEach(function(c){_set[c]=1;});
      colCodes=colCodes.filter(function(c){return _set[c];});
      if(!colCodes.length) colCodes=['__ninguno__'];
    } else {
      colCodes=_mc;
    }
  }
  let disp = invDispF||'';
  let bajo=false;
  if(invStockF==='bajo') bajo=true;
  else if(invStockF==='critico') disp='agotado';
  const body={
    p_itemcodes: colCodes,
    p_grupo: (invGrupoF||null),
    p_grupos: (invGruposSel && invGruposSel.length ? invGruposSel : null),
    p_textos: invTextos.length?invTextos:null,
    p_q: (invTextos.length?null:((invQ&&invQ.trim())?invQ.trim():null)),
    p_subg: (ext && invCatF!=='' && invTipos && invTipos.map[invCatF]) ? invTipos.map[invCatF].map(c=>String(c)) : null,
    p_pmin: (invPMin!==''&&!isNaN(+invPMin))?+invPMin:null,
    p_pmax: (invPMax!==''&&!isNaN(+invPMax))?+invPMax:null,
    p_smin: (invSMin!==''&&!isNaN(+invSMin))?+invSMin:null,
    p_smax: (invSMax!==''&&!isNaN(+invSMax))?+invSMax:null,
    p_bmin: (invBMin!==''&&!isNaN(+invBMin)&&+invBMin>0)?+invBMin:null,
    p_bmax: (invBMax!==''&&!isNaN(+invBMax)&&+invBMax>0)?+invBMax:null,
    p_disp: disp||null,
    p_img: invImgF||null,
    p_anio: (ext&&invAnioF!=='')?+invAnioF:null,
    // El rango manda sobre "mercancia reciente": son el mismo campo.
    p_desde: invRDesdeF ? invRDesdeF
             : ((invRecienteF!=='' && invRecienteF) ? _mesesAtras(+invRecienteF) : null),
    p_bajo: bajo,
    p_orden: invOrden||'reciente',
    p_limit: INV_PAGE_SIZE+1,
    p_offset: invPage*INV_PAGE_SIZE
  };

  // p_hasta solo se manda si la funcion inv_buscar lo admite. Si todavia no
  // se ha corrido 9-inventario-rango-supabase.sql, PostgREST responderia que
  // la funcion no existe con esos argumentos, asi que se omite y el corte
  // superior se aplica sobre lo que llega.
  if(invRHastaF && INV_RPC_HASTA!==false) body.p_hasta = invRHastaF;
  window._invLastBody=body;
  let all;
  // SIN CONEXION: el catalogo descargado responde lo mismo que el servidor,
  // asi el resto de loadInventario (filtros, orden, pintado) sigue igual.
  if(!navigator.onLine){
    var _offInv = (typeof kccInvBuscar==='function') ? await kccInvBuscar(body) : null;
    if(!_offInv){
      $('inv-grid').innerHTML='<div class="empty" style="padding:34px;text-align:center;color:var(--amber)">'
        +'<b>Sin conexi\u00f3n y sin cat\u00e1logo descargado</b><br>'
        +'<span style="font-size:12.5px;color:var(--text3)">Con\u00e9ctate y pulsa <b>Descargar</b> en el Dashboard.</span></div>';
      invHasNext=false; invLoadingMore=false;
      return;
    }
    all = _offInv;
    if(typeof kccPintarFotos==='function') setTimeout(function(){ kccPintarFotos(); }, 120);
  } else
  try{
    let resp=await fetch(`${SB}/rest/v1/rpc/inv_buscar`,{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(body)});
    let txt=await resp.text();
    // Si la funcion aun no tiene el parametro p_hasta, PostgREST devuelve 404
    // (PGRST202: no encuentra la funcion con esos argumentos). Se reintenta
    // sin el y se recuerda para el resto de la sesion.
    if(!resp.ok && body.p_hasta && (resp.status===404 || /PGRST202|p_hasta/i.test(txt))){
      INV_RPC_HASTA=false;
      delete body.p_hasta;
      resp=await fetch(`${SB}/rest/v1/rpc/inv_buscar`,{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(body)});
      txt=await resp.text();
    }
    if(!resp.ok){
      if(!navigator.onLine){ _sinConexionAviso($('inv-grid')); return; }
      $('inv-grid').innerHTML=`<div class="empty" style="text-align:left;max-width:680px;margin:0 auto;white-space:pre-wrap;line-height:1.5">`+
        `<b style="color:#E24B4A">No se pudo cargar el inventario</b>\n\n`+
        `Codigo HTTP: ${resp.status}\n`+
        `Mensaje de Supabase:\n${txt.slice(0,500)}\n\n`+
        (/57014|timeout/i.test(txt)?`Este filtro/grupo es muy grande para cargarse solo. Combinalo con otro filtro (por ejemplo "Entrada desde 2025" o "Bultos min") y cargara bien.\n\n`:``)+
        `(Mandale esta pantalla a quien te ayuda con el portal)`+
        `</div>`;
      return;
    }
    all=JSON.parse(txt);
  }catch(e){
    if(!navigator.onLine){ _sinConexionAviso($('inv-grid')); return; }
    $('inv-grid').innerHTML=`<div class="empty" style="text-align:left;max-width:680px;margin:0 auto;white-space:pre-wrap">`+
      `<b style="color:#E24B4A">Error de conexion con Supabase</b>\n\n${e.message}</div>`;
    return;
  }
  // Sin p_hasta en la funcion, el corte superior se aplica aqui. Funciona,
  // pero al recortar despues de paginar pueden salir paginas cortas: por eso
  // conviene correr 9-inventario-rango-supabase.sql.
    // Si la busqueda con IA no devolvio nada, se reintenta con menos palabras
  // antes de rendirse. Un termino como "silla negra oficina" puede no existir
  // tal cual en el nombre, pero "silla" si: mas vale de mas que "Sin productos".
  if((!all || !all.length) && invTextos.length && !invPage){
    var _cortos = [];
    invTextos.forEach(function(t){
      var pal = String(t).trim().split(/\s+/);
      if(pal.length > 1) _cortos.push(pal[0]);     // solo la primera palabra
    });
    _cortos = _cortos.filter(function(x,i,a){ return x && a.indexOf(x)===i; });
    if(_cortos.length){
      try{
        var _b2 = Object.assign({}, body, {p_textos:_cortos});
        var _r2 = await fetch(`${SB}/rest/v1/rpc/inv_buscar`,{method:'POST',
          headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},
          body:JSON.stringify(_b2)});
        if(_r2.ok){
          var _t2 = await _r2.text();
          all = JSON.parse(_t2) || [];
          var _m2 = $('inv-ia-msg');
          if(_m2 && all.length) _m2.innerHTML = 'No encontr\u00e9 nada exacto, as\u00ed que busqu\u00e9 solo '
            + _cortos.map(function(x){ return '<b>'+x+'</b>'; }).join(', ') + '.';
        }
      }catch(e){}
    }
  }

if(invRHastaF && INV_RPC_HASTA===false){
    all=all.filter(function(r){
      var f=String(r.fechaentrada||'').substring(0,10);
      return f && f<=invRHastaF;
    });
  }
  const hasNext=all.length>INV_PAGE_SIZE;
  const data=all.slice(0,INV_PAGE_SIZE);
  var _html=data.map(i=>{
    // Dos numeros distintos: lo que hay y lo que se puede vender.
    const stock=invStock(i), disp=dispReal(i), min=Number(i.minlevel||0);
    const pct=min>0?Math.min(100,Math.round(disp/min*100)):100;
    const color=pct<25?'#E24B4A':pct<60?'#EF9F27':'#639922';
    const bulto=Math.max(1,Number(i.unidadesbulto)||Number(i.numinbuy)||1);
    const precio=pvVenta(i);
    const linea=npLineas.find(l=>l.itemcode===i.itemcode);
    const qty=linea?linea.quantity:'';
    const nm=(i.itemname||'').replace(/"/g,'&quot;');
    const bultosStock=bulto>1?Math.floor(disp/bulto):0;
    const bultoTxt=bulto>1?`<span style="font-size:10px;color:var(--text3)">📦 ${fmtN(bultosStock)} bultos · ${fmtN(bulto)} u/bulto</span>`:'';
    return `<div class="icard" data-code="${i.itemcode}" data-name="${nm}" data-bulto="${bulto}" data-price="${precio}">
      <div onclick="verItem(this.parentNode.dataset.code)" style="cursor:pointer">
        ${fotoCard(i.picturname, i.foto_url)}
        <div class="icard-body">
          <div class="icard-name" title="${nm}">${i.itemname||''}</div>
          <div class="icard-code">${i.itemcode}</div>
          <div style="display:flex;justify-content:space-between;align-items:center;margin:8px 0 4px">
            <span style="font-size:16px;font-weight:700;letter-spacing:-.02em;color:${precio>0?'var(--blue)':'var(--text3)'}">${precio>0?'$ '+precio.toFixed(2):'—'}</span>
            <span class="badge ${pct<25?'b-red':pct<60?'b-amber':'b-green'}" title="Stock en bodega">${fmtN(stock)} uds</span>${disp!==stock?`<span class="badge b-blue" style="margin-left:5px" title="Disponible: el stock menos lo separado en pedidos autorizados">disp ${fmtN(disp)}</span>`:''}
          </div>
          ${bultoTxt?`<div style="margin-bottom:5px">${bultoTxt}</div>`:''}
          <div class="ibar"><div class="ibar-f" style="width:${pct}%;background:${color}"></div></div>
        </div>
      </div>
      <div class="iadd" onclick="event.stopPropagation()">
        <button class="iadd-btn" onclick="invAdd(this,-1)">−</button>
        <input class="iadd-qty" type="number" min="0" value="${qty}" placeholder="0" onfocus="this.select()" onchange="invSet(this)">
        <button class="iadd-btn" onclick="invAdd(this,1)">+</button>
      </div>
    </div>`;
  }).join('');
  if(append){ var _s=document.getElementById('inv-sentinel'); if(_s)_s.remove(); $('inv-grid').insertAdjacentHTML('beforeend',_html); }
  else{ $('inv-grid').innerHTML=_html||empty('Sin productos'); }
  invHasNext=hasNext; invLoadingMore=false;
  var _pg=$('inv-pager'); if(_pg)_pg.innerHTML='';
  _infScroll('inv-grid','inv-sentinel',hasNext,function(){ if(!invLoadingMore&&invHasNext){ invLoadingMore=true; invPage++; loadInventario(true); } });
}
let invTimer2=null, invAcT=null;
function searchInventario(v){
  invQ=v;invPage=0;invTextos=[];var m=$('inv-ia-msg');if(m)m.textContent='';
  clearTimeout(invAcT);invAcT=setTimeout(()=>invSugerencias(v),220);
  clearTimeout(invTimer2);invTimer2=setTimeout(function(){ histAdd('inv',v); histRender('inv'); loadInventario(); },420);
}
async function invSugerencias(v){
  const drop=$('inv-ac-drop'); if(!drop)return;
  if(!v||v.trim().length<2){drop.classList.remove('show');drop.innerHTML='';return;}
  const t=encodeURIComponent(v.trim());
  drop.classList.add('show');drop.innerHTML='<div class="ac-msg" style="padding:10px 14px;font-size:12px;color:var(--text3)">Buscando...</div>';
  const data=await q('vista_inventario',`select=itemcode,itemname,disponible,disponiblebodega,onhand,foto_url&or=(itemname.ilike.*${t}*,itemcode.ilike.*${t}*)&order=disponiblebodega.desc.nullslast&limit=8`);
  drop.innerHTML=data.length?data.map(i=>{
    const stock=fmtN(i.onhand!=null?i.onhand:(i.disponiblebodega||i.disponible||0));
    const foto=i.foto_url?`<img src="${i.foto_url}" style="width:32px;height:32px;border-radius:6px;object-fit:cover;flex-shrink:0" onerror="this.style.display='none'">`:'<div class="ac-av">📦</div>';
    const nm=(i.itemname||'').replace(/"/g,'&quot;');
    return `<div class="ac-item" onclick="invElegir(this.dataset.code)" data-code="${i.itemcode}">
      ${foto}
      <div class="ac-info"><p>${i.itemname||''}</p><span>${i.itemcode} · ${stock} uds</span></div>
    </div>`;
  }).join(''):'<div class="ac-msg" style="padding:10px 14px;font-size:12px;color:var(--text3)">Sin resultados</div>';
}
function invElegir(code){
  const drop=$('inv-ac-drop'); if(drop){drop.classList.remove('show');drop.innerHTML='';}
  verItem(code);
}
function invCat(cat){invCatF=cat;invPage=0;invRenderTipos();loadInventario()}
function invRenderTipos(){
  var p=document.getElementById('inv-tipos-panel'); if(!p) return;
  var html=panelHeader('🗂️ Colecciones');
  html+=panelItem('Todas las colecciones', arbSelInv==='', "invSelArbol('')", false);
  html+=arbHTML(arbSelInv,'invSelArbol','var(--blue)');
  html+='<div style="border-top:1px solid var(--border);margin-top:8px"></div>'+panelHeader('🏷️ Tipo de producto');
  html+=panelItem('Todos los tipos', invCatF==='', "invCat('')", false);
  if(invTipos) invTipos.labels.forEach(function(lab){
    html+=panelItem(npEsc(lab), invCatF===lab, "invCat('"+lab.replace(/'/g,"\\'").replace(/"/g,'')+"')", false);
  });
  p.innerHTML=html;
}
function invLlenarAnios(){
  var sel=document.getElementById('inv-anio'); if(!sel||sel.dataset.listo) return;
  var y=new Date().getFullYear();
  for(var a=y; a>=2015; a--){ var o=document.createElement('option'); o.value=a; o.textContent=a+' o más reciente'; sel.appendChild(o); }
  sel.dataset.listo='1';
}
function _mesesAtras(n){ var d=new Date(); d.setMonth(d.getMonth()-n); var m=('0'+(d.getMonth()+1)).slice(-2), dd=('0'+d.getDate()).slice(-2); return d.getFullYear()+'-'+m+'-'+dd; }
// ── Rango de fecha de entrada (dd/mm/aaaa) ─────────────────────────────────
// Los tres filtros de fecha son excluyentes entre si: "Mercancia reciente",
// "Cualquier ano" y este rango miran el mismo campo (fechaentrada), asi que
// combinarlos solo produce resultados confusos o vacios.
var invRDesdeF='', invRHastaF='';
var INV_RPC_HASTA=null;   // null = por probar, false = la funcion no lo admite

// Formatea mientras se escribe: 01072026 -> 01/07/2026
function invRangoInput(el){
  var d=String(el.value||'').replace(/[^0-9]/g,'').slice(0,8);
  var out=d.slice(0,2);
  if(d.length>2) out+='/'+d.slice(2,4);
  if(d.length>4) out+='/'+d.slice(4,8);
  el.value=out;
}

// dd/mm/aaaa -> aaaa-mm-dd. Devuelve '' si aun esta incompleta o no es valida.
function _invFechaISO(txt){
  var m=String(txt||'').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if(!m) return '';
  var dd=+m[1], mm=+m[2], aa=+m[3];
  if(mm<1||mm>12||dd<1||dd>31) return '';
  var f=new Date(aa, mm-1, dd);
  if(f.getFullYear()!==aa || f.getMonth()!==mm-1 || f.getDate()!==dd) return '';
  return aa+'-'+('0'+mm).slice(-2)+'-'+('0'+dd).slice(-2);
}

// aaaa-mm-dd -> dd/mm/aaaa
function _invFechaDMY(iso){
  var p=String(iso||'').split('-');
  return p.length===3 ? (p[2]+'/'+p[1]+'/'+p[0]) : '';
}

// Abre el calendario del navegador. El input date real esta oculto detras del
// campo de texto: asi se puede escribir a mano Y elegir del calendario.
function invAbrirCal(id){
  var cal=document.getElementById(id+'-cal'), txt=document.getElementById(id);
  if(!cal) return;
  // Que el calendario se abra en el mes de lo ya escrito, si es valido.
  if(txt){
    var iso=_invFechaISO(txt.value);
    if(iso) cal.value=iso;
  }
  try{
    if(typeof cal.showPicker==='function') cal.showPicker();
    else { cal.style.opacity='1'; cal.style.width='auto'; cal.style.height='auto'; cal.focus(); cal.click(); }
  }catch(e){ cal.focus(); cal.click(); }
}

// El calendario devolvio una fecha: se escribe en el campo de texto.
function invCalSet(id, iso){
  var txt=document.getElementById(id); if(!txt || !iso) return;
  txt.value=_invFechaDMY(iso);
  txt.style.borderColor='';
  var cal=document.getElementById(id+'-cal');
  if(cal){ cal.style.opacity='0'; cal.style.width='1px'; cal.style.height='1px'; }
  invRango();
}

// Pinta en rojo el borde del recuadro que envuelve al campo, no el del input
// (el input no tiene borde propio: el marco es el span de alrededor).
function _invMarcar(el, mal){
  if(!el) return;
  var caja = el.parentElement || el;
  caja.style.borderColor = mal ? 'var(--red)' : 'var(--border)';
}

function invRango(){
  var d=document.getElementById('inv-rdesde'), h=document.getElementById('inv-rhasta');
  var td=d?d.value.trim():'', th=h?h.value.trim():'';
  var iso1=_invFechaISO(td), iso2=_invFechaISO(th);

  // Fecha a medio escribir o inexistente (31/02): no se consulta, se marca.
  _invMarcar(d, !!(td && !iso1));
  _invMarcar(h, !!(th && !iso2));
  if(td && !iso1){ alert('La fecha "desde" no es valida. Usa el formato dd/mm/aaaa, por ejemplo 01/07/2026.'); return; }
  if(th && !iso2){ alert('La fecha "hasta" no es valida. Usa el formato dd/mm/aaaa, por ejemplo 31/07/2026.'); return; }

  if(iso1 && iso2 && iso1>iso2){
    _invMarcar(d,true); _invMarcar(h,true);
    alert('El rango esta al reves.\n\nDesde: '+_invFechaDMY(iso1)+'\nHasta: '+_invFechaDMY(iso2)
          +'\n\nLa fecha "desde" tiene que ser anterior o igual a la de "hasta".');
    return;
  }
  _invMarcar(d,false); _invMarcar(h,false);

  // Mantener los calendarios en sintonia con lo escrito.
  var c1=document.getElementById('inv-rdesde-cal'); if(c1) c1.value=iso1||'';
  var c2=document.getElementById('inv-rhasta-cal'); if(c2) c2.value=iso2||'';

  invRDesdeF=iso1; invRHastaF=iso2;

  // Al usar el rango se apagan los otros dos filtros de fecha.
  if(iso1 || iso2){
    invRecienteF=''; invAnioF='';
    var m=document.getElementById('inv-reciente'); if(m) m.value='';
    var a=document.getElementById('inv-anio');     if(a) a.value='';
  }
  invPage=0; loadInventario();
}

function _invLimpiarRango(){
  invRDesdeF=''; invRHastaF='';
  ['inv-rdesde','inv-rhasta'].forEach(function(id){
    var e=document.getElementById(id);
    if(e){ e.value=''; _invMarcar(e,false); }
    var c=document.getElementById(id+'-cal');
    if(c) c.value='';
  });
}

function invReciente(v){ invRecienteF=v; if(v){ invAnioF=''; var a=document.getElementById('inv-anio'); if(a) a.value=''; _invLimpiarRango(); } invPage=0; loadInventario(); }
function invAnio(v){invAnioF=v; if(v){ invRecienteF=''; var m=document.getElementById('inv-reciente'); if(m) m.value=''; _invLimpiarRango(); } invPage=0;loadInventario()}
var invFTimer=null;
function invFiltAvz(){
  invPMin=($('inv-pmin')||{}).value||''; invPMax=($('inv-pmax')||{}).value||'';
  invSMin=($('inv-smin')||{}).value||''; invSMax=($('inv-smax')||{}).value||'';
  invBMin=($('inv-bmin')||{}).value||''; invBMax=($('inv-bmax')||{}).value||'';
  invDispF=($('inv-disp')||{}).value||'';
  invImgF=($('inv-img')||{}).value||''; invOrden=($('inv-orden')||{}).value||'';
  invPage=0; clearTimeout(invFTimer); invFTimer=setTimeout(loadInventario,350);
}
function invStock(s,el){invStockF=s;invPage=0;document.querySelectorAll('#page-inventario .pills:last-child .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');loadInventario()}

// Añadir al pedido/cotizacion desde el inventario (suma por bulto)
function invCardData(btn){
  const c=btn.closest('.icard');
  return {code:c.dataset.code,name:c.dataset.name,bulto:Math.max(1,Number(c.dataset.bulto)||1),precio:Number(c.dataset.price)||0,card:c};
}
function invAdd(btn,signo){
  const d=invCardData(btn);
  cartAddUnits(d.code,d.name,d.precio,d.bulto,signo*d.bulto);
  const inp=d.card.querySelector('.iadd-qty');
  const l=npLineas.find(x=>x.itemcode===d.code);
  if(inp) inp.value=l?l.quantity:'';
}
function invSet(inp){
  const d=invCardData(inp);
  cartSetUnits(d.code,d.name,d.precio,d.bulto,+inp.value);
  const l=npLineas.find(x=>x.itemcode===d.code);
  inp.value=l?l.quantity:'';
}

// ══ VER ITEM ══ (la funcion detallada esta definida arriba)

// ══ ESTADO CUENTA ══
var ecCliF='';   // cliente elegido en el buscador (cardcode)

async function loadEC(){
  // De mas nueva a mas vieja por fecha del documento. Antes se ordenaba por
  // dias vencidos, que pone arriba lo mas antiguo: justo lo contrario.
  let filter=`select=docnum,docdate,docduedate,cardcode,cardname,doctotal,saldopendiente,diasvencido,categoria&order=docdate.desc&limit=200`;
  if(ecCatF) filter+=`&categoria=ilike.*${encodeURIComponent(ecCatF)}*`;
  var _esCli=(CU&&CU.rol==='cliente');
  if(_esCli) filter+=`&cardcode=eq.${CU.cardcode}`;
  else if(ecCliF) filter+=`&cardcode=eq.${encodeURIComponent(ecCliF)}`;
  const data=await q('estado_cuenta',filter);
  const total=data.reduce((s,r)=>s+Number(r.saldopendiente||0),0);
  $('ec-tot').textContent=fmt(total);
  $('ec-cnt').textContent=data.length;
  $('ec-cli').textContent=new Set(data.map(r=>r.cardcode)).size;
  var _bar=document.getElementById('ec-cli-sel');
  if(_bar){
    if(ecCliF && data.length){
      var n=data[0].cardname||ecCliF;
      _bar.style.display='flex';
      _bar.innerHTML='<span style="flex:1">Filtrando por <b>'+npEsc(n)+'</b> \u00b7 '+npEsc(ecCliF)+'</span>'
        +'<button class="btn btn-sm btn-p" onclick="verCliente(\''+String(ecCliF).replace(/'/g,"\\'")+'\')">Ver ficha del cliente</button> '
        +'<button class="btn btn-sm" onclick="ecCliQuitar()">Quitar filtro</button>';
    } else if(ecCliF){
      _bar.style.display='flex';
      _bar.innerHTML='<span style="flex:1">Sin documentos para <b>'+npEsc(ecCliF)+'</b></span>'
        +'<button class="btn btn-sm" onclick="ecCliQuitar()">Quitar filtro</button>';
    } else { _bar.style.display='none'; _bar.innerHTML=''; }
  }
  $('ec-table').innerHTML=data.length?`<table class="tbl"><tr><th>Factura</th><th>Fecha</th><th>Vence</th><th>Cliente</th><th>Total</th><th>Saldo</th><th>Dias venc.</th><th>Estado</th></tr>${data.map(r=>`<tr><td>${_esCli?`#${r.docnum}`:`<span style="color:var(--blue2);cursor:pointer" onclick="verFactura(${r.docnum})"><u>#${r.docnum}</u></span>`}</td><td>${fmtD(r.docdate)}</td><td>${fmtD(r.docduedate)}</td><td>${_esCli?r.cardname:`<span style="color:var(--blue2);cursor:pointer" onclick="verCliente('${r.cardcode}')">${r.cardname}</span>`}</td><td>${fmt(r.doctotal)}</td><td><b>${fmt(r.saldopendiente)}</b></td><td>${r.diasvencido||0}</td><td>${badgeEC(r.categoria)}</td></tr>`).join('')}</table>`:empty('Sin facturas vencidas');
}
// Buscador de clientes de la pantalla de estado de cuenta. Usa el mismo
// criterio de orden que el de Clientes (_cliRank): el codigo exacto primero,
// para que buscar 2273 no devuelva antes 12273 y 22273.
var _ecTimer=null;

function ecBuscarCli(val){
  clearTimeout(_ecTimer);
  var drop=document.getElementById('ec-cli-drop'); if(!drop) return;
  if(!val || val.length<2){ drop.classList.remove('show'); drop.innerHTML=''; return; }
  drop.innerHTML='<div class="ac-searching"><div class="spinner"></div> Buscando...</div>';
  drop.classList.add('show');
  _ecTimer=setTimeout(async function(){
    var v=String(val).trim().toLowerCase(), ve=encodeURIComponent(val.trim());
    var campos='select=cardcode,cardname,city,balance&cardtype=eq.C';
    try{
      var res=await Promise.all([
        q('clientes', campos+'&cardcode=ilike.'+ve+'&limit=3'),
        q('clientes', campos+'&or=(cardname.ilike.*'+ve+'*,cardcode.ilike.*'+ve+'*)&limit=40'),
        (typeof npBuscarNapa==='function' ? npBuscarNapa(val) : Promise.resolve([]))
      ]);
      var napa = res[2] || [];
      var vistos={}, todos=[];
      (res[0]||[]).concat(res[1]||[]).forEach(function(c){
        if(!c || vistos[c.cardcode]) return;
        vistos[c.cardcode]=1; todos.push(c);
      });
      todos.sort(function(a,b){
        var d=(typeof _cliRank==='function') ? (_cliRank(a,v)-_cliRank(b,v)) : 0;
        return d!==0 ? d : String(a.cardname||'').localeCompare(String(b.cardname||''));
      });
      // Los de NAPA primero, igual que en los demas buscadores del portal.
      var data=napa.concat(todos).slice(0,10);
      drop.innerHTML = data.length ? data.map(function(c){
        var cs=String(c.cardcode).replace(/'/g,"\\'");
        var nom=String(c.cardname||'').replace(/['"\\]/g,' ');
        if(c.napa){
          // El estado de cuenta de NAPA vive en su propia pantalla, que ya
          // sabe leer el mayor. Llevar ahi es mas fiable que reconstruirlo
          // aqui con otra estructura de datos.
          return '<div class="ac-item" onclick="ecIrNapa(\''+cs+'\',\''+nom+'\')">'
            +'<div class="ac-av" style="background:#7C3AED">'+ini(c.cardname)+'</div>'
            +'<div class="ac-info"><p>'+npEsc(c.cardname||'')
            +'<span style="background:#7C3AED;color:#fff;padding:1px 6px;border-radius:8px;font-size:9.5px;font-weight:700;margin-left:5px">NAPA</span></p>'
            +'<span>'+npEsc(c.cardcode)+' \u00b7 ver en Estados de cuenta NAPPA</span></div></div>';
        }
        return '<div class="ac-item" onclick="ecCliElegir(\''+cs+'\')">'
          +'<div class="ac-av">'+ini(c.cardname)+'</div>'
          +'<div class="ac-info"><p>'+npEsc(c.cardname||'')+'</p>'
          +'<span>'+npEsc(c.cardcode)+' \u00b7 '+npEsc(c.city||'')+' \u00b7 '+fmt(c.balance)+'</span></div></div>';
      }).join('') : '<div class="ac-searching">Sin resultados</div>';
    }catch(e){ drop.innerHTML='<div class="ac-searching">No se pudo buscar</div>'; }
  }, 300);
}

// Abre la ficha de NAPA del cliente.
//
// Se usa el modal (verClienteNapa) y no la pantalla de Estados de cuenta
// NAPPA porque esa mostraba cifras desfasadas: para CITY MALL daba un saldo
// de $138.68 cuando el real es $50,138.68, porque le faltaba el movimiento
// mas reciente. El modal consulta el mayor directo y trae los 273.
function ecIrNapa(code, nombre){
  var drop=document.getElementById('ec-cli-drop'); if(drop) drop.classList.remove('show');
  var inp=document.getElementById('ec-cli-q');     if(inp) inp.value='';
  try{ verClienteNapa(code); }
  catch(e){ alert('No se pudo abrir la ficha: '+(e.message||e)); }
}

function ecCliElegir(code){
  ecCliF=code;
  var drop=document.getElementById('ec-cli-drop'); if(drop) drop.classList.remove('show');
  var inp=document.getElementById('ec-cli-q');     if(inp) inp.value='';
  loadEC();
}

function ecCliQuitar(){
  ecCliF='';
  var inp=document.getElementById('ec-cli-q'); if(inp) inp.value='';
  loadEC();
}

function ecFilt(cat,el){ecCatF=cat;document.querySelectorAll('#page-estado_cuenta .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');loadEC()}
async function loadECCliente(){
  var data=[];
  try{ data=await qAll('vista_facturas','select=docnum,docdate,docduedate,doctotal,paidtodate,docstatus&cardcode=eq.'+encodeURIComponent(CU.cardcode)+'&order=docdate.desc'); }catch(e){}
  data=data||[];
  var hoy=new Date(), totVenc=0, abiertas=0, saldoTot=0;
  var rows=data.map(function(f){
    var tot=Number(f.doctotal)||0, pag=Number(f.paidtodate)||0, sal=tot-pag; if(sal<0)sal=0;
    var dv=0;
    if(sal>0.01 && f.docduedate){ var d=new Date(f.docduedate); dv=Math.floor((hoy-d)/86400000); if(dv<0)dv=0; }
    if(sal>0.01){ abiertas++; saldoTot+=sal; if(dv>0)totVenc+=sal; }
    var est = sal<=0.01 ? '<span class="badge" style="background:#e7f6ec;color:#15803d">Pagada</span>'
            : (pag>0.01 ? '<span class="badge" style="background:#fcefd6;color:#b06a00">Parcial</span>'
                        : '<span class="badge" style="background:#fde8e8;color:#c01b1b">Pendiente</span>');
    return '<tr><td><span class="mono" style="color:var(--blue);font-weight:600">#'+f.docnum+'</span></td><td>'+fmtD(f.docdate)+'</td><td>'+fmtD(f.docduedate)+'</td><td>'+fmt(tot)+'</td><td>'+fmt(pag)+'</td><td><b>'+fmt(sal)+'</b></td><td>'+(sal>0.01?dv:'-')+'</td><td>'+est+'</td></tr>';
  });
  if($('ec-tot'))$('ec-tot').textContent=fmt(totVenc);
  if($('ec-cnt'))$('ec-cnt').textContent=abiertas;
  if($('ec-table'))$('ec-table').innerHTML = rows.length
    ? '<table class="tbl"><tr><th>Factura</th><th>Fecha</th><th>Vence</th><th>Total</th><th>Pagado</th><th>Saldo</th><th>Dias venc.</th><th>Estado</th></tr>'+rows.join('')+'</table>'
    : empty('Sin facturas registradas');
}

// ══ ALERTAS ══
async function loadAlertas(){
  cargarSinPrecio('al-sinpv');
  cargarTopVendidos('al-top');
  cargarUltimosPedidos('al-ped');
  cargarUltimosRecibidos('al-rec');
}

// Mercancia con existencia, marcada para venta y SIN precio en la lista de
// venta. Antes estos articulos mostraban su costo como si fuera el precio; hoy
// dicen "Sin precio", que es honesto pero sigue sin venderse. Esta alerta es
// para que alguien los cargue.
//
// Solo administracion y gerencia: es trabajo suyo, y a un vendedor le sobra.
async function cargarSinPrecio(elId){
  var el=$(elId||'al-sinpv'); if(!el) return;
  var rol=String((CU&&CU.rol)||'').toLowerCase();
  if(['admin','administrador','gerencia'].indexOf(rol)<0){
    var caja=el.closest ? el.closest('.card') : null;
    if(caja) caja.style.display='none';
    return;
  }
  try{
    var data=await q('vista_inventario',
      'select=itemcode,itemname,disponible,fechaentrada,foto_url'
      +'&precioventa=is.null&disponible=gt.0&order=fechaentrada.desc&limit=200');
    // `precioventa` puede llegar en 0 en vez de nulo segun como quedo el sync.
    var cero=await q('vista_inventario',
      'select=itemcode,itemname,disponible,fechaentrada,foto_url'
      +'&precioventa=eq.0&disponible=gt.0&order=fechaentrada.desc&limit=200')
      .catch(function(){ return []; });
    var vistos={}, todos=[];
    (data||[]).concat(cero||[]).forEach(function(d){
      if(!vistos[d.itemcode]){ vistos[d.itemcode]=1; todos.push(d); }
    });

    if(!todos.length){
      el.innerHTML='<div class="empty" style="color:var(--green)">'
        +'Toda la mercancía con existencia tiene precio de venta.</div>';
      return;
    }
    el.innerHTML='<div style="font-size:12.5px;color:#B45309;margin-bottom:9px">'
      +'<b>'+todos.length+' artículo(s)</b> con existencia y sin precio en la lista de venta. '
      +'No se pueden cotizar hasta que se les cargue el precio en SAP.</div>'
      +'<table class="tbl"><tr><th>Artículo</th><th>Entrada</th>'
      +'<th style="text-align:right">Disponible</th></tr>'
      +todos.slice(0,50).map(function(d){
        return '<tr class="clickable" onclick="verItem(\''
          +String(d.itemcode).replace(/'/g,"\\'")+'\')">'
          +'<td><div style="font-weight:600;white-space:nowrap;overflow:hidden;'
          +'text-overflow:ellipsis;max-width:260px">'+npEsc(d.itemname||d.itemcode)+'</div>'
          +'<div class="mono" style="font-size:11px">'+npEsc(d.itemcode)+'</div></td>'
          +'<td style="color:var(--text2)">'+fmtFechaCorta(d.fechaentrada)+'</td>'
          +'<td style="text-align:right;font-weight:700">'+fmtN2(d.disponible)+'</td></tr>';
      }).join('')+'</table>'
      +(todos.length>50 ? ('<div style="font-size:11.5px;color:var(--text3);margin-top:8px">'
        +'Se muestran los 50 más recientes de '+todos.length+'.</div>') : '');
  }catch(e){
    el.innerHTML=empty('No se pudo revisar los precios de venta');
  }
}
async function cargarTopVendidos(elId){
  var el=$(elId||'al-top'); if(!el)return;
  try{
    var data=await q('top_vendidos_mes','select=itemcode,dscription,total_vendido,num_facturas&order=total_vendido.desc&limit=10');
    if(!data || !data.length){ el.innerHTML=empty('Sin ventas registradas en el último mes'); return; }
    // Enriquecer con foto/nombre del inventario
    var codes=data.map(function(d){return '"'+String(d.itemcode).replace(/"/g,'')+'"';}).join(',');
    var inv={};
    try{ var iv=await q('vista_inventario','select=itemcode,itemname,foto_url&itemcode=in.('+codes+')'); (iv||[]).forEach(function(r){inv[r.itemcode]=r;}); }catch(e){}
    var max=Number(data[0].total_vendido)||1;
    el.innerHTML='<table class="tbl"><tr><th>Producto</th><th style="text-align:right">Vendido</th><th></th></tr>'+data.map(function(d,i){
      var r=inv[d.itemcode]||{}, nom=r.itemname||d.dscription||d.itemcode;
      var foto=r.foto_url?'<img src="'+r.foto_url+'" style="width:30px;height:30px;border-radius:6px;object-fit:cover;flex-shrink:0" onerror="this.style.display=\'none\'">':'<div style="width:30px;height:30px;border-radius:6px;background:var(--bg);flex-shrink:0"></div>';
      var pct=Math.round((Number(d.total_vendido)/max)*100);
      return '<tr class="clickable" onclick="verItem(\''+String(d.itemcode).replace(/'/g,"\\'")+'\')"><td><div style="display:flex;align-items:center;gap:9px">'
        +'<span style="font-size:11px;font-weight:700;color:var(--text3);width:16px">'+(i+1)+'</span>'+foto
        +'<div style="min-width:0"><div style="font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:200px">'+npEsc(nom)+'</div><div class="mono">'+npEsc(d.itemcode)+'</div></div></div></td>'
        +'<td style="text-align:right;font-weight:700">'+fmtN2(d.total_vendido)+'</td>'
        +'<td style="width:70px"><div class="ibar" style="margin:0"><div class="ibar-f" style="width:'+pct+'%;background:var(--blue)"></div></div></td></tr>';
    }).join('')+'</table>';
  }catch(e){ el.innerHTML='<div class="empty">No se pudo cargar.<br><span style="font-size:11px">Falta crear la vista <b>top_vendidos_mes</b> en Supabase (archivo 19_top_vendidos.sql).</span></div>'; }
}
async function cargarUltimosPedidos(elId){
  var el=$(elId||'al-ped'); if(!el)return;
  try{
    var f='select=docnum,docdate,cardname,doctotal,doccur,docstatus&linenum=lte.1&order=docnum.desc&limit=30';
    if(CU&&CU.rol==='cliente')f+='&cardcode=eq.'+CU.cardcode;
    var data=await q('pedidos',f);
    if(!data||!data.length){ el.innerHTML=empty('Sin pedidos'); return; }
    el.innerHTML='<table class="tbl"><tr><th>Pedido</th><th>Fecha</th><th>Cliente</th><th style="text-align:right">Total</th><th></th></tr>'+data.map(function(p){
      var ab=p.docstatus==='O';
      return '<tr class="clickable" onclick="verPedido('+p.docnum+')"><td><span class="mono" style="color:var(--blue);font-weight:600">#'+p.docnum+'</span></td>'
        +'<td style="color:var(--text2)">'+fmtD(p.docdate)+'</td>'
        +'<td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:150px">'+npEsc(p.cardname||'—')+'</td>'
        +'<td style="text-align:right;font-weight:700">'+fmtN2(p.doctotal)+'</td>'
        +'<td><span class="badge '+(ab?'b-green':'b-gray')+'">'+(ab?'Abierto':'Cerrado')+'</span></td></tr>';
    }).join('')+'</table>';
  }catch(e){ el.innerHTML=empty('No se pudo cargar pedidos'); }
}
async function cargarUltimosRecibidos(elId){
  var el=$(elId||'al-rec'); if(!el)return;
  try{
    var data=await q('vista_inventario','select=itemcode,itemname,foto_url,fechaentrada,disponiblebodega&fechaentrada=not.is.null&order=fechaentrada.desc&limit=18');
    if(!data||!data.length){ el.innerHTML=empty('Sin artículos con fecha de entrada'); return; }
    el.innerHTML='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px">'+data.map(function(d){
      var foto=d.foto_url?'<img src="'+d.foto_url+'" style="width:100%;height:120px;object-fit:cover;display:block" onerror="this.parentNode.innerHTML=\'<div style=&quot;height:120px;background:var(--bg)&quot;></div>\'">':'<div style="height:120px;background:var(--bg)"></div>';
      var st=Number(d.disponiblebodega)||0;
      return '<div class="icard" onclick="verItem(\''+String(d.itemcode).replace(/'/g,"\\'")+'\')"><div style="overflow:hidden;border-radius:var(--r) var(--r) 0 0">'+foto+'</div>'
        +'<div class="icard-body"><div class="icard-name" title="'+npEsc(d.itemname||'')+'">'+npEsc(d.itemname||d.itemcode)+'</div>'
        +'<div class="mono" style="margin-top:2px">'+npEsc(d.itemcode)+'</div>'
        +'<div style="display:flex;justify-content:space-between;align-items:center;margin-top:7px">'
        +'<span class="badge b-blue">'+fmtFechaCorta(d.fechaentrada)+'</span>'
        +'<span style="font-size:11px;font-weight:700;color:'+(st>0?'var(--green)':'var(--red)')+'">'+st+'</span></div></div></div>';
    }).join('')+'</div>';
  }catch(e){ el.innerHTML=empty('No se pudo cargar recibidos'); }
}
function fmtFechaCorta(f){ if(!f)return '—'; var s=String(f).substring(0,10); var p=s.split('-'); return p.length===3 ? p[2]+'-'+p[1]+'-'+p[0] : s; }

// ══ ULTIMO PRECIO ══
async function loadUP(){
  let filter=`select=cardcode,cardname,itemcode,dscription,fechaultima_compra,ultimoprecio,descuento,ultimacantidad,diasdesdeultimacompra&order=cardcode,itemcode&limit=300`;
  if(upQ) filter=`select=cardcode,cardname,itemcode,dscription,fechaultima_compra,ultimoprecio,descuento,ultimacantidad,diasdesdeultimacompra&or=(cardname.ilike.*${encodeURIComponent(upQ)}*,dscription.ilike.*${encodeURIComponent(upQ)}*,itemcode.ilike.*${encodeURIComponent(upQ)}*)&order=cardcode&limit=300`;
  const data=await q('ultimo_precio_cliente',filter);
  $('up-table').innerHTML=data.length?`<table class="tbl"><tr><th>Cliente</th><th>Producto</th><th>Ultima compra</th><th>Dias</th><th>Precio</th><th>Descuento</th><th>Cantidad</th></tr>${data.map(u=>`<tr><td><span style="color:var(--blue2);cursor:pointer" onclick="verCliente('${u.cardcode}')">${u.cardname}</span></td><td>${u.dscription||u.itemcode}</td><td>${fmtD(u.fechaultima_compra)}</td><td><span class="badge ${Number(u.diasdesdeultimacompra||0)>60?'b-red':Number(u.diasdesdeultimacompra||0)>30?'b-amber':'b-green'}">${u.diasdesdeultimacompra||0}d</span></td><td><b>${fmt(u.ultimoprecio)}</b></td><td>${u.descuento?Number(u.descuento).toFixed(1)+'%':'—'}</td><td>${u.ultimacantidad||'—'}</td></tr>`).join('')}</table>`:empty('Sin datos');
}
let upTimer=null;
function searchUP(v){upQ=v;clearTimeout(upTimer);upTimer=setTimeout(loadUP,400)}

// ══ PRECIOS ══
async function loadPrecios(){
  const data=await q('lista_precios','select=listnum,listname,itemcode,itemname,price,currency&order=listnum,itemcode&limit=300');
  $('pre-table').innerHTML=data.length?`<table class="tbl"><tr><th>Lista</th><th>Nombre</th><th>Codigo</th><th>Producto</th><th>Precio</th><th>Moneda</th></tr>${data.map(p=>`<tr><td>${p.listnum}</td><td>${p.listname}</td><td style="color:var(--text3)">${p.itemcode}</td><td>${p.itemname}</td><td><b>${fmt(p.price)}</b></td><td>${p.currency||'—'}</td></tr>`).join('')}</table>`:empty('Sin datos');
}
let preTimer=null;
function searchPrecios(v){clearTimeout(preTimer);preTimer=setTimeout(async()=>{
  const data=await q('lista_precios',`select=listnum,listname,itemcode,itemname,price,currency&or=(itemname.ilike.*${encodeURIComponent(v)}*,itemcode.ilike.*${encodeURIComponent(v)}*,listname.ilike.*${encodeURIComponent(v)}*)&limit=300`);
  $('pre-table').innerHTML=data.length?`<table class="tbl"><tr><th>Lista</th><th>Nombre</th><th>Codigo</th><th>Producto</th><th>Precio</th><th>Moneda</th></tr>${data.map(p=>`<tr><td>${p.listnum}</td><td>${p.listname}</td><td style="color:var(--text3)">${p.itemcode}</td><td>${p.itemname}</td><td><b>${fmt(p.price)}</b></td><td>${p.currency||'—'}</td></tr>`).join('')}</table>`:empty('Sin resultados');
},350)}

// ══ PAGINACION ══
function renderPagerSimple(id, page, hasNext, cb){
  const el=$(id); if(!el) return;
  if(page===0 && !hasNext){el.innerHTML='';return;}
  el.innerHTML=`<span>Pagina ${page+1}</span>
  <div class="pager-btns">
    <button class="btn btn-sm" ${page===0?'disabled':''} onclick="(${cb.toString()})(${page-1})">← Anterior</button>
    <button class="btn btn-sm" ${!hasNext?'disabled':''} onclick="(${cb.toString()})(${page+1})">Siguiente →</button>
  </div>`;
}
function renderPager(id, page, total, size, cb){
  const el=$(id); if(!el) return;
  const pages=Math.ceil(total/size)||1;
  if(pages<=1){el.innerHTML='';return;}
  el.innerHTML=`<span>${page*size+1}–${Math.min((page+1)*size,total)} de ${total.toLocaleString()}</span>
  <div class="pager-btns">
    <button class="btn btn-sm" ${page===0?'disabled':''} onclick="(${cb.toString()})(${page-1})">← Anterior</button>
    <button class="btn btn-sm" ${page>=pages-1?'disabled':''} onclick="(${cb.toString()})(${page+1})">Siguiente →</button>
  </div>`;
}

// ══ SYNC ══
function syncNow(){
  const btn=event.currentTarget;btn.textContent='↻ Sync...';
  initDashboard();try{radCargar();}catch(e){}loadClientes();loadPedidos();loadFacturas();loadInventario();loadEC();loadAlertas();loadUP();loadPrecios();
  setTimeout(()=>btn.textContent='↻ Sync',3000);
}

// ── NUEVO PEDIDO ──
let npCli=null, npLineas=[], npVendedores=[], npCliT=null, npProdT=null;

// Los articulos entran al PRINCIPIO del carrito, no al final: escaneando en
// bodega con el iPad, lo ultimo agregado es lo que se quiere ver y ajustar,
// y al final de una lista larga queda fuera de pantalla.
// Se usa en vez de npAgregar(...) en todos los sitios que agregan.
function npAgregar(linea){
  // Un articulo sin precio de venta entra en CERO, no al costo. Se avisa una
  // vez por articulo: es preferible que el vendedor teclee el precio a que se
  // vaya una cotizacion con el costo dentro creyendo que es el precio.
  if(!(Number(linea && linea.price) > 0)){
    if(!npAgregar._avisados) npAgregar._avisados = {};
    var _c = linea && linea.itemcode;
    if(_c && !npAgregar._avisados[_c]){
      npAgregar._avisados[_c] = true;
      setTimeout(function(){
        alert('\u26a0 ' + _c + ' no tiene precio de venta en SAP.\n\n'
          + 'Entra al pedido en 0.00: ponle el precio a mano antes de enviarlo, '
          + 'o p\u00eddele a gerencia que lo cargue en la lista de precios.');
      }, 60);
    }
  }
  npLineas.unshift(linea);
  return npLineas.length;
}
let catPage=0, catQ='', catTextos=[], catCatF='', catAnioF='', catRecienteF='', catColF='', catBMin='', catBMax='', catGrupoF='', catGruposSel=[];
var catGruposLoaded=false;
const CAT_PS=30;

function npInit(){
  var br=document.getElementById('np-back-restock'); if(br)br.style.display='none';
  npFechasPorDefecto(true);
  if(!npVendedores.length){
    q('vendedores','select=slpcode,slpname&order=slpname').then(function(data){
      npVendedores=data;
      var sel=document.getElementById('np-vendedor');
      if(!sel)return;
      data.forEach(function(v){var o=document.createElement('option');o.value=v.slpcode;o.textContent=v.slpname;sel.appendChild(o);});
    });
  }
  if(CU&&CU.rol==='cliente'){
    ['np-th-desc','np-btn-bulkdesc','np-btn-bulkprecio'].forEach(function(id){var e=document.getElementById(id);if(e)e.style.display='none';});
    var _dg=document.getElementById('np-desc-gen'); if(_dg&&_dg.parentNode)_dg.parentNode.style.display='none';
    var _dl=document.getElementById('np-tot-desc'); if(_dl&&_dl.parentNode)_dl.parentNode.style.display='none';
    var chg=document.getElementById('np-cli-change');if(chg)chg.style.display='none';
    q('clientes','select=cardcode,cardname,city,balance,creditline,slpcode,currency&cardcode=eq.'+encodeURIComponent(CU.cardcode)+'&limit=1').then(function(rows){if(rows&&rows[0])npSelCliente(rows[0]);var qel=document.getElementById('np-cli-q');var box=qel&&qel.closest?qel.closest('.sbox'):null;if(box)box.style.display='none';});
  }
}

function npBuscarCliente(val){
  clearTimeout(npCliT);
  var drop=document.getElementById('np-cli-drop');
  if(!drop)return;
  if(val.length<2){drop.classList.remove('show');drop.innerHTML='';return;}
  drop.innerHTML='<div class="ac-msg">Buscando...</div>';
  drop.classList.add('show');
  npCliT=setTimeout(async function(){
    // Sin conexion se busca en los datos descargados al dispositivo.
    if(!navigator.onLine && typeof kccBuscarClientes==='function'){
      var off=await kccBuscarClientes(val, 12);
      if(off){
        drop.innerHTML = off.length ? off.map(function(c){
          return '<div class="ac-item" onclick="npSelCliente('+JSON.stringify(c).replace(/"/g,'&quot;')+')">'
            +'<div class="ac-av">'+ini(c.cardname)+'</div>'
            +'<div class="ac-info"><p>'+npEsc(c.cardname||'')+'</p>'
            +'<span>'+npEsc(c.cardcode)+' \u00b7 '+npEsc(c.city||'')+' \u00b7 sin conexi\u00f3n</span></div></div>';
        }).join('') : '<div class="ac-msg">Sin resultados en los datos descargados</div>';
        return;
      }
      drop.innerHTML='<div class="ac-msg">Sin conexi\u00f3n y sin datos descargados. '
        +'Con"ectate una vez y usa Descargar datos.</div>'.replace('"','');
      return;
    }

    // Se busca en las DOS empresas a la vez. Los de NAPA se marcan con
    // napa:true y, al enviarse, el pedido entra bajo el codigo paraguas.
    var res=await Promise.all([
      q('clientes','select=cardcode,cardname,city,balance,creditline,slpcode,currency&cardtype=eq.C&or=(cardname.ilike.*'+encodeURIComponent(val)+'*,cardcode.ilike.*'+encodeURIComponent(val)+'*)&limit=10'),
      (typeof npBuscarNapa==='function' ? npBuscarNapa(val) : Promise.resolve([]))
    ]);
    var kcc=res[0]||[], nap=res[1]||[];
    // Los de NAPA van PRIMERO. Antes iban al final, detras de los 10 de
    // Kennedy, y en una lista de esa altura quedaban fuera de la vista: por
    // eso parecia que no salian.
    var data=nap.concat(kcc.slice(0, Math.max(4, 10-nap.length)));
    var sep = nap.length && kcc.length;
    drop.innerHTML=data.length?data.map(function(c,i){
      // Separador entre las dos empresas, para que se lea de un vistazo.
      var cab = '';
      if(i===0 && nap.length) cab='<div style="padding:5px 11px;font-size:10.5px;font-weight:700;color:#7C3AED;background:#F5F3FF;letter-spacing:.4px">NAPA</div>';
      if(sep && i===nap.length) cab='<div style="padding:5px 11px;font-size:10.5px;font-weight:700;color:var(--text3);background:var(--surface2,#F7F7F8);letter-spacing:.4px">KENNEDY</div>';
      var et = c.napa
        ? '<span style="background:#7C3AED;color:#fff;padding:1px 6px;border-radius:8px;font-size:10px;font-weight:700;margin-left:6px;vertical-align:middle">NAPA</span>'
        : '';
      return cab + (function(){

      return '<div class="ac-item" onclick="npSelCliente('+JSON.stringify(c).replace(/"/g,'&quot;')+')">'
        +'<div class="ac-av"'+(c.napa?' style="background:#7C3AED"':'')+'>'+ini(c.cardname)+'</div>'
        +'<div class="ac-info"><p>'+c.cardname+et+'</p><span>'+c.cardcode+' \u00b7 '+(c.city||'')+'</span></div>'
        +'</div>';
      })();
    }).join(''):'<div class="ac-msg">Sin resultados</div>';
  },300);
}

async function npSelCliente(c){
  // El selector de destino depende del rol: se pinta al preparar el pedido.
  setTimeout(function(){
    try{ npPintarDestino(); }catch(e){}
    try{ npFechasPorDefecto(false); }catch(e){}
  }, 60);
  if(typeof c==='string') c=JSON.parse(c);
  npCli=c;
  var drop=document.getElementById('np-cli-drop');
  if(drop) drop.classList.remove('show');
  var inp=document.getElementById('np-cli-q');
  if(inp) inp.style.display='none';
  var sel=document.getElementById('np-cli-sel');
  if(sel) sel.style.display='flex';
  var av=document.getElementById('np-cli-av');if(av) av.textContent=ini(c.cardname);
  var nm=document.getElementById('np-cli-name');if(nm) nm.textContent=c.cardname;
  var mt=document.getElementById('np-cli-meta');
  if(mt){
    mt.innerHTML = npEsc(c.cardcode)+' \u00b7 '+npEsc(c.city||'')
      + (c.napa ? ' <span style="background:#7C3AED;color:#fff;padding:1px 7px;border-radius:9px;font-size:10.5px;font-weight:700;margin-left:5px">NAPA</span>' : '');
  }
  // Aviso visible: quien arma el pedido tiene que saber a nombre de quien entra.
  var _na=document.getElementById('np-napa-aviso');
  if(c.napa){
    if(!_na && sel){
      _na=document.createElement('div'); _na.id='np-napa-aviso';
      _na.style.cssText='margin-top:8px;background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;'
        +'padding:8px 11px;font-size:12px;color:#5B21B6;line-height:1.5;flex-basis:100%';
      sel.appendChild(_na);
    }
    if(_na) _na.innerHTML='Cliente de <b>NAPA</b>. El pedido se crear\u00e1 en SAP bajo el c\u00f3digo '
      +'<b>'+NAPA_CARDCODE+'</b>, con <b>'+npEsc(c.cardname)+'</b> como marca del cliente. '
      +'Su estado de cuenta y sus facturas siguen siendo los suyos.';
  } else if(_na){ _na.remove(); }
  var sl=document.getElementById('np-cli-saldo');if(sl) sl.textContent=fmt(c.balance);
  var btn=document.getElementById('np-btn2');if(btn) btn.disabled=false;
  if(c.currency){var mon=document.getElementById('np-moneda');if(mon)mon.value=c.currency;}
  if(c.slpcode){var vend=document.getElementById('np-vendedor');if(vend)vend.value=c.slpcode;}
  // Cargar historial
  // El historial de precios vive en las tablas de Kennedy: un cliente de NAPA
  // no lo tiene ahi, asi que no se consulta (devolveria vacio igualmente).
  var hist = c.napa ? [] :
    await q('ultimo_precio_cliente','select=itemcode,dscription,fechaultima_compra,ultimoprecio,ultimacantidad&cardcode=eq.'+c.cardcode+'&order=fechaultima_compra.desc&limit=10');
  if(hist.length){
    var hEl=document.getElementById('np-historial');if(hEl)hEl.style.display='block';
    var hBody=document.getElementById('np-hist-body');
    if(hBody) hBody.innerHTML=hist.map(function(h){
      return '<tr><td>'+(h.dscription||h.itemcode)+'</td><td style="color:#888">'+fmtD(h.fechaultima_compra)+'</td><td><b>'+fmt(h.ultimoprecio)+'</b></td><td>'+(h.ultimacantidad||'—')+'</td>'
        +'<td><button class="btn btn-sm" onclick="npAgregarLineaDirecta(this)" data-code="'+h.itemcode+'" data-name="'+(h.dscription||h.itemcode).replace(/"/g,'')+'" data-price="'+h.ultimoprecio+'" data-qty="'+(h.ultimacantidad||1)+'">+ Agregar</button></td></tr>';
    }).join('');
  }
  cotizUpdate();
  // Si venimos de una cotización (ya hay líneas), saltar directo a revisar el pedido
  if(npLineas.length){ npIr(3); }
}

function npLimpiarCliente(){
  npCli=null;
  var inp=document.getElementById('np-cli-q');if(inp){inp.style.display='block';inp.value='';}
  var sel=document.getElementById('np-cli-sel');if(sel)sel.style.display='none';
  var h=document.getElementById('np-historial');if(h)h.style.display='none';
  var btn=document.getElementById('np-btn2');if(btn)btn.disabled=true;
}

function npIr(n){
  // Al llegar a Detalles, las fechas deben estar puestas: npInit solo
  // corre al entrar a la pantalla, y aqui se puede llegar por otras vias.
  try{ npFechasPorDefecto(false); }catch(e){}
  // Al cambiar de paso, refrescar el contenedor: el carrito pudo cambiar en
  // el catalogo sin pasar por la pantalla de totales.
  setTimeout(function(){ try{ ctRender(); }catch(e){} }, 80);
  if(n===2&&!npCli)return;
  if(n===3&&!npLineas.length)return;
  if(n===4){
    npArmarResumen();
    // El margen no lo ven los clientes, ni aunque armen su propia cotizacion.
    var bm=document.getElementById('np-btn-margen');
    if(bm) bm.style.display = npVerMargen() ? '' : 'none';
    var be=document.getElementById('np-btn-env');
    if(be){be.textContent='✓ Confirmar y enviar cotización';be.disabled=false;}
    var stx=document.getElementById('np-status');
    if(stx){stx.style.display='none';stx.innerHTML='';}
  }
  [1,2,3,4].forEach(function(i){
    var p=document.getElementById('np'+i);if(p)p.style.display=i===n?'block':'none';
    var s=document.getElementById('ns'+i);
    if(s){ s.classList.remove('active','done'); if(i===n) s.classList.add('active'); else if(i<n) s.classList.add('done'); }
  });
  window.scrollTo(0,0);
  if(n===2){
    catPage=0;
    catLlenarAnios();
    catCargar();
    // Cargar tipos (subg) y colecciones para el panel lateral
    Promise.all([
      catCats.length?Promise.resolve(catCats):obtenerTipos().then(function(codes){catCats=codes.sort(function(a,b){return subgLabel(a).localeCompare(subgLabel(b));});return catCats;}),
      (COL_LISTA===null?cargarColecciones():Promise.resolve(COL_LISTA))
    ]).then(function(){ catTipos=tiposDedup(catCats); catRenderTipos(); });
  }
  if(n===3) npRenderLineas();
}
var catCats=[];
function catRenderTipos(){
  var el=document.getElementById('cat-cats'); if(!el) return;
  var html=panelHeader('🗂️ Colecciones');
  html+=panelItem('Todas', arbSelCat==='', "catSelArbol('')", true);
  html+=arbHTML(arbSelCat,'catSelArbol','#e85424');
  html+='<div style="border-top:1px solid var(--border);margin-top:8px"></div>'+panelHeader('🏷️ Tipo de producto');
  html+=panelItem('Todos', catCatF==='', "catFiltCat('')", true);
  if(catTipos) catTipos.labels.forEach(function(lab){
    html+=panelItem(npEsc(lab), catCatF===lab, "catFiltCat('"+lab.replace(/'/g,"\\'").replace(/"/g,'')+"')", true);
  });
  el.innerHTML=html;
  catRenderTabs();
}
function catLlenarAnios(){
  var sel=document.getElementById('cat-anio'); if(!sel||sel.dataset.listo) return;
  var y=new Date().getFullYear();
  for(var a=y; a>=2015; a--){ var o=document.createElement('option'); o.value=a; o.textContent=a+' o más reciente'; sel.appendChild(o); }
  sel.dataset.listo='1';
}
// ── Rango de fecha de entrada del catalogo (dd/mm/aaaa) ────────────────────
// Igual que en Inventario: los tres filtros de fecha miran fechaentrada, asi
// que son excluyentes entre si. Se puede escribir o elegir del calendario.
var catRDesdeF='', catRHastaF='';

function catRangoInput(el){
  var d=String(el.value||'').replace(/[^0-9]/g,'').slice(0,8);
  var out=d.slice(0,2);
  if(d.length>2) out+='/'+d.slice(2,4);
  if(d.length>4) out+='/'+d.slice(4,8);
  el.value=out;
}

function _catMarcar(el, mal){
  if(!el) return;
  var caja = el.parentElement || el;
  caja.style.borderColor = mal ? 'var(--red)' : 'var(--border)';
}

function catAbrirCal(id){
  var cal=document.getElementById(id+'-cal'), txt=document.getElementById(id);
  if(!cal) return;
  if(txt){ var iso=_invFechaISO(txt.value); if(iso) cal.value=iso; }
  try{
    if(typeof cal.showPicker==='function') cal.showPicker();
    else { cal.style.opacity='1'; cal.style.width='auto'; cal.style.height='auto'; cal.focus(); cal.click(); }
  }catch(e){ cal.focus(); cal.click(); }
}

function catCalSet(id, iso){
  var txt=document.getElementById(id); if(!txt || !iso) return;
  txt.value=_invFechaDMY(iso);
  var cal=document.getElementById(id+'-cal');
  if(cal){ cal.style.opacity='0'; cal.style.width='1px'; cal.style.height='1px'; }
  catRango();
}

function catRango(){
  var d=document.getElementById('cat-rdesde'), h=document.getElementById('cat-rhasta');
  var td=d?d.value.trim():'', th=h?h.value.trim():'';
  var iso1=_invFechaISO(td), iso2=_invFechaISO(th);

  _catMarcar(d, !!(td && !iso1));
  _catMarcar(h, !!(th && !iso2));
  if(td && !iso1){ alert('La fecha "desde" no es valida. Usa el formato dd/mm/aaaa, por ejemplo 01/07/2026.'); return; }
  if(th && !iso2){ alert('La fecha "hasta" no es valida. Usa el formato dd/mm/aaaa, por ejemplo 31/07/2026.'); return; }

  if(iso1 && iso2 && iso1>iso2){
    _catMarcar(d,true); _catMarcar(h,true);
    alert('El rango esta al reves.\n\nDesde: '+_invFechaDMY(iso1)+'\nHasta: '+_invFechaDMY(iso2)
          +'\n\nLa fecha "desde" tiene que ser anterior o igual a la de "hasta".');
    return;
  }
  _catMarcar(d,false); _catMarcar(h,false);

  var c1=document.getElementById('cat-rdesde-cal'); if(c1) c1.value=iso1||'';
  var c2=document.getElementById('cat-rhasta-cal'); if(c2) c2.value=iso2||'';

  catRDesdeF=iso1; catRHastaF=iso2;

  if(iso1 || iso2){
    catRecienteF=''; catAnioF='';
    var m=document.getElementById('cat-reciente'); if(m) m.value='';
    var a=document.getElementById('cat-anio');     if(a) a.value='';
  }
  catPage=0; catCargar();
}

function _catLimpiarRango(){
  catRDesdeF=''; catRHastaF='';
  ['cat-rdesde','cat-rhasta'].forEach(function(id){
    var e=document.getElementById(id);
    if(e){ e.value=''; _catMarcar(e,false); }
    var c=document.getElementById(id+'-cal');
    if(c) c.value='';
  });
}

// ── Filtro por marca en el catalogo del pedido ────────────────────────────
// Reutiliza invMarcaCodes e invCargarMarcas del inventario: la lista de
// marcas y el cruce a itemcodes son los mismos, no hace falta duplicarlos.
var catMarcaF='', catMarcasLoaded=false;

function catMarca(v){ catMarcaF=v||''; catPage=0; catCargar(); }

async function catCargarMarcas(){
  if(!navigator.onLine) return;
  if(catMarcasLoaded) return;
  var sel=document.getElementById('cat-marca'); if(!sel) return;
  catMarcasLoaded=true;
  var marcas=[];
  try{
    var rows=await q('marcas_inventario','select=marca&order=marca');
    marcas=(rows||[]).map(function(r){ return (r.marca||'').trim(); }).filter(Boolean);
  }catch(e){}
  if(!marcas.length){
    try{
      var rs=await q('inventario','select=marca&marca=not.is.null&limit=20000');
      var st={}; (rs||[]).forEach(function(r){ var m=(r.marca||'').trim(); if(m) st[m]=1; });
      marcas=Object.keys(st);
    }catch(e){}
  }
  marcas=marcas.sort(function(a,b){ return a.localeCompare(b,'es',{sensitivity:'base'}); });
  if(!marcas.length){ catMarcasLoaded=false; return; }
  var cur=sel.value;
  sel.innerHTML='<option value="">Todas las marcas</option>'
    + marcas.map(function(m){ return '<option value="'+npEsc(m)+'">'+npEsc(m)+'</option>'; }).join('');
  sel.value=cur;
}

function catAnio(v){catAnioF=v; if(v){ catRecienteF=''; var m=document.getElementById('cat-reciente'); if(m) m.value=''; _catLimpiarRango(); } catPage=0;catCargar();}
function catReciente(v){ catRecienteF=v; if(v){ catAnioF=''; var a=document.getElementById('cat-anio'); if(a) a.value=''; _catLimpiarRango(); } catPage=0; catCargar(); }
var catFTimer=null;
function catFiltAvz(){
  catPMin=($('cat-pmin')||{}).value||''; catPMax=($('cat-pmax')||{}).value||'';
  catSMin=($('cat-smin')||{}).value||''; catDispF=($('cat-disp')||{}).value||'';
  catImgF=($('cat-img')||{}).value||''; catOrden=($('cat-orden')||{}).value||'';
  catBMin=($('cat-bmin')||{}).value||''; catBMax=($('cat-bmax')||{}).value||'';
  catPage=0; clearTimeout(catFTimer); catFTimer=setTimeout(catCargar,350);
}

async function catCargar(append){
  var grid=document.getElementById('cat-grid');
  if(!grid)return;
  if(!append){ catPage=0; grid.innerHTML='<div style="grid-column:1/-1;padding:40px;text-align:center;color:#888">Cargando...</div>'; }

  var ext=await invCols();
  var off=catPage*CAT_PS;
  var colsExtra=ext?',numinbuy,subg,precioventa,unidadesbulto,fechaentrada':'';
  var ccodes=null;
  if(arbSelCat && ARB_NODES[arbSelCat]){
    ccodes=await arbolItemcodes(ARB_NODES[arbSelCat]);
    if(!ccodes||!ccodes.length) ccodes=['__ninguno__'];
  }
  if(!append){ catCargarGrupos(); catCargarMarcas(); }

  // Filtro por marca: se cruza con la coleccion ya elegida. inv_buscar no
  // tiene parametro de marca, asi que se resuelve mandando sus itemcodes.
  if(catMarcaF){
    var _mc = await invMarcaCodes(catMarcaF);
    if(!_mc.length) _mc=['__ninguno__'];
    if(ccodes && ccodes.length && ccodes[0]!=='__ninguno__'){
      var _set={}; _mc.forEach(function(c){ _set[c]=1; });
      ccodes = ccodes.filter(function(c){ return _set[c]; });
      if(!ccodes.length) ccodes=['__ninguno__'];
    } else {
      ccodes = _mc;
    }
  }

  var body={
    p_itemcodes: ccodes,
    p_grupo: (catGrupoF||null),
    p_grupos: (catGruposSel && catGruposSel.length ? catGruposSel : null),
    p_textos: catTextos.length?catTextos:null,
    p_q: (catTextos.length?null:((catQ&&catQ.trim())?catQ.trim():null)),
    p_subg: (ext && catCatF!=='' && catTipos && catTipos.map[catCatF]) ? catTipos.map[catCatF].map(function(c){return String(c);}) : null,
    p_pmin: (catPMin!==''&&!isNaN(+catPMin))?+catPMin:null,
    p_pmax: (catPMax!==''&&!isNaN(+catPMax))?+catPMax:null,
    p_smin: (catSMin!==''&&!isNaN(+catSMin))?+catSMin:null,
    p_smax: null,
    p_bmin: (catBMin!==''&&!isNaN(+catBMin)&&+catBMin>0)?+catBMin:null,
    p_bmax: (catBMax!==''&&!isNaN(+catBMax)&&+catBMax>0)?+catBMax:null,
    p_disp: catDispF||null,
    p_img: catImgF||null,
    p_anio: (ext&&catAnioF!=='')?+catAnioF:null,
    p_desde: (catRecienteF!=='' && catRecienteF) ? _mesesAtras(+catRecienteF) : null,
    p_bajo: false,
    p_orden: catOrden||'reciente',
    p_limit: CAT_PS,
    p_offset: off
  };

  var data;

  // SIN CONEXION: se responde con los articulos descargados, devolviendo lo
  // MISMO que devolveria el servidor. Asi el resto de catCargar sigue igual
  // —orden, tarjetas, fotos, paginacion— en vez de tener un camino aparte.
  if(!navigator.onLine){
    var _off = (typeof kccInvBuscar==='function') ? await kccInvBuscar(body) : null;
    if(!_off){
      // Sin red y sin catalogo descargado: se avisa YA en vez de intentar la
      // llamada al servidor y dejar la pantalla en "Cargando..." para siempre.
      grid.innerHTML='<div style="grid-column:1/-1;padding:34px;text-align:center;color:var(--amber);font-size:13.5px;line-height:1.6">'
        +'<b>Sin conexi\u00f3n y sin cat\u00e1logo descargado</b><br>'
        +'<span style="color:var(--text3);font-size:12.5px">Con\u00e9ctate y pulsa '
        +'<b>Descargar</b> en la tarjeta del Dashboard.</span></div>';
      catHasNext=false; catLoadingMore=false;
      return;
    }
    if(_off){
      data = _off;
      var _av=document.getElementById('cat-aviso-off');
      if(!_av && grid.parentElement){
        _av=document.createElement('div');
        _av.id='cat-aviso-off';
        _av.style.cssText='background:#FFFBEB;border:1px solid #FDE68A;color:#92400E;'
          +'border-radius:9px;padding:9px 12px;font-size:12.5px;margin-bottom:10px';
        grid.parentElement.insertBefore(_av, grid);
      }
      if(_av) _av.innerHTML='Sin conexi\u00f3n \u00b7 cat\u00e1logo descargado. '
        +'<b>El stock puede haber cambiado</b>: se confirmar\u00e1 al enviar el pedido.';
      // Las fotos guardadas se colocan al terminar de pintar: solo las visibles.
      if(typeof kccPintarFotos==='function') setTimeout(function(){ kccPintarFotos(grid); }, 60);
    }
  } else {
    var _av2=document.getElementById('cat-aviso-off'); if(_av2) _av2.remove();
  }

  if(data===undefined) try{
    let resp=await fetch(`${SB}/rest/v1/rpc/inv_buscar`,{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(body)});
    // Si la funcion aun no tiene p_hasta, PostgREST responde 404/PGRST202:
    // se reintenta sin el y el corte superior se aplica sobre lo recibido.
    if(!resp.ok && body.p_hasta){
      var _t0=await resp.text();
      if(resp.status===404 || /PGRST202|p_hasta/i.test(_t0)){
        INV_RPC_HASTA=false; delete body.p_hasta;
        resp=await fetch(`${SB}/rest/v1/rpc/inv_buscar`,{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(body)});
      } else {
        grid.innerHTML='<div style="grid-column:1/-1;padding:40px;text-align:center;color:#E24B4A">No se pudo cargar el cat\u00e1logo<br><small>'+npEsc(_t0.slice(0,200))+'</small></div>';
        return;
      }
    }
    if(!resp.ok){ var t=await resp.text(); grid.innerHTML='<div style="grid-column:1/-1;padding:40px;text-align:center;color:#E24B4A">No se pudo cargar el catálogo<br><span style="font-size:11px;color:#888">'+t.slice(0,200)+'</span></div>'; return; }
    data=await resp.json();
    // Sin p_hasta en la funcion, el corte superior se hace aqui.
    if(catRHastaF && INV_RPC_HASTA===false){
      data=(data||[]).filter(function(r){
        var f=String(r.fechaentrada||'').substring(0,10);
        return f && f<=catRHastaF;
      });
    }
  }catch(e){ grid.innerHTML='<div style="grid-column:1/-1;padding:40px;text-align:center;color:#E24B4A">Error de conexión: '+e.message+'</div>'; return; }
  var countEl=document.getElementById('cat-count-top');
  if(countEl) countEl.textContent=(off+data.length)+' productos';
  if(!append && !data.length){
    grid.innerHTML='<div style="grid-column:1/-1;padding:40px;text-align:center;color:#888">Sin resultados</div>';
    _infScroll('cat-grid','cat-sentinel',false,function(){});
    return;
  }
  var _cards=data.map(function(i){return catVista==='list'?catCardList(i):catCard(i);}).join('');
  var _nuevas;
  if(append){
    var _s=document.getElementById('cat-sentinel'); if(_s)_s.remove();
    var _tmp=document.createElement('div'); _tmp.innerHTML=_cards;
    _nuevas=Array.prototype.slice.call(_tmp.children);
    while(_tmp.firstChild) grid.appendChild(_tmp.firstChild);
  }else{
    grid.innerHTML=_cards;
    _nuevas=Array.prototype.slice.call(grid.querySelectorAll('[id^="pcard-"]'));
  }
  aplicarVistaCat();
  _nuevas.forEach(function(card){
    if(!card.querySelector) return;
    var minus=card.querySelector('.cat-minus');
    var plus=card.querySelector('.cat-plus');
    var inp=card.querySelector('.cat-qty');
    if(minus) minus.addEventListener('click',function(){catQtyByEl(card,-1);});
    if(plus) plus.addEventListener('click',function(){catQtyByEl(card,1);});
    if(inp) inp.addEventListener('change',function(){catSetQtyByEl(card,+this.value);});
    card.querySelectorAll('.pc-open').forEach(function(t){ t.addEventListener('click',function(){ catVerModal(card.dataset.code); }); });
  });
  catHasNext=(data.length===CAT_PS); catLoadingMore=false;
  _infScroll('cat-grid','cat-sentinel',catHasNext,function(){ if(!catLoadingMore&&catHasNext){ catLoadingMore=true; catPage++; catCargar(true); } });
}

// ===================== MODAL DETALLE DE PRODUCTO (catalogo Nuevo Pedido) =====================
function _pcEsc(e){ if(e.key==='Escape') catCerrarModal(); }
function catCerrarModal(){ var m=document.getElementById('pc-modal'); if(m) m.remove(); document.removeEventListener('keydown',_pcEsc); }
async function catVerModal(code){
  if(!code) return;
  catCerrarModal();
  var ov=document.createElement('div');
  ov.id='pc-modal';
  ov.style.cssText='position:fixed;inset:0;z-index:300;background:rgba(10,12,19,.55);display:flex;align-items:center;justify-content:center;padding:18px';
  ov.addEventListener('click',function(e){ if(e.target===ov) catCerrarModal(); });
  ov.innerHTML='<div style="background:#fff;border-radius:14px;max-width:560px;width:100%;max-height:88vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.35);padding:18px"><div style="display:flex;align-items:center;justify-content:center;height:200px"><div class="spinner" style="border-top-color:var(--blue)"></div></div></div>';
  document.body.appendChild(ov);
  document.addEventListener('keydown',_pcEsc);
  var box=ov.firstChild;
  try{
    var res=await Promise.all([
      q('vista_inventario','select=*&itemcode=eq.'+encodeURIComponent(code)+'&limit=1'),
      q('fotos','select=url&itemcode=eq.'+encodeURIComponent(code)+'&limit=1')
    ]);
    var b=(res[0]&&res[0][0])||{};
    var foto=(res[1]&&res[1][0]&&res[1][0].url)||b.foto_url||null;
    var nombre=b.itemname||code;
    var precio=pvVenta(b);
    var pventa=Number(b.precioventa||0);
    var dispo=Number(b.disponiblebodega||b.disponible||0);
    var bulto=Math.max(1,Number(b.unidadesbulto)||Number(b.numinbuy)||1);
    var carac=(b.caracteristicas&&typeof b.caracteristicas==='object')?b.caracteristicas:null;
    var marca=b.marca||(carac?rptCarac(carac,['marca','brand']):'')||'';
    var nmJs=String(nombre).replace(/'/g,"\\'");
    var cdJs=String(code).replace(/'/g,"\\'");
    var fichaHtml=fichaTecnica(b,carac);
    box.innerHTML=
      '<div style="display:flex;align-items:flex-start;gap:10px;margin-bottom:12px">'
        +'<div style="font-size:16px;font-weight:700;flex:1;line-height:1.3">'+nombre+'</div>'
        +'<button onclick="catCerrarModal()" style="width:32px;height:32px;border:1px solid var(--border);background:#fff;border-radius:8px;cursor:pointer;font-size:18px;line-height:1;flex:0 0 auto">&times;</button>'
      +'</div>'
      +(foto
        ? '<img src="'+foto+'" style="width:100%;max-height:300px;object-fit:contain;background:var(--bg);border-radius:10px;border:1px solid var(--border);margin-bottom:12px" onerror="this.style.display=\'none\'">'
        : '<div style="width:100%;height:220px;background:var(--bg);border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:46px;margin-bottom:12px">\u{1F4E6}</div>')

  // El CIF, para administracion. Es la lista 2 de SAP -la misma que usa el
  // calculo de margen-, y en la ficha hace falta al lado del FOB: el FOB es
  // lo que costo la mercancia y el CIF lo que costo puesta aqui.
  var _catCif = null;
  if(CU && CU.rol === 'admin'){
    try{
      var _lp = await q('lista_precios',
        'select=price&listnum=eq.2&itemcode=eq.' + encodeURIComponent(code) + '&limit=1');
      if(_lp && _lp[0] && Number(_lp[0].price) > 0) _catCif = Number(_lp[0].price);
    }catch(e){}
  }

      +'<div style="display:grid;grid-template-columns:repeat('+((CU&&CU.rol==='admin')?(_catCif!=null?4:3):2)+',1fr);gap:8px;margin-bottom:12px">'
        +'<div style="background:var(--bg);border-radius:10px;padding:8px 10px"><div style="font-size:11px;color:var(--text3)">Precio</div><div style="font-size:15px;font-weight:700">'+(pventa?fmt(pventa):pvEtiqueta(precio))+'</div></div>'
        +'<div style="background:var(--bg);border-radius:10px;padding:8px 10px"><div style="font-size:11px;color:var(--text3)">Disponible</div><div style="font-size:15px;font-weight:700">'+fmtN(dispo)+'</div></div>'
        +((CU&&CU.rol==='admin')?'<div style="background:var(--bg);border-radius:10px;padding:8px 10px"><div style="font-size:11px;color:var(--text3)">Ultimo costo</div><div style="font-size:15px;font-weight:700">'+fmt(b.lastpurprc)+'</div></div>':'')
        +((CU&&CU.rol==='admin' && _catCif!=null)?'<div style="background:var(--bg);border-radius:10px;padding:8px 10px"><div style="font-size:11px;color:var(--text3)">Costo CIF</div><div style="font-size:15px;font-weight:700">'+fmt(_catCif)+'</div>'+((Number(b.lastpurprc)||0)>0?'<div style="font-size:10.5px;color:var(--text3)">+'+Math.round((_catCif/Number(b.lastpurprc)-1)*100)+'% sobre el FOB</div>':'')+'</div>':'')
      +'</div>'
      +'<table class="tbl">'
        +'<tr><td style="color:var(--text3);width:130px">Codigo</td><td><b>'+code+'</b></td></tr>'
        +'<tr><td style="color:var(--text3)">Tipo de producto</td><td>'+subgLabel(b.subg)+'</td></tr>'
        +'<tr><td style="color:var(--text3)">Marca</td><td>'+marca+'</td></tr>'
        +'<tr><td style="color:var(--text3)">Codigo barras</td><td>'+(b.codebars||'')+'</td></tr>'
        +'<tr><td style="color:var(--text3)">Unidades por bulto</td><td>'+fmtN(bulto)+'</td></tr>'
      +'</table>'
      +(fichaHtml||'')
      +'<div style="display:flex;gap:8px;margin-top:14px">'
        +'<button class="btn btn-p" style="flex:1" onclick="catModalAdd(\''+cdJs+'\',\''+nmJs+'\','+precio+','+bulto+')">Anadir al pedido'+(bulto>1?' (bulto '+fmtN(bulto)+')':'')+'</button>'
        +'<button class="btn" onclick="catCerrarModal()">Cerrar</button>'
      +'</div>';
  }catch(e){
    box.innerHTML='<div style="padding:8px 4px">No se pudo cargar el producto. <button class="btn btn-sm" onclick="catCerrarModal()">Cerrar</button></div>';
  }
}
function catModalAdd(code,name,price,bulto){
  catQty(code,name,price,bulto,bulto);
  var card=document.getElementById('pcard-'+String(code).replace(/[^a-zA-Z0-9]/g,'_'));
  if(card){ var inp=card.querySelector('input.cat-qty'); if(inp){ var l=npLineas.find(function(x){return x.itemcode===code;}); inp.value=l?l.quantity:''; } }
}

function renderCatPager(grid,off,count){
  var hasPrev=catPage>0, hasNext=count===CAT_PS;
  var pag=document.createElement('div');
  pag.style.cssText='grid-column:1/-1;padding:12px 16px;display:flex;justify-content:space-between;align-items:center;background:#f5f7fa;border-top:1px solid #e5e7eb';
  pag.innerHTML='<span style="font-size:12px;color:#888">'+(off+1)+'-'+(off+count)+'</span>';
  var btns=document.createElement('div');btns.style.cssText='display:flex;gap:8px';
  if(hasPrev){var b=document.createElement('button');b.className='btn btn-sm';b.textContent='← Anterior';b.onclick=function(){catPage--;catCargar();};btns.appendChild(b);}
  if(hasNext){var b=document.createElement('button');b.className='btn btn-sm btn-p';b.textContent='Siguiente →';b.onclick=function(){catPage++;catCargar();};btns.appendChild(b);}
  pag.appendChild(btns);
  grid.appendChild(pag);
}



// ===================== TABS DE CATEGORIA + MODOS DE VISTA + DASHBOARD CLIENTE (v9) =====================
var catVista=(function(){try{return localStorage.getItem('kc_catvista')||'grid';}catch(e){return 'grid';}})();
function aplicarVistaCat(){
  var g=document.getElementById('cat-grid'); if(!g)return;
  g.classList.remove('catv-grid','catv-list','catv-img'); g.classList.add('catv-'+catVista);
  g.style.gridTemplateColumns = catVista==='list' ? '1fr' : (catVista==='img' ? 'repeat(auto-fill,minmax(210px,1fr))' : 'repeat(auto-fill,minmax(150px,1fr))');
  ['grid','list','img'].forEach(function(m){var b=document.getElementById('cv-'+m);if(b)b.classList.toggle('active',m===catVista);});
}
function catSetVista(m){ catVista=m; try{localStorage.setItem('kc_catvista',m);}catch(e){} catCargar(); }
// El precio de venta del articulo, SIN caer en el costo.
//
// Antes estas tarjetas hacian `precioventa || avgprice || lastpurprc`, asi que
// un articulo recien llegado, todavia sin precio en la lista 3, mostraba su
// COSTO con formato de precio de venta. Un vendedor podia cotizarlo a costo
// sin enterarse. Ahora devuelve 0 y la tarjeta lo dice.
function pvVenta(i){
  return Number((i&&i.precioventa)||0);
}
// La etiqueta que se pinta en su lugar.
function pvEtiqueta(p){
  return p>0 ? fmt(p)
    : '<span style="color:#B45309;font-weight:700">Sin precio</span>';
}

/* ── Stock y disponible ───────────────────────────────────────────────
   STOCK      lo que hay fisicamente en bodega.
   DISPONIBLE lo que se puede vender: el stock menos lo separado en pedidos
              YA AUTORIZADOS.

   Lo reservado en pedidos SIN autorizar no se descuenta: ese pedido puede
   caerse y la mercancia sigue libre. Descontarlo hacia que el vendedor viera
   menos de lo que podia vender.
   ────────────────────────────────────────────────────────────────────── */
var SEP_AUT = {};        // itemcode -> piezas en pedidos AUTORIZADOS
var SEP_PEND = [];
var SEP_TIMER = null;

// El stock fisico, tal como lo da SAP.
function invStock(i){
  if(!i) return 0;
  return Number(i.onhand != null ? i.onhand
         : (i.disponiblebodega != null ? i.disponiblebodega : i.disponible)) || 0;
}

// Lo que se puede vender.
function dispReal(i){
  var cod = i && i.itemcode;
  var st = invStock(i);
  if(!cod) return st;
  // Si no se sabe todavia, se pide. Asi no hay que tocar cada pantalla: se
  // consultan solo los articulos que de verdad se estan pintando.
  if(SEP_AUT[cod] === undefined){ sepPedir([cod]); return st; }
  return st - Number(SEP_AUT[cod] || 0);
}

// Cuanto esta separado en pedidos autorizados.
function sepAutorizado(itemcode){
  return Number(SEP_AUT[itemcode] || 0);
}

// Se piden en bloque: una pantalla trae muchos articulos y no tiene sentido
// una consulta por cada uno.
function sepPedir(codes){
  if(!codes || !codes.length) return;
  for(var i=0;i<codes.length;i++){
    var c=codes[i];
    if(c && SEP_AUT[c]===undefined && SEP_PEND.indexOf(c)<0) SEP_PEND.push(c);
  }
  if(SEP_TIMER || !SEP_PEND.length) return;
  SEP_TIMER=setTimeout(async function(){
    SEP_TIMER=null;
    var lote=SEP_PEND.splice(0,300);
    // Se marcan en cero ANTES de preguntar: asi no se vuelven a pedir en cada
    // repintado aunque la vista no devuelva nada para ellos.
    lote.forEach(function(c){ if(SEP_AUT[c]===undefined) SEP_AUT[c]=0; });
    try{
      var inList=lote.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var r=await q('separado_autorizado',
        'select=itemcode,autorizado&itemcode=in.('+inList+')&limit='+lote.length);
      var hubo=false;
      (r||[]).forEach(function(x){
        var v=Number(x.autorizado)||0;
        if(v>0){ SEP_AUT[x.itemcode]=v; hubo=true; }
      });
      if(hubo) sepRepintarTodo();
    }catch(e){}
    if(SEP_PEND.length) sepPedir([]);
  }, 300);
}

// Carga lo separado y ESPERA a tenerlo.
//
// `sepPedir` no vale para los informes: encola y vuelve enseguida, asi que el
// Excel se armaba antes de que llegara el dato y el disponible salia igual al
// stock. Aqui se espera de verdad.
async function sepCargar(codes){
  var faltan=[];
  (codes||[]).forEach(function(c){
    if(c && SEP_AUT[c]===undefined && faltan.indexOf(c)<0) faltan.push(c);
  });
  if(!faltan.length) return;
  for(var i=0;i<faltan.length;i+=300){
    var lote=faltan.slice(i,i+300);
    lote.forEach(function(c){ if(SEP_AUT[c]===undefined) SEP_AUT[c]=0; });
    try{
      var inList=lote.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var r=await q('separado_autorizado',
        'select=itemcode,autorizado&itemcode=in.('+inList+')&limit='+lote.length);
      (r||[]).forEach(function(x){
        var v=Number(x.autorizado)||0;
        if(v>0) SEP_AUT[x.itemcode]=v;
      });
    }catch(e){}
  }
}

// Al llegar los datos se repinta lo que haya en pantalla. Se prueban las
// funciones conocidas con guarda: la que no exista, se salta.
function sepRepintarTodo(){
  ['catRender','invRenderGrid','npRenderLineas'].forEach(function(f){
    try{ if(typeof window[f]==='function') window[f](); }catch(e){}
  });
}

function catCardList(i){
  var precio=pvVenta(i);
  // Se suma de vuelta lo reservado en pedidos SIN autorizar: esas
  // piezas todavia se pueden vender.
  var stock=dispReal(i);
  var bulto=Math.max(1,Number(i.unidadesbulto)||Number(i.numinbuy)||1);
  var linea=npLineas.find(function(l){return l.itemcode===i.itemcode;});
  var qty=linea?linea.quantity:0;
  var _fp2=(typeof fotoPair==='function')?fotoPair(i.picturname, i.foto_url):{primary:(i.foto_url||''),fb:''};
  var foto=_fp2.primary||null;
  var div=document.createElement('div');
  div.id='pcard-'+i.itemcode.replace(/[^a-zA-Z0-9]/g,'_');
  div.style.cssText='grid-column:1/-1;display:flex;align-items:center;gap:12px;padding:8px 12px;border-bottom:1px solid #e5e7eb;background:#fff;position:relative';
  var thumb = foto
    ? '<img src="'+foto+'" data-fb="'+(_fp2.fb||'')+'" class="pc-open" style="cursor:pointer;width:48px;height:48px;object-fit:cover;border-radius:6px;flex:0 0 auto" onerror="fotoFallback(this)">'
    : '<div class="pc-open" style="cursor:pointer;width:48px;height:48px;background:#f5f7fa;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:20px;flex:0 0 auto">📦</div>';
  var html=thumb
    +'<div style="flex:1;min-width:0">'
      +'<div class="pc-open" style="cursor:pointer;font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+i.itemname+'</div>'
      +'<div style="font-size:10px;color:#888">'+i.itemcode+(bulto>1?' · bulto '+fmtN(bulto):'')+'</div>'
    +'</div>'
    +'<div style="font-size:13px;font-weight:700;text-align:right;flex:0 0 auto;min-width:96px">'+pvEtiqueta(precio)+'<div style="font-size:10px;font-weight:400"><span style="color:rgb(21,206,43)">'+fmtN(stock)+'</span> <span style="color:rgb(255,0,0)">('+fmtN(i.iscommited||0)+')</span> <span style="color:#C9A800">('+fmtN(i.onorder||0)+')</span></div></div>'
    +'<div style="display:flex;align-items:center;gap:0;flex:0 0 auto">'
      +'<button class="cat-minus" style="width:28px;height:28px;border:1px solid #e5e7eb;background:#fff;cursor:pointer;border-radius:6px 0 0 6px;font-size:16px">−</button>'
      +'<input class="cat-qty" type="number" min="0" value="'+(qty||'')+'" placeholder="0" style="width:52px;height:28px;border:1px solid #e5e7eb;border-left:none;border-right:none;text-align:center;font-size:13px">'
      +'<button class="cat-plus" style="width:28px;height:28px;border:1px solid #e5e7eb;background:#fff;cursor:pointer;border-radius:0 6px 6px 0;font-size:16px">+</button>'
    +'</div>';
  div.innerHTML=html;
  div.dataset.code=i.itemcode; div.dataset.name=i.itemname; div.dataset.price=precio; div.dataset.bulto=bulto;
  return div.outerHTML;
}
// Tabs = departamentos de nivel 1 del arbol (escala con muchas categorias: el detalle vive en el arbol lateral)
function catRenderTabs(){
  var el=document.getElementById('cat-tabs'); if(el) el.innerHTML='';
}
function catGrupo(v){ catGrupoF=v||''; catPage=0; catCargar(); }
async function catCargarGrupos(){
  if(!navigator.onLine) return;
  if(catGruposLoaded) return; catGruposLoaded=true;
  var cont=document.getElementById('cat-grupo-ms'); if(!cont) return;
  var grupos=[];
  try{ var rows=await q('grupos_inventario','select=grupo&order=grupo'); grupos=(rows||[]).map(function(r){return r.grupo;}).filter(Boolean); }catch(e){}
  if(!grupos.length){ try{ var rs=await q('inventario','select=grupo&grupo=not.is.null&limit=8000'); var st={}; (rs||[]).forEach(function(r){ if(r.grupo) st[r.grupo]=1; }); grupos=Object.keys(st).sort(); }catch(e){} }
  if(!grupos.length){ catGruposLoaded=false; return; }
  msGruposInit('cat-grupo-ms', grupos, function(sel){ catGruposSel=sel; catPage=0; catCargar(); });
}
function catTab(id){
  if(id){ ARB_EXP[id]=true; arbSelCat=id; } else { arbSelCat=''; }
  catPage=0; catRenderTipos(); catCargar();
  var el=document.getElementById('cat-tabs'); if(el){ var a=el.querySelector('.cat-tab.active'); if(a&&a.scrollIntoView)a.scrollIntoView({inline:'center',block:'nearest'}); }
}

// ---- Dashboard del cliente: nuevo pedido / recomprar frecuentes ----
function _setNpCli(cardcode,cardname){
  npCli={cardcode:cardcode,cardname:cardname||cardcode};
  var inp=document.getElementById('np-cli-q');if(inp)inp.style.display='none';
  var sel=document.getElementById('np-cli-sel');
  if(sel){sel.style.display='block';
    var nm=document.getElementById('np-cli-name');if(nm)nm.textContent=npCli.cardname;
    var mt=document.getElementById('np-cli-meta');if(mt)mt.textContent=npCli.cardcode;
    var av=document.getElementById('np-cli-av');if(av)av.textContent=(npCli.cardname||'?').slice(0,2).toUpperCase();
  }
  var b2=document.getElementById('np-btn2');if(b2)b2.disabled=false;
}
function nuevoPedidoCliente(cardcode){
  var nm=(_cliActual&&_cliActual.cardname)||cardcode;
  npLineas=[];
  go('nuevo_pedido',document.getElementById('nav-np'));
  setTimeout(function(){ _setNpCli(cardcode,nm); npIr(2); },150);
}
function recomprarFrecuentes(){
  var up=_cliUP||[];
  if(!up.length){ alert('Este cliente no tiene productos frecuentes registrados.'); return; }
  if(!confirm('Cargar '+up.length+' producto(s) frecuente(s) en un nuevo pedido para '+((_cliActual&&_cliActual.cardname)||'')+'?')) return;
  npLineas=up.map(function(u){return {itemcode:u.itemcode,itemname:u.dscription||u.itemcode,quantity:Number(u.ultimacantidad)||1,price:Number(u.ultimoprecio)||0,discount:Number(u.descuento)||0,whscode:'',bulto:1,note:''};});
  var cc=(_cliActual&&_cliActual.cardcode)||''; var nm=(_cliActual&&_cliActual.cardname)||cc;
  go('nuevo_pedido',document.getElementById('nav-np'));
  setTimeout(function(){ _setNpCli(cc,nm); npIr(3); if(typeof npRenderLineas==='function')npRenderLineas(); },150);
}
// =====================================================================================================

function catCard(i){
  var precio=pvVenta(i);
  // Se suma de vuelta lo reservado en pedidos SIN autorizar: esas
  // piezas todavia se pueden vender.
  var stock=dispReal(i);
  var bulto=Math.max(1,Number(i.unidadesbulto)||Number(i.numinbuy)||1);
  var linea=npLineas.find(function(l){return l.itemcode===i.itemcode;});
  var qty=linea?linea.quantity:0;
  var _fp=(typeof fotoPair==='function')?fotoPair(i.picturname, i.foto_url):{primary:(i.foto_url||''),fb:''};
  var foto=_fp.primary||null;
  var div=document.createElement('div');
  div.id='pcard-'+i.itemcode.replace(/[^a-zA-Z0-9]/g,'_');
  div.style.cssText='border-right:1px solid #e5e7eb;border-bottom:1px solid #e5e7eb;padding:10px;display:flex;flex-direction:column;position:relative;background:#fff';
  var html='';
  if(qty>0) html+='<div style="position:absolute;top:6px;right:6px;width:8px;height:8px;border-radius:50%;background:#e85424"></div>';
  if(foto) html+='<img src="'+foto+'" data-fb="'+(_fp.fb||'')+'" class="pc-open" style="cursor:pointer;width:100%;aspect-ratio:1;object-fit:cover;border-radius:6px;margin-bottom:6px" onerror="fotoFallback(this)">';
  else html+='<div class="pc-open" style="cursor:pointer;width:100%;aspect-ratio:1;background:#f5f7fa;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:28px;margin-bottom:6px">📦</div>';
  html+='<div class="pc-code" style="font-size:10px;color:#888;font-weight:600;margin-bottom:2px">'+i.itemcode+'</div>';
  html+='<div class="pc-name pc-open" style="cursor:pointer;font-size:11px;line-height:1.3;flex:1;margin-bottom:6px">'+i.itemname+'</div>';
  html+='<div class="pc-price" style="font-size:13px;font-weight:700;margin-bottom:2px">'+pvEtiqueta(precio)+' <span style="font-size:10px;font-weight:400"><span style="color:rgb(21,206,43)">'+fmtN(stock)+'</span> <span style="color:rgb(255,0,0)">('+fmtN(i.iscommited||0)+')</span> <span style="color:#C9A800">('+fmtN(i.onorder||0)+')</span></span></div>';
  if(bulto>1) html+='<div class="pc-bulto" style="font-size:10px;color:#888;margin-bottom:2px">📦 Bulto: '+fmtN(bulto)+'</div>';
  html+='<div style="display:flex;align-items:center;gap:0;margin-top:4px">';
  html+='<button class="cat-minus" style="width:28px;height:28px;border:1px solid #e5e7eb;background:#fff;cursor:pointer;border-radius:6px 0 0 6px;font-size:16px">−</button>';
  html+='<input class="cat-qty" type="number" min="0" value="'+(qty||'')+'" placeholder="0" style="flex:1;height:28px;border:1px solid #e5e7eb;border-left:none;border-right:none;text-align:center;font-size:13px;font-weight:600;outline:none;min-width:0" onfocus="this.select()">';
  html+='<button class="cat-plus" style="width:28px;height:28px;border:1px solid #e5e7eb;background:#fff;cursor:pointer;border-radius:0 6px 6px 0;font-size:16px">+</button>';
  html+='</div>';
  div.innerHTML=html;
  div.dataset.code=i.itemcode;
  div.dataset.name=i.itemname;
  div.dataset.price=precio;
  div.dataset.bulto=bulto;
  return div.outerHTML;
}

function catQtyByEl(div,signo){
  var code=div.dataset.code;
  var name=div.dataset.name;
  var price=parseFloat(div.dataset.price)||0;
  var bulto=Math.max(1,parseFloat(div.dataset.bulto)||1);
  catQty(code,name,price,bulto,signo*bulto);
  // Actualizar input en esta card
  var inp=div.querySelector('input.cat-qty');
  if(inp){var l=npLineas.find(function(x){return x.itemcode===code;});inp.value=l?l.quantity:'';}
}

function catSetQtyByEl(div,qty){
  var code=div.dataset.code;
  var name=div.dataset.name;
  var price=parseFloat(div.dataset.price)||0;
  var bulto=Math.max(1,parseFloat(div.dataset.bulto)||1);
  catSetQty(code,name,price,qty);
  var l=npLineas.find(function(x){return x.itemcode===code;});
  if(l) l.bulto=bulto;
}


function catQtyBtn(btn,delta){
  var p=btn.parentElement;
  var code=btn.dataset.code||p.querySelector('[data-code]').dataset.code;
  var name=btn.dataset.name||p.querySelector('[data-name]').dataset.name;
  var price=parseFloat(btn.dataset.price||p.querySelector('[data-price]').dataset.price)||0;
  catQty(code,name,price,1,delta);
  var inp=p.querySelector('input');
  if(inp){var l=npLineas.find(function(x){return x.itemcode===code;});inp.value=l?l.quantity:'';}
}
function catSetQtyInp(inp){
  var code=inp.dataset.code;
  var name=inp.dataset.name;
  var price=parseFloat(inp.dataset.price)||0;
  catSetQty(code,name,price,+inp.value);
}
// ══ CARRITO COMPARTIDO (inventario + catalogo) ══
function cartAddUnits(itemcode,itemname,precio,bulto,units){
  var l=npLineas.find(function(x){return x.itemcode===itemcode;});
  if(l){
    l.quantity=Math.max(0,Number((l.quantity+units).toFixed(4)));
    if(l.quantity<=0) npLineas=npLineas.filter(function(x){return x.itemcode!==itemcode;});
  } else if(units>0){
    npAgregar({itemcode:itemcode,itemname:itemname,quantity:units,price:Number(precio)||0,discount:0,whscode:'',bulto:bulto||1,note:''});
  }
  cotizUpdate();catUpdateFooter();npUpdateBtn();
}
function cartSetUnits(itemcode,itemname,precio,bulto,qty){
  qty=Number(qty)||0;
  npLineas=npLineas.filter(function(x){return x.itemcode!==itemcode;});
  if(qty>0) npAgregar({itemcode:itemcode,itemname:itemname,quantity:qty,price:Number(precio)||0,discount:0,whscode:'',bulto:bulto||1});
  cotizUpdate();catUpdateFooter();npUpdateBtn();
}

// ══ BARRA FLOTANTE DE COTIZACION ══
function cotizUpdate(){
  var bar=document.getElementById('cotiz-bar');
  if(!bar) return;
  var n=npLineas.length;
  var uds=npLineas.reduce(function(s,l){return s+Number(l.quantity||0);},0);
  var total=npLineas.reduce(function(s,l){return s+l.quantity*l.price*(1-l.discount/100);},0);
  if(n<=0){bar.style.display='none';return;}
  bar.style.display='flex';
  var info=document.getElementById('cotiz-info');
  if(info) info.textContent=(npCli?npCli.cardname:'Cotización')+' · '+n+' ítem'+(n!==1?'s':'')+' · '+fmtN(uds)+' uds · '+fmt(total);
  // El panel de contenedor se refresca con cada cambio del carrito.
  try{ ctRender(); }catch(e){}
}
function abrirCotizacion(){
  go('nuevo_pedido',document.getElementById('nav-np'));
  setTimeout(function(){
    if(npCli) npIr(3);          // ya hay cliente -> revisar pedido
    else npIr(1);               // sin cliente -> elegir cliente (luego salta al paso 3)
  },90);
}
function cotizVaciar(){
  if(!npLineas.length||confirm('¿Vaciar la cotización?')){
    npLineas=[];cotizUpdate();catUpdateFooter&&catUpdateFooter();npUpdateBtn&&npUpdateBtn();
    if(document.getElementById('page-inventario').classList.contains('active')) loadInventario();
  }
}

function catQty(itemcode,itemname,precio,bulto,delta){
  var linea=npLineas.find(function(l){return l.itemcode===itemcode;});
  if(linea){
    linea.quantity=Math.max(0,Number((linea.quantity+delta).toFixed(4)));
    if(linea.quantity<=0) npLineas=npLineas.filter(function(l){return l.itemcode!==itemcode;});
  } else if(delta>0){
    npAgregar({itemcode:itemcode,itemname:itemname,quantity:delta,price:Number(precio)||0,discount:0,whscode:'',bulto:bulto||1});
  }
  cotizUpdate();catUpdateFooter();npUpdateBtn();
  // Actualizar card
  var inp=document.querySelector('#pcard-'+itemcode+' input');
  if(inp){var l=npLineas.find(function(x){return x.itemcode===itemcode;});inp.value=l?l.quantity:'';}
  var dot=document.querySelector('#pcard-'+itemcode+'>div:first-child');
  // Simpler: rebuild card
  var card=document.getElementById('pcard-'+itemcode);
  if(card){var linea2=npLineas.find(function(l){return l.itemcode===itemcode;});if(linea2){var inp2=card.querySelector('input');if(inp2)inp2.value=linea2.quantity;}}
}

function catSetQty(itemcode,itemname,precio,qty){
  qty=Number(qty)||0;
  npLineas=npLineas.filter(function(l){return l.itemcode!==itemcode;});
  if(qty>0) npAgregar({itemcode:itemcode,itemname:itemname,quantity:qty,price:Number(precio)||0,discount:0,whscode:'',bulto:1});
  cotizUpdate();catUpdateFooter();npUpdateBtn();
}

function catAddTodo(){ return _catAddTodo(); }
async function _catAddTodo(){
  var ext=await invCols();
  var ccodes=null;
  if(arbSelCat && ARB_NODES[arbSelCat]){
    ccodes=await arbolItemcodes(ARB_NODES[arbSelCat]);
    if(!ccodes||!ccodes.length) ccodes=['__ninguno__'];
  }
  // El filtro de MARCA, igual que en catCargar. Faltaba aqui, y como
  // inv_buscar no tiene parametro de marca, la consulta salia sin ese filtro:
  // con OREO en pantalla (17 articulos) proponia anadir los 17.552 del
  // catalogo entero.
  if(catMarcaF){
    var _mc = await invMarcaCodes(catMarcaF);
    if(!_mc.length) _mc=['__ninguno__'];
    if(ccodes && ccodes.length && ccodes[0]!=='__ninguno__'){
      var _set={}; _mc.forEach(function(c){ _set[c]=1; });
      ccodes = ccodes.filter(function(c){ return _set[c]; });
      if(!ccodes.length) ccodes=['__ninguno__'];
    } else {
      ccodes = _mc;
    }
  }
  var base={
    p_itemcodes: ccodes,
    p_grupo: (catGrupoF||null),
    p_grupos: (catGruposSel && catGruposSel.length ? catGruposSel : null),
    p_textos: catTextos.length?catTextos:null,
    p_q: (catTextos.length?null:((catQ&&catQ.trim())?catQ.trim():null)),
    p_subg: (ext && catCatF!=='' && catTipos && catTipos.map[catCatF]) ? catTipos.map[catCatF].map(function(c){return String(c);}) : null,
    p_pmin: (catPMin!==''&&!isNaN(+catPMin))?+catPMin:null,
    p_pmax: (catPMax!==''&&!isNaN(+catPMax))?+catPMax:null,
    p_smin: (catSMin!==''&&!isNaN(+catSMin))?+catSMin:null,
    p_smax: null,
    p_bmin: (catBMin!==''&&!isNaN(+catBMin)&&+catBMin>0)?+catBMin:null,
    p_bmax: (catBMax!==''&&!isNaN(+catBMax)&&+catBMax>0)?+catBMax:null,
    p_disp: catDispF||null,
    p_img: catImgF||null,
    p_anio: (ext&&catAnioF!=='')?+catAnioF:null,
    // El rango manda sobre "mercancia reciente": son el mismo campo.
    p_desde: catRDesdeF ? catRDesdeF
             : ((catRecienteF!=='' && catRecienteF) ? _mesesAtras(+catRecienteF) : null),
    p_bajo: false,
    p_orden: catOrden||'reciente'
  };
  if(catRHastaF && INV_RPC_HASTA!==false) base.p_hasta = catRHastaF;
  var btn=document.getElementById('cat-add-all'); var prev=btn?btn.innerHTML:'';
  if(btn){ btn.disabled=true; btn.textContent='Cargando...'; }
  var all=[], off=0, CH=1000;
  try{
    while(true){
      var body=Object.assign({},base,{p_limit:CH,p_offset:off});
      var resp=await fetch(`${SB}/rest/v1/rpc/inv_buscar`,{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(body)});
      if(!resp.ok){ break; }
      var chunk=await resp.json();
      // Mismo corte de respaldo que en el catalogo, por si la funcion aun no
      // admite p_hasta. Se filtra el lote antes de acumularlo.
      if(catRHastaF && INV_RPC_HASTA===false){
        chunk=(chunk||[]).filter(function(r){
          var f=String(r.fechaentrada||'').substring(0,10);
          return f && f<=catRHastaF;
        });
      }
      all=all.concat(chunk);
      if(!chunk.length || chunk.length<CH) break;
      off+=CH;
      if(all.length>20000) break;
    }
  }catch(e){ if(btn){btn.disabled=false;btn.innerHTML=prev;} alert('No se pudo cargar la lista: '+e.message); return; }
  if(btn){ btn.disabled=false; btn.innerHTML=prev; }
  if(!all.length){ alert('No hay productos que coincidan con la busqueda actual.'); return; }
  var yaen={}; npLineas.forEach(function(l){ yaen[l.itemcode]=true; });
  var nuevos=all.filter(function(i){ return !yaen[i.itemcode]; });
  if(!nuevos.length){ alert('Todos los productos que coinciden ya estan en el pedido.'); return; }
  // Un BULTO de cada uno, que es como se vende al mayoreo. Antes entraba una
  // unidad suelta, que casi nunca es un pedido real y obligaba a corregir
  // linea por linea.
  var _conBulto=0;
  nuevos.forEach(function(i){
    if(Math.max(1,Number(i.unidadesbulto)||Number(i.numinbuy)||1)>1) _conBulto++;
  });
  var msg='Se a\u00f1adir\u00e1 1 BULTO de cada uno: '+nuevos.length+' producto'
    +(nuevos.length!==1?'s':'')+'.';
  if(_conBulto<nuevos.length){
    msg+='\n('+(nuevos.length-_conBulto)+' no tiene'+(nuevos.length-_conBulto!==1?'n':'')
      +' bulto definido y entra'+(nuevos.length-_conBulto!==1?'n':'')+' con 1 unidad.)';
  }
  if(all.length!==nuevos.length) msg+='\n('+(all.length-nuevos.length)+' ya estaban en el pedido.)';
  if(!confirm(msg+'\n\n\u00bfContinuar?')) return;
  nuevos.forEach(function(i){
    var precio=pvVenta(i);
    var bulto=Math.max(1,Number(i.unidadesbulto)||Number(i.numinbuy)||1);
    npAgregar({itemcode:i.itemcode,itemname:i.itemname,quantity:bulto,price:precio,
               discount:0,whscode:'',bulto:bulto});
  });
  cotizUpdate(); catUpdateFooter(); npUpdateBtn();
  catCargar();
}

function catFiltCat(cat){
  catCatF=cat;catPage=0;
  catRenderTipos();
  catCargar();
}

var catT=null;
function catBuscar(val){catQ=val;catTextos=[];var m=$('cat-ia-msg');if(m)m.textContent='';catPage=0;clearTimeout(catT);catT=setTimeout(catCargar,400);}

function catUpdateFooter(){
  var total=npLineas.reduce(function(s,l){return s+l.quantity*l.price*(1-l.discount/100);},0);
  var count=npLineas.length;
  var fc=document.getElementById('cat-footer-count');if(fc)fc.textContent=count+' producto'+(count!==1?'s':'')+' en el pedido';
  var ft=document.getElementById('cat-footer-total');if(ft)ft.textContent='TOTAL '+fmt(total);
}

function npUpdateBtn(){
  var has=npLineas.length>0;
  var n=npLineas.length;
  ['np-btn3','np-btn3-top'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=!has;b.textContent=has?'Ver pedido ('+n+') →':'Ver pedido →';}});
}

// ── Clientes de NAPA en el pedido ──────────────────────────────────────────
// NAPA es otra empresa de SAP. Sus clientes pueden pedir, pero el pedido se
// crea en kennedydb bajo un unico codigo paraguas, con el cliente real
// anotado en marca_cliente. Es el mismo mecanismo que ya usaba el portal
// para las marcas de ese codigo.
var NAPA_CARDCODE = '16414';
var NAPA_CARDNAME = 'NAPA';

// Busca en los clientes de NAPA. Devuelve el mismo formato que el buscador
// normal, con napa:true para que el envio sepa que tiene que redirigirlo.
async function npBuscarNapa(txt){
  var v=encodeURIComponent(String(txt||'').trim());
  if(!v) return [];
  try{
    // Primero la tabla propia (trae contacto y vendedor); si aun no esta
    // poblada, se cae a la vista que ya existia.
    var r=await q('clientes_napa','select=cardcode,cardname,city,balance,nombrevendedor'
      +'&or=(cardname.ilike.*'+v+'*,cardcode.ilike.*'+v+'*)&limit=12').catch(function(){return[];});
    if(!r || !r.length){
      r=await q('clientes_nappa','select=cardcode,cardname'
        +'&or=(cardname.ilike.*'+v+'*,cardcode.ilike.*'+v+'*)&limit=12').catch(function(){return[];});
    }
    return (r||[]).map(function(c){
      return {cardcode:c.cardcode, cardname:c.cardname||c.cardcode,
              city:c.city||'', balance:c.balance, napa:true};
    });
  }catch(e){ return []; }
}

// Elegir un cliente de NAPA para la cotizacion en curso.
function npElegirNapa(code, nombre){
  npCli={cardcode:code, cardname:nombre, napa:true};
  var nm=document.getElementById('np-cli-name'); if(nm) nm.textContent=nombre;
  var mt=document.getElementById('np-cli-meta');
  if(mt) mt.innerHTML=npEsc(code)+' <span style="background:#7C3AED;color:#fff;padding:1px 7px;border-radius:9px;font-size:10.5px;font-weight:700;margin-left:5px">NAPA</span>';
  var av=document.getElementById('np-cli-av'); if(av) av.textContent=(nombre||'?').slice(0,2).toUpperCase();
  var inp=document.getElementById('np-cli-q');   if(inp){ inp.value=''; inp.style.display='none'; }
  var sel=document.getElementById('np-cli-sel'); if(sel) sel.style.display='block';
  var dp=document.getElementById('np-cli-drop'); if(dp) dp.classList.remove('show');
  // Aviso claro: quien arma el pedido tiene que saber a nombre de quien entra.
  var av2=document.getElementById('np-napa-aviso');
  if(!av2 && sel){
    av2=document.createElement('div'); av2.id='np-napa-aviso';
    av2.style.cssText='margin-top:8px;background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;'
      +'padding:8px 11px;font-size:12px;color:#5B21B6;line-height:1.5';
    sel.appendChild(av2);
  }
  if(av2){
    av2.innerHTML='Cliente de <b>NAPA</b>. El pedido se crear\u00e1 en SAP bajo el c\u00f3digo '
      +'<b>'+NAPA_CARDCODE+'</b>, con <b>'+npEsc(nombre)+'</b> anotado como marca del cliente. '
      +'Su estado de cuenta y sus facturas siguen siendo los suyos.';
  }
  try{ cotizUpdate(); }catch(e){}
  try{ npIr(3); }catch(e){}
}

function npAgregarLineaDirecta(btnOrCode,itemname,precio,cantidad){
  var itemcode,name,p,q;
  if(typeof btnOrCode==='object'&&btnOrCode.dataset){
    itemcode=btnOrCode.dataset.code;
    name=btnOrCode.dataset.name;
    p=parseFloat(btnOrCode.dataset.price)||0;
    q=parseFloat(btnOrCode.dataset.qty)||1;
  } else {
    itemcode=btnOrCode;name=itemname;p=precio;q=cantidad;
  }
  itemname=name;precio=p;cantidad=q;
  var existe=npLineas.find(function(l){return l.itemcode===itemcode;});
  if(existe){existe.quantity=Number(cantidad);existe.price=Number(precio);}
  else npAgregar({itemcode:itemcode,itemname:itemname,quantity:Number(cantidad)||1,price:Number(precio)||0,discount:0,whscode:'',bulto:1});
  catUpdateFooter();npUpdateBtn();
  npIr(2);
}

// Factor para convertir el VOLUMEN de SAP (SVolume) a pie cubico.
// 1 = SVolume ya viene en pie cubico. Si viniera en m3 seria 35.3147.
var NP_VOL_FACTOR=1;

async function npCargarPesos(){
  var faltan=npLineas.filter(function(l){return l.peso===undefined;}).map(function(l){return l.itemcode;});
  if(!faltan.length)return;
  try{
    var inList=faltan.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
    var rows=await q('vista_inventario','select=itemcode,peso,volumen,disponiblebodega,disponible,onhand&itemcode=in.('+inList+')&limit='+faltan.length);
    var map={};(rows||[]).forEach(function(r){map[r.itemcode]={peso:Number(r.peso)||0,volumen:Number(r.volumen)||0,stock:Number(r.onhand!=null?r.onhand:(r.disponiblebodega!=null?r.disponiblebodega:r.disponible||0))};});
    var _fm=await _frgnMap(faltan);
    // De paso, lo separado en pedidos autorizados: asi la linea ya puede
    // pintar el disponible real sin esperar a una segunda vuelta.
    await sepCargar(faltan);
    npLineas.forEach(function(l){
      if(map[l.itemcode]){l.peso=map[l.itemcode].peso;l.volumen=map[l.itemcode].volumen;l.stockActual=map[l.itemcode].stock;l.frgnname=_fm[l.itemcode]||'';}
      else if(l.peso===undefined){l.peso=0;l.volumen=0;if(l.stockActual==null)l.stockActual=0;}
    });
  }catch(e){ npLineas.forEach(function(l){if(l.peso===undefined){l.peso=0;l.volumen=0;}}); }
}

function npTotales(){
  var sub=0,desc=0,uds=0,bultos=0,kilos=0,piecub=0;
  npLineas.forEach(function(l){
    var s=l.quantity*l.price; sub+=s; desc+=s*(l.discount/100);
    uds+=Number(l.quantity||0);
    var b=Math.max(1,Number(l.bulto)||1); bultos+=l.quantity/b;
    kilos+=(Number(l.peso)||0)*l.quantity;
    piecub+=(Number(l.volumen)||0)*l.quantity*NP_VOL_FACTOR;
  });
  var dg=Number((document.getElementById('np-desc-gen')||{}).value)||0;
  var baseTrasLineas=sub-desc;
  var descGen=baseTrasLineas*(dg/100);
  return {sub:sub,descLineas:desc,descGen:descGen,descTotal:desc+descGen,total:baseTrasLineas-descGen,uds:uds,bultos:bultos,kilos:kilos,piecub:piecub,dgPct:dg,n:npLineas.length};
}

// ── Fotos en las líneas del pedido/resumen/restock ──────────
// Caché por itemcode; se llena bajo demanda desde `fotos` + `inventario`.
var NP_FOTO_CACHE = window.NP_FOTO_CACHE || (window.NP_FOTO_CACHE={});
function npFotoCell(itemcode, size){
  size = size || 40;
  var f = NP_FOTO_CACHE[itemcode];
  if(f && (f.pn || f.fu)){
    if(typeof lineFoto==='function') return lineFoto(f.pn, f.fu);
  }
  // placeholder mientras carga o si no hay foto
  return '<div style="width:'+size+'px;height:'+size+'px;border-radius:6px;background:var(--bg,#f1f1f1);display:flex;align-items:center;justify-content:center;flex-shrink:0"><svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" style="opacity:.4"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
}
// Carga las fotos faltantes y llama a redraw() cuando termina.
async function npCargarFotos(itemcodes, redraw){
  var faltan=(itemcodes||[]).filter(function(c){ return c && !NP_FOTO_CACHE[c]; });
  if(!faltan.length) return;
  faltan.forEach(function(c){ NP_FOTO_CACHE[c]={pn:'',fu:'',_loading:true}; }); // evita recargas dobles
  var inList='('+faltan.map(function(c){return '"'+c+'"';}).join(',')+')';
  try{
    var res=await Promise.all([
      q('inventario','select=itemcode,picturname,foto_url&itemcode=in.'+inList),
      q('fotos','select=itemcode,url&itemcode=in.'+inList)
    ]);
    (res[0]||[]).forEach(function(i){ var m=NP_FOTO_CACHE[i.itemcode]||{}; m.pn=i.picturname||m.pn||''; if(!m.fu)m.fu=i.foto_url||''; m._loading=false; NP_FOTO_CACHE[i.itemcode]=m; });
    (res[1]||[]).forEach(function(x){ if(!x.url)return; var m=NP_FOTO_CACHE[x.itemcode]||{}; if(!m.fu)m.fu=x.url; m._loading=false; NP_FOTO_CACHE[x.itemcode]=m; });
    faltan.forEach(function(c){ if(NP_FOTO_CACHE[c])NP_FOTO_CACHE[c]._loading=false; });
  }catch(e){}
  if(typeof redraw==='function') redraw();
}

function npRenderLineas(){
  var empty=document.getElementById('np-lineas-empty');
  var tbl=document.getElementById('np-lineas-tbl');
  var tots=document.getElementById('np-tots');
  var has=npLineas.length>0;
  if(empty)empty.style.display=has?'none':'block';
  if(tbl)tbl.style.display=has?'table':'none';
  if(tots)tots.style.display=has?'flex':'none';
  if(!has)return;
  var body=document.getElementById('np-lineas-body');
  if(!body)return;
  var esCli=(CU&&CU.rol==='cliente');
  body.innerHTML=npLineas.map(function(l,i){
    if(esCli) l.discount=0;
    var sub=l.quantity*l.price, disc=sub*(l.discount/100), total=sub-disc;
    var precioDesc=l.price*(1-(Number(l.discount)||0)/100);   // precio unitario tras descuento
    var b=Math.max(1,Number(l.bulto)||1);
    // Dos numeros, y el que manda es el DISPONIBLE: el stock menos lo
    // separado en pedidos ya autorizados. Antes solo se veia el stock, y un
    // articulo con 126 en bodega pero 252 comprometidos parecia vendible.
    var stk=(l.stockActual!=null)?Number(l.stockActual):null;
    var sepA=sepAutorizado(l.itemcode);
    if(stk!=null && SEP_AUT[l.itemcode]===undefined) sepPedir([l.itemcode]);
    var disp=(stk!=null)?(stk-sepA):null;
    var pedido=Number(l.quantity)||0;
    var stkColor=(disp!=null && disp<pedido)?'#c0392b':'#2f7d32';
    var stkTxt='';
    if(stk!=null){
      stkTxt='<div style="margin-top:3px;line-height:1.35">'
        // El stock, en pequeno y apagado: es informativo.
        +'<div style="font-size:9.5px;font-weight:500;color:var(--text3)">Stock '
        +fmtN(stk)+(sepA?(' \u00b7 sep '+fmtN(sepA)):'')+'</div>'
        // El disponible, grande: es lo que decide si se puede vender.
        +'<div style="font-size:13px;font-weight:800;color:'+stkColor+'">'
        +'Disp. '+fmtN(disp)+(disp<pedido?' \u26a0':'')+'</div>'
        +(disp<0
          ? '<div style="font-size:9.5px;font-weight:600;color:#c0392b">'
            +'comprometido de m\u00e1s</div>'
          : '')
        +'</div>';
    }
    var cel='padding:8px 8px;border-bottom:1px solid #e5e7eb';
    var bultoRow='<div style="display:flex;gap:5px;justify-content:center;align-items:center">'
      +'<button class="qty-btn" style="font-weight:700;padding:7px 11px;font-size:12px" onclick="npLineas['+i+'].quantity=Math.max('+b+',(Number(npLineas['+i+'].quantity)||0)-'+b+');npRenderLineas()">\u2212 bulto</button>'
      +'<input style="width:66px;text-align:center;padding:7px 4px;border:1px solid #e5e7eb;border-radius:6px;font-size:15px;font-weight:700" type="number" value="'+l.quantity+'" onchange="npLineas['+i+'].quantity=+this.value||1;npRenderLineas()">'
      +'<button class="qty-btn" style="font-weight:700;padding:7px 11px;font-size:12px" onclick="npLineas['+i+'].quantity=(Number(npLineas['+i+'].quantity)||0)+'+b+';npRenderLineas()">+ bulto</button>'
      +'</div>';
    var unitRow='<div style="display:flex;gap:8px;justify-content:center;margin-top:5px">'
      +'<button class="qty-btn" style="font-size:11px;padding:1px 9px;color:#777" onclick="npLineas['+i+'].quantity=Math.max(0.01,(Number(npLineas['+i+'].quantity)||0)-1);npRenderLineas()">\u2212 u</button>'
      +'<button class="qty-btn" style="font-size:11px;padding:1px 9px;color:#777" onclick="npLineas['+i+'].quantity=(Number(npLineas['+i+'].quantity)||0)+1;npRenderLineas()">+ u</button>'
      +'</div>';
    return '<tr>'
      +'<td style="'+cel+';width:48px">'+npFotoCell(l.itemcode)+'</td>'
      +'<td style="'+cel+'"><span style="color:var(--blue2,#185FA5);cursor:pointer;text-decoration:underline;font-weight:600;font-size:13px" data-code="'+l.itemcode+'" onclick="catVerModal(this.dataset.code)">'+l.itemcode+'</span>'+(b>1?'<div style="font-size:11px;color:#777;margin-top:2px">bulto '+fmtN(b)+'</div>':'')+'</td>'
      +'<td style="'+cel+';font-size:12px;max-width:260px">'+l.itemname+'</td>'
      +'<td style="'+cel+';text-align:right">'+(esCli?('<span style="font-weight:600">'+fmt(l.price)+'</span>'):('<input style="width:82px;text-align:right;padding:5px;border:1px solid #e5e7eb;border-radius:4px;font-size:12px" type="number" value="'+l.price+'" onchange="npLineas['+i+'].price=+this.value;npRenderLineas()">'))+'</td>'
      +(esCli?'':('<td style="'+cel+';text-align:right"><input style="width:54px;text-align:right;padding:5px;border:1px solid #e5e7eb;border-radius:4px;font-size:12px" type="number" value="'+l.discount+'" onchange="npLineas['+i+'].discount=+this.value;npRenderLineas()"></td>'))
      +'<td style="'+cel+';text-align:right;font-size:12px;color:var(--text2,#555)">'+fmt(precioDesc)+'</td>'
      +'<td style="'+cel+';text-align:right;font-weight:700;font-size:13px">'+fmt(total)+'</td>'
      +'<td style="'+cel+';text-align:center;min-width:190px">'+bultoRow+unitRow+stkTxt+'</td>'
      +'<td style="'+cel+'"><button style="background:none;border:none;color:var(--red);cursor:pointer;font-size:16px" onclick="npLineas.splice('+i+',1);npRenderLineas()">\u2715</button></td>'
      +'</tr>';
  }).join('');
  var t=npTotales();
  npRenderContainer(t);
  var tr=document.getElementById('np-tot-resumen');if(tr)tr.textContent=t.n+' productos · '+fmtN(t.uds)+' unidades · '+fmtN(Math.round(t.bultos*100)/100)+' bultos · '+fmtN(Math.round(t.kilos*100)/100)+' kg · '+fmtN(Math.round(t.piecub*1000)/1000)+' ft³';
  var ts=document.getElementById('np-tot-sub');if(ts)ts.textContent=fmt(t.sub);
  var td=document.getElementById('np-tot-desc');if(td)td.textContent=fmt(t.descLineas);
  var tf=document.getElementById('np-tot-final');if(tf)tf.textContent=fmt(t.total);
  // El panel de contenedor se pinta aqui, no solo en cotizUpdate: los pesos y
  // volumenes llegan de forma asincrona (npCargarPesos), y esta funcion se
  // vuelve a ejecutar cuando estan listos. Antes salia en cero o no salia.
  try{ ctRender(); }catch(e){}
  if(npLineas.some(function(l){return l.peso===undefined;})) npCargarPesos().then(npRenderLineas);
  npCargarFotos(npLineas.map(function(l){return l.itemcode;}), npRenderLineas);
}

function npEsc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function npVendedorNombre(){var s=document.getElementById('np-vendedor');return s&&s.value&&s.selectedIndex>=0?s.options[s.selectedIndex].text:'';}
function npFechaDisp(){var f=(document.getElementById('np-fecha')||{}).value||hoyLocal();var m=String(f).match(/(\d{4})-(\d{2})-(\d{2})/);return m?m[3]+'/'+m[2]+'/'+m[1]:f;}


var _pedHtml = null, _pedSoloHtml = false;


/* ══════════════════════════════════════════════════════════════════════════
   MANDAR EL PEDIDO AL CLIENTE POR WHATSAPP
   ---------------------------------------------------------------------------
   El mismo PDF que sale al imprimir, sin recrearlo: se le pide el HTML a
   `pedPdf` sin abrir la ventana y se convierte. Dos versiones del mismo
   documento es pedir que algun dia no cuadren.

   El archivo NO se sube a ningun sitio. En el telefono se comparte con el
   boton del sistema, que lo manda a WhatsApp como documento; en el
   escritorio se descarga y se adjunta a mano, porque WhatsApp Web no admite
   archivos desde una pagina.
   ══════════════════════════════════════════════════════════════════════════ */

var _pedListo = null;

async function pedPdfBlob(docnum){
  if(typeof ncrCargarLib === 'function') await ncrCargarLib();
  else if(typeof catCargarLib === 'function') await catCargarLib();
  if(!(window.jspdf && window.jspdf.jsPDF))
    throw new Error('No se pudo cargar el generador de PDF.');
  if(typeof ecCargarH2C === 'function') await ecCargarH2C();
  if(!window.html2canvas) throw new Error('No se pudo cargar el conversor de PDF.');

  _pedHtml = null;
  _pedSoloHtml = true;
  try{ await pedPdf(docnum); }
  finally{ _pedSoloHtml = false; }
  if(!_pedHtml) throw new Error('No pude generar el pedido.');

  var caja = document.createElement('div');
  caja.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;'
    + 'background:#fff;z-index:-1';
  var cuerpo = _pedHtml.replace(/^[\s\S]*?<body[^>]*>/i, '')
                       .replace(/<\/body>[\s\S]*$/i, '');
  var estilos = (_pedHtml.match(/<style>([\s\S]*?)<\/style>/i) || [])[1] || '';
  caja.innerHTML = '<style>' + estilos + '</style>'
    + '<div style="padding:20px">' + cuerpo + '</div>';
  document.body.appendChild(caja);

  try{
    var lienzo = await window.html2canvas(caja, {scale:2, backgroundColor:'#fff'});
    var doc = new window.jspdf.jsPDF({unit:'pt', format:'a4'});
    var W = doc.internal.pageSize.getWidth();
    var H = doc.internal.pageSize.getHeight();
    var alto = lienzo.height * W / lienzo.width;
    var img = lienzo.toDataURL('image/jpeg', 0.92);
    doc.addImage(img, 'JPEG', 0, 0, W, alto);
    var restante = alto - H, y = -H;
    while(restante > 1){
      doc.addPage();
      doc.addImage(img, 'JPEG', 0, y, W, alto);
      restante -= H; y -= H;
    }
    return doc.output('blob');
  }finally{
    try{ caja.remove(); }catch(e){}
  }
}

async function pedWhatsApp(docnum){
  var btn = document.getElementById('ped-wa');
  var txt0 = btn ? btn.innerHTML : '';
  if(btn){ btn.disabled = true; btn.textContent = 'Preparando\u2026'; }
  try{
    var blob = await pedPdfBlob(docnum);
    var nom = 'pedido-' + String(docnum).replace(/[^\w-]/g,'') + '.pdf';

    var cli = null, tel = '';
    try{
      var r = await q('vista_pedidos',
        'select=cardcode,cardname,doctotal&docnum=eq.' + encodeURIComponent(docnum)
        + '&limit=1');
      if(r && r[0]) cli = r[0];
    }catch(e){}
    if(cli && cli.cardcode){
      try{
        var c = await q('clientes',
          'select=cellular,phone1,phone2&cardcode=eq.'
          + encodeURIComponent(cli.cardcode) + '&limit=1');
        if(c && c[0] && typeof ecTelefono === 'function') tel = ecTelefono(c[0]);
      }catch(e){}
    }

    var msg = 'Aqu\u00ed tiene su pedido #' + docnum + ' para revisi\u00f3n.'
      + (cli && cli.doctotal
          ? ('\n\nTotal: $' + (Number(cli.doctotal)||0).toLocaleString('en-US',
              {minimumFractionDigits:2, maximumFractionDigits:2}))
          : '')
      + '\n\nCualquier cambio me avisa antes de despacharlo.';

    var file = null;
    try{ file = new File([blob], nom, {type:'application/pdf'}); }catch(e){}

    // El navegador exige que compartir se llame en el mismo instante del
    // toque. Generar el PDF antes rompe esa cadena, asi que va en dos pasos.
    if(file && navigator.canShare && navigator.canShare({files:[file]})){
      _pedListo = {file:file, msg:msg, nom:nom, tel:tel, docnum:docnum};
      pedAvisoCompartir(cli, docnum);
      return;
    }

    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = nom;
    document.body.appendChild(a); a.click();
    setTimeout(function(){ try{ URL.revokeObjectURL(a.href); a.remove(); }catch(e){} }, 4000);

    window.open('https://wa.me/' + tel + '?text=' + encodeURIComponent(msg), '_blank');
    setTimeout(function(){
      alert('El PDF se descargo como:\n' + nom +
        '\n\nArrastralo al chat de WhatsApp que acaba de abrirse.' +
        '\n\nDesde el telefono se manda de una sola vez.');
    }, 600);
  }catch(e){
    alert('No se pudo preparar el env\u00edo: ' + (e.message || e));
  }finally{
    if(btn){ btn.disabled = false; btn.innerHTML = txt0; }
  }
}

function pedAvisoCompartir(cli, docnum){
  var v = document.getElementById('ped-wa-modal'); if(v) v.remove();
  var m = document.createElement('div');
  m.id = 'ped-wa-modal';
  m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    + 'display:flex;align-items:center;justify-content:center;padding:16px';
  m.innerHTML = '<div style="background:var(--surface,#fff);border-radius:14px;'
    + 'max-width:380px;width:100%;padding:20px;text-align:center">'
    + '<div style="font-size:16px;font-weight:700;margin-bottom:4px">'
    + 'Pedido #' + npEsc(docnum) + ' listo</div>'
    + '<div style="font-size:13px;color:var(--text3);margin-bottom:16px">'
    + npEsc((cli && (cli.cardname||cli.cardcode)) || '') + '</div>'
    + '<button id="ped-wa-go" class="btn" style="background:#25D366;color:#fff;'
    + 'border-color:#25D366;width:100%;padding:12px;font-size:15px;font-weight:700">'
    + 'Enviar por WhatsApp</button>'
    + '<div style="margin-top:10px"><button id="ped-wa-dl" class="btn btn-sm" '
    + 'style="width:100%">Descargar el PDF</button></div>'
    + '<div style="margin-top:12px"><a href="javascript:void(0)" id="ped-wa-no" '
    + 'style="font-size:12.5px;color:var(--text3)">Cancelar</a></div></div>';
  document.body.appendChild(m);

  document.getElementById('ped-wa-go').onclick = async function(){
    if(!_pedListo) return;
    try{
      await navigator.share({files:[_pedListo.file], title:'Pedido',
                             text:_pedListo.msg});
      m.remove();
    }catch(e){
      if(e && e.name === 'AbortError') return;
      alert('No se pudo compartir: ' + (e.message||e));
    }
  };
  document.getElementById('ped-wa-dl').onclick = function(){
    var a = document.createElement('a');
    a.href = URL.createObjectURL(_pedListo.file);
    a.download = _pedListo.nom;
    document.body.appendChild(a); a.click();
    setTimeout(function(){ try{ URL.revokeObjectURL(a.href); a.remove(); }catch(e){} }, 4000);
  };
  document.getElementById('ped-wa-no').onclick = function(){ m.remove(); };
  m.addEventListener('click', function(e){ if(e.target===m) m.remove(); });
}

async function pedPdf(docnum){
  var w=null;
  if(!_pedSoloHtml){
    w=window.open('','_blank');
    if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); return; }
    w.document.write('<p style="font-family:Arial;padding:20px">Generando pedido...</p>');
  }
  var head=await q('pedidos','select=docnum,docdate,cardcode,cardname,doctotal,comments,nombrevendedor,slpcode,address,address2&docnum=eq.'+docnum+'&limit=1');
  var lines=await q('pedidos','select=linenum,itemcode,dscription,quantity,price,descuentolinea,linetotal,unitmsr&docnum=eq.'+docnum+'&order=linenum');
  var h=(head&&head[0])||{};
  var cli={};
  if(h.cardcode){ try{ var cc=await q('clientes','select=condicionpago,city,country&cardcode=eq.'+encodeURIComponent(h.cardcode)+'&limit=1'); cli=(cc&&cc[0])||{}; }catch(e){} }
  var pv={};
  if(lines && lines.length){
    try{
      var inList=lines.map(function(l){return '"'+String(l.itemcode||'').replace(/"/g,'')+'"';}).join(',');
      var inv=await q('vista_inventario','select=itemcode,peso,volumen,unidadesbulto&itemcode=in.('+inList+')&limit='+lines.length);
      (inv||[]).forEach(function(i){ pv[i.itemcode]={peso:Number(i.peso)||0,vol:Number(i.volumen)||0,bulto:Math.max(1,Number(i.unidadesbulto)||1)}; });
      var _fm=await _frgnMap(lines.map(function(l){return l.itemcode;})); (lines||[]).forEach(function(l){ if(pv[l.itemcode]) pv[l.itemcode].en=_fm[l.itemcode]||''; });
    }catch(e){}
  }
  function m2(n){ return (Number(n)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function m4(n){ return (Number(n)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }
  function nN(n){ return (Number(n)||0).toLocaleString('en-US'); }
  function fSlash(d){ if(!d) return ''; var s=String(d).substring(0,10).split('-'); return s.length===3?(s[2]+'/'+s[1]+'/'+s[0]):String(d); }

  var totBts=0,totKg=0,totFt=0,sub=0;
  var filas=(lines||[]).map(function(l,i){
    var info=pv[l.itemcode]||{peso:0,vol:0,bulto:1};
    var qn=Number(l.quantity)||0;
    var bts=Math.round((qn/info.bulto)*100)/100;
    var kg=Math.round(info.peso*qn*100)/100;
    var ft=Math.round(info.vol*qn*100)/100;
    var tot=(l.linetotal!=null&&l.linetotal!=='')?Number(l.linetotal):(qn*Number(l.price||0));
    totBts+=bts; totKg+=kg; totFt+=ft; sub+=Number(tot)||0;
    return '<tr><td class="c">'+(i+1)+'</td><td class="r">'+nN(bts)+'</td><td class="r">'+m2(kg)+'</td><td class="r">'+m2(ft)+'</td>'
      +'<td>'+npEsc(l.itemcode||'')+'</td><td>'+npEsc(l.dscription||'')+'</td><td>'+npEsc(info.en||'')+'</td>'
      +'<td class="r">'+nN(qn)+' '+npEsc(l.unitmsr||'')+'</td>'
      +'<td class="r">$ '+m4(l.price)+'</td><td class="r">$ '+m2(tot)+'</td></tr>';
  }).join('');
  var total=(h.doctotal!=null&&h.doctotal!=='')?Number(h.doctotal):sub;
  var year2=String(h.docdate||'').substring(2,4);

  var css='@page{size:letter portrait;margin:.45in}*{box-sizing:border-box}'
    +'body{font-family:Arial,Helvetica,sans-serif;color:#000;font-size:12px;margin:0}'
    +'.hd{display:grid;grid-template-columns:34% 40% 26%;align-items:start;margin-bottom:8px}'
    +'.hd .l .kc{font-weight:bold;font-size:11px;margin-bottom:2px}.hd .l div{font-size:10px;line-height:1.35}'
    +'.hd .c{text-align:center}.hd .c h1{font-size:24px;font-style:italic;font-weight:bold;margin:0}.hd .c p{margin:3px 0;font-size:12px}'
    +'.hd .r{text-align:right;font-size:18px;font-weight:bold;padding-top:16px}'
    +'.meta{display:grid;grid-template-columns:58% 42%;gap:0 14px;margin:6px 0 10px}'
    +'.meta .lft div,.meta .rgt div{margin-bottom:5px}'
    +'.vendido{font-size:13px}.vendido .cn{font-weight:bold;margin-left:16px}'
    +'.marcas{border:1px solid #000;padding:6px 8px;min-height:56px}.marcas .mk{font-weight:bold;margin-top:10px}'
    +'.dest{line-height:1.35;margin-top:2px}'
    +'table.it{width:100%;border-collapse:collapse;margin-top:8px}'
    +'table.it th{border:1px solid #000;padding:5px 6px;font-size:11px;text-align:left}'
    +'table.it td{border:1px solid #000;padding:4px 6px;text-align:left;vertical-align:top}'
    +'table.it td.r,table.it th.r{text-align:right;white-space:nowrap}table.it td.c{text-align:center}'
    +'.tt td{font-weight:bold}'
    +'.sub{text-align:right;font-weight:bold;font-size:14px;margin-top:10px}'
    +'.foot{display:flex;justify-content:space-between;align-items:flex-end;margin-top:8px}'
    +'.foot .notas{font-size:12px}.foot .total{font-weight:bold;font-size:16px;border-top:2px solid #000;padding-top:4px;min-width:220px;text-align:right}'
    +'.firmas{display:grid;grid-template-columns:1fr 1fr;gap:80px;margin-top:64px}'
    +'.firmas span{display:block;border-bottom:1px solid #000;height:16px}.firmas b{display:block;margin-top:6px}';

  var html='<!doctype html><html><head><meta charset="utf-8"><title>Pedido '+npEsc(h.docnum)+'</title><style>'+css+'</style></head><body>'
    +'<div class="hd">'
      +'<div class="l"><div class="kc">KC PEDIDO</div>'
        +'<div>TEL. 4318500</div><div>FAX. 441-6314</div><div>APARTADO: P.O. Box 0302-00737</div>'
        +'<div>Zona Libre de Colón</div><div>Colón, Rep. de Panamá</div>'
        +'<div>Calle 15 Ave. Sta. Isabel,</div><div>Edificio Kennedy Center</div></div>'
      +'<div class="c"><h1>KENNEDY CENTER CORP.</h1><p>IMPORTADORES - EXPORTADORES</p><p>ZONA LIBRE DE COLON</p></div>'
      +'<div class="r">PEDIDO #: '+npEsc(h.docnum)+(year2?(' / '+year2):'')+'</div>'
    +'</div>'
    +'<div class="meta">'
      +'<div class="lft">'
        +'<div class="vendido"><b>VENDIDO A:</b> <b>'+npEsc(h.cardcode||'')+'</b><span class="cn">'+npEsc(h.cardname||'')+'</span></div>'
        +'<div><b>Num. Ref.:</b> </div>'
        +'<div style="margin-top:10px"><b>INSTRUCCIONES DE EMBARQUE:</b></div>'
        +'<div><b>TRASPASO A:</b> </div>'
        +'<div><b>OTRAS INST.:</b></div>'
        +'<div class="dest">'+npEsc(cli.city||'')+(cli.country?('<br>'+npEsc(cli.country)):'')+'</div>'
      +'</div>'
      +'<div class="rgt">'
        +'<div><b>CONDICION DE PAGO:</b></div>'
        +'<div style="font-weight:bold">'+npEsc(cli.condicionpago||'')+'</div>'
        +'<div><b>Fecha:</b> '+fSlash(h.docdate)+'</div>'
        +'<div class="marcas"><b>MARCAS:</b><div class="mk"></div></div>'
        +'<div style="margin-top:8px"><b>VENDEDOR:</b> '+npEsc(h.slpcode!=null?h.slpcode:'')+' &nbsp; '+npEsc(h.nombrevendedor||'')+'</div>'
      +'</div>'
    +'</div>'
    +'<table class="it"><thead><tr><th class="c">#</th><th class="r">Bts.</th><th class="r">Kilos</th><th class="r">Pie Cub.</th>'
      +'<th>Referencia</th><th>Descripción</th><th>Descripción (Inglés)</th><th class="r">Cantidad</th><th class="r">Precio</th><th class="r">Total</th></tr></thead>'
      +'<tbody>'+filas
      +'<tr class="tt"><td></td><td class="r">'+nN(totBts)+'</td><td class="r">'+m2(totKg)+'</td><td class="r">'+m2(totFt)+'</td><td colspan="5"></td></tr>'
      +'</tbody></table>'
    +'<div class="sub">SUBTOTAL EXWORK: &nbsp;&nbsp; $ '+m2(total)+'</div>'
    +'<div class="foot"><div class="notas">'+(h.comments?('<b>NOTAS:</b> '+npEsc(h.comments)):'')+'</div>'
      +'<div class="total">TOTAL &nbsp;&nbsp; $ '+m2(total)+'</div></div>'
    +'<div class="firmas"><div><span></span><b>FIRMA</b></div><div><span></span><b>FIRMA</b></div></div>'
    +'</body></html>';
  // Se guarda el HTML para que el envio por WhatsApp mande EXACTAMENTE el
  // mismo documento, sin recrearlo por otro lado.
  _pedHtml = html;
  if(_pedSoloHtml) return html;
  w.document.open(); w.document.write(html); w.document.close(); w.focus();
  if(w) setTimeout(function(){ try{ w.print(); }catch(e){} }, 500);
}

async function npPdf(){
  if(!npLineas.length){alert('No hay productos en la cotización.');return;}
  var w=window.open('','_blank');
  if(!w){alert('Permite ventanas emergentes para generar el PDF.');return;}
  w.document.write('<p style="font-family:Arial;padding:20px">Generando cotización...</p>');
  await npCargarPesos();
  var t=npTotales();
  var filas=npLineas.map(function(l,i){
    var b=Math.max(1,Number(l.bulto)||1), bultos=Math.round((l.quantity/b)*100)/100;
    var kg=Math.round((Number(l.peso)||0)*l.quantity*100)/100;
    var ft=Math.round((Number(l.volumen)||0)*l.quantity*NP_VOL_FACTOR*1000)/1000;
    var tot=l.quantity*l.price*(1-l.discount/100);
    return '<tr><td class="r">'+(i+1)+'</td><td class="r">'+bultos+'</td><td class="r">'+kg+'</td><td class="r">'+ft+'</td><td>'+npEsc(l.itemcode)+'</td><td>'+npEsc(l.itemname)+(l.note?' <i style="color:#555">('+npEsc(l.note)+')</i>':'')+'</td><td>'+npEsc(l.frgnname||'')+'</td><td class="r">'+fmtN(l.quantity)+'</td><td class="r">$ '+l.price.toFixed(2)+'</td><td class="r">$ '+tot.toFixed(2)+'</td></tr>';
  }).join('');
  var html='<!doctype html><html><head><meta charset="utf-8"><title>Cotizacion Kennedy Center</title><style>'
    +'@page{size:letter landscape;margin:.4in}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#000;font-size:12px}'
    +'.hd{display:grid;grid-template-columns:32% 44% 24%;border-bottom:2px solid #185FA5;padding-bottom:8px;margin-bottom:10px}'
    +'.hd .c{text-align:center}.hd h1{font-size:22px;font-style:italic;margin:0 0 4px}.hd p{margin:1px 0;font-size:13px}'
    +'.hd .r{text-align:right;font-size:12px}.hd .r b{display:block;font-size:14px}'
    +'.meta{display:grid;grid-template-columns:1.4fr .8fr 1fr;gap:4px 12px;border-bottom:2px solid #185FA5;padding-bottom:8px;margin-bottom:10px}'
    +'.meta div{display:flex;gap:6px}.meta b{white-space:nowrap}'
    +'table.it{width:100%;border-collapse:collapse;margin-top:6px}table.it th,table.it td{border-bottom:1px solid #ccc;padding:4px 6px;text-align:left}'
    +'table.it th{border-bottom:2px solid #000;font-size:11px}table.it td.r,table.it th.r{text-align:right;white-space:nowrap}'
    +'.tot{margin-top:10px;width:40%;margin-left:auto}.tot div{display:flex;justify-content:space-between;padding:3px 0}.tot .f{border-top:2px solid #000;font-weight:800;font-size:15px}'
    +'.firmas{display:grid;grid-template-columns:1fr 1fr;gap:70px;margin-top:48px}.firmas span{display:block;border-bottom:1px solid #000;height:18px}.firmas b{display:block;text-align:center;margin-top:6px}'
    +'</style></head><body>'
    +'<div class="hd"><div><b>KC COTIZACION</b><div>TEL. 441-6755</div><div>P.O. Box 0302-00737</div><div>Zona Libre de Colon</div><div>Colon, Rep. de Panama</div></div>'
    +'<div class="c"><h1>KENNEDY CENTER CORP.</h1><p>IMPORTADORES - EXPORTADORES</p><p>ZONA LIBRE DE COLON</p></div>'
    +'<div class="r"><b>COTIZACION</b><span>'+npEsc(npFechaDisp())+'</span></div></div>'
    +'<div class="meta"><div><b>VENDIDO A:</b><span>'+npEsc((npCli?npCli.cardcode+' - '+npCli.cardname:'—'))+'</span></div>'
    +'<div><b>FECHA:</b><span>'+npEsc(npFechaDisp())+'</span></div>'
    +'<div><b>VENDEDOR:</b><span>'+npEsc(npVendedorNombre()||'—')+'</span></div>'
    +'<div><b>BULTOS:</b><span>'+(Math.round(t.bultos*100)/100)+'</span></div>'
    +'<div><b>KILOS:</b><span>'+(Math.round(t.kilos*100)/100)+'</span></div>'
    +'<div><b>PIE CUBICO:</b><span>'+(Math.round(t.piecub*1000)/1000)+'</span></div></div>'
    +'<table class="it"><thead><tr><th class="r">#</th><th class="r">Bts.</th><th class="r">Kilos</th><th class="r">Pie Cub</th><th>Referencia</th><th>Descripcion</th><th>Descripcion (Ingles)</th><th class="r">Cantidad</th><th class="r">Precio</th><th class="r">Total</th></tr></thead><tbody>'+filas+'</tbody></table>'
    +'<div class="tot"><div><span>Subtotal</span><span>$ '+t.sub.toFixed(2)+'</span></div>'
    +'<div><span>Descuentos</span><span>- $ '+t.descTotal.toFixed(2)+'</span></div>'
    +'<div class="f"><span>TOTAL</span><span>$ '+t.total.toFixed(2)+'</span></div></div>'
    +(document.getElementById('np-comments')&&document.getElementById('np-comments').value?'<p style="margin-top:14px"><b>NOTAS:</b> '+npEsc(document.getElementById('np-comments').value)+'</p>':'')
    +'<div class="firmas"><div><span></span><b>FIRMA</b></div><div><span></span><b>FIRMA</b></div></div>'
    +'</body></html>';
  w.document.open();w.document.write(html);w.document.close();w.focus();
  setTimeout(function(){try{w.print();}catch(e){}},600);
}

async function npExcel(){
  if(!npLineas.length){alert('No hay productos en la cotización.');return;}
  await npCargarPesos();
  var t=npTotales();
  var rows=npLineas.map(function(l){
    var tot=l.quantity*l.price*(1-l.discount/100);
    var kg=Math.round((Number(l.peso)||0)*l.quantity*100)/100;
    var ft=Math.round((Number(l.volumen)||0)*l.quantity*NP_VOL_FACTOR*1000)/1000;
    return '<tr><td>'+npEsc(l.itemcode)+'</td><td>'+npEsc(l.itemname)+'</td><td>'+npEsc(l.frgnname||'')+'</td><td>'+l.quantity+'</td><td>'+l.price.toFixed(2)+'</td><td>'+(l.discount||0)+'%</td><td>'+tot.toFixed(2)+'</td><td>'+kg+'</td><td>'+ft+'</td><td>'+npEsc(l.note||'')+'</td></tr>';
  }).join('');
  var html='<meta charset="utf-8"><table border="1"><tr><td colspan="9" style="font-size:16px;font-weight:bold">KENNEDY CENTER CORP. - COTIZACION</td></tr>'
    +'<tr><td colspan="9">Cliente: '+npEsc(npCli?npCli.cardcode+' - '+npCli.cardname:'—')+'</td></tr>'
    +'<tr><td colspan="9">Vendedor: '+npEsc(npVendedorNombre()||'—')+' &nbsp; Fecha: '+npEsc(npFechaDisp())+'</td></tr>'
    +'<tr><th>SKU</th><th>Producto</th><th>Producto (Ingles)</th><th>Cantidad</th><th>Precio</th><th>Desc.</th><th>Total</th><th>Kilos</th><th>Pie Cub</th><th>Nota</th></tr>'+rows
    +'<tr><td colspan="5" style="text-align:right;font-weight:bold">Subtotal</td><td>'+t.sub.toFixed(2)+'</td><td>'+(Math.round(t.kilos*100)/100)+'</td><td>'+(Math.round(t.piecub*1000)/1000)+'</td><td></td></tr>'
    +'<tr><td colspan="5" style="text-align:right;font-weight:bold">Descuentos</td><td>'+t.descTotal.toFixed(2)+'</td><td></td><td></td><td></td></tr>'
    +'<tr><td colspan="5" style="text-align:right;font-weight:bold">TOTAL</td><td style="font-weight:bold">'+t.total.toFixed(2)+'</td><td></td><td></td><td></td></tr></table>';
  var blob=new Blob(['\ufeff',html],{type:'application/vnd.ms-excel;charset=utf-8'});
  var url=URL.createObjectURL(blob);var a=document.createElement('a');
  a.href=url;a.download='cotizacion-kennedy-'+(npCli?npCli.cardcode:'')+'.xls';
  document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);
}

// ════ REPORTES ════
var RPT_CAMPOS=[
  {k:'foto',label:'Foto',def:true},
  {k:'sku',label:'SKU',def:true},
  {k:'barcode',label:'Barcode',def:false},
  {k:'precio',label:'Precio',def:true},
  {k:'stock',label:'Stock',def:true},
  // Lo que se puede vender: el stock menos lo separado en pedidos autorizados.
  {k:'disponible',label:'Disponible',def:true},
  {k:'packing',label:'Packing',def:true},
  {k:'peso',label:'Peso',def:false},
  {k:'marca',label:'Marca',def:false},
  {k:'tipo',label:'Tipo',def:false},
  {k:'tamano',label:'Tamaño del item',def:false},
  {k:'cubicaje',label:'Cubicaje',def:false},
  {k:'color',label:'Color',def:false},
  {k:'composicion',label:'Composición',def:false},
  // El grupo arancelario (Customs Group de SAP). Apagado por defecto: solo
  // hace falta para aduana y documentos de embarque.
  {k:'arancel',label:'Arancel',def:false},
  // El pais de origen de la mercancia. Sale de las caracteristicas del
  // articulo (el campo 'Porigen' de SAP), no de una columna.
  {k:'origen',label:'Origen',def:false},
  // La medida de la caja (OITM.U_CartonSize). Distinto de 'Tamano del item',
  // que es la del producto: esta es la del bulto, la que interesa para
  // cubicar el contenedor y para aduana.
  {k:'tamanobulto',label:'Tama\u00f1o bulto',def:false}
];
var rptTipo='factura', rptDoc=null, rptLineas=[];
var RPT_NUM=['precio','stock','packing','peso','cubicaje'];
var _atrData=[], _atrLoaded=false, _atrLoading=false;
var _reconData=null,_reconLoading=false,_reconLoaded=false;
async function reconCargar(forzar){
  if(_reconLoading) return;
  if(_reconLoaded && !forzar){ reconFiltrar(); return; }
  _reconLoading=true;
  var cont=document.getElementById('recon-cont');
  function _msg(t){ if(cont)cont.innerHTML='<div style="padding:30px;text-align:center;color:#888"><div class="spinner"></div> '+t+'</div>'; }
  function p2(n){ n=String(n); return n.length<2?('0'+n):n; }
  function inlist(arr){ return arr.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(','); }
  try{
    var hoy=new Date();
    var Y=hoy.getFullYear(), M=hoy.getMonth(); // 0-11
    var wY=Y-1;
    var wStart=wY+'-'+p2(M+1)+'-01';
    var wEnd = (M+1===12) ? (wY+1)+'-01-01' : (wY+'-'+p2(M+2)+'-01');
    var seis=new Date(hoy); seis.setMonth(seis.getMonth()-6);
    var seisIso=seis.getFullYear()+'-'+p2(seis.getMonth()+1)+'-'+p2(seis.getDate());
    var meses=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
    var mesNom=meses[M];
    var dsc=document.getElementById('recon-desc');

    // 1) Compras de ese mes el ano pasado
    _msg('Buscando compras de '+mesNom+' de '+wY+'...');
    var fac=await qAll('facturas','select=cardcode,docnum,docdate,doctotal&docdate=gte.'+wStart+'&docdate=lt.'+wEnd);
    var cand={};
    (fac||[]).forEach(function(r){
      var cc=r.cardcode; if(!cc) return;
      var c=cand[cc]||(cand[cc]={docs:{},fecha:''});
      if(r.docnum!=null) c.docs[r.docnum]=Number(r.doctotal||0);
      var dk=String(r.docdate||''); if(dk>c.fecha) c.fecha=dk;
    });
    var candCodes=Object.keys(cand);
    if(!candCodes.length){ _reconData=[]; _reconLoaded=true; reconPoblarFiltros(); reconFiltrar(); _reconLoading=false; return; }

    // 2) De esos, quienes SI compraron en los ultimos 6 meses (se excluyen)
    _msg('Revisando actividad reciente de '+candCodes.length+' clientes...');
    var recientes={};
    for(var i=0;i<candCodes.length;i+=120){
      var chk=candCodes.slice(i,i+120);
      var rec=await qAll('facturas','select=cardcode&cardcode=in.('+inlist(chk)+')&docdate=gte.'+seisIso);
      (rec||[]).forEach(function(r){ if(r.cardcode) recientes[r.cardcode]=1; });
    }
    var finales=candCodes.filter(function(cc){ return !recientes[cc]; });
    if(!finales.length){ _reconData=[]; _reconLoaded=true; reconPoblarFiltros(); reconFiltrar(); _reconLoading=false; return; }

    // 3) Ultima compra real (max docdate) de los finales
    _msg('Calculando ultima compra de '+finales.length+' clientes...');
    var ult={};
    for(var i=0;i<finales.length;i+=120){
      var chk=finales.slice(i,i+120);
      var rows=await qAll('facturas','select=cardcode,docdate&cardcode=in.('+inlist(chk)+')&order=cardcode,docdate');
      (rows||[]).forEach(function(r){ var cc=r.cardcode, dk=String(r.docdate||''); if(dk>(ult[cc]||'')) ult[cc]=dk; });
    }

    // 4) Datos de contacto
    _msg('Cargando datos de contacto...');
    var cliMap={};
    for(var i=0;i<finales.length;i+=120){
      var chk=finales.slice(i,i+120);
      var cs=await q('clientes','select=cardcode,cardname,city,country,nombrevendedor,phone1,cellular,e_mail&cardcode=in.('+inlist(chk)+')&limit='+chk.length);
      (cs||[]).forEach(function(c){ cliMap[c.cardcode]=c; });
    }

    var data=finales.map(function(cc){
      var c=cliMap[cc]||{}, cd=cand[cc]||{docs:{},fecha:''};
      var total=0, n=0; Object.keys(cd.docs).forEach(function(d){ total+=cd.docs[d]; n++; });
      var ultF=ult[cc]||cd.fecha||'';
      var dias=ultF?Math.round((hoy-new Date(ultF+'T00:00:00'))/86400000):null;
      return { cardcode:cc, cardname:(c.cardname||cc), city:c.city||'', country:c.country||'',
        vendedor:c.nombrevendedor||'', phone:(c.phone1||c.cellular||''), email:(c.e_mail||''),
        compraAnio:total, nComp:n, ultFecha:ultF, dias:dias };
    }).sort(function(a,b){ return (b.compraAnio||0)-(a.compraAnio||0); });

    if(dsc) dsc.innerHTML='Clientes que compraron en <b>'+mesNom+' de '+wY+'</b> y que llevan <b>m&aacute;s de 6 meses sin comprar</b>. Buenos candidatos para contactar y reactivar.';
    _reconData=data; _reconLoaded=true; reconPoblarFiltros(); reconFiltrar(); _reconLoading=false;
  }catch(e){
    if(cont)cont.innerHTML='<div class="empty" style="padding:30px;text-align:center;color:var(--red)">Error al cargar: '+(e&&e.message||e)+'</div>';
    _reconLoading=false;
  }
}
function reconPoblarFiltros(){
  var vs={}, ps={};
  (_reconData||[]).forEach(function(r){ if(r.vendedor)vs[r.vendedor]=1; if(r.country)ps[r.country]=1; });
  var sv=document.getElementById('recon-vend');
  if(sv){ var cur=sv.value; sv.innerHTML='<option value="">Todos los vendedores</option>'+Object.keys(vs).sort().map(function(v){return '<option'+(v===cur?' selected':'')+'>'+npEsc(v)+'</option>';}).join(''); }
  var sp=document.getElementById('recon-pais');
  if(sp){ var cur2=sp.value; sp.innerHTML='<option value="">Todos los paises</option>'+Object.keys(ps).sort().map(function(p){return '<option value="'+npEsc(p)+'"'+(p===cur2?' selected':'')+'>'+npEsc(paisNombre(p)||p)+'</option>';}).join(''); }
}
function reconFiltrar(){
  var v=(document.getElementById('recon-vend')||{}).value||'';
  var p=(document.getElementById('recon-pais')||{}).value||'';
  var rows=(_reconData||[]).filter(function(r){ return (!v||r.vendedor===v)&&(!p||r.country===p); });
  reconRender(rows);
}
function reconRender(rows){
  var cont=document.getElementById('recon-cont'); if(!cont) return;
  var res=document.getElementById('recon-resumen');
  if(res) res.innerHTML = rows.length? ('<b>'+rows.length+'</b> cliente'+(rows.length!==1?'s':'')+' para reactivar') : '';
  if(!rows.length){ cont.innerHTML='<div class="empty" style="padding:30px;text-align:center;color:#888">No hay clientes que cumplan el criterio este mes.</div>'; return; }
  cont.innerHTML='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(320px,1fr));gap:12px">'+rows.map(function(r){
    var meses=r.dias!=null?Math.floor(r.dias/30):null;
    var sin=r.dias!=null?(meses>=1?(meses+' mes'+(meses!==1?'es':'')):(r.dias+' dias')):'s/d';
    var ccJs=String(r.cardcode).replace(/'/g,"\\'");
    var tel=r.phone?'<a href="tel:'+npEsc(r.phone)+'" style="color:var(--blue);text-decoration:none">'+npEsc(r.phone)+'</a>':'';
    var mail=r.email?'<a href="mailto:'+npEsc(r.email)+'" style="color:var(--blue);text-decoration:none">'+npEsc(r.email)+'</a>':'';
    return '<div class="card" style="cursor:pointer" onclick="verCliente(\''+ccJs+'\')">'
      +'<div style="display:flex;justify-content:space-between;gap:8px;align-items:flex-start">'
        +'<div style="min-width:0"><div style="font-weight:700;font-size:14px">'+paisFlag(r.country)+' '+npEsc(r.cardname)+'</div>'
        +'<div style="font-size:11.5px;color:var(--text3)">'+npEsc(r.cardcode)+(r.vendedor?'  &middot;  '+npEsc(r.vendedor):'')+'</div></div>'
        +'<span style="background:#fde8ef;color:#c2185b;font-size:11px;font-weight:600;padding:3px 9px;border-radius:20px;white-space:nowrap">'+sin+' sin comprar</span>'
      +'</div>'
      +'<div style="display:flex;gap:22px;margin-top:11px;font-size:12px">'
        +'<div><div style="color:var(--text3)">Compr&oacute; el a&ntilde;o pasado</div><div style="font-weight:600">'+fmt(r.compraAnio)+(r.nComp>1?' &middot; '+r.nComp+' fact.':'')+'</div></div>'
        +'<div><div style="color:var(--text3)">&Uacute;ltima compra</div><div style="font-weight:600">'+(r.ultFecha?fmtD(r.ultFecha):'s/d')+'</div></div>'
      +'</div>'
      +((tel||mail)?'<div style="display:flex;gap:16px;margin-top:11px;font-size:12px;flex-wrap:wrap" onclick="event.stopPropagation()">'+(tel?'<span>&#9742; '+tel+'</span>':'')+(mail?'<span>&#9993; '+mail+'</span>':'')+'</div>':'')
      +'</div>';
  }).join('')+'</div>';
}
async function rptAtrasadosCargar(forzar){
  if(_atrLoading) return;
  if(_atrLoaded && !forzar){ atrFiltrar(); return; }
  _atrLoading=true;
  var cont=document.getElementById('atr-cont');
  function _msg(t){ if(cont) cont.innerHTML='<div style="padding:30px;text-align:center;color:#888"><div class="spinner"></div> '+t+'</div>'; }
  _msg('Buscando clientes con saldo...');
  try{
    // 1) UNIVERSO de candidatos = clientes con filas en estado_cuenta (saldo>0) U clientes con balance>0.
    //    Es el mismo universo amplio de siempre, para no perder ningun deudor. El ledger depura despues.
    var ecAgg={};   // cardcode -> {pend, maxDias} (respaldo si no hay ledger)
    var ecRows=await qAll('estado_cuenta','select=cardcode,saldopendiente,diasvencido&saldopendiente=gt.0');
    (ecRows||[]).forEach(function(r){
      var cc=r.cardcode; if(!cc) return;
      var a=ecAgg[cc]||(ecAgg[cc]={pend:0,maxDias:0});
      a.pend+=Number(r.saldopendiente||0);
      var dv=Number(r.diasvencido||0); if(dv>a.maxDias) a.maxDias=dv;
    });
    var setCodes={}; Object.keys(ecAgg).forEach(function(k){ setCodes[k]=1; });
    var balRows=await qAll('clientes','select=cardcode&cardtype=eq.C&balance=gt.0');
    (balRows||[]).forEach(function(r){ if(r.cardcode) setCodes[r.cardcode]=1; });
    var codes=Object.keys(setCodes);
    if(!codes.length){ _atrData=[]; _atrLoaded=true; atrPoblarFiltros(); atrFiltrar(); _atrLoading=false; return; }

    // 2) Datos de esos clientes
    _msg('Cargando datos de '+codes.length+' clientes...');
    var cliMap={};
    for(var i=0;i<codes.length;i+=120){
      var chk=codes.slice(i,i+120);
      var inL=chk.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
      var cs=await q('clientes','select=cardcode,cardname,city,country,balance,creditline,condicionpago,nombrevendedor&cardcode=in.('+inL+')&limit='+chk.length);
      (cs||[]).forEach(function(c){ cliMap[c.cardcode]=c; });
    }

    // 3) Ledger de esos clientes (por lotes con paginacion interna)
    var led={};
    for(var i=0;i<codes.length;i+=80){
      var chunk=codes.slice(i,i+80);
      var inList=chunk.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
      // qAll pagina respetando el tope real del servidor. Antes limit=3000 se cortaba en ~1000
      // y, con el break por mv.length<3000, dejaba ledgers incompletos (facturas sin sus pagos).
      var mv=await qAll('movimientos','select=cardcode,docdate,docduedate,debito,credito&cardcode=in.('+inList+')&order=cardcode,docdate,docnum');
      (mv||[]).forEach(function(m){ (led[m.cardcode]=led[m.cardcode]||[]).push(m); });
      _msg('Calculando saldos desde el ledger... ('+Math.min(i+80,codes.length)+' / '+codes.length+' clientes)');
    }

    // 4) Construir filas
    var out=[];
    codes.forEach(function(cc){
      var c=cliMap[cc]; if(!c) return;
      var bal=Number(c.balance||0), lim=Number(c.creditline||0);
      var cond=String(c.condicionpago||'');
      var isContado=/contado|cash|efectivo|\bcod\b|c\.o\.d/i.test(cond);
      var movs=led[cc], pend, maxDias, vencido;
      if(movs && movs.length){
        // tiene ledger -> fuente confiable; si cuadra en 0 es fantasma y se descarta
        var ag=cliAgingLedger(movs);
        pend=ag.total; maxDias=ag.maxDias; vencido=ag.vencido>0.005?ag.vencido:ag.total;
      }else{
        // sin ledger -> respaldo con estado_cuenta / balance (no perder al cliente)
        var a=ecAgg[cc]||{pend:0,maxDias:0};
        pend = a.pend>0.005 ? a.pend : bal;
        maxDias = a.maxDias; vencido = pend;
      }
      if(pend<=0.005) return;                                   // ya no debe
      var incluir = isContado ? (pend>0.005) : (maxDias>0);     // contado: cualquier saldo; credito: vencido
      if(!incluir) return;
      out.push({ cardcode:c.cardcode, cardname:c.cardname||c.cardcode, city:c.city||'', country:c.country||'',
        vendedor:c.nombrevendedor||'(Sin vendedor)', pais:paisNombre(c.country||''), cond:cond, isContado:isContado,
        pend:pend, vencido:vencido, maxDias:maxDias, balance:bal, creditline:lim,
        excedeLim:(!isContado && lim>0)?Math.max(0,bal-lim):0 });
    });
    _atrData=out; _atrLoaded=true;
    atrPoblarFiltros();
    atrFiltrar();
  }catch(e){
    if(cont) cont.innerHTML='<div style="padding:20px;color:#E24B4A">No se pudo cargar el reporte: '+(e&&e.message?e.message:e)+'</div>';
  }
  _atrLoading=false;
}
function atrPoblarFiltros(){
  var vs={}, ps={};
  _atrData.forEach(function(r){ vs[r.vendedor]=1; if(r.pais) ps[r.pais]=1; });
  var selV=document.getElementById('atr-vend'), selP=document.getElementById('atr-pais');
  if(selV){ var cur=selV.value; selV.innerHTML='<option value="">Todos los vendedores</option>'+Object.keys(vs).sort().map(function(v){return '<option value="'+String(v).replace(/"/g,'&quot;')+'">'+v+'</option>';}).join(''); selV.value=cur; }
  if(selP){ var curp=selP.value; selP.innerHTML='<option value="">Todos los paises</option>'+Object.keys(ps).sort().map(function(p){return '<option value="'+String(p).replace(/"/g,'&quot;')+'">'+p+'</option>';}).join(''); selP.value=curp; }
}

function atrColor(d){ return d<=90?'#eab308':(d<=180?'#f97316':'#dc2626'); }
function atrTint(d){ return d<=90?'#fefce8':(d<=180?'#fff7ed':'#fef2f2'); }
function atrTier(d){ return d<=90?'\u2264 3 meses':(d<=180?'\u2264 6 meses':'+ 6 meses'); }

function atrFiltrar(){
  var cont=document.getElementById('atr-cont'); if(!cont) return;
  var fv=(document.getElementById('atr-vend')||{}).value||'';
  var fp=(document.getElementById('atr-pais')||{}).value||'';
  var rows=_atrData.filter(function(r){ return (!fv||r.vendedor===fv) && (!fp||r.pais===fp); });
  rows.sort(function(a,b){ return b.pend-a.pend; });
  var res=document.getElementById('atr-resumen');
  if(res){ var tot=rows.reduce(function(s,r){return s+r.pend;},0); var ven=rows.reduce(function(s,r){return s+r.vencido;},0);
    res.innerHTML='<b>'+rows.length+'</b> cliente'+(rows.length!==1?'s':'')+' atrasado'+(rows.length!==1?'s':'')+'  &middot;  Total pendiente: <b>'+fmt(tot)+'</b>  &middot;  Vencido: <b style="color:#dc2626">'+fmt(ven)+'</b>'; }
  if(!rows.length){ cont.innerHTML=empty('Sin clientes atrasados'); return; }
  var groups={}; rows.forEach(function(r){ (groups[r.vendedor]=groups[r.vendedor]||[]).push(r); });
  var vends=Object.keys(groups).sort(function(a,b){
    var sa=groups[a].reduce(function(s,r){return s+r.pend;},0), sb=groups[b].reduce(function(s,r){return s+r.pend;},0);
    return sb-sa;
  });
  cont.innerHTML=vends.map(function(v){
    var g=groups[v]; var gt=g.reduce(function(s,r){return s+r.pend;},0);
    var cards=g.map(function(r){
      var col=atrColor(r.maxDias), tint=atrTint(r.maxDias);
      var cdJs=String(r.cardcode).replace(/'/g,"\\'");
      return '<div class="cc" style="border-left:4px solid '+col+';background:'+tint+'" onclick="verCliente(\''+cdJs+'\')">'
        +'<div class="cc-top"><div class="cc-av">'+ini(r.cardname)+'</div>'
        +'<div style="min-width:0"><div class="cc-name">'+paisFlag(r.country)+r.cardname+'</div>'
        +'<div class="cc-code">'+r.cardcode+(r.city?'  '+r.city:'')+'</div></div></div>'
        +'<div style="display:flex;gap:6px;flex-wrap:wrap;margin:8px 0 4px">'
          +'<span class="badge '+(r.isContado?'b-gray':'b-blue')+'">'+(r.isContado?'Contado':'Credito')+'</span>'
          +'<span class="badge" style="background:'+col+'22;color:'+col+'">'+atrTier(r.maxDias)+'  '+r.maxDias+' dias</span>'
        +'</div>'
        +'<div class="cc-stats">'
          +'<div class="cc-stat"><label>Saldo pend.</label><span>'+fmt(r.pend)+'</span></div>'
          +'<div class="cc-stat"><label>Vencido</label><span>'+fmt(r.vencido)+'</span></div>'
          +'<div class="cc-stat"><label>'+(r.isContado?'Limite':'Excede lim.')+'</label><span>'+(r.isContado?fmt(r.creditline):fmt(r.excedeLim))+'</span></div>'
        +'</div>'
      +'</div>';
    }).join('');
    return '<div style="margin-bottom:20px">'
      +'<div style="font-size:13px;font-weight:700;margin:6px 0 10px;padding-bottom:6px;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap">'
        +'<span>Vendedor: '+v+' <span style="color:var(--text3);font-weight:400">('+g.length+' cliente'+(g.length!==1?'s':'')+')</span></span>'
        +'<span style="color:var(--text3);font-weight:600">Pendiente: '+fmt(gt)+'</span>'
      +'</div>'
      +'<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));gap:12px">'+cards+'</div>'
    +'</div>';
  }).join('');
}

function loadReportes(){ rptRenderCampos(); rptTipoSet(rptTipo,true); }
function rptRenderCampos(){
  var c=document.getElementById('rpt-campos'); if(!c||c.dataset.listo) return;
  c.innerHTML=RPT_CAMPOS.map(function(f){
    return '<label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer;padding:9px 11px;border:1px solid var(--border);border-radius:8px"><input type="checkbox" id="rptc-'+f.k+'"'+(f.def?' checked':'')+'>'+f.label+'</label>';
  }).join('');
  c.dataset.listo='1';
}
function rptTipoSet(t,noReset){
  rptTipo=t;
  var pf=document.getElementById('rpt-pill-fac'), pp=document.getElementById('rpt-pill-ped');
  if(pf)pf.classList.toggle('active',t==='factura');
  if(pp)pp.classList.toggle('active',t==='pedido');
  var lbl=document.getElementById('rpt-tipo-lbl'); if(lbl)lbl.textContent=(t==='factura'?'factura':'pedido');
  if(!noReset){ rptDoc=null; rptLineas=[]; var pc=document.getElementById('rpt-preview-card'); if(pc)pc.style.display='none'; rptToggleBtns(false); var inf=document.getElementById('rpt-info'); if(inf)inf.textContent=''; }
}
function rptToggleBtns(on){
  var a=document.getElementById('rpt-btn-pdf'), b=document.getElementById('rpt-btn-xls');
  if(a)a.disabled=!on; if(b)b.disabled=!on;
}
// El grupo arancelario NO esta en `vista_inventario`, solo en la tabla
// `inventario`. Se pide aparte y con su propio try/catch: si se metiera en el
// select de la vista, PostgREST responderia 400 y se perderian TODOS los
// campos del reporte, no solo el arancel.
async function _rptArancel(map){
  var codes=Object.keys(map||{});
  if(!codes.length) return;
  try{
    var en=codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    var r=await q('inventario',
      'select=itemcode,arancel,arancel_cod&itemcode=in.('+en+')&limit='+codes.length);
    (r||[]).forEach(function(x){
      var d=map[x.itemcode];
      if(d){ d.arancel=x.arancel; d.arancel_cod=x.arancel_cod; }
    });
  }catch(e){}
}

// SAP guarda el pais de origen con su codigo de dos letras. En un reporte que
// ve el cliente tiene que decir CHINA, no CN. La tabla de paises vive en
// kennedy-reportes2.js (r2Pais); si ese archivo no esta cargado se deja el
// valor tal cual en vez de fallar.
function rptPais(v){
  var t=String(v||'').trim();
  if(!t) return '';
  try{ if(typeof r2Pais==='function') return r2Pais(t,'es'); }catch(e){}
  return t.toUpperCase();
}

function rptCarac(c,claves){
  if(!c||typeof c!=='object') return '';
  var keys=Object.keys(c);
  for(var i=0;i<keys.length;i++){var kl=keys[i].toLowerCase();for(var j=0;j<claves.length;j++){if(kl.indexOf(claves[j])>=0&&c[keys[i]]!=null&&c[keys[i]]!=='')return String(c[keys[i]]);}}
  return '';
}
async function _frgnMap(codes){
  var m={};
  codes=(codes||[]).filter(Boolean);
  if(!codes.length) return m;
  try{
    var uniq=Array.from(new Set(codes));
    for(var i=0;i<uniq.length;i+=300){
      var chunk=uniq.slice(i,i+300);
      var inList=chunk.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
      var rows=await q('inventario','select=itemcode,frgnname&itemcode=in.('+inList+')&limit='+chunk.length);
      (rows||[]).forEach(function(r){ if(r&&r.itemcode) m[r.itemcode]=r.frgnname||''; });
    }
  }catch(e){}
  return m;
}
// esNapa: el documento esta en las tablas de NAPA. Sin esto, exportar una
// factura de NAPA traia la de Kennedy con el mismo numero, que es otra
// factura completamente distinta.
async function rptFetch(tipo,num,esNapa){
  var tabla = esNapa ? (tipo==='factura' ? 'facturas_napa' : 'pedidos_napa')
                     : (tipo==='factura' ? 'facturas'      : 'pedidos');
  // Las tablas de NAPA no tienen descuentolinea ni comments.
  var headSel = esNapa
    ? 'select=docnum,docdate,cardcode,cardname,doctotal,nombrevendedor&docnum=eq.'+encodeURIComponent(num)+'&limit=1'
    : 'select=docnum,docdate,cardcode,cardname,doctotal,nombrevendedor,comments&docnum=eq.'+encodeURIComponent(num)+'&limit=1';
  var lineSel = esNapa
    ? 'select=linenum,itemcode,dscription,quantity,price,linetotal&docnum=eq.'+encodeURIComponent(num)+'&order=linenum'
    : 'select=linenum,itemcode,dscription,quantity,price,descuentolinea,linetotal&docnum=eq.'+encodeURIComponent(num)+'&order=linenum';
  var res=await Promise.all([ q(tabla,headSel), q(tabla,lineSel) ]);
  var head=res[0], lines=res[1];
  if(!lines||!lines.length) return null;
  var doc=(head&&head[0])||{docnum:num};
  var codes=[...new Set(lines.map(function(l){return l.itemcode;}).filter(Boolean))];
  var map={};
  if(codes.length){
    var inList=codes.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
    var rows=await q('vista_inventario','select=itemcode,foto_url,picturname,disponiblebodega,disponible,onhand,peso,volumen,unidadesbulto,subg,caracteristicas,marca,codebars&itemcode=in.('+inList+')&limit='+codes.length);
    (rows||[]).forEach(function(r){map[r.itemcode]=r;});
    await _rptArancel(map);
  }
  var _fm=await _frgnMap(codes);
  // Se ESPERA a saber cuanto esta separado antes de armar las filas: si no,
  // el disponible sale igual al stock.
  await sepCargar(codes);

  var lineas=lines.map(function(l){
    var inv=map[l.itemcode]||{};
    return {
      itemcode:l.itemcode, frgnname:(_fm[l.itemcode]||''), dscription:l.dscription, quantity:Number(l.quantity)||0, price:Number(l.price)||0,
      // La foto puede estar en el bucket (picturname) y no en Shopify
      // (foto_url). Sin las candidatas, los articulos con foto en el bucket
      // salian sin imagen en el PDF y el Excel.
      foto_url:(function(){ var pp=fotoPair(inv.picturname, inv.foto_url); return pp.primary||''; })(),
      foto_cands:(function(){
        var pp=fotoPair(inv.picturname, inv.foto_url);
        var l=[]; if(pp.primary) l.push(pp.primary);
        if(pp.fb) l=l.concat(String(pp.fb).split('|').filter(Boolean));
        return l;
      })(),
      picturname:(inv.picturname||''),
      stock:Number(inv.onhand!=null?inv.onhand:(inv.disponiblebodega!=null?inv.disponiblebodega:(inv.disponible||0))),
      // Lo que se puede vender: el stock menos lo separado en pedidos
      // autorizados. Sin esta linea el informe caia al stock y los dos
      // numeros salian iguales.
      disponible:(Number(inv.onhand!=null?inv.onhand:(inv.disponiblebodega!=null?inv.disponiblebodega:(inv.disponible||0)))||0) - sepAutorizado(l.itemcode),
      peso:Number(inv.peso)||0, volumen:Number(inv.volumen)||0, packing:Number(inv.unidadesbulto)||0,
      tipo:subgLabel(inv.subg), barcode:(inv.codebars||''), marca:(inv.marca||rptCarac(inv.caracteristicas,['marca','brand'])),
      tamano:rptCarac(inv.caracteristicas,['tama','medida','size','dimens','largo','ancho']),
      color:rptCarac(inv.caracteristicas,['color','colour','tono']),
      // El grupo arancelario viene como columna, no dentro de caracteristicas.
      // Va el CODIGO, que es lo que pide aduana ("001.324.348"). La
      // descripcion queda de respaldo por si un articulo no tiene codigo.
      arancel:(function(){
        var cd=(inv.arancel_cod!=null&&inv.arancel_cod!=='')?String(inv.arancel_cod).trim():'';
        return cd || String(inv.arancel||'').trim();
      })(),
      // 'Porigen' es como se llama el campo en esta base; se dejan los
      // nombres largos por delante por si en otra instalacion difiere.
      // 'Cartonsize' es como llega U_CartonSize. Se busca por ese nombre y
      // NO por 'tamano' a secas, que es el del articulo, no el de la caja.
      tamanobulto:rptCarac(inv.caracteristicas,['cartonsize','carton size','tamanobulto','tamano bulto','tamano de bulto','medida bulto']),
      origen:rptPais(rptCarac(inv.caracteristicas,['porigen','origen','procedencia','pais','country','made'])),
      composicion:rptCarac(inv.caracteristicas,['composic','compo','material','tela','fabric','content','hecho','confeccion','confección','fibra','algod','poliest','composition'])
    };
  });
  return {doc:doc, lineas:lineas};
}
async function rptCargar(){
  var num=(document.getElementById('rpt-num').value||'').trim();
  var inf=document.getElementById('rpt-info');
  if(!num){ if(inf)inf.textContent='Escribe el número de '+(rptTipo==='factura'?'factura':'pedido')+'.'; return; }
  if(inf)inf.textContent='Cargando...'; rptToggleBtns(false);
  try{
    var r=await rptFetch(rptTipo,num);
    if(!r){ if(inf)inf.textContent='No se encontró '+(rptTipo==='factura'?'la factura':'el pedido')+' #'+num+'.'; return; }
    rptDoc=r.doc; rptLineas=r.lineas;
    if(inf)inf.textContent=(rptTipo==='factura'?'Factura':'Pedido')+' #'+(rptDoc.docnum||num)+' · '+(rptDoc.cardname||'')+' · '+rptLineas.length+' líneas cargadas.';
    rptToggleBtns(true); rptPreview();
  }catch(e){ if(inf)inf.textContent='Error al cargar: '+e.message; }
}
// Generar PDF/Excel de un documento directamente (desde el detalle del pedido/factura)
async function docReporte(tipo,docnum,modo,esNapa){
  try{
    var r=await rptFetch(tipo,docnum,esNapa);
    if(!r){ await new Promise(function(res){setTimeout(res,500);}); r=await rptFetch(tipo,docnum,esNapa); }   // reintento por si la consulta se demoró
    if(!r){ alert('No se pudo cargar '+(tipo==='factura'?'la factura':'el pedido')+' #'+docnum+'. Intenta de nuevo.'); return; }
    rptTipo=tipo; rptDoc=r.doc; rptLineas=r.lineas;
    var cols=colsFromPrefix('pdc-');
    if(!cols.length) cols=RPT_CAMPOS.filter(function(f){return ['foto','sku','precio','stock','packing'].indexOf(f.k)>=0;});
    if(modo==='excel') rptExcel(cols); else rptPdf(cols);
  }catch(e){ alert('Error: '+e.message); }
}
async function _npRepLineas(){
  var codes=Array.from(new Set(npLineas.map(function(l){return l.itemcode;}).filter(Boolean)));
  var map={};
  if(codes.length){
    var inList=codes.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
    var rows=await q('vista_inventario','select=itemcode,foto_url,picturname,disponiblebodega,disponible,onhand,peso,volumen,unidadesbulto,subg,caracteristicas,marca,codebars&itemcode=in.('+inList+')&limit='+codes.length);
    (rows||[]).forEach(function(r){map[r.itemcode]=r;});
    await _rptArancel(map);
  }
  var _fm=await _frgnMap(codes);
  await sepCargar(codes);   // igual que arriba: primero el dato, luego las filas

  return npLineas.map(function(l){
    var inv=map[l.itemcode]||{};
    return {
      itemcode:l.itemcode, frgnname:(_fm[l.itemcode]||''), dscription:l.itemname, quantity:Number(l.quantity)||0, price:Number(l.price)||0,
      // La foto puede estar en el bucket (picturname) y no en Shopify
      // (foto_url). Sin las candidatas, los articulos con foto en el bucket
      // salian sin imagen en el PDF y el Excel.
      foto_url:(function(){ var pp=fotoPair(inv.picturname, inv.foto_url); return pp.primary||''; })(),
      foto_cands:(function(){
        var pp=fotoPair(inv.picturname, inv.foto_url);
        var l=[]; if(pp.primary) l.push(pp.primary);
        if(pp.fb) l=l.concat(String(pp.fb).split('|').filter(Boolean));
        return l;
      })(),
      picturname:(inv.picturname||''),
      stock:Number(inv.onhand!=null?inv.onhand:(inv.disponiblebodega!=null?inv.disponiblebodega:(inv.disponible||0))),
      // Lo que se puede vender: el stock menos lo separado en pedidos
      // autorizados. Sin esta linea el informe caia al stock y los dos
      // numeros salian iguales.
      disponible:(Number(inv.onhand!=null?inv.onhand:(inv.disponiblebodega!=null?inv.disponiblebodega:(inv.disponible||0)))||0) - sepAutorizado(l.itemcode),
      peso:Number(inv.peso)||0, volumen:Number(inv.volumen)||0, packing:Number(inv.unidadesbulto)||0,
      tipo:subgLabel(inv.subg), barcode:(inv.codebars||''), marca:(inv.marca||rptCarac(inv.caracteristicas,['marca','brand'])),
      tamano:rptCarac(inv.caracteristicas,['tama','medida','size','dimens','largo','ancho','alto']),
      color:rptCarac(inv.caracteristicas,['color','colour','tono']),
      // El grupo arancelario viene como columna, no dentro de caracteristicas.
      // Va el CODIGO, que es lo que pide aduana ("001.324.348"). La
      // descripcion queda de respaldo por si un articulo no tiene codigo.
      arancel:(function(){
        var cd=(inv.arancel_cod!=null&&inv.arancel_cod!=='')?String(inv.arancel_cod).trim():'';
        return cd || String(inv.arancel||'').trim();
      })(),
      // 'Porigen' es como se llama el campo en esta base; se dejan los
      // nombres largos por delante por si en otra instalacion difiere.
      // 'Cartonsize' es como llega U_CartonSize. Se busca por ese nombre y
      // NO por 'tamano' a secas, que es el del articulo, no el de la caja.
      tamanobulto:rptCarac(inv.caracteristicas,['cartonsize','carton size','tamanobulto','tamano bulto','tamano de bulto','medida bulto']),
      origen:rptPais(rptCarac(inv.caracteristicas,['porigen','origen','procedencia','pais','country','made'])),
      composicion:rptCarac(inv.caracteristicas,['composic','compo','material','tela','fabric','content','hecho','confeccion','confección','fibra','algod','poliest','composition'])
    };
  });
}
async function npRepGen(modo){
  if(!npLineas.length){ alert('Agrega productos al pedido primero.'); return; }
  var cols=colsFromPrefix('npc-');
  if(!cols.length) cols=RPT_CAMPOS.filter(function(f){return ['foto','sku','precio'].indexOf(f.k)>=0;});
  try{
    var lineas=await _npRepLineas();
    rptTipo='pedido';
    rptDoc={docnum:'', cardcode:(npCli?npCli.cardcode:''), cardname:(npCli?npCli.cardname:'')||'Cotizacion', docdate:npFechaDisp()};
    rptLineas=lineas;
    if(modo==='excel') await rptExcel(cols); else await rptPdf(cols);
  }catch(e){ alert('Error al generar: '+(e&&e.message||e)); }
}
function colsFromPrefix(prefix){ return RPT_CAMPOS.filter(function(f){var cb=document.getElementById(prefix+f.k);return cb&&cb.checked;}); }
function rptCols(){ return colsFromPrefix('rptc-'); }
function rptChecksHTML(prefix){
  return RPT_CAMPOS.map(function(f){
    return '<label style="display:flex;align-items:center;gap:7px;font-size:12px;cursor:pointer;padding:7px 9px;border:1px solid var(--border);border-radius:8px"><input type="checkbox" id="'+prefix+f.k+'"'+(f.def?' checked':'')+'>'+f.label+'</label>';
  }).join('');
}
// Las casillas de Nuevo pedido estan escritas a mano en el liquid, no
// generadas como las del detalle de pedido. Por eso se quedaron atras: cuando
// se añadio Barcode y despues Arancel a RPT_CAMPOS, esa pantalla ni se entero
// y el usuario no podia marcarlos.
//
// Esto compara lo que hay con RPT_CAMPOS y agrega lo que falte. No borra ni
// reordena nada: si el liquid ya las trae, no hace nada. Asi, si mañana se
// suma otro campo, aparece solo en las dos pantallas.
function npChecksSync(){
  var cont=document.getElementById('npc-checks');
  if(!cont) return;
  var faltan=RPT_CAMPOS.filter(function(f){ return !document.getElementById('npc-'+f.k); });
  if(!faltan.length) return;
  cont.insertAdjacentHTML('beforeend', faltan.map(function(f){
    return '<label style="display:flex;align-items:center;gap:7px;font-size:12px;'
      +'cursor:pointer;padding:7px 9px;border:1px solid var(--border);border-radius:8px">'
      +'<input type="checkbox" id="npc-'+f.k+'"'+(f.def?' checked':'')+'>'+f.label+'</label>';
  }).join(''));
  if(window.KCC_DEBUG) console.log('[npc] agregadas:', faltan.map(function(f){return f.k;}));
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')
    document.addEventListener('DOMContentLoaded', npChecksSync);
  else npChecksSync();
}

function rptValor(l,k){
  switch(k){
    case 'foto': return l.foto_url||'';
    case 'sku': return l.itemcode||'';
    case 'barcode': return l.barcode||'';
    case 'precio': return '$ '+l.price.toFixed(2);
    case 'stock': return fmtN(l.stock);
    case 'disponible': return fmtN(l.disponible!=null?l.disponible:l.stock);
    case 'packing': return l.packing?fmtN(l.packing):'';
    case 'peso': return l.peso?(Math.round(l.peso*100)/100)+' kg':'';
    case 'marca': return l.marca||'';
    case 'tipo': return (l.tipo&&l.tipo!=='—')?l.tipo:'';
    case 'tamano': return l.tamano||'';
    case 'color': return l.color||'';
    case 'cubicaje': return l.volumen?(Math.round(l.volumen*1000)/1000)+' ft³':'';
    case 'composicion': return l.composicion||'';
    case 'origen': return l.origen||'';
    case 'tamanobulto': return l.tamanobulto||'';
    case 'arancel': return l.arancel||'';
    case 'bultos': return (l.bultos!=null)?fmtN(l.bultos):'';
  }
  return '';
}
function rptPreview(){
  var card=document.getElementById('rpt-preview-card'), box=document.getElementById('rpt-preview');
  if(!card||!box) return;
  var cols=rptCols();
  var th='<th style="text-align:left;padding:6px 8px;border-bottom:2px solid #000;font-size:11px">Descripción</th><th style="text-align:left;padding:6px 8px;border-bottom:2px solid #000;font-size:11px">Descripción (Inglés)</th><th style="text-align:right;padding:6px 8px;border-bottom:2px solid #000;font-size:11px">Cant.</th>'
    +cols.map(function(c){return '<th style="text-align:left;padding:6px 8px;border-bottom:2px solid #000;font-size:11px">'+c.label+'</th>';}).join('');
  var body=rptLineas.map(function(l){
    return '<tr><td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:12px">'+npEsc(l.dscription||'')+'</td><td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:12px;color:#555">'+npEsc(l.frgnname||'')+'</td><td style="padding:5px 8px;border-bottom:1px solid #eee;text-align:right;font-size:12px">'+fmtN(l.quantity)+'</td>'
      +cols.map(function(c){
        if(c.k==='foto') return '<td style="padding:3px 8px;border-bottom:1px solid #eee">'+(l.foto_url?'<img src="'+l.foto_url+'" style="width:42px;height:42px;object-fit:contain" loading="lazy">':'')+'</td>';
        return '<td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:12px">'+npEsc(rptValor(l,c.k))+'</td>';
      }).join('')+'</tr>';
  }).join('');
  box.innerHTML='<table style="width:100%;border-collapse:collapse"><thead><tr>'+th+'</tr></thead><tbody>'+body+'</tbody></table>';
  card.style.display='';
}
async function rptPdf(colsOverride){
  if(!rptLineas.length){alert('Carga un documento primero.');return;}
  var w=window.open('','_blank');
  if(!w){alert('Permite ventanas emergentes para generar el PDF.');return;}
  var cols=colsOverride||rptCols();
  var tieneFoto=cols.some(function(c){return c.k==='foto';});
  var campoCols=cols.filter(function(c){return c.k!=='foto';});
  var tipoTxt=rptTipo==='factura'?'Factura':'Pedido';
  var _thumbs={};
  if(tieneFoto){ try{ w.document.write('<p style="font-family:Arial;padding:20px" id="_ld">Optimizando imagenes...</p>'); var _cf=_calidadFoto(rptLineas.length); _thumbs=await _fetchThumbPool(rptLineas.map(function(l){return l.foto_url||'';}),_cf.px,_cf.q,function(d,t){ try{var e=w.document.getElementById('_ld'); if(e)e.textContent='Optimizando imagenes '+d+'/'+t+'...'; _avisarFotosFaltantes(); }catch(_x){} }); }catch(_e){} }
  var perPage=9;
  var _hdr='<div class="hdr"><div><h1>KENNEDY CENTER CORP.</h1><div class="sub">Catalogo de productos</div></div>'
    +'<div class="rt"><b>'+tipoTxt+' #'+npEsc(String(rptDoc.docnum||''))+'</b><span>'+npEsc(rptDoc.cardname||'')+'</span><br><span>'+npEsc(rptDoc.docdate||'')+'</span><br><span>'+rptLineas.length+' productos</span></div></div>';
  var pagesHtml='';
  for(var _p=0;_p<rptLineas.length;_p+=perPage){
    var _slice=rptLineas.slice(_p,_p+perPage);
    var _cards=_slice.map(function(l,idx){
      var i=_p+idx;
      var _src=tieneFoto?(_thumbs[l.foto_url]||l.foto_url||''):'';
      var foto=tieneFoto?'<div class="ph">'+(_src?'<img src="'+_src+'">':'<span class="noimg">Sin foto</span>')+'</div>':'';
      var campos=campoCols.map(function(c){
        return '<div class="fl"><b>'+npEsc(c.label)+':</b> '+npEsc(rptValor(l,c.k)||'—')+'</div>';
      }).join('');
      return '<div class="card">'+foto+'<div class="nm">'+(i+1)+'. '+npEsc(l.dscription||'')+'</div>'+(l.frgnname?'<div style="font-size:9.3px;color:#777;font-style:italic;line-height:1.15;margin:-3px 0 6px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">'+npEsc(l.frgnname)+'</div>':'')+'<div class="fields">'+campos+'</div></div>';
    }).join('');
    pagesHtml+='<div class="page">'+_hdr+'<div class="grid">'+_cards+'</div></div>';
  }
  var html='<!doctype html><html><head><meta charset="utf-8"><title>Catalogo Kennedy Center</title><style>'
    +'@page{size:letter;margin:.45in}*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-family:Arial,Helvetica,sans-serif;color:#1a1a1a;font-size:11px;margin:0}'
    +'.page{height:10in;display:flex;flex-direction:column;overflow:hidden;page-break-after:always}'
    +'.page:last-child{page-break-after:auto}'
    +'.hdr{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #6c47ff;padding-bottom:8px;margin-bottom:12px;flex:0 0 auto}'
    +'.hdr h1{font-size:18px;margin:0;font-weight:800;letter-spacing:.4px;color:#111}.hdr .sub{font-size:11px;color:#777;margin-top:3px}'
    +'.hdr .rt{text-align:right;font-size:10.5px;color:#555;line-height:1.45}.hdr .rt b{display:block;color:#6c47ff;font-size:12px}'
    +'.grid{flex:1 1 auto;display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(3,minmax(0,1fr));gap:12px;min-height:0}'
    +'.card{border:1px solid #e5e5ec;border-radius:9px;padding:11px 10px 9px;display:flex;flex-direction:column;align-items:center;text-align:center;overflow:hidden;background:#fff}'
    +'.ph{width:100%;height:118px;display:flex;align-items:center;justify-content:center;background:#f6f6fb;border:1px solid #eee;border-radius:7px;margin-bottom:9px;flex:0 0 auto;overflow:hidden}'
    +'.ph img{max-width:100%;max-height:116px;object-fit:contain}.noimg{color:#c2c2cc;font-size:10px}'
    +'.nm{font-weight:700;font-size:11.5px;margin-bottom:7px;line-height:1.22;color:#111;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}'
    +'.fields{width:100%;overflow:hidden}.fields .fl{font-size:9.4px;line-height:1.34;color:#3a3a3a}.fields .fl b{color:#6c47ff;font-weight:700}'
    +'</style></head><body>'
    +pagesHtml
    +'<scr'+'ipt>(function(){var imgs=document.images,n=imgs.length,done=0,printed=false;function pr(){if(printed)return;printed=true;setTimeout(function(){window.focus();window.print();},250);}function chk(){if(done>=n)pr();}if(n===0){pr();return;}for(var i=0;i<n;i++){if(imgs[i].complete){done++;}else{imgs[i].addEventListener("load",function(){done++;chk();});imgs[i].addEventListener("error",function(){done++;chk();});}}chk();setTimeout(pr,8000);})();<\/scr'+'ipt>'
    +'</body></html>';
  w.document.open();w.document.write(html);w.document.close();w.focus();
}
async function rptExcel(colsOverride){
  if(!rptLineas.length){alert('Carga un documento primero.');return;}
  var cols=colsOverride||rptCols();
  var hayFoto=cols.some(function(c){return c.k==='foto';});
  var tipoTxt=rptTipo==='factura'?'FACTURA':'PEDIDO';
  try{
    var columns=[{label:'Descripcion',key:'__desc',width:42},{label:'Descripcion (Ingles)',key:'__desc_en',width:42},{label:'Cantidad',key:'__cant',width:10}].concat(cols.map(function(c){
      return {label:c.label,key:c.k,width:(c.k==='foto'?9:(c.k==='sku'?16:12)),numFmt:(c.k==='precio'?'0.00':undefined)};
    }));
    await xlsxExport({
      filename:'reporte-'+rptTipo+'-'+(rptDoc.docnum||'')+'.xlsx',
      titulo:'KENNEDY CENTER CORP. - REPORTE '+tipoTxt+' #'+(rptDoc.docnum||''),
      subtitulo:'Cliente: '+((rptDoc.cardcode||'')+' - '+(rptDoc.cardname||''))+'  -  Fecha: '+(rptDoc.docdate||''),
      columns:columns, rows:rptLineas, fotoKey:(hayFoto?'foto':null),
      fotoUrlFn:function(l){return l.foto_url||'';},
      fotoCandsFn:function(l){ return l.foto_cands || (l.foto_url?[l.foto_url]:[]); },
      valueFn:_rptXlsxVal
    });
  }catch(ex){ rptExcelHTML(colsOverride); }
}
function rptExcelHTML(colsOverride){
  if(!rptLineas.length){alert('Carga un documento primero.');return;}
  var cols=colsOverride||rptCols(), tipoTxt=rptTipo==='factura'?'FACTURA':'PEDIDO', nc=2+cols.length;
  var hayFoto=cols.some(function(c){return c.k==='foto';});
  var FH=40;
  var rows=rptLineas.map(function(l){
    var tds=cols.map(function(c){
      if(c.k==='foto') return '<td height="'+(FH+6)+'" width="80" style="width:80px;height:'+(FH+6)+'px;text-align:center;vertical-align:middle;mso-number-format:\'@\'">'+(l.foto_url?'<img src="'+l.foto_url+'" width="'+FH+'" height="'+FH+'" style="width:'+FH+'px;height:'+FH+'px">':'')+'</td>';
      var v;
      switch(c.k){
        case 'precio': v=l.price.toFixed(2); break;
        case 'stock': v=l.stock; break;
        case 'disponible': v=(l.disponible!=null?l.disponible:l.stock); break;
        case 'packing': v=l.packing||''; break;
        case 'peso': v=l.peso||''; break;
        case 'cubicaje': v=l.volumen||''; break;
        default: v=rptValor(l,c.k);
      }
      return '<td style="vertical-align:middle">'+npEsc(String(v))+'</td>';
    }).join('');
    var trh=hayFoto?' height="'+(FH+6)+'" style="height:'+(FH+6)+'px"':'';
    return '<tr'+trh+'><td style="vertical-align:middle">'+npEsc(l.dscription||'')+'</td><td style="vertical-align:middle">'+npEsc(l.frgnname||'')+'</td><td style="vertical-align:middle;text-align:center">'+l.quantity+'</td>'+tds+'</tr>';
  }).join('');
  var colgroup='<colgroup><col style="width:240px"><col style="width:60px">'+cols.map(function(c){return '<col style="width:'+(c.k==='foto'?'80px':(c.k==='sku'?'110px':'70px'))+'">';}).join('')+'</colgroup>';
  var html='<meta charset="utf-8"><table border="1" cellspacing="0" style="border-collapse:collapse">'+colgroup
    +'<tr><td colspan="'+nc+'" style="font-size:16px;font-weight:bold">KENNEDY CENTER CORP. - REPORTE '+tipoTxt+' #'+npEsc(String(rptDoc.docnum||''))+'</td></tr>'
    +'<tr><td colspan="'+nc+'">Cliente: '+npEsc((rptDoc.cardcode||'')+' - '+(rptDoc.cardname||''))+' &nbsp; Fecha: '+npEsc(rptDoc.docdate||'')+'</td></tr>'
    +'<tr style="background:#e8f2ef;font-weight:bold"><th>Descripcion</th><th>Descripcion (Ingles)</th><th>Cantidad</th>'+cols.map(function(c){return '<th>'+npEsc(c.label)+'</th>';}).join('')+'</tr>'+rows+'</table>';
  var blob=new Blob(['\ufeff',html],{type:'application/vnd.ms-excel;charset=utf-8'});
  var url=URL.createObjectURL(blob);var a=document.createElement('a');
  a.href=url;a.download='reporte-'+rptTipo+'-'+(rptDoc.docnum||'')+'.xls';
  document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);
}


// ════════════════════════════════════════════════════════════════════
//  MERCANCIA SIN ROTACION
//  Articulos CON STOCK que llevan mas de N meses sin venderse.
//  Los datos los calcula el RPC mercancia_sin_rotacion en Postgres:
//  averiguar que NO se vendio exige mirar todo el historial de facturas,
//  y bajarlo al navegador tardaria minutos.
// ════════════════════════════════════════════════════════════════════
var SR_ALL=[], srSel={}, srMesesF=6, srOrdenF='viejo', srDeptOpen={}, srQF='';

function srInit(){
  var box=document.getElementById('sr-result'); if(!box) return;
  if(SR_ALL && SR_ALL.length){ srRender(); return; }
  srCargar();
}

async function srCargar(){
  var box=document.getElementById('sr-result'); if(!box) return;
  box.innerHTML='<div class="card" style="padding:20px;color:var(--text3);font-size:13px">Buscando mercancia sin movimiento\u2026</div>';
  srSel={}; srDeptOpen={};   // todas las secciones arrancan cerradas
  try{
    var r=await fetch(SB+'/rest/v1/rpc/mercancia_sin_rotacion',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},
      body:JSON.stringify({p_meses:Number(srMesesF)||6})
    });
    if(!r.ok){ var t=await r.text(); throw new Error(r.status+': '+t.slice(0,160)); }
    var d=await r.json();
    SR_ALL=Array.isArray(d)?d:[];
    // Sembrar el cache de fotos con lo que ya vino del RPC.
    SR_ALL.forEach(function(x){
      if(x.itemcode && (x.picturname||x.foto_url) && !NP_FOTO_CACHE[x.itemcode]){
        NP_FOTO_CACHE[x.itemcode]={pn:x.picturname||'',fu:x.foto_url||''};
      }
    });
    srRender();
    npCargarFotos(SR_ALL.slice(0,500).map(function(x){return x.itemcode;}), srRender);
  }catch(e){
    var msg=String(e.message||e);
    var falta=/mercancia_sin_rotacion|PGRST202|404/i.test(msg);
    box.innerHTML='<div class="card" style="padding:18px">'
      +'<div style="color:var(--red);font-weight:600;font-size:13px">No se pudo cargar el reporte</div>'
      +'<div style="font-size:12px;color:var(--text3);margin-top:6px">'+npEsc(msg)+'</div>'
      +(falta?'<div style="font-size:12px;margin-top:10px;background:#FEF3E8;border:1px solid #F5B971;border-radius:8px;padding:9px 11px;color:#B45309">Falta crear la funci\u00f3n en Supabase. Corre el archivo <b>10_sql_mercancia_sin_rotacion.sql</b> en el SQL Editor.</div>':'')
      +'</div>';
  }
}

function srMeses(v){ srMesesF=Number(v)||6; SR_ALL=[]; srCargar(); }
function srOrden(v){ srOrdenF=v||'nuevo'; srRender(); }
function srBuscar(v){ srQF=String(v||'').trim().toLowerCase(); srRender(); }
function srDept(g){ srDeptOpen[g]=!srDeptOpen[g]; srRender(); }
function srAbrirTodos(on){ srFiltradas().forEach(function(r){ srDeptOpen[r.grupo]=!!on; }); srRender(); }
function srSelToggle(code,on){ if(on) srSel[code]=1; else delete srSel[code]; srPintarBoton(); }

function srPintarBoton(){
  var n=Object.keys(srSel||{}).length;
  var b=document.getElementById('sr-btn-add');
  if(b){ b.disabled=!n; b.textContent=n?('Agregar '+n+' al pedido (1 bulto c/u)'):'Agregar al pedido (1 bulto c/u)'; }
}

// Marca o desmarca todo un departamento de una vez.
function srDeptTodos(g, on){
  srFiltradas().forEach(function(r){
    if(String(r.grupo)!==String(g)) return;
    if(on) srSel[r.itemcode]=1; else delete srSel[r.itemcode];
  });
  srRender();
}

// ── Exclusiones del reporte de sin rotacion ────────────────────────────────
// 1) Mercancia muerta: mas de 5 anios sin venderse. Ya no es candidata a oferta,
//    solo ensucia el reporte. Si nunca se vendio, se mide por su fecha de
//    entrada al inventario (asi un articulo que llego el mes pasado si aparece).
var SR_ANIOS_MAX = 5;

// 2) Departamentos descontinuados. Comparacion exacta (sin acentos ni
//    mayusculas), a proposito: 'Electronica' a secas NO se excluye, solo
//    'ElectronicaXX'.
var SR_DEPT_FUERA = ['electronicaxx','construccion','wallpaper','calzado','ropaxx'];

function _srNorm(x){
  return String(x==null?'':x).toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[\s._-]+/g,'').trim();
}

function _srDeptFuera(g){ return SR_DEPT_FUERA.indexOf(_srNorm(g)) >= 0; }

// true = hay que sacarlo por antiguedad
function _srMuyViejo(r){
  var lim = SR_ANIOS_MAX * 365;
  var d = Number(r.dias_sin_venta);
  if(isFinite(d) && d > 0) return d > lim;

  var ref = r.ultima_venta || r.fechaentrada;   // nunca vendido -> fecha de entrada
  if(!ref) return false;                        // sin ninguna fecha: lo dejamos
  var t = new Date(String(ref).substring(0,10) + 'T00:00:00');
  if(isNaN(t.getTime())) return false;
  return (Date.now() - t.getTime()) / 86400000 > lim;
}

function srFiltradas(){
  var q=srQF;
  return (SR_ALL||[]).filter(function(r){
    if(_srDeptFuera(r.grupo)) return false;
    if(_srMuyViejo(r)) return false;
    if(!q) return true;
    return String(r.itemcode||'').toLowerCase().indexOf(q)>=0
        || String(r.itemname||'').toLowerCase().indexOf(q)>=0
        || String(r.marca||'').toLowerCase().indexOf(q)>=0;
  });
}

// Cuantos se estan ocultando, para decirlo en pantalla.
function srOcultados(){
  var dept=0, viejo=0;
  (SR_ALL||[]).forEach(function(r){
    if(_srDeptFuera(r.grupo)) dept++;
    else if(_srMuyViejo(r)) viejo++;
  });
  return {dept:dept, viejo:viejo, total:dept+viejo};
}

function _srCmp(a,b){
  var fa=String(a.fechaentrada||''), fb=String(b.fechaentrada||'');
  var ba=Number(a.bultos)||0,        bb=Number(b.bultos)||0;
  if(srOrdenF==='stock'){                      // mayor stock primero
    if(bb!==ba) return bb-ba;
    return fb.localeCompare(fa);
  }
  if(srOrdenF==='viejo'){                      // mas viejo primero
    if(fa!==fb) return fa.localeCompare(fb);
    return bb-ba;
  }
  // 'nuevo' (por defecto): mas nuevo primero, y a igual fecha mas stock primero
  if(fa!==fb) return fb.localeCompare(fa);
  return bb-ba;
}

function srRender(){
  var box=document.getElementById('sr-result'); if(!box) return;
  var rows=srFiltradas();

  if(!(SR_ALL||[]).length){
    box.innerHTML='<div class="card" style="padding:20px;text-align:center;color:var(--text3);font-size:13px">Sin mercanc\u00eda detenida con ese criterio. \u00a1Todo rota!</div>';
    return;
  }

  // Agrupar por departamento
  var porDept={};
  rows.forEach(function(r){
    var g=r.grupo||'(Sin departamento)';
    if(!porDept[g]) porDept[g]={items:[], bultos:0, uds:0, valor:0};
    porDept[g].items.push(r);
    porDept[g].bultos += Number(r.bultos)||0;
    porDept[g].uds    += Number(r.onhand)||0;
    porDept[g].valor  += (Number(r.onhand)||0)*(Number(r.precioventa)||0);
  });
  var depts=Object.keys(porDept).sort(function(a,b){ return porDept[b].items.length-porDept[a].items.length; });

  var totB=0, totU=0, totV=0;
  rows.forEach(function(r){
    totB+=Number(r.bultos)||0; totU+=Number(r.onhand)||0;
    totV+=(Number(r.onhand)||0)*(Number(r.precioventa)||0);
  });

  var resumen='<div class="card" style="margin-bottom:12px;display:flex;gap:22px;flex-wrap:wrap;align-items:center;padding:13px 16px">'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Art\u00edculos detenidos</div><div style="font-size:19px;font-weight:700">'+fmtN(rows.length)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Departamentos</div><div style="font-size:19px;font-weight:700">'+depts.length+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Bultos</div><div style="font-size:19px;font-weight:700">'+fmtN(totB)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Unidades</div><div style="font-size:19px;font-weight:700">'+fmtN(totU)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Valor a etiqueta</div><div style="font-size:19px;font-weight:700;color:var(--blue2)">'+fmt(totV)+'</div></div>'
    +(function(){ var o=srOcultados(); if(!o.total) return '';
        return '<div style="font-size:11px;color:var(--text3);border-left:1px solid var(--border);padding-left:16px;line-height:1.5">'
          +'<b>'+fmtN(o.total)+'</b> excluidos<br>'
          +(o.viejo?('&bull; '+fmtN(o.viejo)+' sin venta hace +'+SR_ANIOS_MAX+' a\u00f1os<br>'):'')
          +(o.dept?('&bull; '+fmtN(o.dept)+' de departamentos viejos'):'')
          +'</div>'; })()
    +'</div>';

  var secciones=depts.map(function(g){
    var d=porDept[g];
    var lista=d.items.slice().sort(_srCmp);
    var cerrado=!srDeptOpen[g];   // por defecto cerrada
    var gJs=String(g).replace(/'/g,"\\'");

    var head='<div class="ch" style="cursor:pointer;margin-bottom:'+(cerrado?'0':'10px')+'" onclick="srDept(\'' + gJs + '\')">'
      +'<span class="ct">'+(cerrado?'\u25b8':'\u25be')+' '+npEsc(g)
        +' <span style="font-weight:400;color:var(--text3);font-size:12px">\u00b7 '+d.items.length+' art\u00edculos \u00b7 '+fmtN(d.bultos)+' bultos \u00b7 '+fmt(d.valor)+'</span></span>'
      +'<span style="display:flex;gap:6px" onclick="event.stopPropagation()">'
        +'<button class="btn btn-sm" onclick="srDeptTodos(\'' + gJs + '\',true)">Marcar todo</button>'
        +'<button class="btn btn-sm" onclick="srDeptTodos(\'' + gJs + '\',false)">Quitar</button>'
      +'</span></div>';

    if(cerrado) return '<div class="card" style="margin-bottom:12px">'+head+'</div>';

    var th='<tr><th style="width:26px"></th><th>Foto</th><th>SKU</th><th>Descripci\u00f3n</th><th>Marca</th>'
      +'<th style="text-align:right">Stock</th><th style="text-align:right">Precio</th>'
      +'<th>\u00daltima entrada</th><th>\u00daltima venta</th><th style="text-align:right">Sin vender</th></tr>';

    var body=lista.map(function(r){
      var code=String(r.itemcode);
      var cJs=code.replace(/'/g,"\\'");
      var dias=(r.dias_sin_venta==null)?null:Number(r.dias_sin_venta);
      var meses=(dias==null)?null:Math.floor(dias/30);
      var colorDias=(dias==null)?'var(--red)':(dias>=365?'var(--red)':(dias>=180?'var(--amber)':'var(--text3)'));
      var txtDias=(dias==null)?'Nunca vendido':(meses+' meses');
      return '<tr>'
        +'<td style="text-align:center"><input type="checkbox" class="sr-chk" data-code="'+npEsc(code)+'"'+(srSel[code]?' checked':'')+' onchange="srSelToggle(this.getAttribute(\'data-code\'),this.checked)"></td>'
        +'<td>'+npFotoCell(r.itemcode,40)+'</td>'
        +'<td style="font-weight:600;color:var(--blue2);cursor:pointer" onclick="verItem(\'' + cJs + '\')"><u>'+npEsc(code)+'</u></td>'
        +'<td>'+npEsc(r.itemname||'')+'</td>'
        +'<td style="font-size:11.5px;color:var(--text3)">'+npEsc(r.marca||'')+'</td>'
        +'<td style="text-align:right;font-weight:700;color:var(--green)">'+fmtN(r.bultos)+' <span style="font-size:10px;font-weight:400">bultos</span>'
          +'<div style="font-size:10px;color:var(--text3);font-weight:400">'+fmtN(r.onhand)+' uds \u00b7 '+fmtN(r.unidadesbulto)+' x bulto</div></td>'
        +'<td style="text-align:right">'+fmt(r.precioventa)+'</td>'
        +'<td style="font-size:12px">'+(r.fechaentrada?fmtD(r.fechaentrada):'\u2014')+'</td>'
        +'<td style="font-size:12px">'+(r.ultima_venta?fmtD(r.ultima_venta):'<span style="color:var(--red)">\u2014</span>')+'</td>'
        +'<td style="text-align:right;font-weight:600;font-size:11.5px;color:'+colorDias+'">'+txtDias+'</td>'
        +'</tr>';
    }).join('');

    return '<div class="card" style="margin-bottom:12px">'+head
      +'<div style="overflow-x:auto"><table class="tbl">'+th+body+'</table></div></div>';
  }).join('');

  var barra='<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:12px;flex-wrap:wrap">'
    +'<span style="display:flex;gap:6px">'
      +'<button class="btn btn-sm" onclick="srAbrirTodos(true)">Abrir todos</button>'
      +'<button class="btn btn-sm" onclick="srAbrirTodos(false)">Cerrar todos</button>'
    +'</span>'
    +'<button class="btn btn-p" id="sr-btn-add" onclick="srAgregarSeleccion()" disabled>Agregar al pedido (1 bulto c/u)</button></div>';

  box.innerHTML=resumen+barra+(secciones||'<div class="card" style="padding:18px;text-align:center;color:var(--text3)">Sin resultados para esa b\u00fasqueda.</div>')+barra;
  srPintarBoton();
}

// Manda lo marcado al pedido, siempre 1 bulto por articulo.
function srAgregarSeleccion(){
  var codes=Object.keys(srSel||{});
  if(!codes.length){ alert('Marca al menos un art\u00edculo.'); return; }
  var n=0;
  codes.forEach(function(code){
    var r=(SR_ALL||[]).find(function(x){return String(x.itemcode)===String(code);});
    if(!r) return;
    var bulto=Math.max(1, Number(r.unidadesbulto)||1);
    var precio=Number(r.precioventa)||0;
    var l=npLineas.find(function(x){return String(x.itemcode)===String(r.itemcode);});
    if(l){ l.quantity=(Number(l.quantity)||0)+bulto; }
    else{
      npAgregar({itemcode:r.itemcode, itemname:r.itemname||r.itemcode, quantity:bulto,
                     price:precio, discount:0, whscode:'', bulto:bulto, note:'',
                     stockActual:Number(r.onhand)||0});
    }
    n++;
  });
  if(!n){ alert('No se pudieron leer los art\u00edculos seleccionados.'); return; }
  if(typeof npRenderLineas==='function') npRenderLineas();
  if(typeof _npEnableBtns==='function') _npEnableBtns();
  srSel={}; srPintarBoton();
  go('nuevo_pedido', document.getElementById('nav-np'));
  // Si aun no hay cliente elegido, empezar por ahi; si ya hay, ir a las lineas.
  setTimeout(function(){ if(typeof npIr==='function') npIr((typeof npCli!=='undefined' && npCli && npCli.cardcode)?3:1); },60);
}

// ── Auto-montaje del boton del menu y de la pagina ──────────────────
// El menu y las paginas viven en la plantilla Liquid, no aqui. Para no
// obligar a editar la plantilla, este bloque los crea solo si no existen.
// Si algun dia se pegan a mano en el Liquid, esto no hace nada (no duplica).
var _SR_NAV='<div class="ni" id="nav-sinrot" onclick="go(\'sinrotacion\',this)">'
  +'<svg style="color:#A78BFA" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">'
  +'<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>'
  +'<polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>'
  +'Mercanc\u00eda sin rotaci\u00f3n</div>';

var _SR_PAGE='<div class="page" id="page-sinrotacion">'
  +'<div class="card">'
    +'<div class="ch"><span class="ct">Mercanc\u00eda detenida \u2014 candidata a oferta</span></div>'
    +'<div style="font-size:12px;color:var(--text3);margin-bottom:12px">Art\u00edculos con <b>al menos 1 bulto completo</b> que llevan m\u00e1s de N meses sin venderse (o que nunca se han vendido). Pasa el mouse por la foto para verla grande; pulsa el SKU para abrir la ficha.</div>'
    +'<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap">'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Sin venderse hace m\u00e1s de</label>'
        +'<select id="sr-meses" onchange="srMeses(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="6" selected>6 meses</option><option value="9">9 meses</option><option value="12">12 meses</option><option value="18">18 meses</option><option value="24">24 meses</option></select></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Ordenar por</label>'
        +'<select id="sr-orden" onchange="srOrden(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="viejo" selected>M\u00e1s viejo primero</option><option value="nuevo">M\u00e1s nuevo primero</option><option value="stock">Mayor stock primero</option></select></div>'
      +'<div style="flex:1;min-width:200px"><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Buscar</label>'
        +'<input type="text" id="sr-q" placeholder="SKU, descripci\u00f3n o marca..." oninput="srBuscar(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;width:100%;outline:none;box-sizing:border-box"></div>'
      +'<button class="btn" onclick="srCargar()">Recargar</button>'
    +'</div>'
  +'</div>'
  +'<div id="sr-result"></div>'
+'</div>';

function _srMontarUI(){
  try{
    if(!document.getElementById('nav-sinrot')){
      var ref=document.getElementById('nav-tva')||document.getElementById('nav-atr')
            ||document.getElementById('nav-rst')||document.getElementById('nav-sep');
      if(ref && ref.insertAdjacentHTML) ref.insertAdjacentHTML('afterend', _SR_NAV);
    }
    if(!document.getElementById('page-sinrotacion')){
      var pg=document.getElementById('page-separados')||document.getElementById('page-restock')
           ||document.getElementById('page-topart')||document.querySelector('.page');
      if(pg && pg.insertAdjacentHTML) pg.insertAdjacentHTML('afterend', _SR_PAGE);
    }
  }catch(e){}
}
if(document.readyState!=='loading'){ try{_srMontarUI();}catch(e){} }
else { document.addEventListener('DOMContentLoaded',function(){ try{_srMontarUI();}catch(e){} }); }

// ════ RESTOCK POR CLIENTE ════
// ===== EXCEL REAL (.xlsx) CON FOTOS INCRUSTADAS (ExcelJS) =====
var _exceljsLoad=null;
function _ensureExcelJS(){
  if(window.ExcelJS) return Promise.resolve(window.ExcelJS);
  if(_exceljsLoad) return _exceljsLoad;
  _exceljsLoad=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js';
    sc.onload=function(){ if(window.ExcelJS) res(window.ExcelJS); else rej(new Error('ExcelJS no disponible')); };
    sc.onerror=function(){ rej(new Error('No se pudo cargar la libreria de Excel (revisa la conexion)')); };
    document.head.appendChild(sc);
  });
  return _exceljsLoad;
}
// Descarga una foto y la deja lista para incrustar en el Excel.
// ANTES: metia el archivo ORIGINAL tal cual. Como en la hoja se ve a 54x54 px
// pero el original pesa ~100 KB, un Excel de 2000 articulos salia de 200 MB.
// AHORA la reescala igual que hace el PDF: mismo aspecto en pantalla,
// una fraccion del peso.
async function _imgToB64(url, maxPx, quality){
  try{
    var _ac=new AbortController(); var _to=setTimeout(function(){try{_ac.abort();}catch(_){}},7000);
    var r; try{ r=await fetch(url,{mode:'cors',signal:_ac.signal}); } finally { clearTimeout(_to); }
    if(!r.ok) return null;
    var blob=await r.blob();
    var ty=(blob.type||'').toLowerCase();
    var ext = ty.indexOf('png')>=0?'png' : (ty.indexOf('gif')>=0?'gif' : ((ty.indexOf('jpeg')>=0||ty.indexOf('jpg')>=0)?'jpeg' : (/\.png(\?|$)/i.test(url)?'png':(/\.gif(\?|$)/i.test(url)?'gif':'jpeg'))));

    // Reescalado por canvas. Si algo falla se cae al original, que siempre
    // es preferible a quedarse sin foto.
    if(maxPx){
      try{
        var burl=URL.createObjectURL(blob);
        var img=await new Promise(function(res,rej){
          var _d=false; var _t=setTimeout(function(){if(!_d){_d=true;rej();}},7000);
          var im=new Image();
          im.onload =function(){ if(!_d){_d=true;clearTimeout(_t);res(im);} };
          im.onerror=function(){ if(!_d){_d=true;clearTimeout(_t);rej();} };
          im.src=burl;
        });
        var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
        if(w&&h){
          var sc=Math.min(1,maxPx/Math.max(w,h));
          var cw=Math.max(1,Math.round(w*sc)), ch=Math.max(1,Math.round(h*sc));
          var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch;
          var cx=cv.getContext('2d');
          cx.fillStyle='#fff'; cx.fillRect(0,0,cw,ch);   // fondo blanco para PNG con transparencia
          cx.drawImage(img,0,0,cw,ch);
          var durl=cv.toDataURL('image/jpeg', quality||0.7);
          URL.revokeObjectURL(burl);
          if(durl && durl.indexOf('data:image')===0){
            return { b64: durl.split(',')[1], ext: 'jpeg' };
          }
        } else { URL.revokeObjectURL(burl); }
      }catch(_e){ /* sigue al original */ }
    }

    var b64=await new Promise(function(res){ var fr=new FileReader(); fr.onload=function(){res(String(fr.result).split(',')[1]||null);}; fr.onerror=function(){res(null);}; fr.readAsDataURL(blob); });
    return b64?{b64:b64,ext:ext}:null;
  }catch(e){ return null; }
}
async function _fetchImgPool(urls,onProg,maxPx,quality){
  // Igual que _fetchThumbPool: admite una URL o una lista de candidatas.
  var listas=(urls||[]).map(function(u){
    return Array.isArray(u) ? u.filter(Boolean) : (u?[u]:[]);
  }).filter(function(l){ return l.length; });
  var _v={}, uniq=[];
  listas.forEach(function(l){ if(!_v[l[0]]){ _v[l[0]]=1; uniq.push(l); } });
  var plan=_poolPlan(uniq.length);
  var map={}, idx=0, done=0, ok=0, corte=false, _st=Date.now();
  async function w(){
    while(idx<uniq.length){
      if(Date.now()-_st>plan.dl){ corte=true; break; }
      var my=idx++; var cand=uniq[my], b=null;
      var orden=_ordenarCandidatas(cand, plan.corto);
      for(var ci=0; ci<orden.length && !b; ci++){
        try{ b=await _imgToB64(orden[ci],maxPx,quality); }catch(_e){ b=null; }
        if(b) _fotoVarPref=cand.indexOf(orden[ci]);
      }
      map[cand[0]]=b;
      if(b) ok++;
      done++; if(onProg) onProg(done,uniq.length);
    }
  }
  var arr=[]; for(var i=0;i<Math.min(plan.conc,uniq.length||0);i++) arr.push(w());
  await Promise.all(arr);
  window._thumbStats={total:uniq.length, ok:ok, fallidas:uniq.length-ok, corte:corte,
                      seg:Math.round((Date.now()-_st)/1000)};
  if(corte) console.warn('[fotos] se agoto el tiempo: '+ok+' de '+uniq.length);
  return map;
}
async function _imgToThumb(url,maxPx,quality){
  try{
    var _ac=new AbortController(); var _to=setTimeout(function(){try{_ac.abort();}catch(_){}},7000);
    var r; try{ r=await fetch(url,{mode:'cors',signal:_ac.signal}); } finally { clearTimeout(_to); }
    if(!r.ok) return null;
    var blob=await r.blob(); var burl=URL.createObjectURL(blob);
    var img=await new Promise(function(res,rej){ var _d=false; var _t=setTimeout(function(){if(!_d){_d=true;rej();}},7000); var im=new Image(); im.onload=function(){if(!_d){_d=true;clearTimeout(_t);res(im);}}; im.onerror=function(){if(!_d){_d=true;clearTimeout(_t);rej();}}; im.src=burl; });
    var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
    if(!w||!h){ URL.revokeObjectURL(burl); return null; }
    var sc=Math.min(1,(maxPx||200)/Math.max(w,h));
    var cw=Math.max(1,Math.round(w*sc)), ch=Math.max(1,Math.round(h*sc));
    var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch;
    var cx=cv.getContext('2d'); cx.fillStyle='#fff'; cx.fillRect(0,0,cw,ch); cx.drawImage(img,0,0,cw,ch);
    var durl=cv.toDataURL('image/jpeg', quality||0.72);
    URL.revokeObjectURL(burl);
    return (durl&&durl.indexOf('data:image')===0)?durl:null;
  }catch(e){ return null; }
}
// Devuelve las URLs candidatas de una foto, en el mismo orden que usa la
// pantalla (fotoPair): nombre tal cual, minusculas, mayusculas, solo la
// extension en minusculas, y por ultimo la de Shopify.
// El PDF/Excel usaban SOLO foto_url, por eso items con picturname (pero sin
// foto_url) salian como "Sin foto" aunque en pantalla si se vieran.
function _fotoCands(picturname, foto_url){
  var pn=(picturname||'').toString().trim();
  var out=[], vistos={};
  function add(u){ if(u && !vistos[u]){ vistos[u]=1; out.push(u); } }
  if(typeof FOTO_BASE!=='undefined' && FOTO_BASE && pn){
    add(FOTO_BASE+encodeURIComponent(pn));
    add(FOTO_BASE+encodeURIComponent(pn.toLowerCase()));
    add(FOTO_BASE+encodeURIComponent(pn.toUpperCase()));
    // picturname suele venir ".JPG" y en el bucket estan ".jpg" con el
    // nombre base tal cual; esta variante cubre justo ese caso.
    var m=pn.match(/^(.*)(\.[A-Za-z0-9]+)$/);
    if(m) add(FOTO_BASE+encodeURIComponent(m[1]+m[2].toLowerCase()));
  }
  add(foto_url||'');
  return out;
}

// ── Descarga de fotos para PDF/Excel: ajustes para lotes grandes ──
// Con 800+ articulos el pool se quedaba corto y las fotos que no llegaban
// salian en blanco. Tres causas y sus arreglos:
//   1. El presupuesto de tiempo era fijo (45 s) daba igual el tamano.
//   2. Solo 6 descargas en paralelo.
//   3. Cada articulo reintentaba TODAS las variantes de URL (.JPG, .jpg,
//      ...) aunque ya se supiera cual es la buena, multiplicando peticiones.

// Cual de las variantes de _fotoCands funciono. El bucket usa una convencion
// consistente, asi que en cuanto acierta con una, el resto de articulos van
// directos a esa y se ahorran el intento fallido.
var _fotoVarPref = null;

// Si aun con el presupuesto ampliado no dio tiempo, mejor decirlo que
// entregar un PDF de 800 paginas con huecos sin explicacion.
function _avisarFotosFaltantes(){
  var st=window._thumbStats;
  if(!st || !st.corte) return;
  alert('Aviso: no dio tiempo a cargar todas las fotos.\n\n'
    +'Se cargaron '+st.ok+' de '+st.total+' en '+st.seg+' segundos.\n'
    +'Las que faltan saldran en blanco en el documento.\n\n'
    +'Si te pasa a menudo, genera el documento en dos tandas usando los '
    +'filtros, o desmarca la casilla "Foto".');
}

// Resolucion de las fotos del PDF segun cuantas lleve. En la ficha se ven a
// 118-170 px de alto; para documentos enormes se baja un punto para que el
// archivo no se dispare, y en los pequenos se mantiene la calidad alta.
function _calidadFoto(n){
  if(n <= 300) return { px:200, q:0.72 };
  if(n <= 800) return { px:170, q:0.68 };
  return                { px:150, q:0.62 };
}

function _poolPlan(n){
  return {
    // ~200 ms por foto, con suelo de 45 s y techo de 4 min.
    dl:   Math.min(240000, Math.max(45000, n * 200)),
    conc: n > 250 ? 12 : 6,
    // En lotes grandes, una vez aprendida la variante buena se prueban solo
    // esa y la de Shopify (ultima de la lista), no las 4-5 completas.
    corto: n > 150
  };
}

function _ordenarCandidatas(cand, corto){
  if(_fotoVarPref == null || cand.length < 2) return cand;
  var pref = cand[Math.min(_fotoVarPref, cand.length - 1)];
  if(corto){
    var ultima = cand[cand.length - 1];              // la de Shopify
    return (ultima && ultima !== pref) ? [pref, ultima] : [pref];
  }
  return [pref].concat(cand.filter(function(u){ return u !== pref; }));
}

async function _fetchThumbPool(urls,maxPx,quality,onProg){
  // Cada entrada puede ser una URL suelta o una LISTA de candidatas: se
  // prueban en orden hasta que una cargue. El resultado se indexa por la
  // PRIMERA candidata, que es la que se guarda en l.foto_url, asi que quien
  // consulte _thumbs[l.foto_url] sigue funcionando igual.
  var listas=(urls||[]).map(function(u){
    return Array.isArray(u) ? u.filter(Boolean) : (u?[u]:[]);
  }).filter(function(l){ return l.length; });
  var _v={}, uniq=[];
  listas.forEach(function(l){ if(!_v[l[0]]){ _v[l[0]]=1; uniq.push(l); } });
  var plan=_poolPlan(uniq.length);
  var map={}, idx=0, done=0, ok=0, corte=false, _st=Date.now();
  async function wk(){
    while(idx<uniq.length){
      if(Date.now()-_st>plan.dl){ corte=true; break; }
      var my=idx++; var cand=uniq[my], t=null;
      var orden=_ordenarCandidatas(cand, plan.corto);
      for(var ci=0; ci<orden.length && !t; ci++){
        try{ t=await _imgToThumb(orden[ci],maxPx,quality); }catch(_e){ t=null; }
        if(t) _fotoVarPref=cand.indexOf(orden[ci]);
      }
      map[cand[0]]=t;
      if(t) ok++;
      done++; if(onProg) onProg(done,uniq.length);
    }
  }
  var arr=[]; for(var i=0;i<Math.min(plan.conc,uniq.length||0);i++) arr.push(wk());
  await Promise.all(arr);
  window._thumbStats={total:uniq.length, ok:ok, fallidas:uniq.length-ok, corte:corte,
                      seg:Math.round((Date.now()-_st)/1000)};
  if(corte) console.warn('[fotos] se agoto el tiempo: '+ok+' de '+uniq.length);
  return map;
}
async function xlsxExport(opts){
  var ExcelJS=await _ensureExcelJS();
  var cols=opts.columns, fotoKey=opts.fotoKey||null;
  var fotoIdx=fotoKey?cols.findIndex(function(c){return c.key===fotoKey;}):-1;
  var imgMap={};
  if(fotoIdx>=0){
    // 110 px de origen para un hueco de 54x54: el doble, que basta para que
    // se vea nitido tambien en pantallas de alta densidad.
    imgMap=await _fetchImgPool(opts.rows.map(opts.fotoCandsFn||opts.fotoUrlFn), opts.onProgress, 110, 0.7);
  }
  var wb=new ExcelJS.Workbook();
  var ws=wb.addWorksheet('Datos',{views:[{state:'frozen',ySplit:3}]});
  var nc=cols.length;
  ws.mergeCells(1,1,1,nc);
  var c1=ws.getCell(1,1); c1.value=opts.titulo||''; c1.font={bold:true,size:14};
  ws.mergeCells(2,1,2,nc);
  var c2=ws.getCell(2,1); c2.value=opts.subtitulo||''; c2.font={size:10,color:{argb:'FF555555'}};
  cols.forEach(function(c,ci){
    var h=ws.getCell(3,ci+1); h.value=c.label;
    h.font={bold:true}; h.fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFE8F2EF'}}; h.alignment={vertical:'middle'};
    var col=ws.getColumn(ci+1); col.width=c.width||14; if(c.numFmt) col.numFmt=c.numFmt;
  });
  opts.rows.forEach(function(r,ri){
    var rowNum=4+ri;
    cols.forEach(function(c,ci){
      if(c.key===fotoKey) return;
      var cell=ws.getCell(rowNum,ci+1);
      cell.value=opts.valueFn(r,c.key);
      cell.alignment={vertical:'middle'};
    });
    if(fotoIdx>=0){
      ws.getRow(rowNum).height=44;
      // Se prueban TODAS las candidatas, no solo la principal: _fetchImgPool
      // guarda la imagen bajo la URL que consiguio descargar, que puede ser
      // una de respaldo. Buscando solo por la primera, las fotos del bucket
      // se perdian y la columna salia vacia.
      var cands = (opts.fotoCandsFn ? opts.fotoCandsFn(r) : null)
                  || (opts.fotoUrlFn(r) ? [opts.fotoUrlFn(r)] : []);
      var im=null;
      for(var _i=0; _i<cands.length && !im; _i++){
        if(cands[_i] && imgMap[cands[_i]] && imgMap[cands[_i]].b64) im=imgMap[cands[_i]];
      }
      if(im && im.b64){
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id,{ tl:{col:fotoIdx+0.15, row:(rowNum-1)+0.12}, ext:{width:54,height:54}, editAs:'oneCell' });
      }
    }
  });
  var buf=await wb.xlsx.writeBuffer();
  // Con devolver:true no se descarga: se entrega el archivo en memoria, que es
  // lo que necesita el envio por correo para adjuntarlo.
  if(opts.devolver) return buf;
  var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download=opts.filename;
  document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
}
function _invXlsxVal(l,k){
  switch(k){
    case '__desc': return l.dscription||'';
    case '__desc_en': return l.frgnname||'';
    case 'foto': return '';
    case 'precio': return Number(l.price||0);
    case 'stock': return Number(l.stock||0);
    case 'disponible': return Number(l.disponible!=null?l.disponible:l.stock||0);
    case 'packing': return l.packing?Number(l.packing):'';
    case 'bultos': return (l.bultos!=null)?Number(l.bultos):'';
    case 'peso': return l.peso?Number(l.peso):'';
    case 'cubicaje': return l.volumen?Number(l.volumen):'';
    case 'sku': return l.itemcode||'';
    case 'barcode': return l.barcode||'';
    case 'marca': return l.marca||'';
    case 'tipo': return (l.tipo&&l.tipo!=='')?l.tipo:'';
    case 'tamano': return l.tamano||'';
    case 'color': return l.color||'';
    case 'composicion': return l.composicion||'';
    case 'origen': return l.origen||'';
    case 'tamanobulto': return l.tamanobulto||'';
    case 'arancel': return l.arancel||'';
  }
  return '';
}
function _rptXlsxVal(l,k){
  switch(k){
    case '__desc': return l.dscription||'';
    case '__desc_en': return l.frgnname||'';
    case '__cant': return Number(l.quantity||0);
    case 'foto': return '';
    case 'precio': return Number(l.price||0);
    case 'stock': return Number(l.stock||0);
    case 'packing': return l.packing?Number(l.packing):'';
    case 'peso': return l.peso?Number(l.peso):'';
    case 'cubicaje': return l.volumen?Number(l.volumen):'';
    default: return rptValor(l,k);
  }
}
// ===== EXPORT DE INVENTARIO (PDF / EXCEL) =====
var INV_CAMPOS=[
  {k:'foto',label:'Foto',def:true},
  {k:'sku',label:'SKU',def:true},
  {k:'barcode',label:'Barcode',def:false},
  {k:'precio',label:'Precio',def:true},
  {k:'stock',label:'Stock',def:true},
  // Lo que se puede vender: el stock menos lo separado en pedidos autorizados.
  {k:'disponible',label:'Disponible',def:true},
  {k:'packing',label:'U/Bulto',def:true},
  {k:'bultos',label:'Bultos disp.',def:false},
  {k:'peso',label:'Peso',def:false},
  {k:'marca',label:'Marca',def:false},
  {k:'tipo',label:'Tipo',def:false},
  {k:'tamano',label:'Tamano',def:false},
  {k:'composicion',label:'Composicion',def:false},
  {k:'arancel',label:'Arancel',def:false},
  {k:'origen',label:'Origen',def:false},
  {k:'tamanobulto',label:'Tamano bulto',def:false},
  {k:'cubicaje',label:'Cubicaje',def:false},
  {k:'color',label:'Color',def:false}
];
function invRenderCampos(){
  var c=document.getElementById('inv-campos'); if(!c||c.dataset.listo) return;
  c.innerHTML=INV_CAMPOS.map(function(f){
    return '<label style="display:flex;align-items:center;gap:7px;font-size:12.5px;cursor:pointer;padding:7px 9px;border:1px solid var(--border);border-radius:8px"><input type="checkbox" id="invc-'+f.k+'"'+(f.def?' checked':'')+'>'+f.label+'</label>';
  }).join('');
  c.dataset.listo='1';
}
function invExpCols(){ return INV_CAMPOS.filter(function(f){var cb=document.getElementById('invc-'+f.k);return cb&&cb.checked;}); }
function invFiltrosTexto(){
  var parts=[];
  if(invGruposSel && invGruposSel.length) parts.push('Grupo'+(invGruposSel.length>1?'s':'')+': '+invGruposSel.map(function(g){return String(g).replace(/^[.\s]+/,'');}).join(', '));
  else if(invGrupoF) parts.push('Grupo: '+String(invGrupoF).replace(/^[.\s]+/,''));
  if(typeof arbSelInv!=='undefined' && arbSelInv && typeof ARB_NODES!=='undefined' && ARB_NODES[arbSelInv]) parts.push('Coleccion');
  if(invCatF) parts.push('Tipo: '+invCatF);
  if(invAnioF) parts.push('Entrada '+invAnioF+'+');
  if(invRDesdeF || invRHastaF){
    function _dmy(iso){ var p=String(iso).split('-'); return p.length===3?(p[2]+'/'+p[1]+'/'+p[0]):iso; }
    parts.push('Entrada '+(invRDesdeF?('desde '+_dmy(invRDesdeF)):'')+(invRDesdeF&&invRHastaF?' ':'')+(invRHastaF?('hasta '+_dmy(invRHastaF)):''));
  }
  if(invRecienteF) parts.push('\u00daltimos '+invRecienteF+' mes'+(+invRecienteF>1?'es':''));
  if(invStockF==='bajo') parts.push('Bajo stock');
  if(invStockF==='critico') parts.push('Critico/Agotado');
  if(invDispF) parts.push('Disp: '+invDispF);
  if(invImgF) parts.push(invImgF==='con'?'Con foto':'Sin foto');
  if(invQ&&invQ.trim()) parts.push('Busqueda: "'+invQ.trim()+'"');
  if(invBMin&&+invBMin>0) parts.push('Bultos>='+invBMin);
  if(invPMin&&+invPMin>0) parts.push('Precio>='+invPMin);
  if(invPMax&&+invPMax>0) parts.push('Precio<='+invPMax);
  return parts.length?parts.join('  -  '):'Todo el inventario';
}
// bodyOverride permite reutilizar esta descarga desde otras pantallas
// (la de WMS le pasa {p_itemcodes:[...]}) sin duplicar el codigo.
async function invExportFetch(bodyOverride){
  var base=bodyOverride||window._invLastBody;
  if(!base){ await loadInventario(); base=window._invLastBody; }
  if(!base) return [];
  var items=[], off=0, PS=500, MAXP=24;
  for(var p=0;p<MAXP;p++){
    var b=Object.assign({},base,{p_limit:PS,p_offset:off});
    var resp=await fetch(SB+'/rest/v1/rpc/inv_buscar',{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(b)});
    var txt=await resp.text();
    if(!resp.ok){
      if(/57014|timeout/i.test(txt)) throw new Error('El filtro es demasiado grande y el servidor agoto el tiempo. Combinalo con otro filtro (ano, bultos, precio) y vuelve a exportar.');
      throw new Error('HTTP '+resp.status+': '+txt.slice(0,160));
    }
    var rows; try{ rows=JSON.parse(txt); }catch(e){ rows=[]; }
    if(!rows||!rows.length) break;
    items=items.concat(rows);
    if(rows.length<PS) break;
    off+=PS;
  }
  return items;
}
async function invEnrich(items){
  var codes=items.map(function(i){return i.itemcode;}).filter(Boolean);
  var map={};
  for(var i=0;i<codes.length;i+=300){
    var chunk=codes.slice(i,i+300);
    var inList=chunk.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
    var rows=await q('vista_inventario','select=itemcode,itemname,foto_url,peso,volumen,unidadesbulto,subg,caracteristicas,marca,precioventa,disponiblebodega,disponible,onhand,codebars,iscommited,onorder&itemcode=in.('+inList+')&limit='+chunk.length);
    (rows||[]).forEach(function(r){map[r.itemcode]=r;});
    await _rptArancel(map);
  }
  var _fm=await _frgnMap(codes);
  // Igual que en los informes del pedido: se espera a saber lo separado
  // antes de armar las filas. Aqui solia funcionar porque el dato ya estaba
  // en cache de la pantalla, pero al exportar en frio no lo estaba.
  await sepCargar(items.map(function(x){ return x.itemcode; }));

  return items.map(function(it){
    var inv=map[it.itemcode]||{};
    var stock=Number(it.onhand!=null?it.onhand:(inv.onhand!=null?inv.onhand:(it.disponiblebodega!=null?it.disponiblebodega:(it.disponible!=null?it.disponible:(inv.disponiblebodega!=null?inv.disponiblebodega:(inv.disponible||0))))));
    var packing=Number(it.unidadesbulto||inv.unidadesbulto||0);
    var price=Number(it.precioventa!=null?it.precioventa:(inv.precioventa||0));
    var _fc=_fotoCands(it.picturname||inv.picturname, it.foto_url||inv.foto_url);
    return {
      itemcode:it.itemcode,
      frgnname:(_fm[it.itemcode]||''),
      dscription:it.itemname||inv.itemname||'',
      price:price, stock:stock, packing:packing,
      // Se pide a la vista si no se sabe; al repintar ya esta en cache.
      disponible:(stock - sepAutorizado(it.itemcode)),
      iscommited:Number(it.iscommited!=null?it.iscommited:(inv.iscommited||0)),
      onorder:Number(it.onorder!=null?it.onorder:(inv.onorder||0)),
      bultos:(packing>0?Math.floor(stock/packing):null),
      // El RPC inv_buscar ya devuelve picturname (por eso la pantalla si
      // muestra la foto); antes aqui se ignoraba y solo se usaba foto_url.
      foto_url:(_fc[0]||''), foto_cands:_fc,
      peso:Number(inv.peso)||0, volumen:Number(inv.volumen)||0,
      tipo:subgLabel(it.subg||inv.subg),
      barcode:(it.codebars||inv.codebars||''),
      marca:(inv.marca||it.marca||rptCarac(inv.caracteristicas,['marca','brand'])),
      tamano:rptCarac(inv.caracteristicas,['tama','medida','size','dimens','largo','ancho','alto']),
      color:rptCarac(inv.caracteristicas,['color','colour','tono']),
      // El grupo arancelario viene como columna, no dentro de caracteristicas.
      // Va el CODIGO, que es lo que pide aduana ("001.324.348"). La
      // descripcion queda de respaldo por si un articulo no tiene codigo.
      arancel:(function(){
        var cd=(inv.arancel_cod!=null&&inv.arancel_cod!=='')?String(inv.arancel_cod).trim():'';
        return cd || String(inv.arancel||'').trim();
      })(),
      // 'Porigen' es como se llama el campo en esta base; se dejan los
      // nombres largos por delante por si en otra instalacion difiere.
      // 'Cartonsize' es como llega U_CartonSize. Se busca por ese nombre y
      // NO por 'tamano' a secas, que es el del articulo, no el de la caja.
      tamanobulto:rptCarac(inv.caracteristicas,['cartonsize','carton size','tamanobulto','tamano bulto','tamano de bulto','medida bulto']),
      origen:rptPais(rptCarac(inv.caracteristicas,['porigen','origen','procedencia','pais','country','made'])),
      composicion:rptCarac(inv.caracteristicas,['composic','compo','material','tela','fabric','content','hecho','confeccion','confección','fibra','algod','poliest','composition'])
    };
  });
}
function _invBtns(on){
  var a=document.getElementById('inv-btn-pdf'), b=document.getElementById('inv-btn-xls');
  if(a)a.disabled=!on; if(b)b.disabled=!on;
}
async function invPdf(colsOverride, bodyOverride){
  var cols=colsOverride||invExpCols();
  // Con muchas caracteristicas la tarjeta necesita mas ancho. En vertical y a
  // tres columnas cada una tiene unas 2,3 pulgadas utiles, que no dan para 10
  // campos: la tercera se salia de la hoja y se cortaba por la derecha.
  var _nCampos = cols.filter(function(c){ return c.k!=='foto'; }).length;
  var _nCols  = _nCampos > 8 ? 2 : 3;
  var _horiz  = _nCampos > 11;
  if(!cols.length){ alert('Marca al menos una caracteristica para incluir.'); return; }
  var info=document.getElementById('inv-export-info');
  if(info)info.textContent='Preparando datos (en filtros grandes puede tardar)...'; _invBtns(false);
  try{
    var raw=await invExportFetch(bodyOverride);
    if(!raw.length){ if(info)info.textContent='No hay productos que coincidan con el filtro.'; _invBtns(true); return; }
    var lineas=await invEnrich(raw);
    var w=window.open('','_blank');
    if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); if(info)info.textContent=''; _invBtns(true); return; }
    var tieneFoto=cols.some(function(c){return c.k==='foto';});
    var campoCols=cols.filter(function(c){return c.k!=='foto';});
    var _thumbs={};
    if(tieneFoto){ try{ var _cf=_calidadFoto(lineas.length); _thumbs=await _fetchThumbPool(lineas.map(function(l){return l.foto_cands||(l.foto_url?[l.foto_url]:[]);}),_cf.px,_cf.q,function(d,t){ if(info)info.textContent='Optimizando imagenes '+d+'/'+t+'...'; }); _avisarFotosFaltantes(); }catch(_e){} }
    var cards=lineas.map(function(l,i){
      var _src=tieneFoto?(_thumbs[l.foto_url]||l.foto_url||''):'';
      var foto=tieneFoto?'<div class="ph">'+(_src?'<img src="'+_src+'">':'<span class="noimg">Sin foto</span>')+'</div>':'';
      var campos=campoCols.map(function(c){return '<div class="fl"><b>'+npEsc(c.label)+':</b> '+npEsc(rptValor(l,c.k)||'')+'</div>';}).join('');
      return '<div class="card">'+foto+'<div class="nm">'+(i+1)+'. '+npEsc(l.dscription||'')+'</div>'+(l.frgnname?'<div style="font-size:9.3px;color:#777;font-style:italic;line-height:1.15;margin:-3px 0 6px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">'+npEsc(l.frgnname)+'</div>':'')+'<div class="fields">'+campos+'</div></div>';
    }).join('');
    var fecha=fmtD(hoyLocal());
    var html='<!doctype html><html><head><meta charset="utf-8"><title>Inventario Kennedy Center</title><style>'
      +'@page{size:letter'+(_horiz?' landscape':'')+';margin:.45in}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#111;font-size:12px;margin:0}'
      +'.top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:16px}'
      +'.top h1{font-size:21px;margin:0;font-weight:800}.top .sub{font-size:13px;margin-top:3px;color:#444;max-width:440px;line-height:1.4}.top .rt{text-align:right;font-size:12px;color:#333}.top .rt b{display:block;font-size:14px}'
      +'.grid{display:grid;grid-template-columns:repeat('+_nCols+',minmax(0,1fr));gap:12px;width:100%}'
      // minmax(0,1fr) y overflow-wrap impiden que un texto largo ensanche la
      // columna y empuje a las demas fuera de la pagina.
      +'.grid>*{min-width:0}.card *{overflow-wrap:anywhere;word-break:break-word}'
      +'.card{border:1px solid #ccc;border-radius:4px;padding:12px;break-inside:avoid;page-break-inside:avoid}'
      +'.ph{height:170px;display:flex;align-items:center;justify-content:center;border:1px solid #eee;margin-bottom:10px;overflow:hidden}'
      +'.ph img{max-width:100%;max-height:168px;object-fit:contain}.noimg{color:#bbb;font-size:11px}'
      +'.nm{font-weight:700;font-size:13px;margin-bottom:8px;line-height:1.25}'
      +'.fields .fl{font-size:12px;line-height:1.5}.fields .fl b{font-weight:700}'
      +'</style></head><body>'
      +'<div class="top"><div><h1>KENNEDY CENTER CORP.</h1><div class="sub">Catalogo de inventario<br>'+npEsc(invFiltrosTexto())+'</div></div>'
      +'<div class="rt"><b>'+lineas.length+' productos</b><span>'+fecha+'</span></div></div>'
      +'<div class="grid">'+cards+'</div>'
      +'<scr'+'ipt>(function(){var imgs=document.images,n=imgs.length,done=0,printed=false;function pr(){if(printed)return;printed=true;setTimeout(function(){window.focus();window.print();},250);}function chk(){if(done>=n)pr();}if(n===0){pr();return;}for(var i=0;i<n;i++){if(imgs[i].complete){done++;}else{imgs[i].addEventListener("load",function(){done++;chk();});imgs[i].addEventListener("error",function(){done++;chk();});}}chk();setTimeout(pr,8000);})();<\/scr'+'ipt>'
      +'</body></html>';
    w.document.open();w.document.write(html);w.document.close();w.focus();
    if(info)info.textContent=lineas.length+' productos exportados a PDF.';
  }catch(e){ if(info)info.textContent='Error: '+e.message; }
  _invBtns(true);
}
async function invExcel(colsOverride, bodyOverride){
  var cols=colsOverride||invExpCols();
  if(!cols.length){ alert('Marca al menos una caracteristica para incluir.'); return; }
  var info=document.getElementById('inv-export-info');
  if(info)info.textContent='Preparando Excel...'; _invBtns(false);
  try{
    var raw=await invExportFetch(bodyOverride);
    if(!raw.length){ if(info)info.textContent='No hay productos que coincidan con el filtro.'; _invBtns(true); return; }
    var lineas=await invEnrich(raw);
    var hayFoto=cols.some(function(c){return c.k==='foto';});
    try{
      var columns=[{label:'Descripcion',key:'__desc',width:42},{label:'Descripcion (Ingles)',key:'__desc_en',width:42}].concat(cols.map(function(c){
        return {label:c.label,key:c.k,width:(c.k==='foto'?9:(c.k==='sku'?16:12)),numFmt:(c.k==='precio'?'0.00':undefined)};
      }));
      var fecha=fmtD(hoyLocal());
      await xlsxExport({
        filename:'inventario-kennedy.xlsx',
        titulo:'KENNEDY CENTER CORP. - INVENTARIO',
        subtitulo:invFiltrosTexto()+'  -  '+fecha+'  -  '+lineas.length+' productos',
        columns:columns, rows:lineas, fotoKey:(hayFoto?'foto':null),
        fotoUrlFn:function(l){return l.foto_url||'';},
      fotoCandsFn:function(l){ return l.foto_cands || (l.foto_url?[l.foto_url]:[]); },
        fotoCandsFn:function(l){return l.foto_cands||(l.foto_url?[l.foto_url]:[]);},
        valueFn:_invXlsxVal,
        onProgress:function(d,t){ if(info&&hayFoto)info.textContent='Incrustando fotos... ('+d+'/'+t+')'; }
      });
      if(info)info.textContent=lineas.length+' productos exportados a Excel (fotos incrustadas).';
    }catch(ex){
      invExcelHTML(cols, lineas);
      if(info)info.textContent=lineas.length+' productos exportados (modo simple: '+(ex&&ex.message||'')+').';
    }
  }catch(e){ if(info)info.textContent='Error: '+(e&&e.message||e); }
  _invBtns(true);
}
function invExcelHTML(cols, lineas){
  var nc=1+cols.length, hayFoto=cols.some(function(c){return c.k==='foto';}), FH=40;
  var rows=lineas.map(function(l){
    var tds=cols.map(function(c){
      if(c.k==='foto') return '<td height="'+(FH+6)+'" width="80" style="width:80px;height:'+(FH+6)+'px;text-align:center;vertical-align:middle;mso-number-format:\'@\'">'+(l.foto_url?'<img src="'+l.foto_url+'" width="'+FH+'" height="'+FH+'" style="width:'+FH+'px;height:'+FH+'px">':'')+'</td>';
      var v;
      switch(c.k){
        case 'precio': v=(l.price||0).toFixed(2); break;
        case 'stock': v=l.stock; break;
        case 'packing': v=l.packing||''; break;
        case 'bultos': v=(l.bultos!=null?l.bultos:''); break;
        case 'peso': v=l.peso||''; break;
        case 'cubicaje': v=l.volumen||''; break;
        default: v=rptValor(l,c.k);
      }
      return '<td style="vertical-align:middle">'+npEsc(String(v))+'</td>';
    }).join('');
    var trh=hayFoto?' height="'+(FH+6)+'" style="height:'+(FH+6)+'px"':'';
    return '<tr'+trh+'><td style="vertical-align:middle">'+npEsc(l.dscription||'')+'</td><td style="vertical-align:middle">'+npEsc(l.frgnname||'')+'</td>'+tds+'</tr>';
  }).join('');
  var colgroup='<colgroup><col style="width:240px">'+cols.map(function(c){return '<col style="width:'+(c.k==='foto'?'80px':(c.k==='sku'?'110px':'70px'))+'">';}).join('')+'</colgroup>';
  var fecha=fmtD(hoyLocal());
  var html='<meta charset="utf-8"><table border="1" cellspacing="0" style="border-collapse:collapse">'+colgroup
    +'<tr><td colspan="'+nc+'" style="font-size:16px;font-weight:bold">KENNEDY CENTER CORP. - INVENTARIO</td></tr>'
    +'<tr><td colspan="'+nc+'">'+npEsc(invFiltrosTexto())+' &nbsp; Fecha: '+fecha+' &nbsp; '+lineas.length+' productos</td></tr>'
    +'<tr style="background:#e8f2ef;font-weight:bold"><th>Descripcion</th><th>Descripcion (Ingles)</th>'+cols.map(function(c){return '<th>'+npEsc(c.label)+'</th>';}).join('')+'</tr>'+rows+'</table>';
  var blob=new Blob(['\ufeff',html],{type:'application/vnd.ms-excel;charset=utf-8'});
  var url=URL.createObjectURL(blob);var a=document.createElement('a');
  a.href=url;a.download='inventario-kennedy.xls';
  document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);
}
var rsCli=null, rsDisp=[], rsPorLlegar=[], rsAll=[], rsT=null, rsSel={}, rsPgDisp=0, rsPgPL=0, rsYear='', RS_PAGE=50;
function loadRestock(){
  rsCli=null; rsDisp=[]; rsPorLlegar=[];
  var q1=document.getElementById('rs-cli-q'); if(q1)q1.value='';
  var inf=document.getElementById('rs-info'); if(inf)inf.textContent='';
  var ac=document.getElementById('rs-acciones'); if(ac)ac.style.display='none';
  var res=document.getElementById('rs-resultado'); if(res)res.innerHTML='';
  var ff=document.getElementById('rs-filtros'); if(ff)ff.style.display='none';
  rsAll=[]; rsSel={}; rsPgDisp=0; rsPgPL=0; rsYear='';
}
function rsBuscarCli(v){
  clearTimeout(rsT);
  var drop=document.getElementById('rs-cli-drop');
  if(!v||v.trim().length<2){ drop.classList.remove('show'); drop.innerHTML=''; return; }
  rsT=setTimeout(function(){
    var t=encodeURIComponent(v.trim());
    // Se busca en las dos empresas: un cliente de NAPA tambien compra y su
    // restock sale de sus propias facturas.
    Promise.all([
      q('clientes','select=cardcode,cardname&or=(cardname.ilike.*'+t+'*,cardcode.ilike.*'+t+'*)&limit=12'),
      (typeof npBuscarNapa==='function' ? npBuscarNapa(v.trim()) : Promise.resolve([]))
    ]).then(function(res){
      var napa=(res[1]||[]).map(function(c){ c.napa=true; return c; });
      var rows=napa.concat(res[0]||[]).slice(0,14);
      if(!rows.length){ drop.innerHTML='<div class="ac-searching">Sin resultados</div>'; drop.classList.add('show'); return; }
      drop.innerHTML=rows.map(function(c){
        var cc=String(c.cardcode).replace(/'/g,"\\'");
        var cn=String(c.cardname||'').replace(/'/g,"\\'");
        var et = c.napa ? '<span style="background:#7C3AED;color:#fff;padding:1px 6px;border-radius:8px;font-size:9.5px;font-weight:700;margin-left:5px">NAPA</span>' : '';
        return '<div class="ac-item" onclick="rsElegirCli(\''+cc+'\',\''+cn+'\','+(c.napa?'true':'false')+')">'
          +'<div class="ac-info"><p>'+npEsc(c.cardname||'')+et+'</p><span>'+npEsc(c.cardcode)+'</span></div></div>';
      }).join('');
      drop.classList.add('show');
    });
  },300);
}
// esNapa: el restock tiene que leer las facturas de la empresa correcta.
var RS_NAPA=false;

function rsElegirCli(cardcode,cardname,esNapa){
  RS_NAPA = !!esNapa;
  document.getElementById('rs-cli-drop').classList.remove('show');
  document.getElementById('rs-cli-q').value=cardname+' ('+cardcode+')';
  rsCargar(cardcode,cardname);
}
function rsRestaurar(cardcode,cardname){
  document.querySelectorAll('.page').forEach(function(p){p.classList.remove('active');});
  var pg=document.getElementById('page-restock'); if(pg)pg.classList.add('active');
  var pt=document.getElementById('ptitle'); if(pt)pt.innerHTML=ico('refresh',{size:19,mr:9,color:'var(--blue2)'})+'<span>Restock por cliente</span>';
  var ne=document.getElementById('nav-rst'); if(ne){document.querySelectorAll('.ni').forEach(function(n){n.classList.remove('active');});ne.classList.add('active');}
  rsCargar(cardcode,cardname);
}
async function rsCargar(cardcode,cardname){
  rsCli={cardcode:cardcode,cardname:cardname};
  VISTA_ACTUAL=function(){ rsRestaurar(cardcode,cardname); };
  rsSel={}; rsPgDisp=0; rsPgPL=0; rsYear=''; rsBultosMin=''; rsDeptoF='';
  rsPgAgo=0; rsAgotados=[];
  window._rsSug={}; window._rsSugIdx={}; window._rsSugEstado={}; window._rsSugOpen={};
  var inf=document.getElementById('rs-info'); if(inf)inf.textContent='Cargando historial de compras...';
  document.getElementById('rs-acciones').style.display='none';
  document.getElementById('rs-resultado').innerHTML='';
  try{
    // Un cliente de NAPA tiene sus facturas en facturas_napa. Sin esto el
    // restock salia vacio: consultaba la tabla de Kennedy, donde no esta.
    var _tabFac = RS_NAPA ? 'facturas_napa' : 'facturas';
    var lineas=await qAll(_tabFac,'select=docnum,docdate,itemcode,dscription,quantity,price&cardcode=eq.'+encodeURIComponent(cardcode)+'&order=docdate.desc');
    if(!lineas||!lineas.length){ if(inf)inf.textContent='Este cliente no tiene compras registradas.'; return; }
    var g={};
    lineas.forEach(function(l){
      if(!l.itemcode) return;
      var k=l.itemcode, qty=Number(l.quantity)||0;
      if(!g[k]) g[k]={itemcode:k, dscription:l.dscription, total:0, byDoc:{}};
      if(!g[k].dscription && l.dscription) g[k].dscription=l.dscription;
      g[k].total += qty;
      var dn=String(l.docnum);
      var d=g[k].byDoc[dn]; if(!d){ d={doc:l.docnum, f:l.docdate, price:Number(l.price)||0, qty:0}; g[k].byDoc[dn]=d; }
      d.qty += qty;
      if(Number(l.price)) d.price=Number(l.price);
    });
    var items=Object.keys(g), map={};
    for(var i=0;i<items.length;i+=300){
      var chunk=items.slice(i,i+300);
      var inList=chunk.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
      var rows=await q('vista_inventario','select=itemcode,disponiblebodega,disponible,onhand,onorder,foto_url,unidadesbulto,marca&itemcode=in.('+inList+')&limit='+chunk.length);
      (rows||[]).forEach(function(r){map[r.itemcode]=r;});
      // El departamento vive en 'inventario', no en la vista.
      try{
        var gr=await q('inventario','select=itemcode,grupo&itemcode=in.('+inList+')&limit='+chunk.length);
        (gr||[]).forEach(function(x){ if(map[x.itemcode]) map[x.itemcode].grupo=x.grupo; });
      }catch(e){}
    }
    rsAll=[];
    items.forEach(function(k){
      var it=g[k], inv=map[k]||{};
      var disp=Number(inv.onhand!=null?inv.onhand:(inv.disponiblebodega!=null?inv.disponiblebodega:(inv.disponible||0)));
      var llega=Number(inv.onorder||0);
      var compras=Object.keys(it.byDoc).map(function(dn){return it.byDoc[dn];});
      compras.sort(function(a,b){ return String(a.f||'').localeCompare(String(b.f||'')); });
      rsAll.push({itemcode:k, dscription:it.dscription, total:it.total, compras:compras, disp:disp, llega:llega, foto_url:inv.foto_url||'', packing:Number(inv.unidadesbulto)||0, grupo:inv.grupo||'', marca:inv.marca||''});
    });
    try{ rsLlenarDeptos(); }catch(e){}
    if(inf)inf.textContent=rsCli.cardname+' · '+rsDisp.length+' productos en stock · '+rsPorLlegar.length+' por llegar.';
    document.getElementById('rs-acciones').style.display='flex';
    var _ff=document.getElementById('rs-filtros'); if(_ff)_ff.style.display='flex';
    rsRender();
  }catch(e){ if(inf)inf.textContent='Error: '+e.message; }
}
function rsLimpiarFechas(){ var b=document.getElementById('rs-hasta'); if(b)b.value=''; rsRender(); }
function rsRender(){
  var box=document.getElementById('rs-resultado'); if(!box) return;
  // Filtro por AÑO de la ÚLTIMA compra. Cada producto cuenta solo por su última compra.
  function _dk(v){
    if(!v) return null;
    var t=String(v).trim();
    var m=t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if(m) return (+m[1])*10000+(+m[2])*100+(+m[3]);
    m=t.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
    if(m) return (+m[3])*10000+(+m[2])*100+(+m[1]);
    var d2=new Date(t); if(!isNaN(d2.getTime())) return d2.getFullYear()*10000+(d2.getMonth()+1)*100+d2.getDate();
    return null;
  }
  function _yr(f){ var k=_dk(f); return k?Math.floor(k/10000):null; }
  // Una fila por producto, usando SIEMPRE su última compra absoluta
  var rows=[];
  (rsAll||[]).forEach(function(r){
    var compras=r.compras||[]; if(!compras.length) return;
    var last=compras[compras.length-1];
    // grupo y marca tienen que viajar hasta aqui: el filtro trabaja sobre
    // estas filas, no sobre rsAll. Sin copiarlos llegaban vacios y el filtro
    // descartaba TODO, aunque en rsAll estuvieran bien.
    rows.push({itemcode:r.itemcode, dscription:r.dscription, total:r.total, ultDoc:last.doc, ultFecha:last.f, ultPrecio:last.price, ultCant:last.qty, disp:r.disp, llega:r.llega, foto_url:r.foto_url, packing:r.packing, grupo:r.grupo||'', marca:r.marca||''});
  });
  // Años disponibles (según la última compra de los productos con stock)
  var yset={};
  rows.forEach(function(r){ if(r.disp>0||r.llega>0){ var y=_yr(r.ultFecha); if(y) yset[y]=1; } });
  var rsYears=Object.keys(yset).map(Number).sort(function(a,b){return b-a;});
  // Filtrar por el año elegido = año de la última compra
  var disp=[], pll=[], ago=[];
  rows.forEach(function(r){
    if(rsYear && String(_yr(r.ultFecha))!==String(rsYear)) return;
    var _pk=Math.max(1,Number(r.packing)||1);
    // Filtro por bultos disponibles: solo afecta a lo que SI tiene stock.
    if(rsBultosMin!=='' && r.disp>=_pk && rsBultos(r) < rsBultosMin) return;
    if(rsDeptoF && String(r.grupo||'')!==rsDeptoF) return;
    if(rsMarcaF && String(r.marca||'')!==rsMarcaF) return;
    if(r.disp>=_pk) disp.push(r);
    else if(r.llega>0) pll.push(r);
    else ago.push(r); // agotado y sin pedido futuro: candidato a sustituto
  });
  // De mayor a menor cantidad comprada: lo que mas se le vende va primero,
  // que es lo que hay que reponer. A igualdad, lo mas reciente.
  var _byCant=function(a,b){
    var d=(Number(b.total)||0)-(Number(a.total)||0);
    return d!==0 ? d : String(b.ultFecha||'').localeCompare(String(a.ultFecha||''));
  };
  disp.sort(_byCant); pll.sort(_byCant); ago.sort(_byCant);
  rsDisp=disp; rsPorLlegar=pll; rsAgotados=ago;
  var _inf=document.getElementById('rs-info');
  if(_inf && rsCli){ _inf.textContent=rsCli.cardname+' \u2014 '+rsDisp.length+' en stock \u00b7 '+rsPorLlegar.length+' por llegar'+(rsYear?' \u00b7 a\u00f1o '+rsYear:'')+(rsBultosMin!==''?' \u00b7 '+rsBultosMin+'+ bultos':''); }

  // Selector de departamento, encima de las tres secciones: filtra las tres
  // a la vez, a diferencia de los de ano y bultos que van en la cabecera de
  // su columna.
  // Departamento y marca: filtran las tres secciones a la vez, a diferencia
  // de los de ano y bultos, que van en la cabecera de su columna.
  function deptoBar(){
    function opciones(campo, sel){
      var c={};
      (rsAll||[]).forEach(function(r){ var v=r[campo]||''; if(v) c[v]=(c[v]||0)+1; });
      var l=Object.keys(c).sort();
      return { lista:l, cuenta:c };
    }
    var dep=opciones('grupo'), mar=opciones('marca');
    if(!dep.lista.length && !mar.lista.length) return '';

    function selector(id, fn, etiqueta, o, actual){
      if(!o.lista.length) return '';
      return '<div><label style="font-size:11.5px;color:var(--text3);display:block;margin-bottom:3px">'+etiqueta+'</label>'
        +'<select id="'+id+'" onchange="'+fn+'(this.value)" '
        +'style="padding:7px 11px;border:1px solid var(--border);border-radius:9px;font-size:13px;background:#fff;min-width:210px;max-width:280px">'
        +'<option value="">Todas</option>'
        + o.lista.map(function(g){
            return '<option value="'+npEsc(g)+'"'+(g===actual?' selected':'')+'>'
              +npEsc(g)+' ('+o.cuenta[g]+')</option>';
          }).join('')
        +'</select></div>';
    }

    return '<div style="display:flex;align-items:flex-end;gap:10px;margin-bottom:12px;flex-wrap:wrap">'
      + selector('rs-depto','rsDepto','Departamento', dep, rsDeptoF)
      + selector('rs-marca','rsMarca','Marca',        mar, rsMarcaF)
      + ((rsDeptoF||rsMarcaF)
          ? '<button class="btn btn-sm" onclick="rsQuitarFiltros()">Quitar filtros</button>' : '')
      + '</div>';
  }


  function ufHeader(){
    var opts='<option value="">Todos los años</option>'+rsYears.map(function(y){ return '<option value="'+y+'"'+(String(rsYear)===String(y)?' selected':'')+'>'+y+'</option>'; }).join('');
    return '<div style="margin-top:5px;font-weight:400"><select onchange="rsYearSet(this.value)" style="font-size:11px;padding:3px 6px;border:1px solid var(--border);border-radius:5px;background:#fff">'+opts+'</select></div>';
  }
  // Selector de bultos minimos, en la cabecera de la columna Stock.
  function bfHeader(){
    var ops=[['','Todos'],['1','1+ bulto'],['2','2+'],['3','3+'],['5','5+'],['10','10+'],['20','20+'],['50','50+']];
    var o=ops.map(function(p){
      return '<option value="'+p[0]+'"'+(String(rsBultosMin)===String(p[0])?' selected':'')+'>'+p[1]+'</option>';
    }).join('');
    return '<div style="margin-top:5px;font-weight:400"><select title="Bultos disponibles" onchange="rsBultosSet(this.value)" style="font-size:11px;padding:3px 6px;border:1px solid var(--border);border-radius:5px;background:#fff">'+o+'</select></div>';
  }
  function tabla(titulo,arr,esLlegar,pg,sec,conFiltro){
    if(!arr.length && !conFiltro) return '';
    var tot=Math.max(1,Math.ceil(arr.length/RS_PAGE)); if(pg>=tot)pg=tot-1; if(pg<0)pg=0;
    var page=arr.slice(pg*RS_PAGE, pg*RS_PAGE+RS_PAGE);
    var th='<tr><th style="width:26px"></th><th>Foto</th><th>SKU</th><th>Descripci\u00f3n</th><th style="text-align:right">Total hist\u00f3rico</th><th style="text-align:right">Stock actual</th><th style="text-align:right">Bultos'+(conFiltro?bfHeader():'')+'</th>'+(esLlegar?'<th style="text-align:right">Por llegar</th>':'')+'<th>\u00daltima compra'+(conFiltro?ufHeader():'')+'</th><th style="text-align:right">Cant. \u00falt. compra</th><th style="text-align:right">\u00dalt. precio</th></tr>';
    var body=page.length?page.map(function(r){
      var code=npEsc(String(r.itemcode));
      return '<tr><td style="text-align:center"><input type="checkbox" class="rs-chk" data-code="'+code+'"'+(rsSel[r.itemcode]?' checked':'')+' onchange="rsSelToggle(this.getAttribute(\'data-code\'),this.checked)"></td>'
        +'<td>'+npFotoCell(r.itemcode,38)+'</td>'
        +'<td style="font-weight:600;color:var(--blue2);cursor:pointer" onclick="verItem(\''+String(r.itemcode).replace(/'/g,"\\'")+'\')"><u>'+npEsc(r.itemcode)+'</u></td>'
        +'<td>'+npEsc(r.dscription||'')+'</td>'
        +'<td style="text-align:right;font-weight:700">'+fmtN(r.total)+'</td>'
        +'<td style="text-align:right;font-weight:600;color:'+(r.disp>0?'var(--green)':'var(--red)')+'">'+fmtN(r.disp)+'</td>'
        +'<td style="text-align:right;font-weight:600">'+fmtN(rsBultos(r))+'</td>'
        +(esLlegar?'<td style="text-align:right;color:var(--amber);font-weight:700">'+fmtN(r.llega)+'</td>':'')
        +'<td>#'+npEsc(String(r.ultDoc))+' \u00b7 '+fmtD(r.ultFecha)+'</td>'
        +'<td style="text-align:right;font-weight:600">'+fmtN(r.ultCant)+'</td>'
        +'<td style="text-align:right">'+fmt(r.ultPrecio)+'</td></tr>';
    }).join(''):'<tr><td colspan="'+(esLlegar?11:10)+'" style="text-align:center;color:#888;padding:18px">Sin productos para este filtro.</td></tr>';
    var nav=(tot>1)?('<div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;font-size:13px"><span style="color:var(--text3)">'+arr.length+' productos \u00b7 p\u00e1gina '+(pg+1)+' de '+tot+'</span><span style="display:flex;gap:6px"><button class="btn btn-sm" '+(pg<=0?'disabled':'')+' onclick="rsPag(\''+sec+'\',-1)">\u2039 Anterior</button><button class="btn btn-sm" '+(pg>=tot-1?'disabled':'')+' onclick="rsPag(\''+sec+'\',1)">Siguiente \u203a</button></span></div>'):'';
    var accs='<span style="display:flex;gap:6px;flex-shrink:0">'
      +'<button class="btn btn-sm"'+(arr.length?'':' disabled')+' onclick="rsMarcarLista(\''+sec+'\',true)">Marcar todo'+(arr.length?(' ('+arr.length+')'):'')+'</button>'
      +'<button class="btn btn-sm"'+(arr.length?'':' disabled')+' onclick="rsMarcarLista(\''+sec+'\',false)">Quitar</button></span>';
    return '<div class="card" style="margin-top:14px"><div class="ch" style="margin-bottom:10px"><span class="ct">'+titulo+'</span>'+accs+'</div><div style="overflow-x:auto"><table class="tbl">'+th+body+'</table></div>'+nav+'</div>';
  }
  // Tabla de agotados: una fila por producto que ya compraba y hoy no hay,
  // con sus sugeridos desplegables debajo.
  function tablaAgotados(){
    var arr=rsAgotados||[];
    if(!arr.length) return '';
    var tot=Math.max(1,Math.ceil(arr.length/RS_PAGE)); var pg=rsPgAgo; if(pg>=tot)pg=tot-1; if(pg<0)pg=0;
    var page=arr.slice(pg*RS_PAGE, pg*RS_PAGE+RS_PAGE);
    var th='<tr><th>Foto</th><th>SKU que compraba</th><th>Descripci\u00f3n</th><th style="text-align:right">Total hist\u00f3rico</th><th>\u00daltima compra</th><th style="text-align:right">Cant. \u00falt.</th><th style="text-align:right">\u00dalt. precio</th><th style="width:150px"></th></tr>';
    var body=page.map(function(r){
      var code=String(r.itemcode);
      var codeJs=code.replace(/'/g,"\\'");
      var st=(window._rsSugEstado||{})[code]||'';
      var abierto=!!(window._rsSugOpen||{})[code];
      var btn = st==='cargando'
        ? '<button class="btn btn-sm" disabled>Buscando\u2026</button>'
        : '<button class="btn btn-sm btn-p" onclick="rsSugerir(\''+codeJs+'\')">'+(abierto?'Ocultar':(st==='listo'?'Ver sugeridos':'\u2728 20 sugeridos'))+'</button>';
      return '<tr>'
        +'<td>'+npFotoCell(r.itemcode,38)+'</td>'
        +'<td style="font-weight:600;color:var(--blue2);cursor:pointer" onclick="verItem(\''+codeJs+'\')"><u>'+npEsc(code)+'</u></td>'
        +'<td>'+npEsc(r.dscription||'')+'</td>'
        +'<td style="text-align:right;font-weight:700">'+fmtN(r.total)+'</td>'
        +'<td>#'+npEsc(String(r.ultDoc))+' \u00b7 '+fmtD(r.ultFecha)+'</td>'
        +'<td style="text-align:right;font-weight:600">'+fmtN(r.ultCant)+'</td>'
        +'<td style="text-align:right">'+fmt(r.ultPrecio)+'</td>'
        +'<td style="text-align:right">'+btn+'</td>'
        +'</tr>'
        +'<tr id="rs-sug-'+npEsc(code)+'"><td colspan="8" style="padding:0;border:0"></td></tr>';
    }).join('');
    var nav=(tot>1)?('<div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;font-size:13px"><span style="color:var(--text3)">'+arr.length+' productos \u00b7 p\u00e1gina '+(pg+1)+' de '+tot+'</span><span style="display:flex;gap:6px"><button class="btn btn-sm" '+(pg<=0?'disabled':'')+' onclick="rsPag(\'ago\',-1)">\u2039 Anterior</button><button class="btn btn-sm" '+(pg>=tot-1?'disabled':'')+' onclick="rsPag(\'ago\',1)">Siguiente \u203a</button></span></div>'):'';
    var nSug=0; Object.keys(window._rsSug||{}).forEach(function(k){ nSug+=(window._rsSug[k]||[]).length; });
    var accsA='<span style="display:flex;gap:6px;flex-shrink:0">'
      +'<button class="btn btn-sm"'+(nSug?'':' disabled')+' title="Marca los sugeridos que ya hayas desplegado" onclick="rsMarcarLista(\'sug\',true)">Marcar todo'+(nSug?(' ('+nSug+')'):'')+'</button>'
      +'<button class="btn btn-sm"'+(nSug?'':' disabled')+' onclick="rsMarcarLista(\'sug\',false)">Quitar</button></span>';
    return '<div class="card" style="margin-top:14px">'
      +'<div class="ch" style="margin-bottom:4px"><span class="ct">Agotados \u2014 sugeridos para reemplazar \u00b7 '+arr.length+'</span>'+accsA+'</div>'
      +'<div style="font-size:11.5px;color:var(--text3);margin-bottom:10px">Productos que este cliente ya compraba, hoy sin stock y sin pedido futuro. Pulsa <b>20 sugeridos</b> para que la IA proponga reemplazos disponibles.</div>'
      +'<div style="overflow-x:auto"><table class="tbl">'+th+body+'</table></div>'+nav+'</div>';
  }

  // Sembrar cache con la foto_url que ya trae el restock; cargar las que falten.
  (rsDisp.concat(rsPorLlegar).concat(rsAgotados)).forEach(function(r){
    if(r.itemcode && r.foto_url && !(NP_FOTO_CACHE[r.itemcode]&&NP_FOTO_CACHE[r.itemcode].fu)){
      NP_FOTO_CACHE[r.itemcode]={pn:(NP_FOTO_CACHE[r.itemcode]||{}).pn||'',fu:r.foto_url};
    }
  });
  npCargarFotos((rsDisp.concat(rsPorLlegar).concat(rsAgotados)).map(function(r){return r.itemcode;}), rsRender);
  var hay=rsDisp.length||rsPorLlegar.length||rsAgotados.length;
  var btn=hay?'<div style="display:flex;justify-content:flex-end;margin-top:14px"><button class="btn btn-p" onclick="rsRestockSeleccion()">Restock seleccionados \u2192 Nuevo pedido</button></div>':'';
  box.innerHTML=deptoBar()
    + btn
    + tabla('Productos que ya compra (en stock) \u00b7 '+rsDisp.length, rsDisp, false, rsPgDisp, 'disp', true)
    + tabla('Agotados pero por llegar (pedido futuro) \u00b7 '+rsPorLlegar.length, rsPorLlegar, true, rsPgPL, 'pl', false)
    + tablaAgotados()
    + btn;
  // Repintar los sugeridos que ya estaban abiertos (el innerHTML los borro).
  Object.keys(window._rsSug||{}).forEach(function(c){ rsSugPintar(c); });
}
function rsYearSet(v){ rsYear=v||''; rsPgDisp=0; rsPgPL=0; rsRender(); }

// ── Filtro por bultos disponibles ──────────────────────────────────────────
// Bultos = stock actual / unidades por bulto. Un producto con 40 unidades y
// empaque de 12 tiene 3 bultos completos (el resto suelto no se cuenta).
var rsBultosMin = '';

// ── Filtros de departamento y marca del restock ────────────────────────────
// Van arriba, sobre las tres secciones, y filtran las tres a la vez.
var rsDeptoF = '', rsMarcaF = '';

function rsDepto(v){ rsDeptoF=v||''; rsPgDisp=0; rsPgPL=0; rsPgAgo=0; rsRender(); }
function rsMarca(v){ rsMarcaF=v||''; rsPgDisp=0; rsPgPL=0; rsPgAgo=0; rsRender(); }
function rsQuitarFiltros(){ rsDeptoF=''; rsMarcaF=''; rsPgDisp=0; rsPgPL=0; rsPgAgo=0; rsRender(); }
function rsBultos(r){
  var pk = Math.max(1, Number(r.packing)||1);
  return Math.floor((Number(r.disp)||0) / pk);
}
function rsBultosSet(v){
  rsBultosMin = (v===''||v==null) ? '' : Number(v);
  rsPgDisp=0; rsPgPL=0; rsPgAgo=0;
  rsRender();
}
function rsPag(sec,delta){ if(sec==='disp') rsPgDisp=Math.max(0,rsPgDisp+delta); else if(sec==='ago') rsPgAgo=Math.max(0,rsPgAgo+delta); else rsPgPL=Math.max(0,rsPgPL+delta); rsRender(); var _r=document.getElementById('rs-resultado'); if(_r&&_r.scrollIntoView) _r.scrollIntoView({behavior:'smooth',block:'start'}); }
function rsSelToggle(code,on){ if(on) rsSel[code]=1; else delete rsSel[code]; }

// Marca o quita de golpe una lista entera del reporte de restock.
//   'disp' = productos en stock   'pl' = por llegar
//   'sug'  = los sugeridos de los paneles que esten desplegados
function rsMarcarLista(sec, on){
  var codes=[];
  if(sec==='disp')      codes=(rsDisp||[]).map(function(r){return r.itemcode;});
  else if(sec==='pl')   codes=(rsPorLlegar||[]).map(function(r){return r.itemcode;});
  else if(sec==='sug'){
    Object.keys(window._rsSug||{}).forEach(function(k){
      (window._rsSug[k]||[]).forEach(function(s){ codes.push(s.itemcode); });
    });
  }
  codes.forEach(function(c){ if(on) rsSel[c]=1; else delete rsSel[c]; });
  rsRender();
}

// ════════════════════════════════════════════════════════════════════
//  SUGERIDOS PARA AGOTADOS  (preseleccion local + ranking con IA)
//
//  Por que en dos pasos: mandarle a la IA cientos de productos seria
//  lento y caro. Primero se filtra y puntua localmente (familia, marca,
//  precio, palabras de la descripcion, rotacion, stock), y a la IA solo
//  le llegan los ~60 mejores para que haga el juicio fino y explique
//  por que cada uno sustituye al agotado.
// ════════════════════════════════════════════════════════════════════
var rsPgAgo=0, rsAgotados=[];
window._rsSug=window._rsSug||{};        // itemcode agotado -> [sugeridos]
window._rsSugIdx=window._rsSugIdx||{};  // itemcode sugerido -> datos p/ restock
window._rsSugEstado=window._rsSugEstado||{};
// Que paneles estan desplegados. Vive aqui y NO en un atributo del DOM,
// porque rsRender reemplaza el HTML entero y el atributo se perderia en
// cada repintado (paginar, filtrar por ano, marcar todo...).
window._rsSugOpen=window._rsSugOpen||{};

function _rsTokens(s){
  return String(s||'').toLowerCase()
    .replace(/[^a-z0-9\u00e0-\u00fc\s]/g,' ')
    .split(/\s+/).filter(function(w){ return w.length>2; });
}

// Deja solo los candidatos que tienen AL MENOS UN BULTO COMPLETO en stock y
// les calcula cuantos bultos hay. Ofrecer menos de un bulto no sirve: no se
// puede despachar suelto.
function _rsConBulto(arr, excluir){
  return (arr||[]).filter(function(c){
    if(String(c.itemcode)===String(excluir)) return false;
    var pk=Math.max(1, Number(c.unidadesbulto)||1);
    var oh=Number(c.onhand)||0;
    c._pk=pk;
    c._bultos=Math.floor(oh/pk);
    return c._bultos>=1;
  });
}

// Puntuacion local 0..1 para preseleccionar candidatos.
function _rsScoreLocal(t, c){
  // 1) Parecido de descripcion: la senal mas fiable
  var simDesc=0;
  var a=_rsTokens(t.dscription), b=_rsTokens(c.itemname);
  if(a.length && b.length){
    var setB={}; b.forEach(function(w){setB[w]=1;});
    var comunes=a.filter(function(w){return setB[w];}).length;
    simDesc = comunes / Math.max(a.length, b.length);
  }
  var mismaFam = (t.subg && c.subg && String(t.subg).toLowerCase()===String(c.subg).toLowerCase()) ? 1 : 0;
  var mismaMarca = (t.marca && c.marca && String(t.marca).toLowerCase()===String(c.marca).toLowerCase()) ? 1 : 0;

  // 2) Rango de precio: ETIQUETA contra ETIQUETA (el precio de lista del
  //    agotado frente al de lista del candidato). Comparar contra lo que el
  //    cliente pago mezclaria descuentos puntuales con el precio real.
  var simPrecio=0;
  var p0=Number(t.precioEtiq)||0, p1=Number(c.precioventa)||0;
  if(p0>0 && p1>0) simPrecio = Math.max(0, 1-Math.min(1, Math.abs(p1-p0)/p0));

  var s = 0.42*simDesc + 0.22*simPrecio + 0.12*mismaMarca + 0.10*mismaFam;

  // 3) Rotacion y BULTOS disponibles son DESEMPATES, no meritos propios: se
  //    multiplican por la relevancia. Sin esto, un producto muy vendido pero
  //    sin relacion (una cortina frente a una alfombra) se colaba por encima
  //    de sustitutos reales. Mientras mas bultos, mejor.
  var relev = Math.max(simDesc, mismaFam*0.6);
  var bultos = Number(c._bultos)||0;
  s += relev * (0.09*Math.min(1,(Number(c._rot)||0)/500) + 0.07*Math.min(1, bultos/25));
  return s;
}

// Rotacion = unidades facturadas de cada candidato en los ultimos 12 meses.
async function _rsRotacion(codes){
  var rot={};
  try{
    var d=new Date(); d.setMonth(d.getMonth()-12);
    var desde=hoyLocal(d);
    var inList=codes.slice(0,120).map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
    var f=await q('facturas','select=itemcode,quantity&itemcode=in.('+inList+')&docdate=gte.'+desde+'&limit=5000');
    (f||[]).forEach(function(l){ rot[l.itemcode]=(rot[l.itemcode]||0)+(Number(l.quantity)||0); });
  }catch(e){}
  return rot;
}

async function rsSugerir(code){
  var box=document.getElementById('rs-sug-'+code);
  if(window._rsSug[code]){ // ya estaban: alternar
    if(window._rsSugOpen[code]) rsSugCerrar(code);
    else rsSugPintar(code, true);
    return;
  }
  window._rsSugEstado[code]='cargando';
  if(box) box.querySelector('td').innerHTML='<div style="padding:12px;color:var(--blue2);font-size:12.5px">\ud83e\udd16 Buscando reemplazos parecidos\u2026</div>';

  try{
    var t=(rsAgotados||[]).find(function(x){return String(x.itemcode)===String(code);});
    if(!t) throw new Error('No se encontro el producto agotado');

    // 1) Datos del agotado (familia, marca, caracteristicas)
    var meta=await q('vista_inventario','select=itemcode,itemname,subg,marca,caracteristicas,precioventa&itemcode=eq.'+encodeURIComponent(code)+'&limit=1');
    var m=(meta&&meta[0])||{};
    t.subg=m.subg||''; t.marca=m.marca||''; t.caract=m.caracteristicas||'';
    // La comparacion de precio se hace ETIQUETA contra ETIQUETA: el precio que
    // el cliente pago alguna vez pudo llevar descuento y distorsionaria el
    // parecido. El ultimo precio pagado se sigue mostrando en la tabla, pero
    // no interviene en el ranking.
    t.precioEtiq=Number(m.precioventa)||0;

    // 2) Candidatos: primero la misma familia; si quedan pocos, se abre a la
    //    marca y por ultimo a palabras de la descripcion. Se exige SIEMPRE al
    //    menos un bulto completo (ver _rsConBulto).
    var campos='itemcode,itemname,subg,marca,caracteristicas,precioventa,onhand,disponible,unidadesbulto,foto_url';
    var cands=[], vistos={};
    function _sumar(arr){
      _rsConBulto(arr, code).forEach(function(c){
        if(!vistos[c.itemcode]){ vistos[c.itemcode]=1; cands.push(c); }
      });
    }
    if(t.subg){
      _sumar(await q('vista_inventario','select='+campos+'&subg=eq.'+encodeURIComponent(t.subg)+'&onhand=gt.0&order=onhand.desc&limit=300'));
    }
    if(cands.length<25 && t.marca){
      _sumar(await q('vista_inventario','select='+campos+'&marca=eq.'+encodeURIComponent(t.marca)+'&onhand=gt.0&order=onhand.desc&limit=200'));
    }
    if(cands.length<25){
      var pal=_rsTokens(t.dscription)[0];
      if(pal) _sumar(await q('vista_inventario','select='+campos+'&itemname=ilike.*'+encodeURIComponent(pal)+'*&onhand=gt.0&order=onhand.desc&limit=200'));
    }
    if(!cands.length) throw new Error('No hay productos con al menos 1 bulto completo parecidos a este');

    // 3) Rotacion y preseleccion local
    var rot=await _rsRotacion(cands.map(function(c){return c.itemcode;}));
    cands.forEach(function(c){ c._rot=rot[c.itemcode]||0; c._sc=_rsScoreLocal(t,c); });
    cands.sort(function(a,b){ return b._sc-a._sc; });
    var corto=cands.slice(0,60);

    // 4) La IA elige y ordena los 20 finales
    var sug=await _rsSugIA(t, corto);
    if(!sug.length) sug=corto.slice(0,20).map(function(c){ return {sku:c.itemcode, razon:'Misma familia y rango de precio.'}; });

    var idx={}; corto.forEach(function(c){ idx[String(c.itemcode)]=c; });
    var finales=[];
    sug.forEach(function(s){
      var c=idx[String(s.sku)]; if(!c) return;
      finales.push({ itemcode:c.itemcode, itemname:c.itemname, precio:Number(c.precioventa)||0,
                     onhand:Number(c.onhand)||0, packing:Number(c._pk)||0,
                     bultos:Number(c._bultos)||0,
                     marca:c.marca||'', subg:c.subg||'', rot:c._rot||0,
                     foto_url:c.foto_url||'', razon:s.razon||'' });
      window._rsSugIdx[String(c.itemcode)]={ itemcode:c.itemcode, dscription:c.itemname,
                     ultPrecio:Number(c.precioventa)||0, disp:Number(c.onhand)||0,
                     packing:Number(c.unidadesbulto)||0 };
    });
    window._rsSug[code]=finales.slice(0,20);
    window._rsSugEstado[code]='listo';
    // Fotos de los sugeridos
    finales.forEach(function(r){
      if(r.itemcode && r.foto_url && !(NP_FOTO_CACHE[r.itemcode]&&NP_FOTO_CACHE[r.itemcode].fu)){
        NP_FOTO_CACHE[r.itemcode]={pn:(NP_FOTO_CACHE[r.itemcode]||{}).pn||'',fu:r.foto_url};
      }
    });
    npCargarFotos(finales.map(function(r){return r.itemcode;}), function(){ rsSugPintar(code); });
    rsSugPintar(code, true);
  }catch(e){
    window._rsSugEstado[code]='';
    if(box) box.querySelector('td').innerHTML='<div style="padding:12px;color:var(--red);font-size:12.5px">No se pudieron generar sugerencias: '+npEsc(e.message||String(e))+'</div>';
  }
}

// Llamada a la IA: recibe el agotado + candidatos y devuelve 20 SKUs con motivo.
async function _rsSugIA(t, cands){
  var lista=cands.map(function(c){
    return [c.itemcode, String(c.itemname||'').slice(0,70), (Number(c.precioventa)||0).toFixed(2),
            String(c.marca||'').slice(0,20), String(c.subg||'').slice(0,25),
            'bultos:'+(Number(c._bultos)||0), 'stock:'+(Number(c.onhand)||0),
            'rot12m:'+(Number(c._rot)||0),
            String(c.caracteristicas||'').slice(0,50)].join(' | ');
  }).join('\n');

  var sistema='Eres comprador experto de un mayorista de articulos de hogar y ferreteria. '
    +'Te doy un producto AGOTADO que un cliente compraba y una lista de productos CON STOCK. '
    +'Elige hasta 20 que sirvan de reemplazo, del mejor al peor. Criterios, en orden: '
    +'(1) que cumpla la misma funcion segun la descripcion; (2) misma familia; '
    +'(3) precio de etiqueta en un rango cercano al precio de etiqueta del agotado; '
    +'(4) misma marca o calidad similar; '
    +'(5) color y tamano parecidos si se deducen; '
    +'(6) mayor rotacion y MAS BULTOS disponibles (todos tienen al menos 1 bulto completo). '
    +'No inventes SKUs: usa solo los de la lista. '
    +'Responde UNICAMENTE un array JSON: [{"sku":"...","razon":"motivo breve en espanol, max 12 palabras"}]';

  var usuario='PRODUCTO AGOTADO:\n'
    +'SKU: '+t.itemcode+'\nDescripcion: '+(t.dscription||'')+'\n'
    +'Precio de etiqueta: '+(Number(t.precioEtiq)||0).toFixed(2)+'\n'
    +'Familia: '+(t.subg||'?')+'\nMarca: '+(t.marca||'?')+'\n'
    +'Caracteristicas: '+(t.caract||'?')+'\n\n'
    +'CANDIDATOS (sku | descripcion | precio etiqueta | marca | familia | bultos disponibles | unidades | rotacion 12m | caracteristicas):\n'+lista;

  var arr = await iaLlamar('reemplazos', usuario);
  return Array.isArray(arr)?arr:[];
}

// Pinta la fila desplegable con los 20 sugeridos.
function rsSugPintar(code, abrir){
  var tr=document.getElementById('rs-sug-'+code); if(!tr) return;
  var td=tr.querySelector('td'); if(!td) return;
  var sug=window._rsSug[code]||[];
  if(!sug.length){ td.innerHTML=''; return; }
  if(abrir) window._rsSugOpen[code]=true;
  if(!window._rsSugOpen[code]){ td.innerHTML=''; return; }

  var filas=sug.map(function(r,i){
    var c=npEsc(String(r.itemcode));
    var cJs=String(r.itemcode).replace(/'/g,"\\'");
    var bultos=Number(r.bultos)||(r.packing>0?Math.floor(r.onhand/r.packing):0);
    return '<tr>'
      +'<td style="text-align:center"><input type="checkbox" class="rs-chk" data-code="'+c+'"'+(rsSel[r.itemcode]?' checked':'')+' onchange="rsSelToggle(this.getAttribute(\'data-code\'),this.checked)"></td>'
      +'<td style="color:var(--text3);font-size:11px">'+(i+1)+'</td>'
      +'<td>'+npFotoCell(r.itemcode,34)+'</td>'
      +'<td style="font-weight:600;color:var(--blue2);cursor:pointer" onclick="verItem(\''+cJs+'\')"><u>'+c+'</u></td>'
      +'<td>'+npEsc(r.itemname||'')+'<div style="font-size:10.5px;color:var(--text3);margin-top:1px">'+npEsc(r.razon||'')+'</div></td>'
      +'<td style="font-size:11px;color:var(--text3)">'+npEsc(r.marca||'')+'</td>'
      +'<td style="text-align:right">'+fmt(r.precio)+'</td>'
      +'<td style="text-align:right;color:var(--green);font-weight:700">'+fmtN(bultos)+' <span style="font-size:10px;font-weight:400">bultos</span>'
        +'<div style="font-size:10px;color:var(--text3);font-weight:400">'+fmtN(r.onhand)+' uds \u00b7 '+fmtN(r.packing)+' x bulto</div></td>'
      +'<td style="text-align:right;font-size:11px;color:var(--text3)">'+fmtN(r.rot)+'</td>'
      +'</tr>';
  }).join('');

  td.innerHTML='<div style="background:var(--bg2,#f7f8fa);border-left:3px solid var(--blue2);padding:10px 12px;margin:2px 0 8px">'
    +'<div style="font-size:12px;font-weight:600;margin-bottom:7px">\u2728 Sugeridos para reemplazar <b>'+npEsc(code)+'</b> <span style="font-weight:400;color:var(--text3)">\u00b7 '+sug.length+' opciones con 1 bulto o m\u00e1s</span>'
      +' <button class="btn btn-sm" style="margin-left:8px" onclick="rsSugCerrar(\''+String(code).replace(/'/g,"\\'")+'\')">Ocultar</button></div>'
    +'<div style="overflow-x:auto"><table class="tbl" style="font-size:12px">'
    +'<tr><th style="width:26px"></th><th style="width:24px">#</th><th>Foto</th><th>SKU</th><th>Descripci\u00f3n / por qu\u00e9</th><th>Marca</th><th style="text-align:right">Precio etiqueta</th><th style="text-align:right">Bultos disp.</th><th style="text-align:right">Rot. 12m</th></tr>'
    +filas+'</table></div></div>';
}

function rsSugCerrar(code){
  var tr=document.getElementById('rs-sug-'+code);
  window._rsSugOpen[code]=false;
  if(tr){ var td=tr.querySelector('td'); if(td) td.innerHTML=''; }
}
function rsRestockSeleccion(){
  var codes=Object.keys(rsSel||{});
  if(!codes.length){ alert('Marca al menos un producto (con el check) para hacer restock.'); return; }
  var sel=[];
  codes.forEach(function(code){
    var src=(rsAll||[]).find(function(x){return String(x.itemcode)===String(code);});
    if(src){
      var compras=src.compras||[]; var last=compras.length?compras[compras.length-1]:{};
      sel.push({itemcode:src.itemcode, dscription:src.dscription, ultPrecio:Number(last.price)||0, disp:src.disp, packing:src.packing});
      return;
    }
    // Los sugeridos no estan en rsAll (el cliente nunca los compro): van aparte.
    var sg=(window._rsSugIdx||{})[String(code)];
    if(sg) sel.push({itemcode:sg.itemcode, dscription:sg.dscription, ultPrecio:sg.ultPrecio, disp:sg.disp, packing:sg.packing});
  });
  if(!sel.length){ alert('No se pudieron leer los productos seleccionados.'); return; }
  npLineas=sel.map(function(r){
    var b=Math.max(1,Number(r.packing)||1);
    return {itemcode:r.itemcode, itemname:r.dscription||r.itemcode, quantity:b, price:Number(r.ultPrecio)||0, discount:0, whscode:'', bulto:b, note:'', stockActual:Number(r.disp)||0};
  });
  if(rsCli){
    npCli={cardcode:rsCli.cardcode,cardname:rsCli.cardname||rsCli.cardcode};
    var inp=document.getElementById('np-cli-q');if(inp)inp.style.display='none';
    var s=document.getElementById('np-cli-sel');
    if(s){s.style.display='block';
      var nm=document.getElementById('np-cli-name');if(nm)nm.textContent=npCli.cardname;
      var mt=document.getElementById('np-cli-meta');if(mt)mt.textContent=npCli.cardcode;
      var av=document.getElementById('np-cli-av');if(av)av.textContent=(npCli.cardname||'?').slice(0,2).toUpperCase();
    }
    var b2=document.getElementById('np-btn2');if(b2)b2.disabled=false;
  }
  go('nuevo_pedido',document.getElementById('nav-np'));
  // Dejar camino de regreso al reporte (conservandolo) y mostrar el boton
  NAVSTACK=[mostrarRestock];
  var br=document.getElementById('np-back-restock'); if(br)br.style.display='block';
  var faltantes=npLineas.filter(function(l){return l.stockActual!=null && l.stockActual < l.quantity;});
  setTimeout(function(){npIr(3);npRenderLineas();if(faltantes.length)npAvisoStock(faltantes);},120);
}
function mostrarRestock(){
  document.querySelectorAll('.page').forEach(function(p){p.classList.remove('active');});
  var pg=document.getElementById('page-restock'); if(pg)pg.classList.add('active');
  var t=document.getElementById('ptitle'); if(t)t.innerHTML=ico('refresh',{size:19,mr:9,color:'var(--blue2)'})+'<span>'+(TITLES['restock']||'Restock')+'</span>';
  document.querySelectorAll('.ni').forEach(function(n){n.classList.remove('active');});
  var br=document.getElementById('np-back-restock'); if(br)br.style.display='none';
}
function rsFilasPdf(arr,esLlegar){
  return arr.map(function(r,i){
    return '<tr><td class="r">'+(i+1)+'</td><td>'+(r.foto_url?'<img src="'+r.foto_url+'" style="width:40px;height:40px;object-fit:contain">':'')+'</td><td>'+npEsc(r.itemcode)+'</td><td>'+npEsc(r.dscription||'')+'</td><td class="r">'+fmtN(r.total)+'</td><td class="r">'+fmtN(esLlegar?r.llega:r.disp)+'</td><td>#'+npEsc(String(r.ultDoc))+' '+fmtD(r.ultFecha)+'</td><td class="r">'+fmtN(r.ultCant)+'</td><td class="r">'+r.ultPrecio.toFixed(2)+'</td></tr>';
  }).join('');
}
// Antes esto NO generaba un PDF: abria una ventana con las filas en HTML, con
// las fotos apuntando al bucket EN TAMANO ORIGINAL, esperaba a que cargaran
// TODAS y mandaba a imprimir. Con 300 articulos eso son cientos de megas
// descargados antes de ver nada, y el "Guardar como PDF" del navegador
// incrusta esas mismas fotos sin reducir: minutos de espera y un archivo que
// no pasa por correo.
//
// Ahora se arma con jsPDF y las fotos van por _fetchImgPool, que las descarga
// en paralelo y las reduce antes de incrustarlas. Es el mismo camino que usa
// el Excel de esta pantalla.
async function rsPdf(){
  if(!rsCli){alert('Selecciona un cliente.');return;}
  if(!rsDisp.length && !rsPorLlegar.length){alert('No hay datos para el reporte.');return;}

  var btn=document.getElementById('rs-pdf-btn');
  var prev=btn?btn.innerHTML:null;
  var aviso=function(t){ if(btn) btn.textContent=t; };
  if(btn) btn.disabled=true;

  try{
    if(typeof catCargarLib==='function') await catCargarLib();
    if(!(window.jspdf && window.jspdf.jsPDF)) throw new Error('No se pudo cargar el generador de PDF');

    var secciones=[];
    if(rsDisp.length)      secciones.push({t:'Productos en stock', arr:rsDisp, llegar:false});
    if(rsPorLlegar.length) secciones.push({t:'Agotados \u2014 por llegar (pedido futuro)',
                                           arr:rsPorLlegar, llegar:true});
    var todas=[].concat(rsDisp, rsPorLlegar);

    // 96 px de lado basta para una miniatura de 34 pt en el PDF. Pedir el
    // original era lo que hacia pesar el archivo decenas de megas.
    aviso('Fotos 0/'+todas.length+'\u2026');
    var cands=todas.map(function(r){
      return (r.foto_cands && r.foto_cands.length) ? r.foto_cands : (r.foto_url||null);
    });
    var imgs={};
    try{
      imgs=await _fetchImgPool(cands, function(d,t){ aviso('Fotos '+d+'/'+t+'\u2026'); },
                               96, 0.62) || {};
    }catch(e){ imgs={}; }

    aviso('Armando el PDF\u2026');
    var jsPDF=window.jspdf.jsPDF;
    var doc=new jsPDF({unit:'pt', format:'letter', orientation:'landscape'});
    var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
    var M=28, y=M;

    // #, Foto, SKU, Descripcion, Total hist., Disponible, Ult. compra, Cant., Precio
    var anchos=[24, 40, 92, 250, 66, 72, 84, 60, 66];
    var titulos=['#','Foto','SKU','Descripcion','Total hist.','Disponible',
                 'Ult. compra','Cant. ult.','Ult. precio'];
    var derecha={0:1, 4:1, 5:1, 7:1, 8:1};
    var FILA=26;

    function membrete(){
      doc.setFont('helvetica','bold'); doc.setFontSize(15); doc.setTextColor(15,15,15);
      doc.text('KENNEDY CENTER CORP.', M, y+4);
      doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(80,80,80);
      doc.text('Reporte de Restock \u2014 historial de compras', M, y+18);
      doc.setFont('helvetica','bold'); doc.setFontSize(10.5); doc.setTextColor(20,20,20);
      doc.text(String(rsCli.cardname||''), W-M, y+4, {align:'right'});
      doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(80,80,80);
      doc.text(String(rsCli.cardcode||''), W-M, y+17, {align:'right'});
      doc.text(String(npFechaDisp()), W-M, y+29, {align:'right'});
      y+=38;
      doc.setDrawColor(20,20,20); doc.setLineWidth(1.2);
      doc.line(M, y, W-M, y);
      y+=12;
    }

    function cabecera(etiqueta){
      doc.setFillColor(236,236,236); doc.setDrawColor(150,150,150); doc.setLineWidth(.5);
      doc.rect(M, y, W-2*M, 16, 'FD');
      doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor(35,35,35);
      var x=M;
      titulos.forEach(function(t,i){
        var txt=(i===5 && etiqueta) ? etiqueta : t;
        doc.text(txt, derecha[i]?(x+anchos[i]-4):(x+4), y+11, {align:derecha[i]?'right':'left'});
        x+=anchos[i];
      });
      y+=16;
    }

    function salto(alto, etiqueta){
      if(y+alto <= H-M) return;
      doc.addPage(); y=M; cabecera(etiqueta);
    }

    membrete();

    secciones.forEach(function(sec){
      var etiqueta = sec.llegar ? 'Por llegar' : 'Disponible';

      if(y+40 > H-M){ doc.addPage(); y=M; }
      doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(31,78,156);
      doc.text(sec.t, M, y+10);
      y+=18;
      cabecera(etiqueta);

      sec.arr.forEach(function(r,i){
        salto(FILA, etiqueta);

        if(i%2===1){
          doc.setFillColor(247,247,247);
          doc.rect(M, y, W-2*M, FILA, 'F');
        }

        var x=M;
        var vals=[
          String(i+1),
          '',                                   // la foto se dibuja aparte
          String(r.itemcode||''),
          String(r.dscription||''),
          fmtN(r.total),
          fmtN(sec.llegar ? r.llega : r.disp),
          (r.ultDoc?('#'+r.ultDoc+'  '):'')+(r.ultFecha?fmtD(r.ultFecha):''),
          fmtN(r.ultCant),
          r.ultPrecio!=null ? fmt(r.ultPrecio) : ''
        ];

        doc.setFont('helvetica','normal'); doc.setFontSize(7.6); doc.setTextColor(25,25,25);
        vals.forEach(function(v,c){
          if(c===1){ x+=anchos[c]; return; }
          var txt=String(v==null?'':v);
          if(c===3){
            // Una sola linea por fila. Si no cabe se corta, pero con puntos
            // suspensivos: sin ellos parece que el articulo se llama asi.
            var partes=doc.splitTextToSize(txt, anchos[c]-8);
            txt=(partes[0]||'');
            if(partes.length>1) txt=doc.splitTextToSize(txt, anchos[c]-16)[0]+'\u2026';
          }
          doc.text(txt, derecha[c]?(x+anchos[c]-4):(x+4), y+16,
                   {align:derecha[c]?'right':'left'});
          x+=anchos[c];
        });

        // La foto, si se pudo bajar. Se busca por la primera candidata, que es
        // la clave con la que _fetchImgPool guarda el resultado.
        var clave=(r.foto_cands && r.foto_cands[0]) || r.foto_url;
        var im=clave ? imgs[clave] : null;
        if(im && im.b64){
          try{
            doc.addImage(im.b64, im.ext||'JPEG', M+anchos[0]+3, y+2, 22, 22, undefined, 'FAST');
          }catch(e){}
        }

        doc.setDrawColor(220,220,220); doc.setLineWidth(.4);
        doc.line(M, y+FILA, W-M, y+FILA);
        y+=FILA;
      });

      y+=10;
    });

    // Pie con la paginacion, al final para saber cuantas paginas hay.
    var tot=doc.internal.getNumberOfPages();
    for(var pg=1; pg<=tot; pg++){
      doc.setPage(pg);
      doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(140,140,140);
      doc.text(String(rsCli.cardname||'')+'  \u00b7  '+rsDisp.length+' en stock, '
        +rsPorLlegar.length+' por llegar', M, H-14);
      doc.text('Pagina '+pg+' de '+tot, W-M, H-14, {align:'right'});
    }

    doc.save('restock-'+String(rsCli.cardcode).replace(/[^A-Za-z0-9_-]/g,'')+'.pdf');
  }catch(e){
    alert('No se pudo generar el PDF: '+(e&&e.message?e.message:e));
  }finally{
    if(btn){ btn.disabled=false; btn.innerHTML=prev; }
  }
}

// Antes esto armaba una tabla HTML y la bajaba como .xls: Excel abria un aviso
// de "el formato no coincide con la extension", los numeros entraban como texto
// y las fotos se perdian al reabrir. Ahora usa el mismo xlsxExport (ExcelJS)
// que el resto de los reportes, asi que sale un .xlsx de verdad con las fotos
// incrustadas y las cantidades como numeros.
async function rsExcel(){
  if(!rsCli){alert('Selecciona un cliente.');return;}
  if(!rsDisp.length && !rsPorLlegar.length){alert('No hay datos para el reporte.');return;}

  // Las dos secciones del reporte van en una sola hoja con una columna que las
  // distingue: en un xlsx se puede filtrar y ordenar, que es la ventaja de
  // tenerlo plano en vez de con encabezados intercalados.
  var filas=[]
    .concat(rsDisp.map(function(r){
      return Object.assign({}, r, {__sec:'EN STOCK',  __cant:Number(r.disp)||0});
    }))
    .concat(rsPorLlegar.map(function(r){
      return Object.assign({}, r, {__sec:'POR LLEGAR', __cant:Number(r.llega)||0});
    }));

  var hayFoto=filas.some(function(r){ return !!r.foto_url; });

  var columns=[];
  if(hayFoto) columns.push({label:'Foto', key:'foto', width:9});
  columns=columns.concat([
    {label:'Secci\u00f3n',            key:'__sec',     width:13},
    {label:'SKU',                 key:'itemcode',  width:16},
    {label:'Descripci\u00f3n',         key:'dscription',width:44},
    {label:'Total hist\u00f3rico',     key:'total',     width:14, numFmt:'#,##0'},
    {label:'Disp. / Por llegar', key:'__cant',    width:16, numFmt:'#,##0'},
    {label:'\u00daltima compra',       key:'__ult',     width:20},
    {label:'Cant. \u00faltima',        key:'ultCant',   width:12, numFmt:'#,##0'},
    {label:'\u00dalt. precio',         key:'ultPrecio', width:12, numFmt:'0.00'},
    {label:'Grupo',               key:'grupo',     width:24},
    {label:'Marca',               key:'marca',     width:16}
  ]);

  var btn=document.getElementById('rs-xlsx-btn');
  var txtPrev=btn?btn.innerHTML:null;
  if(btn){ btn.disabled=true; btn.innerHTML='Generando...'; }

  try{
    await xlsxExport({
      filename:'restock-'+String(rsCli.cardcode).replace(/[^A-Za-z0-9_-]/g,'')+'.xlsx',
      titulo:'KENNEDY CENTER CORP. - RESTOCK '+rsCli.cardname+' ('+rsCli.cardcode+')',
      subtitulo:'Historial de compras  -  '+npFechaDisp()+'  -  '
                +rsDisp.length+' en stock, '+rsPorLlegar.length+' por llegar',
      columns:columns,
      rows:filas,
      fotoKey:(hayFoto?'foto':null),
      fotoUrlFn:function(r){ return r.foto_url||''; },
      fotoCandsFn:function(r){ return r.foto_cands || (r.foto_url?[r.foto_url]:[]); },
      onProgress:function(d,t){ if(btn) btn.innerHTML='Fotos '+d+'/'+t+'...'; },
      valueFn:function(r,k){
        if(k==='__ult'){
          // Documento y fecha juntos, como en el PDF.
          return (r.ultDoc?('#'+r.ultDoc+'  '):'')+(r.ultFecha?fmtD(r.ultFecha):'');
        }
        if(k==='total'||k==='__cant'||k==='ultCant') return Number(r[k])||0;
        if(k==='ultPrecio') return Number(r.ultPrecio)||0;
        return r[k]==null?'':r[k];
      }
    });
  }catch(e){
    alert('No se pudo generar el Excel: '+(e&&e.message?e.message:e));
  }finally{
    if(btn){ btn.disabled=false; btn.innerHTML=txtPrev; }
  }
}

function npArmarResumen(){
  var vSel=document.getElementById('np-vendedor');
  var total=npLineas.reduce(function(s,l){return s+l.quantity*l.price*(1-l.discount/100);},0);
  var meta=document.getElementById('np-resumen-meta');
  if(meta) meta.innerHTML='<div><div style="font-size:11px;color:#888;text-transform:uppercase;margin-bottom:4px">Cliente</div><div style="font-size:14px;font-weight:600">'+(npCli?npCli.cardname:'—')+'</div></div>'
    +'<div><div style="font-size:11px;color:#888;text-transform:uppercase;margin-bottom:4px">Fecha</div><div style="font-size:14px;font-weight:600">'+(document.getElementById('np-fecha')?document.getElementById('np-fecha').value:'—')+'</div></div>'
    +'<div><div style="font-size:11px;color:#888;text-transform:uppercase;margin-bottom:4px">Total</div><div style="font-size:20px;font-weight:700;color:var(--blue)">'+fmt(total)+'</div></div>';
  var lineas=document.getElementById('np-resumen-lineas');
  if(lineas){ lineas.innerHTML=npLineas.map(function(l){
    var tot=l.quantity*l.price*(1-l.discount/100);
    var precioDesc=l.price*(1-(Number(l.discount)||0)/100);
    return '<tr><td style="width:48px">'+npFotoCell(l.itemcode)+'</td><td>'+l.itemname+'</td><td>'+l.quantity+'</td><td>'+fmt(l.price)+'</td><td>'+(l.discount?l.discount+'%':'—')+'</td><td>'+fmt(precioDesc)+'</td><td><b>'+fmt(tot)+'</b></td></tr>';
  }).join('');
    npCargarFotos(npLineas.map(function(l){return l.itemcode;}), npArmarResumen);
  }
}

async function npEnviar(){
  if(!npCli){ alert('Selecciona el cliente antes de enviar la cotización.'); npIr(1); return; }
  var btn=document.getElementById('np-btn-env');
  if(btn){btn.textContent='Enviando...';btn.disabled=true;}
  var t=npTotales();
  var total=t.total;
  var vSel=document.getElementById('np-vendedor');
  // Red de seguridad: una fecha vacia hace que Postgres rechace todo el
  // pedido con "invalid input syntax for type date". Antes de enviar, se
  // rellena lo que falte en vez de dejar que falle.
  try{ npFechasPorDefecto(false); }catch(e){}

  var payload={
    // Cliente de NAPA: el pedido se factura bajo el codigo paraguas 16414 en
    // kennedydb, y el cliente real queda en marca_cliente. Su estado de cuenta
    // y sus facturas siguen siendo los suyos, en la base de NAPA; lo unico que
    // cambia es a nombre de quien entra el pedido.
    // Cliente de NAPA. La marca 'napa' se pone al buscarlo en su pantalla,
    // pero se pierde si el pedido llega por otra via (un borrador, el reporte
    // de viabilidad...). Por eso se comprueba TAMBIEN el codigo: los de NAPA
    // empiezan por C y no existen en kennedydb, asi que SAP los rechaza con
    // "Invalid BP code" si se mandan tal cual.
    cardcode: (_npEsNapa(npCli) ? NAPA_CARDCODE : npCli.cardcode),
    cardname: (_npEsNapa(npCli) ? NAPA_CARDNAME : npCli.cardname),
    marca_cliente: (_npEsNapa(npCli) ? (npCli.cardname+' ['+npCli.cardcode+']') : null),
    // A donde va en SAP. Un cliente NUNCA puede mandar directo a pedido: lo
    // suyo entra como cotizacion y alguien de dentro decide.
    destino: _npDestino(),
    // null, nunca cadena vacia: Postgres rechaza '' como fecha.
  docdate: (_bdVal('np-fecha') || hoyLocal()),
    docduedate: (_bdVal('np-entrega') || hoyLocal(Date.now()+7*86400000)),
    currency:document.getElementById('np-moneda')?document.getElementById('np-moneda').value:'USD',
    comments:document.getElementById('np-comments')?document.getElementById('np-comments').value:'',
    slpcode:vSel&&vSel.value?parseInt(vSel.value):null,
    discprcnt:t.dgPct||0,
    estado:'pendiente',usuario:CU?CU.username:'portal',
    lineas:JSON.stringify(npLineas.map(function(l){return {itemcode:l.itemcode,dscription:l.itemname,quantity:l.quantity,price:l.price,discprcnt:l.discount,priceafterdisc:Math.round(l.price*(1-(Number(l.discount)||0)/100)*100)/100,linetotal:l.quantity*l.price*(1-l.discount/100),whscode:l.whscode,comment:l.note||''};}))
  };
  var st=document.getElementById('np-status');

  // Sin conexion el pedido NO se pierde: se guarda en el dispositivo y sale
  // solo al recuperar la red. Es lo que permite seguir vendiendo en bodega
  // o en la visita a un cliente aunque no haya senal.
  if(!navigator.onLine && typeof kccEncolarPedido==='function'){
    try{
      await kccEncolarPedido(payload);
      if(st){
        st.className='status-box'; st.style.display='block';
        st.style.background='#FFFBEB'; st.style.border='1px solid #FDE68A';
        st.style.borderRadius='10px'; st.style.padding='20px'; st.style.textAlign='center';
        st.innerHTML='<div style="font-size:30px;margin-bottom:8px">\u{1F4F4}</div>'
          +'<div style="font-size:16px;font-weight:700;margin-bottom:4px">Guardado sin conexi\u00f3n</div>'
          +'<div style="font-size:13px;color:#92400E">'+npEsc(npCli.cardname)+' \u00b7 '+fmt(total)+'</div>'
          +'<div style="font-size:12.5px;color:#78350F;margin-top:9px;line-height:1.5">'
          +'Se enviar\u00e1 solo en cuanto vuelva el internet.<br>'
          +'Puedes cerrar el portal sin perderlo.</div>';
      }
      try{ npLimpiarTodo(); }catch(e){}
      try{ kccPintarEstado(); }catch(e){}
      return;
    }catch(e){
      if(st){ st.style.display='block'; st.textContent='No se pudo guardar el pedido: '+(e.message||e); }
      return;
    }
  }

  try{
    var ctrl=new AbortController();
    var to=setTimeout(function(){ctrl.abort();},25000);
    var resp=await fetch(SB+'/rest/v1/pedidos_queue',{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=representation'},body:JSON.stringify(payload),signal:ctrl.signal});
    clearTimeout(to);
    if(resp.ok){
      if(st){
        st.className='status-box';st.style.display='block';st.style.background='#e8f5e3';st.style.border='1px solid #90c878';st.style.borderRadius='10px';st.style.padding='20px';st.style.textAlign='center';
        st.innerHTML='';
        var d1=document.createElement('div');d1.style.fontSize='32px';d1.style.marginBottom='8px';d1.textContent='✅';st.appendChild(d1);
        var d2=document.createElement('div');d2.style.fontSize='16px';d2.style.fontWeight='700';d2.style.marginBottom='4px';d2.textContent='Cotización enviada!';st.appendChild(d2);
        var d3=document.createElement('div');d3.style.fontSize='13px';d3.style.color='#555';d3.textContent=npCli.cardname+' · '+fmt(total);st.appendChild(d3);
        var btns=document.createElement('div');btns.style.cssText='margin-top:14px;display:flex;gap:8px;justify-content:center';
        var b1=document.createElement('button');b1.className='btn btn-p';b1.textContent='Nueva cotización';b1.onclick=npLimpiarTodo;btns.appendChild(b1);
        var b2=document.createElement('button');b2.className='btn';b2.textContent='Ver pedidos';b2.onclick=function(){go('pedidos',null);};btns.appendChild(b2);
        st.appendChild(btns);
      }
      var np4=document.getElementById('np4');if(np4)np4.style.display='none';
      npLineas=[];cotizUpdate();
      bdCerrar();     // ya esta en SAP: el borrador sobra
    } else {throw new Error(await resp.text());}
  }catch(e){
    var esTimeout=(e&&e.name==='AbortError');
    if(st){
      st.className='status-box';st.style.display='block';st.style.background='#fdeaea';st.style.border='1px solid #e8a0a0';st.style.borderRadius='10px';st.style.padding='20px';st.style.textAlign='center';
      st.innerHTML='';
      var d1=document.createElement('div');d1.style.fontSize='32px';d1.style.marginBottom='8px';d1.textContent=esTimeout?'⏳':'❌';st.appendChild(d1);
      var d2=document.createElement('div');d2.style.fontSize='16px';d2.style.fontWeight='700';d2.style.marginBottom='4px';d2.textContent=esTimeout?'La conexión tardó demasiado':'Error al enviar';st.appendChild(d2);
      var d3=document.createElement('div');d3.style.fontSize='13px';d3.style.color='#555';d3.textContent=esTimeout?'Puede que la cotización sí haya entrado. Revisa en unos minutos en SAP o en la cola ANTES de reenviar, para no duplicarla.':e.message;st.appendChild(d3);
    }
    if(btn){btn.textContent='Reintentar';btn.disabled=false;}
  }
}

function npLimpiarTodo(){
  npCli=null;npLineas=[];
  BD_ID=null; BD_ULT='';   // empezar de cero, no seguir escribiendo el borrador anterior
  var inp=document.getElementById('np-cli-q');if(inp){inp.style.display='block';inp.value='';}
  var sel=document.getElementById('np-cli-sel');if(sel)sel.style.display='none';
  var h=document.getElementById('np-historial');if(h)h.style.display='none';
  var btn=document.getElementById('np-btn2');if(btn)btn.disabled=true;
  var st=document.getElementById('np-status');if(st){st.className='status-box';st.style.display='none';st.innerHTML='';}
  cotizUpdate();
  npRenderLineas();npIr(1);
}

function npPreselCliente(c){
  if(typeof c==='string') c=JSON.parse(c.replace(/&quot;/g,'"'));
  npLimpiarTodo();
  npCli=c;
  var inp=document.getElementById('np-cli-q');if(inp)inp.style.display='none';
  var sel=document.getElementById('np-cli-sel');if(sel)sel.style.display='flex';
  var av=document.getElementById('np-cli-av');if(av)av.textContent=ini(c.cardname);
  var nm=document.getElementById('np-cli-name');if(nm)nm.textContent=c.cardname;
  var mt=document.getElementById('np-cli-meta');if(mt)mt.textContent=c.cardcode;
  var sl=document.getElementById('np-cli-saldo');if(sl)sl.textContent=fmt(c.balance);
  var btn=document.getElementById('np-btn2');if(btn)btn.disabled=false;
}


// ===================== ESCÁNER / CONTENEDOR / MASIVOS (v7) =====================
function _npEnableBtns(){['np-btn3','np-btn3-top','np-btn2'].forEach(function(id){var b=document.getElementById(id);if(b)b.disabled=npLineas.length===0;});}

// ---- Escáner de código de barras ----
var _scanner=null,_scanMode='cart',_scanBusy=false;
function openScan(mode){
  _scanMode=mode||'cart';_scanBusy=false;
  var m=document.getElementById('scan-modal');if(!m)return;
  m.style.display='flex';
  var msg=document.getElementById('scan-msg');
  if(msg)msg.textContent=(_scanMode==='inv'?'Escanea un producto para ver su ficha.':'Escanea con la pistola para agregar 1 bulto por lectura.');
  // Enfocar el campo del lector físico (funciona sin cámara)
  var inp=document.getElementById('scan-input');
  if(inp){ inp.value=''; setTimeout(function(){inp.focus();},60); }
  var tog=document.getElementById('scan-cam-toggle'); if(tog) tog.checked=false;
  var rd=document.getElementById('scan-reader'); if(rd) rd.style.display='none';
}
// Cámara opcional (checkbox): iniciarla/detenerla bajo demanda
function toggleScanCam(on){
  var msg=document.getElementById('scan-msg');
  var rd=document.getElementById('scan-reader');
  if(on){
    if(typeof Html5Qrcode==='undefined'){ if(msg)msg.textContent='No se pudo cargar la cámara (revisa tu conexión).'; return; }
    if(rd) rd.style.display='block';
    try{_scanner=new Html5Qrcode('scan-reader');}catch(e){ if(msg)msg.textContent='No se pudo iniciar la cámara.'; return; }
    _scanner.start({facingMode:'environment'},{fps:10,qrbox:{width:250,height:160}},onScanOk,function(){}).catch(function(){
      if(msg)msg.textContent='No se pudo abrir la cámara. Necesitas HTTPS y permiso de cámara. Puedes seguir usando la pistola.';
      if(rd) rd.style.display='none';
    });
  } else {
    _stopScanner(); if(rd) rd.style.display='none';
    var inp=document.getElementById('scan-input'); if(inp) inp.focus();
  }
}
function _stopScanner(){
  if(_scanner){try{_scanner.stop().then(function(){try{_scanner.clear();}catch(e){}_scanner=null;}).catch(function(){_scanner=null;});}catch(e){_scanner=null;}}
}
function closeScan(){
  var m=document.getElementById('scan-modal');if(m)m.style.display='none';
  _stopScanner();
}
// Lector físico (pistola): toma el código del campo y lo procesa
function onScanHardware(){
  var inp=document.getElementById('scan-input'); if(!inp) return;
  var code=String(inp.value||'').trim(); inp.value='';
  if(!code) return;
  onScanOk(code);
  setTimeout(function(){ inp.focus(); },30);
}

// Resuelve un código escaneado/tecleado: barcode (todos), luego columna codebars, luego SKU.
async function scanResolve(code){
  code=String(code||'').trim(); if(!code) return null;
  var SEL='select=itemcode,itemname,precioventa,unidadesbulto,numinbuy,codebars,disponiblebodega,disponible,onhand,iscommited,onorder';
  try{ var cb=await q('codigos_barra','select=itemcode&barcode=eq.'+encodeURIComponent(code)+'&limit=1');
       if(cb&&cb[0]&&cb[0].itemcode){ var it=await q('vista_inventario',SEL+'&itemcode=eq.'+encodeURIComponent(cb[0].itemcode)+'&limit=1'); if(it&&it[0]) return it[0]; } }catch(e){}
  try{ var r=await q('vista_inventario',SEL+'&codebars=eq.'+encodeURIComponent(code)+'&limit=1'); if(r&&r[0]) return r[0]; }catch(e){}
  try{ var s2=await q('vista_inventario',SEL+'&itemcode=eq.'+encodeURIComponent(code)+'&limit=1'); if(s2&&s2[0]) return s2[0]; }catch(e){}
  return null;
}
// Enter en el buscador de producto: si parece un código, lo agrega por bulto y LIMPIA el campo.
function npProdKey(e){
  // El Enter manual en el buscador NO hace nada (no borra ni agrega).
  // El escáner físico lo detecta el captador global por su velocidad de ráfaga.
}

// Feedback de escaneo: en el modal si está abierto, si no un toast flotante
function _scanFeedback(html,ok){
  var m=document.getElementById('scan-modal');
  var msg=document.getElementById('scan-msg');
  var modalOpen=m && m.style.display==='flex';
  if(modalOpen && msg){ msg.innerHTML=html; }
  else { scanToast(html); }
}
function scanToast(html){
  var t=document.getElementById('scan-toast');
  if(!t){ t=document.createElement('div'); t.id='scan-toast';
    t.style.cssText='position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(8px);z-index:99999;background:var(--surface,#fff);color:var(--text,#111);border:1px solid var(--border,#eee);box-shadow:0 12px 34px rgba(22,19,40,.22);border-radius:12px;padding:12px 20px;font-size:14px;line-height:1.35;text-align:center;max-width:92vw;opacity:0;transition:opacity .18s,transform .18s;pointer-events:none';
    document.body.appendChild(t);
  }
  t.innerHTML=html;
  requestAnimationFrame(function(){ t.style.opacity='1'; t.style.transform='translateX(-50%) translateY(0)'; });
  clearTimeout(t._h); t._h=setTimeout(function(){ t.style.opacity='0'; t.style.transform='translateX(-50%) translateY(8px)'; },1900);
}

// Captador global de pistola: detecta la ráfaga rápida + Enter, la procesa como
// escaneo, la BORRA de donde haya caído y agrega por bulto (sin abrir el modal).
(function(){
  var buf='', lastT=0, bufStart=0; var MINLEN=4, GAP=100, AVG=45;
  document.addEventListener('keydown', function(e){
    var ae=document.activeElement;
    if(ae && ae.id==='scan-input') return;          // el modal maneja su propio campo
    var now=Date.now();
    if(e.key==='Enter'){
      var steps=document.getElementById('ns1');
      var enNP=steps && steps.offsetParent!==null;   // estamos en Nuevo Pedido (cualquier paso)
      // Sólo es ESCÁNER si fue una ráfaga rápida (promedio < AVG ms por tecla).
      var dur=lastT-bufStart;
      var esRafaga=(buf.length>=MINLEN) && (dur < buf.length*AVG);
      var code=esRafaga?buf:'';
      buf='';
      if(enNP && code){
        if(ae && ae.id==='np-prod-q'){ ae.value=''; try{ if(typeof catBuscar==='function') catBuscar(''); }catch(_){} }
        else if(ae && (ae.tagName==='INPUT'||ae.tagName==='TEXTAREA') && typeof ae.value==='string' && ae.value.slice(-code.length)===code){
          ae.value=ae.value.slice(0, ae.value.length-code.length);
          try{ ae.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
        }
        e.preventDefault(); e.stopPropagation();
        _scanMode='cart'; onScanOk(code);
      }
      return;
    }
    if(e.key && e.key.length===1){
      if(now-lastT>GAP){ buf=''; bufStart=now; }      // corte de tiempo = nueva secuencia
      buf+=e.key; lastT=now;
    }
  }, true);
})();
async function onScanOk(text){
  if(_scanBusy)return;_scanBusy=true;
  var msg=document.getElementById('scan-msg');var code=String(text).trim();
  if(msg)msg.textContent='Buscando '+code+'…';
  try{
    var i=await scanResolve(code);
    if(!i){_scanFeedback('<span style="color:var(--red,#e23b58);font-weight:600">Sin resultados para '+code+'</span>',false);setTimeout(function(){_scanBusy=false;},350);return;}
    if(_scanMode==='inv'){closeScan();if(typeof verItem==='function')verItem(i.itemcode);return;}
    var precio=pvVenta(i);
    var bulto=Math.max(1,Number(i.unidadesbulto)||Number(i.numinbuy)||1);
    var l=npLineas.find(function(x){return x.itemcode===i.itemcode;});
    if(l){l.quantity=(Number(l.quantity)||0)+bulto;}else{npAgregar({itemcode:i.itemcode,itemname:i.itemname,quantity:bulto,price:precio,discount:0,whscode:'',bulto:bulto,note:''});}
    npRenderLineas();_npEnableBtns();
    var _np3=document.getElementById('np3');
    if(!(_np3 && _np3.style.display==='block') && typeof npIr==='function'){ npIr(3); }
    var _tot=(npLineas.find(function(x){return x.itemcode===i.itemcode;})||{}).quantity||bulto;
    _scanFeedback('<span style="color:var(--green);font-weight:700">✓ '+(i.itemname||i.itemcode)+'</span><br>+1 bulto ('+fmtN(bulto)+' u) · Total: '+fmtN(_tot)+' u',true);
    setTimeout(function(){_scanBusy=false;},350);
  }catch(e){_scanFeedback('<span style="color:var(--red,#e23b58)">Error al buscar. Intenta de nuevo.</span>',false);setTimeout(function(){_scanBusy=false;},350);}
}

// ---- Operaciones masivas en el pedido ----
function npBulkDescuento(){
  if(!npLineas.length){alert('No hay productos en el pedido.');return;}
  var v=prompt('Aplicar este % de descuento a TODAS las líneas (0-100):','0');
  if(v===null)return;var p=Math.max(0,Math.min(100,Number(v)||0));
  npLineas.forEach(function(l){l.discount=p;});npRenderLineas();
}
function npBulkPrecioPct(){
  if(!npLineas.length){alert('No hay productos en el pedido.');return;}
  var v=prompt('Ajustar el precio de TODAS las líneas en % (ej: -10 baja 10%, 5 sube 5%):','0');
  if(v===null)return;var p=Number(v)||0;
  npLineas.forEach(function(l){l.price=Math.round((Number(l.price)||0)*(1+p/100)*100)/100;});npRenderLineas();
}

// ---- Importar pedido desde lista pegada ----
function npImportAbrir(){var m=document.getElementById('import-modal');if(!m)return;m.style.display='flex';var t=document.getElementById('import-text');if(t){t.value='';t.focus();}var s2=document.getElementById('import-msg');if(s2)s2.textContent='';}
function npImportCerrar(){var m=document.getElementById('import-modal');if(m)m.style.display='none';}
async function npImportProcesar(){
  var ta=document.getElementById('import-text');var msg=document.getElementById('import-msg');
  var txt=(ta&&ta.value||'').trim();if(!txt){if(msg)msg.textContent='Pega una lista de códigos.';return;}
  var pares=parseImportLines(txt);
  if(!pares.length){if(msg)msg.textContent='No se reconocieron líneas.';return;}
  if(msg)msg.textContent='Buscando '+pares.length+' productos…';
  try{
    var inList=pares.map(function(p){return '"'+String(p.code).replace(/"/g,'')+'"';}).join(',');
    var rows=await q('vista_inventario','select=itemcode,itemname,precioventa,unidadesbulto,numinbuy&itemcode=in.('+inList+')&limit='+pares.length);
    var map={};(rows||[]).forEach(function(r){map[String(r.itemcode).toUpperCase()]=r;});
    var add=0,nf=[];
    pares.forEach(function(p){
      var r=map[String(p.code).toUpperCase()];
      if(!r){nf.push(p.code);return;}
      var precio=(p.price!=null)?p.price:pvVenta(r);
      var bulto=Math.max(1,Number(r.unidadesbulto)||Number(r.numinbuy)||1);
      var l=npLineas.find(function(x){return x.itemcode===r.itemcode;});
      if(l){l.quantity+=p.qty;}else{npAgregar({itemcode:r.itemcode,itemname:r.itemname,quantity:p.qty,price:precio,discount:0,whscode:'',bulto:bulto,note:''});}
      add++;
    });
    npRenderLineas();_npEnableBtns();
    if(msg)msg.innerHTML='<span style="color:var(--green);font-weight:600">✓ '+add+' agregados.</span>'+(nf.length?' <span style="color:var(--red)">No encontrados: '+nf.join(', ')+'</span>':'');
  }catch(e){if(msg)msg.textContent='Error al importar. Intenta de nuevo.';}
}

// ---- Calculadora de cubicaje / contenedor ----

// ---- Parser compartido de importación (Código · Cantidad · Precio) ----
function parseImportLines(txt){
  var out=[];
  String(txt||'').split(/\r?\n/).forEach(function(ln){
    ln=ln.trim(); if(!ln) return;
    var p=ln.split(/[\s,;\t]+/).filter(Boolean); if(!p.length) return;
    var code=p[0];
    var qty=p.length>1?Number(String(p[1]).replace(',','.')):1;
    if(!qty||isNaN(qty)||qty<=0) qty=1;
    var price=p.length>2?Number(String(p[2]).replace(',','.')):null;
    if(price!=null&&(isNaN(price)||price<0)) price=null;
    out.push({code:code,qty:qty,price:price});
  });
  return out;
}

// ---- Importar pedido desde Excel (zona Reportes) ----
async function rptImportExcel(){
  var ta=document.getElementById('rpt-imp-text'); var msg=document.getElementById('rpt-imp-msg');
  var rows=parseImportLines(ta&&ta.value);
  if(!rows.length){ if(msg)msg.textContent='Pega al menos una línea (Código Cantidad Precio).'; return; }
  if(msg)msg.textContent='Buscando '+rows.length+' productos…';
  try{
    var inList=rows.map(function(r){return '"'+String(r.code).replace(/"/g,'')+'"';}).join(',');
    var inv=await q('vista_inventario','select=itemcode,itemname,precioventa,unidadesbulto,numinbuy&itemcode=in.('+inList+')&limit='+rows.length);
    var map={}; (inv||[]).forEach(function(r){map[String(r.itemcode).toUpperCase()]=r;});
    var nuevas=[], nf=[];
    rows.forEach(function(r){
      var inf=map[String(r.code).toUpperCase()];
      if(!inf){ nf.push(r.code); return; }
      var precio=(r.price!=null)?r.price:pvVenta(inf);
      var bulto=Math.max(1,Number(inf.unidadesbulto)||Number(inf.numinbuy)||1);
      nuevas.push({itemcode:inf.itemcode,itemname:inf.itemname,quantity:r.qty,price:precio,discount:0,whscode:'',bulto:bulto,note:''});
    });
    if(!nuevas.length){ if(msg)msg.innerHTML='<span style="color:var(--red)">Ningún código encontrado: '+nf.join(', ')+'</span>'; return; }
    var reemplazar=true;
    if(npLineas.length){ reemplazar=confirm('Ya hay '+npLineas.length+' producto(s) en un pedido en curso.\n\nAceptar = reemplazar por la importación.\nCancelar = agregar a lo existente.'); }
    if(reemplazar){ npLineas=nuevas; }
    else { nuevas.forEach(function(n){ var l=npLineas.find(function(x){return x.itemcode===n.itemcode;}); if(l){ l.quantity+=n.quantity; l.price=n.price; } else { npAgregar(n); } }); }
    if(msg)msg.innerHTML='<span style="color:var(--green);font-weight:600">✓ '+nuevas.length+' líneas importadas.</span>'+(nf.length?' <span style="color:var(--red)">No encontrados: '+nf.join(', ')+'</span>':'')+' Abriendo el pedido…';
    if(typeof go==='function') go('nuevo_pedido');
    setTimeout(function(){ if(typeof npIr==='function')npIr(3); if(typeof npRenderLineas==='function')npRenderLineas(); },170);
  }catch(e){ if(msg)msg.textContent='Error al importar. Revisa tu conexión e intenta de nuevo.'; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  IMPORTAR PEDIDO DESDE EXCEL POR BARCODE  (zona Reportes)
//  Igual que rptImportExcel pero recibe BARCODE en lugar de SKU.
//  - Si un barcode está asociado a 2+ items, elige el de MÁS stock.
//  - Los barcodes no encontrados se listan al final del pedido.
//  Pegar esta función en kennedy-2.js (junto a rptImportExcel, ~línea 2931)
// ═══════════════════════════════════════════════════════════════════════════
async function rptImportExcelBarcode(){
  var ta=document.getElementById('rpt-impbc-text'); var msg=document.getElementById('rpt-impbc-msg');
  var rows=parseImportLines(ta&&ta.value);   // reutiliza el mismo parser: {code, qty, price}
  if(!rows.length){ if(msg)msg.textContent='Pega al menos una línea (Barcode Cantidad Precio).'; return; }
  if(msg)msg.textContent='Buscando '+rows.length+' códigos de barra…';
  try{
    // 1) Traer TODOS los items que tengan alguno de los barcodes pegados.
    //    Un mismo barcode puede devolver varios items -> luego elegimos el de más stock.
    var inList=rows.map(function(r){return '"'+String(r.code).replace(/"/g,'').trim()+'"';}).join(',');
    var inv=await q('vista_inventario',
      'select=itemcode,itemname,codebars,precioventa,unidadesbulto,numinbuy,disponiblebodega,disponible,onhand,fechaentrada'+
      '&codebars=in.('+inList+')&limit=5000');

    // 2) Agrupar por barcode (normalizado a mayúsculas y sin espacios).
    //    Para cada barcode nos quedamos con el item de MAYOR stock (onhand = total, el verde).
    //    Si hay empate de stock, se elige el MÁS NUEVO (mayor fechaentrada).
    var byBarcode={};
    (inv||[]).forEach(function(r){
      var bc=String(r.codebars||'').trim().toUpperCase();
      if(!bc) return;
      var stock=Number(r.onhand!=null?r.onhand:(r.disponiblebodega!=null?r.disponiblebodega:(r.disponible||0)))||0;
      var fecha=r.fechaentrada?Date.parse(r.fechaentrada)||0:0;
      var actual=byBarcode[bc];
      // Gana el de más stock; si empatan en stock, gana el de fechaentrada más reciente.
      if(!actual || stock > actual._stock || (stock === actual._stock && fecha > actual._fecha)){
        r._stock=stock;
        r._fecha=fecha;
        byBarcode[bc]=r;
      }
    });

    // 3) Construir las líneas del pedido en el MISMO orden en que se pegaron.
    var nuevas=[], nf=[];
    rows.forEach(function(r){
      var bc=String(r.code||'').trim().toUpperCase();
      var inf=byBarcode[bc];
      if(!inf){ nf.push(r.code); return; }
      var precio=(r.price!=null)?r.price:pvVenta(inf);
      var bulto=Math.max(1,Number(inf.unidadesbulto)||Number(inf.numinbuy)||1);
      // Si el mismo item ya venía en otra línea, sumar cantidades.
      var yaEsta=nuevas.find(function(x){return x.itemcode===inf.itemcode;});
      if(yaEsta){ yaEsta.quantity+=r.qty; }
      else { nuevas.push({itemcode:inf.itemcode,itemname:inf.itemname,quantity:r.qty,price:precio,discount:0,whscode:'',bulto:bulto,note:''}); }
    });

    if(!nuevas.length){ if(msg)msg.innerHTML='<span style="color:var(--red)">Ningún barcode encontrado: '+nf.join(', ')+'</span>'; return; }

    // 4) Reemplazar o agregar al pedido en curso (igual que el original).
    var reemplazar=true;
    if(npLineas.length){ reemplazar=confirm('Ya hay '+npLineas.length+' producto(s) en un pedido en curso.\n\nAceptar = reemplazar por la importación.\nCancelar = agregar a lo existente.'); }
    if(reemplazar){ npLineas=nuevas; }
    else { nuevas.forEach(function(n){ var l=npLineas.find(function(x){return x.itemcode===n.itemcode;}); if(l){ l.quantity+=n.quantity; l.price=n.price; } else { npAgregar(n); } }); }

    // 5) Mensaje: importados + (al final) los barcodes NO encontrados.
    if(msg)msg.innerHTML='<span style="color:var(--green);font-weight:600">✓ '+nuevas.length+' líneas importadas.</span>'+
      (nf.length?' <span style="color:var(--red)">Barcodes no encontrados ('+nf.length+'): '+nf.join(', ')+'</span>':'')+' Abriendo el pedido…';

    // 6) Guardar los no encontrados para mostrarlos también dentro del pedido.
    window._impBarcodeNoEncontrados = nf;

    if(typeof go==='function') go('nuevo_pedido');
    setTimeout(function(){
      if(typeof npIr==='function')npIr(3);
      if(typeof npRenderLineas==='function')npRenderLineas();
      // Mostrar aviso de no encontrados dentro del paso del pedido, si hay.
      try{
        if(nf.length){
          var cont=document.getElementById('np-lineas-empty')||document.getElementById('np-tots');
          var aviso=document.getElementById('np-barcode-nf');
          if(!aviso && cont && cont.parentNode){
            aviso=document.createElement('div');
            aviso.id='np-barcode-nf';
            aviso.style.cssText='margin:12px 0;padding:11px 14px;border:1px solid var(--red);border-radius:10px;background:rgba(226,75,74,.06);font-size:13px;color:var(--red)';
            cont.parentNode.insertBefore(aviso, cont.nextSibling);
          }
          if(aviso) aviso.innerHTML='<b>⚠️ '+nf.length+' barcode(s) no encontrados (no están en inventario):</b><br>'+nf.join(', ');
        }
      }catch(_e){}
    },170);
  }catch(e){ if(msg)msg.textContent='Error al importar. Revisa tu conexión e intenta de nuevo.'; }
}

function npRenderContainer(t){
  var box=document.getElementById('np-container');if(!box)return;
  if(!t||!t.n){box.style.display='none';return;}
  var ft3=Number(t.piecub)||0,m3=ft3*0.0283168;
  var conts=[{n:"20'",ft:1172,m3:33.2},{n:"40'",ft:2390,m3:67.7},{n:"40' HC",ft:2694,m3:76.3}];
  var bars=conts.map(function(c){
    var pct=c.ft>0?ft3/c.ft*100:0,pctR=Math.round(pct),w=Math.min(100,pct);
    var col=pct>100?'var(--red)':(pct>85?'var(--amber)':'var(--green)');
    return '<div style="margin-bottom:9px"><div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:4px"><span style="font-weight:600">Contenedor '+c.n+'</span><span style="color:var(--text3)">'+pctR+'%'+(pct>100?' · excede':'')+' · cap. '+c.m3+' m³</span></div>'
      +'<div style="height:8px;background:var(--bg);border-radius:5px;overflow:hidden"><div style="height:100%;width:'+w+'%;background:'+col+';border-radius:5px;transition:width .4s"></div></div></div>';
  }).join('');
  var ic='<svg class="tic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="1"/><path d="M6 6v12M10 6v12M14 6v12M18 6v12"/></svg>';
  box.innerHTML='<div class="card"><div class="ch"><span class="ct">'+ic+' Cubicaje del pedido</span>'
    +'<span style="font-size:12px;color:var(--text3)">'+fmtN(Math.round(ft3*10)/10)+' ft³ · '+fmtN(Math.round(m3*100)/100)+' m³ · '+fmtN(Math.round(t.kilos))+' kg · '+fmtN(Math.round(t.bultos*100)/100)+' bultos</span></div>'
    +bars
    +'<div style="font-size:11px;color:var(--text3);margin-top:2px">Estimado según el volumen registrado por producto. Capacidad útil aproximada por tipo de contenedor.</div></div>';
  box.style.display='block';
}
// ═══════════════════════════════════════════════════════════════════════════
//  NUEVO CLIENTE  (formulario en el portal -> clientes_queue -> SAP)
//  Pegar en kennedy-2.js (al final, antes del último comentario de cierre).
//  Visible solo para vendedores y gerencia (ver control de acceso más abajo).
//  Los valores de los checklists son EXACTOS de SAP.
// ═══════════════════════════════════════════════════════════════════════════

// ── Catálogos (valores exactos de SAP) ──────────────────────────────────────
var NC_GRUPOS = [
  {v:105, t:'Clientes - Contado'}, {v:100, t:'Clientes - Credito'},
  {v:108, t:'Clientes - LC 60 ds'}, {v:102, t:'Empleados'},
  {v:107, t:'N/A'}, {v:106, t:'NO VALIDO'}
];
// Condiciones de pago SAP (tabla OCTG) — distinto de "Forma de pago" (UDF)
var NC_COND_PAGO = [
  {v:'-1', t:'CONTADO'},
  {v:'9',  t:'CREDITO'},
  {v:'2',  t:'CREDITO 30 DIAS'},
  {v:'4',  t:'CREDITO 60 DIAS'},
  {v:'5',  t:'CREDITO 90 DIAS'},
  {v:'17', t:'CREDITO 120 DIAS'},
  {v:'16', t:'CREDITO 240 DIAS'},
  {v:'19', t:'CREDITO : 90-120 DIAS'},
  {v:'18', t:'90-120'},
  {v:'15', t:'CREDITO 60 DIAS FECHA B/L'},
  {v:'3',  t:'CREDITO 30 DIAS COMPRAS'},
  {v:'6',  t:'CREDITO 90 DIAS COMPRAS'},
  {v:'7',  t:'C.O.D.'},
  {v:'14', t:'CARTA DE CREDITO 45 DIAS'},
  {v:'20', t:'CARTA DE CREDITO 90 DIAS'},
  {v:'13', t:'L/C'},
  {v:'21', t:'L/C 60 dias'},
  {v:'22', t:'L/C 90 Dias'},
  {v:'12', t:'D/P'},
  {v:'11', t:'T/T'},
  {v:'10', t:'FOB MANZANILLO'},
  {v:'8',  t:'CO-5223'},
  {v:'1',  t:'PROVEDORES CONTADO'}
];
var NC_FORMA_PAGO = [
  {v:'1', t:'Efectivo'}, {v:'2', t:'Transferencias'}, {v:'3', t:'Cheques'}, {v:'4', t:'Otros'}
];
var NC_TIPO_RUC = [ {v:'Natural', t:'Natural'}, {v:'Jurídico', t:'Jurídico'} ];
var NC_TIPO_RECEPTOR = [
  {v:'Contribuyente', t:'Contribuyente'}, {v:'Consumidor Final', t:'Consumidor Final'},
  {v:'Gobierno', t:'Gobierno'}, {v:'Extrangero', t:'Extrangero'}
];
var NC_FE_ENVIO = [
  {v:'Normal', t:'Normal'},
  {v:'El_receptor_exceptua_al_emisor_de_la_obligatoriedad_de_envio_del_contenedo', t:'Envio Exceptuado'}
];
var NC_FE_TIPO_RUC = [ {v:'Natural', t:'Natural'}, {v:'Juridico', t:'Juridico'} ];
var NC_FE_TIPO_RECEPTOR = [
  {v:'Contribuyente', t:'Contribuyente'}, {v:'Consumidor_final', t:'Consumidor Final'},
  {v:'Gobierno', t:'Gobierno'}, {v:'Extranjero', t:'Extranjero'}
];
// Países (código, nombre). Lista completa de SAP.
var NC_PAISES = [
  {v:'AF',t:'Afganistán'},{v:'AL',t:'Albania'},{v:'DE',t:'Alemania'},{v:'AD',t:'Andorra'},{v:'AO',t:'Angóla'},
  {v:'AI',t:'Anguilla'},{v:'AG',t:'Antigua'},{v:'AN',t:'Antillas Holandesas'},{v:'SA',t:'Arabia Saudi'},{v:'DZ',t:'Argelia'},
  {v:'AR',t:'Argentina'},{v:'AW',t:'Aruba'},{v:'AU',t:'Australia'},{v:'AT',t:'Austria'},{v:'AZ',t:'Azerbaiyán'},
  {v:'BS',t:'Bahamas'},{v:'BH',t:'Bahrein'},{v:'BD',t:'Bangladesh'},{v:'BB',t:'Barbados'},{v:'BE',t:'Bélgica'},
  {v:'BZ',t:'Belize'},{v:'BJ',t:'Benin'},{v:'BM',t:'Bermudas'},{v:'BT',t:'Bhutan'},{v:'BY',t:'Bielorrusia'},
  {v:'BO',t:'Bolivia'},{v:'BA',t:'Bosnia y Herzegovina'},{v:'BW',t:'Botswana'},{v:'BR',t:'Brasil'},{v:'BG',t:'Bulgaria'},
  {v:'BF',t:'Burkina Faso'},{v:'BI',t:'Burundi'},{v:'KH',t:'Cambodia'},{v:'CM',t:'Camerún'},{v:'CA',t:'Canada'},
  {v:'TD',t:'Chad'},{v:'CL',t:'Chile'},{v:'CN',t:'China'},{v:'CY',t:'Chipre'},{v:'VA',t:'Ciudad del Vaticano'},
  {v:'CO',t:'Colombia'},{v:'KM',t:'Comores'},{v:'CG',t:'Congo'},{v:'KP',t:'Corea del norte'},{v:'KR',t:'Corea del Sur'},
  {v:'CI',t:'Costa de Marfil'},{v:'CR',t:'Costa Rica'},{v:'HR',t:'Croacia'},{v:'CU',t:'Cuba'},{v:'CW',t:'Curazao'},
  {v:'DK',t:'Dinamarca'},{v:'DM',t:'Dominica'},{v:'EC',t:'Ecuador'},{v:'EG',t:'Egipto'},{v:'SV',t:'El Salvador'},
  {v:'AE',t:'Emiratos Arabes Unidos'},{v:'ER',t:'Eritrea'},{v:'SK',t:'Eslovaquia'},{v:'SI',t:'eslovenia'},{v:'ES',t:'España'},
  {v:'US',t:'Estados Unidos de America'},{v:'EE',t:'Estonia'},{v:'ET',t:'Etiopía'},{v:'RU',t:'Federación Rusa'},{v:'PH',t:'Filipinas'},
  {v:'FI',t:'Finlandia'},{v:'FJ',t:'Fiyi'},{v:'FR',t:'Francia'},{v:'GA',t:'Gabón'},{v:'GM',t:'Gambia'},
  {v:'GE',t:'Georgia'},{v:'GH',t:'Ghana'},{v:'GI',t:'Gibraltar'},{v:'GB',t:'Gran Bretaña'},{v:'GD',t:'Granada'},
  {v:'GR',t:'Grecia'},{v:'GL',t:'Groenlandia'},{v:'GP',t:'Guadalupe'},{v:'GU',t:'Guam'},{v:'GT',t:'Guatemala'},
  {v:'GF',t:'Guayana Francesa'},{v:'GN',t:'Guinea'},{v:'GQ',t:'Guinea Ecuatorial'},{v:'GW',t:'Guinea-Bissau'},{v:'GY',t:'Guyana'},
  {v:'HT',t:'Haiti'},{v:'NL',t:'Holanda'},{v:'HN',t:'Honduras'},{v:'HK',t:'Hong Kong'},{v:'HU',t:'Hungría'},
  {v:'IN',t:'India'},{v:'ID',t:'Indonesia'},{v:'IR',t:'Iran'},{v:'IQ',t:'Iraq'},{v:'IE',t:'Irlanda'},
  {v:'IS',t:'Islandia'},{v:'IL',t:'Israel'},{v:'IT',t:'Italia'},{v:'JM',t:'Jamaica'},{v:'JP',t:'Japón'},
  {v:'JO',t:'Jordania'},{v:'KZ',t:'Kazajstán'},{v:'KE',t:'Kenia'},{v:'KW',t:'Kuwait'},{v:'LA',t:'Laos'},
  {v:'LB',t:'Líbano'},{v:'LR',t:'Liberia'},{v:'LY',t:'Libia'},{v:'LI',t:'Liechtenstein'},{v:'LT',t:'Lituania'},
  {v:'LU',t:'Luxemburgo'},{v:'MG',t:'Madagascar'},{v:'MY',t:'Malasia'},{v:'MW',t:'Malawi'},{v:'ML',t:'Mali'},
  {v:'MT',t:'Malta'},{v:'MA',t:'Marruecos'},{v:'MQ',t:'Martinica'},{v:'MU',t:'Mauricio'},{v:'MR',t:'Mauritania'},
  {v:'MX',t:'Mexico'},{v:'FM',t:'Micronesia'},{v:'MD',t:'Moldavia'},{v:'MC',t:'Monaco'},{v:'MN',t:'Mongolia'},
  {v:'ME',t:'Montenegro'},{v:'MS',t:'Montserrat'},{v:'MZ',t:'Mozambique'},{v:'MM',t:'Myanmar'},{v:'NA',t:'Namibia'},
  {v:'NP',t:'Nepal'},{v:'NI',t:'Nicaragua'},{v:'NE',t:'Niger'},{v:'NG',t:'Nigeria'},{v:'NO',t:'Noruega'},
  {v:'NC',t:'Nueva Caledonia'},{v:'NZ',t:'Nueva Zelanda'},{v:'OM',t:'Omán'},{v:'PK',t:'Pakistán'},{v:'PW',t:'Palau'},
  {v:'PA',t:'Panamá'},{v:'PG',t:'Papúa Nueva Guinea'},{v:'PY',t:'Paraguay'},{v:'PE',t:'Perú'},{v:'PL',t:'Polonia'},
  {v:'PT',t:'Portugal'},{v:'PR',t:'Puerto Rico'},{v:'QA',t:'Qatar'},{v:'CZ',t:'Republica Checa'},{v:'DO',t:'Republica Dominicana'},
  {v:'RO',t:'Rumania'},{v:'RW',t:'Ruanda'},{v:'SM',t:'San Marino'},{v:'SN',t:'Senegal'},{v:'RS',t:'Serbia'},
  {v:'SC',t:'Seychelles'},{v:'SL',t:'Sierra Leona'},{v:'SG',t:'Singapur'},{v:'SY',t:'Siria'},{v:'SO',t:'Somalia'},
  {v:'LK',t:'Sri Lanka'},{v:'SD',t:'Sudán'},{v:'SE',t:'Suecia'},{v:'CH',t:'Suiza'},{v:'ZA',t:'Sur Africa'},
  {v:'SR',t:'Surinam'},{v:'SZ',t:'Swazilandia'},{v:'TH',t:'Tailandia'},{v:'TW',t:'Taiwán'},{v:'TZ',t:'Tanzania'},
  {v:'TJ',t:'Tayikistán'},{v:'TG',t:'Togo'},{v:'TO',t:'Tonga'},{v:'TT',t:'Trinidad y Tobago'},{v:'TN',t:'Tunez'},
  {v:'TM',t:'Turkmenistán'},{v:'TR',t:'Turquía'},{v:'TV',t:'Tuvalu'},{v:'UA',t:'Ucrania'},{v:'UG',t:'Uganda'},
  {v:'UY',t:'Uruguay'},{v:'UZ',t:'Uzbekistán'},{v:'VU',t:'Vanuatu'},{v:'VE',t:'Venezuela'},{v:'VN',t:'Vietnam'},
  {v:'YE',t:'Yemen'},{v:'ZM',t:'Zambia'},{v:'ZW',t:'Zimbabue'},{v:'ZL',t:'Zona Libre'}
];

// ── Control de acceso: solo vendedores y gerencia ──────────────────────────
function ncPuedeCrear(){
  try{
    var rol=(CU && CU.rol ? String(CU.rol) : '').toLowerCase();
    return rol==='vendedor' || rol==='gerencia' || rol==='admin' || rol==='administrador';
  }catch(e){ return false; }
}

function _ncOpts(arr, sel){
  return arr.map(function(o){ return '<option value="'+npEsc(String(o.v))+'"'+(String(o.v)===String(sel)?' selected':'')+'>'+npEsc(o.t)+'</option>'; }).join('');
}
function _ncField(label, inner, req){
  return '<div style="margin-bottom:12px">'
    +'<label style="display:block;font-size:12px;font-weight:600;color:var(--text2,#374151);margin-bottom:4px">'+npEsc(label)+(req?' <span style="color:#E24B4A">*</span>':'')+'</label>'
    +inner+'</div>';
}
function _ncInput(id, ph, req){
  return '<input id="'+id+'" type="text" placeholder="'+npEsc(ph||'')+'" autocomplete="off" '
    +'style="width:100%;padding:9px 11px;border:1px solid var(--border,#d1d5db);border-radius:8px;font-size:13px;outline:none;box-sizing:border-box'+(req?';background:#fff8f8':'')+'">';
}
function _ncSelect(id, arr, sel, req){
  return '<select id="'+id+'" style="width:100%;padding:9px 11px;border:1px solid var(--border,#d1d5db);border-radius:8px;font-size:13px;outline:none;box-sizing:border-box;background:'+(req?'#fff8f8':'#fff')+'">'
    +(req?'':'<option value="">— Seleccionar —</option>')+_ncOpts(arr, sel)+'</select>';
}

function nuevoCliente(){
  if(!ncPuedeCrear()){ alert('Solo vendedores y gerencia pueden crear clientes.'); return; }
  // Vendedor por defecto = el usuario actual si tiene slpcode
  var slpDef = (CU && CU.slpcode!=null) ? CU.slpcode : '';
  var html=''
  +'<div id="nc-overlay" style="position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.5);display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto">'
    +'<div style="background:var(--surface,#fff);border-radius:16px;max-width:820px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.3);margin:auto">'
      +'<div style="display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid var(--border,#eee)">'
        +'<h2 style="margin:0;font-size:17px;font-weight:700;color:var(--text,#111)">Nuevo cliente</h2>'
        +'<button onclick="ncCerrar()" style="background:none;border:none;font-size:24px;cursor:pointer;color:var(--text3,#9ca3af);line-height:1">&times;</button>'
      +'</div>'
      +'<div style="padding:22px;max-height:70vh;overflow-y:auto">'
        +'<div id="nc-msg" style="display:none;margin-bottom:14px;padding:10px 14px;border-radius:8px;font-size:13px"></div>'
        // Sección: Datos generales
        +'<div style="font-size:13px;font-weight:700;color:var(--blue,#2563eb);margin-bottom:12px;text-transform:uppercase;letter-spacing:.03em">Datos generales</div>'
        +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:0 16px">'
          +_ncField('Nombre', _ncInput('nc-name','Nombre del cliente',true), true)
          +_ncField('Nombre extranjero', _ncInput('nc-fname','Opcional'), false)
          +_ncField('Grupo', _ncSelect('nc-group', NC_GRUPOS, 105, true), true)
          +_ncField('Moneda', '<input value="US Dollar" disabled style="width:100%;padding:9px 11px;border:1px solid var(--border,#d1d5db);border-radius:8px;font-size:13px;background:#f3f4f6;color:#6b7280;box-sizing:border-box">', true)
          +_ncField('Federal Tax ID / RUC', _ncInput('nc-lictrad','Ej: 901370278',true), true)
          +_ncField('Forma de pago', _ncSelect('nc-forma', NC_FORMA_PAGO, '2', true), true)
          +_ncField('Condiciones de pago (SAP)', _ncSelect('nc-condpago', NC_COND_PAGO, '-1', true), true)
          +_ncField('Teléfono', _ncInput('nc-tel','Ej: +57 300 1234567',true).replace('<input ','<input maxlength="20" '), true)
          +_ncField('E-mail', _ncInput('nc-email','Ej: compras@cliente.com',true), true)
        +'</div>'
        // Sección: Dirección
        +'<div style="font-size:13px;font-weight:700;color:var(--blue,#2563eb);margin:8px 0 12px;text-transform:uppercase;letter-spacing:.03em">Dirección</div>'
        +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:0 16px">'
          +_ncField('Address ID', _ncInput('nc-addrid','Ej: COLOMBIA',true), true)
          +_ncField('País', _ncSelect('nc-country', NC_PAISES, 'CO', true), true)
          +_ncField('Address Name 2', _ncInput('nc-addr2','Ej: CR 9 22-85',true), true)
          +_ncField('Address Name 3', _ncInput('nc-addr3','Ej: CHIA',true), true)
        +'</div>'
        // Sección: Facturación electrónica / fiscal
        +'<div style="font-size:13px;font-weight:700;color:var(--blue,#2563eb);margin:8px 0 12px;text-transform:uppercase;letter-spacing:.03em">Datos fiscales</div>'
        +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:0 16px">'
          +_ncField('RUC', _ncInput('nc-ruc','',true), true)
          +_ncField('DV', _ncInput('nc-dv','Opcional (ej: 5)'), false)
          +_ncField('Tipo de RUC', _ncSelect('nc-tipruc', NC_TIPO_RUC, 'Jurídico', true), true)
          +_ncField('Tipo de Receptor', _ncSelect('nc-tiprec', NC_TIPO_RECEPTOR, 'Extrangero', true), true)
          +_ncField('FE Envío del contenedor', _ncSelect('nc-feenvio', NC_FE_ENVIO, 'Normal', true), true)
          +_ncField('FE Tipo de RUC', _ncSelect('nc-fetipruc', NC_FE_TIPO_RUC, 'Juridico', true), true)
          +_ncField('FE Tipo de Receptor', _ncSelect('nc-fetiprec', NC_FE_TIPO_RECEPTOR, 'Extranjero', true), true)
        +'</div>'
      +'</div>'
      +'<div style="display:flex;justify-content:flex-end;gap:10px;padding:16px 22px;border-top:1px solid var(--border,#eee)">'
        +'<button onclick="ncCerrar()" style="padding:9px 18px;border:1px solid var(--border,#d1d5db);border-radius:9px;background:var(--surface,#fff);font-size:13px;cursor:pointer;color:var(--text2,#374151)">Cancelar</button>'
        +'<button id="nc-btn" onclick="ncGuardar()" style="padding:9px 22px;border:none;border-radius:9px;background:var(--blue,#2563eb);color:#fff;font-size:13px;font-weight:600;cursor:pointer">Crear cliente en SAP</button>'
      +'</div>'
    +'</div>'
  +'</div>';
  var d=document.createElement('div'); d.innerHTML=html; document.body.appendChild(d.firstChild);
}
function ncCerrar(){ var o=document.getElementById('nc-overlay'); if(o)o.remove(); }
function _ncVal(id){ var e=document.getElementById(id); return e?String(e.value||'').trim():''; }
function _ncMsg(txt, ok){
  var m=document.getElementById('nc-msg'); if(!m)return;
  m.style.display='block';
  m.style.background = ok ? 'rgba(99,153,34,.1)' : 'rgba(226,75,74,.08)';
  m.style.color = ok ? 'var(--green,#639922)' : '#E24B4A';
  m.innerHTML=txt;
}

async function ncGuardar(){
  // Validación de obligatorios
  var req = {
    'nc-name':'Nombre', 'nc-lictrad':'Federal Tax ID / RUC', 'nc-addrid':'Address ID',
    'nc-addr2':'Address Name 2', 'nc-addr3':'Address Name 3', 'nc-ruc':'RUC',
    'nc-tel':'Teléfono', 'nc-email':'E-mail'
  };
  var faltan=[];
  Object.keys(req).forEach(function(k){ if(!_ncVal(k)) faltan.push(req[k]); });
  // Selects obligatorios
  var selReq={'nc-group':'Grupo','nc-forma':'Forma de pago','nc-condpago':'Condiciones de pago','nc-country':'País','nc-tipruc':'Tipo de RUC',
    'nc-tiprec':'Tipo de Receptor','nc-feenvio':'FE Envío','nc-fetipruc':'FE Tipo de RUC','nc-fetiprec':'FE Tipo de Receptor'};
  Object.keys(selReq).forEach(function(k){ if(!_ncVal(k)) faltan.push(selReq[k]); });
  if(faltan.length){ _ncMsg('Faltan campos obligatorios: <b>'+faltan.join(', ')+'</b>', false); return; }

  // Al volverlos obligatorios hay que mirar tambien QUE se escribio: si no, se
  // acaba llenando con un guion para pasar el paso y el dato no sirve. El
  // correo y el telefono se usan para mandarle al cliente su factura y para
  // localizarlo, asi que un valor de relleno es peor que ninguno.
  var email=_ncVal('nc-email');
  if(!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)){
    _ncMsg('El <b>e-mail</b> no parece válido: <b>'+npEsc(email)+'</b>', false); return;
  }
  var tel=_ncVal('nc-tel');
  // SAP corta a 20 caracteres en OCRD.Phone1 y a 100 en E_Mail. Pasarse no
  // recorta: aborta el alta con "String or binary data would be truncated" y
  // sin decir que campo fue. Mejor avisar aqui, con el campo delante.
  if(tel.length > 20){
    _ncMsg('El <b>teléfono</b> no puede pasar de 20 caracteres (SAP no admite más). '
      +'Tienes '+tel.length+'. Quita espacios o la extensión.', false); return;
  }
  if(email.length > 100){
    _ncMsg('El <b>e-mail</b> no puede pasar de 100 caracteres. Tienes '+email.length+'.', false);
    return;
  }
  if((tel.match(/\d/g)||[]).length < 7){
    _ncMsg('El <b>teléfono</b> debe tener al menos 7 dígitos. Incluye el código '
      +'del país si el cliente está fuera de Panamá.', false); return;
  }

  var btn=document.getElementById('nc-btn'); if(btn){btn.disabled=true;btn.textContent='Creando…';}

  var payload={
    estado:'pendiente',
    cardname:_ncVal('nc-name'),
    groupcode:parseInt(_ncVal('nc-group'))||105,
    // El nombre tal como lo tiene la empresa en SAP. kennedy_live lo traduce
    // al codigo real de OCRN antes de grabar: mandar 'USD' a secas dejaba el
    // cliente con una moneda que SAP no reconocia y fallaba su primer pedido.
    currency:'US Dolar',
    lictradnum:_ncVal('nc-lictrad'),
    address_id:_ncVal('nc-addrid'),
    address2:_ncVal('nc-addr2'),
    address3:_ncVal('nc-addr3'),
    country:_ncVal('nc-country'),
    forma_pago:_ncVal('nc-forma'),
    groupnum:parseInt(_ncVal('nc-condpago')),
    ruc:_ncVal('nc-ruc'),
    dv:_ncVal('nc-dv'),
    tipo_ruc:_ncVal('nc-tipruc'),
    tipo_receptor:_ncVal('nc-tiprec'),
    fe_envio:_ncVal('nc-feenvio'),
    fe_tipo_ruc:_ncVal('nc-fetipruc'),
    fe_tipo_recep:_ncVal('nc-fetiprec'),
    slpcode:(CU && CU.slpcode!=null)?CU.slpcode:null,
    creado_por:(CU && CU.usuario)?CU.usuario:(CU && CU.rol)||'portal'
  };
  // Telefono y correo son obligatorios: van siempre.
  payload.tel=tel;
  payload.email=email;
  // El unico que sigue siendo opcional.
  var fn=_ncVal('nc-fname');  if(fn) payload.foreign_name=fn;

  try{
    var resp=await fetch(SB+'/rest/v1/clientes_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=minimal'},
      body:JSON.stringify(payload)
    });
    if(resp.ok){
      _ncMsg('✓ Cliente enviado a SAP. Se creará en unos momentos y aparecerá en la lista de clientes.', true);
      if(btn){btn.textContent='Enviado ✓';}
      setTimeout(ncCerrar, 2200);
    }else{
      var t=await resp.text();
      _ncMsg('Error al enviar: '+t.slice(0,200), false);
      if(btn){btn.disabled=false;btn.textContent='Crear cliente en SAP';}
    }
  }catch(e){
    _ncMsg('Error de conexión: '+e.message, false);
    if(btn){btn.disabled=false;btn.textContent='Crear cliente en SAP';}
  }
}

// =============================================================================

// ════════════════════════════════════════════════════════════════════
//  MERCANCIA POR LLEGAR
//  Ordenes de compra abiertas (OPOR/POR1) con cantidad pendiente de
//  recibir, agrupadas por DEPARTAMENTO y por FECHA DE LLEGADA (ETA).
//  Datos: opor_ordenes + opor_lineas, que kennedy_live ya sincroniza.
// ════════════════════════════════════════════════════════════════════
// Columna de fecha de llegada en la tabla: opcional, porque no siempre
// interesa y ocupa ancho.
var PL_VER_FECHA = false;
function plVerFecha(v){ PL_VER_FECHA=!!v; plRender(); }

var PL_ROWS=[], plAgrupF='dept', plVentanaF='', plQF='', plDeptF='', plOpen={}, plCargando=false;

function plInit(){
  var box=document.getElementById('pl-result'); if(!box) return;
  if(PL_ROWS && PL_ROWS.length){ plRender(); return; }
  plCargar();
}

// Fecha de llegada: el ETA del proveedor; si no hay, la fecha de entrega pactada.
function _plFecha(o){
  if(!o) return '';
  var f=o.eta||o.duedate||'';
  return String(f||'').substring(0,10);
}
function _plFechaLbl(f){
  if(!f) return 'Sin fecha confirmada';
  var p=String(f).split('-');
  return p.length===3 ? (p[2]+'-'+p[1]+'-'+p[0]) : String(f);
}
function _plMesLbl(f){
  if(!f) return 'Sin fecha confirmada';
  var MES=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var p=String(f).split('-');
  if(p.length<2) return String(f);
  var m=parseInt(p[1],10)-1;
  return (MES[m]||p[1])+' '+p[0];
}
function _plDias(f){
  if(!f) return null;
  var t=new Date(String(f)+'T00:00:00');
  if(isNaN(t.getTime())) return null;
  return Math.round((t.getTime()-new Date().setHours(0,0,0,0))/86400000);
}
function _plBadgeFecha(f){
  var d=_plDias(f);
  if(d===null) return '<span class="badge" style="background:#F3F4F6;color:#6B7280">sin fecha</span>';
  if(d<0)   return '<span class="badge b-red">atrasada '+Math.abs(d)+'d</span>';
  if(d<=15) return '<span class="badge b-amber">en '+d+' d\u00edas</span>';
  if(d<=45) return '<span class="badge b-blue">en '+d+' d\u00edas</span>';
  return '<span class="badge b-green">en '+d+' d\u00edas</span>';
}

async function plCargar(){
  var box=document.getElementById('pl-result'); if(!box || plCargando) return;
  plCargando=true;
  box.innerHTML='<div class="card" style="padding:20px;color:var(--text3);font-size:13px">Buscando mercanc\u00eda en tr\u00e1nsito\u2026</div>';
  try{
    var res=await Promise.all([
      qAll('opor_ordenes','select=docnum,docdate,duedate,'+(veProveedor()?'vendor_name,':'')+'estado,estado_compra,eta,pais,barco,contenedor,num_contenedor_campo,puerto_embarque,marca_cliente'),
      qAll('opor_lineas','select=docnum,itemcode,itemname,cantidad,cantidad_pendiente,precio,total_linea,grupo_items,cantidad_empaque,unidad_medida,picturname,foto_url&cantidad_pendiente=gt.0')
    ]);
    var ords=res[0]||[], lins=res[1]||[];

    // OJO: opor_lineas.precio es el precio de COMPRA al proveedor. Para el
    // carrito hace falta el de VENTA, asi que se busca en el catalogo. Si se
    // mandara el de la OC, se cotizaria al costo.
    var venta={};
    try{
      var codes=[]; var vistos={};
      lins.forEach(function(l){ if(l.itemcode && !vistos[l.itemcode]){ vistos[l.itemcode]=1; codes.push(l.itemcode); } });
      for(var i=0;i<codes.length;i+=500){
        var lote=codes.slice(i,i+500).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
        var inv=await q('vista_inventario','select=itemcode,precioventa,unidadesbulto&itemcode=in.('+lote+')&limit=500');
        (inv||[]).forEach(function(x){ venta[x.itemcode]={p:Number(x.precioventa)||0, pk:Number(x.unidadesbulto)||0}; });
      }
    }catch(e){ venta={}; }

    var porDoc={};
    ords.forEach(function(o){ porDoc[String(o.docnum)]=o; });

    PL_ROWS=lins.map(function(l){
      var o=porDoc[String(l.docnum)]||null;
      var emp=Number(l.cantidad_empaque)||0;
      var pend=Number(l.cantidad_pendiente)||0;
      var vt=venta[l.itemcode]||{};
      // Empaque: manda el de la OC; si no viene, el del catalogo.
      var pk=emp>0 ? emp : (Number(vt.pk)||1);
      return {
        docnum:l.docnum, itemcode:l.itemcode, itemname:l.itemname,
        dept:(l.grupo_items||'(Sin departamento)'),
        pend:pend,
        bultos:(emp>0 ? pend/emp : 0),
        precio:Number(l.precio)||0,            // de compra: solo para el valor de la OC
        precioVenta:Number(vt.p)||0,           // el que va al carrito
        pk:pk,
        valor:pend*(Number(l.precio)||0),
        picturname:l.picturname||'', foto_url:l.foto_url||'',
        fecha:_plFecha(o),
        proveedor:(o&&o.vendor_name)||'', pais:(o&&o.pais)||'',
        barco:(o&&o.barco)||'', contenedor:(o&&(o.num_contenedor_campo||o.contenedor))||'',
        estado:(o&&(o.estado_compra||o.estado))||''
      };
    });

    // Sembrar el cache de fotos con lo que ya vino.
    PL_ROWS.forEach(function(x){
      if(x.itemcode && (x.picturname||x.foto_url) && !NP_FOTO_CACHE[x.itemcode]){
        NP_FOTO_CACHE[x.itemcode]={pn:x.picturname||'',fu:x.foto_url||''};
      }
    });

    plLlenarDepts();
    plRender();
  }catch(e){
    box.innerHTML='<div class="card" style="padding:18px">'
      +'<div style="color:var(--red);font-weight:600;font-size:13px">No se pudo cargar el reporte</div>'
      +'<div style="font-size:12px;color:var(--text3);margin-top:6px">'+npEsc(String(e.message||e))+'</div>'
      +'</div>';
  }finally{ plCargando=false; }
}

function plLlenarDepts(){
  var sel=document.getElementById('pl-dept'); if(!sel) return;
  var ds={};
  PL_ROWS.forEach(function(r){ ds[r.dept]=1; });
  var lista=Object.keys(ds).sort();
  sel.innerHTML='<option value="">Todos los departamentos</option>'
    + lista.map(function(d){ return '<option value="'+npEsc(d)+'"'+(d===plDeptF?' selected':'')+'>'+npEsc(d)+'</option>'; }).join('');
}

function plAgrup(v){ plAgrupF=v||'dept'; plOpen={}; plRender(); }

// La etiqueta de cada entrada. Con permiso de compras se ve el proveedor;
// sin el, solo la orden y su fecha, que es lo que hace falta para
// distinguir un embarque de otro.
var _PL_ENT = {};
function _plEntradaLbl(r){
  var oc = String(r.docnum || r.oc || '').trim();
  if(typeof veProveedor==='function' && veProveedor()){
    var prov = String(r.proveedor||'').trim();
    return (prov ? prov : 'Sin proveedor') + (oc ? (' \u00b7 OC ' + oc) : '');
  }
  // Sin permiso: se numeran las entradas por orden de llegada.
  if(!oc) return 'Entrada sin identificar';
  if(!_PL_ENT[oc]) _PL_ENT[oc] = 'Entrada ' + (Object.keys(_PL_ENT).length + 1);
  return _PL_ENT[oc] + (r.fecha ? (' \u00b7 ' + _plFechaLbl(r.fecha)) : '');
}
function plVentana(v){ plVentanaF=v||''; plRender(); }
function plDeptSel(v){ plDeptF=v||''; plRender(); }
function plBuscar(v){ plQF=String(v||'').trim().toLowerCase(); plRender(); }
function plToggle(k){ plOpen[k]=!plOpen[k]; plRender(); }
function plAbrirTodos(on){ Object.keys(_plGrupos(plFiltradas())).forEach(function(k){ plOpen[k]=!!on; }); plRender(); }

function plFiltradas(){
  var q=plQF, v=plVentanaF;
  return (PL_ROWS||[]).filter(function(r){
    if(plDeptF && String(r.dept)!==plDeptF) return false;
    if(v){
      var d=_plDias(r.fecha);
      if(v==='sinfecha'){ if(r.fecha) return false; }
      else if(v==='atrasada'){ if(d===null || d>=0) return false; }
      else { var lim=Number(v)||0; if(d===null || d>lim) return false; }
    }
    if(!q) return true;
    return String(r.itemcode||'').toLowerCase().indexOf(q)>=0
        || String(r.itemname||'').toLowerCase().indexOf(q)>=0
        || String(r.proveedor||'').toLowerCase().indexOf(q)>=0
        || String(r.contenedor||'').toLowerCase().indexOf(q)>=0
        || String(r.docnum||'').toLowerCase().indexOf(q)>=0;
  });
}

// Agrupa segun el modo elegido y devuelve {clave: {items, pend, bultos, valor, orden}}
function _plGrupos(rows){
  var g={};
  rows.forEach(function(r){
    var k, ord;
    if(plAgrupF==='fecha'){ k=_plMesLbl(r.fecha); ord=r.fecha||'9999-99'; }
    else if(plAgrupF==='entrada'){
      // Por embarque. A los vendedores no se les dice QUIEN es el proveedor,
      // solo que son entradas distintas: les basta para armar el catalogo de
      // cada una por separado.
      k = _plEntradaLbl(r);
      ord = (r.fecha||'9999-99') + '|' + k;
    }
    else { k=r.dept; ord=r.dept; }
    if(!g[k]) g[k]={items:[], pend:0, bultos:0, valor:0, orden:ord};
    g[k].items.push(r);
    g[k].pend+=r.pend; g[k].bultos+=r.bultos; g[k].valor+=r.valor;
    if(String(ord)<String(g[k].orden)) g[k].orden=ord;
  });
  return g;
}

// Anade UN BULTO de mercancia que aun no ha llegado. Se puede pedir porque
// esta en camino: el pedido queda pendiente hasta que entre al almacen.
function _plBtnCarrito(r){
  var pk=Number(r.pk)||1;
  var cs=String(r.itemcode||'').replace(/'/g,"\\'");
  var nm=String(r.itemname||'').replace(/['"\\]/g,' ').slice(0,80);
  var pv=Number(r.precioVenta)||0;
  return '<button class="btn btn-sm btn-p" '
    +'onclick="plAlCarrito(\''+cs+'\',\''+nm+'\','+pv+','+pk+')" '
    +'title="A\u00f1adir 1 bulto ('+pk+' und) al pedido. Esta mercanc\u00eda a\u00fan no ha llegado."'
    +' style="padding:3px 9px">+ '+pk+'</button>';
}

function plAlCarrito(code, nombre, precio, bulto){
  try{
    if(!precio){
      if(!confirm('Este art\u00edculo no tiene precio de venta en el cat\u00e1logo.\n\n'
        +'Se a\u00f1adir\u00e1 en 0 y habr\u00e1 que ponerle el precio a mano. \u00bfSigo?')) return;
    }
    npAgregarLineaDirecta(code, nombre, Number(precio)||0, Number(bulto)||1);
  }catch(e){ alert('No se pudo a\u00f1adir: '+(e.message||e)); }
}

function plRender(){
  try{ plExpCampos(); }catch(e){}
  var box=document.getElementById('pl-result'); if(!box) return;

  if(!(PL_ROWS||[]).length){
    box.innerHTML='<div class="card" style="padding:20px;text-align:center;color:var(--text3);font-size:13px">No hay mercanc\u00eda pendiente de llegar.</div>';
    return;
  }

  var rows=plFiltradas();
  if(!rows.length){
    box.innerHTML='<div class="card" style="padding:20px;text-align:center;color:var(--text3);font-size:13px">Ning\u00fan art\u00edculo con ese filtro.</div>';
    return;
  }

  var totP=0, totB=0, totV=0, docs={}, conts={};
  rows.forEach(function(r){
    totP+=r.pend; totB+=r.bultos; totV+=r.valor;
    docs[r.docnum]=1; if(r.contenedor) conts[r.contenedor]=1;
  });

  var resumen='<div class="card" style="margin-bottom:12px;display:flex;gap:22px;flex-wrap:wrap;align-items:center;padding:13px 16px">'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Art\u00edculos</div><div style="font-size:19px;font-weight:700">'+fmtN(rows.length)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Unidades</div><div style="font-size:19px;font-weight:700">'+fmtN(Math.round(totP))+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Bultos</div><div style="font-size:19px;font-weight:700">'+fmtN(Math.round(totB))+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">\u00d3rdenes</div><div style="font-size:19px;font-weight:700">'+fmtN(Object.keys(docs).length)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Contenedores</div><div style="font-size:19px;font-weight:700">'+fmtN(Object.keys(conts).length)+'</div></div>'
    +(veCompras()?('<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Valor de compra</div><div style="font-size:19px;font-weight:700;color:var(--blue2)">'+fmt(totV)+'</div></div>'):'')
    +'</div>';
  var g=_plGrupos(rows);
  var claves=Object.keys(g).sort(function(a,b){
    if(plAgrupF==='fecha') return String(g[a].orden).localeCompare(String(g[b].orden));  // cronologico
    return g[b].items.length-g[a].items.length;                                          // el mas cargado primero
  });

  var secciones=claves.map(function(k){
    var d=g[k];
    var cerrado=!plOpen[k];
    var kJs=String(k).replace(/'/g,"\\'");

    var head='<div class="ch" style="cursor:pointer;margin-bottom:'+(cerrado?'0':'10px')+'" onclick="plToggle(\'' + kJs + '\')">'
      +'<span class="ct">'+(cerrado?'\u25b8':'\u25be')+' '+npEsc(k)+'</span>'
      +'<span style="font-size:11.5px;color:var(--text3);font-weight:500">'
        +fmtN(d.items.length)+' art. \u00b7 '+fmtN(Math.round(d.pend))+' und \u00b7 '
        +fmtN(Math.round(d.bultos))+' bultos'+(veCompras()?(' \u00b7 '+fmt(d.valor)):'')
        // Catalogo de ESTE grupo: es lo que se manda al cliente de un
        // embarque o un departamento concreto.
        +' <button class="btn btn-sm" style="padding:2px 9px;margin-left:8px" '
        +'onclick="event.stopPropagation();catDesdePorLlegar(\''+kJs+'\')" '
        +'title="Armar cat\u00e1logo de este grupo">\u{1F4D6} Cat\u00e1logo</button>'
      +'</span></div>';

    if(cerrado) return '<div class="card" style="margin-bottom:10px;padding:12px 16px">'+head+'</div>';

    // Dentro de cada seccion, lo que llega primero va arriba (sin fecha, al final).
    var lista=d.items.slice().sort(function(a,b){
      var fa=a.fecha||'9999-12-31', fb=b.fecha||'9999-12-31';
      if(fa!==fb) return fa.localeCompare(fb);
      return b.pend-a.pend;
    });

    var filas=lista.map(function(r){
      var cJs=String(r.itemcode).replace(/'/g,"\\'");
      var sub=(plAgrupF==='fecha') ? npEsc(r.dept) : _plFechaLbl(r.fecha);
      return '<tr>'
        +'<td style="width:52px">'+fotoThumb(r.picturname,r.foto_url)+'</td>'
        +'<td><a href="javascript:void(0)" onclick="verItem(\''+cJs+'\')" style="font-weight:600;color:var(--blue2);text-decoration:none">'+npEsc(r.itemcode)+'</a>'
          +'<div style="font-size:11.5px;color:var(--text3);margin-top:1px">'+npEsc(String(r.itemname||'').substring(0,70))+'</div></td>'
        +'<td style="font-size:11.5px;color:var(--text3)">'+sub+'</td>'
        +'<td style="text-align:right;font-weight:600">'+fmtN(Math.round(r.pend))+'</td>'
        +'<td style="text-align:right">'+fmtN(Math.round(r.bultos*100)/100)+'</td>'
        +(veCompras()?('<td style="text-align:right">'+fmt(r.valor)+'</td>'):'')
        +(veProveedor()?('<td style="font-size:11.5px">'+npEsc(String(r.proveedor||'').substring(0,28))
          +(r.contenedor?('<div style="color:var(--text3)">'+npEsc(r.contenedor)+'</div>'):'')+'</td>'):'')
        +'<td style="white-space:nowrap">'+_plBadgeFecha(r.fecha)+'</td>'
        // Fecha exacta, solo si se pidio: la etiqueta de al lado dice "en 12
        // dias", pero a veces hace falta el dia concreto para planificar.
        +(PL_VER_FECHA
            ? ('<td style="white-space:nowrap;font-size:11.5px;color:var(--text3)">'
               +(r.fecha ? _plFechaLbl(r.fecha) : 'por confirmar')+'</td>')
            : '')
        +'</tr>';
    }).join('');

    return '<div class="card" style="margin-bottom:10px">'+head
      +'<div style="overflow-x:auto"><table class="tbl">'
      +'<tr><th></th><th>Art\u00edculo</th><th>'+(plAgrupF==='fecha'?'Departamento':'Llegada')+'</th>'
      +'<th style="text-align:right">Unidades</th><th style="text-align:right">Bultos</th>'
      +(veCompras()?'<th style="text-align:right">Valor</th>':'')
      +(PL_VER_FECHA?'<th>Llegada</th>':'')
      +(veProveedor()?'<th>Proveedor</th>':'')+'<th>Estado</th>'
      +'</tr>'
      +filas+'</table></div></div>';
  }).join('');

  var barra='<div style="display:flex;gap:8px;margin-bottom:10px">'
    +'<button class="btn" onclick="plAbrirTodos(true)" style="font-size:12px">Abrir todo</button>'
    +'<button class="btn" onclick="plAbrirTodos(false)" style="font-size:12px">Cerrar todo</button></div>';

  box.innerHTML=resumen+barra+secciones;
}

var _PL_NAV='<div class="ni" id="nav-porllegar" onclick="go(\'porllegar\',this)">'
  +'<svg style="color:#38BDF8" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">'
  +'<path d="M2 17h20"/><path d="M4 17V9a2 2 0 0 1 2-2h8v10"/><path d="M14 9h3.5a2 2 0 0 1 1.7 1l1.8 3v4"/>'
  +'<circle cx="7.5" cy="19" r="2"/><circle cx="17.5" cy="19" r="2"/></svg>'
  +'Mercanc\u00eda por llegar</div>';

var _PL_PAGE='<div class="page" id="page-porllegar">'
  +'<div class="card">'
    +'<div class="ch"><span class="ct">Mercanc\u00eda en tr\u00e1nsito</span></div>'
    +'<div style="font-size:12px;color:var(--text3);margin-bottom:12px">\u00d3rdenes de compra abiertas con cantidad pendiente de recibir. La fecha de llegada es el <b>ETA</b> del proveedor; si no lo tiene, se usa la fecha de entrega pactada.</div>'
    +'<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap">'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Agrupar por</label>'
        +'<select id="pl-agrup" onchange="plAgrup(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="dept" selected>Departamento</option>'
        +'<option value="fecha">Fecha de llegada</option>'
        +'<option value="entrada">Entrada / embarque</option></select></div>'
      +'<div style="display:flex;align-items:flex-end">'
        +'<button class="btn btn-p" onclick="plEntradasAbrir()" style="padding:9px 15px" '
        +'title="Armar cat\u00e1logo eligiendo una o varias entradas">'
        +'\u{1F4D6} Cat\u00e1logo por entrada</button></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Llegada</label>'
        +'<select id="pl-ventana" onchange="plVentana(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="" selected>Todas</option><option value="atrasada">Atrasadas</option><option value="30">Pr\u00f3ximos 30 d\u00edas</option>'
        +'<option value="60">Pr\u00f3ximos 60 d\u00edas</option><option value="90">Pr\u00f3ximos 90 d\u00edas</option><option value="sinfecha">Sin fecha</option></select></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Departamento</label>'
        +'<select id="pl-dept" onchange="plDeptSel(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff;max-width:230px">'
        +'<option value="">Todos los departamentos</option></select></div>'
      +'<div style="flex:1;min-width:200px"><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Buscar</label>'
        +'<input type="text" id="pl-q" placeholder="SKU, descripci\u00f3n, proveedor, contenedor, OC..." oninput="plBuscar(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;width:100%;outline:none;box-sizing:border-box"></div>'
      +'<button class="btn btn-p" onclick="pvAbrir()" title="Ver qu\u00e9 le llega a los clientes de cada vendedor">\u{1F464} Por vendedor</button>'
      +'<button class="btn" onclick="PL_ROWS=[];plCargar()">Recargar</button>'
      +'<label style="display:flex;align-items:center;gap:6px;font-size:12.5px;color:var(--text3);cursor:pointer">'
        +'<input type="checkbox" id="pl-verfecha" onchange="plVerFecha(this.checked)"'+(PL_VER_FECHA?' checked':'')+'> '
        +'Ver fecha de llegada</label>'
    +'</div>'
    +'<div class="card" style="margin:12px 0 0">'
      +'<div class="ch" style="flex-wrap:wrap;gap:8px"><span class="ct">\u2b07 Exportar lo filtrado</span>'
        +'<span style="display:flex;gap:8px">'
        +'<button class="btn btn-p btn-sm" onclick="plExportar(\'pdf\')">Generar PDF</button>'
        +'<button class="btn btn-sm" onclick="plExportar(\'excel\')" style="background:var(--green);color:#fff;border-color:var(--green)">Generar Excel</button>'
        +'</span></div>'
      +'<div id="pl-campos"></div>'
      +'<div id="pl-export-info" style="font-size:12px;margin-top:8px"></div>'
    +'</div>'
  +'</div>'
  +'<div id="pl-result"></div>'
+'</div>';

function _plMontarUI(){
  try{
    if(!document.getElementById('nav-porllegar')){
      var ref=document.getElementById('nav-sinrot')||document.getElementById('nav-tva')
            ||document.getElementById('nav-inv')||document.getElementById('nav-sep');
      if(ref && ref.insertAdjacentHTML) ref.insertAdjacentHTML('afterend', _PL_NAV);
    }
    if(!document.getElementById('page-porllegar')){
      var pg=document.getElementById('page-sinrotacion')||document.getElementById('page-separados')
           ||document.getElementById('page-inventario')||document.querySelector('.page');
      if(pg && pg.insertAdjacentHTML) pg.insertAdjacentHTML('afterend', _PL_PAGE);
    }
  }catch(e){}
}
// Va despues del montaje de "sin rotacion" para poder anclarse a su nav.
if(document.readyState!=='loading'){ setTimeout(function(){ try{_plMontarUI();}catch(e){} },0); }
else { document.addEventListener('DOMContentLoaded',function(){ setTimeout(function(){ try{_plMontarUI();}catch(e){} },0); }); }


// ════════════════════════════════════════════════════════════════════
//  1) LIVE CHAT en tiempo real (solo vendedores y administradores)
//  2) PEDIDOS REALIZADOS (cotizaciones enviadas a SAP por cada usuario)
//
//  Usa de kennedy-1.js: SB, KEY, CU, SESS, AUTHTOK, q, qAll, $, npEsc,
//  fmt, fmtN, go, verItem, verCliente, verPedido.
// ════════════════════════════════════════════════════════════════════

// ════════════════════════════════════════════════════════════════════
//  1. LIVE CHAT
// ════════════════════════════════════════════════════════════════════
var CH_SB = null;          // cliente supabase-js (solo para el realtime)

// Al perder la red se corta el socket: si no, reintenta sin parar.
window.addEventListener('offline', function(){
  try{
    if(CH_CANAL && CH_SB){ CH_SB.removeChannel(CH_CANAL); CH_CANAL = null; }
    if(CH_SB && CH_SB.realtime && CH_SB.realtime.disconnect) CH_SB.realtime.disconnect();
    CH_LISTO = false;      // se vuelve a montar al reconectar
  }catch(e){}
});
window.addEventListener('online', function(){
  try{ if(typeof chatArrancar==='function') setTimeout(chatArrancar, 1200); }catch(e){}
});
var CH_CANAL = null;
var CH_USERS = [];         // companeros de trabajo
var CH_MSGS = {};          // {sala: [mensajes]}
var CH_SALA = 'general';   // sala abierta
var CH_NOLEIDOS = {};      // {usuario|general: cantidad}
var CH_LISTO = false;
var CH_GRABANDO = null;    // MediaRecorder activo
var CH_MARCA = {};         // {sala: ultimo id ya marcado como leido}

var CH_EMOJIS = ['\u{1F44D}','\u{1F44C}','\u{1F64F}','\u{1F44F}','\u{1F4AA}','\u{1F525}','\u2705','\u274C',
  '\u{1F603}','\u{1F602}','\u{1F609}','\u{1F60D}','\u{1F914}','\u{1F62E}','\u{1F625}','\u{1F621}',
  '\u2764\uFE0F','\u{1F389}','\u{1F44B}','\u{1F91D}','\u{1F4E6}','\u{1F69A}','\u{1F4B0}','\u{1F4C4}',
  '\u23F0','\u26A0\uFE0F','\u2757','\u2753','\u{1F4CC}','\u{1F440}','\u{1F44A}','\u{1F929}'];

// Nombre de la sala: 'general' o los dos usuarios ordenados alfabeticamente,
// asi los dos lados calculan exactamente la misma clave.
function chSala(a, b){
  if(!b || b==='general') return 'general';
  return [String(a).toLowerCase(), String(b).toLowerCase()].sort().join('|');
}
function chYo(){ return (CU && CU.username) ? String(CU.username).toLowerCase() : ''; }

// Carga supabase-js solo cuando hace falta (para el websocket del realtime).
var _chLibPromise = null;
function chCargarLib(){
  if(window.supabase && window.supabase.createClient) return Promise.resolve(window.supabase);
  if(_chLibPromise) return _chLibPromise;
  _chLibPromise = new Promise(function(res, rej){
    var sc=document.createElement('script');
    sc.src='https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2.45.4/dist/umd/supabase.js';
    sc.onload=function(){ window.supabase ? res(window.supabase) : rej(new Error('supabase-js no disponible')); };
    sc.onerror=function(){ rej(new Error('No se pudo cargar la libreria del chat (revisa la conexion)')); };
    document.head.appendChild(sc);
  });
  return _chLibPromise;
}

// Arranca el chat en segundo plano: se suscribe y cuenta lo no leido.
// Se llama al entrar al portal, no hace falta abrir la pagina.
async function chatArrancar(){
  if(CH_LISTO || !CU || CU.rol==='cliente') return;
  // Sin conexion el chat no puede hacer nada y su socket reintenta cada pocos
  // segundos, llenando la consola de errores y tapando los mensajes utiles.
  if(!navigator.onLine) return;
  CH_LISTO = true;
  try{
    var lib = await chCargarLib();
    CH_SB = lib.createClient(SB, KEY, {
      auth:{persistSession:false, autoRefreshToken:false},
      realtime:{params:{eventsPerSecond:10}}
    });
    if(SESS && SESS.access_token) CH_SB.realtime.setAuth(SESS.access_token);

    await chCargarUsuarios();
    await chCargarNoLeidos();
    chSuscribir();
    chPintarBadge();
    try{ chPintarCabecera(); chAjustarVista(); }catch(e){}
  }catch(e){
    console.warn('[chat] no arranco:', e && e.message);
    CH_LISTO = false;
  }
}

function chSuscribir(){
  if(!CH_SB || CH_CANAL) return;
  CH_CANAL = CH_SB.channel('chat-portal')
    .on('postgres_changes', {event:'INSERT', schema:'public', table:'chat_mensajes'}, function(p){
      chEntrante(p.new);
    })
    .subscribe();
}

// Llega un mensaje nuevo por el websocket.
function chEntrante(m){
  if(!m) return;
  var yo = chYo();
  var mio = String(m.de_usuario||'').toLowerCase() === yo;
  var paraMi = m.sala==='general' || String(m.para_usuario||'').toLowerCase() === yo;
  if(!mio && !paraMi) return;              // conversacion ajena

  if(!CH_MSGS[m.sala]) CH_MSGS[m.sala]=[];
  if(CH_MSGS[m.sala].some(function(x){ return x.id===m.id; })) return;   // ya lo tengo
  CH_MSGS[m.sala].push(m);

  var abierto = (CH_SALA===m.sala) && document.getElementById('page-chat')
             && document.getElementById('page-chat').classList.contains('active');

  if(!mio && !abierto){
    var k = (m.sala==='general') ? 'general' : String(m.de_usuario).toLowerCase();
    CH_NOLEIDOS[k] = (CH_NOLEIDOS[k]||0) + 1;
    chPintarBadge();
    chTono();
  }
  if(abierto){
    chPintarMensajes();
    if(!mio) chMarcarLeidos(m.sala);
  }
  chPintarLista();
}

// Sonido corto y discreto, sin archivos externos.
function chTono(){
  try{
    var AC = window.AudioContext||window.webkitAudioContext; if(!AC) return;
    var ctx=new AC(), o=ctx.createOscillator(), g=ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.frequency.value=880; g.gain.value=0.05;
    o.start(); o.stop(ctx.currentTime+0.12);
    setTimeout(function(){ try{ctx.close();}catch(e){} }, 400);
  }catch(e){}
}

async function chCargarUsuarios(){
  try{
    var r = await fetch(SB+'/rest/v1/rpc/chat_usuarios', {
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},
      body:'{}'
    });
    if(!r.ok) throw new Error(r.status+': '+(await r.text()).slice(0,140));
    var d = await r.json();
    var yo = chYo();
    CH_USERS = (Array.isArray(d)?d:[]).filter(function(u){
      return String(u.usuario||'').toLowerCase() !== yo;
    }).sort(function(a,b){ return String(a.usuario).localeCompare(String(b.usuario)); });
  }catch(e){
    CH_USERS = [];
    console.warn('[chat] usuarios:', e && e.message);
  }
}

async function chCargarNoLeidos(){
  try{
    var r = await fetch(SB+'/rest/v1/rpc/chat_no_leidos',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},
      body:'{}'
    });
    if(!r.ok) throw new Error(r.status);
    var d = await r.json();
    CH_NOLEIDOS = {};
    (Array.isArray(d)?d:[]).forEach(function(x){
      var k = (x.sala==='general') ? 'general' : String(x.de_usuario).toLowerCase();
      CH_NOLEIDOS[k] = (CH_NOLEIDOS[k]||0) + (Number(x.n)||0);
    });
  }catch(e){
    CH_NOLEIDOS={};
    console.warn('[chat] no leidos:', e && e.message);
  }
}

function chTotalNoLeidos(){
  var n=0; for(var k in CH_NOLEIDOS) n += (CH_NOLEIDOS[k]||0);
  return n;
}

// Punto rojo con el numero, sobre el item del menu.
function chPintarBadge(){
  var nav=document.getElementById('nav-chat'); if(!nav) return;
  var n=chTotalNoLeidos();
  var b=document.getElementById('chat-badge');
  if(!n){ if(b) b.remove(); document.title=document.title.replace(/^\(\d+\)\s*/,''); return; }
  if(!b){
    b=document.createElement('span'); b.id='chat-badge';
    b.style.cssText='margin-left:auto;background:var(--red,#DC2626);color:#fff;border-radius:11px;'
      +'min-width:19px;height:19px;display:inline-flex;align-items:center;justify-content:center;'
      +'font-size:11px;font-weight:700;padding:0 5px';
    nav.appendChild(b);
    nav.style.display='flex'; nav.style.alignItems='center';
  }
  b.textContent = n>99 ? '99+' : String(n);
  document.title = document.title.replace(/^\(\d+\)\s*/,'');
  document.title = '('+n+') ' + document.title;
}

// Guarda hasta que mensaje llego este usuario en esta sala.
// Es por usuario, no en la fila del mensaje: en la sala General la fila es
// una sola para todo el equipo y no se puede marcar leida individualmente.
async function chMarcarLeidos(sala){
  var lista = CH_MSGS[sala]||[];
  var yo = chYo();
  var k = (sala==='general') ? 'general' : sala.split('|').filter(function(x){return x!==yo;})[0];
  if(k) CH_NOLEIDOS[k]=0;
  chPintarBadge(); chPintarLista();

  var maxId = 0;
  lista.forEach(function(m){ var i=Number(m.id)||0; if(i>maxId) maxId=i; });
  if(!maxId) return;
  if(CH_MARCA[sala] && CH_MARCA[sala] >= maxId) return;   // ya estaba guardado
  CH_MARCA[sala]=maxId;

  try{
    await fetch(SB+'/rest/v1/chat_leidos',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json',
               'Prefer':'resolution=merge-duplicates,return=minimal'},
      body: JSON.stringify({usuario:yo, sala:sala, ultimo_id:maxId, visto_en:ahoraLocal()})
    });
  }catch(e){ CH_MARCA[sala]=0; }   // si fallo, que reintente la proxima vez
}

async function chCargarSala(sala){
  var rows = await q('chat_mensajes','select=*&sala=eq.'+encodeURIComponent(sala)+'&order=creado_en.desc&limit=200');
  CH_MSGS[sala] = (rows||[]).slice().reverse();   // el mas viejo arriba
}

async function chatInit(){
  if(!CU || CU.rol==='cliente') return;
  if(!CH_LISTO) await chatArrancar();
  if(!CH_USERS.length) await chCargarUsuarios();
  chPintarLista();
  await chAbrir(CH_SALA==='general' ? 'general' : CH_SALA, true);
}

// destino: 'general' o el usuario del companero
async function chAbrir(destino, esSala){
  var sala = esSala && destino.indexOf('|')>=0 ? destino : chSala(chYo(), destino);
  if(destino==='general') sala='general';
  CH_SALA = sala;
  var box=document.getElementById('ch-msgs');
  if(box) box.innerHTML='<div style="padding:18px;color:var(--text3);font-size:13px">Cargando\u2026</div>';
  try{ await chCargarSala(sala); }catch(e){ CH_MSGS[sala]=[]; }
  chPintarMensajes();
  chPintarLista();
  chPintarCabecera();
  chMarcarLeidos(sala);

  // En pantalla estrecha se pasa a la conversacion, como en el movil.
  var sh = document.getElementById('ch-shell');
  if(sh){ sh.dataset.vista = 'conv'; chAjustarVista(); }

  // El foco al campo de escribir: lo primero que se hace al abrir un chat.
  var inp = document.getElementById('ch-input');
  if(inp && window.innerWidth >= 760) setTimeout(function(){ inp.focus(); }, 60);
}

function chNombreSala(){
  if(CH_SALA==='general') return 'General (todos)';
  var otro = CH_SALA.split('|').filter(function(x){ return x!==chYo(); })[0]||'';
  var u = CH_USERS.filter(function(x){ return String(x.usuario).toLowerCase()===otro; })[0];
  return (otro.charAt(0).toUpperCase()+otro.slice(1)) + (u&&u.rol?(' \u00b7 '+u.rol):'');
}

function chPintarLista(){
  var box=document.getElementById('ch-users'); if(!box) return;
  function item(clave, etiqueta, sub, activa){
    var n=CH_NOLEIDOS[clave]||0;
    var kJs=String(clave).replace(/'/g,"\\'");
    var ini=String(etiqueta).trim().split(/\s+/).map(function(w){return w[0];})
              .slice(0,2).join('').toUpperCase();
    return '<div onclick="chAbrir(\''+kJs+'\')" style="display:flex;align-items:center;gap:11px;'
      +'padding:11px 13px;cursor:pointer;border-bottom:1px solid rgba(0,0,0,.055);'
      +(activa?'background:#F0F2F5':'')+'" '
      +'onmouseover="if(!this.dataset.on)this.style.background=\'#F5F6F6\'" '
      +'onmouseout="this.style.background=\''+(activa?'#F0F2F5':'transparent')+'\'"'
      +(activa?' data-on="1"':'')+'>'
      +'<div style="width:44px;height:44px;border-radius:50%;background:'+_chColorDe(etiqueta)+';'
      +'color:#fff;display:flex;align-items:center;justify-content:center;font-size:15px;'
      +'font-weight:600;flex:0 0 auto">'+npEsc(ini||'?')+'</div>'
      +'<div style="flex:1;min-width:0">'
        +'<div style="font-size:14.5px;font-weight:'+(n?'700':'500')+';color:#111B21;'
        +'text-transform:capitalize;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'
        +npEsc(etiqueta)+'</div>'
        +'<div style="font-size:12.5px;color:#667781;overflow:hidden;text-overflow:ellipsis;'
        +'white-space:nowrap;margin-top:1px">'+npEsc(sub||'')+'</div>'
      +'</div>'
      +(n?('<span style="background:#25D366;color:#fff;border-radius:11px;min-width:21px;height:21px;'
           +'display:inline-flex;align-items:center;justify-content:center;font-size:11.5px;'
           +'font-weight:700;padding:0 6px;flex:0 0 auto">'+(n>99?'99+':n)+'</span>'):'')
      +'</div>';
  }

  var html = item('general','General','Todo el equipo', CH_SALA==='general');
  html += CH_USERS.map(function(u){
    var sala=chSala(chYo(), u.usuario);
    return item(u.usuario, u.usuario, u.rol||'', CH_SALA===sala);
  }).join('');
  if(!CH_USERS.length) html += '<div style="padding:10px;font-size:11.5px;color:var(--text3)">No se pudo leer la lista de usuarios. Revisa que exista la funci\u00f3n <b>chat_usuarios</b> en Supabase.</div>';
  box.innerHTML=html;
  var t=document.getElementById('ch-titulo'); if(t) t.textContent=chNombreSala();
}

function _chHora(iso){
  try{
    var d=new Date(iso);
    var hoy=new Date();
    var hh=('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2);
    if(d.toDateString()===hoy.toDateString()) return hh;
    return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+' '+hh;
  }catch(e){ return ''; }
}

function _chCuerpo(m){
  if(m.tipo==='foto'){
    return '<a href="'+npEsc(m.archivo_url)+'" target="_blank" rel="noopener">'
      +'<img src="'+npEsc(m.archivo_url)+'" style="max-width:230px;max-height:230px;border-radius:9px;display:block">'
      +'</a>'+(m.texto?('<div style="margin-top:5px">'+npEsc(m.texto)+'</div>'):'');
  }
  if(m.tipo==='voz'){
    return '<audio controls preload="none" src="'+npEsc(m.archivo_url)+'" style="max-width:230px;height:38px"></audio>'
      +(m.duracion_seg?('<div style="font-size:10.5px;opacity:.75;margin-top:2px">'+Math.round(m.duracion_seg)+'s</div>'):'');
  }
  if(m.tipo==='archivo'){
    return '<a href="'+npEsc(m.archivo_url)+'" target="_blank" rel="noopener" style="display:flex;align-items:center;gap:7px;text-decoration:none;color:inherit">'
      +'<span style="font-size:19px">\u{1F4CE}</span><span style="text-decoration:underline">'+npEsc(m.archivo_nombre||'archivo')+'</span></a>';
  }
  return npEsc(m.texto||'').replace(/\n/g,'<br>');
}

function chPintarMensajes(){
  var box=document.getElementById('ch-msgs'); if(!box) return;
  var lista=CH_MSGS[CH_SALA]||[];

  if(!lista.length){
    box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%">'
      +'<div style="background:rgba(255,255,255,.92);border-radius:11px;padding:13px 18px;'
      +'font-size:13px;color:#54656F;box-shadow:0 1px 2px rgba(0,0,0,.1);text-align:center">'
      +'Sin mensajes todav\u00eda.<br>Escribe el primero.</div></div>';
    return;
  }

  var yo=chYo(), html='', ultimoDia='', ultimoDe='';

  lista.forEach(function(m, ix){
    // Separador de fecha, como en WhatsApp: una pastilla centrada.
    var dia = String(m.creado_en||'').substring(0,10);
    if(dia && dia !== ultimoDia){
      ultimoDia = dia;
      html += '<div style="text-align:center;margin:13px 0 11px">'
        +'<span style="background:#E1F2FB;color:#54656F;font-size:11.5px;padding:5px 12px;'
        +'border-radius:8px;box-shadow:0 1px 1px rgba(0,0,0,.09)">'+_chDiaLbl(dia)+'</span></div>';
      ultimoDe = '';
    }

    var mio = String(m.de_usuario||'').toLowerCase()===yo;
    var de  = String(m.de_usuario||'');
    // Los mensajes seguidos del mismo autor se agrupan: solo el primero
    // lleva pico y nombre, como en WhatsApp.
    var primero = (de !== ultimoDe);
    ultimoDe = de;

    var esGrupo = (CH_SALA==='general');
    var fondo = mio ? CH_MIA : '#FFFFFF';
    var esquinas = primero
      ? (mio ? 'border-radius:8px 0 8px 8px' : 'border-radius:0 8px 8px 8px')
      : 'border-radius:8px';

    html += '<div style="display:flex;justify-content:'+(mio?'flex-end':'flex-start')+';'
      +'margin-bottom:'+(primero?'3px':'2px')+';padding:0 2px">'
      +'<div style="position:relative;max-width:66%;min-width:88px;background:'+fondo+';'
      +esquinas+';padding:6px 9px 5px;box-shadow:0 1px 1px rgba(0,0,0,.13);'
      +'font-size:14.2px;line-height:1.4;word-break:break-word;color:#111B21">'

      // El pico de la burbuja, solo en el primero del grupo
      + (primero
          ? ('<span style="position:absolute;top:0;'+(mio?'right:-8px':'left:-8px')+';'
             +'width:0;height:0;border-top:8px solid '+fondo+';'
             +'border-'+(mio?'left':'right')+':9px solid transparent"></span>')
          : '')

      // Quien escribe, solo en el general y en el primero del grupo
      + ((esGrupo && !mio && primero)
          ? ('<div style="font-size:12.5px;font-weight:600;color:'+_chColorDe(de)
             +';margin-bottom:2px;text-transform:capitalize">'+npEsc(de)+'</div>')
          : '')

      + _chCuerpo(m)

      // Hora y ticks, alineados abajo a la derecha
      +'<span style="float:right;margin:6px 0 0 9px;font-size:10.5px;color:#667781;'
      +'display:inline-flex;align-items:center;gap:3px;line-height:1">'
        + _chHora(m.creado_en)
        + (mio ? _chTicks(m) : '')
      +'</span>'
      +'<span style="clear:both;display:block"></span>'
      +'</div></div>';
  });

  box.innerHTML = html;
  box.scrollTop = box.scrollHeight;
}

// Los dos ticks: gris al entregarse, azul al leerse.
function _chTicks(m){
  var leido = !!(m.leido || m.leido_en);
  var col = leido ? CH_AZUL : '#667781';
  return '<svg width="15" height="15" viewBox="0 0 16 15" fill="'+col+'" style="flex:0 0 auto">'
    +'<path d="M10.91 3.316l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033'
    +'L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185'
    +'c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"/>'
    +'<path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033'
    +'l-.358-.325-.6.612 1.13 1.105c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"/>'
    +'</svg>';
}

// Un color estable por persona, como hace WhatsApp en los grupos.
var _CH_COLORES = ['#E542A3','#1F7AEC','#00A884','#B4682E','#7F66FF',
                   '#C4532D','#0A7C6B','#9333EA','#B45309','#0E7490'];
function _chColorDe(nombre){
  var n = String(nombre||''), h = 0;
  for(var i=0;i<n.length;i++) h = (h*31 + n.charCodeAt(i)) >>> 0;
  return _CH_COLORES[h % _CH_COLORES.length];
}

// "Hoy", "Ayer" o la fecha, como en WhatsApp.
function _chDiaLbl(iso){
  try{
    var d = new Date(iso+'T00:00:00');
    var h = new Date(); h.setHours(0,0,0,0);
    var dias = Math.round((h - d) / 86400000);
    if(dias === 0) return 'Hoy';
    if(dias === 1) return 'Ayer';
    if(dias < 7)   return ['domingo','lunes','martes','mi\u00e9rcoles','jueves','viernes','s\u00e1bado'][d.getDay()];
    return d.toLocaleDateString('es-PA', {day:'2-digit', month:'long', year:'numeric'});
  }catch(e){ return iso; }
}

// ── Envio ──────────────────────────────────────────────────────────────────
async function chInsertar(datos){
  var otro = CH_SALA==='general' ? null : CH_SALA.split('|').filter(function(x){ return x!==chYo(); })[0];
  var fila = {
    sala: CH_SALA, de_usuario: chYo(), para_usuario: otro,
    tipo: datos.tipo||'texto', texto: datos.texto||null,
    archivo_url: datos.archivo_url||null, archivo_nombre: datos.archivo_nombre||null,
    archivo_tipo: datos.archivo_tipo||null, duracion_seg: datos.duracion_seg||null
  };
  var r = await fetch(SB+'/rest/v1/chat_mensajes',{
    method:'POST',
    headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=representation'},
    body: JSON.stringify(fila)
  });
  if(!r.ok) throw new Error((await r.text()).slice(0,180));
  var d = await r.json();
  if(d && d[0]) chEntrante(d[0]);     // se pinta ya, sin esperar al websocket
}

async function chEnviar(){
  var inp=document.getElementById('ch-input'); if(!inp) return;
  var txt=(inp.value||'').trim(); if(!txt) return;
  inp.value=''; inp.style.height='auto';
  try{ await chInsertar({tipo:'texto', texto:txt}); }
  catch(e){ inp.value=txt; chError(e); }
}

function chTecla(ev){
  if(ev.key==='Enter' && !ev.shiftKey){ ev.preventDefault(); chEnviar(); }
}

function chError(e){
  var b=document.getElementById('ch-err'); if(!b) return;
  b.style.display='block';
  b.textContent='No se pudo enviar: '+String((e&&e.message)||e).slice(0,160);
  setTimeout(function(){ b.style.display='none'; }, 6000);
}

function chEmojis(){
  var p=document.getElementById('ch-emo'); if(!p) return;
  if(p.style.display==='block'){ p.style.display='none'; return; }
  if(!p.innerHTML){
    p.innerHTML = CH_EMOJIS.map(function(e){
      return '<button type="button" onclick="chPonerEmoji(\''+e+'\')" style="border:none;background:none;font-size:20px;cursor:pointer;padding:3px;line-height:1">'+e+'</button>';
    }).join('');
  }
  p.style.display='block';
}
function chPonerEmoji(e){
  var inp=document.getElementById('ch-input'); if(!inp) return;
  inp.value = (inp.value||'') + e;
  inp.focus();
  var p=document.getElementById('ch-emo'); if(p) p.style.display='none';
}

// ── Adjuntos ───────────────────────────────────────────────────────────────
// Sube al bucket 'chat' y devuelve la URL publica.
async function chSubir(blob, nombre, mime){
  var limpio = String(nombre||'archivo').replace(/[^A-Za-z0-9._-]/g,'_').slice(-60);
  var ruta = chYo()+'/'+Date.now()+'-'+Math.random().toString(36).slice(2,10)+'-'+limpio;
  var r = await fetch(SB+'/storage/v1/object/chat/'+encodeURI(ruta),{
    method:'POST',
    headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':mime||'application/octet-stream','x-upsert':'true'},
    body: blob
  });
  if(!r.ok) throw new Error('Subida fallida: '+(await r.text()).slice(0,160));
  return SB+'/storage/v1/object/public/chat/'+encodeURI(ruta);
}

function chAdjuntar(soloFoto){
  var inp=document.getElementById(soloFoto?'ch-file-img':'ch-file'); if(inp) inp.click();
}

async function chArchivoElegido(el){
  var f = el && el.files && el.files[0]; if(!f) return;
  el.value='';
  if(f.size > 25*1024*1024){ chError(new Error('El archivo pasa de 25 MB')); return; }
  var est=document.getElementById('ch-subiendo');
  if(est){ est.style.display='block'; est.textContent='Subiendo '+f.name+'\u2026'; }
  try{
    var url = await chSubir(f, f.name, f.type);
    var esImg = /^image\//.test(f.type||'');
    await chInsertar({tipo: esImg?'foto':'archivo', archivo_url:url, archivo_nombre:f.name, archivo_tipo:f.type});
  }catch(e){ chError(e); }
  finally{ if(est) est.style.display='none'; }
}

// ── Notas de voz ───────────────────────────────────────────────────────────
async function chVoz(){
  var btn=document.getElementById('ch-mic');
  if(CH_GRABANDO){                       // segundo clic: cerrar y enviar
    try{ CH_GRABANDO.stop(); }catch(e){}
    return;
  }
  if(!navigator.mediaDevices || !window.MediaRecorder){
    chError(new Error('Este navegador no permite grabar audio')); return;
  }
  try{
    var stream = await navigator.mediaDevices.getUserMedia({audio:true});
    var trozos=[], t0=Date.now();
    var mr = new MediaRecorder(stream);
    CH_GRABANDO = mr;
    if(btn){ btn.textContent='\u23F9'; btn.style.color='var(--red,#DC2626)'; btn.title='Detener y enviar'; }
    mr.ondataavailable=function(ev){ if(ev.data && ev.data.size) trozos.push(ev.data); };
    mr.onstop=async function(){
      try{ stream.getTracks().forEach(function(t){ t.stop(); }); }catch(e){}
      CH_GRABANDO=null;
      if(btn){ btn.textContent='\u{1F3A4}'; btn.style.color=''; btn.title='Nota de voz'; }
      var segs=(Date.now()-t0)/1000;
      if(segs < 0.6) return;                    // clic accidental
      var blob=new Blob(trozos, {type: mr.mimeType||'audio/webm'});
      var est=document.getElementById('ch-subiendo');
      if(est){ est.style.display='block'; est.textContent='Enviando nota de voz\u2026'; }
      try{
        var url=await chSubir(blob, 'nota.webm', blob.type);
        await chInsertar({tipo:'voz', archivo_url:url, archivo_nombre:'nota de voz', archivo_tipo:blob.type, duracion_seg:Math.round(segs)});
      }catch(e){ chError(e); }
      finally{ if(est) est.style.display='none'; }
    };
    mr.start();
  }catch(e){
    CH_GRABANDO=null;
    chError(new Error('No se pudo usar el micr\u00f3fono. Revisa el permiso del navegador.'));
  }
}

// ════════════════════════════════════════════════════════════════════
//  2. PEDIDOS REALIZADOS
//  Lo que cada usuario envio a SAP desde el portal (tabla pedidos_queue).
// ════════════════════════════════════════════════════════════════════
var PR_ROWS=[], prQF='', prD1='', prD2='', prEstF='', prTodos=false;

async function prInit(){
  if(!PR_ROWS.length) await prCargar(); else prRender();
  // Los pedidos de mis clientes van aparte: si tardan, la pantalla ya esta
  // pintada y el panel aparece encima cuando llega.
  if(!PRC_CARGADO){ await prcCargar(); prRender(); }
}

function prEsAdmin(){
  var r=String((CU&&CU.rol)||'').toLowerCase();
  return r==='admin' || r==='administrador' || r==='gerencia';
}

async function prCargar(){
  var box=document.getElementById('pr-result'); if(!box) return;
  box.innerHTML='<div class="card" style="padding:20px;color:var(--text3);font-size:13px">Cargando pedidos enviados\u2026</div>';
  try{
    var filtro='select=*&order=created_at.desc&limit=1000';
    // Un cliente ve los pedidos hechos a su nombre; un vendedor los suyos;
    // el admin puede ver todo o filtrar por si mismo.
    if(CU && CU.rol==='cliente'){
      filtro += '&cardcode=eq.'+encodeURIComponent(CU.cardcode||'');
    } else if(!prEsAdmin() || !prTodos){
      filtro += '&usuario=eq.'+encodeURIComponent((CU&&CU.username)||'');
    }
    PR_ROWS = await q('pedidos_queue', filtro) || [];

    // Para un cliente se anaden tambien sus pedidos de SAP, los que le hizo
    // su vendedor por el canal habitual. Sin esto solo veia los que el mismo
    // hubiera armado en el portal, que suelen ser los menos.
    if(CU && CU.rol==='cliente' && CU.cardcode){
      try{
        var fs='select=docnum,docdate,docduedate,doctotal,docstatus,comments,nombrevendedor,linenum'
          +'&cardcode=eq.'+encodeURIComponent(CU.cardcode)
          +'&linenum=lte.1&order=docnum.desc&limit=300';
        var sap=await q('pedidos', fs) || [];

        // Con linenum<=1 un pedido puede venir dos veces.
        var vistos={}, deSap=[];
        sap.forEach(function(p){
          var k=String(p.docnum);
          if(vistos[k]) return;
          vistos[k]=1;
          deSap.push({
            id: 'SAP-'+p.docnum,
            docnum: p.docnum,
            docnum_sap: p.docnum,      // asi el numero queda pulsable
            cardcode: CU.cardcode,
            cardname: (CU.nombre||CU.cardcode),
            estado: (String(p.docstatus)==='O' ? 'abierto' : 'cerrado'),
            total: Number(p.doctotal)||0,
            doctotal: Number(p.doctotal)||0,
            created_at: p.docdate,
            comentarios: p.comments||'',
            usuario: p.nombrevendedor||'',
            _sap: true                       // para pintarlo distinto
          });
        });

        // Los del portal que ya llegaron a SAP se quedan fuera, o el mismo
        // pedido apareceria dos veces: una por cada origen.
        var enSap={};
        deSap.forEach(function(p){ enSap[String(p.docnum)]=1; });
        PR_ROWS = PR_ROWS.filter(function(p){
          return !(p.docnum && enSap[String(p.docnum)]);
        }).concat(deSap);

        PR_ROWS.sort(function(a,b){
          return String(b.created_at||'').localeCompare(String(a.created_at||''));
        });
      }catch(e){ console.warn('[pedidos] no pude leer los de SAP:', e); }
    }
    await bdListar();
    prRender();
  }catch(e){
    box.innerHTML='<div class="card" style="padding:18px;color:var(--red);font-size:13px">No se pudo cargar: '+npEsc(String(e.message||e))+'</div>';
  }
}

function prBuscar(v){ prQF=String(v||'').trim().toLowerCase(); prRender(); }
function prFecha(cual,v){ if(cual===1) prD1=v||''; else prD2=v||''; prRender(); }
function prEstado(v){ prEstF=v||''; prRender(); }
function prHoy(){
  var d=new Date(), s=d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2);
  prD1=s; prD2=s;
  var a=document.getElementById('pr-d1'), b=document.getElementById('pr-d2');
  if(a) a.value=s; if(b) b.value=s;
  prRender();
}
function prLimpiar(){
  prQF=''; prD1=''; prD2=''; prEstF='';
  ['pr-q','pr-d1','pr-d2'].forEach(function(id){ var e=document.getElementById(id); if(e) e.value=''; });
  var s=document.getElementById('pr-est'); if(s) s.value='';
  prRender();
}
function prVerTodos(on){ prTodos=!!on; PR_ROWS=[]; prCargar(); }

function prFiltradas(){
  return (PR_ROWS||[]).filter(function(r){
    var f=String(r.created_at||'').substring(0,10);
    if(prD1 && f < prD1) return false;
    if(prD2 && f > prD2) return false;
    if(prEstF && String(r.estado||'')!==prEstF) return false;
    if(!prQF) return true;
    return String(r.cardname||'').toLowerCase().indexOf(prQF)>=0
        || String(r.cardcode||'').toLowerCase().indexOf(prQF)>=0
        || String(r.docnum_sap||'').toLowerCase().indexOf(prQF)>=0
        || String(r.usuario||'').toLowerCase().indexOf(prQF)>=0;
  });
}

function _prTotal(r){
  // Los pedidos traidos de SAP no tienen el detalle de lineas: su total
  // viene ya calculado del documento.
  if(r._sap) return Number(r.doctotal)||0;
  try{
    var ls = typeof r.lineas==='string' ? JSON.parse(r.lineas) : (r.lineas||[]);
    var t=0;
    (ls||[]).forEach(function(l){ t += Number(l.linetotal)||0; });
    var dg=Number(r.discprcnt)||0;
    return t*(1-dg/100);
  }catch(e){ return 0; }
}
function _prNLineas(r){
  if(r._sap) return r._nlineas!=null ? r._nlineas : '';
  try{
    var ls = typeof r.lineas==='string' ? JSON.parse(r.lineas) : (r.lineas||[]);
    return (ls||[]).length;
  }catch(e){ return 0; }
}
function _prBadge(e){
  var s=String(e||'').toLowerCase();
  if(s==='abierto') return '<span class="badge b-amber">abierto</span>';
  if(s==='cerrado') return '<span class="badge b-green">entregado</span>';
  if(s==='ok'||s==='procesado') return '<span class="badge b-green">en SAP</span>';
  if(s==='pendiente')           return '<span class="badge b-amber">pendiente</span>';
  if(s==='error')               return '<span class="badge b-red">error</span>';
  return '<span class="badge b-blue">'+npEsc(e||'-')+'</span>';
}
function _prFechaHora(iso){
  if(!iso) return '-';
  try{
    var d=new Date(iso);
    return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+d.getFullYear()
      +' '+('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2);
  }catch(e){ return String(iso).substring(0,16).replace('T',' '); }
}

/* ══════════════════════════════════════════════════════════════════════════
   PEDIDOS QUE MIS CLIENTES HICIERON EN EL PORTAL
   ---------------------------------------------------------------------------
   Lo que los CLIENTES metieron ellos mismos desde la app, para los clientes
   asignados a este vendedor.

   No son los pedidos de SAP: son los de `pedidos_queue`, la cola del portal.
   Arriba, "Cotizaciones enviadas a SAP" muestra lo que envio el PROPIO
   vendedor; aqui sale lo que enviaron sus clientes, que el vendedor no veria
   de otra forma porque esa lista filtra por usuario.

   Clientes COMPARTIDOS: en SAP el codigo puede ser "LEO/HENRY". Ese cliente
   cuenta para los dos, porque el nombre se parte por "/".
   ══════════════════════════════════════════════════════════════════════════ */

var PRC_ROWS=[], PRC_CARGADO=false, PRC_MINOMBRE=null, PRC_ABIERTO=true;
var PRC_ERROR='', PRC_DIAG='';

function prcEsAdmin(){
  var r=String((CU&&CU.rol)||'').toLowerCase();
  return ['admin','administrador','gerencia'].indexOf(r)>=0;
}
function prcYo(){
  try{ return String((CU&&(CU.username||String(CU.email||'').split('@')[0]))||'').toLowerCase(); }
  catch(e){ return ''; }
}

// Mi nombre de vendedor en SAP, que es como viene en los documentos.
async function prcMiNombre(){
  if(PRC_MINOMBRE!==null) return PRC_MINOMBRE;
  PRC_MINOMBRE='';
  var sc=null;
  try{ sc=(CU&&CU.slpcode); }catch(e){}
  if(sc!=null && sc!==''){
    try{
      var r=await q('vendedores','select=slpname&slpcode=eq.'+encodeURIComponent(sc)+'&limit=1');
      if(r&&r[0]&&r[0].slpname) PRC_MINOMBRE=String(r[0].slpname).trim();
    }catch(e){}
  }
  if(!PRC_MINOMBRE){
    try{ PRC_MINOMBRE=String((CU&&(CU.nombre||CU.username))||'').trim(); }catch(e){}
  }
  return PRC_MINOMBRE;
}

// "LEO/HENRY" cuenta para Leo y para Henry. "03/ALICIA" cuenta para Alicia.
function prcEsMio(nombreVend){
  var yo=String(PRC_MINOMBRE||'').toUpperCase().trim();
  if(!yo) return false;
  var partes=String(nombreVend||'').toUpperCase().split('/');
  for(var i=0;i<partes.length;i++){
    if(partes[i].trim()===yo) return true;
  }
  return false;
}

// Los codigos de MIS clientes, cacheados. Lo usan el panel de actividad y
// tambien la lista de borradores, asi que vive aparte.
var PRC_MISCLIENTES=null;

async function prcMisClientes(){
  if(PRC_MISCLIENTES!==null) return PRC_MISCLIENTES;
  PRC_MISCLIENTES=[];
  try{
    await prcMiNombre();
    var vends=await qAll('vendedores','select=slpcode,slpname') || [];
    var mios=vends.filter(function(v){ return prcEsMio(v.slpname); })
                  .map(function(v){ return v.slpcode; });
    if(!mios.length) return PRC_MISCLIENTES;
    var cli=await qAll('clientes',
      'select=cardcode&cardtype=eq.C&slpcode=in.('+mios.join(',')+')') || [];
    PRC_MISCLIENTES=cli.map(function(c){ return c.cardcode; }).filter(Boolean);
  }catch(e){}
  return PRC_MISCLIENTES;
}

async function prcCargar(){
  if(PRC_CARGADO) return;
  PRC_CARGADO=true;
  var rol=String((CU&&CU.rol)||'').toLowerCase();
  if(rol==='cliente') return;        // el cliente ya ve los suyos abajo
  try{
    await prcMiNombre();

    // Mis clientes: por mi codigo y por los compartidos donde aparezco.
    var codes=[];
    if(!prcEsAdmin()){
      var vends=await qAll('vendedores','select=slpcode,slpname') || [];
      var mios=vends.filter(function(v){ return prcEsMio(v.slpname); })
                    .map(function(v){ return v.slpcode; });
      if(!mios.length){
        PRC_DIAG='No encuentro tu c\u00f3digo de vendedor en SAP. Te reconozco como "'
          +(PRC_MINOMBRE||'(sin nombre)')+'" y no coincide con ninguno.';
        return;
      }
      var cli=await qAll('clientes',
        'select=cardcode&cardtype=eq.C&slpcode=in.('+mios.join(',')+')') || [];
      codes=cli.map(function(c){ return c.cardcode; }).filter(Boolean);
      if(!codes.length){
        PRC_DIAG='No tienes clientes asignados a los c\u00f3digos '+mios.join(', ')+'.';
        return;
      }
    }

    // TODO lo que el cliente ha hecho en el portal, en una sola lista:
    //   · lo que todavia tiene a medias   -> pedidos_borrador
    //   · lo que ya envio                 -> pedidos_queue
    // Lo que metio el PROPIO vendedor se deja fuera: eso ya sale arriba, en
    // "Cotizaciones enviadas a SAP".
    var yo=prcYo();
    var out=[];

    async function _traer(tabla, campos, orden){
      var r=[];
      if(prcEsAdmin()){
        r = await qAll(tabla, 'select='+campos+'&order='+orden+'&limit=400') || [];
      } else {
        for(var i=0;i<codes.length;i+=150){
          var lote=codes.slice(i,i+150)
            .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
          var x=await qAll(tabla,
            'select='+campos+'&cardcode=in.('+lote+')&order='+orden+'&limit=400') || [];
          r=r.concat(x);
        }
      }
      return r;
    }

    // Enviados
    try{
      (await _traer('pedidos_queue','*','created_at.desc')).forEach(function(p){
        out.push({_tipo:'enviado', _cuando:p.created_at, _usuario:p.usuario,
                  cardcode:p.cardcode, cardname:p.cardname, lineas:p.lineas,
                  estado:p.estado, docnum_sap:p.docnum_sap, destino:p.destino,
                  error_msg:p.error_msg, _id:p.id});
      });
    }catch(e){ PRC_DIAG='No pude leer los enviados: '+String(e.message||e).slice(0,90); }

    // A medias, sin enviar
    try{
      (await _traer('pedidos_borrador',
        'id,usuario,cardcode,cardname,lineas,discprcnt,creado_en,actualizado_en',
        'actualizado_en.desc')).forEach(function(b){
        out.push({_tipo:'borrador', _cuando:(b.actualizado_en||b.creado_en),
                  _usuario:b.usuario, cardcode:b.cardcode, cardname:b.cardname,
                  lineas:b.lineas, estado:'borrador', _id:b.id});
      });
    }catch(e){
      PRC_DIAG=(PRC_DIAG?PRC_DIAG+' · ':'')
        +'No pude leer los borradores: '+String(e.message||e).slice(0,90);
    }

    out=out.filter(function(p){
      return String(p._usuario||'').toLowerCase() !== yo;
    });
    // Del mas reciente al mas viejo, mezclando borradores y enviados.
    out.sort(function(a,b){
      return String(b._cuando||'').localeCompare(String(a._cuando||''));
    });
    PRC_ROWS=out;
    if(!out.length && !PRC_DIAG){
      PRC_DIAG=prcEsAdmin()
        ? 'Ning\u00fan cliente ha trabajado en el portal todav\u00eda.'
        : 'Tus clientes no han hecho nada en el portal todav\u00eda.';
    }
  }catch(e){
    PRC_ROWS=[];
    PRC_ERROR=String((e&&e.message)||e);
    try{ console.error('[pedidos de mis clientes]', e); }catch(_){}
  }
}

function prcToggle(){ PRC_ABIERTO=!PRC_ABIERTO; prRender(); }

// El estado, con el mismo lenguaje que usa la gente: un borrador no esta
// "pendiente" (eso suena a que el sistema lo esta procesando), esta "en
// proceso" porque el cliente lo sigue armando.
function prcEstado(p){
  if(p._tipo==='borrador')
    return '<span class="badge b-gray">En proceso</span>';
  var e=String(p.estado||'').toLowerCase();
  if(e==='error')      return '<span class="badge b-red">Con error</span>';
  if(e==='pendiente')  return '<span class="badge b-amber">Enviando a SAP</span>';
  return '<span class="badge b-green">En SAP</span>';
}

// El numero que guarda la cola puede ser de PEDIDO o de COTIZACION, segun el
// destino que se eligio al enviarlo. Un cliente siempre manda cotizacion.
//
// Las cotizaciones no estan sincronizadas en el portal -no hay tabla ni
// pantalla-, asi que no se enlazan: pulsar llevaba a un "Pedido #undefined"
// vacio. Se muestran como texto y se dice que son cotizacion.
function prcDoc(p){
  var n=p.docnum_sap;
  if(!n) return '<span style="color:var(--text3)">\u2014</span>';
  var dest=String(p.destino||'').toLowerCase();
  // Solo se enlaza cuando CONSTA que es un pedido. Las filas viejas, de antes
  // de que existiera `destino`, se quedan sin enlace a proposito: un enlace
  // roto que abre un "Pedido #undefined" es peor que un numero sin enlace.
  if(dest==='pedido' || dest==='ambos'){
    return '<a href="javascript:void(0)" onclick="verPedido(\''
      +String(n).replace(/'/g,"\\'")+'\')" style="font-weight:600">#'+npEsc(n)+'</a>';
  }
  if(dest==='cotizacion'){
    return '<span style="font-weight:600" title="Cotizaci\u00f3n en SAP. '
      +'El portal no tiene pantalla de cotizaciones.">Cot. #'+npEsc(n)+'</span>';
  }
  return '<span style="font-weight:600" title="No consta si es pedido o '
    +'cotizaci\u00f3n: el env\u00edo es anterior a que se guardara ese dato.">#'
    +npEsc(n)+'</span>';
}

// Abre en Nuevo pedido lo que el cliente armo, para que el vendedor lo
// revise, lo ajuste y lo mande como pedido.
//
// Las lineas estan en la propia cola (`lineas`), asi que no hace falta leer
// la cotizacion de SAP: se trabaja sobre lo que el cliente envio.
async function prcTrabajar(id){
  var p=null;
  for(var i=0;i<PRC_ROWS.length;i++){
    if(String(PRC_ROWS[i]._id)===String(id)){ p=PRC_ROWS[i]; break; }
  }
  if(!p){ alert('No encuentro ese movimiento.'); return; }

  var ls;
  try{ ls = (typeof p.lineas==='string') ? JSON.parse(p.lineas) : (p.lineas||[]); }
  catch(e){ ls=[]; }
  if(!ls.length){ alert('Ese env\u00edo no tiene l\u00edneas guardadas.'); return; }

  if(npLineas && npLineas.length){
    if(!confirm('Tienes una cotizaci\u00f3n a medias. Si contin\u00faas se reemplaza '
      +'por lo que arm\u00f3 '+(p.cardname||'el cliente')+'.\n\n\u00bfSigo?')) return;
  }

  npCli = p.cardcode ? {cardcode:p.cardcode, cardname:p.cardname||p.cardcode} : null;
  npLineas = ls.map(function(l){
    return {itemcode:l.itemcode, itemname:l.itemname||l.itemcode,
            quantity:Number(l.quantity)||0, price:Number(l.price)||0,
            discount:Number(l.discount)||0, bulto:Number(l.bulto)||1,
            whscode:l.whscode||'', note:l.note||''};
  });
  // Es una copia para trabajar, no el borrador del cliente: se desliga para
  // no pisarle lo suyo al guardar.
  BD_ID=null; BD_ULT='';

  go('nuevo_pedido', document.getElementById('nav-np'));
  // Los mismos pasos que al retomar un borrador. Faltaban npIr() y
  // npRenderLineas(): sin ellos el asistente se quedaba en el paso 1 y no
  // dejaba avanzar, porque las lineas estaban en memoria pero sin pintar.
  setTimeout(function(){
    if(npCli){
      var nm=document.getElementById('np-cli-name'); if(nm) nm.textContent=npCli.cardname;
      var mt=document.getElementById('np-cli-meta'); if(mt) mt.textContent=npCli.cardcode;
      var av=document.getElementById('np-cli-av');
      if(av) av.textContent=(npCli.cardname||'?').slice(0,2).toUpperCase();
      var inp=document.getElementById('np-cli-q');   if(inp) inp.style.display='none';
      var sel=document.getElementById('np-cli-sel'); if(sel) sel.style.display='block';
    }
    try{ cotizUpdate(); }catch(e){}
    try{ npRenderLineas(); }catch(e){}
    try{ npUpdateBtn && npUpdateBtn(); }catch(e){}
    try{ npIr(npCli?3:1); }catch(e){}
    try{ BD_ULT=bdFoto(); }catch(e){}
  }, 220);
}

function prcPanel(){
  var rol=String((CU&&CU.rol)||'').toLowerCase();
  if(rol==='cliente') return '';
  if(PRC_ERROR){
    return '<div class="card" style="margin-bottom:12px;padding:14px;font-size:12.5px;'
      +'color:var(--red)"><b>No pude cargar la actividad de tus clientes.</b><br>'
      +npEsc(PRC_ERROR)+'</div>';
  }
  if(!PRC_ROWS.length){
    if(!PRC_CARGADO){
      return '<div class="card" style="margin-bottom:12px;padding:14px;color:var(--text3);'
        +'font-size:12.5px">Buscando lo que han hecho tus clientes\u2026</div>';
    }
    return '<div class="card" style="margin-bottom:12px;padding:14px;color:var(--text3);'
      +'font-size:12.5px"><b>Lo que hacen mis clientes en el portal:</b> nada todav\u00eda.'
      +(PRC_DIAG?('<br><span style="font-size:11.5px">'+npEsc(PRC_DIAG)+'</span>'):'')
      +'</div>';
  }

  var total=0, nBorr=0, nPend=0, nErr=0;
  PRC_ROWS.forEach(function(p){
    total+=_prTotal(p);
    if(p._tipo==='borrador'){ nBorr++; return; }
    var e=String(p.estado||'').toLowerCase();
    if(e==='error') nErr++; else if(e==='pendiente') nPend++;
  });

  function kpi(lbl,val,col){
    return '<div style="text-align:right"><div style="font-size:10.5px;color:var(--text3);'
      +'text-transform:uppercase;letter-spacing:.4px">'+lbl+'</div>'
      +'<div style="font-size:16px;font-weight:700'+(col?(';color:'+col):'')+'">'
      +val+'</div></div>';
  }

  var h='<div class="card" style="margin-bottom:12px;padding:0;overflow:hidden">';
  h+='<div style="padding:13px 16px;display:flex;align-items:center;gap:16px;'
    +'flex-wrap:wrap;cursor:pointer" onclick="prcToggle()">'
    +'<div style="flex:1;min-width:220px">'
    +'<div style="font-size:14px;font-weight:700">Lo que hacen mis clientes en el portal</div>'
    +'<div style="font-size:12px;color:var(--text3);margin-top:2px">'
    +'Todo lo que tus clientes han armado o enviado desde la app, '
    +'de lo m\u00e1s reciente a lo m\u00e1s antiguo.</div></div>'
    + kpi('Movimientos', PRC_ROWS.length)
    + kpi('Valor', fmt(total))
    + (nBorr?kpi('En proceso', nBorr, '#6B7280'):'')
    + (nPend?kpi('Enviando', nPend, '#B45309'):'')
    + (nErr?kpi('Con error', nErr, 'var(--red)'):'')
    +'<span style="font-size:18px;color:var(--text3)">'+(PRC_ABIERTO?'\u2212':'+')+'</span>'
    +'</div>';

  if(PRC_ABIERTO){
    h+='<div style="overflow-x:auto;border-top:1px solid var(--border)">'
      +'<table class="tbl" style="margin:0">'
      +'<tr><th>Cu\u00e1ndo</th><th>Estado</th><th>Doc SAP</th><th>Cliente</th>'
      +'<th>Qui\u00e9n</th><th style="text-align:right">L\u00edneas</th>'
      +'<th style="text-align:right">Total</th><th></th></tr>';
    PRC_ROWS.slice(0,150).forEach(function(p){
      var cJs=String(p.cardcode||'').replace(/'/g,"\\'");
      var doc=prcDoc(p);
      // Los borradores van con el fondo mas tenue: no son pedidos todavia.
      h+='<tr'+(p._tipo==='borrador'?' style="background:var(--bg)"':'')+'>'
        +'<td style="white-space:nowrap;font-size:12px">'+_prFechaHora(p._cuando)+'</td>'
        +'<td>'+prcEstado(p)+'</td>'
        +'<td>'+doc+'</td>'
        +'<td><a href="javascript:void(0)" onclick="verCliente(\''+cJs+'\')">'
        +npEsc(p.cardname||'')+'</a>'
        +'<div style="font-size:11px;color:var(--text3)">'+npEsc(p.cardcode||'')+'</div></td>'
        +'<td style="font-size:12px">'+npEsc(p._usuario||'')+'</td>'
        +'<td style="text-align:right">'+fmtN(_prNLineas(p))+'</td>'
        +'<td style="text-align:right;font-weight:600">'+fmt(_prTotal(p))
        +(p.error_msg?('<div style="font-size:10.5px;color:var(--red);max-width:220px;'
          +'font-weight:400">'+npEsc(String(p.error_msg).slice(0,110))+'</div>'):'')
        +'</td>'
        // Abrir lo que armo el cliente en Nuevo pedido, para retomarlo.
        +'<td style="text-align:right;white-space:nowrap">'
        +'<button class="btn btn-sm" onclick="prcTrabajar(\''
        +String(p._id).replace(/'/g,"\\'")+'\')">Trabajarlo</button></td>'
        +'</tr>';
    });
    h+='</table></div>';
    if(PRC_ROWS.length>150){
      h+='<div style="padding:9px 16px;font-size:11.5px;color:var(--text3);'
        +'border-top:1px solid var(--border)">Se muestran los 150 m\u00e1s recientes de '
        +PRC_ROWS.length+'.</div>';
    }
  }
  h+='</div>';
  return h;
}

function prRender(){
  var box=document.getElementById('pr-result'); if(!box) return;
  var rows=prFiltradas();
  var borr=prcPanel() + bdRenderLista();   // mis clientes y lo pendiente de enviar

  if(!(PR_ROWS||[]).length){
    box.innerHTML=borr+'<div class="card" style="padding:20px;text-align:center;color:var(--text3);font-size:13px">Todav\u00eda no has enviado pedidos desde el portal.</div>';
    return;
  }
  if(!rows.length){
    box.innerHTML=borr+'<div class="card" style="padding:20px;text-align:center;color:var(--text3);font-size:13px">Ning\u00fan pedido con esos filtros.</div>';
    return;
  }

  var totV=0, nOK=0, nPend=0, nErr=0;
  rows.forEach(function(r){
    totV += _prTotal(r);
    var e=String(r.estado||'').toLowerCase();
    if(e==='error') nErr++; else if(e==='pendiente') nPend++; else nOK++;
  });

  var resumen='<div class="card" style="margin-bottom:12px;display:flex;gap:22px;flex-wrap:wrap;align-items:center;padding:13px 16px">'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Pedidos</div><div style="font-size:19px;font-weight:700">'+fmtN(rows.length)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">En SAP</div><div style="font-size:19px;font-weight:700;color:var(--green)">'+fmtN(nOK)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Pendientes</div><div style="font-size:19px;font-weight:700;color:var(--amber)">'+fmtN(nPend)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Con error</div><div style="font-size:19px;font-weight:700;color:var(--red)">'+fmtN(nErr)+'</div></div>'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Valor enviado</div><div style="font-size:19px;font-weight:700;color:var(--blue2)">'+fmt(totV)+'</div></div>'
    +'</div>';

  var filas=rows.map(function(r){
    var cJs=String(r.cardcode||'').replace(/'/g,"\\'");
    var doc=r.docnum_sap
      ? prcDoc(r)
      : '<span style="color:var(--text3)">\u2014</span>';
    return '<tr>'
      +'<td style="white-space:nowrap;font-size:12px">'+_prFechaHora(r.created_at)+'</td>'
      +'<td>'+doc+'</td>'
      +'<td><a href="javascript:void(0)" onclick="verCliente(\''+cJs+'\')" style="color:var(--text);text-decoration:none;font-weight:600">'+npEsc(r.cardname||r.cardcode||'')+'</a>'
        +'<div style="font-size:11px;color:var(--text3)">'+npEsc(r.cardcode||'')+'</div></td>'
      +'<td style="text-transform:capitalize;font-size:12px">'+npEsc(r.usuario||'')
        +(r._sap?'<div style="font-size:10px;color:var(--text3);text-transform:none">desde SAP</div>':'')+'</td>'
      +'<td style="text-align:right">'+(r._sap?'\u2014':fmtN(_prNLineas(r)))+'</td>'
      +'<td style="text-align:right;font-weight:600">'+fmt(_prTotal(r))+'</td>'
      +'<td>'+_prBadge(r.estado)
        +(r.error_msg?('<div style="font-size:10.5px;color:var(--red);max-width:230px">'+npEsc(String(r.error_msg).slice(0,120))+'</div>'):'')+'</td>'
      +'</tr>';
  }).join('');

  box.innerHTML = borr + resumen
    +'<div class="card"><div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th>Enviado</th><th>Doc SAP</th><th>Cliente</th><th>Usuario</th>'
    +'<th style="text-align:right">L\u00edneas</th><th style="text-align:right">Total</th><th>Estado</th></tr>'
    +filas+'</table></div></div>';
}

// ════════════════════════════════════════════════════════════════════
//  MONTAJE EN EL MENU
// ════════════════════════════════════════════════════════════════════
var _CH_NAV='<div class="ni" id="nav-chat" onclick="go(\'chat\',this)">'
  +'<svg style="color:#34D399" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">'
  +'<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>'
  +'Live Chat</div>';

var _PR_NAV='<div class="ni" id="nav-predl" onclick="go(\'pedrealizados\',this)">'
  +'<svg style="color:#FBBF24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">'
  +'<path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>'
  +'Pedidos realizados y en proceso</div>';

// ── El panel, con el lenguaje visual de WhatsApp ──────────────────────────
//  Los colores van fijos, no por variables del tema: WhatsApp se reconoce
//  justo por ellos, y en modo oscuro perderia la identidad.
var CH_VERDE   = '#075E54';   // cabecera
var CH_VERDE2  = '#128C7E';   // acentos
var CH_FONDO   = '#ECE5DD';   // el beige de la conversacion
var CH_MIA     = '#DCF8C6';   // burbuja propia
var CH_AZUL    = '#34B7F1';   // los dos ticks al leerse

var _CH_PAGE='<div class="page" id="page-chat">'
  +'<div class="card" style="padding:0;overflow:hidden;border-radius:14px">'
    +'<div style="display:flex;height:70vh;min-height:430px" id="ch-shell">'

      // ── Columna de contactos ────────────────────────────────────────
      +'<div id="ch-col" style="width:238px;flex:0 0 auto;display:flex;flex-direction:column;'
        +'border-right:1px solid rgba(0,0,0,.09);background:#fff">'
        +'<div style="background:'+CH_VERDE+';color:#fff;padding:13px 15px;font-weight:700;font-size:14px;'
          +'display:flex;align-items:center;gap:8px">'
          +'<svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">'
          +'<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7'
          +'a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>'
          +'Chats'
          // Un boton a la vista: si un mensaje se queda marcado como no
          // leido, no hay que buscar el menu de los tres puntos.
          +'<button type="button" id="ch-marcar-todo" onclick="chMarcarTodo()" '
          +'title="Marcar todos los chats como le\u00eddos" '
          +'style="margin-left:auto;border:none;background:rgba(255,255,255,.16);'
          +'color:#fff;font-size:10.5px;padding:4px 8px;border-radius:6px;cursor:pointer">'
          +'\u2713 Todo le\u00eddo</button>'
          +'</div>'
        +'<div id="ch-users" style="flex:1;overflow-y:auto"></div>'
      +'</div>'

      // ── Conversacion ────────────────────────────────────────────────
      +'<div style="flex:1;display:flex;flex-direction:column;min-width:0">'

        // Cabecera: volver, avatar, nombre y cargo
        +'<div style="background:'+CH_VERDE+';color:#fff;padding:9px 14px;display:flex;align-items:center;gap:11px;flex:0 0 auto">'
          +'<button type="button" id="ch-volver" onclick="chVolver()" title="Volver a los chats" '
            +'style="display:none;border:none;background:none;color:#fff;cursor:pointer;padding:2px 4px;line-height:1">'
            +'<svg width="21" height="21" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">'
            +'<path d="M19 12H5M12 19l-7-7 7-7"/></svg></button>'
          +'<div id="ch-avatar" style="width:39px;height:39px;border-radius:50%;background:rgba(255,255,255,.22);'
            +'display:flex;align-items:center;justify-content:center;font-weight:700;font-size:14.5px;flex:0 0 auto"></div>'
          +'<div style="flex:1;min-width:0">'
            +'<div id="ch-titulo" style="font-weight:600;font-size:15px;line-height:1.25;'
              +'white-space:nowrap;overflow:hidden;text-overflow:ellipsis">General</div>'
            +'<div id="ch-sub" style="font-size:11.5px;opacity:.78;line-height:1.3;'
              +'white-space:nowrap;overflow:hidden;text-overflow:ellipsis">todo el equipo</div>'
          +'</div>'
          +'<button type="button" onclick="chMenu()" title="Opciones" '
            +'style="border:none;background:none;color:#fff;cursor:pointer;padding:3px 6px;font-size:19px;line-height:1">\u22EE</button>'
        +'</div>'

        // La conversacion. El fondo lleva el patron tenue de WhatsApp, hecho
        // con un SVG en linea: no hace falta descargar ninguna imagen.
        +'<div id="ch-msgs" style="flex:1;overflow-y:auto;padding:15px 16px;background-color:'+CH_FONDO+';'
          +'background-image:url(\'data:image/svg+xml;utf8,'
          +'<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"56\" height=\"56\" viewBox=\"0 0 56 56\">'
          +'<g fill=\"none\" stroke=\"%23000\" stroke-opacity=\".035\" stroke-width=\"1.1\">'
          +'<circle cx=\"14\" cy=\"14\" r=\"3.2\"/><path d=\"M36 10l5 5-5 5-5-5z\"/>'
          +'<path d=\"M9 40h7M12.5 36.5v7\"/><circle cx=\"42\" cy=\"40\" r=\"2.6\"/></g></svg>\')"></div>'

        +'<div id="ch-err" style="display:none;background:#FEE2E2;color:#991B1B;font-size:12px;padding:7px 14px"></div>'
        +'<div id="ch-subiendo" style="display:none;background:#E0F2FE;color:#075985;font-size:12px;padding:7px 14px"></div>'

        // Barra de escritura
        +'<div style="position:relative;background:#F0F0F0;padding:8px 11px;display:flex;gap:6px;align-items:flex-end;flex:0 0 auto">'
          +'<div id="ch-emo" style="display:none;position:absolute;bottom:56px;left:11px;background:#fff;'
            +'border:1px solid rgba(0,0,0,.1);border-radius:13px;padding:8px;box-shadow:0 8px 26px rgba(0,0,0,.16);'
            +'width:280px;z-index:20"></div>'
          +_chIcono('chEmojis()', 'Emojis',
              '<circle cx="12" cy="12" r="9"/><path d="M8.5 14.5a4.2 4.2 0 0 0 7 0"/>'
              +'<circle cx="9" cy="10" r=".9" fill="currentColor"/><circle cx="15" cy="10" r=".9" fill="currentColor"/>')
          +_chIcono('chAdjuntar(false)', 'Adjuntar',
              '<path d="M21.4 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95'
              +'l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>')
          +_chIcono('chAdjuntar(true)', 'Foto',
              '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>'
              +'<path d="M21 15l-5-5L5 21"/>')
          +'<textarea id="ch-input" rows="1" placeholder="Escribe un mensaje" onkeydown="chTecla(event)" '
            +'style="flex:1;resize:none;max-height:118px;padding:10px 15px;border:none;border-radius:22px;'
            +'font-size:14px;font-family:inherit;outline:none;background:#fff;line-height:1.4;'
            +'box-shadow:0 1px 2px rgba(0,0,0,.08)"></textarea>'
          +_chIcono('chVoz()', 'Nota de voz',
              '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>'
              +'<path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8"/>', 'ch-mic')
          +'<button type="button" onclick="chEnviar()" title="Enviar" '
            +'style="flex:0 0 auto;width:44px;height:44px;border-radius:50%;border:none;background:'+CH_VERDE2+';'
            +'color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;'
            +'box-shadow:0 2px 5px rgba(0,0,0,.18)">'
            +'<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">'
            +'<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg></button>'
          +'<input type="file" id="ch-file" style="display:none" onchange="chArchivoElegido(this)">'
          +'<input type="file" id="ch-file-img" accept="image/*" style="display:none" onchange="chArchivoElegido(this)">'
        +'</div>'
      +'</div>'
    +'</div>'
  +'</div>'
+'</div>';

// Los iconos de la barra, todos iguales.
function _chIcono(accion, titulo, path, id){
  return '<button type="button" onclick="'+accion+'" title="'+titulo+'"'
    +(id?(' id="'+id+'"'):'')
    +' style="flex:0 0 auto;border:none;background:none;color:#54656F;cursor:pointer;padding:8px;'
    +'display:flex;align-items:center;justify-content:center">'
    +'<svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" '
    +'stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">'+path+'</svg></button>';
}

var _PR_PAGE='<div class="page" id="page-pedrealizados">'
  +'<div class="card">'
    +'<div class="ch"><span class="ct">Cotizaciones enviadas a SAP</span></div>'
    +'<div style="font-size:12px;color:var(--text3);margin-bottom:12px">Todo lo que se envi\u00f3 desde el portal, lo m\u00e1s reciente primero. Cada vendedor ve lo suyo; el administrador puede ver el de todos.</div>'
    +'<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap">'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Desde</label>'
        +'<input type="date" id="pr-d1" onchange="prFecha(1,this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none"></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Hasta</label>'
        +'<input type="date" id="pr-d2" onchange="prFecha(2,this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none"></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Estado</label>'
        +'<select id="pr-est" onchange="prEstado(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="">Todos</option><option value="ok">En SAP</option><option value="pendiente">Pendiente</option><option value="error">Con error</option></select></div>'
      +'<div style="flex:1;min-width:190px"><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Cliente</label>'
        +'<input type="text" id="pr-q" placeholder="Nombre, c\u00f3digo o No. de documento..." oninput="prBuscar(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;width:100%;outline:none;box-sizing:border-box"></div>'
      +'<button class="btn" onclick="prHoy()">Hoy</button>'
      +'<button class="btn" onclick="prLimpiar()">Limpiar</button>'
      +'<button class="btn" onclick="PR_ROWS=[];prCargar()">Recargar</button>'
      +'<label id="pr-todos-wrap" style="display:none;align-items:center;gap:6px;font-size:12.5px;color:var(--text3);cursor:pointer">'
        +'<input type="checkbox" id="pr-todos" onchange="prVerTodos(this.checked)"> Ver los de todos</label>'
    +'</div>'
  +'</div>'
  +'<div id="pr-result"></div>'
+'</div>';

function _k3MontarUI(){
  try{
    // El chat va arriba del todo, en PRINCIPAL: si queda al final de la barra
    // lateral se pierde debajo del scroll y nadie lo ve.
    var top=document.getElementById('nav-dash');
    if(top && top.insertAdjacentHTML && !document.getElementById('nav-chat')){
      top.insertAdjacentHTML('afterend', _CH_NAV);
    }
    // "Pedidos realizados" va junto a Pedidos, que es donde se busca.
    var ref=document.getElementById('nav-ped')||document.getElementById('nav-porllegar')
          ||document.getElementById('nav-sinrot')||document.getElementById('nav-rep');
    if(ref && ref.insertAdjacentHTML && !document.getElementById('nav-predl')){
      ref.insertAdjacentHTML('afterend', _PR_NAV);
    }
    if(!document.getElementById('nav-chat')){   // por si no existiera nav-dash
      var alt=document.getElementById('nav-ped')||document.getElementById('nav-cli');
      if(alt && alt.insertAdjacentHTML) alt.insertAdjacentHTML('afterend', _CH_NAV);
    }
    var pg=document.getElementById('page-porllegar')||document.getElementById('page-sinrotacion')
         ||document.querySelector('.page');
    if(pg && pg.insertAdjacentHTML){
      if(!document.getElementById('page-chat'))          pg.insertAdjacentHTML('afterend', _CH_PAGE);
      if(!document.getElementById('page-pedrealizados')) pg.insertAdjacentHTML('afterend', _PR_PAGE);
    }
    // El check "ver los de todos" es solo para administradores.
    var w=document.getElementById('pr-todos-wrap');
    if(w && typeof prEsAdmin==='function' && prEsAdmin()) w.style.display='flex';
  }catch(e){}
}
if(document.readyState!=='loading'){ setTimeout(function(){ try{_k3MontarUI();}catch(e){} },10); }
else { document.addEventListener('DOMContentLoaded',function(){ setTimeout(function(){ try{_k3MontarUI();}catch(e){} },10); }); }


// ════════════════════════════════════════════════════════════════════
//  MAPA DE CLIENTES POR PAIS  (America del Norte, Centro, Caribe y Sur)
//  Se monta encima de la pagina de Clientes y usa el MISMO filtro de
//  pais que ya tenia el desplegable. Clic en un pais = filtrar.
//  Si el mapa no carga (sin internet, CDN bloqueado), cae a la lista
//  de banderas, que hace exactamente lo mismo.
// ════════════════════════════════════════════════════════════════════
var CM_CONT=[], CM_RAW={}, CM_LISTO=false, CM_REGION='';



var CM_REGIONES={
  norte:  {nombre:'Am\u00e9rica del Norte', paises:['US','CA','MX']},
  centro: {nombre:'Centroam\u00e9rica',      paises:['GT','BZ','SV','HN','NI','CR','PA']},
  caribe: {nombre:'Caribe',               paises:['CU','DO','HT','JM','PR','TT','BS','BB','AG','DM','GD','KN','LC','VC','AW','CW','KY','VG','VI','TC','BM','SX','BQ','GP','MQ']},
  sur:    {nombre:'Sudam\u00e9rica',        paises:['CO','VE','EC','PE','BO','BR','PY','UY','AR','CL','GY','SR','GF']}
};

var CM_ISO3={arg:'AR',bol:'BO',bra:'BR',can:'CA',chl:'CL',col:'CO',cri:'CR',cub:'CU',dom:'DO',ecu:'EC',
  slv:'SV',gtm:'GT',guy:'GY',hnd:'HN',hti:'HT',jam:'JM',mex:'MX',nic:'NI',pan:'PA',pry:'PY',per:'PE',
  pri:'PR',sur:'SR',tto:'TT',ury:'UY',usa:'US',ven:'VE',bhs:'BS',blz:'BZ',brb:'BB',esp:'ES',rus:'RU'};

var CM_NOMBRE={'PANAMA':'PA','PANAMÁ':'PA','ZONA LIBRE':'PA','COLOMBIA':'CO','COSTA RICA':'CR','VENEZUELA':'VE',
  'CUBA':'CU','ESTADOS UNIDOS':'US','USA':'US','MEXICO':'MX','MÉXICO':'MX','ECUADOR':'EC','PERU':'PE','PERÚ':'PE',
  'CHILE':'CL','ARGENTINA':'AR','BRASIL':'BR','BRAZIL':'BR','GUATEMALA':'GT','HONDURAS':'HN','NICARAGUA':'NI',
  'EL SALVADOR':'SV','REPUBLICA DOMINICANA':'DO','REPÚBLICA DOMINICANA':'DO','HAITI':'HT','HAITÍ':'HT',
  'JAMAICA':'JM','PUERTO RICO':'PR','BOLIVIA':'BO','PARAGUAY':'PY','URUGUAY':'UY','CANADA':'CA','CANADÁ':'CA',
  'ARUBA':'AW','CURAZAO':'CW','BELICE':'BZ','BELIZE':'BZ','TRINIDAD Y TOBAGO':'TT','BAHAMAS':'BS','GUYANA':'GY',
  'SURINAM':'SR','SURINAME':'SR'};

// Cualquier grafia que venga de SAP -> codigo ISO de 2 letras.
function cmISO2(country){
  var c=String(country==null?'':country).trim(); if(!c) return '';
  var k=c.toLowerCase();
  if(typeof LOCAL_FLAG!=='undefined' && LOCAL_FLAG[k]) return LOCAL_FLAG[k].toUpperCase();
  if(/^[A-Za-z]{2}$/.test(c)) return c.toUpperCase();
  if(/^[A-Za-z]{3}$/.test(c) && CM_ISO3[k]) return CM_ISO3[k];
  return CM_NOMBRE[c.toUpperCase()] || '';
}

function cmRegionDe(iso){
  for(var k in CM_REGIONES){ if(CM_REGIONES[k].paises.indexOf(iso)>=0) return k; }
  return '';
}

async function cmInit(){
  cmMontar();
  if(!CM_LISTO){ CM_LISTO=true; await cmDatos(); cmPintar(); }
  cmMarcar();
}

// Cuenta clientes por pais. Guarda tambien las grafias originales, que son
// las que hay que mandarle a la consulta.
async function cmDatos(){
  try{
    var rows=await qAll('clientes','select=country&cardtype=eq.C');
    var cnt={}; CM_RAW={};
    (rows||[]).forEach(function(r){
      var iso=cmISO2(r.country);
      if(!iso) return;
      cnt[iso]=(cnt[iso]||0)+1;
      if(!CM_RAW[iso]) CM_RAW[iso]=[];
      var raw=String(r.country||'').trim();
      if(raw && CM_RAW[iso].indexOf(raw)<0) CM_RAW[iso].push(raw);
    });
    CM_CONT=Object.keys(cnt).map(function(iso){
      return {iso:iso, n:cnt[iso], region:cmRegionDe(iso)};
    }).sort(function(a,b){ return b.n-a.n; });
  }catch(e){ CM_CONT=[]; CM_RAW={}; }
}

function cmMontar(){
  if(document.getElementById('cm-card')) return;
  var grid=document.getElementById('cli-grid'); if(!grid) return;
  var html='<div class="card" id="cm-card" style="margin-bottom:14px;padding:12px 14px">'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
      +'<span style="font-size:12.5px;font-weight:700;margin-right:4px">Distribuci\u00f3n de clientes</span>'
      +'<button class="btn btn-sm" data-reg="" onclick="cmRegion(\'\')">Todas</button>'
      +'<button class="btn btn-sm" data-reg="norte"  onclick="cmRegion(\'norte\')">Norteam\u00e9rica</button>'
      +'<button class="btn btn-sm" data-reg="centro" onclick="cmRegion(\'centro\')">Centroam\u00e9rica</button>'
      +'<button class="btn btn-sm" data-reg="caribe" onclick="cmRegion(\'caribe\')">Caribe</button>'
      +'<button class="btn btn-sm" data-reg="sur"    onclick="cmRegion(\'sur\')">Sudam\u00e9rica</button>'
      +'<span id="cm-sel" style="font-size:12px;color:var(--text3);margin-left:auto"></span>'
      +'<button class="btn btn-sm" onclick="cmVerMapa()" id="cm-toggle" title="Mostrar u ocultar el desglose">Ocultar</button>'
    +'</div>'
    +'<div id="cm-map" style="width:100%;height:330px"></div>'
    +'<div id="cm-chips" style="display:flex;gap:6px;flex-wrap:wrap;margin-top:10px"></div>'
  +'</div>';
  grid.insertAdjacentHTML('beforebegin', html);
}

function cmVerMapa(){
  var m=document.getElementById('cm-map'), b=document.getElementById('cm-toggle');
  if(!m) return;
  var oculto=(m.style.display==='none');
  m.style.display = oculto ? '' : 'none';
  if(b) b.textContent = oculto ? 'Ocultar' : 'Ver desglose';
}

// Banderas con el conteo: siempre visibles, y son el plan B si el mapa falla.
// Lista de paises agrupada por region. No pide NADA por internet: el
// distintivo es el codigo del pais dibujado con CSS, no una imagen. Asi
// sigue funcionando aunque la red bloquee todo lo de fuera.
// Las banderas se dibujan en kennedy-1.js (banderaSVG), sin pedir nada a internet.
function cmBandera(iso){ return (typeof banderaSVG==='function') ? banderaSVG(iso, 19) : ''; }

var CM_COLOR_REG={norte:'#3B82F6', centro:'#10B981', caribe:'#F59E0B', sur:'#8B5CF6'};

function cmPintarChips(){
  var box=document.getElementById('cm-chips'); if(!box) return;
  var lista=CM_CONT.filter(function(c){ return !CM_REGION || c.region===CM_REGION; });
  if(!lista.length){ box.innerHTML='<span style="font-size:12px;color:var(--text3)">Sin clientes en esta regi\u00f3n.</span>'; return; }

  function chip(c){
    var act=(cmISO2(cliPaisF)===c.iso) ||
            (window.cliPaisesF && (CM_RAW[c.iso]||[]).some(function(r){ return window.cliPaisesF.indexOf(r)>=0; }) && !!cliPaisF);
    var col=CM_COLOR_REG[c.region]||'#6B7280';
    var bandera=cmBandera(c.iso);
    // Si el pais no tiene dibujo, se muestra su codigo en un recuadro.
    var marca = bandera || ('<span style="font-size:9.5px;font-weight:800;letter-spacing:.4px;padding:2px 4px;border-radius:3px;'
      +(act?'background:rgba(255,255,255,.25)':'background:'+col+'1A;color:'+col)+'">'+c.iso+'</span>');
    return '<button class="btn btn-sm" onclick="cmPais(\''+c.iso+'\')" style="display:inline-flex;align-items:center;gap:6px;'
      +'border-left:3px solid '+col+';'
      +(act?'background:'+col+';color:#fff;border-color:'+col+';':'')+'">'
      +marca
      +npEsc(typeof paisNombre==='function'?paisNombre(c.iso):c.iso)
      +'<b style="padding:1px 5px;border-radius:8px;font-size:10.5px;'
      +(act?'background:rgba(255,255,255,.28)':'background:'+col+'1A;color:'+col)+'">'+c.n+'</b></button>';
  }

  if(CM_REGION){
    box.innerHTML=lista.map(chip).join('');
    return;
  }
  // Sin region elegida: se agrupan las cuatro, con su total.
  var orden=['norte','centro','caribe','sur'];
  var html=orden.map(function(k){
    var ls=lista.filter(function(c){ return c.region===k; });
    if(!ls.length) return '';
    var tot=0; ls.forEach(function(c){ tot+=c.n; });
    var colR=CM_COLOR_REG[k]||'#6B7280';
    return '<div style="width:100%;margin-top:4px">'
      +'<div style="font-size:10.5px;font-weight:800;color:'+colR+';text-transform:uppercase;letter-spacing:.5px;margin-bottom:5px;'
      +'display:flex;align-items:center;gap:6px">'
      +'<span style="width:9px;height:9px;border-radius:2px;background:'+colR+';display:inline-block"></span>'
      +npEsc(CM_REGIONES[k].nombre)
      +'<span style="color:var(--text3);font-weight:600">\u00b7 '+tot+' clientes</span></div>'
      +'<div style="display:flex;gap:6px;flex-wrap:wrap">'+ls.map(chip).join('')+'</div></div>';
  }).join('');
  // Fuera de America: paises reales que si tienen bandera.
  var otros=lista.filter(function(c){ return !c.region && cmBandera(c.iso); });
  if(otros.length){
    html+='<div style="width:100%;margin-top:10px">'
      +'<div style="font-size:10.5px;font-weight:800;color:#6B7280;text-transform:uppercase;letter-spacing:.5px;margin-bottom:5px;display:flex;align-items:center;gap:6px">'
      +'<span style="width:9px;height:9px;border-radius:2px;background:#6B7280;display:inline-block"></span>Resto del mundo</div>'
      +'<div style="display:flex;gap:6px;flex-wrap:wrap">'+otros.map(chip).join('')+'</div></div>';
  }

  // Codigos que no corresponden a ningun pais (probablemente codigos internos
  // de SAP). Se muestran aparte para no hacerlos pasar por paises.
  var raros=lista.filter(function(c){ return !c.region && !cmBandera(c.iso); });
  if(raros.length){
    var tr=0; raros.forEach(function(c){ tr+=c.n; });
    html+='<div style="width:100%;margin-top:10px">'
      +'<div style="font-size:10.5px;font-weight:800;color:#B45309;text-transform:uppercase;letter-spacing:.5px;margin-bottom:5px;display:flex;align-items:center;gap:6px">'
      +'<span style="width:9px;height:9px;border-radius:2px;background:#F59E0B;display:inline-block"></span>'
      +'C\u00f3digos sin pa\u00eds <span style="color:var(--text3);font-weight:600">\u00b7 '+tr+' clientes</span></div>'
      +'<div style="display:flex;gap:6px;flex-wrap:wrap">'+raros.map(chip).join('')+'</div>'
      +'<div style="font-size:11px;color:var(--text3);margin-top:5px">No coinciden con ning\u00fan pa\u00eds. Revisa el campo Pa\u00eds de estos clientes en SAP.</div></div>';
  }
  box.innerHTML=html;
}

function cmPintar(){
  // Los chips de abajo se quedan solo cuando hay una region elegida: con el
  // panel de arriba ya se ven todos los paises, repetirlos sobra.
  cmPintarChips();
  cmCargarMapa();
}

// ── Panel de distribucion por region ─────────────────────────────────────
// Aqui hubo dos intentos de mapa y los dos fallaron por motivos distintos:
// el primero cargaba una libreria de un CDN que la red de la oficina bloquea
// a ratos; el segundo dibujaba las siluetas a mano, y unos poligonos de seis
// puntos no parecen un mapa por mucho que se retoquen.
//
// Este panel no finge ser un mapa: presenta la misma informacion (donde estan
// los clientes y en que proporcion) de una forma que si se puede hacer bien
// sin depender de nadie. Para el mapa geografico de verdad hace falta el
// contorno real de cada pais, y eso son miles de coordenadas que tienen que
// venir de un archivo: ver CM_GEO_URL mas abajo.

// Si algun dia subes un world.js de jsVectorMap a los Assets de Shopify, pon
// aqui su URL y el mapa geografico se dibuja en lugar de este panel. Al estar
// en el mismo dominio que el portal, ninguna red corporativa lo bloquea.
var CM_GEO_URL = '';

function cmCargarMapa(){
  var cont=document.getElementById('cm-map'); if(!cont) return;

  var lista=CM_CONT.filter(function(c){ return c.n>0; });
  if(!lista.length){
    cont.style.height='auto';
    cont.innerHTML='<div style="padding:16px;color:var(--text3);font-size:13px">Sin clientes que mostrar.</div>';
    return;
  }

  var totalGlobal=0;
  lista.forEach(function(c){ totalGlobal+=c.n; });

  var orden=['norte','centro','caribe','sur'];
  var bloques=orden.map(function(k){
    var ls=lista.filter(function(c){ return c.region===k; })
                .sort(function(a,b){ return b.n-a.n; });
    if(!ls.length) return '';
    var tot=0, top=0;
    ls.forEach(function(c){ tot+=c.n; if(c.n>top) top=c.n; });
    var col=CM_COLOR_REG[k]||'#6B7280';
    var pct=Math.round(tot/totalGlobal*100);
    var activa=(CM_REGION===k);

    // Una fila por pais, con barra proporcional al mayor de su region.
    var filas=ls.map(function(c){
      var w=Math.max(4, Math.round(c.n/top*100));
      var sel=(cmISO2(cliPaisF)===c.iso);
      return '<div onclick="cmPais(\''+c.iso+'\')" title="'+npEsc(typeof paisNombre==="function"?paisNombre(c.iso):c.iso)+' \u00b7 '+c.n+' clientes"'
        +' style="display:flex;align-items:center;gap:8px;padding:4px 7px;border-radius:7px;cursor:pointer;'
        +(sel?('background:'+col+';color:#fff;'):'')+'margin-bottom:2px"'
        +' onmouseover="if(!this.style.background)this.style.background=\'var(--surface2,#F3F4F6)\'"'
        +' onmouseout="if(this.style.background===\'var(--surface2, #F3F4F6)\'||this.style.background===\'rgb(243, 244, 246)\')this.style.background=\'\'">'
        +'<span style="flex:0 0 26px;line-height:0">'+(typeof banderaSVG==='function'?(banderaSVG(c.iso,22)||''):'')+'</span>'
        +'<span style="flex:0 0 118px;font-size:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'
          +npEsc(typeof paisNombre==='function'?paisNombre(c.iso):c.iso)+'</span>'
        +'<span style="flex:1;height:7px;background:var(--surface2,#F1F2F4);border-radius:4px;overflow:hidden;min-width:40px">'
          +'<span style="display:block;height:100%;width:'+w+'%;background:'+(sel?'#fff':col)+';border-radius:4px"></span></span>'
        +'<span style="flex:0 0 42px;text-align:right;font-size:12px;font-weight:700">'+fmtN(c.n)+'</span>'
        +'</div>';
    }).join('');

    return '<div style="flex:1;min-width:255px;border:1px solid '+(activa?col:'var(--border)')+';'
      +'border-radius:12px;padding:11px 12px;'+(activa?('box-shadow:inset 0 0 0 1px '+col):'')+'">'
      +'<div onclick="cmRegion(\''+(activa?'':k)+'\')" style="display:flex;align-items:center;gap:8px;margin-bottom:9px;cursor:pointer">'
        +'<span style="width:10px;height:10px;border-radius:3px;background:'+col+';flex:0 0 auto"></span>'
        +'<b style="flex:1;font-size:12.5px;color:'+col+'">'+npEsc(CM_REGIONES[k].nombre)+'</b>'
        +'<span style="font-size:16px;font-weight:800">'+fmtN(tot)+'</span>'
        +'<span style="font-size:11px;color:var(--text3)">'+pct+'%</span>'
      +'</div>'
      +filas
      +'</div>';
  }).join('');

  // Paises fuera del continente, si los hay.
  var otros=lista.filter(function(c){ return !c.region; });
  var extra='';
  if(otros.length){
    var to=0; otros.forEach(function(c){ to+=c.n; });
    extra='<div style="margin-top:10px;padding-top:9px;border-top:1px solid var(--border);font-size:11.5px;color:var(--text3)">'
      +'<b>Resto del mundo \u00b7 '+fmtN(to)+'</b> &nbsp; '
      +otros.sort(function(a,b){return b.n-a.n;}).slice(0,14).map(function(c){
          return '<a href="javascript:void(0)" onclick="cmPais(\''+c.iso+'\')" style="color:var(--blue2);text-decoration:none;white-space:nowrap">'
            +npEsc(typeof paisNombre==='function'?paisNombre(c.iso):c.iso)+' <b>'+c.n+'</b></a>';
        }).join(' \u00b7 ')
      +'</div>';
  }

  // Barra de proporcion entre regiones, arriba del todo.
  var barra='<div style="display:flex;height:9px;border-radius:5px;overflow:hidden;margin-bottom:12px;background:var(--surface2,#F1F2F4)">'
    + orden.map(function(k){
        var t=0; lista.forEach(function(c){ if(c.region===k) t+=c.n; });
        if(!t) return '';
        return '<span title="'+npEsc(CM_REGIONES[k].nombre)+': '+t+'" style="width:'+(t/totalGlobal*100)+'%;background:'+(CM_COLOR_REG[k]||'#999')+'"></span>';
      }).join('')
    +'</div>';

  cont.style.height='auto';
  cont.innerHTML = barra
    + '<div style="display:flex;gap:11px;flex-wrap:wrap;align-items:flex-start">'+bloques+'</div>'
    + extra;
}

function cmColorear(){ cmCargarMapa(); }
function cmEnfocar(){ cmCargarMapa(); }

// Clic en una region: filtra todos sus paises de una vez.
function cmRegion(k){
  CM_REGION=k||'';
  var lista = k ? CM_REGIONES[k].paises : null;
  if(lista){
    var raws=[];
    lista.forEach(function(iso){ (CM_RAW[iso]||[]).forEach(function(r){ if(raws.indexOf(r)<0) raws.push(r); }); });
    window.cliPaisesF = raws.length ? raws : ['__nada__'];
    cliPaisF='';
  } else {
    window.cliPaisesF=null; cliPaisF='';
  }
  var sp=document.getElementById('cli-pais'); if(sp) sp.value='';
  cmColorear(); cmEnfocar(); cmPintarChips(); cmMarcar();
  cliPage=0; loadClientes();
}

// Clic en un pais concreto (mapa o bandera).
function cmPais(iso){
  iso=String(iso||'').toUpperCase();
  var raws=CM_RAW[iso]||[];
  if(!raws.length) return;                 // pais sin clientes: no hacemos nada
  var yaEsta = (window.cliPaisesF && window.cliPaisesF.length===raws.length && window.cliPaisesF[0]===raws[0]);
  if(yaEsta){                              // segundo clic: quitar el filtro
    window.cliPaisesF=null; cliPaisF='';
  } else {
    window.cliPaisesF=raws;
    cliPaisF=raws[0];
    CM_REGION=cmRegionDe(iso);
  }
  var sp=document.getElementById('cli-pais');
  if(sp) sp.value = window.cliPaisesF ? (raws.indexOf(sp.value)>=0?sp.value:'') : '';
  cmColorear(); cmPintarChips(); cmMarcar();
  cliPage=0; loadClientes();
}

// Deja los botones y el texto de arriba acordes al filtro puesto.
function cmMarcar(){
  var card=document.getElementById('cm-card'); if(!card) return;
  card.querySelectorAll('button[data-reg]').forEach(function(b){
    var k=b.getAttribute('data-reg')||'';
    var act=(k===CM_REGION);
    var col=CM_COLOR_REG[k]||'#2563EB';
    b.style.background = act ? col : '';
    b.style.color      = act ? '#fff' : (k?col:'');
    b.style.borderColor= act ? col : (k?col+'66':'');
    b.style.fontWeight = act ? '700' : '';
  });
  var sel=document.getElementById('cm-sel');
  if(sel){
    var txt='';
    if(window.cliPaisesF && window.cliPaisesF.length){
      txt = CM_REGION && !cliPaisF
        ? CM_REGIONES[CM_REGION].nombre
        : (typeof paisNombre==='function' ? paisNombre(window.cliPaisesF[0]) : window.cliPaisesF[0]);
      txt = 'Filtrando: '+txt;
    } else if(cliPaisF){
      txt = 'Filtrando: '+(typeof paisNombre==='function'?paisNombre(cliPaisF):cliPaisF);
    }
    sel.textContent=txt;
  }
  try{ cmPintarChips(); }catch(e){}
}


// ════════════════════════════════════════════════════════════════════
//  PDF EN FORMATO PEDIDO (tabla)
//  El PDF que ya existia es un catalogo de 3x3 con fotos grandes. Este
//  saca la MISMA tabla del Excel —mismas columnas elegidas, con lineas—
//  y cierra con los totales del documento.
// ════════════════════════════════════════════════════════════════════
async function rptPdfTabla(colsOverride){
  if(!rptLineas.length){ alert('Carga un documento primero.'); return; }
  var w=window.open('','_blank');
  if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); return; }

  var cols = colsOverride || rptCols();
  var hayFoto = cols.some(function(c){ return c.k==='foto'; });
  var campoCols = cols.filter(function(c){ return c.k!=='foto'; });
  var tipoTxt = rptTipo==='factura' ? 'FACTURA' : 'PEDIDO';

  // Las fotos se reescalan igual que en el catalogo, si no el PDF pesa una barbaridad.
  var thumbs={};
  if(hayFoto){
    try{
      w.document.write('<p style="font-family:Arial;padding:20px" id="_ld">Optimizando imagenes\u2026</p>');
      // OJO: _fetchThumbPool espera URLs (o listas de candidatas), no las
      // lineas enteras. Pasarle los objetos hacia que no redujera ninguna
      // imagen y el PDF acababa incrustando las fotos a tamano original:
      // un pedido normal salia de 80 MB.
      // Los nombres correctos son .px y .q, no .max y .q.
      var cf=_calidadFoto(rptLineas.length);
      thumbs=await _fetchThumbPool(
        rptLineas.map(function(l){ return l.foto_cands || (l.foto_url ? [l.foto_url] : []); }),
        cf.px, cf.q,
        function(d,t){
          try{ var e=w.document.getElementById('_ld'); if(e) e.textContent='Optimizando imagenes '+d+'/'+t+'\u2026'; }catch(_x){}
        });
    }catch(e){ thumbs={}; }
  }

  function m2(n){ n=Number(n)||0; return n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }

  var totCant=0, totImp=0, totBultos=0, totPeso=0, totCub=0;
  var filas = rptLineas.map(function(l, i){
    var cant  = Number(l.quantity||0);
    var imp   = (l.linetotal!=null) ? Number(l.linetotal) : cant*Number(l.price||0);
    var pk    = Number(l.packing||0);
    totCant += cant; totImp += imp;
    if(pk>0) totBultos += cant/pk;
    totPeso += (Number(l.peso||0)*cant);
    totCub  += (Number(l.volumen||0)*cant);

    var tds = campoCols.map(function(c){
      var v = rptValor(l, c.k);
      var num = (['precio','stock','packing','peso','cubicaje','bultos'].indexOf(c.k)>=0);
      return '<td class="'+(num?'r':'')+'">'+npEsc(String(v||''))+'</td>';
    }).join('');

    var foto='';
    if(hayFoto){
      // Solo la miniatura. Si no se pudo generar, la celda va vacia: caer al
      // original es lo que disparaba el tamano del archivo.
      var src = thumbs[l.foto_url] || (l.foto_cands && thumbs[l.foto_cands[0]]) || '';
      foto = '<td class="ph">'+(src?('<img src="'+src+'">'):'')+'</td>';
    }
    return '<tr>'
      +'<td class="c">'+(i+1)+'</td>'
      +foto
      +'<td>'+npEsc(l.dscription||'')
        +(l.frgnname?('<div class="en">'+npEsc(l.frgnname)+'</div>'):'')+'</td>'
      +'<td class="r b">'+fmtN(cant)+'</td>'
      +tds
      +'<td class="r b">'+m2(imp)+'</td>'
      +'</tr>';
  }).join('');

  // Fila de totales, alineada con las columnas que se hayan elegido.
  var vacias = campoCols.map(function(c){
    if(c.k==='packing') return '<td class="r">'+fmtN(Math.round(totBultos*100)/100)+' blt</td>';
    if(c.k==='peso')     return '<td class="r">'+(Math.round(totPeso*100)/100)+' kg</td>';
    if(c.k==='cubicaje') return '<td class="r">'+(Math.round(totCub*1000)/1000)+' ft\u00b3</td>';
    return '<td></td>';
  }).join('');
  // La etiqueta TOTALES tapa solo #, Foto y Descripcion: la celda siguiente
  // tiene que caer justo debajo de Cant. Si aqui se cuenta una columna de mas,
  // toda la fila se corre a la derecha y el peso, los bultos y el cubicaje
  // quedan bajo la columna equivocada.
  var colsAntes = 2 + (hayFoto?1:0);

  var docTotal = Number(rptDoc.doctotal||0);
  var desc     = Number(rptDoc.discprcnt||0);
  var resumen  = '<table class="tot"><tbody>'
    +'<tr><td>Art\u00edculos</td><td class="r">'+fmtN(rptLineas.length)+'</td></tr>'
    +'<tr><td>Unidades</td><td class="r">'+fmtN(totCant)+'</td></tr>'
    +(totBultos>0?('<tr><td>Bultos</td><td class="r">'+fmtN(Math.round(totBultos*100)/100)+'</td></tr>'):'')
    +'<tr><td>Subtotal l\u00edneas</td><td class="r">'+m2(totImp)+'</td></tr>'
    +(desc>0?('<tr><td>Descuento</td><td class="r">'+desc.toFixed(2)+' %</td></tr>'):'')
    +(docTotal>0?('<tr class="gt"><td>TOTAL DEL DOCUMENTO</td><td class="r">'+m2(docTotal)+'</td></tr>')
                :('<tr class="gt"><td>TOTAL</td><td class="r">'+m2(totImp)+'</td></tr>'))
    +'</tbody></table>';

  var th = '<tr><th class="c">#</th>'
    +(hayFoto?'<th>Foto</th>':'')
    +'<th>Descripci\u00f3n</th><th class="r">Cant.</th>'
    +campoCols.map(function(c){ return '<th class="r">'+npEsc(c.label)+'</th>'; }).join('')
    +'<th class="r">Importe</th></tr>';

  var css='@page{size:letter;margin:.42in}'
    +'*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}'
    +'body{font-family:Arial,Helvetica,sans-serif;font-size:10px;color:#1a1a1a;margin:0}'
    +'.hdr{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #6c47ff;padding-bottom:7px;margin-bottom:10px}'
    +'.hdr h1{font-size:17px;margin:0;font-weight:800;color:#111}.hdr .sub{font-size:10px;color:#777;margin-top:2px}'
    +'.hdr .rt{text-align:right;font-size:10px;color:#555;line-height:1.4}.hdr .rt b{display:block;color:#6c47ff;font-size:12px}'
    +'table.tx{width:100%;border-collapse:collapse}'
    +'table.tx th{background:#f0edff;border:1px solid #c9c2e8;padding:5px 4px;font-size:9.5px;text-align:left;color:#3d2f7a}'
    +'table.tx td{border:1px solid #d8d8e2;padding:4px;vertical-align:middle;font-size:9.5px}'
    +'table.tx tr:nth-child(even) td{background:#fafaff}'
    +'.r{text-align:right}.c{text-align:center}.b{font-weight:700}'
    +'.en{font-size:8.4px;color:#777;font-style:italic;line-height:1.15}'
    +'td.ph{width:52px;text-align:center;padding:2px}td.ph img{max-width:46px;max-height:40px;object-fit:contain}'
    +'tr.tt td{background:#f0edff!important;font-weight:700;border-top:2px solid #6c47ff;font-size:10px}'
    +'table.tot{margin:12px 0 0 auto;border-collapse:collapse;min-width:250px}'
    +'table.tot td{border:1px solid #d8d8e2;padding:5px 9px;font-size:10.5px}'
    +'table.tot tr.gt td{background:#f0edff;font-weight:800;font-size:12px;color:#3d2f7a;border-color:#6c47ff}'
    +'thead{display:table-header-group}tr{page-break-inside:avoid}';

  var html='<!doctype html><html><head><meta charset="utf-8"><title>'+tipoTxt+' '+npEsc(String(rptDoc.docnum||''))+'</title><style>'+css+'</style></head><body>'
    +'<div class="hdr"><div><h1>KENNEDY CENTER CORP.</h1><div class="sub">Zona Libre de Col\u00f3n, Panam\u00e1 \u00b7 Tel. 441-6755</div></div>'
      +'<div class="rt"><b>'+tipoTxt+' #'+npEsc(String(rptDoc.docnum||''))+'</b>'
      +'<span>'+npEsc(rptDoc.cardname||'')+'</span><br><span>'+npEsc(rptDoc.cardcode||'')+'</span><br>'
      +'<span>'+npEsc(rptDoc.docdate||'')+'</span></div></div>'
    +'<table class="tx"><thead>'+th+'</thead><tbody>'+filas
    +'<tr class="tt"><td class="c" colspan="'+colsAntes+'" style="text-align:right">TOTALES \u2192</td>'
      +'<td class="r">'+fmtN(totCant)+'</td>'+vacias+'<td class="r">'+m2(totImp)+'</td></tr>'
    +'</tbody></table>'
    + resumen
    +'<scr'+'ipt>(function(){var i=document.images,n=i.length,d=0,p=false;'
      +'function pr(){if(p)return;p=true;setTimeout(function(){window.focus();window.print();},250);}'
      +'if(!n)return pr();for(var k=0;k<n;k++){if(i[k].complete){if(++d===n)pr();}'
      +'else{i[k].onload=i[k].onerror=function(){if(++d===n)pr();};}}setTimeout(pr,9000);})();</scr'+'ipt>'
    +'</body></html>';

  w.document.open(); w.document.write(html); w.document.close(); w.focus();
}

// Igual que docReporte, pero con la tabla en vez del catalogo.
async function docReporteTabla(tipo, docnum, esNapa){
  try{
    var r=await rptFetch(tipo,docnum,esNapa);
    if(!r){ await new Promise(function(res){setTimeout(res,500);}); r=await rptFetch(tipo,docnum,esNapa); }
    if(!r){ alert('No se pudo cargar '+(tipo==='factura'?'la factura':'el pedido')+' #'+docnum+'.'); return; }
    rptTipo=tipo; rptDoc=r.doc; rptLineas=r.lineas;
    var cols=colsFromPrefix('pdc-');
    if(!cols.length) cols=RPT_CAMPOS.filter(function(f){ return ['foto','sku','precio','packing'].indexOf(f.k)>=0; });
    await rptPdfTabla(cols);
  }catch(e){ alert('Error: '+e.message); }
}


// ════════════════════════════════════════════════════════════════════
//  INVENTARIO WMS
//  Lo que dice WarehouseEdge de cada articulo, al lado de lo que dice
//  SAP. La gracia esta en la comparacion: si no cuadran, hay descuadre
//  entre el piso y el sistema.
// ════════════════════════════════════════════════════════════════════
var WMS_ROWS=[], wmsQF='', wmsSoloDif=false, wmsCargando=false, wmsOrden='dif', wmsTotalDif=null, wmsAvisoFiltro='';
var WMS_PASO=100, wmsPagina=0, wmsHayMas=false, wmsMasCargando=false;
var wmsGruposSel=[], wmsGruposLoaded=false, wmsMarcaF='', wmsDispF='';

// Precio, piezas y bultos, igual que en Inventario. Vacio = sin limite.
// Las piezas y los bultos se miden sobre la existencia del WMS, que es lo
// que esta pantalla controla; el precio sale del catalogo de SAP.
var wmsNum={pmin:'', pmax:'', smin:'', smax:'', bmin:'', bmax:''};

function wmsNumSet(k, v){
  var n=String(v==null?'':v).trim().replace(',','.');
  wmsNum[k] = (n==='' || isNaN(Number(n))) ? '' : Number(n);
  clearTimeout(wmsNumSet._t);
  wmsNumSet._t=setTimeout(function(){ WMS_ROWS=[]; wmsPagina=0; wmsCargar(); }, 450);
}

function wmsNumLimpiar(){
  wmsNum={pmin:'', pmax:'', smin:'', smax:'', bmin:'', bmax:''};
  ['pmin','pmax','smin','smax','bmin','bmax'].forEach(function(k){
    var e=document.getElementById('wms-'+k); if(e) e.value='';
  });
  WMS_ROWS=[]; wmsPagina=0; wmsCargar();
}

// Departamentos (grupos), igual que en Inventario. Se reutiliza msGruposInit,
// el mismo componente de seleccion multiple.
async function wmsGruposInit(){
  if(wmsGruposLoaded) return;
  var cont=document.getElementById('wms-grupo-ms'); if(!cont) return;
  wmsGruposLoaded=true;
  var grupos=[];
  try{
    if(typeof invGrupoCache!=='undefined' && invGrupoCache && invGrupoCache.lista){
      grupos=invGrupoCache.lista;                       // ya cargados por Inventario
    } else {
      var r=await qAll('inventario','select=grupo&grupo=not.is.null');
      var set={};
      (r||[]).forEach(function(x){ if(x.grupo) set[x.grupo]=1; });
      grupos=Object.keys(set).sort();
    }
  }catch(e){ grupos=[]; }
  try{
    msGruposInit('wms-grupo-ms', grupos, function(sel){
      wmsGruposSel=sel; WMS_ROWS=[]; wmsPagina=0; wmsCargar();
    });
  }catch(e){}
}

// Casillas de caracteristicas para el PDF/Excel. Mismo listado que Inventario,
// con prefijo propio para que no choquen los identificadores.
function wmsRenderCampos(){
  var c=document.getElementById('wms-campos'); if(!c||c.dataset.listo) return;
  c.innerHTML=INV_CAMPOS.map(function(f){
    return '<label style="display:flex;align-items:center;gap:7px;font-size:12.5px;cursor:pointer;padding:7px 9px;border:1px solid var(--border);border-radius:8px">'
      +'<input type="checkbox" id="wmsc-'+f.k+'"'+(f.def?' checked':'')+'>'+npEsc(f.label)+'</label>';
  }).join('');
  c.dataset.listo='1';
}
function wmsExpCols(){ return INV_CAMPOS.filter(function(f){ var cb=document.getElementById('wmsc-'+f.k); return cb&&cb.checked; }); }

// Exportar: se reutiliza el generador del inventario, pasandole solo los SKU
// que la pantalla del WMS tiene filtrados en este momento.
async function _wmsCodigosFiltrados(){
  var f=WMS_SEL_MIN+_wmsFiltrosURL()+_wmsOrden()+'&limit=3000';
  var r=await q('vista_wms_vs_sap', f) || [];
  return r.map(function(x){ return x.itemcode; }).filter(Boolean);
}

async function wmsExportar(tipo){
  var cols=wmsExpCols();
  if(!cols.length){ alert('Marca al menos una caracteristica para incluir.'); return; }
  var info=document.getElementById('wms-export-info');
  if(info) info.textContent='Preparando datos...';
  try{
    var codes=await _wmsCodigosFiltrados();
    if(!codes.length){ if(info) info.textContent='No hay articulos con este filtro.'; return; }
    if(codes.length>3000){ codes=codes.slice(0,3000); }
    if(info) info.textContent=fmtN(codes.length)+' articulo(s). Generando...';
    var body={p_itemcodes:codes, p_orden:'sku'};
    if(tipo==='pdf') await invPdf(cols, body);
    else             await invExcel(cols, body);
    if(info) info.textContent='';
  }catch(e){
    if(info) info.textContent='Error: '+String(e.message||e).slice(0,140);
  }
}

// Anadir un articulo al pedido en curso desde el WMS.
function wmsAlCarrito(code, nombre, precio, bulto){
  try{
    npAgregarLineaDirecta(code, nombre, Number(precio)||0, Number(bulto)||1);
  }catch(e){ alert('No se pudo anadir: '+(e.message||e)); }
}

// El WMS tiene ~149.000 articulos: no se bajan al navegador. Se consulta la
// vista vista_wms_vs_sap, que ya cruza con SAP, pidiendo solo lo que se
// muestra. Antes se intentaba traer la tabla entera y la peticion moria.
var WMS_SEL='select=itemcode,itemname,prod_class,en_pedidos_wms,comprometidas_wms,pzs_sacadas_wms,'
  +'inv_en_bin,existencia_wms,stock_sap,disponible_sap,disponible_bodega,comprometido_sap,en_sap,'
  +'diferencia,dif_abs,unidadesbulto,picturname,foto_url,actualizado_en,'
  +'grupo,subg,marca,precioventa,fechaentrada,bultos_wms';
var WMS_SEL_MIN='select=itemcode';

// Filtros que comparten la lista y la exportacion, para que el PDF salga con
// exactamente lo mismo que se ve en pantalla.
function _wmsFiltrosURL(){
  var f='';
  if(wmsQF){
    var v=encodeURIComponent(wmsQF);
    f += '&or=(itemcode.ilike.*'+v+'*,itemname.ilike.*'+v+'*)';
  } else {
    f += '&en_sap=is.true';
  }
  if(wmsGruposSel && wmsGruposSel.length){
    f += '&grupo=in.('+wmsGruposSel.map(function(g){ return '"'+String(g).replace(/"/g,'')+'"'; }).join(',')+')';
  }
  if(wmsMarcaF) f += '&marca=eq.'+encodeURIComponent(wmsMarcaF);
  if(wmsDispF==='conwms')   f += '&existencia_wms=gt.0';
  if(wmsDispF==='sinwms')   f += '&existencia_wms=lte.0';
  if(wmsDispF==='comprom')  f += '&comprometidas_wms=gt.0';

  if(wmsNum.pmin!=='') f += '&precioventa=gte.'+wmsNum.pmin;
  if(wmsNum.pmax!=='') f += '&precioventa=lte.'+wmsNum.pmax;
  if(wmsNum.smin!=='') f += '&existencia_wms=gte.'+wmsNum.smin;
  if(wmsNum.smax!=='') f += '&existencia_wms=lte.'+wmsNum.smax;
  if(wmsNum.bmin!=='') f += '&bultos_wms=gte.'+wmsNum.bmin;
  if(wmsNum.bmax!=='') f += '&bultos_wms=lte.'+wmsNum.bmax;
  return f;
}

function wmsInit(){
  var box=document.getElementById('wms-result'); if(!box) return;
  try{ wmsGruposInit(); }catch(e){}
  try{ wmsRenderCampos(); }catch(e){}
  if(WMS_ROWS.length){ wmsRender(); return; }
  wmsCargar();
}

function _wmsOrden(){
  if(wmsOrden==='exwms')       return '&order=existencia_wms.desc';
  if(wmsOrden==='exwms_asc')   return '&order=existencia_wms.asc';
  if(wmsOrden==='sku')         return '&order=itemcode.asc';
  if(wmsOrden==='nombre')      return '&order=itemname.asc';
  if(wmsOrden==='precio_desc') return '&order=precioventa.desc';
  if(wmsOrden==='precio_asc')  return '&order=precioventa.asc';
  if(wmsOrden==='reciente')    return '&order=fechaentrada.desc';
  return '&order=dif_abs.desc';
}

async function wmsCargar(){
  var box=document.getElementById('wms-result'); if(!box || wmsCargando) return;
  wmsCargando=true;
  // Solo se limpia en la primera pagina: al hacer scroll se conserva lo pintado.
  if(wmsPagina===0){
    box.innerHTML='<div class="card" style="padding:20px;color:var(--text3);font-size:13px">Consultando el WMS\u2026</div>';
  }
  try{
    // Sin busqueda se listan los descuadres, que es lo que interesa revisar.
    // Con busqueda manda lo que escribio el usuario: filtrar ademas por
    // descuadre escondia justo el articulo que estaba buscando.
    function _armar(conDif){
      var f = WMS_SEL + _wmsFiltrosURL();
      if(conDif) f += '&dif_abs=gt.0';
      // Se pide una fila de mas: si llega, es que todavia queda algo detras.
      return f + _wmsOrden()
        + '&limit=' + (WMS_PASO+1)
        + '&offset=' + (wmsPagina*WMS_PASO);
    }

    var conDif = wmsQF ? wmsSoloDif : true;
    var rows = await q('vista_wms_vs_sap', _armar(conDif)) || [];

    // Si la busqueda no devolvio nada por culpa del filtro, se repite sin el
    // en vez de dejar al usuario con una pantalla vacia.
    if(wmsPagina===0) wmsAvisoFiltro='';
    if(!rows.length && conDif && wmsQF && wmsPagina===0){
      rows = await q('vista_wms_vs_sap', _armar(false)) || [];
      if(rows.length) wmsAvisoFiltro='Este art\u00edculo cuadra entre WMS y SAP, por eso no sal\u00eda con el filtro de descuadres.';
    }

    wmsHayMas = rows.length > WMS_PASO;
    if(wmsHayMas) rows = rows.slice(0, WMS_PASO);

    var nuevas = rows.map(function(w){
      return {
        itemcode:w.itemcode, itemname:w.itemname||'', clase:w.prod_class||'',
        pedidos:Number(w.en_pedidos_wms)||0, comprom:Number(w.comprometidas_wms)||0,
        sacadas:Number(w.pzs_sacadas_wms)||0, bin:Number(w.inv_en_bin)||0,
        exWms:Number(w.existencia_wms)||0, exSap:Number(w.stock_sap)||0,
        dispSap:Number(w.disponible_sap)||0,
        comSap:Number(w.comprometido_sap)||0, dif:Number(w.diferencia)||0,
        packing:Number(w.unidadesbulto)||0, picturname:w.picturname||'', foto_url:w.foto_url||'',
        enSap:!!w.en_sap, fecha:w.actualizado_en||'',
        grupo:w.grupo||'', marca:w.marca||'', precio:Number(w.precioventa)||0,
        bultos:Number(w.bultos_wms)||0,
        dispBodega:Number(w.disponible_bodega)||0
      };
    });
    WMS_ROWS = (wmsPagina===0) ? nuevas : WMS_ROWS.concat(nuevas);

    // El total de descuadres se cuenta en el servidor, y solo una vez.
    if(wmsPagina===0){
      try{ wmsTotalDif = await qCount('vista_wms_vs_sap','en_sap=is.true&dif_abs=gt.0'); }
      catch(e){ wmsTotalDif=null; }
    }

    wmsRender();
  }catch(e){
    if(wmsPagina>0){
      // Fallo al traer mas: se avisa sin tirar abajo lo que ya estaba en pantalla.
      wmsPagina--; wmsHayMas=false;
      var pg=document.getElementById('wms-pager');
      if(pg) pg.innerHTML='<div style="padding:10px;text-align:center;color:var(--red);font-size:12px">No se pudo cargar m\u00e1s.</div>';
      return;
    }
    box.innerHTML='<div class="card" style="padding:18px">'
      +'<div style="color:var(--red);font-weight:600;font-size:13px">No se pudo consultar el WMS</div>'
      +'<div style="font-size:12px;color:var(--text3);margin-top:6px">'+npEsc(String(e.message||e))+'</div>'
      +'<div style="font-size:12px;color:var(--text3);margin-top:6px">Si falta la vista <b>vista_wms_vs_sap</b>, corre la parte A2 de <b>5-wms-supabase.sql</b> en Supabase.</div>'
      +'</div>';
  }finally{ wmsCargando=false; }
}

var _wmsTimer=null;
function wmsBuscar(v){
  wmsQF=String(v||'').trim().toLowerCase();
  clearTimeout(_wmsTimer);
  _wmsTimer=setTimeout(function(){ WMS_ROWS=[]; wmsPagina=0; wmsCargar(); }, 400);
}
function wmsDif(on){ wmsSoloDif=!!on; WMS_ROWS=[]; wmsPagina=0; wmsCargar(); }
function wmsOrdenSet(v){ wmsOrden=v||'dif'; WMS_ROWS=[]; wmsPagina=0; wmsCargar(); }
function wmsDispSet(v){ wmsDispF=v||''; WMS_ROWS=[]; wmsPagina=0; wmsCargar(); }
function wmsMarcaSet(v){ wmsMarcaF=v||''; WMS_ROWS=[]; wmsPagina=0; wmsCargar(); }

function _wmsNum(n, col){
  var v=fmtN(Math.round(Number(n)||0));
  return '<td style="text-align:right'+(col?(';color:'+col+';font-weight:700'):'')+'">'+v+'</td>';
}

function wmsRender(){
  var box=document.getElementById('wms-result'); if(!box) return;
  var rows=WMS_ROWS||[];

  if(!rows.length){
    box.innerHTML='<div class="card" style="padding:20px;text-align:center;color:var(--text3);font-size:13px">'
      +(wmsQF
        ? ('Ning\u00fan art\u00edculo del WMS coincide con <b>'+npEsc(wmsQF)+'</b>.'
           +(wmsSoloDif?'<br>Prueba a quitar el filtro <b>Solo los que no cuadran</b>: puede que este articulo si cuadre.':''))
        : 'Sin datos del WMS. Corre <b>5-wms-supabase.sql</b> en Supabase y espera un ciclo del sync.')
      +'</div>';
    return;
  }

  // Con pocos resultados se muestra la ficha completa de cada uno.
  var ficha = (rows.length<=3) ? rows.map(wmsFicha).join('') : '';
  if(wmsAvisoFiltro){
    ficha = '<div class="card" style="margin-bottom:12px;padding:10px 14px;font-size:12px;color:var(--blue2);'
      +'background:var(--blue-bg,#EFF6FF)">'+npEsc(wmsAvisoFiltro)+'</div>' + ficha;
  }

  var fecha=rows[0].fecha||'';
  var resumen='<div class="card" style="margin-bottom:12px;display:flex;gap:22px;flex-wrap:wrap;align-items:center;padding:13px 16px">'
    +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Mostrando</div><div style="font-size:19px;font-weight:700">'+fmtN(rows.length)+'</div></div>'
    +(wmsTotalDif!=null?('<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">No cuadran en total</div><div style="font-size:19px;font-weight:700;color:'+(wmsTotalDif?'var(--red)':'var(--green)')+'">'+fmtN(wmsTotalDif)+'</div></div>'):'')
    +(fecha?('<div style="margin-left:auto;font-size:11px;color:var(--text3)">Actualizado: '+npEsc(String(fecha).substring(0,16).replace('T',' '))+'</div>'):'')
    +'</div>';

  var filas=rows.map(function(r){
    var cJs=String(r.itemcode).replace(/'/g,"\\'");
    var colDif = !r.enSap ? 'var(--text3)' : (Math.abs(r.dif)<0.001 ? 'var(--green)' : (r.dif>0?'var(--amber)':'var(--red)'));
    return '<tr>'
      +'<td style="width:46px">'+fotoThumb(r.picturname,r.foto_url)+'</td>'
      +'<td><a href="javascript:void(0)" onclick="verItem(\''+cJs+'\')" style="font-weight:600;color:var(--blue2);text-decoration:none">'+npEsc(r.itemcode)+'</a>'
        +'<div style="font-size:11.5px;color:var(--text3)">'+npEsc(String(r.itemname||'').substring(0,60))+'</div></td>'
      +_wmsNum(r.pedidos)+_wmsNum(r.comprom)+_wmsNum(r.sacadas)+_wmsNum(r.bin)
      +_wmsNum(r.exWms,'var(--blue2)')
      +'<td style="text-align:right;color:var(--text3)">'+fmtN(r.bultos||0)+'</td>'
      +(r.enSap?_wmsNum(r.exSap):'<td style="text-align:right;color:var(--text3)">\u2014</td>')
      +'<td style="text-align:right;font-weight:700;color:'+colDif+'">'
        +(r.enSap?((r.dif>0?'+':'')+fmtN(Math.round(r.dif))):'no est\u00e1 en SAP')+'</td>'
      +'<td style="text-align:center">'
        +'<button class="btn btn-sm btn-p" title="A\u00f1adir al pedido en curso" '
        +'onclick="wmsAlCarrito(\''+cJs+'\',\''+String(r.itemname||'').replace(/[\\'"]/g,'')+'\','+r.precio+','+(r.packing||1)+')">+</button>'
      +'</td></tr>';
  }).join('');

  var aviso = '<div style="font-size:11.5px;color:var(--text3);padding:8px 4px">'
    + fmtN(rows.length) + ' art\u00edculo(s)'
    + (wmsHayMas ? ' \u00b7 baja para seguir cargando' : ' \u00b7 no hay m\u00e1s')
    + '</div><div id="wms-pager"></div>';

  box.innerHTML = ficha + resumen
    +'<div class="card"><div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th></th><th>Art\u00edculo</th>'
    +'<th style="text-align:right">En pedidos</th><th style="text-align:right">Comprometidas</th>'
    +'<th style="text-align:right">Pzs sacadas</th><th style="text-align:right">En bin</th>'
    +'<th style="text-align:right">Existencia WMS</th>'
    +'<th style="text-align:right" title="Bultos completos en el WMS">Bultos</th>'
    +'<th style="text-align:right">Stock SAP</th>'
    +'<th style="text-align:right">Diferencia</th><th style="text-align:center" title="A\u00f1adir al pedido">+</th></tr>'
    +filas+'</table></div>'+aviso+'</div>';

  // Scroll infinito: al acercarse el final, se pide la pagina siguiente.
  // Reutiliza el mismo helper que usan clientes, inventario y pedidos.
  _infScroll('wms-pager','wms-sentinel', wmsHayMas, function(){
    if(wmsMasCargando || !wmsHayMas) return;
    wmsMasCargando=true;
    var p=document.getElementById('wms-pager');
    if(p) p.innerHTML='<div style="padding:12px;text-align:center;color:var(--text3);font-size:12px">Cargando m\u00e1s\u2026</div>';
    wmsPagina++;
    wmsCargar().finally(function(){ wmsMasCargando=false; });
  });
}

function wmsFicha(r){
  function kpi(t,v,col){
    return '<div style="flex:1;min-width:118px"><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">'+t+'</div>'
      +'<div style="font-size:21px;font-weight:700'+(col?(';color:'+col):'')+'">'+fmtN(Math.round(v))+'</div></div>';
  }
  var cuadra=Math.abs(r.dif)<0.001;
  var bultos = r.packing>0 ? (' \u00b7 '+fmtN(Math.floor(r.exWms/r.packing))+' bultos') : '';
  return '<div class="card" style="margin-bottom:12px">'
    +'<div class="ch"><span class="ct">'+npEsc(r.itemcode)+'</span>'
      +'<span style="font-size:12px;color:var(--text3)">'+npEsc(String(r.itemname||'').substring(0,70))
      +(r.clase?(' \u00b7 clase '+npEsc(r.clase)):'')+bultos+'</span></div>'
    +'<div style="display:flex;gap:18px;flex-wrap:wrap;padding:4px 2px 10px">'
      +kpi('En pedidos WMS', r.pedidos)
      +kpi('Comprometidas', r.comprom)
      +kpi('Piezas sacadas', r.sacadas)
      +kpi('Inventario en bin', r.bin)
      +kpi('Existencia WMS', r.exWms, 'var(--blue2)')
      +kpi('Bultos en WMS', r.bultos||0)
      +(r.enSap?kpi('Stock SAP', r.exSap):'')
      +(r.enSap?kpi('Diferencia', r.dif, cuadra?'var(--green)':'var(--red)'):'')
    +'</div>'
    +'<div style="padding-bottom:8px"><button class="btn btn-p btn-sm" '
      +'onclick="wmsAlCarrito(\''+String(r.itemcode).replace(/'/g,"\\'")+'\',\''+String(r.itemname||'').replace(/[\\'"]/g,'')+'\','+r.precio+','+(r.packing||1)+')">'
      +'\u{1F6D2} A\u00f1adir al pedido'+(r.precio?(' \u00b7 '+fmt(r.precio)):'')+'</button></div>'
    +(!r.enSap
      ? '<div style="font-size:12px;color:var(--amber);font-weight:600">Este art\u00edculo est\u00e1 en el WMS pero no en el inventario de SAP.</div>'
      : (cuadra
        ? '<div style="font-size:12px;color:var(--green);font-weight:600">WMS y SAP cuadran.</div>'
        : '<div style="font-size:12px;color:var(--red);font-weight:600">Descuadre de '+fmtN(Math.abs(Math.round(r.dif)))+' unidades'
          +(r.dif>0?' de m\u00e1s en el WMS':' de menos en el WMS')+'.</div>'))
    +(!cuadra && r.enSap && r.packing>0 && Math.abs(Math.abs(r.dif)/r.packing - Math.round(Math.abs(r.dif)/r.packing))<0.001
      ? '<div style="font-size:11.5px;color:var(--text3);margin-top:4px">La diferencia son '
        +fmtN(Math.round(Math.abs(r.dif)/r.packing))+' bulto(s) exactos. El dato del WMS es de '
        +npEsc(String(r.fecha||'').substring(0,16).replace('T',' '))+' y el de SAP es de ahora mismo: '
        +'si acaba de moverse mercanc\u00eda, puede ser solo el desfase entre las dos lecturas. Vu\u00e9lvelo a mirar tras el pr\u00f3ximo ciclo del sync.</div>'
      : '')
  +'</div>';
}

var _WMS_NAV='<div class="ni" id="nav-wms" onclick="go(\'wms\',this)">'
  +'<svg style="color:#F472B6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">'
  +'<path d="M3 9l9-6 9 6v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 21V12h6v9"/></svg>'
  +'Inventario WMS</div>';

var _WMS_PAGE='<div class="page" id="page-wms">'
  +'<div class="card">'
    +'<div class="ch"><span class="ct">Inventario en WarehouseEdge</span></div>'
    +'<div style="font-size:12px;color:var(--text3);margin-bottom:12px">Lo que el WMS tiene de cada art\u00edculo, junto al stock de SAP. <b>Existencia WMS</b> = piezas sacadas + inventario en bin. Escribe un SKU para ver su ficha; sin b\u00fasqueda se listan los mayores descuadres.</div>'
    +'<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:230px"><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Art\u00edculo</label>'
        +'<input type="text" id="wms-q" placeholder="SKU o descripci\u00f3n..." oninput="wmsBuscar(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;width:100%;outline:none;box-sizing:border-box"></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Ordenar por</label>'
        +'<select id="wms-ord" onchange="wmsOrdenSet(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="dif" selected>Mayor descuadre</option><option value="exwms">Mayor existencia</option><option value="sku">SKU</option></select></div>'
      +'<div><label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Existencia WMS</label>'
        +'<select id="wms-disp" onchange="wmsDispSet(this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;background:#fff">'
        +'<option value="">Todas</option><option value="conwms">Con existencia</option>'
        +'<option value="sinwms">Sin existencia</option><option value="comprom">Con comprometidas</option></select></div>'
      +'<label style="display:flex;align-items:center;gap:6px;font-size:12.5px;color:var(--text3);cursor:pointer;padding-bottom:9px">'
        +'<input type="checkbox" id="wms-dif" onchange="wmsDif(this.checked)"> Solo los que no cuadran</label>'
      +'<button class="btn" onclick="WMS_ROWS=[];wmsPagina=0;wmsCargar()">Recargar</button>'
    +'</div>'
    +'<div style="margin-top:10px">'
      +'<label style="font-size:12px;color:var(--text3);display:block;margin-bottom:5px">Departamentos</label>'
      +'<div id="wms-grupo-ms"></div>'
    +'</div>'
    +'<div style="margin-top:12px;display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px">'
      +'<div><label style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;display:block;margin-bottom:4px">$ Precio m\u00edn.</label>'
        +'<input type="number" step="any" min="0" id="wms-pmin" placeholder="0" oninput="wmsNumSet(\'pmin\',this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;width:100%;box-sizing:border-box"></div>'
      +'<div><label style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;display:block;margin-bottom:4px">$ Precio m\u00e1x.</label>'
        +'<input type="number" step="any" min="0" id="wms-pmax" placeholder="Sin l\u00edmite" oninput="wmsNumSet(\'pmax\',this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;width:100%;box-sizing:border-box"></div>'
      +'<div><label style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;display:block;margin-bottom:4px">\u25a3 Piezas m\u00edn.</label>'
        +'<input type="number" step="any" min="0" id="wms-smin" placeholder="0" oninput="wmsNumSet(\'smin\',this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;width:100%;box-sizing:border-box"></div>'
      +'<div><label style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;display:block;margin-bottom:4px">\u25a3 Piezas m\u00e1x.</label>'
        +'<input type="number" step="any" min="0" id="wms-smax" placeholder="Sin l\u00edmite" oninput="wmsNumSet(\'smax\',this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;width:100%;box-sizing:border-box"></div>'
      +'<div><label style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;display:block;margin-bottom:4px">\u25a4 Bultos m\u00edn.</label>'
        +'<input type="number" step="any" min="0" id="wms-bmin" placeholder="0" oninput="wmsNumSet(\'bmin\',this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;width:100%;box-sizing:border-box"></div>'
      +'<div><label style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;display:block;margin-bottom:4px">\u25a4 Bultos m\u00e1x.</label>'
        +'<input type="number" step="any" min="0" id="wms-bmax" placeholder="Sin l\u00edmite" oninput="wmsNumSet(\'bmax\',this.value)" style="padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;outline:none;width:100%;box-sizing:border-box"></div>'
    +'</div>'
    +'<div style="margin-top:8px;display:flex;align-items:center;gap:10px">'
      +'<button class="btn btn-sm" onclick="wmsNumLimpiar()">Limpiar l\u00edmites</button>'
      +'<span style="font-size:11.5px;color:var(--text3)">Piezas y bultos se miden sobre la existencia del WMS. Un bulto = '
      +'existencia \u00f7 unidades por bulto, redondeando hacia abajo.</span>'
    +'</div>'
  +'</div>'
  +'<div class="card" style="margin-bottom:12px">'
    +'<div class="ch" style="flex-wrap:wrap;gap:8px"><span class="ct">\u2b07 Exportar lo filtrado</span>'
      +'<span style="display:flex;gap:8px">'
      +'<button class="btn btn-p btn-sm" onclick="wmsExportar(\'pdf\')">Generar PDF</button>'
      +'<button class="btn btn-sm" onclick="wmsExportar(\'excel\')" style="background:var(--green);color:#fff;border-color:var(--green)">Generar Excel</button>'
      +'</span></div>'
    +'<div style="font-size:12px;color:var(--text3);margin-bottom:8px">Caracteristicas a incluir en el documento:</div>'
    +'<div id="wms-campos" style="display:flex;gap:8px;flex-wrap:wrap"></div>'
    +'<div id="wms-export-info" style="font-size:12px;color:var(--blue2);margin-top:8px"></div>'
  +'</div>'
  +'<div id="wms-result"></div>'
+'</div>';

function _wmsMontarUI(){
  try{
    var ref=document.getElementById('nav-porllegar')||document.getElementById('nav-sinrot')
          ||document.getElementById('nav-inv');
    if(ref && ref.insertAdjacentHTML && !document.getElementById('nav-wms')) ref.insertAdjacentHTML('afterend', _WMS_NAV);
    var pg=document.getElementById('page-porllegar')||document.getElementById('page-sinrotacion')
         ||document.querySelector('.page');
    if(pg && pg.insertAdjacentHTML && !document.getElementById('page-wms')) pg.insertAdjacentHTML('afterend', _WMS_PAGE);
  }catch(e){}
}
if(document.readyState!=='loading'){ setTimeout(function(){ try{_wmsMontarUI();}catch(e){} },12); }
else { document.addEventListener('DOMContentLoaded',function(){ setTimeout(function(){ try{_wmsMontarUI();}catch(e){} },12); }); }


// ════════════════════════════════════════════════════════════════════
//  BORRADORES DE PEDIDO (autoguardado)
//  La cotizacion que se esta armando se guarda sola cada pocos segundos,
//  para poder cerrar el portal y seguir mas tarde desde "Pedidos
//  realizados". Al enviarla a SAP, el borrador se elimina.
// ════════════════════════════════════════════════════════════════════
var BD_ID=null;          // id del borrador en curso
var BD_ULT='';           // ultima foto guardada, para no repetir escrituras
var BD_GUARDANDO=false;
var BD_LISTA=[];         // borradores mostrados en "Pedidos realizados"

function _bdVal(id){ var e=document.getElementById(id); return e? (e.value||'') : ''; }

// Foto del estado actual del carrito. Si no cambia, no se guarda nada:
// npLineas se modifica en veinte sitios distintos, asi que comparar la foto
// es mas fiable que intentar enganchar cada uno de ellos.
function bdFoto(){
  if(!npLineas || !npLineas.length) return '';
  return JSON.stringify({
    c: npCli ? npCli.cardcode : '',
    l: npLineas.map(function(l){
      return [l.itemcode, l.quantity, l.price, l.discount, l.note||''];
    }),
    m: [_bdVal('np-fecha'), _bdVal('np-entrega'), _bdVal('np-moneda'), _bdVal('np-comments'), _bdVal('np-vendedor')]
  });
}

function bdCuerpo(){
  var t = (typeof npTotales==='function') ? npTotales() : {dgPct:0};
  var v = _bdVal('np-vendedor');
  var _esCli = CU && CU.rol==='cliente';
  return {
    // Para un cliente el usuario es su codigo: asi el borrador es suyo y las
    // politicas RLS lo dejan ver solo lo propio.
    usuario: _esCli ? String(CU.cardcode||'').toLowerCase() : ((CU && CU.username) || 'portal'),
    cardcode: _esCli ? CU.cardcode : (npCli ? npCli.cardcode : null),
    cardname: _esCli ? (CU.nombre||CU.cardcode) : (npCli ? npCli.cardname : null),
    docdate: _bdVal('np-fecha'),
    docduedate: _bdVal('np-entrega'),
    currency: _bdVal('np-moneda') || 'USD',
    comments: _bdVal('np-comments'),
    slpcode: v ? parseInt(v,10) : null,
    discprcnt: t.dgPct || 0,
    lineas: npLineas.map(function(l){
      return {itemcode:l.itemcode, itemname:l.itemname, quantity:l.quantity,
              price:l.price, discount:l.discount||0, bulto:l.bulto||1,
              whscode:l.whscode||'', note:l.note||''};
    })
  };
}

async function bdGuardar(){
  // Los clientes tambien guardan: si arman una cotizacion y cierran, deben
  // poder retomarla igual que un vendedor.
  if(BD_GUARDANDO || !CU) return;
  var foto=bdFoto();
  if(!foto || foto===BD_ULT) return;      // carrito vacio o sin cambios
  BD_GUARDANDO=true;
  try{
    var cuerpo=bdCuerpo();
    var r;
    if(BD_ID){
      r = await fetch(SB+'/rest/v1/pedidos_borrador?id=eq.'+BD_ID,{
        method:'PATCH',
        headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=minimal'},
        body: JSON.stringify(cuerpo)
      });
    } else {
      r = await fetch(SB+'/rest/v1/pedidos_borrador',{
        method:'POST',
        headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=representation'},
        body: JSON.stringify(cuerpo)
      });
      if(r.ok){ var d=await r.json(); if(d && d[0]) BD_ID=d[0].id; }
    }
    if(r && r.ok){ BD_ULT=foto; bdAviso('Borrador guardado'); }
  }catch(e){ /* sin conexion: se reintenta en el proximo ciclo */ }
  finally{ BD_GUARDANDO=false; }
}

// Aviso discreto en la barra del carrito, para que se note que quedo a salvo.
function bdAviso(txt){
  var bar=document.getElementById('cotiz-info'); if(!bar) return;
  var e=document.getElementById('bd-aviso');
  if(!e){
    e=document.createElement('span'); e.id='bd-aviso';
    e.style.cssText='margin-left:8px;font-size:11px;opacity:.75';
    bar.appendChild(e);
  }
  e.textContent='\u00b7 '+txt;
  clearTimeout(e._t);
  e._t=setTimeout(function(){ if(e) e.textContent=''; }, 2500);
}

// Cada 8 segundos se compara la foto; si cambio, se guarda.
setInterval(function(){ try{ bdGuardar(); }catch(e){} }, 8000);

// Al enviar la cotizacion a SAP el borrador sobra: se elimina.
async function bdCerrar(){
  var id=BD_ID; BD_ID=null; BD_ULT='';
  if(!id) return;
  try{
    await fetch(SB+'/rest/v1/pedidos_borrador?id=eq.'+id,{
      method:'DELETE',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Prefer':'return=minimal'}
    });
  }catch(e){}
}

// ── Retomar un borrador ────────────────────────────────────────────────────
async function bdContinuar(id){
  try{
    var r=await q('pedidos_borrador','select=*&id=eq.'+id+'&limit=1');
    var b=r && r[0];
    if(!b){ alert('No encontr\u00e9 ese borrador. Puede que ya se haya eliminado.'); prCargar(); return; }

    if(npLineas && npLineas.length && BD_ID && String(BD_ID)!==String(id)){
      if(!confirm('Tienes otra cotizaci\u00f3n a medias. Si contin\u00faas, se guarda aparte y se abre esta. \u00bfSigo?')) return;
      await bdGuardar();
    }

    npCli = b.cardcode ? {cardcode:b.cardcode, cardname:b.cardname||b.cardcode} : null;
    var ls = (typeof b.lineas==='string') ? JSON.parse(b.lineas) : (b.lineas||[]);
    npLineas = (ls||[]).map(function(l){
      return {itemcode:l.itemcode, itemname:l.itemname||l.itemcode,
              quantity:Number(l.quantity)||0, price:Number(l.price)||0,
              discount:Number(l.discount)||0, bulto:Number(l.bulto)||1,
              whscode:l.whscode||'', note:l.note||''};
    });
    BD_ID=b.id; BD_ULT='';

    go('nuevo_pedido', document.getElementById('nav-np'));

    setTimeout(function(){
      // Rellenar la cabecera con lo que se habia guardado.
      [['np-fecha',b.docdate],['np-entrega',b.docduedate],['np-moneda',b.currency],
       ['np-comments',b.comments],['np-vendedor',b.slpcode]].forEach(function(p){
        var e=document.getElementById(p[0]);
        if(e && p[1]!=null && p[1]!=='') e.value=p[1];
      });
      if(npCli){
        var nm=document.getElementById('np-cli-name'); if(nm) nm.textContent=npCli.cardname;
        var mt=document.getElementById('np-cli-meta'); if(mt) mt.textContent=npCli.cardcode;
        var av=document.getElementById('np-cli-av');   if(av) av.textContent=(npCli.cardname||'?').slice(0,2).toUpperCase();
        var inp=document.getElementById('np-cli-q');   if(inp) inp.style.display='none';
        var sel=document.getElementById('np-cli-sel'); if(sel) sel.style.display='block';
      }
      try{ cotizUpdate(); }catch(e){}
      try{ npRenderLineas(); }catch(e){}
      try{ npUpdateBtn && npUpdateBtn(); }catch(e){}
      try{ npIr(npCli?3:1); }catch(e){}
      BD_ULT=bdFoto();      // recien cargado: aun no hay nada que guardar
    }, 220);
  }catch(e){ alert('No se pudo abrir el borrador: '+(e.message||e)); }
}

async function bdEliminar(id, nombre){
  if(!confirm('Eliminar para siempre el borrador de '+(nombre||'este cliente')+'?\n\nEsta acci\u00f3n no se puede deshacer.')) return;
  try{
    var r=await fetch(SB+'/rest/v1/pedidos_borrador?id=eq.'+id,{
      method:'DELETE',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Prefer':'return=minimal'}
    });
    if(!r.ok) throw new Error(await r.text());
    if(String(BD_ID)===String(id)){ BD_ID=null; BD_ULT=''; }
    prCargar();
  }catch(e){ alert('No se pudo eliminar: '+String(e.message||e).slice(0,160)); }
}

async function bdListar(){
  try{
    var campos='id,usuario,cardcode,cardname,lineas,discprcnt,creado_en,actualizado_en';
    var base='select='+campos+'&order=actualizado_en.desc&limit=100';
    var yo=String((CU&&CU.username)||'').toLowerCase();

    if(CU && CU.rol==='cliente'){
      BD_LISTA = await q('pedidos_borrador',
        base+'&cardcode=eq.'+encodeURIComponent(CU.cardcode||'')) || [];
    } else if(prEsAdmin() && prTodos){
      BD_LISTA = await q('pedidos_borrador', base) || [];
    } else {
      // Los mios Y los que estan armando MIS CLIENTES. Antes solo salian los
      // propios, asi que un vendedor no veia en que andaba su cliente.
      var mios = await q('pedidos_borrador',
        base+'&usuario=eq.'+encodeURIComponent((CU&&CU.username)||'')) || [];
      var deClientes=[];
      try{
        var codes=await prcMisClientes();
        for(var i=0;i<codes.length;i+=150){
          var lote=codes.slice(i,i+150)
            .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
          var r=await q('pedidos_borrador', base+'&cardcode=in.('+lote+')') || [];
          deClientes=deClientes.concat(r);
        }
      }catch(e){}
      var visto={}, todo=[];
      mios.concat(deClientes).forEach(function(b){
        if(visto[b.id]) return;
        visto[b.id]=1;
        // Marca lo que NO es mio: es el trabajo del cliente, no el propio.
        b._ajeno = String(b.usuario||'').toLowerCase() !== yo;
        todo.push(b);
      });
      todo.sort(function(a,b){
        return String(b.actualizado_en||'').localeCompare(String(a.actualizado_en||''));
      });
      BD_LISTA=todo;
    }
  }catch(e){ BD_LISTA=[]; }
}

function _bdTotal(b){
  try{
    var ls=(typeof b.lineas==='string')?JSON.parse(b.lineas):(b.lineas||[]);
    var t=0;
    (ls||[]).forEach(function(l){
      t += (Number(l.quantity)||0)*(Number(l.price)||0)*(1-(Number(l.discount)||0)/100);
    });
    return t*(1-(Number(b.discprcnt)||0)/100);
  }catch(e){ return 0; }
}
function _bdItems(b){
  try{
    var ls=(typeof b.lineas==='string')?JSON.parse(b.lineas):(b.lineas||[]);
    return (ls||[]).length;
  }catch(e){ return 0; }
}

function _bdAjenos(){
  var n=0;
  (BD_LISTA||[]).forEach(function(b){ if(b._ajeno) n++; });
  return n;
}

function bdRenderLista(){
  if(!BD_LISTA.length) return '';
  var filas=BD_LISTA.map(function(b){
    var nom=String(b.cardname||b.cardcode||'Sin cliente').replace(/'/g,"\\'");
    var enCurso = String(BD_ID)===String(b.id);
    return '<tr'+(b._ajeno?' style="background:var(--bg)"':'')+'>'
      +'<td style="white-space:nowrap;font-size:12px">'+_prFechaHora(b.actualizado_en)+'</td>'
      +'<td><b>'+npEsc(b.cardname||b.cardcode||'Sin cliente')+'</b>'
        +(b.cardcode?('<div style="font-size:11px;color:var(--text3)">'+npEsc(b.cardcode)+'</div>'):'')
        +(enCurso?'<div style="font-size:11px;color:var(--blue2);font-weight:600">Es el que tienes abierto</div>':'')+'</td>'
      +'<td style="text-transform:capitalize;font-size:12px">'+npEsc(b.usuario||'')
        +(b._ajeno?'<div style="font-size:10.5px;color:#7C3AED;font-weight:600;'
          +'text-transform:none">lo est\u00e1 armando el cliente</div>':'')+'</td>'
      +'<td style="text-align:right">'+fmtN(_bdItems(b))+'</td>'
      +'<td style="text-align:right;font-weight:600">'+fmt(_bdTotal(b))+'</td>'
      +'<td style="white-space:nowrap;text-align:right">'
        +'<button class="btn btn-sm btn-p" onclick="bdContinuar('+b.id+')">'
        +(b._ajeno?'Trabajarlo':'Continuar')+'</button> '
        // El borrador de un cliente NO se puede eliminar desde aqui: es su
        // trabajo, y borrarselo mientras lo arma seria desastroso.
        +(b._ajeno ? ''
          : '<button class="btn btn-sm" onclick="bdEliminar('+b.id+',\''+nom+'\')" '
            +'style="color:var(--red);border-color:var(--red)">Eliminar</button>')
      +'</td></tr>';
  }).join('');

  return '<div class="card" style="margin-bottom:12px">'
    +'<div class="ch"><span class="ct">\u270f\ufe0f Borradores sin enviar ('+BD_LISTA.length+')</span>'
      +'<span style="font-size:12px;color:var(--text3)">'
      +(_bdAjenos()
        ? ('Incluye <b>'+_bdAjenos()+'</b> que est\u00e1n armando tus clientes')
        : 'Se guardan solos mientras armas la cotizaci\u00f3n')+'</span></div>'
    +'<div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th>\u00daltimo cambio</th><th>Cliente</th><th>Usuario</th>'
    +'<th style="text-align:right">\u00cdtems</th><th style="text-align:right">Total</th><th></th></tr>'
    +filas+'</table></div></div>';
}



// ════════════════════════════════════════════════════════════════════
//  BLOQUE MOVIDO DESDE page_app.liquid
//  Estaba como <script> dentro de la plantilla, justo debajo de los dos
//  asset_url. Se traslado aqui porque el .liquid supero el limite de 256 KB
//  que impone Shopify. El orden de ejecucion no cambia: este archivo se
//  carga en el mismo punto donde estaba el script.
//  No contenia ninguna etiqueta Liquid, asi que se movio tal cual.
// ════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════
// MÓDULO OPOR - OVERRIDE (evita conflicto con kennedy-2.js)
// ═══════════════════════════════════════════════════════════════

// Variable global sin redeclarar (usa window para evitar SyntaxError)
window.ordenActualOPOR = window.ordenActualOPOR || null;

window.mostrarTabOPOR = function() {
  const tabOpch = document.getElementById('tab-opch');
  const tabOpor = document.getElementById('tab-opor');
  if (tabOpch && tabOpor) {
    tabOpch.style.display = 'none';
    tabOpor.style.display = 'block';
    cargarOPOR();
  }
};

window._oporSel = null;

// Códigos del campo U_EstCompra en SAP -> texto completo + color
// P=Pendiente, D=Despachado, C=Confirmado, S=Embarcado
window._OPOR_ESTADOS = {
  'P': { txt: 'PENDIENTE',  bg: '#fff3e0', fg: '#e65100' },  // naranja
  'D': { txt: 'DESPACHADO', bg: '#ede7f6', fg: '#5e35b1' },  // morado
  'C': { txt: 'CONFIRMADO', bg: '#e3f2fd', fg: '#1565c0' },  // azul
  'S': { txt: 'EMBARCADO',  bg: '#e8f5e9', fg: '#2e7d32' }   // verde
};

window._oporEstadoInfo = function(o) {
  var raw = (o.estado_compra || '').toString().trim();
  // 1) Si es un código conocido (P/D/C/S), traducirlo
  if (raw.length === 1 && window._OPOR_ESTADOS[raw.toUpperCase()]) {
    return window._OPOR_ESTADOS[raw.toUpperCase()];
  }
  // 2) Si ya viene el texto completo, usarlo con color por palabra clave
  var txt = raw.toUpperCase();
  if (!txt) txt = (o.doc_status === 'C') ? 'CERRADA' : 'ABIERTA';
  var bg = '#eceff1', fg = '#546e7a';           // gris por defecto
  if (txt.indexOf('EMBARC') === 0)      { bg = '#e8f5e9'; fg = '#2e7d32'; }
  else if (txt.indexOf('CONFIRM') === 0){ bg = '#e3f2fd'; fg = '#1565c0'; }
  else if (txt.indexOf('DESPACH') === 0){ bg = '#ede7f6'; fg = '#5e35b1'; }
  else if (txt.indexOf('PEND') === 0)   { bg = '#fff3e0'; fg = '#e65100'; }
  else if (txt.indexOf('ABIER') === 0)  { bg = '#e8f5e9'; fg = '#2e7d32'; }
  return { txt: txt, bg: bg, fg: fg };
};

window._oporRow = function(o) {
  var dias = (o.duedate && o.docdate) ? Math.round((new Date(o.duedate) - new Date(o.docdate)) / 86400000) : 0;
  var total = parseFloat(o.total) || 0;
  var abono = parseFloat(o.abono) || 0;
  var pend = total - abono;
  var saldo = parseFloat(o.saldo_cxp) || 0;
  var f = function(n){ return '$' + (parseFloat(n)||0).toLocaleString('es-ES',{minimumFractionDigits:2}); };
  var est = window._oporEstadoInfo(o);
  var diasStyle = dias < 0 ? 'background:#ef5350;color:white;font-weight:700' : '';
  return '<tr data-docnum="' + o.docnum + '" onclick="verDetallesOPOR(\'' + o.docnum + '\')" style="border-bottom:1px solid var(--border);cursor:pointer" onmouseover="this.style.background=\'var(--bg-2)\'" onmouseout="if(!this.classList.contains(\'opor-active\'))this.style.background=\'\'">' +
    '<td style="padding:5px 6px;white-space:nowrap">' + (o.marca_cliente||'-') + '</td>' +
    '<td style="padding:5px 6px">' + (o.vendor_name||'-') + '</td>' +
    '<td style="padding:5px 6px;text-align:center;white-space:nowrap">' + (o.vendor_code||'-') + '</td>' +
    '<td style="padding:5px 6px;font-weight:600;color:var(--blue2);white-space:nowrap">' + o.docnum + (o._desglosado ? ' <span title="Orden con varios proveedores" style="font-size:8px;color:var(--text3);font-weight:400">⑂</span>' : '') + '</td>' +
    '<td style="padding:5px 6px;white-space:nowrap">' + (o.num_proveedor||'-') + '</td>' +
    '<td style="padding:5px 6px;text-align:center"><span style="display:inline-block;padding:2px 7px;border-radius:10px;font-size:9px;font-weight:700;white-space:nowrap;background:' + est.bg + ';color:' + est.fg + '">' + est.txt + '</span></td>' +
    '<td style="padding:5px 6px;white-space:nowrap">' + (o.docdate||'-') + '</td>' +
    '<td style="padding:5px 6px;white-space:nowrap">' + (o.duedate||'-') + '</td>' +
    '<td style="padding:5px 6px;text-align:center;' + diasStyle + '">' + dias + '</td>' +
    '<td style="padding:5px 6px;text-align:right;white-space:nowrap">' + f(total) + '</td>' +
    '<td style="padding:5px 6px;text-align:right;white-space:nowrap">' + f(abono) + '</td>' +
    '<td style="padding:5px 6px;text-align:right;white-space:nowrap;font-weight:600">' + f(pend) + '</td>' +
    '<td style="padding:5px 6px;white-space:nowrap">' + (o.grupo_pago||'-') + '</td>' +
    '<td style="padding:5px 6px;text-align:right;white-space:nowrap">' + (parseFloat(o.porcentaje)||0).toFixed(1) + '%</td>' +
    '<td style="padding:5px 6px;text-align:right;white-space:nowrap">' + f(saldo) + '</td>' +
    '<td style="padding:5px 6px;text-align:center;white-space:nowrap">' + (o.num_contenedor_campo||o.contenedor||'-') + '</td>' +
    '</tr>';
};

window._oporHighlight = function(docnum) {
  document.querySelectorAll('#opor-tbody tr').forEach(function(tr){
    if (tr.getAttribute('data-docnum') === String(docnum)) {
      tr.classList.add('opor-active');
      tr.style.background = 'var(--blue-pale,#e3f2fd)';
    } else {
      tr.classList.remove('opor-active');
      tr.style.background = '';
    }
  });
};

window._oporTodas = [];   // todas las órdenes en memoria (para filtrar sin recargar)

window.cargarOPOR = async function() {
  const $tbody = document.getElementById('opor-tbody');
  if (!$tbody) return;
  $tbody.innerHTML = '<tr><td colspan="16" style="padding:40px;text-align:center;color:var(--text3)">Cargando órdenes OPOR...</td></tr>';
  try {
    console.log('🔹 cargarOPOR iniciado');
    // 1) Cabeceras de órdenes
    const resp = await fetch(SB + '/rest/v1/opor_ordenes?select=*&limit=2000&order=docnum.desc', {
      method: 'GET',
      headers: { 'apikey': KEY, 'Authorization': 'Bearer ' + AUTHTOK(), 'Content-Type': 'application/json' }
    });
    const data = await resp.json();
    let ordenes = Array.isArray(data) ? data : [];
    console.log('✅ Órdenes:', ordenes.length);

    // 2) Líneas (para desglosar por proveedor del artículo, como SAP)
    //    Supabase corta en 1000 filas por defecto; paginamos con Range hasta traer todo.
    let lineas = [];
    try {
      var desde = 0, tam = 1000, seguir = true;
      while (seguir) {
        var rL = await fetch(SB + '/rest/v1/opor_lineas?select=docnum,item_vendor_name,item_vendor_code,total_linea&order=docnum', {
          headers: {
            'apikey': KEY, 'Authorization': 'Bearer ' + AUTHTOK(),
            'Range-Unit': 'items',
            'Range': desde + '-' + (desde + tam - 1)
          }
        });
        var dL = await rL.json();
        if (Array.isArray(dL) && dL.length) {
          lineas = lineas.concat(dL);
          if (dL.length < tam) seguir = false; else desde += tam;
        } else {
          seguir = false;
        }
        if (desde > 100000) seguir = false;  // tope de seguridad
      }
      console.log('Líneas cargadas:', lineas.length);
    } catch(le) { console.warn('sin líneas para desglose:', le); }

    // 3) Agrupa las líneas por (orden + proveedor del item) y suma sus montos
    var desglose = {};  // docnum -> { provName -> {monto, code} }
    lineas.forEach(function(l){
      var dn = String(l.docnum);
      var prov = (l.item_vendor_name || '').trim();
      if (!prov) return;
      if (!desglose[dn]) desglose[dn] = {};
      if (!desglose[dn][prov]) desglose[dn][prov] = { monto:0, code:l.item_vendor_code||'' };
      desglose[dn][prov].monto += parseFloat(l.total_linea) || 0;
    });

    // 4) Expande: si una orden tiene >1 proveedor, genera una fila por proveedor
    var expandidas = [];
    ordenes.forEach(function(o){
      var dn = String(o.docnum);
      var provs = desglose[dn] ? Object.keys(desglose[dn]) : [];
      if (provs.length > 1) {
        // Orden con varios proveedores -> una fila por proveedor (como SAP)
        provs.forEach(function(pn){
          var copia = Object.assign({}, o);
          copia.vendor_name = pn;                          // proveedor del grupo
          copia.vendor_code = desglose[dn][pn].code || o.vendor_code;
          copia.total = desglose[dn][pn].monto;            // monto de ese proveedor
          copia.abono = 0;                                 // el abono es a nivel orden; se muestra 0 por fila
          copia._desglosado = true;
          copia._ordenBase = dn;
          expandidas.push(copia);
        });
      } else {
        // Orden normal (un solo proveedor) -> tal cual
        expandidas.push(o);
      }
    });
    console.log('Filas tras desglose:', expandidas.length);

    window._oporTodas = expandidas;
    window._oporPoblarFiltros(expandidas);
    if (!expandidas.length) {
      $tbody.innerHTML = '<tr><td colspan="16" style="padding:40px;text-align:center;color:var(--text3)">Sin órdenes OPOR (revisa el sync en Python)</td></tr>';
      return;
    }
    window.aplicarFiltrosOPOR();
  } catch(e) {
    console.error('❌ Error OPOR:', e);
    $tbody.innerHTML = '<tr><td colspan="16" style="padding:40px;text-align:center;color:red">Error: ' + e.message + '</td></tr>';
  }
};

// Rellena los <select> de estado, proveedor y departamento con valores únicos
window._oporPoblarFiltros = function(ordenes) {
  var estados = {}, provs = {}, deptos = {};
  ordenes.forEach(function(o){
    var est = window._oporEstadoInfo(o).txt;
    if (est) estados[est] = 1;
    if (o.vendor_name) provs[o.vendor_name] = 1;
    var dep = (o.marca_cliente || '').trim();
    if (dep) deptos[dep] = 1;
  });
  var llenar = function(id, valores, etiqueta) {
    var sel = document.getElementById(id);
    if (!sel) return;
    var actual = sel.value;
    var opts = '<option value="">' + etiqueta + '</option>';
    Object.keys(valores).sort().forEach(function(v){
      opts += '<option value="' + v.replace(/"/g,'&quot;') + '">' + v + '</option>';
    });
    sel.innerHTML = opts;
    if (actual) sel.value = actual;   // conserva selección al recargar
  };
  llenar('opor-f-estado', estados, 'Todos los estados');
  llenar('opor-f-proveedor', provs, 'Todos los proveedores');
  llenar('opor-f-depto', deptos, 'Todos los departamentos');
};

// Aplica buscador + los 3 filtros sobre las órdenes en memoria
window.aplicarFiltrosOPOR = function() {
  var $tbody = document.getElementById('opor-tbody');
  if (!$tbody) return;
  var term = (document.getElementById('opor-search') || {}).value || '';
  term = term.trim().toLowerCase();
  var fEstado = (document.getElementById('opor-f-estado') || {}).value || '';
  var fProv = (document.getElementById('opor-f-proveedor') || {}).value || '';
  var fDepto = (document.getElementById('opor-f-depto') || {}).value || '';

  var filtradas = window._oporTodas.filter(function(o){
    if (term) {
      var hay = (String(o.docnum||'').toLowerCase().indexOf(term) >= 0) ||
                (String(o.vendor_name||'').toLowerCase().indexOf(term) >= 0) ||
                (String(o.num_proveedor||'').toLowerCase().indexOf(term) >= 0);
      if (!hay) return false;
    }
    if (fEstado && window._oporEstadoInfo(o).txt !== fEstado) return false;
    if (fProv && (o.vendor_name||'') !== fProv) return false;
    if (fDepto && (o.marca_cliente||'').trim() !== fDepto) return false;
    return true;
  });

  var $c = document.getElementById('opor-count');
  if ($c) $c.textContent = filtradas.length + ' de ' + window._oporTodas.length;

  if (!filtradas.length) {
    $tbody.innerHTML = '<tr><td colspan="16" style="padding:40px;text-align:center;color:var(--text3)">Sin resultados con esos filtros</td></tr>';
    return;
  }
  $tbody.innerHTML = filtradas.map(window._oporRow).join('');
  verDetallesOPOR(filtradas[0].docnum);
};

window.limpiarFiltrosOPOR = function() {
  ['opor-search','opor-f-estado','opor-f-proveedor','opor-f-depto'].forEach(function(id){
    var el = document.getElementById(id); if (el) el.value = '';
  });
  window.aplicarFiltrosOPOR();
};

// Compatibilidad: el buscador ahora pasa por los filtros
window.searchOPOR = function(term) { window.aplicarFiltrosOPOR(); };

window.verDetallesOPOR = async function(docnum) {
  const $detalles = document.getElementById('opor-detalles');
  if (!$detalles) return;
  $detalles.style.display = 'block';
  window._oporHighlight(docnum);
  document.getElementById('opor-detalle-titulo').textContent = 'Orden ' + docnum;
  document.getElementById('opor-lineas-tbody').innerHTML = '<tr><td colspan="4" style="padding:16px;text-align:center;color:var(--text3)">Cargando...</td></tr>';
  try {
    const respOrden = await fetch(SB + '/rest/v1/opor_ordenes?docnum=eq.' + docnum, {
      headers: { 'apikey': KEY, 'Authorization': 'Bearer ' + AUTHTOK() }
    });
    const ordenes = await respOrden.json();
    const orden = (Array.isArray(ordenes) && ordenes.length > 0) ? ordenes[0] : null;
    if (!orden) {
      document.getElementById('opor-lineas-tbody').innerHTML = '<tr><td colspan="4" style="padding:16px;text-align:center;color:red">No encontrada</td></tr>';
      return;
    }
    window.ordenActualOPOR = orden;
    var est = window._oporEstadoInfo(orden);
    var tit = document.getElementById('opor-detalle-titulo');
    if (tit) tit.innerHTML = 'Orden ' + docnum +
      ' <span style="display:inline-block;margin-left:6px;padding:2px 8px;border-radius:10px;font-size:10px;font-weight:700;vertical-align:middle;background:' + est.bg + ';color:' + est.fg + '">' + est.txt + '</span>';
    var setTxt = function(id, val){ var el = document.getElementById(id); if (el) el.textContent = val; };
    var f = function(n){ return '$' + (parseFloat(n)||0).toLocaleString('es-ES', {minimumFractionDigits:2}); };
    setTxt('opor-proveedor', orden.vendor_name || '-');
    setTxt('opor-vendor-code', orden.vendor_code || '-');
    setTxt('opor-skc', orden.num_proveedor || '-');
    setTxt('opor-fecha', orden.docdate || '-');
    setTxt('opor-entrega', orden.duedate || '-');
    setTxt('opor-barco', orden.barco || '-');
    setTxt('opor-eta-det', orden.eta || '-');
    setTxt('opor-pais', orden.pais || '-');
    setTxt('opor-puerto', orden.puerto_embarque || '-');
    setTxt('opor-cpago', orden.grupo_pago || '-');
    setTxt('opor-abono', f(orden.abono));
    setTxt('opor-total', f(orden.total));

    const respLineas = await fetch(SB + '/rest/v1/opor_lineas?docnum=eq.' + docnum, {
      headers: { 'apikey': KEY, 'Authorization': 'Bearer ' + AUTHTOK() }
    });
    const lineas = await respLineas.json();
    if (!Array.isArray(lineas) || !lineas.length) {
      document.getElementById('opor-lineas-tbody').innerHTML = '<tr><td colspan="4" style="padding:16px;text-align:center">Sin líneas</td></tr>';
      return;
    }
    document.getElementById('opor-lineas-tbody').innerHTML = lineas.map(function(l) {
      // Usa la misma función de fotos del portal (bucket fotos-items + respaldo Shopify)
      var foto = (typeof lineFoto === 'function')
        ? lineFoto(l.picturname || l.foto_nombre, l.foto_url)
        : '<span style="color:var(--text3)">—</span>';
      return '<tr style="border-bottom:1px solid var(--border)">' +
        '<td style="padding:5px;text-align:center">' + foto + '</td>' +
        '<td style="padding:5px"><div style="font-weight:600">' + (l.itemcode||'-') + '</div><div style="color:var(--text3);font-size:9px">' + (l.itemname||'') + '</div></td>' +
        '<td style="padding:5px;text-align:right">' + (parseFloat(l.cantidad)||0).toLocaleString('es-ES') + '</td>' +
        '<td style="padding:5px;text-align:right;font-weight:600">' + f(l.total_linea) + '</td>' +
        '</tr>';
    }).join('');
  } catch(e) {
    console.error('Error detalles:', e);
    document.getElementById('opor-lineas-tbody').innerHTML = '<tr><td colspan="4" style="padding:16px;color:red">Error: ' + e.message + '</td></tr>';
  }
};

window.cerrarDetallesOPOR = function() {
  const $d = document.getElementById('opor-detalles');
  if ($d) $d.style.display = 'none';
  window.ordenActualOPOR = null;
};

window.exportarOPORAll = async function() {
  if (!window.ordenActualOPOR) { alert('Selecciona una orden primero'); return; }
  try {
    const o = window.ordenActualOPOR;
    let csv = 'ORDEN DE COMPRA\n\n';
    csv += 'Numero,' + o.docnum + '\n';
    csv += 'Proveedor,' + o.vendor_name + '\n';
    csv += 'Fecha,' + o.docdate + '\n';
    csv += 'Entrega,' + o.duedate + '\n';
    csv += 'Total,$' + (parseFloat(o.total)||0).toFixed(2) + '\n\n';
    csv += 'Item,Descripcion,Cantidad,Precio,Total\n';
    const lineas = await fetch(SB + '/rest/v1/opor_lineas?docnum=eq.' + o.docnum, {
      headers: { 'apikey': KEY, 'Authorization': 'Bearer ' + AUTHTOK() }
    }).then(function(r){return r.json();});
    lineas.forEach(function(l) {
      csv += '"' + l.itemcode + '","' + l.itemname + '",' + l.cantidad + ',' + l.precio + ',' + l.total_linea + '\n';
    });
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'OPOR-' + o.docnum + '.csv';
    link.click();
  } catch(e) { alert('Error exportando'); }
};

window.oporVerFoto = function(img) {
  var u = img.getAttribute('data-foto');
  if (u) window.open(u, '_blank');
};

// ── Auto-carga: cuando la página de órdenes se vuelve visible, carga OPOR sola ──
(function() {
  var _oporCargando = false;
  function paginaOporVisible() {
    var pg = document.getElementById('page-ordenes_compra');
    return pg && pg.classList.contains('active');
  }
  function intentarCargar() {
    if (!paginaOporVisible()) return;
    if (typeof SB === 'undefined' || typeof KEY === 'undefined') return; // aún no cargó kennedy-1.js
    if (_oporCargando) return;
    _oporCargando = true;
    try { cargarOPOR(); } catch(e) { console.error('auto cargarOPOR:', e); }
    setTimeout(function(){ _oporCargando = false; }, 1500);
  }
  // 1) Observa cambios de clase en la página (cuando go() le pone .active)
  var pg = document.getElementById('page-ordenes_compra');
  if (pg && window.MutationObserver) {
    new MutationObserver(intentarCargar).observe(pg, { attributes: true, attributeFilter: ['class'] });
  }
  // 2) Respaldo: por si ya estaba activa al cargar el script
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(intentarCargar, 300); });
  setTimeout(intentarCargar, 800);
})();

// ═══════════════════════════════════════════════════════════════
//  REPORTE: Compradores de mercancía recién llegada
// ═══════════════════════════════════════════════════════════════
window._recAll = [];    // items agrupados (desde la vista), ya listos
window._recShown = 0;   // cuántos items se están mostrando (paginación)
var REC_PAGE = 20;      // items por página (evita colgar el navegador)

window.recCargar = async function() {
  var $res = document.getElementById('rec-res');
  var $cnt = document.getElementById('rec-count');
  if (!$res) return;
  $res.innerHTML = '<div style="padding:30px;text-align:center;color:var(--text3)">Cargando...</div>';
  if ($cnt) $cnt.textContent = '';
  try {
    var dias = parseInt((document.getElementById('rec-dias')||{}).value || '30', 10);
    var desde = new Date(); desde.setDate(desde.getDate() - dias);
    var desdeStr = hoyLocal(desde);

    // Trae TODO desde la vista. Supabase corta en 1000 filas por defecto, así que
    // paginamos con el header Range hasta traer todas las filas (item×cliente).
    var filas = [];
    var offset = 0;
    var PASO = 1000;
    while (true) {
      var rr = await fetch(SB + '/rest/v1/compradores_recien?select=*&fechaentrada=gte.' + desdeStr + '&order=itemcode.asc,cantidad.desc', {
        headers: { 'apikey': KEY, 'Authorization': 'Bearer ' + AUTHTOK(), 'Range-Unit': 'items', 'Range': offset + '-' + (offset + PASO - 1) }
      });
      var lote = await rr.json();
      if (!Array.isArray(lote) || !lote.length) break;
      filas = filas.concat(lote);
      if (lote.length < PASO) break;   // última página
      offset += PASO;
      if (offset > 100000) break;      // tope de seguridad
    }

    // Agrupa filas (item+cliente) en items con su lista de clientes
    var mapa = {};
    filas.forEach(function(row){
      var ic = row.itemcode;
      if (!mapa[ic]) {
        var bulto = Math.max(1, Number(row.unidadesbulto)||Number(row.numinbuy)||1);
        mapa[ic] = {
          itemcode: ic,
          itemname: row.itemname || '',
          picturname: row.picturname || '',
          foto_url: row.foto_url || '',
          fechaentrada: row.fechaentrada || '',
          precio: parseFloat(row.precioventa)||0,
          stock: parseFloat(row.disponible)||0,
          bulto: bulto,
          clientes: []
        };
      }
      mapa[ic].clientes.push(row);
    });

    window._recAll = Object.keys(mapa).map(function(k){ return mapa[k]; });
    // Ordena items por su mejor cliente (cantidad)
    window._recAll.sort(function(a,b){
      var ca = a.clientes.length ? parseFloat(a.clientes[0].cantidad)||0 : 0;
      var cb = b.clientes.length ? parseFloat(b.clientes[0].cantidad)||0 : 0;
      return cb - ca;
    });
    // Cada item: top 15 clientes
    window._recAll.forEach(function(it){
      it.clientes.sort(function(a,b){ return (parseFloat(b.cantidad)||0)-(parseFloat(a.cantidad)||0); });
      it.totalClientes = it.clientes.length;
      it.clientes = it.clientes.slice(0, 25);
    });

    window._recShown = 0;
    document.getElementById('rec-res').innerHTML = '';
    window.recRender(true);
  } catch(e) {
    console.error('recCargar:', e);
    $res.innerHTML = '<div style="padding:30px;text-align:center;color:red">Error: ' + e.message + '. Verifica que la vista compradores_recien exista.</div>';
  }
};

// Filtro por texto (solo filtra la lista ya cargada, sin ir al servidor)
window.recFiltrar = function() {
  window._recShown = 0;
  document.getElementById('rec-res').innerHTML = '';
  window.recRender(true);
};

// Renderiza SOLO una página de items a la vez (paginación => no cuelga)
window.recRender = function(reset) {
  var $res = document.getElementById('rec-res');
  var $cnt = document.getElementById('rec-count');
  if (!$res) return;
  var term = ((document.getElementById('rec-buscar')||{}).value || '').trim().toLowerCase();
  var data = window._recAll.filter(function(it){
    if (!term) return true;
    return (String(it.itemcode).toLowerCase().indexOf(term)>=0) ||
           (String(it.itemname).toLowerCase().indexOf(term)>=0);
  });
  if ($cnt) $cnt.textContent = data.length + ' articulo' + (data.length===1?'':'s');
  if (!data.length) { $res.innerHTML = '<div style="padding:30px;text-align:center;color:var(--text3)">Sin resultados.</div>'; return; }

  var f = function(n){ return '$' + (parseFloat(n)||0).toLocaleString('es-ES',{minimumFractionDigits:2}); };
  var foto = function(it){
    if (typeof fotoPair === 'function') {
      var fp = fotoPair(it.picturname, it.foto_url);
      if (fp && fp.primary) return '<img src="'+fp.primary+'" data-fb="'+(fp.fb||'')+'" data-fbi="0" onclick="if(typeof imgZoom===\'function\')imgZoom(this.src)" onerror="if(typeof fotoFallback===\'function\')fotoFallback(this)" style="width:56px;height:56px;object-fit:contain;border-radius:6px;border:1px solid var(--border);background:var(--surface);cursor:zoom-in;padding:2px">';
    }
    return '<div style="width:56px;height:56px;border-radius:6px;background:var(--bg);display:flex;align-items:center;justify-content:center;font-size:22px">📦</div>';
  };

  var hasta = Math.min(window._recShown + REC_PAGE, data.length);
  var htmlParts = [];
  for (var i = window._recShown; i < hasta; i++) {
    var it = data[i];
    var bultosStock = it.bulto>1 ? Math.floor(it.stock/it.bulto) : it.stock;
    var stockTxt = it.bulto>1
      ? ('<b>'+it.stock.toLocaleString('es-ES')+'</b> u &middot; '+bultosStock.toLocaleString('es-ES')+' bultos ('+it.bulto+' u/bulto)')
      : ('<b>'+it.stock.toLocaleString('es-ES')+'</b> u');
    var nmJs = (it.itemname||'').replace(/'/g,"\\'").replace(/"/g,'&quot;');
    var icJs = (it.itemcode||'').replace(/'/g,"\\'");

    var filasClientes = it.clientes.length
      ? it.clientes.map(function(c, idx){
          var facts = Array.isArray(c.facturas) ? c.facturas : [];
          var factLinks = facts.slice(0,8).map(function(dn){
            return '<a href="#" onclick="recVerFactura(\'' + dn + '\');return false;" style="color:var(--blue2);text-decoration:none;font-size:10px;margin-right:6px">#' + dn + '</a>';
          }).join('');
          if (c.num_facturas > 8) factLinks += '<span style="font-size:10px;color:var(--text3)">+' + (c.num_facturas-8) + ' mas</span>';
          return '<tr style="border-bottom:1px solid var(--border)">' +
            '<td style="padding:5px 6px;text-align:center;color:var(--text3);font-size:11px">' + (idx+1) + '</td>' +
            '<td style="padding:5px 6px;font-weight:600">' + (c.cardname||c.cardcode) + '</td>' +
            '<td style="padding:5px 6px;color:var(--text3);font-size:11px">' + (c.cardcode||'') + '</td>' +
            '<td style="padding:5px 6px;text-align:right;font-weight:700">' + (parseFloat(c.cantidad)||0).toLocaleString('es-ES') + '</td>' +
            '<td style="padding:5px 6px;text-align:right">' + f(c.monto) + '</td>' +
            '<td style="padding:5px 6px">' + factLinks + '</td>' +
          '</tr>';
        }).join('')
      : '<tr><td colspan="6" style="padding:12px;text-align:center;color:var(--text3);font-size:12px">Aun sin ventas</td></tr>';

    var controles =
      '<div style="display:flex;align-items:center;gap:6px;flex-shrink:0">' +
        '<button onclick="recAddBulto(\''+icJs+'\',\''+nmJs+'\','+it.precio+','+it.bulto+',-1)" style="width:30px;height:30px;border:1px solid var(--border);border-radius:6px;background:var(--surface);color:var(--text);font-size:16px;cursor:pointer;line-height:1">-</button>' +
        '<span id="rec-q-'+icJs+'" style="min-width:60px;text-align:center;font-size:11px;color:var(--text3)">0 bultos</span>' +
        '<button onclick="recAddBulto(\''+icJs+'\',\''+nmJs+'\','+it.precio+','+it.bulto+',1)" style="width:30px;height:30px;border:1px solid var(--border);border-radius:6px;background:var(--blue2);color:#fff;font-size:16px;cursor:pointer;line-height:1">+</button>' +
      '</div>';

    htmlParts.push('<div style="border:1px solid var(--border);border-radius:var(--r2);margin-bottom:16px;overflow:hidden">' +
      '<div style="display:flex;gap:12px;align-items:center;padding:10px 14px;background:var(--surface2);border-bottom:1px solid var(--border)">' +
        '<div style="flex-shrink:0">' + foto(it) + '</div>' +
        '<div style="flex:1;min-width:0">' +
          '<div style="font-weight:700;font-size:14px">' + it.itemname + '</div>' +
          '<div style="font-size:11px;color:var(--text3)">Codigo: ' + it.itemcode + ' &middot; Entro: ' + (it.fechaentrada||'-') + ' &middot; ' + it.totalClientes + ' cliente(s)</div>' +
          '<div style="font-size:11px;color:var(--text2);margin-top:2px">Stock: ' + stockTxt + ' &middot; Precio: ' + f(it.precio) + '</div>' +
        '</div>' + controles +
      '</div>' +
      '<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:12px">' +
        '<thead><tr style="background:var(--bg)">' +
          '<th style="padding:6px;text-align:center;font-weight:600;color:var(--text3);width:30px">#</th>' +
          '<th style="padding:6px;text-align:left;font-weight:600;color:var(--text3)">Cliente</th>' +
          '<th style="padding:6px;text-align:left;font-weight:600;color:var(--text3)">Codigo</th>' +
          '<th style="padding:6px;text-align:right;font-weight:600;color:var(--text3)">Cant.</th>' +
          '<th style="padding:6px;text-align:right;font-weight:600;color:var(--text3)">Monto</th>' +
          '<th style="padding:6px;text-align:left;font-weight:600;color:var(--text3)">Facturas</th>' +
        '</tr></thead><tbody>' + filasClientes + '</tbody>' +
      '</table></div>' +
    '</div>');
  }

  // Quita el centinela/indicador anterior si existe
  var oldS = document.getElementById('rec-sentinel');
  if (oldS) oldS.remove();

  $res.insertAdjacentHTML('beforeend', htmlParts.join(''));
  window._recShown = hasta;

  // Scroll infinito: si quedan items, pone un "centinela" al final.
  // Cuando el usuario llega cerca de él (al bajar), carga la siguiente página solo.
  if (window._recShown < data.length) {
    $res.insertAdjacentHTML('beforeend',
      '<div id="rec-sentinel" style="text-align:center;padding:14px 0;color:var(--text3);font-size:12px">Cargando más artículos...</div>');
    var sentinel = document.getElementById('rec-sentinel');
    if ('IntersectionObserver' in window) {
      // Desconecta el observer anterior para no acumular
      if (window._recObserver) { try { window._recObserver.disconnect(); } catch(e){} }
      window._recObserver = new IntersectionObserver(function(entries){
        if (entries[0] && entries[0].isIntersecting) {
          window._recObserver.disconnect();
          window.recRender(false);   // carga la siguiente página
        }
      }, { rootMargin: '300px' });   // dispara 300px antes de llegar, para que sea fluido
      window._recObserver.observe(sentinel);
    } else {
      // Respaldo para navegadores viejos: botón manual
      sentinel.innerHTML = '<button class="btn btn-p" onclick="recRender(false)">Cargar más (' + (data.length - window._recShown) + ')</button>';
    }
  }
};

window._recBultos = {};
window.recAddBulto = function(itemcode, nombre, precio, bulto, dir) {
  var actual = window._recBultos[itemcode] || 0;
  actual = Math.max(0, actual + dir);
  window._recBultos[itemcode] = actual;
  var lbl = document.getElementById('rec-q-' + itemcode.replace(/'/g,"\\'"));
  if (lbl) lbl.textContent = actual + (actual===1?' bulto':' bultos');
  var unidades = actual * bulto;
  if (typeof cartAddUnits === 'function') {
    cartAddUnits(itemcode, nombre, precio, unidades, bulto);
    if (typeof showT === 'function' && dir>0) showT('Agregado 1 bulto (' + bulto + ' u) de ' + itemcode);
  }
};

window.recVerFactura = function(docnum) {
  if (typeof verFactura === 'function') { verFactura(docnum); return; }
  if (typeof abrirFactura === 'function') { abrirFactura(docnum); return; }
  if (typeof go === 'function') {
    go('facturas');
    setTimeout(function(){
      var b = document.getElementById('fac-search') || document.querySelector('#page-facturas input');
      if (b) { b.value = docnum; if (typeof facturasBuscar === 'function') facturasBuscar(docnum); }
    }, 200);
  }
};

console.log('✅ OPOR override cargado (window.*)');


// ════════════════════════════════════════════════════════════════════
//  AYUDA POR PANTALLA
//  Un icono (i) al lado del titulo. Al pulsarlo, un panel corto que
//  explica para que sirve la pantalla y que se puede hacer en ella.
// ════════════════════════════════════════════════════════════════════
var AYUDA_PANTALLA = {

dashboard: {t:'Dashboard', d:'Resumen del dia: ventas, pedidos pendientes de autorizar, clientes con saldo vencido y los articulos que se estan moviendo.',
  p:['Los recuadros de arriba son atajos: pulsa uno y te lleva a la lista filtrada.',
     'Las cifras se actualizan solas cada vez que el sync trae datos de SAP.']},

clientes: {t:'Clientes', d:'Todos los clientes de SAP, con su saldo, limite de credito y vendedor asignado.',
  p:['Filtra por vendedor, pais, <b>no compra desde</b> (un ano hacia atras) y <b>total facturado</b> por tramos.',
     'El mapa de arriba filtra por region o por pais; se combina con los demas filtros.',
     'Cada ficha muestra la ultima compra, lo comprado en 12 meses y que tipo de mercancia compra mas.',
     'El telefono y el correo son enlaces: llaman o escriben sin salir del portal.',
     'Pulsa una ficha para abrir el cliente completo: estado de cuenta, pedidos, facturas e historial.']},

nuevo_cliente: {t:'Nuevo cliente', d:'Da de alta un cliente en SAP desde el portal.',
  p:['Al guardar entra en la cola y el proceso lo crea en SAP en menos de un minuto.',
     'El codigo lo asigna SAP, no se escribe a mano.']},

pedidos: {t:'Pedidos', d:'Las ordenes de venta de SAP, abiertas y cerradas.',
  p:['Filtra por estado, vendedor, cliente y fechas.',
     'Al abrir un pedido ves lineas, avance de entrega, facturas y entregas asociadas.',
     'Un pedido sin autorizar se puede <b>modificar</b> desde su ficha; una vez autorizado, ya no.',
     'Solo el administrador autoriza pedidos.']},

pedido_det: {t:'Detalle de pedido', d:'Todo lo del pedido: lineas, avance, entregas, facturas y comentarios.',
  p:['<b>Modificar</b> cambia cantidades y precios (solo si aun no esta autorizado).',
     '<b>Autorizar</b> lo libera para despacho; queda registrado quien y cuando.',
     '<b>Duplicar</b> crea una cotizacion nueva con las mismas lineas.',
     '<b>PDF</b> saca el catalogo con fotos grandes; <b>PDF formato pedido</b>, la tabla con lineas y totales; <b>Excel</b>, la misma tabla en hoja de calculo.',
     'En "lo que falta por entregar" ves el disponible en SAP y en el WMS de cada articulo.',
     'El codigo del cliente es un enlace a su ficha.']},

pedrealizados: {t:'Pedidos realizados y en proceso', d:'Lo que se ha enviado a SAP desde el portal, y las cotizaciones a medio hacer.',
  p:['Arriba, los <b>borradores</b>: se guardan solos mientras armas un pedido. Puedes continuarlos o eliminarlos.',
     'Abajo, lo ya enviado, con su numero de documento en SAP o el error si fallo.',
     'Cada vendedor ve lo suyo; el administrador puede ver el de todos.',
     'Filtra por cliente, estado y rango de fechas.']},

nuevo_pedido: {t:'Nuevo pedido', d:'Arma una cotizacion y mandala a SAP.',
  p:['Elige cliente, agrega articulos del catalogo y revisa antes de enviar.',
     'El catalogo filtra por departamento, precio, piezas, bultos y fecha de entrada.',
     'La busqueda con IA entiende lenguaje normal: "sartenes con mas de 5 bultos".',
     'Se guarda solo cada pocos segundos: puedes cerrar y seguir mas tarde desde Pedidos realizados.',
     'Al enviar entra en la cola y SAP crea la cotizacion en menos de un minuto.']},

facturas: {t:'Facturas', d:'Las facturas de venta de SAP.',
  p:['Filtra por cliente, vendedor y fechas.',
     'Cada factura se puede exportar en PDF o Excel con las columnas que elijas.']},

factura_det: {t:'Detalle de factura', d:'Lineas, totales y documentos relacionados.',
  p:['<b>Restock en nuevo pedido</b> copia estas lineas a una cotizacion nueva.',
     'Los tres botones de exportar funcionan igual que en el pedido.']},

estado_cuenta: {t:'Estado de cuenta', d:'Lo que cada cliente debe, documento por documento.',
  p:['Filtra por antiguedad para ver primero lo mas vencido.',
     'Desde la ficha del cliente se genera el PDF, que respeta el rango de fechas que pongas.']},

ecnappa: {t:'Estados de cuenta NAPPA', d:'Lo mismo, para la empresa NAPPA.'},

inventario: {t:'Inventario', d:'El catalogo completo con stock, precios y fotos.',
  p:['Filtra por departamento, precio, piezas, bultos, disponibilidad y fecha de entrada.',
     'El rango de fechas de entrada acepta escribir dd/mm/aaaa o elegir del calendario.',
     '<b>Exportar lo filtrado</b> genera PDF o Excel con las caracteristicas que marques.',
     'El boton Escanear lee codigos de barras con la camara.']},

item_det: {t:'Detalle de producto', d:'Ficha completa: precio, stock, ficha tecnica, fotos e historial.',
  p:['El numero de <b>separado</b> es un enlace: muestra en que pedidos esta comprometido.',
     '<b>Anadir al pedido</b> lo mete en la cotizacion en curso.']},

separados: {t:'Mercancia separada', d:'Que articulos estan comprometidos en pedidos abiertos y para quien.',
  p:['Util antes de prometer mercancia: el stock puede estar ya reservado.',
     'Cada pedido es un enlace a su ficha.']},

wms: {t:'Inventario WMS', d:'Lo que dice WarehouseEdge de cada articulo, junto al stock de SAP.',
  p:['<b>Existencia WMS</b> = piezas sacadas + inventario en bin.',
     'La columna <b>Diferencia</b> compara WMS contra SAP: si no cuadran, hay descuadre entre el piso y el sistema.',
     'Filtra por departamento, precio, piezas y bultos, igual que en Inventario.',
     'Se puede exportar a PDF o Excel y anadir articulos al pedido con el boton +.',
     'Ojo: el dato del WMS es de la ultima sincronizacion y el de SAP es de ahora, asi que una diferencia recien movida puede ser solo el desfase.']},

porllegar: {t:'Mercancia por llegar', d:'Ordenes de compra abiertas con cantidad pendiente de recibir.',
  p:['Se agrupa por departamento o por fecha de llegada.',
     'La fecha es el ETA del proveedor; si no lo tiene, la fecha de entrega pactada.',
     'El semaforo marca lo atrasado y lo que llega en los proximos dias.']},

precios: {t:'Lista de precios', d:'Precios vigentes por articulo y por lista.'},

ultimo_precio: {t:'Ultimo precio', d:'A que precio compro cada cliente cada articulo la ultima vez.',
  p:['Sirve para no cotizar por debajo de lo que ya se le vendio.']},

restock: {t:'Restock por cliente', d:'Que le has vendido a un cliente y cuanto queda disponible hoy.',
  p:['Separa lo que tiene stock, lo que esta por llegar y lo agotado.',
     'Filtra por ano de la compra y por bultos disponibles.',
     'Marca lo que quieras y pasalo a una cotizacion nueva de una vez.']},

atrasados: {t:'Clientes atrasados', d:'Quien debe y desde cuando, ordenado por lo mas vencido.',
  p:['Desde aqui se manda el recordatorio por correo.']},
  radar: {t:'Radar de clientes', d:'Quien se esta enfriando segun SU propio ritmo de compra, no un umbral general.',
    p:['El <b>motivo</b> es lo que importa: "compraba cada 31 dias, lleva 82" es un argumento para llamar.',
       'Hay tres motivos. <b>Ritmo</b>: se paso de lo suyo. <b>Dejo un grupo</b>: sigue comprando pero abandono una categoria que le pesaba. <b>Compra menos</b>: cayo respecto al año pasado.',
       'El de la categoria es el que mas dinero vale y el que ninguna lista de inactivos detecta.',
       'Se ordena por lo que te juegas al año, no por dias sin comprar.',
       '<b>Armar vitrina</b> carga lo que ese cliente suele comprar en Nuevo pedido, para mandarselo por WhatsApp.']},

reconquista: {t:'Reactivar clientes', d:'Clientes que compraban y dejaron de hacerlo.',
  p:['Muestra que compraban antes, para saber con que volver a buscarlos.']},

ventas_vendedor: {t:'Reporte de Ventas por Vendedor', d:'Las ventas del a\u00f1o, mes a mes, separando lo propio de lo compartido.',
  p:['<b>Ventas solo</b>: facturas a su nombre. <b>Ventas compartidas</b>: las de c\u00f3digos como LEO/LIRAN, donde cuenta el 50%.',
     'El <b>gran total</b> es la suma de las dos.',
     'En verde lo propio y en \u00e1mbar lo compartido, tanto en las barras como en la tabla.',
     'Pulsa un mes y salen sus facturas, con los cinco clientes que m\u00e1s pesaron.',
     'Cada factura es un enlace a su detalle completo.',
     'Un vendedor ve solo sus ventas; el administrador puede ver todas o filtrar por vendedor.',
     'El total suma por documento, no por l\u00ednea, as\u00ed que cuadra con SAP.']},

viabilidad: {t:'Viabilidad del pedido', d:'Reparte un pedido de SAP seg\u00fan el stock de hoy.',
  p:['Escribe el n\u00famero de pedido y se analiza l\u00ednea por l\u00ednea.',
     'A la izquierda, lo que se puede servir ya; a la derecha, lo que espera a que llegue mercanc\u00eda.',
     'Las l\u00edneas incompletas se deciden una a una: servir lo que hay, dejarlo para cuando llegue, o sustituir.',
     'El bot\u00f3n de reemplazo pide 20 sugerencias a la IA entre lo que tiene stock de la misma familia.',
     'Cada panel tiene tres salidas: <b>Borrador</b> lo guarda sin enviarlo, '
     +'<b>A cotizaci\u00f3n SAP</b> lo crea como documento nuevo, y <b>Abrir</b> lo lleva al carrito para editarlo.',
     'Tambi\u00e9n se pueden mandar los dos de una vez, como cotizaciones separadas.',
     'El pedido original NO se modifica: se crean documentos nuevos.']},

topart: {t:'Mejores articulos vendidos', d:'Lo que mas se vende, por periodo.',
  p:['Sirve para decidir reposicion y para saber que ofrecer.']},

sinrotacion: {t:'Mercancia sin rotacion', d:'Lo que esta parado en bodega ocupando espacio.',
  p:['Excluye lo que lleva mas de 5 anos sin venderse y los departamentos descontinuados.',
     'En los totales se indica cuantos articulos se estan ocultando y por que.']},

entregaspedido: {t:'Entregas de un pedido', d:'Que se ha despachado de un pedido y que falta.',
  p:['Compara lo pedido con lo entregado, linea por linea.']},

recien: {t:'Cliente x mercancia recien llegada', d:'Cruza la mercancia que acaba de entrar con los clientes que suelen comprarla.',
  p:['Sirve para avisar al cliente adecuado en cuanto llega algo.']},

alertas: {t:'Alertas', d:'Avisos que necesitan atencion: stock bajo, pedidos sin autorizar, saldos vencidos.'},

reportes: {t:'Reportes', d:'Informes de ventas por periodo, vendedor, cliente y linea de producto.'},

ordenes_compra: {t:'Ordenes de compra', d:'Las ordenes a proveedores y su estado.'},

chat: {t:'Live Chat', d:'Mensajeria entre vendedores y administradores, en tiempo real.',
  p:['Sala General para todo el equipo, o conversacion privada con cada persona.',
     'Manda texto, emojis, fotos, archivos y notas de voz.',
     'El punto rojo del menu avisa de lo no leido, sin recargar la pagina.',
     'Los clientes no tienen acceso.']},

link_pago: {t:'Link de pago', d:'Genera un enlace de pago para mandarle al cliente.'},

ley23: {t:'Ley 23', d:'Informacion y control de cumplimiento de la Ley 23.'}

};

var _AY_ABIERTA=null;

function ayudaPantalla(id){
  var a=AYUDA_PANTALLA[id];
  if(!a) return;
  if(_AY_ABIERTA===id){ ayudaCerrar(); return; }
  ayudaCerrar();
  _AY_ABIERTA=id;

  var caja=document.createElement('div');
  caja.id='ay-panel';
  caja.style.cssText='position:fixed;z-index:9999;max-width:430px;background:var(--surface,#fff);'
    +'border:1px solid var(--border);border-radius:13px;box-shadow:0 12px 40px rgba(0,0,0,.18);'
    +'padding:15px 17px;font-size:13px;line-height:1.55;color:var(--text)';
  caja.innerHTML='<div style="display:flex;align-items:flex-start;gap:9px;margin-bottom:7px">'
    +'<b style="font-size:14.5px;flex:1">'+npEsc(a.t)+'</b>'
    +'<button onclick="ayudaCerrar()" style="border:none;background:none;cursor:pointer;font-size:19px;'
    +'line-height:1;color:var(--text3);padding:0 2px">&times;</button></div>'
    +'<div style="color:var(--text2,#444)">'+a.d+'</div>'
    +(a.p&&a.p.length
      ? '<ul style="margin:9px 0 0;padding-left:19px;color:var(--text2,#444)">'
        +a.p.map(function(x){ return '<li style="margin-bottom:5px">'+x+'</li>'; }).join('')+'</ul>'
      : '');
  document.body.appendChild(caja);

  // Debajo del icono, y si no cabe a la derecha se pega al borde.
  var btn=document.getElementById('ay-btn');
  if(btn){
    var r=btn.getBoundingClientRect();
    var ancho=Math.min(430, window.innerWidth-24);
    caja.style.width=ancho+'px';
    caja.style.top=(r.bottom+9)+'px';
    caja.style.left=Math.max(12, Math.min(r.left-8, window.innerWidth-ancho-12))+'px';
  }

  setTimeout(function(){ document.addEventListener('click', _ayFuera, true); }, 30);
}

function _ayFuera(ev){
  var p=document.getElementById('ay-panel'), b=document.getElementById('ay-btn');
  if(p && !p.contains(ev.target) && b && !b.contains(ev.target)) ayudaCerrar();
}

function ayudaCerrar(){
  var p=document.getElementById('ay-panel');
  if(p) p.remove();
  document.removeEventListener('click', _ayFuera, true);
  _AY_ABIERTA=null;
}

// Pone el icono al lado del titulo. Lo llama go() cada vez que se cambia de
// pantalla, porque el titulo se reescribe entero en cada navegacion.
function ayudaMontar(id){
  ayudaCerrar();
  var t=document.getElementById('ptitle');
  if(!t || !AYUDA_PANTALLA[id]) return;
  var b=document.createElement('button');
  b.id='ay-btn';
  b.title='Que se puede hacer en esta pantalla';
  b.setAttribute('aria-label','Ayuda de la pantalla');
  b.style.cssText='margin-left:9px;border:none;background:none;cursor:pointer;padding:2px;'
    +'line-height:0;color:var(--text3);vertical-align:middle';
  b.onmouseenter=function(){ b.style.color='var(--blue2)'; };
  b.onmouseleave=function(){ b.style.color='var(--text3)'; };
  b.onclick=function(ev){ ev.stopPropagation(); ayudaPantalla(id); };
  b.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
    +'stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/>'
    +'<line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
  t.appendChild(b);
}


// ════════════════════════════════════════════════════════════════════
//  OFRECER MERCANCIA POR LLEGAR A UN CLIENTE
//  Cruza lo que este cliente ya compra con lo que viene en camino.
// ════════════════════════════════════════════════════════════════════
var OPL_CLI=null, OPL_ROWS=[];

async function ofrecerPorLlegar(cardcode){
  var cli = (typeof _cliActual!=='undefined' && _cliActual) ? _cliActual : {cardcode:cardcode};
  OPL_CLI = cli;

  var m=document.createElement('div');
  m.id='opl-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9998;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:15px;max-width:940px;width:100%;'
    +'max-height:88vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.3)">'
    +'<div style="padding:15px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px">'
      +'<b style="flex:1;font-size:15px">\u{1F69A} Mercanc\u00eda por llegar para '+npEsc(cli.cardname||cardcode)+'</b>'
      +'<button onclick="oplCerrar()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="opl-body" style="flex:1;overflow-y:auto;padding:16px 18px">'
      +'<div style="color:var(--text3);font-size:13px">Cruzando su historial con lo que viene en camino\u2026</div>'
    +'</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) oplCerrar(); });

  try{
    // 1) Lo que este cliente ha comprado alguna vez.
    var comprado = await qAll('facturas',
      'select=itemcode,docdate,quantity&cardcode=eq.'+encodeURIComponent(cardcode));
    var hist={};
    (comprado||[]).forEach(function(f){
      if(!f.itemcode) return;
      var h=hist[f.itemcode] || (hist[f.itemcode]={veces:0, uds:0, ultima:''});
      h.veces++; h.uds += Number(f.quantity)||0;
      var d=String(f.docdate||'').substring(0,10);
      if(d>h.ultima) h.ultima=d;
    });
    var codes=Object.keys(hist);
    if(!codes.length){ oplPintarVacio('Este cliente no tiene compras registradas.'); return; }

    // 2) Lo que viene en camino, solo de esos articulos.
    var lineas=[], ordenes=[];
    for(var i=0;i<codes.length;i+=300){
      var lote=codes.slice(i,i+300).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var r=await q('opor_lineas',
        'select=docnum,itemcode,itemname,cantidad_pendiente,precio,cantidad_empaque,picturname,foto_url'
        +'&cantidad_pendiente=gt.0&itemcode=in.('+lote+')&limit=1000');
      lineas=lineas.concat(r||[]);
    }
    if(!lineas.length){ oplPintarVacio('No hay mercanc\u00eda en camino de lo que este cliente compra.'); return; }

    // 3) Fecha de llegada y precio de venta.
    var docs={};
    lineas.forEach(function(l){ docs[l.docnum]=1; });
    try{
      // Sin el proveedor si quien mira no puede verlo.
      var o=await q('opor_ordenes','select=docnum,eta,duedate'
        +(veProveedor()?',vendor_name':'')+'&docnum=in.('
        +Object.keys(docs).join(',')+')&limit=500');
      (o||[]).forEach(function(x){ ordenes[x.docnum]=x; });
    }catch(e){}

    var venta={};
    for(var j=0;j<codes.length;j+=500){
      var l2=codes.slice(j,j+500).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      try{
        var inv=await q('vista_inventario','select=itemcode,precioventa,unidadesbulto&itemcode=in.('+l2+')&limit=500');
        (inv||[]).forEach(function(x){ venta[x.itemcode]={p:Number(x.precioventa)||0, pk:Number(x.unidadesbulto)||0}; });
      }catch(e){}
    }

    // 4) Una fila por articulo: si viene en varias OC, se suma lo pendiente y
    //    se queda la fecha mas proxima, que es lo que le importa al vendedor.
    var m2={};
    lineas.forEach(function(l){
      var o=ordenes[l.docnum]||{};
      var f=String(o.eta||o.duedate||'').substring(0,10);
      var vt=venta[l.itemcode]||{};
      var emp=Number(l.cantidad_empaque)||0;
      var pk=emp>0?emp:(Number(vt.pk)||1);
      var x=m2[l.itemcode];
      if(!x){
        x=m2[l.itemcode]={itemcode:l.itemcode, itemname:l.itemname||'', pend:0, pk:pk,
                          precioVenta:Number(vt.p)||0, fecha:f, docs:[],
                          picturname:l.picturname||'', foto_url:l.foto_url||'',
                          hist:hist[l.itemcode]};
      }
      x.pend += Number(l.cantidad_pendiente)||0;
      if(f && (!x.fecha || f<x.fecha)) x.fecha=f;
      if(x.docs.indexOf(l.docnum)<0) x.docs.push(l.docnum);
    });

    OPL_ROWS=Object.keys(m2).map(function(k){ return m2[k]; })
      .sort(function(a,b){
        // Primero lo que mas compra, que es lo que mas probable que repita.
        var d=(b.hist?b.hist.uds:0)-(a.hist?a.hist.uds:0);
        return d!==0 ? d : String(a.fecha||'9999').localeCompare(String(b.fecha||'9999'));
      });
    oplPintar();
  }catch(e){
    oplPintarVacio('No se pudo consultar: '+String(e.message||e).slice(0,140));
  }
}

function oplCerrar(){
  var m=document.getElementById('opl-modal');
  if(m) m.remove();
}

function oplPintarVacio(txt){
  var b=document.getElementById('opl-body');
  if(b) b.innerHTML='<div style="padding:22px;text-align:center;color:var(--text3);font-size:13px">'+npEsc(txt)+'</div>';
}

function oplPintar(){
  var b=document.getElementById('opl-body'); if(!b) return;
  var totU=0, totV=0;
  OPL_ROWS.forEach(function(r){ totU+=r.pend; totV+=r.pend*r.precioVenta; });

  var filas=OPL_ROWS.map(function(r,i){
    var cs=String(r.itemcode).replace(/'/g,"\\'");
    var nm=String(r.itemname||'').replace(/['"\\]/g,' ').slice(0,80);
    var h=r.hist||{};
    var d=_plDias(r.fecha);
    var col = d===null ? 'var(--text3)' : (d<0?'var(--red)':(d<=30?'var(--amber)':'var(--green)'));
    var cuando = r.fecha
      ? (d<0 ? ('atrasada '+Math.abs(d)+'d') : ('en '+d+' d\u00edas'))
      : 'sin fecha';
    return '<tr>'
      +'<td style="width:46px">'+fotoThumb(r.picturname,r.foto_url)+'</td>'
      +'<td><a href="javascript:void(0)" onclick="oplCerrar();verItem(\''+cs+'\')" style="font-weight:600;color:var(--blue2);text-decoration:none">'+npEsc(r.itemcode)+'</a>'
        +'<div style="font-size:11.5px;color:var(--text3)">'+npEsc(String(r.itemname||'').substring(0,55))+'</div></td>'
      +'<td style="font-size:11.5px;color:var(--text3)">'
        +'compr\u00f3 '+fmtN(Math.round(h.uds||0))+' und<br>'
        +(h.ultima?('\u00falt. '+_plFechaLbl(h.ultima)):'')+'</td>'
      +'<td style="text-align:right;font-weight:600">'+fmtN(Math.round(r.pend))+'</td>'
      +'<td style="text-align:right">'+fmtN(Math.floor(r.pend/(r.pk||1)))+'</td>'
      +'<td style="text-align:right">'+(r.precioVenta?fmt(r.precioVenta):'\u2014')+'</td>'
      +'<td style="white-space:nowrap;font-size:11.5px;color:'+col+';font-weight:600">'+cuando
        +(r.fecha?('<div style="color:var(--text3);font-weight:400">'+_plFechaLbl(r.fecha)+'</div>'):'')+'</td>'
      +'<td style="text-align:center"><button class="btn btn-sm btn-p" style="padding:3px 9px" '
        +'onclick="oplAlCarrito(\''+cs+'\',\''+nm+'\','+r.precioVenta+','+(r.pk||1)+')" '
        +'title="A\u00f1adir 1 bulto ('+(r.pk||1)+' und) al pedido">+ '+(r.pk||1)+'</button></td>'
      +'</tr>';
  }).join('');

  b.innerHTML='<div style="display:flex;gap:20px;flex-wrap:wrap;margin-bottom:12px;font-size:12.5px">'
    +'<div><span style="color:var(--text3)">Art\u00edculos que ya compra y vienen en camino:</span> <b>'+OPL_ROWS.length+'</b></div>'
    +'<div><span style="color:var(--text3)">Unidades:</span> <b>'+fmtN(Math.round(totU))+'</b></div>'
    +'<div><span style="color:var(--text3)">Valor a su precio:</span> <b>'+fmt(totV)+'</b></div>'
    +'</div>'
    +'<div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th></th><th>Art\u00edculo</th><th>Su historial</th>'
    +'<th style="text-align:right">Por llegar</th><th style="text-align:right">Bultos</th>'
    +'<th style="text-align:right">Precio</th><th>Llegada</th>'
    +'</tr>'
    +filas+'</table></div>'
    +'<div style="font-size:11.5px;color:var(--text3);margin-top:10px">'
    +'Ordenado por lo que m\u00e1s compra este cliente. La mercanc\u00eda a\u00fan no ha llegado: '
    +'el pedido queda pendiente hasta que entre al almac\u00e9n.</div>';
}

function oplAlCarrito(code, nombre, precio, bulto){
  try{
    if(!precio){
      if(!confirm('Este art\u00edculo no tiene precio de venta en el cat\u00e1logo.\n\n'
        +'Se a\u00f1adir\u00e1 en 0 y habr\u00e1 que ponerle el precio a mano. \u00bfSigo?')) return;
    }
    // Si no hay cotizacion abierta, se arranca con este cliente ya puesto.
    if(OPL_CLI && OPL_CLI.cardcode && (!npCli || npCli.cardcode!==OPL_CLI.cardcode) && !npLineas.length){
      npCli={cardcode:OPL_CLI.cardcode, cardname:OPL_CLI.cardname||OPL_CLI.cardcode};
    }
    npAgregarLineaDirecta(code, nombre, Number(precio)||0, Number(bulto)||1);
  }catch(e){ alert('No se pudo a\u00f1adir: '+(e.message||e)); }
}


// ════════════════════════════════════════════════════════════════════
//  MERCANCIA POR LLEGAR, POR VENDEDOR
//  Cruza lo que viene en camino con los clientes de cada vendedor: que
//  le va a llegar a quien. Se puede seleccionar, mandar al pedido por
//  bultos, y enviar por correo en PDF o Excel.
//  El correo sale por correos_queue -> Microsoft Graph (Azure), el mismo
//  camino que ya usan los recordatorios de pago.
// ════════════════════════════════════════════════════════════════════
var PV_VEND='', PV_ROWS=[], PV_SEL={}, PV_CLI='', PV_CARGANDO=false;

function pvAbrir(){
  var m=document.createElement('div');
  m.id='pv-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9998;'
    +'display:flex;align-items:center;justify-content:center;padding:10px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:15px;max-width:1500px;width:98vw;'
    +'height:94vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.3)">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<b style="font-size:15px">\u{1F69A} Mercanc\u00eda por llegar por vendedor</b>'
      +'<select id="pv-vend" onchange="pvVend(this.value)" style="padding:7px 11px;border:1px solid var(--border);border-radius:8px;font-size:13px;background:#fff;min-width:180px">'
        +'<option value="">Elige un vendedor\u2026</option></select>'
      +'<select id="pv-cli" onchange="pvCli(this.value)" style="padding:7px 11px;border:1px solid var(--border);border-radius:8px;font-size:13px;background:#fff;min-width:180px">'
        +'<option value="">Todos sus clientes</option></select>'
      +'<span style="flex:1"></span>'
      +'<button onclick="pvCerrar()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="pv-body" style="flex:1;overflow-y:auto;padding:15px 18px">'
      +'<div style="color:var(--text3);font-size:13px">Elige un vendedor para ver qu\u00e9 le llega a sus clientes.</div>'
    +'</div>'
    +'<div id="pv-pie" style="padding:12px 18px;border-top:1px solid var(--border);display:none;gap:8px;align-items:center;flex-wrap:wrap"></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) pvCerrar(); });
  pvCargarVendedores();
}

function pvCerrar(){ var m=document.getElementById('pv-modal'); if(m) m.remove(); }

async function pvCargarVendedores(){
  var sel=document.getElementById('pv-vend'); if(!sel) return;
  try{
    var v=await q('vendedores','select=slpcode,slpname&order=slpname');
    var vistos={};
    (v||[]).forEach(function(x){
      if(x.slpcode==null || vistos[x.slpcode]) return;
      vistos[x.slpcode]=1;
      var o=document.createElement('option');
      o.value=x.slpcode; o.textContent=x.slpname||('Vendedor '+x.slpcode);
      sel.appendChild(o);
    });
    // Si quien mira es vendedor, se abre con el suyo ya elegido.
    if(CU && CU.slpcode!=null){
      sel.value=String(CU.slpcode);
      if(sel.value) pvVend(sel.value);
    }
  }catch(e){}
}

function pvVend(v){ PV_VEND=v||''; PV_CLI=''; PV_SEL={}; pvCargar(); }
function pvCli(c){ PV_CLI=c||''; pvPintar(); }

async function pvCargar(){
  var b=document.getElementById('pv-body'); if(!b || PV_CARGANDO) return;
  if(!PV_VEND){ b.innerHTML='<div style="color:var(--text3);font-size:13px">Elige un vendedor.</div>'; return; }
  PV_CARGANDO=true;
  b.innerHTML='<div style="color:var(--text3);font-size:13px">Cruzando sus clientes con lo que viene en camino\u2026</div>';
  try{
    // 1) Clientes del vendedor
    var cls=await qAll('clientes','select=cardcode,cardname,e_mail,nombrevendedor&cardtype=eq.C&slpcode=eq.'+encodeURIComponent(PV_VEND));
    if(!cls.length){ b.innerHTML='<div style="color:var(--text3);font-size:13px">Este vendedor no tiene clientes asignados.</div>'; PV_CARGANDO=false; return; }
    var mapCli={}; cls.forEach(function(c){ mapCli[c.cardcode]=c; });

    // Cuanto factura cada uno, para ordenar la lista por importancia. Sale de
    // vista_cliente_perfil, que ya lo tiene calculado: sumarlo aqui obligaria
    // a leer otra vez todas las facturas.
    try{
      var codesT=Object.keys(mapCli);
      for(var t=0;t<codesT.length;t+=200){
        var lt=codesT.slice(t,t+200).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
        var pf=await q('vista_cliente_perfil','select=cardcode,total_historico,total_12m&cardcode=in.('+lt+')&limit=200');
        (pf||[]).forEach(function(x){
          if(mapCli[x.cardcode]){
            mapCli[x.cardcode].total=Number(x.total_historico)||0;
            mapCli[x.cardcode].total12=Number(x.total_12m)||0;
          }
        });
      }
    }catch(e){ /* sin perfil se ordena por numero de articulos, como antes */ }

    // ── Orden de las consultas ──────────────────────────────────────────
    // Antes esto leia TODAS las facturas de TODOS los clientes del vendedor y
    // despues miraba cuales de esos articulos venian en camino. Con una
    // cartera grande son cientos de miles de lineas y la pantalla tardaba
    // minutos.
    //
    // Ahora va al reves: primero se mira que viene en camino (unos pocos
    // miles de articulos como mucho) y solo despues se buscan las facturas
    // DE ESOS ARTICULOS. La consulta de facturas queda acotada por las dos
    // puntas -- clientes del vendedor Y articulos que llegan -- que es lo que
    // hace la diferencia.

    // 2) Lo que viene en camino (una sola consulta, sin depender del vendedor)
    if(b) b.innerHTML='<div style="color:var(--text3);font-size:13px">Leyendo mercanc\u00eda en camino\u2026</div>';
    var lineas=await qAll('opor_lineas',
      'select=docnum,itemcode,itemname,cantidad_pendiente,cantidad_empaque,picturname,foto_url'
      +'&cantidad_pendiente=gt.0');
    if(!lineas.length){
      b.innerHTML='<div style="color:var(--text3);font-size:13px">No hay mercanc\u00eda pendiente de llegar.</div>';
      PV_CARGANDO=false; return;
    }

    var itemsLlegan=[], vi={};
    lineas.forEach(function(l){ if(l.itemcode && !vi[l.itemcode]){ vi[l.itemcode]=1; itemsLlegan.push(l.itemcode); } });

    // 3) Facturas, acotadas por clientes del vendedor Y articulos que llegan
    var hist={};   // itemcode -> {cardcode: {uds, ultima}}
    var codes=Object.keys(mapCli);
    var totalLotes=Math.ceil(codes.length/120)*Math.ceil(itemsLlegan.length/250);
    var lote=0;
    for(var i=0;i<codes.length;i+=120){
      var lc=codes.slice(i,i+120).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      for(var j=0;j<itemsLlegan.length;j+=250){
        var li=itemsLlegan.slice(j,j+250).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
        lote++;
        if(b) b.innerHTML='<div style="color:var(--text3);font-size:13px">Cruzando historial de compras\u2026 '
          +Math.round(lote/Math.max(1,totalLotes)*100)+'%</div>';
        var f=await qAll('facturas',
          'select=cardcode,itemcode,quantity,docdate&cardcode=in.('+lc+')&itemcode=in.('+li+')');
        (f||[]).forEach(function(x){
          if(!x.itemcode) return;
          var h=hist[x.itemcode] || (hist[x.itemcode]={});
          var e=h[x.cardcode] || (h[x.cardcode]={uds:0, ultima:''});
          e.uds+=Number(x.quantity)||0;
          var d=String(x.docdate||'').substring(0,10);
          if(d>e.ultima) e.ultima=d;
        });
      }
    }
    if(!Object.keys(hist).length){
      b.innerHTML='<div style="color:var(--text3);font-size:13px">Sus clientes no han comprado nada de lo que viene en camino.</div>';
      PV_CARGANDO=false; return;
    }

    // 4) Fechas de llegada y precio de venta
    var docs={}; lineas.forEach(function(l){ docs[l.docnum]=1; });
    var ords={};
    try{
      var o=await q('opor_ordenes','select=docnum,eta,duedate&docnum=in.('+Object.keys(docs).join(',')+')&limit=800');
      (o||[]).forEach(function(x){ ords[x.docnum]=x; });
    }catch(e){}

    var venta={};
    for(var k=0;k<itemsLlegan.length;k+=500){
      var l3=itemsLlegan.slice(k,k+500).map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      try{
        var inv=await q('vista_inventario','select=itemcode,precioventa,unidadesbulto&itemcode=in.('+l3+')&limit=500');
        (inv||[]).forEach(function(x){ venta[x.itemcode]={p:Number(x.precioventa)||0, pk:Number(x.unidadesbulto)||0}; });
      }catch(e){}
    }

    // 5) Una fila por articulo + cliente: eso es lo que se le ofrece a cada uno
    var out=[];
    var porItem={};
    lineas.forEach(function(l){
      var o=ords[l.docnum]||{};
      var f=String(o.eta||o.duedate||'').substring(0,10);
      var x=porItem[l.itemcode];
      if(!x){
        var vt=venta[l.itemcode]||{};
        var emp=Number(l.cantidad_empaque)||0;
        x=porItem[l.itemcode]={itemcode:l.itemcode, itemname:l.itemname||'', pend:0,
          pk:(emp>0?emp:(Number(vt.pk)||1)), precio:Number(vt.p)||0, fecha:f,
          picturname:l.picturname||'', foto_url:l.foto_url||''};
      }
      x.pend += Number(l.cantidad_pendiente)||0;
      if(f && (!x.fecha || f<x.fecha)) x.fecha=f;
    });

    Object.keys(porItem).forEach(function(ic){
      var it=porItem[ic];
      Object.keys(hist[ic]||{}).forEach(function(cc){
        var c=mapCli[cc]; if(!c) return;
        var h=hist[ic][cc];
        out.push({
          key: cc+'|'+ic,
          cardcode:cc, cardname:c.cardname||cc, email:c.e_mail||'',
          totalCli:Number(c.total)||0, total12Cli:Number(c.total12)||0,
          itemcode:ic, itemname:it.itemname, pend:it.pend, pk:it.pk,
          precio:it.precio, fecha:it.fecha,
          picturname:it.picturname, foto_url:it.foto_url,
          uds:h.uds, ultima:h.ultima
        });
      });
    });

    // Por cliente, y dentro por lo que mas compra.
    // Cliente que mas factura primero; dentro de cada uno, lo que mas compra.
    out.sort(function(a,b){
      var d=(b.totalCli||0)-(a.totalCli||0);
      if(d!==0) return d;
      var e=String(a.cardname).localeCompare(String(b.cardname));
      return e!==0 ? e : (b.uds-a.uds);
    });
    PV_ROWS=out;
    PV_SEL={};

    // Llenar el desplegable de clientes con los que tienen algo que ofrecer
    var selC=document.getElementById('pv-cli');
    if(selC){
      var vistos={}, ops='<option value="">Todos sus clientes</option>';
      out.forEach(function(r){
        if(vistos[r.cardcode]) return; vistos[r.cardcode]=1;
        ops+='<option value="'+npEsc(r.cardcode)+'">'+npEsc(r.cardname)
          +(r.totalCli?('  \u00b7  '+fmt(r.totalCli)):'')+'</option>';
      });
      selC.innerHTML=ops;
    }
    pvPintar();
  }catch(e){
    b.innerHTML='<div style="color:var(--red);font-size:13px">No se pudo consultar: '+npEsc(String(e.message||e).slice(0,160))+'</div>';
  }finally{ PV_CARGANDO=false; }
}

function pvFiltradas(){
  return PV_ROWS.filter(function(r){ return !PV_CLI || r.cardcode===PV_CLI; });
}

function pvToggle(k, on){ if(on) PV_SEL[k]=1; else delete PV_SEL[k]; pvPie(); }
function pvTodos(on){
  pvFiltradas().forEach(function(r){ if(on) PV_SEL[r.key]=1; else delete PV_SEL[r.key]; });
  pvPintar();
}

var PV_ABIERTO={};   // que clientes estan desplegados

function pvToggleCli(cc){
  PV_ABIERTO[cc] = !PV_ABIERTO[cc];
  pvPintar();
}
function pvAbrirTodos(on){
  var v={};
  pvFiltradas().forEach(function(r){ v[r.cardcode]=1; });
  Object.keys(v).forEach(function(cc){ PV_ABIERTO[cc]=!!on; });
  pvPintar();
}

// Marca o desmarca todo lo de UN cliente sin desplegarlo.
function pvSelCli(cc, on, ev){
  if(ev) ev.stopPropagation();
  PV_ROWS.forEach(function(r){
    if(r.cardcode!==cc) return;
    if(on) PV_SEL[r.key]=1; else delete PV_SEL[r.key];
  });
  pvPintar();
}

function pvPintar(){
  var b=document.getElementById('pv-body'); if(!b) return;
  var rows=pvFiltradas();
  if(!rows.length){ b.innerHTML='<div style="color:var(--text3);font-size:13px">Nada que ofrecer con este filtro.</div>'; pvPie(); return; }

  // Un grupo por cliente. Cerrados por defecto: con 40 clientes y 300 lineas,
  // abrirlo todo de golpe hace la pantalla inmanejable.
  var grupos={}, orden=[];
  rows.forEach(function(r){
    if(!grupos[r.cardcode]){ grupos[r.cardcode]={info:r, filas:[]}; orden.push(r.cardcode); }
    grupos[r.cardcode].filas.push(r);
  });
  orden.sort(function(a,b){
    var d=(grupos[b].info.totalCli||0)-(grupos[a].info.totalCli||0);
    return d!==0 ? d : (grupos[b].filas.length-grupos[a].filas.length);
  });

  var html=orden.map(function(cc){
    var g=grupos[cc], r0=g.info;
    var abierto=!!PV_ABIERTO[cc];
    var marcados=g.filas.filter(function(x){ return PV_SEL[x.key]; }).length;
    var cs=String(cc).replace(/'/g,"\\'");
    var uds=0, val=0;
    g.filas.forEach(function(x){ uds+=x.pend; val+=x.pend*(x.precio||0); });

    var cab='<div onclick="pvToggleCli(\''+cs+'\')" style="display:flex;align-items:center;gap:10px;'
      +'padding:11px 13px;cursor:pointer;background:'+(abierto?'var(--blue-bg,#EFF6FF)':'var(--surface2,#FAFAFB)')+';'
      +'border-radius:'+(abierto?'10px 10px 0 0':'10px')+'">'
      +'<span style="font-size:13px;color:var(--text3);width:12px">'+(abierto?'\u25be':'\u25b8')+'</span>'
      +'<input type="checkbox" '+(marcados===g.filas.length?'checked':'')+' onclick="event.stopPropagation()" '
        +'onchange="pvSelCli(\''+cs+'\',this.checked,event)" title="Marcar todo lo de este cliente">'
      +'<div style="flex:1;min-width:0">'
        +'<b style="font-size:13.5px">'+npEsc(r0.cardname)+'</b>'
        +'<span style="font-size:11.5px;color:var(--text3);margin-left:8px">'+npEsc(cc)+'</span>'
        +(r0.email?'':'<span style="font-size:11px;color:var(--amber);margin-left:8px">sin correo</span>')
      +'</div>'
      +(r0.totalCli?('<span style="font-size:11.5px;color:var(--text3);white-space:nowrap" '
        +'title="Total facturado historico">factura '+fmt(r0.totalCli)+'</span>'):'')
      +'<span style="font-size:12px;color:var(--text3);white-space:nowrap">'
        +g.filas.length+' art. \u00b7 '+fmtN(Math.round(uds))+' und \u00b7 '+fmt(val)+'</span>'
      +(marcados?('<span style="background:var(--blue2,#2563EB);color:#fff;border-radius:10px;padding:1px 8px;font-size:11px;font-weight:700">'+marcados+'</span>'):'')
      +'</div>';

    if(!abierto) return '<div style="margin-bottom:7px;border:1px solid var(--border);border-radius:10px;overflow:hidden">'+cab+'</div>';

    var filas=g.filas.map(function(r){
      var cs2=String(r.itemcode).replace(/'/g,"\\'");
      var nm=String(r.itemname||'').replace(/['"\\]/g,' ').slice(0,80);
      var d=_plDias(r.fecha);
      var col = d===null ? 'var(--text3)' : (d<0?'var(--red)':(d<=30?'var(--amber)':'var(--green)'));
      return '<tr>'
        +'<td><input type="checkbox" '+(PV_SEL[r.key]?'checked':'')+' onchange="pvToggle(\''+r.key+'\',this.checked);pvPintar()"></td>'
        +'<td style="width:44px">'+fotoThumb(r.picturname,r.foto_url)+'</td>'
        +'<td><b style="font-size:12px">'+npEsc(r.itemcode)+'</b>'
          +'<div style="font-size:11px;color:var(--text3)">'+npEsc(String(r.itemname||'').substring(0,55))+'</div></td>'
        +'<td style="font-size:11.5px;color:var(--text3)">'+fmtN(Math.round(r.uds))+' und'
          +(r.ultima?('<br>'+_plFechaLbl(r.ultima)):'')+'</td>'
        +'<td style="text-align:right;font-weight:600">'+fmtN(Math.round(r.pend))+'</td>'
        +'<td style="text-align:right">'+fmtN(Math.floor(r.pend/(r.pk||1)))+'</td>'
        +'<td style="text-align:right">'+(r.precio?fmt(r.precio):'\u2014')+'</td>'
        +'<td style="white-space:nowrap;font-size:11.5px;color:'+col+'">'+(r.fecha?_plFechaLbl(r.fecha):'sin fecha')+'</td>'
        +'<td style="text-align:center"><button class="btn btn-sm btn-p" style="padding:2px 8px" '
          +'onclick="pvAlCarrito(\''+cs2+'\',\''+nm+'\','+r.precio+','+(r.pk||1)+',\''+cs+'\',\''+String(r0.cardname).replace(/['"\\]/g,' ')+'\')">+ '+(r.pk||1)+'</button></td>'
        +'</tr>';
    }).join('');

    return '<div style="margin-bottom:7px;border:1px solid var(--border);border-radius:10px;overflow:hidden">'
      +cab
      +'<div style="overflow-x:auto;padding:0 4px 4px"><table class="tbl">'
      +'<tr><th style="width:26px"></th><th></th><th>Art\u00edculo</th><th>Ya compr\u00f3</th>'
      +'<th style="text-align:right">Por llegar</th><th style="text-align:right">Bultos</th>'
      +'<th style="text-align:right">Precio</th><th>Llegada</th><th style="text-align:center">+</th></tr>'
      +filas+'</table></div></div>';
  }).join('');

  b.innerHTML='<div style="display:flex;gap:8px;margin-bottom:10px;flex-wrap:wrap;align-items:center">'
    +'<button class="btn btn-sm" onclick="pvAbrirTodos(true)">Abrir todo</button>'
    +'<button class="btn btn-sm" onclick="pvAbrirTodos(false)">Cerrar todo</button>'
    +'<button class="btn btn-sm" onclick="pvTodos(true)">Marcar todo</button>'
    +'<button class="btn btn-sm" onclick="pvTodos(false)">Desmarcar</button>'
    +'<span style="flex:1"></span>'
    +'<span style="font-size:12px;color:var(--text3)">'+orden.length+' cliente(s) \u00b7 '+rows.length+' l\u00ednea(s)</span>'
    +'</div>'+html;
  pvPie();
}

function pvPie(){
  var p=document.getElementById('pv-pie'); if(!p) return;
  var n=Object.keys(PV_SEL).length;
  if(!n){ p.style.display='none'; p.innerHTML=''; return; }
  p.style.display='flex';
  p.innerHTML='<b style="font-size:13px">'+n+' seleccionado(s)</b>'
    +'<span style="flex:1"></span>'
    +'<button class="btn btn-sm" onclick="pvExportar(\'pdf\')">\u{1F4C4} PDF</button>'
    +'<button class="btn btn-sm" onclick="pvExportar(\'excel\')" style="background:var(--green);color:#fff;border-color:var(--green)">\u{1F4CA} Excel</button>'
    +'<button class="btn btn-sm btn-p" onclick="pvCorreo()">\u2709 Enviar por correo</button>';
}

function pvAlCarrito(code, nombre, precio, bulto, cardcode, cardname){
  try{
    if(!npLineas.length && cardcode && (!npCli || npCli.cardcode!==cardcode)){
      npCli={cardcode:cardcode, cardname:cardname||cardcode};
    }
    if(npCli && cardcode && npCli.cardcode!==cardcode){
      if(!confirm('La cotizaci\u00f3n abierta es de '+npCli.cardname+'.\n\n'
        +'Este art\u00edculo es para '+(cardname||cardcode)+'. \u00bfLo a\u00f1ado igual?')) return;
    }
    npAgregarLineaDirecta(code, nombre, Number(precio)||0, Number(bulto)||1);
  }catch(e){ alert('No se pudo a\u00f1adir: '+(e.message||e)); }
}

// ── Exportar: reutiliza el generador de Inventario ────────────────────────
function _pvSeleccion(){
  return PV_ROWS.filter(function(r){ return PV_SEL[r.key]; });
}

async function pvExportar(tipo){
  var sel=_pvSeleccion();
  if(!sel.length){ alert('Marca al menos un art\u00edculo.'); return; }
  var codes=[], v={};
  sel.forEach(function(r){ if(!v[r.itemcode]){ v[r.itemcode]=1; codes.push(r.itemcode); } });
  var cols=_pvCols();
  try{
    var body={p_itemcodes:codes, p_orden:'sku'};
    if(tipo==='pdf') await invPdf(cols, body);
    else             await invExcel(cols, body);
  }catch(e){ alert('No se pudo generar: '+(e.message||e)); }
}

// ── Enviar por correo (Microsoft Graph, via correos_queue) ────────────────
function pvCorreo(){
  var sel=_pvSeleccion();
  if(!sel.length){ alert('Marca al menos un art\u00edculo.'); return; }

  // Un correo por cliente, con solo lo suyo: un envio conjunto dejaria ver a
  // cada cliente lo que se le ofrece a los demas.
  var porCli={};
  sel.forEach(function(r){
    var g=porCli[r.cardcode] || (porCli[r.cardcode]={nombre:r.cardname, email:r.email, filas:[]});
    g.filas.push(r);
  });
  window._PVC = porCli;
  var clientes=Object.keys(porCli);

  // Una fila por cliente con su correo editable. Asi se corrige el que este
  // mal en SAP, se pone el que falta, o se agregan varios separados por coma.
  var filas=clientes.map(function(cc){
    var g=porCli[cc];
    return '<div style="display:flex;align-items:center;gap:8px;padding:6px 0;border-bottom:1px solid var(--border)">'
      +'<label style="display:flex;align-items:center;gap:6px;flex:0 0 auto">'
        +'<input type="checkbox" class="pvc-on" data-cc="'+npEsc(cc)+'" checked></label>'
      +'<div style="flex:0 0 170px;min-width:0">'
        +'<div style="font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+npEsc(g.nombre)+'</div>'
        +'<div style="font-size:11px;color:var(--text3)">'+g.filas.length+' art\u00edculo(s)</div></div>'
      +'<input type="text" class="pvc-mail" data-cc="'+npEsc(cc)+'" value="'+npEsc(g.email||'')+'" '
        +'placeholder="correo@cliente.com (varios separados por coma)" '
        +'style="flex:1;padding:7px 10px;border:1px solid '+(g.email?'var(--border)':'var(--amber)')+';'
        +'border-radius:8px;font-size:12.5px;outline:none">'
      +'</div>';
  }).join('');

  var m=document.createElement('div');
  m.id='pvc-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:760px;width:100%;max-height:92vh;display:flex;flex-direction:column">'
    +'<div style="padding:16px 18px 0"><b style="font-size:15px">Enviar mercanc\u00eda por llegar</b>'
    +'<div style="font-size:12.5px;color:var(--text3);margin:6px 0 12px">'
      +clientes.length+' cliente(s) \u00b7 '+sel.length+' l\u00ednea(s). Cada uno recibe solo sus art\u00edculos.</div></div>'
    +'<div style="flex:1;overflow-y:auto;padding:0 18px">'
      +'<div style="font-size:12px;color:var(--text3);margin-bottom:4px">Destinatarios <span style="font-weight:400">(editables)</span></div>'
      +filas
      +'<div style="margin-top:12px">'
        +'<label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Copia a (todos los correos, opcional)</label>'
        +'<input id="pvc-cc" placeholder="otro@kennedyzl.com, jefe@kennedyzl.com" style="width:100%;padding:8px 11px;border:1px solid var(--border);border-radius:9px;font-size:13px;box-sizing:border-box"></div>'
      +'<div style="margin-top:10px">'
        +'<label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Asunto</label>'
        +'<input id="pvc-asunto" value="Mercanc\u00eda en camino que puede interesarle" style="width:100%;padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:14px;box-sizing:border-box"></div>'
      +'<div style="margin-top:10px">'
        +'<label style="font-size:12px;color:var(--text3);display:block;margin-bottom:4px">Mensaje</label>'
        +'<textarea id="pvc-cuerpo" rows="5" style="width:100%;padding:9px 12px;border:1px solid var(--border);border-radius:9px;font-size:13.5px;font-family:inherit;box-sizing:border-box">Buen d\u00eda,\n\nLe comparto la mercanc\u00eda que tenemos en camino y que suele interesarle. Con gusto le reservamos lo que necesite.\n\nQuedo atento.</textarea></div>'
      +'<div style="margin-top:12px">'
        +'<label style="font-size:12px;color:var(--text3);display:block;margin-bottom:5px">Caracter\u00edsticas a incluir en el documento</label>'
        +'<div id="pvc-campos" style="display:flex;gap:7px;flex-wrap:wrap">'
        + INV_CAMPOS.map(function(f){
            // La foto va marcada siempre; del resto, los de siempre.
            var chk = (f.k==='foto') || ['sku','precio','packing'].indexOf(f.k)>=0;
            return '<label style="display:flex;align-items:center;gap:6px;font-size:12px;cursor:pointer;'
              +'padding:5px 8px;border:1px solid var(--border);border-radius:8px">'
              +'<input type="checkbox" class="pvc-col" data-k="'+f.k+'"'+(chk?' checked':'')+'>'
              +npEsc(f.label)+'</label>';
          }).join('')
        +'</div></div>'
      +'<div style="display:flex;gap:12px;align-items:center;margin:11px 0">'
        +'<label style="font-size:13px;display:flex;align-items:center;gap:6px;cursor:pointer">'
          +'<input type="radio" name="pvcf" value="pdf" checked> PDF</label>'
        +'<label style="font-size:13px;display:flex;align-items:center;gap:6px;cursor:pointer">'
          +'<input type="radio" name="pvcf" value="excel"> Excel</label>'
        +'<label style="font-size:13px;display:flex;align-items:center;gap:6px;cursor:pointer">'
          +'<input type="checkbox" id="pvc-copia" checked> Enviarme copia</label>'
      +'</div>'
    +'</div>'
    +'<div style="padding:12px 18px;border-top:1px solid var(--border)">'
      +'<div id="pvc-msg" style="font-size:12.5px;margin-bottom:8px"></div>'
      +'<div style="display:flex;gap:8px;justify-content:flex-end">'
        +'<button class="btn btn-sm" onclick="document.getElementById(\'pvc-modal\').remove()">Cancelar</button>'
        +'<button class="btn btn-sm btn-p" id="pvc-ok" onclick="pvCorreoEnviar()">Enviar</button>'
      +'</div></div>'
    +'</div>';
  document.body.appendChild(m);
}

// Encola el correo. Si la tabla no tiene alguna columna (PGRST204), se quita
// esa columna y se reintenta: mejor enviar sin el dato opcional que no enviar.
// Las columnas de correos_queue han ido cambiando y no todas las instalaciones
// tienen las mismas.
var _PV_QUITAR=[];

async function _pvEncolar(fila){
  for(var intento=0; intento<6; intento++){
    var envio={};
    Object.keys(fila).forEach(function(k){
      if(_PV_QUITAR.indexOf(k)<0) envio[k]=fila[k];
    });
    // para_lista es la unica imprescindible: si tampoco existe, se usa el
    // campo antiguo de un solo destinatario.
    if(_PV_QUITAR.indexOf('para_lista')>=0 && fila.para_lista){
      envio.para_email = fila.para_lista[0];
    }
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=minimal'},
      body: JSON.stringify(envio)
    });
    if(r.ok) return {ok:true};

    var txt=await r.text();
    var m=txt.match(/'([a-z_]+)' column/i) || txt.match(/column "?([a-z_]+)"?/i);

    // La tabla no tiene esa columna: se quita y se reintenta.
    if(/PGRST204/.test(txt) && m && _PV_QUITAR.indexOf(m[1])<0){
      _PV_QUITAR.push(m[1]);
      continue;
    }
    // La columna es obligatoria y va vacia: se rellena con algo neutro. Pasa
    // con campos que otra parte del portal si usa y esta no.
    if(/23502/.test(txt) && m && !(m[1] in fila)){
      // Columna obligatoria que no estabamos mandando. Se rellena con algo
      // coherente al campo: poner texto suelto en una columna de correo o de
      // fecha volveria a fallar en el siguiente intento.
      var col=m[1];
      if(/mail|correo/.test(col))      fila[col] = (fila.para_lista && fila.para_lista[0]) || '';
      else if(/fecha|_en$|date/.test(col)) fila[col] = ahoraLocal();
      else if(/estado|status/.test(col))   fila[col] = 'pendiente';
      else                                 fila[col] = 'PORLLEGAR';
      continue;
    }
    return {ok:false, msg:txt.slice(0,300)};
  }
  return {ok:false, msg:'No se pudo encolar tras varios intentos'};
}

async function pvCorreoEnviar(){
  var porCli=window._PVC||{};
  var msg=document.getElementById('pvc-msg');
  var btn=document.getElementById('pvc-ok');
  var asunto=(document.getElementById('pvc-asunto')||{}).value||'Mercanc\u00eda en camino';
  var cuerpo=(document.getElementById('pvc-cuerpo')||{}).value||'';
  var fmtSel=(document.querySelector('input[name="pvcf"]:checked')||{}).value||'pdf';
  var copia=(document.getElementById('pvc-copia')||{}).checked;

  // Se toman los correos tal como quedaron en pantalla, no los de SAP.
  var extras=String((document.getElementById('pvc-cc')||{}).value||'')
    .split(/[,;]/).map(function(x){ return x.trim(); }).filter(Boolean);

  var envios=[];
  Array.prototype.forEach.call(document.querySelectorAll('.pvc-on'), function(chk){
    if(!chk.checked) return;
    var cc=chk.getAttribute('data-cc');
    var inp=document.querySelector('.pvc-mail[data-cc="'+cc+'"]');
    var mails=String(inp?inp.value:'').split(/[,;]/).map(function(x){ return x.trim(); }).filter(Boolean);
    if(!mails.length) return;
    envios.push({cc:cc, mails:mails, g:porCli[cc]});
  });

  if(!envios.length){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='No hay ning\u00fan destinatario con correo.'; }
    return;
  }
  // Aviso si alguno no parece un correo: mejor pararse aqui que descubrirlo
  // cuando el sync intente enviarlo.
  var malos=[];
  envios.forEach(function(e){
    e.mails.forEach(function(m){ if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(m)) malos.push(m); });
  });
  if(malos.length){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='Revisa estos correos: '+malos.join(', '); }
    return;
  }

  if(btn){ btn.disabled=true; btn.textContent='Enviando\u2026'; }
  var ok=0, fallos=[];

  for(var i=0;i<envios.length;i++){
    var e=envios[i], cc=e.cc, g=e.g;
    if(msg){ msg.style.color='var(--text3)'; msg.textContent='Preparando '+(i+1)+' de '+envios.length+': '+g.nombre+'\u2026'; }
    try{
      var b64=await _pvArchivo(g.filas, fmtSel, g.nombre);
      var nombreArch='Mercancia-en-camino-'+String(cc).replace(/[^A-Za-z0-9_-]/g,'')+(fmtSel==='pdf'?'.pdf':'.xlsx');
      var destinos=e.mails.slice();
      extras.forEach(function(x){ if(destinos.indexOf(x)<0) destinos.push(x); });
      if(copia && CU && CU.email && destinos.indexOf(CU.email)<0) destinos.push(CU.email);

      var fila={
        para_lista: destinos,
        // para_email tambien es NOT NULL: la tabla se hizo cuando solo habia
        // un destinatario, antes de que existiera para_lista. Se manda el
        // primero, que es el cliente; el resto van en para_lista.
        para_email: destinos[0],
        asunto: asunto,
        cuerpo: cuerpo,
        adjuntos: [{nombre:nombreArch, contenido:b64}],
        estado: 'pendiente',
        cardcode: cc,
        // docnum es obligatorio en correos_queue: la tabla nacio para enviar
        // el comprobante de un pedido. Aqui no hay documento, asi que se pone
        // una referencia que identifica el envio sin fingir un numero de SAP.
        docnum: 'PORLLEGAR-'+String(cc),
        origen: 'porllegar',
        creado_por: (CU && CU.username) || 'portal'
      };
      var r=await _pvEncolar(fila);
      if(!r.ok) throw new Error(r.msg);
      ok++;
    }catch(e){ fallos.push(g.nombre+': '+String(e.message||e).slice(0,300)); }
  }

  if(btn){ btn.disabled=false; btn.textContent='Enviar'; }
  if(msg){
    msg.style.color = fallos.length ? 'var(--amber)' : 'var(--green)';
    msg.innerHTML = ok+' correo(s) en cola. Salen en el pr\u00f3ximo ciclo del sync.'
      + (_PV_QUITAR.length?('<br><span style="color:var(--text3);font-size:11.5px">La tabla no tiene: '
         +_PV_QUITAR.join(', ')+'. Se envi\u00f3 sin esos campos.</span>'):'')
      + (fallos.length?('<br><span style="color:var(--red)">Fallaron: '+npEsc(fallos.join(' | '))+'</span>'):'');
  }
  if(!fallos.length) setTimeout(function(){
    var m=document.getElementById('pvc-modal'); if(m) m.remove();
  }, 2200);
}

// Columnas marcadas en la ventana de envio. Si no hay ninguna (o la ventana
// no esta abierta), se usan las de siempre con la foto incluida.
function _pvCols(){
  var ks=[];
  Array.prototype.forEach.call(document.querySelectorAll('.pvc-col:checked'), function(c){
    ks.push(c.getAttribute('data-k'));
  });
  if(!ks.length) ks=['foto','sku','precio','packing'];
  if(ks.indexOf('foto')<0) ks.unshift('foto');   // la foto siempre
  return INV_CAMPOS.filter(function(f){ return ks.indexOf(f.k)>=0; });
}

// Genera el archivo y lo devuelve en base64, que es como lo espera
// correos_queue.adjuntos (el proceso lo pasa tal cual a Graph).
async function _pvArchivo(filas, tipo, cliente){
  var cols=_pvCols();
  var codes=[], v={};
  filas.forEach(function(r){ if(!v[r.itemcode]){ v[r.itemcode]=1; codes.push(r.itemcode); } });
  var datos=await invExportFetch({p_itemcodes:codes, p_orden:'sku'});
  if(tipo==='excel') return await _pvExcel64(datos, cols, cliente, filas);
  return await _pvPdf64(datos, cols, cliente, filas);
}

// Excel en base64, con las MISMAS columnas y fotos que el resto del portal.
// Se reutiliza xlsxExport (el que ya incrusta las imagenes) en vez de armar
// una hoja aparte: asi el archivo que recibe el cliente es identico al que
// se genera desde Inventario.
async function _pvExcel64(datos, cols, cliente, filas){
  var lineas=await invEnrich(datos);
  var hayFoto=cols.some(function(c){ return c.k==='foto'; });

  // Los datos propios de "por llegar" se pegan a cada linea para poder
  // mostrarlos como columnas mas.
  var extra={};
  (filas||[]).forEach(function(f){ extra[f.itemcode]=f; });
  lineas.forEach(function(l){
    var f=extra[l.itemcode]; if(!f) return;
    // invEnrich normaliza el nombre a 'dscription'; se deja tambien en
    // itemname por si alguna funcion lo busca con ese nombre.
    if(!l.itemname && l.dscription) l.itemname=l.dscription;
    l.__pend=Math.round(f.pend);
    l.__bultos=Math.floor(f.pend/(f.pk||1));
    l.__llegada=f.fecha ? _plFechaLbl(f.fecha) : 'por confirmar';
  });

  var columns=[
    {label:'Descripcion', key:'__desc', width:42},
    {label:'Descripcion (Ingles)', key:'__desc_en', width:42}
  ].concat(cols.map(function(c){
    return {label:c.label, key:c.k, width:(c.k==='foto'?9:(c.k==='sku'?16:12)),
            numFmt:(c.k==='precio'?'0.00':undefined)};
  })).concat([
    {label:'Por llegar', key:'__pend', width:12},
    {label:'Bultos', key:'__bultos', width:10},
    {label:'Llegada', key:'__llegada', width:14}
  ]);

  var buf=await xlsxExport({
    devolver:true,
    filename:'mercancia-en-camino.xlsx',
    titulo:'KENNEDY CENTER CORP. - MERCANCIA EN CAMINO',
    subtitulo:(cliente||'')+'  -  '+fmtD(hoyLocal())+'  -  '+lineas.length+' productos',
    columns:columns, rows:lineas, fotoKey:(hayFoto?'foto':null),
    fotoUrlFn:function(l){ return l.foto_url||''; },
    fotoCandsFn:function(l){ return l.foto_cands||(l.foto_url?[l.foto_url]:[]); },
    valueFn:function(l,k){
      if(k==='__pend')    return l.__pend||0;
      if(k==='__bultos')  return l.__bultos||0;
      if(k==='__llegada') return l.__llegada||'';
      return _invXlsxVal(l,k);
    }
  });
  return _pvB64(buf);
}

// ── PDF de verdad, construido a mano ────────────────────────────────────
// Antes esto adjuntaba un .html. Un PDF real necesitaria jsPDF, que solo esta
// en un CDN y esta red lo bloquea. Pero el formato PDF es texto plano con una
// tabla de posiciones al final: se puede escribir directamente. Sale un PDF
// valido, con fuente Helvetica y varias paginas, que abre cualquier lector.
// No lleva fotos (eso si necesitaria una libreria), pero para una lista de
// mercancia es justo lo que hace falta.

function _pdfEsc(t){
  return String(t==null?'':t)
    .replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)')
    // El PDF basico usa WinAnsi: los acentos se transliteran para que no
    // salgan caracteres raros en el lector.
    .replace(/[áàä]/gi,function(c){return c===c.toUpperCase()?'A':'a';})
    .replace(/[éèë]/gi,function(c){return c===c.toUpperCase()?'E':'e';})
    .replace(/[íìï]/gi,function(c){return c===c.toUpperCase()?'I':'i';})
    .replace(/[óòö]/gi,function(c){return c===c.toUpperCase()?'O':'o';})
    .replace(/[úùü]/gi,function(c){return c===c.toUpperCase()?'U':'u';})
    .replace(/ñ/g,'n').replace(/Ñ/g,'N').replace(/[^\x20-\x7E]/g,'');
}

// Ancho aproximado de un texto en Helvetica, para poder recortar y alinear.
function _pdfAncho(t, size){ return String(t).length * size * 0.5; }

function _pdfTexto(x, y, t, size, bold, gris){
  return 'BT /' + (bold?'F2':'F1') + ' ' + size + ' Tf '
    + (gris? (gris+' g ') : '0 g ')
    + x.toFixed(1) + ' ' + y.toFixed(1) + ' Td (' + _pdfEsc(t) + ') Tj ET\n';
}
function _pdfLinea(x1,y1,x2,y2,gris){
  return (gris||'0.8')+' G '+x1.toFixed(1)+' '+y1.toFixed(1)+' m '+x2.toFixed(1)+' '+y2.toFixed(1)+' l S\n';
}
function _pdfCaja(x,y,w,h,gris){
  return (gris||'0.94')+' g '+x.toFixed(1)+' '+y.toFixed(1)+' '+w.toFixed(1)+' '+h.toFixed(1)+' re f\n';
}

// Genera el PDF y lo devuelve en base64. Acepta las mismas columnas que el
// resto de reportes, y las fotos van incrustadas: un JPEG se puede meter en un
// PDF tal cual, declarandolo como DCTDecode, sin descomprimirlo ni convertirlo.
async function _pvPdf64(datos, cols, cliente, filas){
  var lineas=await invEnrich(datos);
  var extra={};
  (filas||[]).forEach(function(f){ extra[f.itemcode]=f; });
  lineas.forEach(function(l){
    var f=extra[l.itemcode];
    if(f){ l.__pend=f.pend; l.__pk=f.pk||1; l.__fecha=f.fecha; }
  });
  // Si el cruce fallara, mejor mandar todo que mandar un documento vacio.
  var conDatos=lineas.filter(function(l){ return l.__pend!=null; });
  if(conDatos.length) lineas=conDatos;

  var hayFoto=cols.some(function(c){ return c.k==='foto'; });
  var campos=cols.filter(function(c){ return c.k!=='foto'; });

  // Fotos: se reducen antes de incrustarlas, si no el PDF se dispara.
  var imgs={};
  if(hayFoto){
    try{
      var cf=_calidadFoto(lineas.length);
      var thumbs=await _fetchThumbPool(
        lineas.map(function(l){ return l.foto_cands || (l.foto_url?[l.foto_url]:[]); }),
        Math.min(cf.px, 120), 0.62);
      lineas.forEach(function(l){
        var u=l.foto_url||'';
        var d=thumbs[u] || (l.foto_cands && thumbs[l.foto_cands[0]]);
        if(d && /^data:image\/jpe?g;base64,/.test(d)) imgs[l.itemcode]=d.split(',')[1];
      });
    }catch(e){ imgs={}; }
  }

  var W=612, H=792, mx=32;
  var altoFila = hayFoto ? 34 : 15;
  var xFoto=mx, wFoto=hayFoto?30:0;
  var xSku=mx+(hayFoto?36:0);
  var xDesc=xSku+72;
  var wDesc=hayFoto?150:186;
  var xCampos=xDesc+wDesc+6;
  // Lo que sobra se reparte entre las columnas elegidas mas las tres fijas.
  var nCols=campos.length+3;                    // + por llegar, bultos, llegada
  // Con muchas caracteristicas marcadas el ancho por columna se queda corto y
  // los textos se montan. Se encoge la descripcion primero y, si aun no cabe,
  // se pasa a apaisado.
  var wCol=(W-mx-xCampos)/nCols;
  if(wCol < 40){
    W=792; H=612;
    wDesc=hayFoto?190:230;
    xCampos=xDesc+wDesc+6;
    wCol=Math.max(38, (W-mx-xCampos)/nCols);
  }

  var porPagina=Math.floor((H-150)/altoFila);
  var paginas=[], recursos=[];

  for(var p0=0; p0<lineas.length; p0+=porPagina){
    var trozo=lineas.slice(p0, p0+porPagina);
    var c='', y=H-52, usadas=[];

    c+=_pdfTexto(mx, y, 'KENNEDY CENTER CORP.', 15, true); y-=14;
    c+=_pdfTexto(mx, y, 'Zona Libre de Colon, Panama  ·  Tel. 441-6755', 8.5, false, '0.45'); y-=17;
    c+=_pdfTexto(mx, y, 'MERCANCIA EN CAMINO', 11.5, true);
    var der='Pag. '+(paginas.length+1)+' de '+Math.ceil(lineas.length/porPagina);
    c+=_pdfTexto(W-mx-_pdfAncho(der,9), y, der, 9, false, '0.45'); y-=13;
    c+=_pdfTexto(mx, y, (cliente||'')+'   ·   '+new Date().toLocaleDateString('es-PA'), 9.5, false, '0.35'); y-=11;
    c+=_pdfLinea(mx, y, W-mx, y, '0.42'); y-=15;

    // Cabecera
    c+=_pdfCaja(mx-3, y-5, W-mx*2+6, 15, '0.93');
    if(hayFoto) c+=_pdfTexto(xFoto, y, 'FOTO', 7.5, true);
    c+=_pdfTexto(xSku, y, 'SKU', 7.5, true);
    c+=_pdfTexto(xDesc, y, 'DESCRIPCION', 7.5, true);
    var xc=xCampos;
    campos.forEach(function(cc){
      c+=_pdfTexto(xc, y, String(cc.label).toUpperCase().substring(0,9), 7.5, true); xc+=wCol;
    });
    c+=_pdfTexto(xc, y, 'X LLEGAR', 7.5, true); xc+=wCol;
    c+=_pdfTexto(xc, y, 'BULTOS', 7.5, true);   xc+=wCol;
    c+=_pdfTexto(xc, y, 'LLEGADA', 7.5, true);
    y-=altoFila;

    trozo.forEach(function(l, idx){
      if((p0+idx)%2===1) c+=_pdfCaja(mx-3, y-4, W-mx*2+6, altoFila-1, '0.975');
      var yt = hayFoto ? (y+altoFila-16) : y;

      if(hayFoto && imgs[l.itemcode]){
        var nom='Im'+(recursos.length);
        recursos.push({nombre:nom, b64:imgs[l.itemcode]});
        usadas.push(nom);
        // La imagen se dibuja con su propia matriz de posicion.
        c+='q '+wFoto+' 0 0 '+(altoFila-6)+' '+xFoto+' '+(y-2)+' cm /'+nom+' Do Q\n';
      }

      c+=_pdfTexto(xSku, yt, String(l.itemcode||''), 7.5, true);
      // invEnrich devuelve el nombre en 'dscription' (asi se llama en SAP),
      // no en 'itemname': por eso la columna salia vacia.
      var desc=String(l.dscription || l.itemname || '');
      while(_pdfAncho(desc,7) > wDesc && desc.length>3) desc=desc.slice(0,-2);
      c+=_pdfTexto(xDesc, yt, desc, 7);
      // Con foto la fila es alta: cabe el nombre en ingles debajo.
      if(hayFoto && l.frgnname){
        var en=String(l.frgnname);
        while(_pdfAncho(en,6.5) > wDesc && en.length>3) en=en.slice(0,-2);
        c+=_pdfTexto(xDesc, yt-9, en, 6.5, false, '0.45');
      }

      var x2=xCampos;
      campos.forEach(function(cc){
        var v=_invXlsxVal(l, cc.k);
        v = (v==null?'':String(v));
        while(_pdfAncho(v,7) > wCol-5 && v.length>2) v=v.slice(0,-2);
        c+=_pdfTexto(x2, yt, v, 7); x2+=wCol;
      });
      c+=_pdfTexto(x2, yt, fmtN(Math.round(l.__pend)), 7.5, true); x2+=wCol;
      c+=_pdfTexto(x2, yt, fmtN(Math.floor(l.__pend/(l.__pk||1))), 7.5); x2+=wCol;
      c+=_pdfTexto(x2, yt, l.__fecha? _plFechaLbl(l.__fecha) : 'por confirmar', 7);

      y-=altoFila;
    });

    if(p0+porPagina >= lineas.length){
      var tu=0, tb=0;
      lineas.forEach(function(l){ tu+=l.__pend; tb+=Math.floor(l.__pend/(l.__pk||1)); });
      y-=4;
      c+=_pdfLinea(mx, y+9, W-mx, y+9, '0.42');
      c+=_pdfTexto(xSku, y-3, 'TOTALES  ·  '+lineas.length+' articulo(s)', 8.5, true);
      var xt=xCampos+campos.length*wCol;
      c+=_pdfTexto(xt, y-3, fmtN(Math.round(tu)), 8.5, true); xt+=wCol;
      c+=_pdfTexto(xt, y-3, fmtN(tb), 8.5, true);
      y-=22;
      c+=_pdfTexto(mx, y, 'Mercancia pendiente de recibir. Las fechas son estimadas y pueden variar.', 7.5, false, '0.45');
    }
    paginas.push({contenido:c, imagenes:usadas});
  }

  return _pdfArmar(paginas, W, H, recursos);
}

// Ensambla los objetos del PDF y calcula la tabla de referencias cruzadas.
// Las imagenes van como objetos XObject con DCTDecode: un JPEG entra tal cual,
// sin recodificar, que es lo que permite hacer esto sin ninguna libreria.
function _pdfArmar(paginas, W, H, recursos){
  recursos=recursos||[];
  var objs=[];
  var nPag=paginas.length;

  // Numeracion: 1 catalogo, 2 paginas, 3 y 4 fuentes, luego las imagenes y
  // por ultimo cada pagina con su contenido.
  var idImg0=5;
  var idPag0=idImg0+recursos.length;

  var kids=[];
  for(var i=0;i<nPag;i++) kids.push((idPag0+i*2)+' 0 R');

  objs.push('<< /Type /Catalog /Pages 2 0 R >>');
  objs.push('<< /Type /Pages /Kids ['+kids.join(' ')+'] /Count '+nPag+' >>');
  objs.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
  objs.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');

  // Imagenes
  var idPorNombre={};
  recursos.forEach(function(r, i){
    var bin=atob(r.b64);
    var dim=_jpegDim(bin);
    idPorNombre[r.nombre]=idImg0+i;
    objs.push({crudo:'<< /Type /XObject /Subtype /Image /Width '+dim.w+' /Height '+dim.h
      +' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length '+bin.length+' >>\nstream\n'
      + bin + '\nendstream'});
  });

  paginas.forEach(function(pg, i){
    var idCont=idPag0+i*2+1;
    var xo=(pg.imagenes||[]).map(function(n){ return '/'+n+' '+idPorNombre[n]+' 0 R'; }).join(' ');
    objs.push('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 '+W+' '+H+']'
      +' /Resources << /Font << /F1 3 0 R /F2 4 0 R >>'
      + (xo? (' /XObject << '+xo+' >>') : '') + ' >>'
      +' /Contents '+idCont+' 0 R >>');
    objs.push('<< /Length '+pg.contenido.length+' >>\nstream\n'+pg.contenido+'endstream');
  });

  var pdf='%PDF-1.4\n';
  var pos=[];
  objs.forEach(function(o, i){
    pos.push(pdf.length);
    pdf += (i+1)+' 0 obj\n'+(typeof o==='string'?o:o.crudo)+'\nendobj\n';
  });
  var inicioXref=pdf.length;
  pdf += 'xref\n0 '+(objs.length+1)+'\n0000000000 65535 f \n';
  pos.forEach(function(p){ pdf += ('0000000000'+p).slice(-10)+' 00000 n \n'; });
  pdf += 'trailer\n<< /Size '+(objs.length+1)+' /Root 1 0 R >>\nstartxref\n'+inicioXref+'\n%%EOF';

  // Latin-1: un byte por caracter. Las posiciones del xref se cuentan en
  // bytes, asi que escribir en UTF-8 las desalinearia y el PDF no abriria.
  var bytes=new Uint8Array(pdf.length);
  for(var k=0;k<pdf.length;k++) bytes[k]=pdf.charCodeAt(k) & 0xFF;
  return _pvB64(bytes.buffer);
}

// Alto y ancho de un JPEG, leidos de sus marcadores SOF.
function _jpegDim(bin){
  for(var i=2;i<bin.length-9;){
    if(bin.charCodeAt(i)!==0xFF){ i++; continue; }
    var m=bin.charCodeAt(i+1);
    if(m>=0xC0 && m<=0xCF && m!==0xC4 && m!==0xC8 && m!==0xCC){
      return { h:(bin.charCodeAt(i+5)<<8)|bin.charCodeAt(i+6),
               w:(bin.charCodeAt(i+7)<<8)|bin.charCodeAt(i+8) };
    }
    i += 2 + ((bin.charCodeAt(i+2)<<8)|bin.charCodeAt(i+3));
  }
  return {w:100, h:100};
}

function _pvB64(buffer){
  var bytes=new Uint8Array(buffer), bin='';
  var paso=0x8000;
  for(var i=0;i<bytes.length;i+=paso){
    bin+=String.fromCharCode.apply(null, bytes.subarray(i, i+paso));
  }
  return btoa(bin);
}


// ════════════════════════════════════════════════════════════════════
//  FICHA DE UN CLIENTE DE NAPA
//  Su estado de cuenta y sus facturas son los suyos, en las tablas de
//  NAPA. Lo unico que cambia es que sus pedidos entran bajo el codigo
//  paraguas de Kennedy.
// ════════════════════════════════════════════════════════════════════
async function verClienteNapa(cardcode){
  // Al abrir otra ficha los paneles vuelven a 25 lineas: si no, se heredaria
  // el "mostrar todo" del cliente anterior.
  PM_VIS['cnmov']=PM_PASO; PM_VIS['cnfac']=PM_PASO; PM_VIS['cnped']=PM_PASO;

  var m=document.createElement('div');
  m.id='cn-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9998;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:15px;max-width:1100px;width:100%;'
    +'max-height:92vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.3)">'
    +'<div style="padding:15px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px">'
      +'<b id="cn-tit" style="flex:1;font-size:15px">Cargando\u2026</b>'
      +'<button onclick="cnCerrar()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="cn-body" style="flex:1;overflow-y:auto;padding:16px 18px">'
      +'<div style="color:var(--text3);font-size:13px">Consultando NAPA\u2026</div></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) cnCerrar(); });

  try{
    var enc=encodeURIComponent(cardcode);
    var res=await Promise.all([
      q('clientes_napa','select=*&cardcode=eq.'+enc+'&limit=1').catch(function(){return[];}),
      // TODOS los movimientos, no los ultimos 300: el saldo es la suma del
      // historial completo. Con un limite se tomaban los mas recientes, que
      // en un cliente activo son sobre todo pagos, y el saldo salia negativo
      // (TOVA marcaba -119,882 cuando lo real son 69,971).
      qAll('estado_cuenta_nappa','select=refdate,ref1,linememo,debit,credit,transtype'
        +'&cardcode=eq.'+enc+'&order=refdate.asc').catch(function(){return[];}),
      // Sin limite: facturas_napa tiene una fila por LINEA, asi que 400 filas
      // pueden ser solo cuatro facturas grandes. El contador decia 16 cuando
      // el cliente tiene muchas mas.
      qAll('facturas_napa','select=docnum,docdate,doctotal,itemcode,dscription,quantity,linetotal'
        +'&cardcode=eq.'+enc+'&order=docdate.desc').catch(function(){return[];}),
      qAll('pedidos_napa','select=docnum,docdate,docduedate,doctotal,docstatus,itemcode,openqty'
        +'&cardcode=eq.'+enc+'&order=docnum.desc').catch(function(){return[];})
    ]);
    var cli=(res[0]||[])[0]||{cardcode:cardcode, cardname:cardcode};
    var mov=res[1]||[], fac=res[2]||[], ped=res[3]||[];

    var t=document.getElementById('cn-tit');
    if(t) t.innerHTML=npEsc(cli.cardname||cardcode)
      +' <span style="background:#7C3AED;color:#fff;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700;margin-left:6px">NAPA</span>'
      +'<span style="font-size:12px;color:var(--text3);font-weight:400;margin-left:8px">'+npEsc(cardcode)+'</span>';

    // Saldo: en el mayor de cuentas es debitos menos creditos.
    var deb=0, cre=0;
    mov.forEach(function(x){ deb+=Number(x.debit)||0; cre+=Number(x.credit)||0; });
    var saldo=deb-cre;

    // Facturas: una fila por linea, se agrupan por documento.
    var docs={};
    fac.forEach(function(f){
      var d=docs[f.docnum] || (docs[f.docnum]={docnum:f.docnum, docdate:f.docdate,
                                               total:Number(f.doctotal)||0, lineas:0});
      d.lineas++;
    });
    var lista=Object.keys(docs).map(function(k){ return docs[k]; })
      .sort(function(a,b){ return String(b.docdate||'').localeCompare(String(a.docdate||'')); });

    function kpi(l,v,c){
      return '<div style="flex:1;min-width:130px"><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">'+l+'</div>'
        +'<div style="font-size:20px;font-weight:700'+(c?(';color:'+c):'')+'">'+v+'</div></div>';
    }

    var contacto=[];
    if(cli.cellular||cli.phone1) contacto.push('\u260e '+npEsc(cli.cellular||cli.phone1));
    if(cli.e_mail)   contacto.push('\u2709 '+npEsc(cli.e_mail));
    if(cli.cntctprsn)contacto.push('\u{1F464} '+npEsc(cli.cntctprsn));
    if(cli.nombrevendedor) contacto.push('Vendedor: '+npEsc(cli.nombrevendedor));

    var _cc=String(cardcode).replace(/'/g,"\\'");
    var _nm=String(cli.cardname||cardcode).replace(/['"\\]/g,' ');

    // Los tres paneles se pintan por separado para poder recargarlos solos
    // al pulsar "Mostrar mas", sin volver a consultar nada.
    window._CN_DATOS = {mov:mov, fac:fac, ped:ped, lista:lista, cc:_cc};

    document.getElementById('cn-body').innerHTML=
       '<div class="card" style="margin-bottom:12px;display:flex;gap:20px;flex-wrap:wrap;padding:13px 16px">'
      +kpi('Saldo', fmt(saldo), saldo>0.005?'var(--red)':'var(--green)')
      +kpi('Movimientos', fmtN(mov.length))
      +kpi('Facturas', fmtN(lista.length))
      +(cli.creditline?kpi('L\u00edmite de cr\u00e9dito', fmt(cli.creditline)):'')
      +(cli.condicionpago?kpi('Condici\u00f3n', npEsc(cli.condicionpago)):'')
      +'</div>'
      +(contacto.length?('<div style="font-size:12.5px;color:var(--text3);margin-bottom:12px">'+contacto.join(' &nbsp;|&nbsp; ')+'</div>'):'')
      +'<div style="display:flex;gap:8px;margin-bottom:10px;flex-wrap:wrap">'
        +'<button class="btn btn-sm btn-p" onclick="cnPedido(\''+_cc+'\',\''+_nm+'\')">\u{1F6D2} Nuevo pedido</button>'
        +'<button class="btn btn-sm" onclick="cnRestock(\''+_cc+'\',\''+_nm+'\')">\u{1F504} Restock</button>'
        +'<button class="btn btn-sm" onclick="cnEstadoCuenta(\''+_cc+'\')">\u{1F4C4} Estado de cuenta completo</button>'
      +'</div>'
      +'<div id="pm-cnmov"></div>'
      +'<div id="pm-cnfac"></div>'
      +'<div id="pm-cnped"></div>';

    cnPanelMov(); cnPanelFac(); cnPanelPed();
    }catch(e){
    var b=document.getElementById('cn-body');
    if(b) b.innerHTML='<div style="color:var(--red);font-size:13px">No se pudo consultar: '+npEsc(String(e.message||e).slice(0,160))+'</div>';
  }
}

function cnCerrar(){ var m=document.getElementById('cn-modal'); if(m) m.remove(); }

function cnPedido(code, nombre){
  cnCerrar();
  npCli={cardcode:code, cardname:nombre, napa:true};
  go('nuevo_pedido', document.getElementById('nav-np'));
  setTimeout(function(){
    try{ npSelCliente({cardcode:code, cardname:nombre, napa:true}); }catch(e){}
  }, 200);
}


// ════════════════════════════════════════════════════════════════════
//  BUSCAR POR FOTO
//  El cliente sube una imagen, la IA la describe, y con esa descripcion
//  se busca en el catalogo. La IA NO ve el catalogo: solo describe la
//  foto. La busqueda la hace el portal contra la base.
// ════════════════════════════════════════════════════════════════════
var BF_DESC=null, BF_RES=[], BF_CARGANDO=false;

function bfAbrir(){
  if(document.getElementById('bf-modal')) return;
  var m=document.createElement('div');
  m.id='bf-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9998;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:15px;max-width:1000px;width:100%;'
    +'max-height:92vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.3)">'
    +'<div style="padding:15px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px">'
      +'<b style="flex:1;font-size:15px">\u{1F4F7} Buscar por foto</b>'
      +'<button onclick="bfCerrar()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="bf-body" style="flex:1;overflow-y:auto;padding:18px">'
      +'<div id="bf-zona" style="border:2px dashed var(--border);border-radius:13px;padding:34px 20px;text-align:center;cursor:pointer">'
        +'<div style="font-size:38px;line-height:1">\u{1F5BC}\uFE0F</div>'
        +'<div style="font-size:14px;font-weight:600;margin-top:8px">Sube una foto del art\u00edculo</div>'
        +'<div style="font-size:12px;color:var(--text3);margin-top:5px">'
          +'Arr\u00e1strala aqu\u00ed o pulsa para elegirla. Tambi\u00e9n puedes pegarla con Ctrl+V.</div>'
        +'<div style="font-size:11.5px;color:var(--text3);margin-top:10px">'
          +'Funciona mejor con el art\u00edculo solo, bien iluminado y sobre fondo liso.</div>'
      +'</div>'
      +'<input type="file" id="bf-file" accept="image/*" style="display:none" onchange="bfArchivo(this)">'
    +'</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) bfCerrar(); });

  var z=document.getElementById('bf-zona');
  z.onclick=function(){ document.getElementById('bf-file').click(); };
  z.ondragover=function(e){ e.preventDefault(); z.style.borderColor='var(--blue2)'; };
  z.ondragleave=function(){ z.style.borderColor='var(--border)'; };
  z.ondrop=function(e){
    e.preventDefault(); z.style.borderColor='var(--border)';
    if(e.dataTransfer.files && e.dataTransfer.files[0]) bfProcesar(e.dataTransfer.files[0]);
  };
  document.addEventListener('paste', bfPegar);
}

function bfCerrar(){
  document.removeEventListener('paste', bfPegar);
  var m=document.getElementById('bf-modal'); if(m) m.remove();
}

function bfPegar(e){
  if(!document.getElementById('bf-modal')) return;
  var it=(e.clipboardData||{}).items||[];
  for(var i=0;i<it.length;i++){
    if(it[i].type && it[i].type.indexOf('image/')===0){
      var f=it[i].getAsFile();
      if(f){ e.preventDefault(); bfProcesar(f); return; }
    }
  }
}

function bfArchivo(el){
  var f=el && el.files && el.files[0];
  el.value='';
  if(f) bfProcesar(f);
}

// Reduce la foto antes de mandarla: una de camara son varios MB y a la IA no
// le aporta nada por encima de 900px. Ademas abarata la llamada.
function bfReducir(file){
  return new Promise(function(res, rej){
    var fr=new FileReader();
    fr.onload=function(){
      var img=new Image();
      img.onload=function(){
        var max=900, w=img.width, h=img.height;
        if(w>max || h>max){
          if(w>h){ h=Math.round(h*max/w); w=max; } else { w=Math.round(w*max/h); h=max; }
        }
        var c=document.createElement('canvas'); c.width=w; c.height=h;
        c.getContext('2d').drawImage(img,0,0,w,h);
        var d=c.toDataURL('image/jpeg', 0.82);
        res({ b64:d.split(',')[1], vista:d });
      };
      img.onerror=function(){ rej(new Error('No se pudo leer la imagen')); };
      img.src=fr.result;
    };
    fr.onerror=function(){ rej(new Error('No se pudo leer el archivo')); };
    fr.readAsDataURL(file);
  });
}

async function bfProcesar(file){
  if(BF_CARGANDO) return;
  if(!/^image\//.test(file.type||'')){ alert('Eso no parece una imagen.'); return; }
  BF_CARGANDO=true;
  var b=document.getElementById('bf-body');

  try{
    var img=await bfReducir(file);
    b.innerHTML='<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:flex-start">'
      +'<img src="'+img.vista+'" style="width:190px;border-radius:11px;border:1px solid var(--border)">'
      +'<div style="flex:1;min-width:220px;color:var(--text3);font-size:13px;padding-top:8px">'
        +'<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:8px"></div>'
        +'Mirando la foto\u2026</div></div>';

    // 1) La IA describe lo que ve
    var d = await iaLlamarFoto(img.b64, 'image/jpeg');
    BF_DESC = d;

    if(!d || !d.tipo || Number(d.confianza) < 25){
      b.innerHTML='<div style="display:flex;gap:18px;flex-wrap:wrap">'
        +'<img src="'+img.vista+'" style="width:190px;border-radius:11px;border:1px solid var(--border)">'
        +'<div style="flex:1;min-width:230px">'
          +'<div style="font-size:14px;font-weight:600;margin-bottom:6px">No pude identificar el art\u00edculo</div>'
          +'<div style="font-size:12.5px;color:var(--text3);line-height:1.6">'
            +'Prueba con una foto del art\u00edculo solo, bien iluminado y sobre fondo liso. '
            +'Si la imagen tiene varios productos o est\u00e1 borrosa, cuesta reconocerlo.</div>'
          +'<button class="btn btn-sm" style="margin-top:12px" onclick="bfReiniciar()">Probar con otra</button>'
        +'</div></div>';
      BF_CARGANDO=false; return;
    }

    b.innerHTML='<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:flex-start">'
      +'<img src="'+img.vista+'" style="width:190px;border-radius:11px;border:1px solid var(--border)">'
      +'<div style="flex:1;min-width:220px;color:var(--text3);font-size:13px;padding-top:8px">'
        +'<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:8px"></div>'
        +'Buscando <b>'+npEsc(d.tipo)+'</b> en el cat\u00e1logo\u2026</div></div>';

    // 2) Busqueda en el catalogo con lo que describio
    var res = await bfBuscarCatalogo(d);
    BF_RES = res;
    bfPintar(img.vista, d, res);
  }catch(e){
    b.innerHTML='<div style="color:var(--red);font-size:13px">'+npEsc(String(e.message||e).slice(0,200))+'</div>'
      +'<button class="btn btn-sm" style="margin-top:12px" onclick="bfReiniciar()">Volver a intentar</button>';
  }finally{ BF_CARGANDO=false; }
}

function bfReiniciar(){ bfCerrar(); bfAbrir(); }

// Llama al proxy de IA con la imagen. La clave nunca sale del servidor.
async function iaLlamarFoto(b64, mime){
  var r = await fetch(IA_URL, {
    method:'POST',
    headers:{'Content-Type':'application/json','apikey':KEY,'Authorization':'Bearer '+AUTHTOK()},
    body: JSON.stringify({tarea:'foto', imagen:b64, tipo_imagen:mime, texto:'Describe este articulo.'})
  });
  var d = await r.json().catch(function(){ return null; });
  if(!r.ok){
    var m=(d && d.error) || ('IA '+r.status);
    if(r.status===429) m='Llegaste al l\u00edmite de fotos por hoy. Prueba ma\u00f1ana.';
    if(r.status===413) m='La imagen es demasiado grande.';
    // El detalle ayuda a saber que respondio de verdad la IA.
    if(d && d.detalle) console.warn('[foto] respuesta de la IA:', d.detalle);
    throw new Error(m);
  }
  return d && d.resultado;
}

// Busca en el catalogo con los terminos que devolvio la IA. Se puntua cada
// resultado: cuantos terminos coinciden, si el color y el material aparecen
// en el nombre, y si hay existencia. Ordenado por esa puntuacion.
async function bfBuscarCatalogo(d){
  var terminos=(d.terminos||[]).filter(Boolean).slice(0,8);
  if(d.tipo && terminos.indexOf(d.tipo)<0) terminos.unshift(d.tipo);
  if(!terminos.length) return [];

  var vistos={}, todos=[];
  for(var i=0;i<terminos.length;i++){
    var t=String(terminos[i]).trim();
    if(t.length<3) continue;
    try{
      // Cada palabra del termino tiene que estar en el nombre, en cualquier
      // orden: "mesita noche" encuentra "MESITA DE NOCHE".
      var patron=t.split(/\s+/).join('%');
      var r=await q('vista_inventario',
        'select=itemcode,itemname,precioventa,disponible,unidadesbulto,marca,subg,picturname,foto_url'
        +'&itemname=ilike.*'+encodeURIComponent(patron)+'*&limit=40');
      (r||[]).forEach(function(x){
        if(vistos[x.itemcode]){ vistos[x.itemcode].hits++; return; }
        x.hits=1; vistos[x.itemcode]=x; todos.push(x);
      });
    }catch(e){}
  }
  if(!todos.length) return [];

  var col=String(d.color||'').toLowerCase();
  var mat=String(d.material||'').toLowerCase();
  var forma=String(d.forma||'').toLowerCase();

  todos.forEach(function(x){
    var nom=String(x.itemname||'').toLowerCase();
    var car=JSON.stringify(x.caracteristicas||'').toLowerCase();
    var p = x.hits * 10;                                   // cuantos terminos coinciden
    if(col && (nom.indexOf(col)>=0 || car.indexOf(col)>=0)) p += 6;
    if(mat && (nom.indexOf(mat)>=0 || car.indexOf(mat)>=0)) p += 4;
    if(forma && nom.indexOf(forma)>=0) p += 2;
    if(Number(x.disponible)>0) p += 3;                     // lo que hay se ofrece antes
    if(x.foto_url || x.picturname) p += 1;                 // con foto, se compara mejor
    x.score = p;
  });

  return todos.sort(function(a,b){ return b.score-a.score; }).slice(0, 24);
}

function bfPintar(vista, d, res){
  var b=document.getElementById('bf-body'); if(!b) return;

  var detalle=[d.color, d.material, d.forma, d.uso].filter(Boolean).join(' \u00b7 ');

  var tarjetas = res.map(function(x){
    var cs=String(x.itemcode).replace(/'/g,"\\'");
    var nm=String(x.itemname||'').replace(/['"\\]/g,' ').slice(0,80);
    var pk=Number(x.unidadesbulto)||1;
    var disp=Number(x.disponible)||0;
    return '<div style="border:1px solid var(--border);border-radius:11px;padding:9px;width:168px">'
      +'<div style="height:118px;display:flex;align-items:center;justify-content:center;background:var(--surface2,#F7F7F8);border-radius:8px;overflow:hidden">'
        + (x.foto_url||x.picturname
            ? fotoThumb(x.picturname, x.foto_url).replace('width:32px;height:32px','width:100%;height:118px').replace('object-fit:cover','object-fit:contain')
            : '<span style="color:var(--text3);font-size:11px">Sin foto</span>')
      +'</div>'
      +'<div style="font-size:11.5px;font-weight:700;margin-top:7px;color:var(--blue2);cursor:pointer" onclick="bfCerrar();verItem(\''+cs+'\')">'+npEsc(x.itemcode)+'</div>'
      +'<div style="font-size:11px;color:var(--text3);line-height:1.35;height:44px;overflow:hidden">'+npEsc(String(x.itemname||'').substring(0,60))+'</div>'
      +'<div style="font-size:13px;font-weight:700;margin-top:4px">'+fmt(x.precioventa)+'</div>'
      +'<div style="font-size:11px;color:'+(disp>0?'var(--green)':'var(--red)')+'">'
        +(disp>0 ? (fmtN(disp)+' disp.') : 'agotado')+'</div>'
      +'<button class="btn btn-sm btn-p" style="width:100%;margin-top:6px;padding:3px" '
        +'onclick="bfAlCarrito(\''+cs+'\',\''+nm+'\','+(Number(x.precioventa)||0)+','+pk+')">+ '+pk+'</button>'
      +'</div>';
  }).join('');

  b.innerHTML='<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:flex-start;margin-bottom:14px">'
    +'<img src="'+vista+'" style="width:150px;border-radius:11px;border:1px solid var(--border)">'
    +'<div style="flex:1;min-width:230px">'
      +'<div style="font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">La foto parece</div>'
      +'<div style="font-size:17px;font-weight:700;text-transform:capitalize">'+npEsc(d.tipo||'')+'</div>'
      +(detalle?('<div style="font-size:12.5px;color:var(--text3);margin-top:3px;text-transform:capitalize">'+npEsc(detalle)+'</div>'):'')
      +'<div style="font-size:12px;color:var(--text3);margin-top:9px">'
        + (res.length ? ('<b>'+res.length+'</b> art\u00edculo(s) parecidos en el cat\u00e1logo')
                      : 'No encontr\u00e9 nada parecido en el cat\u00e1logo')+'</div>'
      +'<button class="btn btn-sm" style="margin-top:11px" onclick="bfReiniciar()">Probar con otra foto</button>'
    +'</div></div>'
    + (res.length
        ? '<div style="display:flex;gap:11px;flex-wrap:wrap">'+tarjetas+'</div>'
          +'<div style="font-size:11.5px;color:var(--text3);margin-top:14px;line-height:1.5">'
          +'Los resultados salen de comparar la descripci\u00f3n de la foto con los nombres del cat\u00e1logo. '
          +'Puede haber art\u00edculos parecidos que no aparezcan si su nombre est\u00e1 escrito de otra forma.</div>'
        : '<div style="padding:20px;text-align:center;color:var(--text3);font-size:13px">'
          +'Prueba buscando a mano por <b>'+npEsc(d.tipo||'')+'</b> en el cat\u00e1logo.</div>');
}

function bfAlCarrito(code, nombre, precio, bulto){
  try{ npAgregarLineaDirecta(code, nombre, Number(precio)||0, Number(bulto)||1); }
  catch(e){ alert('No se pudo a\u00f1adir: '+(e.message||e)); }
}

// ── Acciones de la ficha de un cliente de NAPA ─────────────────────────────

// El detalle de una factura de NAPA usa la MISMA pantalla que las de Kennedy:
// verFactura(docnum, null, true). Asi trae fotos, exportadores y stock actual,
// en vez de la tabla simple que habia aqui antes.

// Abre Restock cliente con ese cliente ya elegido, marcado como de NAPA.
function cnRestock(code, nombre){
  cnCerrar();
  go('restock', document.getElementById('nav-rst'));
  setTimeout(function(){
    try{ rsElegirCli(code, nombre, true); }catch(e){}
  }, 220);
}

// Lleva a la pantalla de Estados de cuenta NAPPA, que trae el mayor completo
// con su antiguedad y el PDF.
function cnEstadoCuenta(code){
  cnCerrar();
  go('ecnappa', document.getElementById('nav-ecnappa'));
  setTimeout(function(){
    var c=document.getElementById('ecn-code');
    if(c) c.value=code;
    try{ if(typeof ecnPick==='function') ecnPick(code); }catch(e){}
  }, 250);
}


// ════════════════════════════════════════════════════════════════════
//  CAPACIDAD DE CONTENEDOR
//  Mientras se arma el pedido, cuanto lleva lleno el contenedor por
//  volumen y por peso. En Zona Libre es lo que decide si el pedido se
//  puede embarcar o hay que ajustarlo.
// ════════════════════════════════════════════════════════════════════

// Capacidades reales de embarque, no las nominales del contenedor: se
// descuenta lo que no se aprovecha al estibar (pallets, huecos, forma de
// la carga). Un 40'HQ da 2.694 pies cubicos nominales pero rara vez se
// carga por encima de 2.350.
var CONTENEDORES = {
  '20':    {nombre:"20'",      cft:1050, kg:21700},
  '40':    {nombre:"40' Std",  cft:2150, kg:26500},
  '40hq':  {nombre:"40' HQ",   cft:2450, kg:26200},
  '45':    {nombre:"45' HQ",   cft:2790, kg:27600}
};

var CT_TIPO = '40hq';    // el mas usado

var CT_UNID = 1;         // cuantos contenedores

function ctTipo(v){ CT_TIPO=v||'40hq'; ctRender(); }
function ctUnidades(n){
  CT_UNID = Math.max(1, Math.min(20, Number(n)||1));
  var i=document.getElementById('ct-unid'); if(i) i.value=CT_UNID;
  ctRender();
}

// Se llama desde cotizUpdate: cada vez que cambia el carrito.
function ctRender(){
  var box=document.getElementById('ct-panel'); if(!box) return;

  if(!npLineas || !npLineas.length){
    box.style.display='none';
    return;
  }
  box.style.display='';

  var t = npTotales();
  var c = CONTENEDORES[CT_TIPO] || CONTENEDORES['40hq'];
  var capCft = c.cft * CT_UNID;
  var capKg  = c.kg  * CT_UNID;

  var cft = Number(t.piecub)||0;
  var kg  = Number(t.kilos)||0;
  var cbm = cft * 0.0283168;          // pies cubicos a metros cubicos

  var pVol = capCft>0 ? (cft/capCft*100) : 0;
  var pPes = capKg>0  ? (kg/capKg*100)   : 0;

  // Manda el que llegue antes al tope: un contenedor se cierra por volumen
  // o por peso, lo que ocurra primero.
  var pMax = Math.max(pVol, pPes);
  var porPeso = pPes > pVol;

  var col = pMax > 100 ? 'var(--red)' : (pMax > 90 ? 'var(--amber)' : 'var(--green)');

  function barra(pct, color, etiqueta, valor, cap, unidad){
    var w = Math.min(100, pct);
    var exceso = pct > 100;
    return '<div style="flex:1;min-width:230px">'
      +'<div style="display:flex;justify-content:space-between;font-size:11.5px;margin-bottom:4px">'
        +'<span style="color:var(--text3)">'+etiqueta+'</span>'
        +'<span style="font-weight:700;color:'+color+'">'+Math.round(pct)+'%</span>'
      +'</div>'
      +'<div style="height:11px;background:var(--surface2,#F1F2F4);border-radius:6px;overflow:hidden;position:relative">'
        +'<div style="height:100%;width:'+w+'%;background:'+color+';border-radius:6px;transition:width .3s"></div>'
        + (exceso ? '<div style="position:absolute;inset:0;border:2px solid var(--red);border-radius:6px"></div>' : '')
      +'</div>'
      +'<div style="font-size:11px;color:var(--text3);margin-top:3px">'
        +fmtN(Math.round(valor))+' de '+fmtN(cap)+' '+unidad+'</div>'
      +'</div>';
  }

  // Cuanto falta para llenar, o cuanto sobra. Es el dato accionable.
  var aviso;
  if(pMax > 100){
    var sobraCft = Math.max(0, cft-capCft), sobraKg = Math.max(0, kg-capKg);
    aviso = '<div style="background:#FEF2F2;border:1px solid #FECACA;color:#991B1B;border-radius:9px;padding:9px 12px;font-size:12.5px;line-height:1.5">'
      +'<b>No cabe.</b> Sobran '
      + (sobraCft>0 ? (fmtN(Math.round(sobraCft))+' pies c\u00fabicos') : '')
      + (sobraCft>0 && sobraKg>0 ? ' y ' : '')
      + (sobraKg>0 ? (fmtN(Math.round(sobraKg))+' kg') : '')
      + '. Quita mercanc\u00eda o pasa a '+(CT_UNID+1)+' contenedores.</div>';
  } else if(pMax > 90){
    aviso = '<div style="background:#FFFBEB;border:1px solid #FDE68A;color:#92400E;border-radius:9px;padding:9px 12px;font-size:12.5px">'
      +'<b>Casi lleno</b> ('+Math.round(pMax)+'%). Queda poco margen'
      +(porPeso?' de peso':' de espacio')+'.</div>';
  } else {
    var faltaCft = capCft - cft, faltaKg = capKg - kg;
    aviso = '<div style="font-size:12.5px;color:var(--text3);line-height:1.5">'
      +'Caben <b>'+fmtN(Math.round(faltaCft))+'</b> pies c\u00fabicos m\u00e1s '
      +'(<b>'+fmtN(Math.round(faltaKg))+' kg</b>). '
      + (porPeso ? 'El l\u00edmite lo marca el <b>peso</b>.' : 'El l\u00edmite lo marca el <b>volumen</b>.')
      +'</div>';
  }

  var ops = Object.keys(CONTENEDORES).map(function(k){
    return '<option value="'+k+'"'+(k===CT_TIPO?' selected':'')+'>'+CONTENEDORES[k].nombre+'</option>';
  }).join('');

  box.innerHTML =
     '<div class="ch" style="flex-wrap:wrap;gap:9px;margin-bottom:10px">'
      +'<span class="ct">\u{1F69A} Capacidad del contenedor</span>'
      +'<span style="display:flex;gap:7px;align-items:center;margin-left:auto">'
        +'<select onchange="ctTipo(this.value)" style="padding:5px 9px;border:1px solid var(--border);border-radius:8px;font-size:12px;background:#fff">'+ops+'</select>'
        +'<span style="font-size:12px;color:var(--text3)">\u00d7</span>'
        +'<input type="number" id="ct-unid" min="1" max="20" value="'+CT_UNID+'" onchange="ctUnidades(this.value)" '
        +'style="width:48px;padding:5px 6px;border:1px solid var(--border);border-radius:8px;font-size:12px;text-align:center">'

      +'</span>'
    +'</div>'
    +'<div style="display:flex;gap:18px;flex-wrap:wrap;margin-bottom:11px">'
      + barra(pVol, col, 'Volumen', cft, capCft, 'pies c\u00fabicos')
      + barra(pPes, col, 'Peso',    kg,  capKg,  'kg')
    +'</div>'
    + aviso
    +'<div style="display:flex;gap:20px;flex-wrap:wrap;margin-top:11px;font-size:11.5px;color:var(--text3)">'
      +'<span>CBM: <b style="color:var(--text)">'+cbm.toFixed(2)+' m\u00b3</b></span>'
      +'<span>Bultos: <b style="color:var(--text)">'+fmtN(Math.round(t.bultos))+'</b></span>'
      +'<span>Unidades: <b style="color:var(--text)">'+fmtN(Math.round(t.uds))+'</b></span>'
    +'</div>';
}


// ════════════════════════════════════════════════════════════════════
//  COMPARTIR ESTADO DE CUENTA
//  Genera el PDF como archivo de verdad (no una ventana de impresion)
//  para poder adjuntarlo al correo o mandarlo por WhatsApp.
// ════════════════════════════════════════════════════════════════════

// Arma el PDF del estado de cuenta y lo devuelve en base64.
function ecPdfArchivo(cli, movs, desde, hasta){
  var W=612, H=792, mx=36;
  var COL=[mx, mx+78, mx+150, mx+330, mx+412, mx+494];   // fecha, doc, concepto, debito, credito, saldo
  var porPagina=40;
  var paginas=[];

  // Solo lo que tiene saldo pendiente o movimiento, en orden cronologico.
  var filas=(movs||[]).slice().sort(function(a,b){
    return String(a.docdate||'').localeCompare(String(b.docdate||''));
  });
  if(desde) filas=filas.filter(function(m){ return String(m.docdate||'')>=desde; });
  if(hasta) filas=filas.filter(function(m){ return String(m.docdate||'')<=hasta; });

  var saldo=0, totD=0, totC=0;
  filas.forEach(function(m){
    var d=Number(m.debito)||0, c=Number(m.credito)||0;
    totD+=d; totC+=c; saldo+=d-c;
    m.__saldo=saldo;
  });

  for(var p0=0; p0<filas.length; p0+=porPagina){
    var trozo=filas.slice(p0, p0+porPagina);
    var c='', y=H-50;

    c+=_pdfTexto(mx, y, 'KENNEDY CENTER CORP.', 15, true); y-=14;
    c+=_pdfTexto(mx, y, 'Zona Libre de Colon, Panama  ·  Tel. 441-6755', 8.5, false, '0.45'); y-=17;
    c+=_pdfTexto(mx, y, 'ESTADO DE CUENTA', 11.5, true);
    var der='Pag. '+(paginas.length+1)+' de '+Math.max(1,Math.ceil(filas.length/porPagina));
    c+=_pdfTexto(W-mx-_pdfAncho(der,9), y, der, 9, false, '0.45'); y-=14;

    c+=_pdfTexto(mx, y, String(cli.cardname||''), 11, true); y-=12;
    var sub=String(cli.cardcode||'');
    if(cli.nombrevendedor) sub+='   ·   Vendedor: '+cli.nombrevendedor;
    c+=_pdfTexto(mx, y, sub, 9, false, '0.35'); y-=11;
    var per=(desde||hasta)
      ? ('Periodo: '+(desde?_plFechaLbl(desde):'inicio')+' a '+(hasta?_plFechaLbl(hasta):'hoy'))
      : 'Todo el historial';
    c+=_pdfTexto(mx, y, per+'   ·   Emitido '+new Date().toLocaleDateString('es-PA'), 8.5, false, '0.45');
    y-=11;
    c+=_pdfLinea(mx, y, W-mx, y, '0.42'); y-=15;

    c+=_pdfCaja(mx-3, y-5, W-mx*2+6, 15, '0.93');
    c+=_pdfTexto(COL[0], y, 'FECHA', 8, true);
    c+=_pdfTexto(COL[1], y, 'DOCUMENTO', 8, true);
    c+=_pdfTexto(COL[2], y, 'CONCEPTO', 8, true);
    c+=_pdfTexto(COL[3], y, 'DEBITO', 8, true);
    c+=_pdfTexto(COL[4], y, 'CREDITO', 8, true);
    c+=_pdfTexto(COL[5], y, 'SALDO', 8, true);
    y-=14;

    trozo.forEach(function(m, idx){
      if((p0+idx)%2===1) c+=_pdfCaja(mx-3, y-4, W-mx*2+6, 13, '0.975');
      var d=Number(m.debito)||0, cr=Number(m.credito)||0;
      c+=_pdfTexto(COL[0], y, _plFechaLbl(String(m.docdate||'').substring(0,10)), 7.5);
      c+=_pdfTexto(COL[1], y, String(m.tipo||'')+' '+String(m.docnum||''), 7.5, true);
      var con=String(m.comments||'');
      while(_pdfAncho(con,7) > 172 && con.length>3) con=con.slice(0,-2);
      c+=_pdfTexto(COL[2], y, con, 7);
      if(d)  c+=_pdfTexto(COL[4]-8-_pdfAncho(fmtN2(d),7.5),  y, fmtN2(d), 7.5);
      if(cr) c+=_pdfTexto(COL[5]-8-_pdfAncho(fmtN2(cr),7.5), y, fmtN2(cr), 7.5);
      var sa=fmtN2(m.__saldo);
      c+=_pdfTexto(W-mx-_pdfAncho(sa,7.5), y, sa, 7.5, true);
      y-=13;
    });

    if(p0+porPagina >= filas.length){
      y-=4;
      c+=_pdfLinea(mx, y+9, W-mx, y+9, '0.42');
      c+=_pdfTexto(COL[0], y-4, 'TOTALES  ·  '+filas.length+' movimiento(s)', 9, true);
      c+=_pdfTexto(COL[4]-8-_pdfAncho(fmtN2(totD),9), y-4, fmtN2(totD), 9, true);
      c+=_pdfTexto(COL[5]-8-_pdfAncho(fmtN2(totC),9), y-4, fmtN2(totC), 9, true);
      var sf=fmtN2(saldo);
      c+=_pdfTexto(W-mx-_pdfAncho(sf,10), y-4, sf, 10, true);
      y-=24;
      c+=_pdfTexto(mx, y, 'Saldo a la fecha: '+fmt(saldo), 10, true);
      y-=14;
      c+=_pdfTexto(mx, y, 'Cualquier diferencia, favor comunicarla a la brevedad.', 8, false, '0.45');
    }
    paginas.push({contenido:c, imagenes:[]});
  }

  if(!paginas.length){
    paginas.push({contenido:_pdfTexto(mx, H-70, 'Sin movimientos en el periodo.', 11), imagenes:[]});
  }
  return _pdfArmar(paginas, W, H, []);
}

// Ventana de compartir: correo o WhatsApp.
function ecCompartir(){
  var cli = (typeof _cliActual!=='undefined' && _cliActual) ? _cliActual : null;
  if(!cli){ alert('Abre primero la ficha del cliente.'); return; }
  if(!_ecCliMovs || !_ecCliMovs.length){ alert('Este cliente no tiene movimientos.'); return; }

  var tel = String(cli.cellular || cli.phone1 || '').replace(/[^0-9]/g,'');
  var mail = String(cli.e_mail || '').trim();
  var saldo = 0;
  _ecCliMovs.forEach(function(m){ saldo += (Number(m.debito)||0)-(Number(m.credito)||0); });

  var m=document.createElement('div');
  m.id='ecs-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:520px;width:100%;padding:18px">'
    +'<div style="display:flex;align-items:center;gap:10px;margin-bottom:4px">'
      +'<b style="flex:1;font-size:15px">Compartir estado de cuenta</b>'
      +'<button onclick="document.getElementById(\'ecs-modal\').remove()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:14px">'
      +npEsc(cli.cardname||'')+' \u00b7 saldo '+fmt(saldo)+'</div>'

    +'<div style="display:flex;gap:9px;margin-bottom:14px">'
      +'<div><label style="font-size:11.5px;color:var(--text3);display:block;margin-bottom:3px">Desde</label>'
        +'<input type="date" id="ecs-desde" style="padding:7px 9px;border:1px solid var(--border);border-radius:8px;font-size:13px"></div>'
      +'<div><label style="font-size:11.5px;color:var(--text3);display:block;margin-bottom:3px">Hasta</label>'
        +'<input type="date" id="ecs-hasta" style="padding:7px 9px;border:1px solid var(--border);border-radius:8px;font-size:13px"></div>'
      +'<div style="align-self:flex-end;font-size:11.5px;color:var(--text3);padding-bottom:8px">'
        +'D\u00e9jalos vac\u00edos para todo el historial</div>'
    +'</div>'

    +'<div style="display:grid;gap:9px">'
      +'<button class="btn" onclick="ecsDescargar()" style="justify-content:flex-start;padding:11px 13px;text-align:left">'
        +'<b>\u2b07 Descargar PDF</b><br><span style="font-size:11.5px;color:var(--text3)">Para guardarlo o adjuntarlo a mano</span></button>'

      +'<button class="btn" onclick="ecsWhatsApp()" style="justify-content:flex-start;padding:11px 13px;text-align:left;border-color:#25D366">'
        +'<b style="color:#128C7E">\u{1F4AC} WhatsApp</b><br>'
        +'<span style="font-size:11.5px;color:var(--text3)">'
        + (tel ? ('Abre el chat con '+npEsc(tel)+' y descarga el PDF para adjuntarlo')
               : 'Este cliente no tiene tel\u00e9fono registrado')
        +'</span></button>'

      +'<button class="btn btn-p" onclick="ecsCorreo()" style="justify-content:flex-start;padding:11px 13px;text-align:left">'
        +'<b>\u2709 Enviar por correo</b><br>'
        +'<span style="font-size:11.5px;opacity:.85">'
        + (mail ? ('Con el PDF adjunto a '+npEsc(mail)) : 'Este cliente no tiene correo registrado')
        +'</span></button>'
    +'</div>'
    +'<div id="ecs-msg" style="font-size:12.5px;margin-top:11px"></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) m.remove(); });
  window._ECS_CLI = cli;
}

function _ecsRango(){
  var d=(document.getElementById('ecs-desde')||{}).value||'';
  var h=(document.getElementById('ecs-hasta')||{}).value||'';
  return {desde:d, hasta:h};
}

function _ecsNombre(cli){
  return 'Estado-de-cuenta-'+String(cli.cardcode||'').replace(/[^A-Za-z0-9_-]/g,'')+'.pdf';
}

function ecsDescargar(){
  var cli=window._ECS_CLI; if(!cli) return;
  var r=_ecsRango();
  try{
    var b64=ecPdfArchivo(cli, _ecCliMovs, r.desde, r.hasta);
    var bin=atob(b64), arr=new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    var url=URL.createObjectURL(new Blob([arr],{type:'application/pdf'}));
    var a=document.createElement('a'); a.href=url; a.download=_ecsNombre(cli);
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function(){ URL.revokeObjectURL(url); }, 4000);
    var msg=document.getElementById('ecs-msg');
    if(msg){ msg.style.color='var(--green)'; msg.textContent='PDF descargado.'; }
  }catch(e){ alert('No se pudo generar el PDF: '+(e.message||e)); }
}

// WhatsApp no deja adjuntar archivos desde un enlace: solo texto. Asi que se
// descarga el PDF y se abre el chat con el mensaje listo, para que la persona
// lo adjunte con el clip. Es el unico camino que funciona sin la API de pago.
function ecsWhatsApp(){
  var cli=window._ECS_CLI; if(!cli) return;
  var tel=String(cli.cellular||cli.phone1||'').replace(/[^0-9]/g,'');
  if(!tel){ alert('Este cliente no tiene tel\u00e9fono registrado.'); return; }
  if(tel.length<=8) tel='507'+tel;      // sin indicativo se asume Panama

  var saldo=0;
  _ecCliMovs.forEach(function(m){ saldo += (Number(m.debito)||0)-(Number(m.credito)||0); });

  ecsDescargar();

  var txt='Buen d\u00eda '+(cli.cardname||'')+',\n\n'
    +'Le comparto su estado de cuenta con Kennedy Center Corp.\n'
    +'Saldo a la fecha: '+fmt(saldo)+'\n\n'
    +'Quedamos atentos. Gracias.';

  setTimeout(function(){
    window.open('https://wa.me/'+tel+'?text='+encodeURIComponent(txt), '_blank');
    var msg=document.getElementById('ecs-msg');
    if(msg){
      msg.style.color='var(--text3)';
      msg.innerHTML='Se descarg\u00f3 el PDF y se abri\u00f3 el chat. '
        +'<b>Adjunta el archivo con el clip</b>: WhatsApp no permite adjuntarlo autom\u00e1ticamente.';
    }
  }, 700);
}

// El correo sí puede llevar el PDF adjunto: sale por correos_queue -> Graph.
async function ecsCorreo(){
  var cli=window._ECS_CLI; if(!cli) return;
  var msg=document.getElementById('ecs-msg');
  var mail=String(cli.e_mail||'').trim();

  if(!mail){
    mail = prompt('Este cliente no tiene correo registrado.\nEscribe a qu\u00e9 direcci\u00f3n enviarlo:') || '';
    mail = mail.trim();
    if(!mail) return;
  }
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='Ese correo no parece v\u00e1lido.'; }
    return;
  }

  var r=_ecsRango();
  if(msg){ msg.style.color='var(--text3)'; msg.textContent='Preparando el env\u00edo\u2026'; }

  try{
    var b64=ecPdfArchivo(cli, _ecCliMovs, r.desde, r.hasta);
    var saldo=0;
    _ecCliMovs.forEach(function(m){ saldo += (Number(m.debito)||0)-(Number(m.credito)||0); });

    var destinos=[mail];
    if(CU && CU.email && destinos.indexOf(CU.email)<0) destinos.push(CU.email);

    var fila={
      para_lista: destinos,
      para_email: destinos[0],
      asunto: 'Estado de cuenta - Kennedy Center Corp',
      cuerpo: 'Buen d\u00eda,\n\nAdjunto su estado de cuenta con Kennedy Center Corp.\n'
             +'Saldo a la fecha: '+fmt(saldo)+'\n\n'
             +'Cualquier diferencia, favor comunicarla a la brevedad.\n\nGracias.',
      adjuntos: [{nombre:_ecsNombre(cli), contenido:b64}],
      estado: 'pendiente',
      cardcode: cli.cardcode,
      docnum: 'ESTCTA-'+String(cli.cardcode||''),
      origen: 'estado_cuenta',
      creado_por: (CU && CU.username) || 'portal'
    };

    var res = (typeof _pvEncolar==='function')
      ? await _pvEncolar(fila)
      : await (async function(){
          var rr=await fetch(SB+'/rest/v1/correos_queue',{
            method:'POST',
            headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=minimal'},
            body: JSON.stringify(fila)
          });
          return rr.ok ? {ok:true} : {ok:false, msg:(await rr.text()).slice(0,200)};
        })();

    if(!res.ok) throw new Error(res.msg||'no se pudo encolar');
    if(msg){
      msg.style.color='var(--green)';
      msg.innerHTML='Correo en cola para <b>'+npEsc(mail)+'</b>. Sale en el pr\u00f3ximo ciclo del sync.';
    }
  }catch(e){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='No se pudo enviar: '+String(e.message||e).slice(0,180); }
  }
}


// ════════════════════════════════════════════════════════════════════
//  DESCARGAR FOTOS EN ALTA DEFINICION
//  Del pedido o la factura, en PDF (una foto por pagina) o en un ZIP
//  con los JPG originales, nombrados por SKU.
// ════════════════════════════════════════════════════════════════════

// ── ZIP sin comprimir, escrito a mano ─────────────────────────────────────
// Un JPG ya viene comprimido, asi que guardarlo "stored" no pierde nada y
// evita cargar una libreria de un CDN, que en esta red suele fallar.
function _crc32(bytes){
  var t=_crc32.tabla;
  if(!t){
    t=_crc32.tabla=new Int32Array(256);
    for(var n=0;n<256;n++){
      var c=n;
      for(var k=0;k<8;k++) c = (c&1) ? (0xEDB88320 ^ (c>>>1)) : (c>>>1);
      t[n]=c;
    }
  }
  var crc=-1;
  for(var i=0;i<bytes.length;i++) crc=(crc>>>8) ^ t[(crc^bytes[i])&0xFF];
  return (crc^-1)>>>0;
}

function _zipCrear(archivos){
  var partes=[], central=[], off=0;
  var enc=new TextEncoder();

  function u16(n){ return [n&0xFF,(n>>8)&0xFF]; }
  function u32(n){ return [n&0xFF,(n>>8)&0xFF,(n>>16)&0xFF,(n>>24)&0xFF]; }

  archivos.forEach(function(f){
    var nom=enc.encode(f.nombre);
    var dat=f.datos;
    var crc=_crc32(dat);
    var cab=[].concat(
      u32(0x04034b50), u16(20), u16(0), u16(0), u16(0), u16(0),
      u32(crc), u32(dat.length), u32(dat.length), u16(nom.length), u16(0));
    partes.push(new Uint8Array(cab), nom, dat);

    central.push({nom:nom, crc:crc, len:dat.length, off:off});
    off += cab.length + nom.length + dat.length;
  });

  var ini=off, cen=[];
  central.forEach(function(c){
    var h=[].concat(
      u32(0x02014b50), u16(20), u16(20), u16(0), u16(0), u16(0), u16(0),
      u32(c.crc), u32(c.len), u32(c.len), u16(c.nom.length),
      u16(0), u16(0), u16(0), u16(0), u32(0), u32(c.off));
    cen.push(new Uint8Array(h), c.nom);
    off += h.length + c.nom.length;
  });

  var fin=new Uint8Array([].concat(
    u32(0x06054b50), u16(0), u16(0),
    u16(central.length), u16(central.length),
    u32(off-ini), u32(ini), u16(0)));

  var todo=partes.concat(cen, [fin]);
  var total=0; todo.forEach(function(p){ total+=p.length; });
  var out=new Uint8Array(total), p=0;
  todo.forEach(function(x){ out.set(x, p); p+=x.length; });
  return out;
}

// ── Descarga de las fotos originales, sin reducir ─────────────────────────
async function _fotosHD(lineas, onProg){
  var res=[], hechos=0;
  var pendientes = lineas.filter(function(l){
    return l.foto_cands ? l.foto_cands.length : !!l.foto_url;
  });

  // De 5 en 5: son archivos grandes y saturar la red no acelera nada.
  var i=0;
  async function uno(){
    while(i < pendientes.length){
      var l = pendientes[i++];
      var cands = l.foto_cands || (l.foto_url ? [l.foto_url] : []);
      var bytes=null, tipo='image/jpeg';
      for(var c=0; c<cands.length && !bytes; c++){
        try{
          var r=await fetch(cands[c], {cache:'force-cache'});
          if(!r.ok) continue;
          var b=await r.blob();
          if(!b.size) continue;
          tipo = b.type || 'image/jpeg';
          bytes = new Uint8Array(await b.arrayBuffer());
        }catch(e){}
      }
      if(bytes) res.push({itemcode:l.itemcode, nombre:l.dscription||'', bytes:bytes, tipo:tipo});
      hechos++;
      if(onProg) onProg(hechos, pendientes.length, res.length);
    }
  }
  await Promise.all([uno(),uno(),uno(),uno(),uno()]);

  // El orden de la descarga es indeterminado: se devuelve como en el documento.
  var pos={}; lineas.forEach(function(l,ix){ pos[l.itemcode]=ix; });
  res.sort(function(a,b){ return (pos[a.itemcode]||0)-(pos[b.itemcode]||0); });
  return res;
}

function _hdNombreBase(){
  var d = (typeof rptDoc!=='undefined' && rptDoc) ? rptDoc : {};
  return (rptTipo==='factura' ? 'Factura-' : 'Pedido-')
    + String(d.docnum||'').replace(/[^A-Za-z0-9_-]/g,'');
}

function _hdBajar(bytes, nombre, tipo){
  var url=URL.createObjectURL(new Blob([bytes],{type:tipo}));
  var a=document.createElement('a'); a.href=url; a.download=nombre;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(function(){ URL.revokeObjectURL(url); }, 6000);
}

// ── Ventana de descarga ───────────────────────────────────────────────────
async function fotosHD(tipo, docnum, esNapa){
  var m=document.createElement('div');
  m.id='hd-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:480px;width:100%;padding:18px">'
    +'<div style="display:flex;align-items:center;gap:10px;margin-bottom:12px">'
      +'<b style="flex:1;font-size:15px">\u{1F5BC} Fotos en alta definici\u00f3n</b>'
      +'<button onclick="document.getElementById(\'hd-modal\').remove()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="hd-body" style="font-size:13px;color:var(--text3)">Leyendo el documento\u2026</div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) m.remove(); });

  try{
    var r=await rptFetch(tipo, docnum, esNapa);
    if(!r || !r.lineas || !r.lineas.length){
      document.getElementById('hd-body').innerHTML='No pude leer las l\u00edneas del documento.';
      return;
    }
    rptTipo=tipo; rptDoc=r.head; rptLineas=r.lineas;

    var conFoto=r.lineas.filter(function(l){
      return l.foto_cands ? l.foto_cands.length : !!l.foto_url;
    });

    document.getElementById('hd-body').innerHTML=
       '<div style="margin-bottom:14px">'
      +'<b style="color:var(--text)">'+r.lineas.length+'</b> art\u00edculo(s) en el documento \u00b7 '
      +'<b style="color:'+(conFoto.length?'var(--green)':'var(--red)')+'">'+conFoto.length+'</b> con foto'
      + (conFoto.length<r.lineas.length
          ? ('<div style="font-size:11.5px;margin-top:4px">Los '+(r.lineas.length-conFoto.length)
             +' sin foto no se incluyen.</div>') : '')
      +'</div>'
      + (conFoto.length
          ? '<div style="display:grid;gap:9px">'
            +'<button class="btn btn-p" onclick="hdPdf()" style="justify-content:flex-start;padding:11px 13px;text-align:left">'
              +'<b>\u{1F4C4} PDF en alta definici\u00f3n</b><br>'
              +'<span style="font-size:11.5px;opacity:.85">Una foto por p\u00e1gina, con SKU y descripci\u00f3n</span></button>'
            +'<button class="btn" onclick="hdZip()" style="justify-content:flex-start;padding:11px 13px;text-align:left">'
              +'<b>\u{1F5C2} ZIP con los JPG originales</b><br>'
              +'<span style="font-size:11.5px;color:var(--text3)">Cada archivo nombrado con su SKU, sin recomprimir</span></button>'
            +'</div>'
          : '<div style="color:var(--amber)">Ning\u00fan art\u00edculo de este documento tiene foto.</div>')
      +'<div id="hd-msg" style="font-size:12.5px;margin-top:12px"></div>';
  }catch(e){
    document.getElementById('hd-body').innerHTML='<span style="color:var(--red)">Error: '
      +npEsc(String(e.message||e).slice(0,170))+'</span>';
  }
}

function _hdProg(hechos, total, ok){
  var m=document.getElementById('hd-msg');
  if(m){
    m.style.color='var(--text3)';
    m.innerHTML='<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:7px"></div>'
      +'Descargando fotos\u2026 '+hechos+' de '+total+(ok<hechos?(' \u00b7 '+(hechos-ok)+' fallaron'):'');
  }
}

async function hdZip(){
  var msg=document.getElementById('hd-msg');
  try{
    var fotos=await _fotosHD(rptLineas, _hdProg);
    if(!fotos.length){ if(msg){ msg.style.color='var(--red)'; msg.textContent='No se pudo descargar ninguna foto.'; } return; }

    var usados={};
    var archivos=fotos.map(function(f){
      var ext = /png/i.test(f.tipo) ? 'png' : (/webp/i.test(f.tipo) ? 'webp' : 'jpg');
      var base=String(f.itemcode||'foto').replace(/[^A-Za-z0-9._-]/g,'_');
      // Un mismo SKU puede repetirse en el documento: se numeran.
      usados[base]=(usados[base]||0)+1;
      var nom = base + (usados[base]>1 ? ('_'+usados[base]) : '') + '.' + ext;
      return {nombre:nom, datos:f.bytes};
    });

    var zip=_zipCrear(archivos);
    _hdBajar(zip, _hdNombreBase()+'-fotos.zip', 'application/zip');
    if(msg){
      msg.style.color='var(--green)';
      msg.textContent=fotos.length+' foto(s) en el ZIP ('+Math.round(zip.length/1048576*10)/10+' MB).';
    }
  }catch(e){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='Error: '+String(e.message||e).slice(0,170); }
  }
}

async function hdPdf(){
  var msg=document.getElementById('hd-msg');
  try{
    var fotos=await _fotosHD(rptLineas, _hdProg);
    if(!fotos.length){ if(msg){ msg.style.color='var(--red)'; msg.textContent='No se pudo descargar ninguna foto.'; } return; }

    if(msg){ msg.style.color='var(--text3)'; msg.textContent='Armando el PDF\u2026'; }

    // Solo JPEG se puede incrustar tal cual (DCTDecode). Lo demas se convierte.
    var listas=[];
    for(var i=0;i<fotos.length;i++){
      var f=fotos[i];
      if(/jpe?g/i.test(f.tipo)){ listas.push(f); continue; }
      try{
        var conv=await _hdAJpeg(f.bytes, f.tipo);
        if(conv) listas.push({itemcode:f.itemcode, nombre:f.nombre, bytes:conv, tipo:'image/jpeg'});
      }catch(e){}
    }
    if(!listas.length){ if(msg){ msg.style.color='var(--red)'; msg.textContent='No pude preparar las im\u00e1genes.'; } return; }

    var W=612, H=792, mx=40;
    var paginas=[], recursos=[];
    var d=rptDoc||{};

    listas.forEach(function(f, ix){
      var bin='';
      var b=f.bytes, paso=0x8000;
      for(var k=0;k<b.length;k+=paso) bin+=String.fromCharCode.apply(null, b.subarray(k,k+paso));
      var b64=btoa(bin);
      var nom='Im'+ix;
      recursos.push({nombre:nom, b64:b64});

      var dim=_jpegDim(atob(b64));
      // Se encaja en el area util respetando la proporcion.
      var maxW=W-mx*2, maxH=H-190;
      var esc=Math.min(maxW/dim.w, maxH/dim.h);
      var w=dim.w*esc, h=dim.h*esc;
      var x=(W-w)/2, y=H-140-h;

      var c='';
      c+=_pdfTexto(mx, H-52, 'KENNEDY CENTER CORP.', 13, true);
      c+=_pdfTexto(mx, H-67, (rptTipo==='factura'?'Factura ':'Pedido ')+String(d.docnum||'')
                   +'   \u00b7   '+String(d.cardname||''), 9, false, '0.4');
      var pag=(ix+1)+' / '+listas.length;
      c+=_pdfTexto(W-mx-_pdfAncho(pag,9), H-67, pag, 9, false, '0.45');
      c+=_pdfLinea(mx, H-76, W-mx, H-76, '0.45');

      c+='q '+w.toFixed(1)+' 0 0 '+h.toFixed(1)+' '+x.toFixed(1)+' '+y.toFixed(1)+' cm /'+nom+' Do Q\n';

      c+=_pdfTexto(mx, y-24, String(f.itemcode||''), 13, true);
      var des=String(f.nombre||'');
      while(_pdfAncho(des,10) > (W-mx*2) && des.length>3) des=des.slice(0,-2);
      c+=_pdfTexto(mx, y-40, des, 10, false, '0.3');

      paginas.push({contenido:c, imagenes:[nom]});
    });

    var b64pdf=_pdfArmar(paginas, W, H, recursos);
    var bin2=atob(b64pdf), arr=new Uint8Array(bin2.length);
    for(var j=0;j<bin2.length;j++) arr[j]=bin2.charCodeAt(j);
    _hdBajar(arr, _hdNombreBase()+'-fotos-HD.pdf', 'application/pdf');

    if(msg){
      msg.style.color='var(--green)';
      msg.textContent=listas.length+' foto(s) en el PDF ('+Math.round(arr.length/1048576*10)/10+' MB).';
    }
  }catch(e){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='Error: '+String(e.message||e).slice(0,170); }
  }
}

// PNG o WEBP a JPEG, para poder incrustarlo en el PDF sin perder resolucion.
function _hdAJpeg(bytes, tipo){
  return new Promise(function(res){
    var url=URL.createObjectURL(new Blob([bytes],{type:tipo}));
    var img=new Image();
    img.onload=function(){
      var c=document.createElement('canvas');
      c.width=img.naturalWidth; c.height=img.naturalHeight;
      var ctx=c.getContext('2d');
      ctx.fillStyle='#fff'; ctx.fillRect(0,0,c.width,c.height);   // por si tiene transparencia
      ctx.drawImage(img,0,0);
      c.toBlob(function(b){
        URL.revokeObjectURL(url);
        if(!b) return res(null);
        b.arrayBuffer().then(function(ab){ res(new Uint8Array(ab)); });
      }, 'image/jpeg', 0.92);
    };
    img.onerror=function(){ URL.revokeObjectURL(url); res(null); };
    img.src=url;
  });
}


// ════════════════════════════════════════════════════════════════════
//  EXPORTAR MERCANCIA POR LLEGAR
//  Mismas caracteristicas a elegir que en Inventario, mas los datos
//  propios del embarque: llegada, proveedor, barco, contenedor.
// ════════════════════════════════════════════════════════════════════

// Columnas propias de este reporte, que no estan en INV_CAMPOS.
// SOLO estas cuatro. El proveedor, el pais de origen, el barco, el numero de
// contenedor y la orden de compra son informacion de compra: estos reportes
// se le mandan al cliente y no debe ver a quien le compramos ni por donde
// viene la mercancia. Si algun dia hacen falta para uso interno, tendrian que
// ir en un reporte aparte que no se comparta.
var PL_EXTRA = [
  {k:'pl_llegada', label:'Fecha de llegada',    def:true},
  {k:'pl_dias',    label:'D\u00edas para llegar', def:false},
  {k:'pl_pend',    label:'Por llegar (uds)',     def:true},
  {k:'pl_bultos',  label:'Bultos',               def:true}
];

function plExpCampos(){
  var c=document.getElementById('pl-campos');
  if(!c || c.dataset.listo) return;
  function casilla(k, label, chk){
    return '<label style="display:flex;align-items:center;gap:7px;font-size:12.5px;cursor:pointer;'
      +'padding:7px 9px;border:1px solid var(--border);border-radius:8px">'
      +'<input type="checkbox" id="plc-'+k+'"'+(chk?' checked':'')+'>'+npEsc(label)+'</label>';
  }
  c.innerHTML =
     '<div style="font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;margin:0 0 6px">Del art\u00edculo</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px">'
    + INV_CAMPOS.map(function(f){ return casilla(f.k, f.label, f.def); }).join('')
    +'</div>'
    +'<div style="font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px;margin:0 0 6px">Del embarque</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
    + PL_EXTRA.map(function(f){ return casilla(f.k, f.label, f.def); }).join('')
    +'</div>';
  c.dataset.listo='1';
}

function plColsArticulo(){
  return INV_CAMPOS.filter(function(f){
    var cb=document.getElementById('plc-'+f.k); return cb && cb.checked;
  });
}
function plColsEmbarque(){
  return PL_EXTRA.filter(function(f){
    var cb=document.getElementById('plc-'+f.k); return cb && cb.checked;
  });
}

// Las filas que se ven ahora mismo, respetando los filtros de la pantalla.
function plFilasVisibles(){
  return (PL_ROWS||[]).filter(function(r){
    if(plDeptF && r.dept!==plDeptF) return false;
    if(plQF){
      var q=plQF.toLowerCase();
      if(String(r.itemcode||'').toLowerCase().indexOf(q)<0 &&
         String(r.itemname||'').toLowerCase().indexOf(q)<0) return false;
    }
    if(plVentanaF){
      var d=_plDias(r.fecha);
      if(plVentanaF==='atrasado' && !(d!==null && d<0)) return false;
      if(plVentanaF==='30' && !(d!==null && d>=0 && d<=30)) return false;
      if(plVentanaF==='60' && !(d!==null && d>30 && d<=60)) return false;
      if(plVentanaF==='90' && !(d!==null && d>60)) return false;
    }
    return true;
  });
}

function _plValor(r, k){
  switch(k){
    case 'pl_llegada':    return r.fecha ? _plFechaLbl(r.fecha) : 'por confirmar';
    case 'pl_dias':       var d=_plDias(r.fecha); return d===null ? '' : d;
    case 'pl_pend':       return Math.round(Number(r.pend)||0);
    case 'pl_bultos':     return Math.round(Number(r.bultos)||0);
    // No hay caso para proveedor, pais, barco, contenedor ni orden de compra:
    // son datos internos y no se exportan.
    default: return '';
  }
}

async function plExportar(tipo){
  var filas=plFilasVisibles();
  if(!filas.length){ alert('No hay mercanc\u00eda que exportar con los filtros actuales.'); return; }

  var colsArt=plColsArticulo(), colsEmb=plColsEmbarque();
  if(!colsArt.length && !colsEmb.length){ alert('Marca al menos una caracter\u00edstica.'); return; }

  var info=document.getElementById('pl-export-info');
  if(info){ info.style.color='var(--blue2)'; info.textContent='Preparando '+filas.length+' l\u00ednea(s)\u2026'; }

  try{
    // Los datos del articulo salen del catalogo; los del embarque, de aqui.
    var codes=[], v={};
    filas.forEach(function(r){ if(!v[r.itemcode]){ v[r.itemcode]=1; codes.push(r.itemcode); } });
    var datos = colsArt.length ? await invExportFetch({p_itemcodes:codes, p_orden:'sku'}) : [];
    var lineas = colsArt.length ? await invEnrich(datos) : [];

    // Un articulo puede venir en varias ordenes de compra: manda la fila del
    // reporte, no el catalogo, para no perder embarques.
    var porCode={};
    lineas.forEach(function(l){ porCode[l.itemcode]=l; });

    var salida = filas.map(function(r){
      var base = porCode[r.itemcode] || {itemcode:r.itemcode, dscription:r.itemname};
      var o = Object.assign({}, base);
      o.__pl = r;
      return o;
    });

    if(tipo==='excel') await plExcel(salida, colsArt, colsEmb);
    else               await plPdf(salida, colsArt, colsEmb);

    if(info) info.textContent='';
  }catch(e){
    if(info){ info.style.color='var(--red)'; info.textContent='Error: '+String(e.message||e).slice(0,160); }
  }
}

async function plExcel(lineas, colsArt, colsEmb){
  var hayFoto=colsArt.some(function(c){ return c.k==='foto'; });
  var columns=[{label:'Descripcion', key:'__desc', width:44}]
    .concat(colsArt.map(function(c){
      return {label:c.label, key:c.k, width:(c.k==='foto'?9:(c.k==='sku'?16:12)),
              numFmt:(c.k==='precio'?'0.00':undefined)};
    }))
    .concat(colsEmb.map(function(c){
      return {label:c.label, key:c.k, width:14};
    }));

  var buf=await xlsxExport({
    devolver:true,
    filename:'mercancia-por-llegar.xlsx',
    titulo:'KENNEDY CENTER CORP. - MERCANCIA POR LLEGAR',
    subtitulo:new Date().toLocaleDateString('es-PA')+'  -  '+lineas.length+' l\u00ednea(s)',
    columns:columns, rows:lineas, fotoKey:(hayFoto?'foto':null),
    fotoUrlFn:function(l){ return l.foto_url||''; },
    fotoCandsFn:function(l){ return l.foto_cands||(l.foto_url?[l.foto_url]:[]); },
    valueFn:function(l,k){
      if(k.indexOf('pl_')===0) return _plValor(l.__pl||{}, k);
      if(k==='__desc') return l.dscription||l.itemname||'';
      return _invXlsxVal(l,k);
    }
  });

  var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var a=document.createElement('a'); a.href=URL.createObjectURL(blob);
  a.download='mercancia-por-llegar.xlsx';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(function(){ URL.revokeObjectURL(a.href); }, 5000);
}

async function plPdf(lineas, colsArt, colsEmb){
  var hayFoto=colsArt.some(function(c){ return c.k==='foto'; });
  var campos=colsArt.filter(function(c){ return c.k!=='foto'; });

  var imgs={};
  if(hayFoto){
    try{
      var cf=_calidadFoto(lineas.length);
      var th=await _fetchThumbPool(
        lineas.map(function(l){ return l.foto_cands||(l.foto_url?[l.foto_url]:[]); }),
        Math.min(cf.px,120), 0.62);
      lineas.forEach(function(l){
        var d=th[l.foto_url] || (l.foto_cands && th[l.foto_cands[0]]);
        if(d && /^data:image\/jpe?g;base64,/.test(d)) imgs[l.itemcode]=d.split(',')[1];
      });
    }catch(e){}
  }

  // Ancho por columna segun lo que ocupa de verdad. Antes se repartia el
  // sobrante por igual entre todas, y al elegir muchas caracteristicas no
  // cabian: se montaban unas sobre otras.
  var ANCHOS = {
    sku:52, barcode:62, precio:38, stock:36, disponible:40, packing:32, peso:34,
    marca:70, tipo:52, tamano:66, cubicaje:38, color:44, composicion:88,
    pl_llegada:52, pl_dias:32, pl_pend:42, pl_bultos:34
  };
  function anchoDe(k){ return ANCHOS[k] || 46; }

  var todasCols = campos.concat(colsEmb);
  var necesario = todasCols.reduce(function(t,c){ return t + anchoDe(c.k); }, 0);

  // Si con todo lo elegido no cabe en vertical, se pasa a apaisado; y si aun
  // asi no cabe, se encoge la descripcion antes que solapar nada.
  var W=612, H=792, mx=32;
  var hayFotoW = hayFoto?34:0;
  var minDesc = 90;
  var anchoFijo = hayFotoW + 70 + 6;             // foto + SKU + margen interno
  if(necesario + anchoFijo + minDesc > (W - mx*2)){
    W=792; H=612; mx=28;
  }

  var altoFila = hayFoto ? 32 : 14;
  var xFoto=mx, wFoto=hayFoto?28:0;
  var xSku=mx+hayFotoW;
  var xDesc=xSku+70;
  var wDesc=Math.max(minDesc, (W-mx) - xDesc - necesario - 6);
  var xCols=xDesc+wDesc+6;

  // Ultimo recurso: si ni en apaisado caben todas (marcando las 12 del
  // articulo mas las 4 del embarque hacen falta ~1000 pt y solo hay 764),
  // se encogen todas en proporcion. Se lee mas apretado, pero NADA se monta
  // encima de nada, que era el problema.
  var disponible = (W-mx) - xCols;
  var factor = (necesario > disponible && necesario > 0) ? (disponible/necesario) : 1;
  if(factor < 1){
    // Con muchas columnas conviene bajar tambien el tamano de letra.
    var _fs = factor < 0.72 ? 5.5 : 6.5;
    todasCols.__fs = _fs;
  }
  function anchoFinal(k){ return anchoDe(k)*factor; }

  var libre = disponible - necesario*factor;
  var extra = (libre > 0 && todasCols.length) ? (libre/todasCols.length) : 0;
  var FS = todasCols.__fs || 6.5;

  var porPagina=Math.floor((H-120)/altoFila);
  var paginas=[], recursos=[];

  for(var p0=0;p0<lineas.length;p0+=porPagina){
    var trozo=lineas.slice(p0,p0+porPagina);
    var c='', y=H-44, usadas=[];

    c+=_pdfTexto(mx, y, 'KENNEDY CENTER CORP.', 13, true); y-=13;
    c+=_pdfTexto(mx, y, 'MERCANCIA POR LLEGAR', 10.5, true);
    var der='Pag. '+(paginas.length+1)+' de '+Math.ceil(lineas.length/porPagina);
    c+=_pdfTexto(W-mx-_pdfAncho(der,9), y, der, 9, false, '0.45'); y-=12;
    c+=_pdfTexto(mx, y, new Date().toLocaleDateString('es-PA')+'   \u00b7   '+lineas.length+' l\u00ednea(s)', 8.5, false, '0.4');
    y-=10;
    c+=_pdfLinea(mx, y, W-mx, y, '0.42'); y-=14;

    c+=_pdfCaja(mx-3, y-5, W-mx*2+6, 14, '0.93');
    if(hayFoto) c+=_pdfTexto(xFoto, y, 'FOTO', 7, true);
    c+=_pdfTexto(xSku, y, 'SKU', 7, true);
    c+=_pdfTexto(xDesc, y, 'DESCRIPCION', 7, true);
    var xh=xCols;
    todasCols.forEach(function(cc){
      var w=anchoFinal(cc.k)+extra;
      // El titulo se recorta al ancho real de SU columna, no a un numero fijo.
      var et=String(cc.label).toUpperCase();
      var fsT=Math.min(7, FS+0.5);
      while(_pdfAncho(et,fsT) > w-3 && et.length>2) et=et.slice(0,-1);
      c+=_pdfTexto(xh, y, et, fsT, true);
      xh+=w;
    });
    y-=altoFila;

    trozo.forEach(function(l, idx){
      if((p0+idx)%2===1) c+=_pdfCaja(mx-3, y-4, W-mx*2+6, altoFila-1, '0.975');
      var yt = hayFoto ? (y+altoFila-15) : y;

      if(hayFoto && imgs[l.itemcode]){
        var nom='Im'+recursos.length;
        recursos.push({nombre:nom, b64:imgs[l.itemcode]});
        usadas.push(nom);
        c+='q '+wFoto+' 0 0 '+(altoFila-6)+' '+xFoto+' '+(y-2)+' cm /'+nom+' Do Q\n';
      }

      c+=_pdfTexto(xSku, yt, String(l.itemcode||''), 7, true);
      var des=String(l.dscription||l.itemname||'');
      while(_pdfAncho(des,6.5) > wDesc && des.length>3) des=des.slice(0,-2);
      c+=_pdfTexto(xDesc, yt, des, 6.5);

      var x2=xCols;
      todasCols.forEach(function(cc){
        var esEmb = cc.k.indexOf('pl_')===0;
        var v = esEmb ? _plValor(l.__pl||{}, cc.k) : _invXlsxVal(l, cc.k);
        v = (v==null?'':String(v));
        var w = anchoFinal(cc.k)+extra;
        while(_pdfAncho(v,FS) > w-3 && v.length>2) v=v.slice(0,-1);
        c+=_pdfTexto(x2, yt, v, FS, cc.k==='pl_llegada');
        x2+=w;
      });
      y-=altoFila;
    });

    if(p0+porPagina >= lineas.length){
      var tu=0, tb=0;
      lineas.forEach(function(l){
        tu += Number((l.__pl||{}).pend)||0;
        tb += Number((l.__pl||{}).bultos)||0;
      });
      y-=4;
      c+=_pdfLinea(mx, y+9, W-mx, y+9, '0.42');
      c+=_pdfTexto(xSku, y-3, 'TOTALES  \u00b7  '+lineas.length+' l\u00ednea(s)  \u00b7  '
        +fmtN(Math.round(tu))+' unidades  \u00b7  '+fmtN(Math.round(tb))+' bultos', 8.5, true);
    }
    paginas.push({contenido:c, imagenes:usadas});
  }

  var b64=_pdfArmar(paginas, W, H, recursos);
  var bin=atob(b64), arr=new Uint8Array(bin.length);
  for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
  var url=URL.createObjectURL(new Blob([arr],{type:'application/pdf'}));
  var a=document.createElement('a'); a.href=url; a.download='mercancia-por-llegar.pdf';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(function(){ URL.revokeObjectURL(url); }, 5000);
}


// ════════════════════════════════════════════════════════════════════
//  REPORTE DE VENTAS POR VENDEDOR
//  En el dashboard. Ventas del año en curso mes a mes; al elegir un mes,
//  el detalle de las facturas de ese mes con acceso a cada una.
//
//  Un vendedor ve SOLO lo suyo; el administrador ve a todos y puede
//  filtrar por vendedor.
// ════════════════════════════════════════════════════════════════════
var RV_ANIO = new Date().getFullYear();
var RV_MES = '';          // '' = todo el año
var RV_VEND = '';         // solo el administrador puede cambiarlo
var RV_MESES = null;      // {mes: {monto, facturas}}
var RV_CARGANDO = false;

var RV_NOMBRE_MES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                     'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

function rvEsAdmin(){
  return !!(CU && String(CU.rol||'').toLowerCase()==='admin');
}
function rvPuedeVer(){
  var r = String((CU&&CU.rol)||'').toLowerCase();
  return r==='admin' || r==='vendedor';
}

// El vendedor queda fijado a su propio codigo: no es solo que no se le
// muestre el selector, es que su slpcode se impone en la consulta.
function rvSlpcode(){
  if(rvEsAdmin()) return RV_VEND || '';
  return (CU && CU.slpcode!=null) ? String(CU.slpcode) : '__sin_codigo__';
}

function rvInit(){
  var card=document.getElementById('rv-card');
  if(!card) return;
  if(!rvPuedeVer()){ card.style.display='none'; return; }
  card.style.display='';
  RV_ANIO=new Date().getFullYear(); RV_MES='';
  rvControles();
  rvCargarAnio();
}

function rvControles(){
  var c=document.getElementById('rv-ctrl'); if(!c) return;
  var anios=[];
  for(var a=new Date().getFullYear(); a>=new Date().getFullYear()-4; a--) anios.push(a);

  c.innerHTML =
     '<select onchange="rvAnio(this.value)" style="padding:5px 9px;border:1px solid var(--border);border-radius:8px;font-size:12px;background:var(--surface);color:var(--text)">'
    + anios.map(function(a){ return '<option value="'+a+'"'+(a===RV_ANIO?' selected':'')+'>'+a+'</option>'; }).join('')
    + '</select>'
    + (rvEsAdmin()
        ? '<select id="rv-vend" onchange="rvVend(this.value)" style="padding:5px 9px;border:1px solid var(--border);border-radius:8px;font-size:12px;background:var(--surface);color:var(--text);max-width:180px">'
          +'<option value="">Todos los vendedores</option></select>'
        : '');
  if(rvEsAdmin()) rvCargarVendedores();
}

async function rvCargarVendedores(){
  var sel=document.getElementById('rv-vend'); if(!sel || sel.dataset.listo) return;
  try{
    var v=await q('vendedores','select=slpcode,slpname&order=slpname');
    var vistos={}, ops='<option value="">Todos los vendedores</option>';
    (v||[]).forEach(function(x){
      if(x.slpcode==null || vistos[x.slpcode]) return;
      // Los dados de baja llevan Z- delante; no hace falta ofrecerlos.
      if(/^Z-/i.test(String(x.slpname||''))) return;
      vistos[x.slpcode]=1;
      ops+='<option value="'+x.slpcode+'">'+npEsc(x.slpname||('Vendedor '+x.slpcode))+'</option>';
    });
    sel.innerHTML=ops; sel.value=RV_VEND; sel.dataset.listo='1';
  }catch(e){}
}

function rvAnio(a){ RV_ANIO=parseInt(a,10)||new Date().getFullYear(); RV_MES=''; rvCargarAnio(); }
function rvVend(v){ RV_VEND=v||''; RV_MES=''; rvCargarAnio(); }
function rvMes(m){ RV_MES=(String(RV_MES)===String(m)) ? '' : String(m); rvPintar(); }

// Los doce meses del año. Se piden solo las cabeceras de factura (linenum 0
// o 1) para no traer una fila por linea: con miles de facturas seria enorme.
async function rvCargarAnio(){
  var body=document.getElementById('rv-body'); if(!body || RV_CARGANDO) return;
  RV_CARGANDO=true;
  body.innerHTML='<div class="loading"><div class="spinner"></div> Cargando ventas de '+RV_ANIO+'...</div>';
  try{
    var slp=rvSlpcode();
    if(slp==='__sin_codigo__'){
      body.innerHTML='<div style="padding:18px;color:var(--text3);font-size:13px">'
        +'Tu usuario no tiene c\u00f3digo de vendedor asignado, as\u00ed que no puedo '
        +'mostrar tus ventas. Pide que te asignen el c\u00f3digo de SAP.</div>';
      RV_CARGANDO=false; return;
    }
    // Se suman los LINETOTAL de todas las lineas y se restan las devoluciones,
    // igual que la vista ventas_comparativo del Dashboard. Antes tomaba el
    // doctotal de una sola linea, que incluye impuestos y flete y no descuenta
    // devoluciones: para agosto daba 862,447 en vez de 791,435.
    var f='select=docnum,docdate,cardcode,cardname,doctotal,linetotal,slpcode,nombrevendedor'
      +'&docdate=gte.'+RV_ANIO+'-01-01&docdate=lte.'+RV_ANIO+'-12-31';
    if(slp) f+='&slpcode=eq.'+encodeURIComponent(slp);

    var filas=await qAll('facturas', f);

    var docs={};
    (filas||[]).forEach(function(x){
      var k=String(x.docnum);
      if(!docs[k]){
        docs[k]=Object.assign({}, x);
        docs[k].doctotal=Number(x.doctotal)||0;
        docs[k].monto=0;
      }
      docs[k].monto += Number(x.linetotal)||0;   // la venta real
    });

    // Devoluciones del mismo periodo, en negativo.
    try{
      var fd='select=*&docdate=gte.'+RV_ANIO+'-01-01&docdate=lte.'+RV_ANIO+'-12-31';
      if(slp) fd+='&slpcode=eq.'+encodeURIComponent(slp);
      var devs=await qAll('devoluciones', fd);
      (devs||[]).forEach(function(x){
        var k='DEV-'+x.docnum;
        if(!docs[k]){
          docs[k]=Object.assign({}, x);
          docs[k].monto=0; docs[k].esDevolucion=true;
        }
        docs[k].monto -= Number(x.linetotal)||0;
      });
    }catch(e){ console.warn('[rv] no pude leer devoluciones:', e); }

    var meses={};
    for(var m=0;m<12;m++) meses[m]={monto:0, n:0, facturas:[]};
    Object.keys(docs).forEach(function(k){
      var d=docs[k];
      var mm=parseInt(String(d.docdate||'').substring(5,7),10)-1;
      if(mm<0 || mm>11) return;
      meses[mm].monto += Number(d.monto)||0;
      if(!d.esDevolucion) meses[mm].n++;   // una devolucion no es una factura
      meses[mm].facturas.push(d);
    });
    RV_MESES=meses;
    rvPintar();
  }catch(e){
    body.innerHTML='<div style="padding:16px;color:var(--red);font-size:13px">No se pudo cargar: '
      +npEsc(String(e.message||e).slice(0,160))+'</div>';
  }finally{ RV_CARGANDO=false; }
}

function rvPintar(){
  var body=document.getElementById('rv-body'); if(!body || !RV_MESES) return;

  var total=0, nTot=0, tope=0;
  for(var m=0;m<12;m++){
    total+=RV_MESES[m].monto; nTot+=RV_MESES[m].n;
    if(RV_MESES[m].monto>tope) tope=RV_MESES[m].monto;
  }

  var quien = rvEsAdmin()
    ? (RV_VEND ? ((document.getElementById('rv-vend')||{}).selectedOptions
                  ? document.getElementById('rv-vend').selectedOptions[0].textContent
                  : RV_VEND)
               : 'todos los vendedores')
    : ((CU && CU.nombre) || (CU && CU.username) || 'mis ventas');

  var mesActual=new Date().getMonth(), anioActual=new Date().getFullYear();

  var barras = '';
  for(var i=0;i<12;i++){
    var d=RV_MESES[i];
    var pct = tope>0 ? (d.monto/tope*100) : 0;
    var sel = String(RV_MES)===String(i);
    var futuro = (RV_ANIO===anioActual && i>mesActual);
    barras +=
       '<div onclick="'+(d.n?('rvMes('+i+')'):'')+'" style="display:flex;align-items:center;gap:9px;'
      +'padding:5px 8px;border-radius:8px;'+(d.n?'cursor:pointer;':'opacity:.5;')
      +(sel?'background:var(--blue-bg,#EFF6FF);':'')+'">'
      +'<span style="flex:0 0 74px;font-size:12px'+(sel?';font-weight:700':'')+'">'+RV_NOMBRE_MES[i]+'</span>'
      +'<span style="flex:1;height:9px;background:var(--surface2,#F1F2F4);border-radius:5px;overflow:hidden;min-width:50px">'
        +'<span style="display:block;height:100%;width:'+pct+'%;background:'+(sel?'var(--blue2,#2563EB)':'#93C5FD')+';border-radius:5px"></span></span>'
      +'<span style="flex:0 0 96px;text-align:right;font-size:12.5px;font-weight:600">'
        +(d.monto?fmt(d.monto):(futuro?'':'—'))+'</span>'
      +'<span style="flex:0 0 54px;text-align:right;font-size:11px;color:var(--text3)">'
        +(d.n?(d.n+' fact.'):'')+'</span>'
      +'</div>';
  }

  var detalle='';
  if(RV_MES!=='' && RV_MESES[RV_MES]){
    var d=RV_MESES[RV_MES];
    var facts=d.facturas.slice().sort(function(a,b){
      return String(b.docdate||'').localeCompare(String(a.docdate||''));
    });
    detalle =
       '<div style="margin-top:14px;border-top:1px solid var(--border);padding-top:12px">'
      +'<div style="display:flex;align-items:center;gap:9px;margin-bottom:9px;flex-wrap:wrap">'
        +'<b style="font-size:13.5px">'+RV_NOMBRE_MES[RV_MES]+' '+RV_ANIO+'</b>'
        +'<span style="font-size:12px;color:var(--text3)">'+d.n+' factura(s)</span>'
        +'<span style="margin-left:auto;font-size:15px;font-weight:800;color:var(--blue2)">'+fmt(d.monto)+'</span>'
      +'</div>'
      +'<div style="overflow-x:auto;max-height:340px"><table class="tbl">'
      +'<tr><th>Factura</th><th>Fecha</th><th>Cliente</th>'
      +(rvEsAdmin()&&!RV_VEND?'<th>Vendedor</th>':'')
      +'<th style="text-align:right">Total</th></tr>'
      + facts.map(function(f){
          // Se muestra el monto (lineas), no el doctotal: asi las filas suman
          // el total del mes. Las devoluciones van en rojo y en negativo.
          var m = (f.monto!=null ? f.monto : f.doctotal);
          return '<tr'+(f.esDevolucion?'':' style="cursor:pointer" onclick="verFactura('+f.docnum+')"')+'>'
            +'<td>'+(f.esDevolucion
                ? ('<span style="color:var(--red)">\u21a9 '+npEsc(String(f.docnum))+'</span>')
                : ('<b style="color:var(--blue2);text-decoration:underline">'+npEsc(String(f.docnum))+'</b>'))+'</td>'
            +'<td style="white-space:nowrap">'+_plFechaLbl(String(f.docdate||'').substring(0,10))+'</td>'
            +'<td>'+npEsc(String(f.cardname||'').substring(0,42))
              +(f.esDevolucion?' <span style="background:#FEE2E2;color:#991B1B;padding:1px 6px;border-radius:8px;font-size:10px;font-weight:700">devoluci\u00f3n</span>':'')
              +'</td>'
            +(rvEsAdmin()&&!RV_VEND?('<td style="font-size:11.5px;color:var(--text3)">'+npEsc(f.nombrevendedor||'')+'</td>'):'')
            +'<td style="text-align:right;font-weight:600'+(m<0?';color:var(--red)':'')+'">'+fmt(m)+'</td></tr>';
        }).join('')
      +'</table></div></div>';
  }

  body.innerHTML =
     '<div style="display:flex;gap:20px;flex-wrap:wrap;margin-bottom:12px;align-items:baseline">'
      +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Total '+RV_ANIO+'</div>'
        +'<div style="font-size:22px;font-weight:800">'+fmt(total)+'</div></div>'
      +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Facturas</div>'
        +'<div style="font-size:17px;font-weight:700">'+fmtN(nTot)+'</div></div>'
      +'<div style="font-size:12px;color:var(--text3);align-self:center">'+npEsc(quien)+'</div>'
    +'</div>'
    + (nTot
        ? (barras
           + '<div style="font-size:11.5px;color:var(--text3);margin-top:8px">Pulsa un mes para ver sus facturas.</div>'
           + detalle)
        : '<div style="padding:18px;text-align:center;color:var(--text3);font-size:13px">Sin ventas registradas en '+RV_ANIO+'.</div>');
}


// ════════════════════════════════════════════════════════════════════
//  REPORTE DE VENTAS POR VENDEDOR
//  Ventas del ano en curso, mes a mes. Al pulsar un mes salen las
//  facturas de ese periodo con acceso al detalle.
//
//  Quien ve que: un vendedor solo lo suyo (su slpcode); el
//  administrador puede ver todos o filtrar por uno. Los clientes no
//  entran aqui.
// ════════════════════════════════════════════════════════════════════
// ── Ventas compartidas ────────────────────────────────────────────────────
// En SAP hay codigos de vendedor combinados: LEO/LIRAN, TAMARA/HENRY,
// KABASSO/SHACALO. Esas ventas son de dos personas y cuentan al 50% para cada
// una. Se resuelve por el NOMBRE, partiendo por la barra: el slpcode del
// combinado no guarda ninguna relacion con los individuales.
var RVV_VENDS = [];       // [{slpcode, slpname}]
var RVV_PARTES = {};      // slpcode -> ['LEO','LIRAN']

function _rvvNorm(t){
  return String(t||'').trim().toUpperCase().replace(/\s+/g,' ').replace(/^Z-/,'');
}
function _rvvPartes(nombre){
  return _rvvNorm(nombre).split('/').map(function(x){ return x.trim(); }).filter(Boolean);
}

// Cuanto de una venta con ESE slpcode le toca al vendedor indicado:
// 1 si es suya entera, 0.5 si la comparte con otro, 0 si no es suya.
function rvvFactor(slpcodeVenta, nombreMio){
  var partes = RVV_PARTES[String(slpcodeVenta)];
  if(!partes || !partes.length) return 0;
  var mio = _rvvNorm(nombreMio);
  if(partes.length===1) return partes[0]===mio ? 1 : 0;
  return partes.indexOf(mio)>=0 ? (1/partes.length) : 0;
}

// Los slpcode en los que aparece un vendedor, solo o compartido.
function rvvCodigosDe(nombreMio){
  var mio=_rvvNorm(nombreMio), solos=[], comp=[];
  Object.keys(RVV_PARTES).forEach(function(cod){
    var p=RVV_PARTES[cod];
    if(p.indexOf(mio)<0) return;
    if(p.length===1) solos.push(cod); else comp.push(cod);
  });
  return {solos:solos, compartidos:comp, todos:solos.concat(comp)};
}

var RVV_ANIO = new Date().getFullYear();
var RVV_VEND = '';        // slpcode elegido ('' = todos, solo admin)
var RVV_MES  = null;      // 1..12, o null para el resumen
var RVV_MESES = [], RVV_FACTS = [], RVV_CARGANDO = false;

var RVV_NOMBRE_MES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                      'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

/* ── Reparto por departamento ──────────────────────────────────────────
   Un pastel con el peso de cada departamento sobre el TOTAL vendido por el
   vendedor en el año. No por cliente: es la foto completa.

   La suma la hace la BASE, no el navegador. Antes se bajaban todas las
   lineas de factura del año y se sumaban aqui; por eso en SAP era
   instantaneo y aqui no. Ahora llegan doce filas ya sumadas.

   Necesita la funcion `ventas_por_depto` (ventas-depto.sql).
   ────────────────────────────────────────────────────────────────────── */
// Dos pasteles: el del AÑO en el resumen, y el del MES al pulsar un mes.
// Cada uno con su estado, porque se piden por separado y en momentos
// distintos; compartirlos haria que uno pisara al otro.
var RVV_DEP={
  anio:{datos:[], cargando:false, error:'', clave:''},
  mes :{datos:[], cargando:false, error:'', clave:''}
};

var RVV_DEPTO_COLS=['#4F46E5','#0EA5E9','#10B981','#F59E0B','#EF4444','#8B5CF6',
                    '#14B8A6','#EC4899','#84CC16','#F97316','#06B6D4','#64748B'];

// El nombre del vendedor elegido, tal como aparece en SAP.
function rvvDeptoNombre(){
  if(!RVV_VEND) return '';
  var nom='';
  try{
    var sel=document.getElementById('rvv-vend');
    if(sel && sel.selectedOptions && sel.selectedOptions.length
       && sel.value===String(RVV_VEND)){
      var op=sel.selectedOptions[0];
      nom=(op.getAttribute('data-nom') || op.textContent || '').trim();
    } else if(!rvvEsAdmin()){
      nom=String((CU && (CU.nombre || CU.username)) || '');
    }
  }catch(e){}
  return nom;
}

// Que fraccion de cada codigo le toca. Es el MISMO calculo que usa el
// reporte, para que el pastel y el gran total no puedan discrepar: antes el
// pastel contaba enteras las facturas compartidas y el reporte las partia.
function rvvDeptoFactores(codes){
  var nom = rvvDeptoNombre();
  return (codes||[]).map(function(c){
    try{ return nom ? rvvFactor(c, nom) : 1; }catch(e){ return 1; }
  });
}

// Los codigos del vendedor elegido, incluidos los compartidos.
function rvvDeptoCodigos(){
  if(!RVV_VEND) return null;
  var nom='';
  try{
    var sel=document.getElementById('rvv-vend');
    if(sel && sel.selectedOptions && sel.selectedOptions.length
       && sel.value===String(RVV_VEND)){
      var op=sel.selectedOptions[0];
      nom=(op.getAttribute('data-nom') || op.textContent || '').trim();
    } else if(!rvvEsAdmin()){
      nom=String((CU && (CU.nombre || CU.username)) || '');
    }
  }catch(e){}
  var cods = nom ? rvvCodigosDe(nom).todos : [String(RVV_VEND)];
  if(!cods.length) cods=[String(RVV_VEND)];
  return cods.map(function(c){ return parseInt(c,10); })
             .filter(function(n){ return !isNaN(n); });
}

// `mes` null = el año entero.
async function rvvDeptos(mes){
  var cual = mes ? 'mes' : 'anio';
  var st   = RVV_DEP[cual];
  var clave=String(RVV_ANIO)+'|'+String(RVV_VEND||'')+'|'+String(mes||'');
  if(st.cargando || st.clave===clave) return;
  st.cargando=true; st.error='';
  rvvRepintar(cual);
  try{
    var r=await fetch(SB+'/rest/v1/rpc/ventas_por_depto',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
               'Content-Type':'application/json'},
      body:(function(){
        var _c = rvvDeptoCodigos();
        return JSON.stringify({p_anio:RVV_ANIO, p_slpcodes:_c,
                               p_mes: mes || null,
                               p_factores: _c ? rvvDeptoFactores(_c) : null});
      })()
    });
    var txt=await r.text();
    if(!r.ok) throw new Error(txt.slice(0,160));
    st.datos=(JSON.parse(txt)||[]).map(function(x){
      return {grupo:String(x.grupo||'Sin departamento'), monto:Number(x.monto)||0};
    }).filter(function(x){ return x.monto>0; });
    st.clave=clave;
  }catch(e){
    st.datos=[];
    st.error=String((e&&e.message)||e);
  }finally{
    st.cargando=false;
  }
  rvvRepintar(cual);
}

// Repinta solo lo que corresponde: el resumen lleva el del año y el detalle
// mensual el del mes.
function rvvRepintar(cual){
  try{
    if(cual==='mes') rvvRenderMes(); else rvvRenderResumen();
  }catch(e){}
}

// El pastel, en SVG. Se dibuja con arcos: un circulo por sectores.
function rvvPastel(datos, total){
  var R=78, C=92, svg='', ang=-Math.PI/2;   // arranca arriba
  if(datos.length===1){
    // Un solo departamento: un arco de 360 grados no se dibuja, hace falta
    // un circulo entero.
    return '<circle cx="'+C+'" cy="'+C+'" r="'+R+'" fill="'+RVV_DEPTO_COLS[0]+'"/>';
  }
  datos.forEach(function(d,i){
    var frac=d.monto/total, barre=frac*2*Math.PI;
    var x1=C+R*Math.cos(ang), y1=C+R*Math.sin(ang);
    ang+=barre;
    var x2=C+R*Math.cos(ang), y2=C+R*Math.sin(ang);
    svg+='<path d="M '+C+' '+C+' L '+x1.toFixed(2)+' '+y1.toFixed(2)
      +' A '+R+' '+R+' 0 '+(barre>Math.PI?1:0)+' 1 '
      +x2.toFixed(2)+' '+y2.toFixed(2)+' Z" fill="'+RVV_DEPTO_COLS[i%RVV_DEPTO_COLS.length]
      +'" stroke="var(--surface,#fff)" stroke-width="1.5">'
      +'<title>'+npEsc(d.grupo)+': '+fmt(d.monto)+' ('+(frac*100).toFixed(2)+'%)</title>'
      +'</path>';
  });
  return svg;
}

function rvvDeptoPanel(cual, titulo){
  cual=cual||'anio';
  var st=RVV_DEP[cual]||{datos:[],cargando:false,error:''};
  var RVV_DEPTO_CARGANDO=st.cargando, RVV_DEPTO_ERROR=st.error, RVV_DEPTOS=st.datos;
  if(RVV_DEPTO_CARGANDO){
    return '<div class="card" style="margin-top:12px;padding:16px;color:var(--text3);'
      +'font-size:12.5px">Calculando el reparto por departamento\u2026</div>';
  }
  if(RVV_DEPTO_ERROR){
    return '<div class="card" style="margin-top:12px;padding:14px;font-size:12.5px;'
      +'color:var(--red)"><b>No se pudo calcular el reparto por departamento.</b><br>'
      +npEsc(RVV_DEPTO_ERROR)+'<br><span style="color:var(--text3)">'
      +'Si dice que no existe <code>ventas_por_depto</code>, falta correr '
      +'<b>ventas-depto.sql</b> en Supabase.</span></div>';
  }
  if(!RVV_DEPTOS.length) return '';
  var tot=RVV_DEPTOS.reduce(function(a,d){ return a+d.monto; },0);
  if(tot<=0.005) return '';

  var h='<div class="card" style="margin-top:12px">';
  h+='<div style="font-size:14px;font-weight:700;margin-bottom:3px">'
    +'Reparto por departamento'+(titulo?(' \u00b7 '+npEsc(titulo)):'')+'</div>';
  h+='<div style="font-size:12px;color:var(--text3);margin-bottom:14px">'
    +'De los '+fmt(tot)+' vendidos, cu\u00e1nto fue de cada departamento.</div>';

  h+='<div style="display:flex;gap:26px;align-items:center;flex-wrap:wrap">';

  // El pastel
  h+='<svg viewBox="0 0 184 184" style="width:184px;height:184px;flex:0 0 auto">'
    + rvvPastel(RVV_DEPTOS, tot) + '</svg>';

  // La leyenda
  h+='<div style="flex:1;min-width:260px"><table class="tbl" style="margin:0">'
    +'<tr><th>Departamento</th><th style="text-align:right">Monto</th>'
    +'<th style="text-align:right">%</th></tr>';
  RVV_DEPTOS.forEach(function(d,i){
    var p=d.monto/tot*100;
    h+='<tr><td><span style="display:inline-block;width:11px;height:11px;border-radius:3px;'
      +'margin-right:8px;vertical-align:-1px;background:'
      +RVV_DEPTO_COLS[i%RVV_DEPTO_COLS.length]+'"></span>'+npEsc(d.grupo)+'</td>'
      +'<td style="text-align:right;font-weight:600">'+fmt(d.monto)+'</td>'
      +'<td style="text-align:right;font-weight:700">'+p.toFixed(2)+' %</td></tr>';
  });
  h+='<tr style="font-weight:700;border-top:2px solid var(--border)">'
    +'<td>TOTAL</td><td style="text-align:right">'+fmt(tot)+'</td>'
    +'<td style="text-align:right">100.00 %</td></tr>';
  h+='</table></div></div></div>';
  return h;
}

function rvvEsAdmin(){ return CU && String(CU.rol||'').toLowerCase()==='admin'; }

function rvvInit(){
  var box=document.getElementById('page-ventas_vendedor'); if(!box) return;
  // Se vacia siempre al entrar: si no, al volver quedaria el contenido del
  // render anterior debajo del nuevo.
  box.innerHTML='';

  // Un cliente no tiene nada que hacer aqui.
  if(CU && CU.rol==='cliente'){
    box.innerHTML='<div class="card" style="padding:26px;text-align:center;color:var(--text3)">'
      +'Este reporte es solo para el personal de Kennedy Center.</div>';
    return;
  }

  // Un vendedor sin slpcode no puede filtrar por si mismo: se avisa en vez
  // de mostrarle las ventas de todos.
  if(!rvvEsAdmin() && (CU.slpcode==null || CU.slpcode==='')){
    box.innerHTML='<div class="card" style="padding:26px;text-align:center;color:var(--amber)">'
      +'Tu usuario no tiene c\u00f3digo de vendedor asignado, as\u00ed que no puedo mostrar tus ventas.<br>'
      +'<span style="font-size:12.5px;color:var(--text3)">Pide que te asignen el c\u00f3digo en el portal.</span></div>';
    return;
  }

  if(!rvvEsAdmin()) RVV_VEND = String(CU.slpcode);

  box.innerHTML =
     '<div class="card" style="margin-bottom:12px">'
      +'<div class="ch" style="flex-wrap:wrap;gap:10px">'
        +'<span class="ct">\u{1F4CA} Ventas por vendedor</span>'
        +'<span style="display:flex;gap:8px;align-items:center;margin-left:auto;flex-wrap:wrap">'
          +'<select id="rvv-anio" onchange="rvvAnio(this.value)" style="padding:7px 11px;border:1px solid var(--border);border-radius:9px;font-size:13px;background:#fff"></select>'
          + (rvvEsAdmin()
              ? '<select id="rvv-vend" onchange="rvvVend(this.value)" style="padding:7px 11px;border:1px solid var(--border);border-radius:9px;font-size:13px;background:#fff;min-width:190px">'
                +'<option value="">Todos los vendedores</option></select>'
              : '')
          +'<button class="btn btn-sm" onclick="rvvCargar()">Actualizar</button>'
        +'</span>'
      +'</div>'
      +'<div id="rvv-resumen"><div class="loading"><div class="spinner"></div></div></div>'
    +'</div>'
    +'<div id="rvv-detalle"></div>';

  // Anios: desde 2020 hasta el actual.
  var sa=document.getElementById('rvv-anio');
  var hoy=new Date().getFullYear();
  var ops='';
  for(var a=hoy; a>=2020; a--) ops+='<option value="'+a+'"'+(a===RVV_ANIO?' selected':'')+'>'+a+'</option>';
  sa.innerHTML=ops;

  // Las partes hacen falta siempre, asi que se esperan antes de calcular.
  rvvCargarVendedores().then(rvvCargar);
}

async function rvvCargarVendedores(){
  // OJO: no se sale aunque no haya selector. Un vendedor no lo tiene (solo el
  // admin puede cambiar de vendedor), pero igual necesita que se carguen las
  // partes de cada codigo para saber que ventas compartidas le tocan.
  var sel=document.getElementById('rvv-vend');
  try{
    var v=await q('vendedores','select=slpcode,slpname&order=slpname');
    RVV_VENDS = v||[];
    RVV_PARTES = {};
    (v||[]).forEach(function(x){
      if(x.slpcode!=null) RVV_PARTES[String(x.slpcode)] = _rvvPartes(x.slpname);
    });

    if(!sel) return;
    var vistos={}, ops='<option value="">Todos los vendedores</option>';
    (v||[]).forEach(function(x){
      if(x.slpcode==null || vistos[x.slpcode]) return;
      var n=String(x.slpname||'');
      // Fuera los de baja (Z-), los combinados (llevan barra) y los que no son
      // personas. Los combinados no se eligen: sus ventas se reparten solas
      // entre los vendedores que los componen.
      if(/^Z-/i.test(n) || /\//.test(n) || /^-|^N\/A$/i.test(n)) return;
      vistos[x.slpcode]=1;
      // El nombre va en data-nom ademas de en el texto: asi no depende de
      // como se pinte la opcion.
      ops+='<option value="'+x.slpcode+'" data-nom="'+npEsc(n)+'"'
        +(String(x.slpcode)===RVV_VEND?' selected':'')+'>'+npEsc(n)+'</option>';
    });
    sel.innerHTML=ops;
  }catch(e){}
}

function rvvAnio(v){ RVV_ANIO=parseInt(v,10)||new Date().getFullYear(); RVV_MES=null; rvvCargar(); }
function rvvVend(v){ RVV_VEND=v||''; RVV_MES=null; rvvCargar(); }

async function rvvCargar(){
  // Los dos pasteles caducan: cambian el año o el vendedor.
  RVV_DEP.anio={datos:[],cargando:false,error:'',clave:''};
  RVV_DEP.mes ={datos:[],cargando:false,error:'',clave:''};
  if(RVV_CARGANDO) return;
  var res=document.getElementById('rvv-resumen'); if(!res) return;
  RVV_CARGANDO=true;
  res.innerHTML='<div class="loading"><div class="spinner"></div></div>';
  var det=document.getElementById('rvv-detalle'); if(det) det.innerHTML='';

  try{
    // El nombre del vendedor elegido: hace falta para repartir las compartidas.
    //
    // OJO: se toma del propio selector, que es lo que el usuario esta viendo.
    // Buscarlo en RVV_VENDS por slpcode daba nombres cruzados —elegias LIRAN
    // y salia LEO— porque esa lista viene ordenada por nombre y puede traer
    // el mismo codigo mas de una vez; el [0] cogia el primero alfabetico.
    var nombreMio='';
    if(RVV_VEND){
      var _sel=document.getElementById('rvv-vend');
      if(_sel && _sel.selectedOptions && _sel.selectedOptions.length && _sel.value===String(RVV_VEND)){
        var _op=_sel.selectedOptions[0];
        nombreMio = (_op.getAttribute('data-nom') || _op.textContent || '').trim();
      } else if(!rvvEsAdmin()){
        // Un vendedor no tiene selector: su nombre sale de su propia cuenta.
        nombreMio = String((CU && (CU.nombre || CU.username)) || '');
        // Si el nombre del usuario no coincide con ningun vendedor, se cae al
        // de la tabla, pero solo si ese codigo aparece UNA vez.
        var _mios=RVV_VENDS.filter(function(x){ return String(x.slpcode)===String(RVV_VEND); });
        if(_mios.length===1) nombreMio=_mios[0].slpname;
      }
      if(!nombreMio){
        var _c=RVV_VENDS.filter(function(x){ return String(x.slpcode)===String(RVV_VEND); });
        if(_c.length===1) nombreMio=_c[0].slpname;
        else if(_c.length>1){
          console.warn('[ventas] el slpcode '+RVV_VEND+' tiene varios nombres:',
                       _c.map(function(x){ return x.slpname; }));
          nombreMio=_c[0].slpname;
        }
      }
      // El codigo no esta en la tabla de vendedores: se avisa en vez de
      // seguir con un nombre que no le corresponde. Pasaba con KABASSO (261),
      // creado en SAP despues de la ultima carga de esa tabla, y el reporte
      // mostraba el nombre de otro vendedor dado de baja.
      if(!nombreMio || !RVV_PARTES[String(RVV_VEND)]){
        RVV_SIN_CODIGO = !RVV_PARTES[String(RVV_VEND)];
      } else {
        RVV_SIN_CODIGO = false;
      }
    }

    // Se pide linetotal, no doctotal. El dashboard suma las LINEAS y resta
    // las devoluciones (ver la vista ventas_comparativo), y ese es el criterio
    // que cuadra con SAP: doctotal incluye impuestos y flete, que no son
    // venta. Para agosto daba 862,447 en vez de 791,435.
    // La suma la hace la BASE, no el navegador.
    //
    // Antes se bajaban TODAS las lineas de factura del año para agruparlas
    // aqui en documentos: cientos de miles de filas por la red para mostrar
    // doce numeros. Por eso tardaba una eternidad.
    //
    // `ventas_vendedor_docs` devuelve una fila por DOCUMENTO, con facturas y
    // devoluciones ya juntas y en el mismo formato que armaba este bucle. El
    // reparto de las compartidas y el detalle por mes se siguen calculando
    // aqui, que es donde deben estar.
    var cods = null;
    if(RVV_VEND){
      var _c = nombreMio ? rvvCodigosDe(nombreMio).todos : [String(RVV_VEND)];
      if(!_c.length) _c=[String(RVV_VEND)];
      cods = _c.map(function(x){ return parseInt(x,10); })
               .filter(function(n){ return !isNaN(n); });
      if(!cods.length) cods=null;
    }

    // Por TANDAS: PostgREST corta en 1.000 filas por respuesta. Con mas
    // documentos en el año, el reporte veia solo los primeros mil y los meses
    // del final salian en cero. Se pide hasta que una tanda venga corta.
    var _todos=[], _tanda=900, _off=0;
    for(var _v=0; _v<80; _v++){
      var _r = await fetch(SB+'/rest/v1/rpc/ventas_vendedor_docs',{
        method:'POST',
        headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
                 'Content-Type':'application/json'},
        body:JSON.stringify({p_anio:RVV_ANIO, p_slpcodes:cods,
                             p_limit:_tanda, p_offset:_off})
      });
      var _t = await _r.text();
      if(!_r.ok) throw new Error(_t.slice(0,180));
      var _lote = JSON.parse(_t) || [];
      _todos = _todos.concat(_lote);
      if(_lote.length < _tanda) break;
      _off += _tanda;
      if(res) res.innerHTML='<div class="loading"><div class="spinner"></div>'
        +'<div style="margin-top:9px;font-size:12.5px;color:var(--text3)">'
        +fmtN(_todos.length)+' documentos\u2026</div></div>';
    }

    var docs={};
    _todos.forEach(function(x){
      var k = (x.esdevolucion ? 'DEV-' : '') + x.docnum;
      docs[k] = {
        docnum: x.docnum,
        docdate: String(x.docdate||'').substring(0,10),
        cardcode: x.cardcode, cardname: x.cardname,
        total: Number(x.total)||0,
        doctotal: Number(x.doctotal)||0,
        slpcode: x.slpcode, vendedor: x.vendedor||'',
        esDevolucion: !!x.esdevolucion
      };
    });

    RVV_FACTS=Object.keys(docs).map(function(k){
      var d=docs[k];
      // Cuanto de esta venta le toca al vendedor elegido. Sin vendedor
      // (vista de admin) cuenta entera: es el total de la empresa.
      var fac = RVV_VEND ? rvvFactor(d.slpcode, nombreMio) : 1;
      d.factor = fac;
      d.parte  = d.total * fac;                 // lo que suma para el
      d.compartida = (fac > 0 && fac < 1);
      return d;
    }).filter(function(d){ return !RVV_VEND || d.factor > 0; });

    var meses=[];
    for(var m=0;m<12;m++) meses.push({mes:m+1, solo:0, comp:0, total:0, n:0, nComp:0});
    RVV_FACTS.forEach(function(d){
      var m=parseInt(String(d.docdate).substring(5,7),10);
      if(m<1 || m>12) return;
      var t=meses[m-1];
      if(d.compartida){ t.comp += d.parte; t.nComp++; }
      else            { t.solo += d.parte; }
      t.total += d.parte;
      if(!d.esDevolucion) t.n++;   // las devoluciones no son facturas
      else t.nDev = (t.nDev||0)+1;
    });
    RVV_MESES=meses;
    RVV_NOMBRE_MIO=nombreMio;
    rvvRenderResumen();
    // El pastel del año va solo: es UNA consulta que devuelve doce filas.
    rvvDeptos(null);
  }catch(e){
    res.innerHTML='<div style="color:var(--red);font-size:13px;padding:14px">No se pudo cargar: '
      +npEsc(String(e.message||e).slice(0,170))+'</div>';
  }finally{ RVV_CARGANDO=false; }
}

var RVV_NOMBRE_MIO='';
var RVV_SIN_CODIGO=false;   // el slpcode no esta en la tabla de vendedores

function rvvRenderResumen(){
  var res=document.getElementById('rvv-resumen'); if(!res) return;

  var tSolo=0, tComp=0, nDoc=0, nComp=0, mayor=0;
  RVV_MESES.forEach(function(m){
    tSolo+=m.solo; tComp+=m.comp; nDoc+=m.n; nComp+=m.nComp;
    if(m.total>mayor) mayor=m.total;
  });
  var total=tSolo+tComp;

  var quien = RVV_VEND ? (RVV_NOMBRE_MIO || RVV_VEND) : 'Todos los vendedores';
  if(!rvvEsAdmin()) quien = RVV_NOMBRE_MIO || (CU.nombre || CU.username || '');

  // Que codigos se estan sumando. Se muestra a proposito: si alguna vez
  // vuelve a cruzarse un vendedor con otro, se ve aqui de inmediato.
  var _det='';
  if(RVV_SIN_CODIGO){
    _det='<div style="font-size:11.5px;color:var(--amber);margin-top:3px">'
      +'El c\u00f3digo <b>'+npEsc(String(RVV_VEND))+'</b> no est\u00e1 en la lista de vendedores. '
      +'Puede ser reciente y faltar por sincronizar: avisa para que lo revisen.</div>';
  } else
  if(RVV_VEND && RVV_NOMBRE_MIO){
    var _cd=rvvCodigosDe(RVV_NOMBRE_MIO);
    var _nom=function(c){
      var v=RVV_VENDS.filter(function(x){ return String(x.slpcode)===String(c); })[0];
      return v ? v.slpname : c;
    };
    _det='<div style="font-size:11.5px;color:var(--text3);margin-top:3px">'
      +'C\u00f3digos: '+_cd.solos.map(function(c){ return '<b>'+npEsc(_nom(c))+'</b>'; }).join(', ')
      +(_cd.compartidos.length
        ? (' \u00b7 compartidos: '+_cd.compartidos.map(function(c){ return npEsc(_nom(c)); }).join(', '))
        : '')
      +'</div>';
  }

  var tarjetas=RVV_MESES.map(function(m){
    var act=(RVV_MES===m.mes);
    var vacio=(m.n===0);
    // La barra se parte: lo propio abajo y lo compartido encima, para ver
    // de un vistazo cuanto del mes vino de ventas a medias.
    var pSolo = mayor>0 ? Math.round(m.solo/mayor*100) : 0;
    var pComp = mayor>0 ? Math.round(m.comp/mayor*100) : 0;
    return '<div onclick="'+(vacio?'':'rvvMes('+m.mes+')')+'" '
      +'style="flex:1;min-width:124px;border:1px solid '+(act?'var(--blue2)':'var(--border)')+';'
      +'border-radius:11px;padding:10px 11px;'+(vacio?'opacity:.5;':'cursor:pointer;')
      +(act?'background:var(--blue-bg,#EFF6FF);':'')+'">'
      +'<div style="font-size:11.5px;color:var(--text3)">'+RVV_NOMBRE_MES[m.mes-1]+'</div>'
      +'<div style="font-size:15px;font-weight:800;margin:2px 0 1px">'+fmt(m.total)+'</div>'
      +'<div style="font-size:10.5px;color:var(--text3)">'+m.n+' fact.'
        +(m.nComp?(' \u00b7 '+m.nComp+' compart.'):'')+'</div>'
      +'<div style="display:flex;height:4px;background:var(--surface2,#F1F2F4);border-radius:3px;margin-top:7px;overflow:hidden">'
        +'<span style="width:'+pSolo+'%;background:var(--green)"></span>'
        +'<span style="width:'+pComp+'%;background:#F59E0B"></span></div>'
      +'</div>';
  }).join('');

  var hayComp = tComp > 0.005;

  res.innerHTML =
     '<div style="display:flex;gap:22px;flex-wrap:wrap;margin-bottom:14px">'
      +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Vendedor</div>'
        +'<div style="font-size:15px;font-weight:700">'+npEsc(quien)+'</div>'+_det+'</div>'
      +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Ventas solo</div>'
        +'<div style="font-size:19px;font-weight:800;color:var(--green)">'+fmt(tSolo)+'</div></div>'
      +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">'
        +'Ventas compartidas <span style="text-transform:none;font-weight:400">(su 50%)</span></div>'
        +'<div style="font-size:19px;font-weight:800;color:#D97706">'+fmt(tComp)+'</div></div>'
      +'<div style="border-left:2px solid var(--border);padding-left:20px">'
        +'<div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Gran total '+RVV_ANIO+'</div>'
        +'<div style="font-size:24px;font-weight:800">'+fmt(total)+'</div></div>'
      +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Facturas</div>'
        +'<div style="font-size:19px;font-weight:800">'+fmtN(nDoc)
        +(nComp?('<span style="font-size:11.5px;color:var(--text3);font-weight:400"> \u00b7 '+nComp+' compart.</span>'):'')
        +'</div></div>'
    +'</div>'
    + (hayComp
        ? '<div style="font-size:11.5px;color:var(--text3);margin-bottom:10px;line-height:1.5">'
          +'<span style="display:inline-block;width:9px;height:9px;background:var(--green);border-radius:2px;vertical-align:middle"></span> venta propia &nbsp; '
          +'<span style="display:inline-block;width:9px;height:9px;background:#F59E0B;border-radius:2px;vertical-align:middle"></span> compartida '
          +'(cuenta el 50%, el otro 50% va al otro vendedor)</div>'
        : '')
    +'<div style="font-size:11.5px;color:var(--text3);margin-bottom:8px;line-height:1.5">'
      +'Pulsa un mes para ver sus facturas. '
      +'<span style="opacity:.85">La venta suma el importe de las l\u00edneas y resta las devoluciones, '
      +'igual que el Dashboard: no incluye impuestos ni flete.</span></div>'
    +'<div style="display:flex;gap:9px;flex-wrap:wrap">'+tarjetas+'</div>'
    // El del AÑO, una sola vez al pie del resumen del vendedor.
    + rvvDeptoPanel('anio', String(RVV_ANIO));
}

function rvvMes(m){
  RVV_MES = (RVV_MES===m) ? null : m;
  rvvRenderResumen();
  rvvRenderMes();
  // Despues del cambio y solo si queda un mes elegido: pulsar el mismo mes
  // lo deselecciona, y entonces no hay pastel que pedir.
  if(RVV_MES) rvvDeptos(RVV_MES);
}

function rvvRenderMes(){
  var box=document.getElementById('rvv-detalle'); if(!box) return;
  if(!RVV_MES){ box.innerHTML=''; return; }

  var mm=String(RVV_MES).padStart(2,'0');
  var facts=RVV_FACTS.filter(function(d){
    return String(d.docdate).substring(5,7)===mm;
  }).sort(function(a,b){ return String(b.docdate).localeCompare(String(a.docdate)); });

  var total=0, tSolo=0, tComp=0, nComp=0;
  facts.forEach(function(d){
    var p = (d.parte!=null ? d.parte : d.total);
    total += p;
    if(d.compartida){ tComp += p; nComp++; } else { tSolo += p; }
  });

  if(!facts.length){
    box.innerHTML='<div class="card" style="padding:20px;text-align:center;color:var(--text3)">'
      +'Sin facturas en '+RVV_NOMBRE_MES[RVV_MES-1]+' de '+RVV_ANIO+'.</div>';
    return;
  }

  // Por cliente, para ver de un vistazo quien pesa mas en el mes.
  var porCli={};
  facts.forEach(function(d){
    var c=porCli[d.cardcode] || (porCli[d.cardcode]={nombre:d.cardname, total:0, n:0});
    c.total += (d.parte!=null ? d.parte : d.total);   // su parte, no el total del documento
    c.n++;
  });
  var top=Object.keys(porCli).map(function(k){ return Object.assign({cardcode:k}, porCli[k]); })
    .sort(function(a,b){ return b.total-a.total; }).slice(0,5);

  var filas=facts.map(function(d){
    var p = (d.parte!=null ? d.parte : d.total);
    // Una devolucion no abre la ficha de factura: es otro documento.
    return '<tr'+(d.esDevolucion?'':' style="cursor:pointer" onclick="verFactura('+d.docnum+')"')+'>'
      +'<td>'+(d.esDevolucion
          ? ('<span style="color:var(--red)">\u21a9 '+npEsc(String(d.docnum))+'</span>')
          : ('<b style="color:var(--blue2);text-decoration:underline">'+npEsc(String(d.docnum))+'</b>'))+'</td>'
      +'<td style="white-space:nowrap">'+_plFechaLbl(d.docdate)+'</td>'
      +'<td>'+npEsc(String(d.cardname||'').substring(0,42))+'</td>'
      +'<td style="font-size:11.5px;color:var(--text3)">'+npEsc(d.cardcode||'')+'</td>'
      + (rvvEsAdmin() && !RVV_VEND
          ? ('<td style="font-size:11.5px;color:var(--text3)">'+npEsc(d.vendedor||'')+'</td>') : '')
      + (RVV_VEND
          ? ('<td style="white-space:nowrap">'
             + (d.esDevolucion
                 ? '<span style="background:#FEE2E2;color:#991B1B;padding:1px 7px;border-radius:9px;font-size:10.5px;font-weight:700">devoluci\u00f3n</span>'
                 : (d.compartida
                 ? ('<span style="background:#FEF3C7;color:#92400E;padding:1px 7px;border-radius:9px;font-size:10.5px;font-weight:700" '
                    +'title="Compartida con '+npEsc(d.vendedor||'')+'">50% \u00b7 '+npEsc(d.vendedor||'')+'</span>')
                 : '<span style="font-size:11px;color:var(--text3)">propia</span>'))
             +'</td>') : '')
      // Con vendedor elegido se muestran las dos cifras: el total del
      // documento y lo que le corresponde a el.
      + (RVV_VEND && d.compartida
          ? ('<td style="text-align:right;font-size:11.5px;color:var(--text3)">'+fmt(d.total)+'</td>')
          : (RVV_VEND ? '<td></td>' : ''))
      +'<td style="text-align:right;font-weight:700'+(p<0?';color:var(--red)':'')+'">'+fmt(p)+'</td>'
      +'</tr>';
  }).join('');

  box.innerHTML =
     // El pastel del MES, una sola vez arriba del detalle. El del año vive en
     // el resumen; estos dos no se pisan porque cada uno tiene su estado.
     rvvDeptoPanel('mes', RVV_NOMBRE_MES[RVV_MES-1]+' '+RVV_ANIO)
     +'<div class="card" style="margin-bottom:12px">'
      +'<div class="ch" style="flex-wrap:wrap;gap:9px">'
        +'<span class="ct">'+RVV_NOMBRE_MES[RVV_MES-1]+' '+RVV_ANIO+'</span>'
        +'<span style="margin-left:auto;font-size:13px">'
          +'<b>'+facts.length+'</b> factura'+(facts.length===1?'':'s')
          + (nComp ? (' \u00b7 <span style="color:#D97706">'+nComp+' compartida'+(nComp===1?'':'s')+'</span>') : '')
          +' \u00b7 <b style="color:var(--green)">'+fmt(total)+'</b></span>'
        +'<button class="btn btn-sm" onclick="rvvExportar()">\u2b07 Excel</button>'
      +'</div>'
      + (nComp
          ? ('<div style="display:flex;gap:20px;flex-wrap:wrap;margin-bottom:12px;font-size:12.5px">'
             +'<span>Propias: <b style="color:var(--green)">'+fmt(tSolo)+'</b></span>'
             +'<span>Compartidas (su 50%): <b style="color:#D97706">'+fmt(tComp)+'</b></span>'
             +'<span>Total: <b>'+fmt(total)+'</b></span></div>')
          : '')
      +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin-bottom:12px">'
      + top.map(function(c){
          return '<div style="border:1px solid var(--border);border-radius:9px;padding:7px 11px;min-width:150px">'
            +'<div style="font-size:11.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'
            +npEsc(String(c.nombre||'').substring(0,26))+'</div>'
            +'<div style="font-size:13px;font-weight:700;color:var(--green)">'+fmt(c.total)+'</div>'
            +'<div style="font-size:10.5px;color:var(--text3)">'+c.n+' factura'+(c.n===1?'':'s')+'</div>'
            +'</div>';
        }).join('')
      +'</div>'
      +'<div style="overflow-x:auto"><table class="tbl">'
      +'<tr><th>Factura</th><th>Fecha</th><th>Cliente</th><th>C\u00f3digo</th>'
      + (rvvEsAdmin() && !RVV_VEND ? '<th>Vendedor</th>' : '')
      + (RVV_VEND ? '<th>Tipo</th><th style="text-align:right">Factura</th>' : '')
      +'<th style="text-align:right">'+(RVV_VEND?'Le corresponde':'Total')+'</th></tr>'
      + filas
      +'<tr style="background:var(--surface2,#F7F7F8);font-weight:700">'
        +'<td colspan="'+(4 + (rvvEsAdmin()&&!RVV_VEND?1:0) + (RVV_VEND?2:0))+'" style="text-align:right">TOTAL '
        +RVV_NOMBRE_MES[RVV_MES-1].toUpperCase()+'</td>'
        +'<td style="text-align:right;color:var(--green)">'+fmt(total)+'</td></tr>'
      +'</table></div></div>';
}

async function rvvExportar(){
  if(!RVV_MES) return;
  var mm=String(RVV_MES).padStart(2,'0');
  var facts=RVV_FACTS.filter(function(d){ return String(d.docdate).substring(5,7)===mm; })
    .sort(function(a,b){ return String(a.docdate).localeCompare(String(b.docdate)); });
  if(!facts.length) return;

  var total=0, tSolo=0, tComp=0;
  facts.forEach(function(d){
    var p=(d.parte!=null?d.parte:d.total);
    total+=p;
    if(d.compartida) tComp+=p; else tSolo+=p;
  });
  var quien = RVV_VEND ? (RVV_NOMBRE_MIO||RVV_VEND) : 'Todos los vendedores';

  try{
    var buf=await xlsxExport({
      devolver:true,
      filename:'ventas.xlsx',
      titulo:'KENNEDY CENTER CORP. - VENTAS '+RVV_NOMBRE_MES[RVV_MES-1].toUpperCase()+' '+RVV_ANIO,
      subtitulo:quien+'  -  '+facts.length+' factura(s)  -  Propias '+fmt(tSolo)
        +(tComp>0.005?('  -  Compartidas '+fmt(tComp)):'')+'  -  TOTAL '+fmt(total),
      columns:[
        {label:'Factura',  key:'docnum',   width:12},
        {label:'Fecha',    key:'docdate',  width:13},
        {label:'Cliente',  key:'cardname', width:38},
        {label:'Codigo',   key:'cardcode', width:12},
        {label:'Vendedor', key:'vendedor', width:20},
        {label:'Tipo',     key:'__tipo',   width:12},
        {label:'Total documento', key:'__doctotal', width:16, numFmt:'#,##0.00'},
        {label:'Le corresponde', key:'__parte', width:15, numFmt:'#,##0.00'}
      ],
      rows:facts,
      valueFn:function(r,k){
        if(k==='docdate') return _plFechaLbl(r.docdate);
        if(k==='total')      return Number(r.total)||0;
        if(k==='__doctotal') return Number(r.doctotal||r.total)||0;
        if(k==='__tipo')  return r.esDevolucion ? 'Devolucion'
                               : (r.compartida ? 'Compartida 50%' : 'Propia');
        if(k==='__parte') return Number(r.parte!=null ? r.parte : r.total)||0;
        return r[k]||'';
      }
    });
    var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    var a=document.createElement('a'); a.href=URL.createObjectURL(blob);
    a.download='ventas-'+RVV_ANIO+'-'+mm+'.xlsx';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function(){ URL.revokeObjectURL(a.href); }, 5000);
  }catch(e){ alert('No se pudo generar el Excel: '+(e.message||e)); }
}


// ════════════════════════════════════════════════════════════════════
//  PANELES CON "MOSTRAR MÁS"
//  El estado de cuenta y las facturas de un cliente pueden ser cientos
//  de líneas: se muestran 25 y el resto bajo demanda.
// ════════════════════════════════════════════════════════════════════
var PM_PASO = 25;
var PM_VIS = {};     // cuántas líneas se ven de cada panel

function pmVisibles(id){
  if(PM_VIS[id] == null) PM_VIS[id] = PM_PASO;
  return PM_VIS[id];
}

// Scroll infinito. Los datos ya estan en memoria, asi que "cargar mas" es
// solo repintar con mas lineas visibles: no hay consulta ni espera.
var PM_OBS = {};

function pmMas(id){
  var v = pmVisibles(id);
  PM_VIS[id] = v + PM_PASO;
  var f = window['_PM_' + id];
  if(typeof f === 'function') f();
}

// Pie del panel. Ya no lleva botones: un centinela invisible que, al entrar en
// pantalla, muestra las siguientes 25. Solo queda el contador, que sirve para
// saber cuanto falta.
function pmPie(id, total){
  var v = pmVisibles(id);
  if(total <= PM_PASO) return '';
  var quedan = total - v;
  var h = '<div style="text-align:center;padding:10px 0 3px;'
    + 'border-top:1px solid var(--border);margin-top:6px">';
  if(quedan > 0){
    h += '<div id="pm-cent-' + id + '" style="height:1px"></div>'
       + '<div style="font-size:11px;color:var(--text3)">'
       + fmtN(Math.min(v, total)) + ' de ' + fmtN(total) + '</div>';
    setTimeout(function(){ pmObservar(id); }, 0);
  } else {
    h += '<div style="font-size:11px;color:var(--text3)">'
       + fmtN(total) + ' en total</div>';
  }
  return h + '</div>';
}

function pmObservar(id){
  if(PM_OBS[id]){ PM_OBS[id].disconnect(); PM_OBS[id] = null; }
  var c = document.getElementById('pm-cent-' + id);
  if(!c) return;
  if(!('IntersectionObserver' in window)){
    // Navegador antiguo: sin observador, se muestra todo de una vez antes que
    // dejar al usuario sin forma de ver el resto.
    PM_VIS[id] = 1e9;
    var f = window['_PM_' + id];
    if(typeof f === 'function') f();
    return;
  }
  // rootMargin: se amplia ANTES de llegar al borde, para que la lista no de
  // un tiron al llegar al final.
  PM_OBS[id] = new IntersectionObserver(function(e){
    if(e[0] && e[0].isIntersecting) pmMas(id);
  }, {rootMargin: '300px'});
  PM_OBS[id].observe(c);
}


// ── Los tres paneles de la ficha de un cliente de NAPA ─────────────────────
// Cada uno se repinta solo al pulsar "Mostrar mas": los datos ya estan en
// memoria, no se vuelve a consultar nada.

function cnPanelMov(){
  var d = window._CN_DATOS; if(!d) return;
  var c = document.getElementById('pm-cnmov'); if(!c) return;
  var todos = d.mov.slice().reverse();          // lo mas reciente arriba
  var ver = todos.slice(0, pmVisibles('cnmov'));

  c.innerHTML =
     '<div class="card" style="margin-bottom:12px">'
    +'<div class="ch"><span class="ct">Estado de cuenta</span>'
      +'<span style="font-size:12px;color:var(--text3)">'+fmtN(d.mov.length)+' movimiento(s)</span></div>'
    +'<div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th>Fecha</th><th>Ref.</th><th>Concepto</th>'
    +'<th style="text-align:right">D\u00e9bito</th><th style="text-align:right">Cr\u00e9dito</th></tr>'
    + (ver.length ? ver.map(function(x){
        return '<tr><td style="white-space:nowrap">'+_plFechaLbl(String(x.refdate||'').substring(0,10))+'</td>'
          +'<td style="font-size:11.5px">'+npEsc(x.ref1||'')+'</td>'
          +'<td style="font-size:11.5px">'+npEsc(String(x.linememo||'').substring(0,60))+'</td>'
          +'<td style="text-align:right">'+(Number(x.debit)?fmt(x.debit):'')+'</td>'
          +'<td style="text-align:right;color:var(--green)">'+(Number(x.credit)?fmt(x.credit):'')+'</td></tr>';
      }).join('') : '<tr><td colspan="5" style="text-align:center;color:var(--text3);padding:16px">Sin movimientos</td></tr>')
    +'</table></div>'
    + pmPie('cnmov', todos.length)
    +'</div>';
}
window._PM_cnmov = cnPanelMov;

function cnPanelFac(){
  var d = window._CN_DATOS; if(!d) return;
  var c = document.getElementById('pm-cnfac'); if(!c) return;
  var ver = d.lista.slice(0, pmVisibles('cnfac'));

  c.innerHTML =
     '<div class="card" style="margin-bottom:12px">'
    +'<div class="ch"><span class="ct">\u00daltimas facturas</span>'
      +'<span style="font-size:12px;color:var(--text3)">'+fmtN(d.lista.length)+' factura(s)</span></div>'
    +'<div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th>Documento</th><th>Fecha</th><th style="text-align:right">L\u00edneas</th>'
    +'<th style="text-align:right">Total</th></tr>'
    + (ver.length ? ver.map(function(x){
        return '<tr style="cursor:pointer" onclick="cnCerrar();verFactura('+x.docnum+',null,true)">'
          +'<td><b style="color:var(--blue2);text-decoration:underline">'+npEsc(String(x.docnum))+'</b></td>'
          +'<td>'+_plFechaLbl(String(x.docdate||'').substring(0,10))+'</td>'
          +'<td style="text-align:right">'+x.lineas+'</td>'
          +'<td style="text-align:right;font-weight:600">'+fmt(x.total)+'</td></tr>';
      }).join('') : '<tr><td colspan="4" style="text-align:center;color:var(--text3);padding:16px">Sin facturas registradas</td></tr>')
    +'</table></div>'
    + pmPie('cnfac', d.lista.length)
    +'</div>';
}
window._PM_cnfac = cnPanelFac;

function cnPanelPed(){
  var d = window._CN_DATOS; if(!d) return;
  var c = document.getElementById('pm-cnped'); if(!c) return;

  // pedidos_napa trae una fila por linea: se agrupa por documento y se
  // cuenta cuanto queda pendiente de entregar.
  var m = {};
  (d.ped||[]).forEach(function(p){
    var k = String(p.docnum);
    if(!m[k]) m[k] = {docnum:p.docnum, docdate:String(p.docdate||'').substring(0,10),
                      total:Number(p.doctotal)||0, estado:p.docstatus,
                      lineas:0, pendientes:0};
    m[k].lineas++;
    if((Number(p.openqty)||0) > 0) m[k].pendientes++;
  });
  var todos = Object.keys(m).map(function(k){ return m[k]; })
    .sort(function(a,b){ return String(b.docdate).localeCompare(String(a.docdate)); });
  var ver = todos.slice(0, pmVisibles('cnped'));

  c.innerHTML =
     '<div class="card">'
    +'<div class="ch"><span class="ct">\u00daltimos pedidos</span>'
      +'<span style="font-size:12px;color:var(--text3)">'+fmtN(todos.length)+' pedido(s)</span></div>'
    +'<div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th>Pedido</th><th>Fecha</th><th style="text-align:right">L\u00edneas</th>'
    +'<th>Estado</th><th style="text-align:right">Total</th></tr>'
    + (ver.length ? ver.map(function(x){
        var abierto = String(x.estado)==='O';
        return '<tr>'
          +'<td><b>'+npEsc(String(x.docnum))+'</b></td>'
          +'<td>'+_plFechaLbl(x.docdate)+'</td>'
          +'<td style="text-align:right">'+x.lineas
            +(x.pendientes?('<span style="font-size:10.5px;color:var(--amber)"> \u00b7 '+x.pendientes+' pend.</span>'):'')
            +'</td>'
          +'<td>'+(abierto
              ? '<span class="badge b-amber">abierto</span>'
              : '<span class="badge b-green">entregado</span>')+'</td>'
          +'<td style="text-align:right;font-weight:600">'+fmt(x.total)+'</td></tr>';
      }).join('') : '<tr><td colspan="5" style="text-align:center;color:var(--text3);padding:16px">Sin pedidos registrados</td></tr>')
    +'</table></div>'
    + pmPie('cnped', todos.length)
    +'</div>';
}
window._PM_cnped = cnPanelPed;


// ════════════════════════════════════════════════════════════════════
//  MARGEN DE GANANCIA DEL PEDIDO
//  Como el "Gross Profit of Order" de SAP: por linea y total.
//  Solo para administradores (ver _pedVerMargen en kennedy-1.js).
// ════════════════════════════════════════════════════════════════════
/* ══════════════════════════════════════════════════════════════════════════
   MARGEN DE LA COTIZACION QUE SE ESTA ARMANDO
   ---------------------------------------------------------------------------
   El mismo calculo del boton "Margen" del pedido, pero sobre las lineas del
   carrito, antes de enviarlo. Asi el vendedor ve lo que va a ganar mientras
   todavia puede cambiar precios.

   El costo es el CIF -la lista 2 de SAP-, igual que alli. No se usa el costo
   promedio: daria otro numero y los dos informes dejarian de coincidir.

   OJO: lo ven vendedores y administracion. Los CLIENTES no, ni aunque armen
   su propia cotizacion desde el portal.
   ══════════════════════════════════════════════════════════════════════════ */

function npVerMargen(){
  var r=String((CU&&CU.rol)||'').toLowerCase();
  return r!=='cliente' && !!r;
}

async function npMargen(){
  if(!npVerMargen()){ alert('El margen no est\u00e1 disponible para tu usuario.'); return; }
  if(!npLineas || !npLineas.length){ alert('No hay productos en la cotizaci\u00f3n.'); return; }

  var m=document.createElement('div');
  m.id='mg-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:1000px;'
    +'width:100%;max-height:92vh;display:flex;flex-direction:column">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);display:flex;'
    +'align-items:center;gap:10px">'
      +'<b style="flex:1;font-size:15px">\u{1F4C8} Margen de esta cotizaci\u00f3n</b>'
      +'<button onclick="document.getElementById(\'mg-modal\').remove()" '
      +'style="border:none;background:none;font-size:23px;cursor:pointer;'
      +'color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="mg-body" style="flex:1;overflow-y:auto;padding:16px 18px;font-size:13px;'
    +'color:var(--text3)"><div class="loading"><div class="spinner"></div></div></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) m.remove(); });

  try{
    // El CIF de cada articulo del carrito.
    var codes=[], v={};
    npLineas.forEach(function(l){
      if(l.itemcode && !v[l.itemcode]){ v[l.itemcode]=1; codes.push(l.itemcode); }
    });
    var costos={}, sinCif=false;
    for(var i=0;i<codes.length;i+=200){
      var trozo=codes.slice(i,i+200);
      var inList=trozo.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      try{
        var r=await q('inventario',
          'select=itemcode,cif&itemcode=in.('+inList+')&limit='+trozo.length);
        if(i===0 && (!r || !r.length || r[0].cif===undefined)) sinCif=true;
        (r||[]).forEach(function(x){ costos[x.itemcode]=Number(x.cif)||0; });
      }catch(e){ sinCif=true; }
    }
    if(sinCif){
      document.getElementById('mg-body').innerHTML=
         '<div style="background:#FEF2F2;border:1px solid #FECACA;color:#991B1B;'
        +'border-radius:9px;padding:12px 14px;line-height:1.6">'
        +'<b>Falta el precio CIF en la base.</b><br>'
        +'Sin la columna <code>cif</code> de <code>inventario</code> no se puede '
        +'calcular el margen.</div>';
      return;
    }

    var tVenta=0, tCosto=0, sinCosto=0;
    var filas=npLineas.map(function(l,ix){
      var costoU = costos[l.itemcode] || 0;
      var cant   = Number(l.quantity)||0;
      var precio = Number(l.price)||0;
      var desc   = Number(l.discount)||0;
      // La venta con el descuento de linea aplicado, que es lo que se cobra.
      var venta  = precio * cant * (1 - desc/100);
      var costoT = costoU * cant;
      var gan    = venta - costoT;
      var pct    = venta > 0 ? (gan/venta*100) : 0;

      if(!costoU){ sinCosto++; }
      else { tVenta += venta; tCosto += costoT; }

      var col = !costoU ? 'var(--text3)'
              : (pct < 15 ? 'var(--red)' : (pct < 25 ? 'var(--amber)' : 'var(--green)'));
      return '<tr>'
        +'<td style="text-align:right;color:var(--text3)">'+(ix+1)+'</td>'
        +'<td><b>'+npEsc(l.itemcode||'')+'</b></td>'
        +'<td style="font-size:11.5px">'+npEsc(String(l.itemname||'').substring(0,42))+'</td>'
        +'<td style="text-align:right">'+fmtN(cant)+'</td>'
        +'<td style="text-align:right">'
          +(costoU?fmt(costoU):'<span style="color:var(--amber)">?</span>')+'</td>'
        +'<td style="text-align:right">'+fmt(precio)+(desc?(' <span style="color:var(--text3);'
          +'font-size:11px">-'+desc+'%</span>'):'')+'</td>'
        +'<td style="text-align:right">'+fmt(venta)+'</td>'
        +'<td style="text-align:right">'+(costoU?fmt(gan):'\u2014')+'</td>'
        +'<td style="text-align:right;font-weight:700;color:'+col+'">'
          +(costoU?(pct.toFixed(1)+'%'):'\u2014')+'</td>'
        +'</tr>';
    }).join('');

    var ganTot = tVenta - tCosto;
    var pctTot = tVenta > 0 ? (ganTot/tVenta*100) : 0;
    var colTot = pctTot < 15 ? 'var(--red)' : (pctTot < 25 ? 'var(--amber)' : 'var(--green)');

    document.getElementById('mg-body').innerHTML=
       '<div style="display:flex;gap:24px;flex-wrap:wrap;margin-bottom:14px;color:var(--text)">'
        +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;'
        +'letter-spacing:.4px">Venta</div>'
          +'<div style="font-size:19px;font-weight:800">'+fmt(tVenta)+'</div></div>'
        +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;'
        +'letter-spacing:.4px">Costo</div>'
          +'<div style="font-size:19px;font-weight:800">'+fmt(tCosto)+'</div></div>'
        +'<div style="border-left:2px solid var(--border);padding-left:22px">'
          +'<div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;'
          +'letter-spacing:.4px">Ganancia</div>'
          +'<div style="font-size:23px;font-weight:800;color:'+colTot+'">'+fmt(ganTot)+'</div></div>'
        +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;'
        +'letter-spacing:.4px">Margen</div>'
          +'<div style="font-size:23px;font-weight:800;color:'+colTot+'">'
          +pctTot.toFixed(2)+'%</div></div>'
      +'</div>'
      + (sinCosto
          ? ('<div style="background:#FFFBEB;border:1px solid #FDE68A;color:#92400E;'
             +'border-radius:9px;padding:9px 12px;font-size:12.5px;margin-bottom:12px">'
             +'<b>'+sinCosto+' l\u00ednea(s) sin precio CIF en SAP.</b> No entran en el '
             +'total: contarlas como costo cero dar\u00eda un margen m\u00e1s alto del real.'
             +'</div>')
          : '')
      +'<div style="overflow-x:auto"><table class="tbl">'
      +'<tr><th></th><th>SKU</th><th>Descripci\u00f3n</th>'
      +'<th style="text-align:right">Cant.</th><th style="text-align:right">CIF u.</th>'
      +'<th style="text-align:right">Precio</th><th style="text-align:right">Venta</th>'
      +'<th style="text-align:right">Ganancia</th><th style="text-align:right">Margen</th></tr>'
      + filas
      +'<tr style="background:var(--surface2,#F7F7F8);font-weight:700">'
        +'<td colspan="6" style="text-align:right">TOTAL</td>'
        +'<td style="text-align:right">'+fmt(tVenta)+'</td>'
        +'<td style="text-align:right">'+fmt(ganTot)+'</td>'
        +'<td style="text-align:right;color:'+colTot+'">'+pctTot.toFixed(2)+'%</td>'
      +'</tr></table></div>';
  }catch(e){
    var b=document.getElementById('mg-body');
    if(b) b.innerHTML='No se pudo calcular el margen: '+npEsc(e.message||e);
  }
}


async function pedMargen(docnum){
  // El boton solo se dibuja para administracion, pero la funcion es global y
  // se puede llamar desde la consola. El CIF y el FOB no salen de aqui.
  if(!(typeof _pedVerMargen==='function' ? _pedVerMargen()
       : String((CU&&CU.rol)||'').toLowerCase()==='admin')){
    alert('El margen es informaci\u00f3n de costos: solo administraci\u00f3n.');
    return;
  }
  if(typeof _pedVerMargen==='function' && !_pedVerMargen()){
    alert('Solo gerencia puede ver el margen.');
    return;
  }

  var m=document.createElement('div');
  m.id='mg-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:1000px;width:100%;'
    +'max-height:92vh;display:flex;flex-direction:column">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px">'
      +'<b style="flex:1;font-size:15px">\u{1F4C8} Margen del pedido '+npEsc(String(docnum))+'</b>'
      +'<button onclick="document.getElementById(\'mg-modal\').remove()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="mg-body" style="flex:1;overflow-y:auto;padding:16px 18px;font-size:13px;color:var(--text3)">'
      +'<div class="loading"><div class="spinner"></div></div></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) m.remove(); });

  try{
    var lin = await qAll('pedidos',
      'select=linenum,itemcode,dscription,quantity,price,descuentolinea,linetotal'
      +'&docnum=eq.'+encodeURIComponent(docnum)+'&order=linenum');
    if(!lin.length){ document.getElementById('mg-body').innerHTML='Este pedido no tiene l\u00edneas.'; return; }

    // El costo es el CIF: la lista de precios 2 de SAP, la que se elige en
    // "Base Price By: 2. CIF" de la ventana de margenes. NO es avgprice.
    var codes=[], v={};
    lin.forEach(function(l){ if(l.itemcode && !v[l.itemcode]){ v[l.itemcode]=1; codes.push(l.itemcode); } });
    var costos={};
    for(var i=0;i<codes.length;i+=200){
      var trozo=codes.slice(i,i+200);
      var inList=trozo.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      try{
        var r=await q('inventario','select=itemcode,cif,fob,avgprice&itemcode=in.('+inList+')&limit='+trozo.length);
        if(i===0 && (!r || !r.length || r[0].cif===undefined)){
          document.getElementById('mg-body').innerHTML=
             '<div style="background:#FEF2F2;border:1px solid #FECACA;color:#991B1B;'
            +'border-radius:9px;padding:12px 14px;line-height:1.6">'
            +'<b>Falta el precio CIF en la base.</b><br>'
            +'La columna <code>cif</code> de la tabla <code>inventario</code> no est\u00e1 '
            +'disponible, y sin ella no se puede calcular el margen.<br>'
            +'<span style="font-size:12px">El sync la trae de la lista de precios 2 de SAP: '
            +'revisa que ese ciclo haya corrido.</span></div>';
          return;
        }
        (r||[]).forEach(function(x){
          costos[x.itemcode]={cif:Number(x.cif)||0, fob:Number(x.fob)||0, avg:Number(x.avgprice)||0};
        });
      }catch(e){}
    }

    var tVenta=0, tCosto=0, sinCosto=0;
    var filas=lin.map(function(l,ix){
      var c = costos[l.itemcode] || {cif:0, fob:0, avg:0};
      // Solo el CIF. Sin el, la linea se marca y queda fuera del total: un
      // numero casi-correcto es peor que uno ausente.
      var costoU = c.cif || 0;
      var cant   = Number(l.quantity)||0;
      var venta  = Number(l.linetotal)||0;
      var costoT = costoU * cant;
      var gan    = venta - costoT;
      var pct    = venta > 0 ? (gan/venta*100) : 0;

      if(!costoU){ sinCosto++; }
      else { tVenta += venta; tCosto += costoT; }

      var col = !costoU ? 'var(--text3)' : (pct < 15 ? 'var(--red)' : (pct < 25 ? 'var(--amber)' : 'var(--green)'));
      return '<tr>'
        +'<td style="text-align:right;color:var(--text3)">'+(ix+1)+'</td>'
        +'<td><b>'+npEsc(l.itemcode||'')+'</b></td>'
        +'<td style="font-size:11.5px">'+npEsc(String(l.dscription||'').substring(0,42))+'</td>'
        +'<td style="text-align:right">'+fmtN(cant)+'</td>'
        +'<td style="text-align:right">'+(costoU?fmt(costoU):'<span style="color:var(--amber)">?</span>')+'</td>'
        +'<td style="text-align:right">'+fmt(Number(l.price)||0)+'</td>'
        +'<td style="text-align:right">'+fmt(venta)+'</td>'
        +'<td style="text-align:right">'+(costoU?fmt(gan):'\u2014')+'</td>'
        +'<td style="text-align:right;font-weight:700;color:'+col+'">'
          +(costoU?(pct.toFixed(1)+'%'):'\u2014')+'</td>'
        +'</tr>';
    }).join('');

    var ganTot = tVenta - tCosto;
    var pctTot = tVenta > 0 ? (ganTot/tVenta*100) : 0;
    var colTot = pctTot < 15 ? 'var(--red)' : (pctTot < 25 ? 'var(--amber)' : 'var(--green)');

    document.getElementById('mg-body').innerHTML=
       '<div style="display:flex;gap:24px;flex-wrap:wrap;margin-bottom:14px;color:var(--text)">'
        +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Venta</div>'
          +'<div style="font-size:19px;font-weight:800">'+fmt(tVenta)+'</div></div>'
        +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Costo</div>'
          +'<div style="font-size:19px;font-weight:800">'+fmt(tCosto)+'</div></div>'
        +'<div style="border-left:2px solid var(--border);padding-left:22px">'
          +'<div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Ganancia</div>'
          +'<div style="font-size:23px;font-weight:800;color:'+colTot+'">'+fmt(ganTot)+'</div></div>'
        +'<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Margen</div>'
          +'<div style="font-size:23px;font-weight:800;color:'+colTot+'">'+pctTot.toFixed(2)+'%</div></div>'
      +'</div>'
      + (sinCosto
          ? ('<div style="background:#FFFBEB;border:1px solid #FDE68A;color:#92400E;border-radius:9px;'
             +'padding:9px 12px;font-size:12.5px;margin-bottom:12px">'
             +'<b>'+sinCosto+' l\u00ednea(s) sin precio CIF en SAP.</b> No entran en el total: '
             +'contarlas como costo cero dar\u00eda un margen m\u00e1s alto del real.</div>')
          : '')
      +'<div style="overflow-x:auto"><table class="tbl">'
      +'<tr><th></th><th>SKU</th><th>Descripci\u00f3n</th>'
      +'<th style="text-align:right">Cant.</th><th style="text-align:right">CIF u.</th>'
      +'<th style="text-align:right">Precio</th><th style="text-align:right">Venta</th>'
      +'<th style="text-align:right">Ganancia</th><th style="text-align:right">Margen</th></tr>'
      + filas
      +'<tr style="background:var(--surface2,#F7F7F8);font-weight:700">'
        +'<td colspan="6" style="text-align:right">TOTAL</td>'
        +'<td style="text-align:right">'+fmt(tVenta)+'</td>'
        +'<td style="text-align:right">'+fmt(ganTot)+'</td>'
        +'<td style="text-align:right;color:'+colTot+'">'+pctTot.toFixed(2)+'%</td></tr>'
      +'</table></div>'
      +'<div style="font-size:11.5px;color:var(--text3);margin-top:12px;line-height:1.5">'
      +'El costo es el <b>CIF</b> (lista de precios 2 de SAP), el mismo de '
      +'<i>Base Price By: 2. CIF</i>. El precio de venta es el que se le dio al '
      +'cliente en este pedido, ya con su descuento.</div>';
  }catch(e){
    document.getElementById('mg-body').innerHTML='<span style="color:var(--red)">No se pudo calcular: '
      +npEsc(String(e.message||e).slice(0,170))+'</span>';
  }
}


// ════════════════════════════════════════════════════════════════════
//  VIABILIDAD DEL PEDIDO
//  Se lee un pedido de SAP y se reparte segun el stock de hoy:
//    · lo que hay          -> pedido inmediato
//    · lo que viene        -> pedido futuro
//    · lo agotado          -> sugerencias de reemplazo con IA
//  Lo parcial se decide linea por linea: dejarlo o sustituirlo.
// ════════════════════════════════════════════════════════════════════
var VB = null;      // {docnum, cliente, lineas:[...]}

async function vbCargar(){
  var num = (document.getElementById('vb-num')||{}).value;
  num = String(num||'').trim();
  var msg = document.getElementById('vb-msg');
  var res = document.getElementById('vb-res');
  if(!num){ if(msg){ msg.style.color='var(--red)'; msg.textContent='Escribe el n\u00famero de pedido.'; } return; }

  if(msg){ msg.style.color='var(--text3)'; msg.innerHTML='<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:7px"></div>Leyendo el pedido\u2026'; }
  res.innerHTML='';

  try{
    var lin = await qAll('pedidos',
      'select=docnum,docdate,cardcode,cardname,linenum,itemcode,dscription,quantity,openqty,price,pricebefdi,descuentolinea,linetotal,docstatus'
      +'&docnum=eq.'+encodeURIComponent(num)+'&order=linenum');
    if(!lin.length){
      if(msg){ msg.style.color='var(--red)'; msg.textContent='No encontr\u00e9 el pedido '+num+'.'; }
      return;
    }

    // Stock actual de cada articulo
    var codes=[], v={};
    lin.forEach(function(l){ if(l.itemcode && !v[l.itemcode]){ v[l.itemcode]=1; codes.push(l.itemcode); } });
    var inv={};
    for(var i=0;i<codes.length;i+=200){
      var trozo=codes.slice(i,i+200);
      var inList=trozo.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      try{
        // OJO: 'grupo' NO existe en vista_inventario (vive en 'inventario'). Al
        // pedirlo, PostgREST devolvia error y el mapa de stock quedaba vacio:
        // por eso las 15 lineas salian agotadas teniendo 732 en stock.
        var r=await q('vista_inventario',
          'select=itemcode,itemname,onhand,disponible,iscommited,onorder,unidadesbulto,precioventa,marca,subg,picturname,foto_url'
          +'&itemcode=in.('+inList+')&limit='+trozo.length);
        (r||[]).forEach(function(x){ inv[x.itemcode]=x; });
        // El departamento se trae aparte, de la tabla que si lo tiene.
        try{
          var g=await q('inventario','select=itemcode,grupo&itemcode=in.('+inList+')&limit='+trozo.length);
          (g||[]).forEach(function(x){ if(inv[x.itemcode]) inv[x.itemcode].grupo=x.grupo; });
        }catch(e){}
      }catch(e){}
    }

    // Mercancia por llegar. Las columnas se llaman 'cantidad_pendiente' (no
    // openqty) y la fecha estimada vive en opor_ordenes como 'eta', no en las
    // lineas: pidiendo openqty/shipdate la consulta fallaba y salia siempre
    // "nada pendiente de llegada" teniendo 360 en camino.
    var llegadas={};
    try{
      var _in = codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var pll = await qAll('opor_lineas',
        'select=docnum,itemcode,cantidad_pendiente&cantidad_pendiente=gt.0&itemcode=in.('+_in+')');

      // Los ETA, de las ordenes de compra a las que pertenecen esas lineas.
      var etas={};
      var docs=[], vd={};
      (pll||[]).forEach(function(x){ if(x.docnum && !vd[x.docnum]){ vd[x.docnum]=1; docs.push(x.docnum); } });
      if(docs.length){
        try{
          var ords = await qAll('opor_ordenes','select=docnum,eta,estado&docnum=in.('+docs.join(',')+')');
          (ords||[]).forEach(function(o){ etas[String(o.docnum)] = String(o.eta||'').substring(0,10); });
        }catch(e){}
      }

      (pll||[]).forEach(function(x){
        var k=x.itemcode;
        if(!llegadas[k]) llegadas[k]={cant:0, fecha:null, docs:[]};
        llegadas[k].cant += Number(x.cantidad_pendiente)||0;
        if(llegadas[k].docs.indexOf(x.docnum)<0) llegadas[k].docs.push(x.docnum);
        var f = etas[String(x.docnum)] || '';
        // La primera llegada manda: es cuando se puede empezar a servir.
        if(f && (!llegadas[k].fecha || f < llegadas[k].fecha)) llegadas[k].fecha = f;
      });
    }catch(e){ console.warn('[viabilidad] no pude leer mercancia por llegar:', e); }

    VB = {
      docnum: lin[0].docnum,
      docdate: String(lin[0].docdate||'').substring(0,10),
      cardcode: lin[0].cardcode,
      cardname: lin[0].cardname,
      cerrado: String(lin[0].docstatus)!=='O',
      lineas: lin.map(function(l){
        var a = inv[l.itemcode] || {};
        // Se trabaja sobre lo que queda PENDIENTE de entregar, no sobre la
        // cantidad original: si ya se sirvio parte, esa no hay que resolverla.
        var pedida = Number(l.openqty);
        if(!(pedida > 0)) pedida = Number(l.quantity)||0;
        // Cuanto se puede servir HOY. 'disponible' ya descuenta lo comprometido,
        // pero parte de eso es este mismo pedido: si no se devuelve, se cuenta
        // dos veces y el pedido parece imposible de servir.
        //
        // En SAP se ve claro: la linea 1 tiene 24 en stock y 48 comprometidas,
        // que son justo las 48 de este pedido. Lo servible son 24, no 24-48.
        var _onhand = Number(a.onhand);
        var _disp   = Number(a.disponible);
        var disp;
        if(isFinite(_disp)){
          disp = _disp + (Number(l.quantity)||0);          // se devuelve lo propio
          if(isFinite(_onhand)) disp = Math.min(disp, _onhand);  // nunca mas que lo fisico
        } else {
          disp = _onhand;
        }
        disp = Math.max(0, Number(disp)||0);
        var sirve = Math.min(pedida, disp);
        var falta = pedida - sirve;
        var lle = llegadas[l.itemcode] || {cant:0, fecha:null};

        // El precio que manda es el del PEDIDO ORIGINAL ya con su descuento.
        // 'price' en SAP es el precio despues del descuento de linea; se
        // comprueba contra linetotal/quantity por si acaso, que es el importe
        // real que se cobro.
        var _cantOrig = Number(l.quantity)||0;
        var _lt = Number(l.linetotal)||0;
        var _pu = Number(l.price)||0;
        if(_cantOrig > 0 && _lt > 0){
          var _calc = _lt / _cantOrig;
          // Si difieren mas de un centimo, manda el de linetotal: es el que
          // cuadra con el total del documento.
          if(Math.abs(_calc - _pu) > 0.01) _pu = _calc;
        }

        return {
          itemcode: l.itemcode,
          linenum: Number(l.linenum)||0,
          descuento: Number(l.descuentolinea)||0,
          precioLista0: Number(l.pricebefdi)||_pu,   // antes del descuento
          cantOriginal: _cantOrig,                    // lo que dice el pedido
          totalOriginal: _lt,                         // importe de esa linea
          nombre: l.dscription || a.itemname || l.itemcode,
          precio: _pu,                                // con descuento aplicado
          pedida: pedida,
          disponible: disp,
          sirve: sirve,
          falta: falta,
          porLlegar: Math.min(falta, lle.cant),
          enCamino: lle.cant,
          llegada: lle.fecha,
          ocs: lle.docs || [],
          bulto: Number(a.unidadesbulto)||0,
          marca: a.marca||'', subg: a.subg||'', grupo: a.grupo||'',
          precioLista: Number(a.precioventa)||0,
          picturname: a.picturname||'', foto_url: a.foto_url||'',
          // Decision del usuario para las lineas incompletas:
          //   'servir'    -> mandar lo que hay y olvidar el resto
          //   'futuro'    -> lo que falta va al pedido futuro
          //   'sustituir' -> buscar reemplazo para lo que falta
          decision: null,
          sustituto: null
        };
      })
    };

    if(msg) msg.textContent='';
    vbRender();
  }catch(e){
    if(msg){ msg.style.color='var(--red)'; msg.textContent='No se pudo leer: '+String(e.message||e).slice(0,140); }
  }
}

// Cada linea cae en uno de cuatro estados.
function _vbEstado(l){
  if(l.falta <= 0)            return 'completo';   // hay de todo
  if(l.sirve > 0)             return 'parcial';    // hay una parte
  if(l.porLlegar > 0)         return 'llega';      // nada ahora, pero viene
  return 'agotado';                                // nada y no viene
}

function vbRender(){
  var res = document.getElementById('vb-res'); if(!res || !VB) return;

  var L = VB.lineas;
  var comp = L.filter(function(l){ return _vbEstado(l)==='completo'; });
  var parc = L.filter(function(l){ return _vbEstado(l)==='parcial'; });
  var lleg = L.filter(function(l){ return _vbEstado(l)==='llega'; });
  var agot = L.filter(function(l){ return _vbEstado(l)==='agotado'; });

  // Lo que se puede facturar ya: lo completo, mas la parte servible de lo
  // parcial (salvo que se haya elegido sustituirlo entero).
  var vYa=0, vFut=0, vSin=0;
  L.forEach(function(l){
    vYa  += l.sirve * l.precio;
    vFut += Math.min(l.falta, l.porLlegar) * l.precio;
    vSin += Math.max(0, l.falta - l.porLlegar) * l.precio;
  });
  var vTot = vYa + vFut + vSin;
  var pctYa = vTot > 0 ? (vYa/vTot*100) : 0;

  res.innerHTML =
     '<div class="card" style="margin-bottom:12px">'
      +'<div style="display:flex;gap:22px;flex-wrap:wrap;align-items:flex-start">'
        +'<div style="flex:1;min-width:220px">'
          +'<div style="font-size:16px;font-weight:800">Pedido '+npEsc(String(VB.docnum))+'</div>'
          +'<div style="font-size:12.5px;color:var(--text3);margin-top:2px">'
            +npEsc(VB.cardname||'')+' \u00b7 '+_plFechaLbl(VB.docdate)
            +(VB.cerrado?' \u00b7 <span style="color:var(--amber)">pedido cerrado</span>':'')
          +'</div>'
        +'</div>'
        +_vbKpi('Se sirve ya', fmt(vYa), 'var(--green)')
        +_vbKpi('Queda para despu\u00e9s', fmt(vFut), 'var(--amber)')
        +_vbKpi('Sin cubrir', fmt(vSin), vSin>0.005?'var(--red)':'var(--text3)')
        +_vbKpi('Del pedido', pctYa.toFixed(0)+'%', 'var(--text)')
      +'</div>'
      // Barra con el reparto, para verlo de un vistazo
      +'<div style="display:flex;height:9px;border-radius:5px;overflow:hidden;margin-top:13px;background:var(--surface2,#F1F2F4)">'
        +'<span style="width:'+(vTot?vYa/vTot*100:0)+'%;background:var(--green)"></span>'
        +'<span style="width:'+(vTot?vFut/vTot*100:0)+'%;background:#F59E0B"></span>'
        +'<span style="width:'+(vTot?vSin/vTot*100:0)+'%;background:#DC2626"></span>'
      +'</div>'
      +'<div style="font-size:11.5px;color:var(--text3);margin-top:6px">'
        +L.length+' l\u00ednea(s) \u00b7 '+comp.length+' completas \u00b7 '+parc.length+' parciales \u00b7 '
        +lleg.length+' por llegar \u00b7 '+agot.length+' agotadas</div>'
      + ((vYa>0.005 || vFut>0.005)
          ? ('<div style="margin-top:12px;padding-top:11px;border-top:1px solid var(--border)">'
             +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:9px">'
             +'Son <b>dos pedidos distintos</b>: uno se factura ya y el otro espera a la mercanc\u00eda. '
             +'El pedido <b>'+npEsc(String(VB.docnum))+'</b> no se modifica.</div>'
             +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">'
             + ((vYa>0.005 && vFut>0.005)
                 ? ('<button class="btn btn-sm" onclick="vbGuardarAmbos()">'
                    +'\u{1F4BE} Guardar las dos como borrador</button>'
                    +'<button class="btn btn-sm btn-p" onclick="vbCotizarAmbas()">'
                    +'\u{1F4E4} Enviar las dos a SAP</button>')
                 : '')
             + (agot.length || parc.length || lleg.length
                 ? ('<button class="btn btn-sm" onclick="vbExcelAgotados()" '
                    +'title="Los que no se pueden servir completos">'
                    +'\u2b07 Excel de faltantes</button>')
                 : '')
             +'<button class="btn btn-sm" onclick="vbExcelReemplazos()" '
                +'title="Las sugerencias de la IA con el art\u00edculo que las origin\u00f3">'
                +'\u2b07 Excel de reemplazos</button>'
             +'</div></div>')
          : '')
      +'<div id="vb-aviso"></div>'
    +'</div>'

    +'<div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-start">'
      +'<div style="flex:1;min-width:330px">'+_vbPanelAhora(comp, parc, agot)+'</div>'
      +'<div style="flex:1;min-width:330px">'+_vbPanelFuturo(parc, lleg)+'</div>'
    +'</div>';
}

function _vbKpi(t, v, c){
  return '<div><div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">'+t+'</div>'
    +'<div style="font-size:19px;font-weight:800;color:'+(c||'var(--text)')+'">'+v+'</div></div>';
}

// Foto + codigo pulsable, igual en las lineas del pedido y en las sugerencias.
function _vbArt(code, nombre, picturname, foto_url){
  var cs = String(code).replace(/'/g,"\\'");
  return '<td style="min-width:190px"><div style="display:flex;gap:8px;align-items:flex-start">'
    + (typeof fotoThumb==='function'
        ? ('<div style="flex:0 0 auto">'+fotoThumb(picturname||'', foto_url||'')+'</div>')
        : '')
    + '<div style="min-width:0">'
      + '<b style="font-size:11.5px;color:var(--blue2);cursor:pointer;text-decoration:underline" '
      + 'onclick="verItem(\''+cs+'\')" title="Ver la ficha del art\u00edculo">'+npEsc(code)+'</b>'
      + '<div style="font-size:11px;color:var(--text3);line-height:1.3">'+npEsc(String(nombre||'').substring(0,44))+'</div>'
    + '</div></div></td>';
}

// ctrl: si se pasa, la celda de cantidad es editable por bultos.
function _vbFila(l, cant, extra, ctrl){
  var desc = Number(l.descuento)||0;
  return '<tr>'
    + _vbArt(l.itemcode, l.nombre, l.picturname, l.foto_url)
    // Lo que decia el pedido original, para poder compararlo de un vistazo.
    +'<td style="text-align:right;font-size:11.5px;color:var(--text3)">'
      + fmtN(l.cantOriginal||l.pedida)
      + '<div style="font-size:10.5px">' + fmt(l.totalOriginal||0) + '</div></td>'
    +'<td style="text-align:right;min-width:120px">'+(ctrl || fmtN(cant))+'</td>'
    +'<td style="text-align:right">'+fmt(l.precio)
      + (desc > 0
          ? ('<div style="font-size:10px;color:var(--green)">\u2212'+desc.toFixed(0)+'%</div>')
          : '')
      +'</td>'
    +'<td style="text-align:right;font-weight:600">'+fmt(cant*l.precio)+'</td>'
    +(extra||'')
    +'</tr>';
}

// ── Panel izquierdo: lo que sale ahora ────────────────────────────────────
function _vbPanelAhora(comp, parc, agot){
  var filas = '';

  comp.forEach(function(l){
    var i = VB.lineas.indexOf(l);
    filas += _vbFila(l, l.sirve,
      '<td><span class="badge b-green">completo</span></td>',
      _vbCantCtrl(i, 'ahora', l.sirve, l.bulto, l.disponible));
  });

  // Parciales: hay una parte. El vendedor decide que hacer con lo que falta.
  parc.forEach(function(l){
    var i = VB.lineas.indexOf(l);
    filas += _vbFila(l, l.sirve,
      '<td><span class="badge b-amber">'+fmtN(l.sirve)+' de '+fmtN(l.pedida)+'</span>'
      +'<div style="font-size:10.5px;color:var(--text3);margin-top:3px">faltan '+fmtN(l.falta)+'</div></td>');
    filas += '<tr><td colspan="6" style="padding:0 0 10px 0;border:0">'
      + _vbOpciones(i, l) + '</td></tr>';
  });

  // Agotados: no hay del original, pero si puede haber reemplazo.
  agot.forEach(function(l){
    var i = VB.lineas.indexOf(l);
    filas += '<tr style="background:#FEF2F2">'
      + _vbArt(l.itemcode, l.nombre, l.picturname, l.foto_url)
      +'<td style="text-align:right;font-size:11.5px;color:var(--text3)">'+fmtN(l.cantOriginal||l.pedida)
        +'<div style="font-size:10.5px">'+fmt(l.totalOriginal||0)+'</div></td>'
      +'<td style="text-align:right;color:var(--red)">0</td>'
      +'<td style="text-align:right">'+fmt(l.precio)+'</td>'
      +'<td style="text-align:right;color:var(--red)">'+fmt(0)+'</td>'
      +'<td><span class="badge" style="background:#FEE2E2;color:#991B1B">agotado</span></td></tr>';
    filas += '<tr><td colspan="6" style="padding:0 0 10px 0;border:0">'
      + _vbOpciones(i, l) + '</td></tr>';
  });

  var tot = 0;
  comp.forEach(function(l){ if(!l.quitarOriginal) tot += l.sirve*l.precio; });
  parc.forEach(function(l){ if(!l.quitarOriginal) tot += l.sirve*l.precio; });
  agot.forEach(function(l){ if(!l.quitarOriginal) tot += l.sirve*l.precio; });
  VB.lineas.forEach(function(l){
    if(l.sustituto) tot += (l.sustituto.cant||0) * (Number(l.sustituto.precio)||0);
  });

  return '<div class="card">'
    +'<div class="ch" style="flex-wrap:wrap;gap:8px"><span class="ct">\u2705 Se puede servir ahora</span>'
      +'<span style="margin-left:auto;display:flex;gap:8px;align-items:center">'
      +'<span style="font-size:13px;font-weight:700;color:var(--green)">'+fmt(tot)+'</span>'
      +(tot>0.005
         ? ('<button class="btn btn-sm" id="vb-guardar-inmediato" onclick="vbGuardar(false)" '
            +'title="Guardar como borrador, sin enviarlo a SAP">\u{1F4BE} Borrador</button>'
            +'<button class="btn btn-sm" id="vb-cot-ahora" onclick="vbCotizarSAP(false)" '
            +'title="Crear la cotizaci\u00f3n en SAP">\u{1F4E4} A cotizaci\u00f3n SAP</button>'
            +'<button class="btn btn-sm" onclick="vbExcelPanel(false)" '
            +'style="background:var(--green);color:#fff;border-color:var(--green)" '
            +'title="Descargar este panel en Excel">\u2b07 Excel</button>'
            +'<button class="btn btn-sm btn-p" onclick="vbAlCarrito(false)" '
            +'title="Abrir en el carrito para editarla antes">Abrir</button>')
         : '')
      +'</span></div>'
    + (filas
        ? ('<div style="overflow-x:auto"><table class="tbl">'
           +'<tr><th>Art\u00edculo</th>'
           +'<th style="text-align:right">Ped\u00eda</th>'
           +'<th style="text-align:right">Se manda</th>'
           +'<th style="text-align:right">Precio</th><th style="text-align:right">Total</th><th>Estado</th></tr>'
           + filas + '</table></div>')
        : '<div style="padding:22px;text-align:center;color:var(--text3);font-size:13px">Nada disponible ahora.</div>')
    +'</div>';
}

// ── Panel derecho: pedido futuro ──────────────────────────────────────────
function _vbPanelFuturo(parc, lleg){
  var filas = '', tot = 0, sinFecha = 0;

  function agrega(l, cant){
    if(cant <= 0) return;
    var i = VB.lineas.indexOf(l);
    tot += cant * l.precio;
    if(!l.llegada) sinFecha++;
    var dias = l.llegada ? _plDias(l.llegada) : null;
    // El tope aqui es generoso: se puede pedir mas de lo que viene en camino,
    // porque entraria en la siguiente orden de compra.
    var tope = Math.max(l.enCamino || 0, l.pedida) * 10;
    filas += _vbFila(l, cant,
      '<td style="white-space:nowrap">'
      + (l.llegada
          ? ('<b style="font-size:11.5px">'+_plFechaLbl(l.llegada)+'</b>'
             + (dias!=null ? ('<div style="font-size:10.5px;color:'+(dias<0?'var(--red)':'var(--text3)')+'">'
                 + (dias<0 ? ('atrasado '+Math.abs(dias)+'d') : ('en '+dias+' d\u00edas')) + '</div>') : ''))
          : '<span style="color:var(--text3);font-size:11.5px">sin fecha</span>')
      + (l.ocs && l.ocs.length
          ? ('<div style="font-size:10px;color:var(--text3);margin-top:2px">OC '
             + l.ocs.slice(0,2).map(function(d){ return npEsc(String(d)); }).join(', ')
             + (l.ocs.length>2 ? ' +'+(l.ocs.length-2) : '') + '</div>')
          : '')
      + (cant > (l.enCamino||0)
          ? ('<div style="font-size:10px;color:var(--amber);margin-top:2px">'
             + 'm\u00e1s de lo que viene</div>')
          : '')
      +'</td>',
      _vbCantCtrl(i, 'futuro', cant, l.bulto, tope));
  }

  // De las parciales solo entra lo que el vendedor mando a futuro.
  // Si se ajusto la cantidad a mano, esa manda sobre la automatica.
  function _cant(l){
    return l.futuroCant != null ? l.futuroCant : Math.min(l.falta, l.porLlegar);
  }
  parc.forEach(function(l){ if(l.decision==='futuro') agrega(l, _cant(l)); });
  lleg.forEach(function(l){ agrega(l, _cant(l)); });

  return '<div class="card">'
    +'<div class="ch" style="flex-wrap:wrap;gap:8px"><span class="ct">\u{1F69A} Pedido futuro \u00b7 mercanc\u00eda por llegar</span>'
      +'<span style="margin-left:auto;display:flex;gap:8px;align-items:center">'
      +'<span style="font-size:13px;font-weight:700;color:#D97706">'+fmt(tot)+'</span>'
      +(tot>0.005
         ? ('<button class="btn btn-sm" id="vb-guardar-futuro" onclick="vbGuardar(true)" '
            +'title="Guardar como borrador, sin enviarlo a SAP">\u{1F4BE} Borrador</button>'
            +'<button class="btn btn-sm" id="vb-cot-futuro" onclick="vbCotizarSAP(true)" '
            +'title="Crear la cotizaci\u00f3n en SAP">\u{1F4E4} A cotizaci\u00f3n SAP</button>'
            +'<button class="btn btn-sm" onclick="vbExcelPanel(true)" '
            +'style="background:var(--green);color:#fff;border-color:var(--green)" '
            +'title="Descargar este panel en Excel">\u2b07 Excel</button>'
            +'<button class="btn btn-sm" onclick="vbAlCarrito(true)" '
            +'title="Abrir en el carrito para editarla antes">Abrir</button>')
         : '')
      +'</span></div>'
    + (filas
        ? ('<div style="overflow-x:auto"><table class="tbl">'
           +'<tr><th>Art\u00edculo</th>'
           +'<th style="text-align:right">Ped\u00eda</th>'
           +'<th style="text-align:right">Se pide</th>'
           +'<th style="text-align:right">Precio</th><th style="text-align:right">Total</th><th>Llegada</th></tr>'
           + filas + '</table></div>'
           + (sinFecha
               ? ('<div style="font-size:11.5px;color:var(--amber);margin-top:9px">'
                  + sinFecha + ' art\u00edculo(s) sin fecha de llegada confirmada en la orden de compra.</div>')
               : ''))
        : '<div style="padding:22px;text-align:center;color:var(--text3);font-size:13px">'
          +'Nada pendiente de llegada.</div>')
    +'</div>';
}

// ── Qué hacer con una línea incompleta ────────────────────────────────────
// Todo editable y combinable: se puede quedar con parte del original, poner
// un reemplazo, las dos cosas, o quitar el original del todo.
function _vbOpciones(i, l){
  var su = l.sustituto;
  var pedida = l.pedida;
  var hay = l.disponible;
  var quita = (l.quitarOriginal === true);
  var delOrig = quita ? 0 : l.sirve;
  var cubierto = delOrig + (su ? su.cant : 0);
  var pendiente = Math.max(0, pedida - cubierto);

  var html = '<div style="background:var(--surface2,#F7F7F8);border-radius:9px;padding:11px 13px">';

  // ── Resumen de la situacion ────────────────────────────────────────────
  html += '<div style="display:flex;gap:20px;flex-wrap:wrap;padding-bottom:10px;'
    +'border-bottom:1px solid var(--border);margin-bottom:10px">'
    +'<div><div style="font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Ped\u00eda el pedido</div>'
      +'<div style="font-size:16px;font-weight:800">'+fmtN(pedida)+'</div></div>'
    +'<div><div style="font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Hay hoy</div>'
      +'<div style="font-size:16px;font-weight:800;color:'+(hay>0?'var(--amber)':'var(--red)')+'">'+fmtN(hay)+'</div></div>'
    +'<div><div style="font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Cubierto</div>'
      +'<div style="font-size:16px;font-weight:800;color:'+(pendiente<=0?'var(--green)':'var(--text)')+'">'
      +fmtN(cubierto)+'</div></div>'
    + (pendiente > 0
        ? ('<div><div style="font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.4px">Falta</div>'
           +'<div style="font-size:16px;font-weight:800;color:var(--red)">'+fmtN(pendiente)+'</div></div>')
        : '')
    +'</div>';

  // ── 1. El articulo original ────────────────────────────────────────────
  html += '<div style="display:flex;gap:10px;align-items:flex-start;flex-wrap:wrap;margin-bottom:10px">'
    +'<div style="flex:1;min-width:170px">'
      +'<div style="font-size:12px;font-weight:600">'
      + (quita ? '<span style="color:var(--red);text-decoration:line-through">' : '')
      + npEsc(l.itemcode)
      + (quita ? '</span> <span style="color:var(--red);font-size:11px">quitado</span>' : '')
      +'</div>'
      +'<div style="font-size:11px;color:var(--text3);margin-top:2px">'
      + (quita ? 'No se manda nada de este art\u00edculo.'
               : ('Se manda lo que haya, hasta '+fmtN(hay)+'.'))
      +'</div>'
      +'<button class="btn btn-sm" style="padding:2px 9px;margin-top:6px" '
        + 'onclick="vbQuitarOriginal('+i+')">'
        + (quita ? '\u21a9 Volver a incluirlo' : '\u2715 Quitar este art\u00edculo')
        + '</button>'
    +'</div>'
    + (quita ? '' : ('<div>'+_vbCantCtrl(i, 'ahora', l.sirve, l.bulto, hay)+'</div>'))
    +'</div>';

  // ── 2. El reemplazo ────────────────────────────────────────────────────
  if(su){
    html += '<div style="display:flex;gap:10px;align-items:flex-start;flex-wrap:wrap;'
      +'background:#ECFDF5;border:1px solid #A7F3D0;border-radius:8px;padding:9px 11px;margin-bottom:10px">'
      +'<div style="flex:1;min-width:170px">'
        +'<div style="font-size:12px;font-weight:600;color:#065F46">'+npEsc(su.itemcode)+'</div>'
        +'<div style="font-size:11px;color:var(--text3);margin-top:2px">'
        +npEsc(String(su.nombre||'').substring(0,46))+'</div>'
        +'<div style="font-size:11.5px;margin-top:3px">'+fmt(su.precio)+' c/u \u00b7 <b>'
        +fmt(su.cant*su.precio)+'</b> \u00b7 hay '+fmtN(su.stock)+'</div>'
        +'<div style="display:flex;gap:5px;margin-top:6px;flex-wrap:wrap">'
          +'<button class="btn btn-sm" style="padding:2px 9px" onclick="vbSugerir('+i+')">Cambiar</button>'
          +'<button class="btn btn-sm" style="padding:2px 9px" onclick="vbQuitarSust('+i+')">Quitar</button>'
        +'</div>'
      +'</div>'
      // El tope es su stock: se puede pedir mas de lo que falta si se quiere.
      +'<div>'+_vbCantCtrl(i, 'sust', su.cant, su.bulto, su.stock)+'</div>'
      +'</div>';
  }

  // ── 3. Lo que queda ────────────────────────────────────────────────────
  html += '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">';
  if(!su){
    html += '<button class="btn btn-sm btn-p" onclick="vbSugerir('+i+')">'
      +'\u{1F916} Buscar reemplazo</button>';
  }
  if(pendiente > 0 && l.porLlegar > 0){
    html += '<button class="btn btn-sm'+(l.decision==='futuro'?' btn-p':'')+'" '
      +'onclick="vbDecidir('+i+',\'futuro\')">'
      +'\u{1F69A} '+fmtN(Math.min(pendiente,l.porLlegar))+' para cuando llegue</button>';
  }
  if(pendiente > 0){
    html += '<span style="font-size:11.5px;color:var(--text3)">'
      +'o se cierra con '+fmtN(cubierto)+' de '+fmtN(pedida)+'</span>';
  } else if(cubierto > 0){
    html += '<span style="font-size:11.5px;color:var(--green);font-weight:600">'
      +'\u2713 Cubierto</span>';
  }
  html += '</div>';

  html += '<div id="vb-sug-'+i+'"></div></div>';
  return html;
}

// Quita (o devuelve) el articulo original de la linea. Util cuando el
// reemplazo lo cubre todo y no interesa mandar las pocas que quedan.
function vbQuitarOriginal(i){
  var l = VB.lineas[i];
  l.quitarOriginal = !l.quitarOriginal;
  vbRender();
}

function vbDecidir(i, d){
  VB.lineas[i].decision = (VB.lineas[i].decision===d) ? null : d;
  vbRender();
}

function vbQuitarSust(i){
  VB.lineas[i].sustituto = null;
  VB.lineas[i].decision = null;
  vbRender();
}

// ── Sugerencias de reemplazo con IA ───────────────────────────────────────
// Se reutiliza la tarea 'reemplazos' que ya usa el restock: mismo prompt y
// mismo formato, asi las sugerencias son coherentes en todo el portal.
async function vbSugerir(i){
  var l = VB.lineas[i];
  var cont = document.getElementById('vb-sug-'+i);
  if(!cont) return;

  // Si ya estan, se pliegan.
  if(cont.dataset.abierto==='1'){ cont.innerHTML=''; cont.dataset.abierto='0'; return; }
  cont.dataset.abierto='1';
  cont.innerHTML='<div style="padding:9px 0;font-size:12px;color:var(--blue2)">'
    +'<div class="spinner" style="display:inline-block;vertical-align:middle;margin-right:7px"></div>'
    +'Buscando art\u00edculos parecidos con stock\u2026</div>';

  try{
    // Candidatos, en circulos cada vez mas amplios hasta reunir suficientes.
    //
    // Antes se exigia stock para TODA la cantidad que faltaba y ademas la
    // misma familia: si faltaban 72 frutas artificiales, se descartaba todo
    // lo que tuviera menos de 72 y salia "no hay reemplazos" teniendo cientos
    // de articulos parecidos. Ahora basta con que haya algo de stock, y si un
    // candidato no cubre todo, se dice cuanto cubre.
    var cand = [], vistos = {};
    function _sumar(arr){
      (arr||[]).forEach(function(c){
        if(!c || c.itemcode===l.itemcode || vistos[c.itemcode]) return;
        vistos[c.itemcode] = 1;
        cand.push(c);
      });
    }
    var SEL = 'select=itemcode,itemname,precioventa,disponible,unidadesbulto,marca,subg,caracteristicas,picturname,foto_url';

    // 1. Misma familia (subgrupo), lo que mas stock tenga.
    if(l.subg){
      try{ _sumar(await q('vista_inventario',
        SEL+'&subg=eq.'+encodeURIComponent(l.subg)+'&disponible=gt.0&order=disponible.desc&limit=90')); }catch(e){}
    }
    // 2. Mismo departamento.
    if(cand.length < 60 && l.grupo){
      try{ _sumar(await q('vista_inventario',
        SEL+'&grupo=eq.'+encodeURIComponent(l.grupo)+'&disponible=gt.0&order=disponible.desc&limit=90')); }catch(e){}
    }
    // 3. Por palabras del nombre: "FRUTA ARTIFICIAL (LIMON)" busca por "fruta"
    //    y por "artificial", que es lo que de verdad acota el parecido.
    if(cand.length < 60){
      var pal = String(l.nombre).toUpperCase()
        .replace(/[^A-ZÑ0-9 ]/g,' ').split(/\s+/)
        .filter(function(p){ return p.length > 3; })
        .slice(0, 2);
      for(var pi=0; pi<pal.length && cand.length < 90; pi++){
        try{ _sumar(await q('vista_inventario',
          SEL+'&itemname=ilike.*'+encodeURIComponent(pal[pi])+'*&disponible=gt.0&order=disponible.desc&limit=70')); }catch(e){}
      }
    }
    // 4. Misma marca, por si es una linea de producto reconocible.
    if(cand.length < 40 && l.marca){
      try{ _sumar(await q('vista_inventario',
        SEL+'&marca=eq.'+encodeURIComponent(l.marca)+'&disponible=gt.0&order=disponible.desc&limit=70')); }catch(e){}
    }
    // 5. Ultimo recurso: precio parecido. Un articulo de precio similar suele
    //    servir mejor que uno diez veces mas caro.
    if(cand.length < 25){
      var pref = l.precioLista || l.precio || 0;
      if(pref > 0){
        try{ _sumar(await q('vista_inventario',
          SEL+'&precioventa=gte.'+(pref*0.5).toFixed(2)+'&precioventa=lte.'+(pref*1.8).toFixed(2)
          +'&disponible=gt.0&order=disponible.desc&limit=70')); }catch(e){}
      }
    }

    // Los que cubren toda la cantidad van primero: la IA los vera antes.
    cand.sort(function(a,b){
      var ca = (Number(a.disponible)||0) >= l.falta ? 1 : 0;
      var cb = (Number(b.disponible)||0) >= l.falta ? 1 : 0;
      if(ca !== cb) return cb - ca;
      return (Number(b.disponible)||0) - (Number(a.disponible)||0);
    });
    cand = cand.slice(0, 160);

    if(!cand.length){
      cont.innerHTML='<div style="padding:9px 0;font-size:12px;color:var(--amber)">'
        +'No encontr\u00e9 ning\u00fan art\u00edculo con stock para sugerir.</div>';
      return;
    }

    var lista = cand.map(function(c){
      var ub = Math.max(1, Number(c.unidadesbulto)||1);
      var d  = Number(c.disponible)||0;
      return [c.itemcode, String(c.itemname||'').slice(0,60), (Number(c.precioventa)||0).toFixed(2),
              c.marca||'?', c.subg||'?',
              'stock:'+d,
              'bultos:'+Math.floor(d/ub),
              (d >= l.falta ? 'CUBRE-TODO' : ('cubre-'+d+'-de-'+l.falta)),
              String(c.caracteristicas||'').slice(0,50)].join(' | ');
    }).join('\n');

    var usuario='PRODUCTO AGOTADO:\n'
      +'SKU: '+l.itemcode+'\nDescripcion: '+l.nombre+'\n'
      +'Precio de etiqueta: '+(l.precioLista||l.precio).toFixed(2)+'\n'
      +'Familia: '+(l.subg||'?')+'\nMarca: '+(l.marca||'?')+'\n'
      +'Faltan '+l.falta+' unidades.\n\n'
      +'Devuelve SIEMPRE 20 sugerencias, de la mas parecida a la menos. Aunque ninguna sea '
      +'igual, elige lo que mas se le acerque: un vendedor prefiere ver alternativas '
      +'imperfectas a no ver nada. Prioriza las marcadas CUBRE-TODO, pero incluye tambien '
      +'las que cubran solo una parte si son mas parecidas.\n\n'
      +'CANDIDATOS (sku | descripcion | precio | marca | familia | stock | bultos | cobertura | caracteristicas):\n'+lista;

    var arr = await iaLlamar('reemplazos', usuario);
    if(!Array.isArray(arr) || !arr.length){
      cont.innerHTML='<div style="padding:9px 0;font-size:12px;color:var(--amber)">'
        +'La IA no encontr\u00f3 un reemplazo claro.</div>';
      return;
    }

    var porCode={}; cand.forEach(function(c){ porCode[c.itemcode]=c; });

    // Se guardan para poder exportarlas a Excel despues, sin volver a
    // preguntarle a la IA.
    l.sugerencias = arr.map(function(su){
      var c = porCode[su.sku];
      if(!c) return null;
      return {itemcode:c.itemcode, nombre:c.itemname, precio:Number(c.precioventa)||0,
              stock:Number(c.disponible)||0, bulto:Number(c.unidadesbulto)||1,
              marca:c.marca||'', razon:su.razon||''};
    }).filter(Boolean);
    var filas = arr.map(function(su){
      var c = porCode[su.sku];
      if(!c) return '';    // la IA no debe inventar SKUs, pero por si acaso
      var ub = Math.max(1, Number(c.unidadesbulto)||1);
      // Lo que este candidato puede cubrir de verdad: puede no llegar a todo.
      var cubre = Math.min(l.falta, Number(c.disponible)||0);
      var cs = String(c.itemcode).replace(/'/g,"\\'");
      var nm = String(c.itemname||'').replace(/['"\\]/g,' ');
      var dif = (Number(c.precioventa)||0) - (l.precioLista || l.precio);
      return '<tr>'
        + _vbArt(c.itemcode, c.itemname, c.picturname, c.foto_url).replace('</div></div></td>',
            (su.razon ? ('<div style="font-size:10.5px;color:var(--blue2);margin-top:2px">'+npEsc(su.razon)+'</div>') : '')
            + '</div></div></td>')
        +'<td style="text-align:right">'+fmt(c.precioventa)
          + (Math.abs(dif) > 0.005
              ? ('<div style="font-size:10.5px;color:'+(dif>0?'var(--red)':'var(--green)')+'">'
                 + (dif>0?'+':'') + fmt(dif) + '</div>')
              : '')
        +'</td>'
        +'<td style="text-align:right">'+fmtN(c.disponible)
          +'<div style="font-size:10.5px;color:'+(cubre>=l.falta?'var(--green)':'var(--amber)')+'">'
          +(cubre>=l.falta ? 'cubre todo' : ('solo '+fmtN(cubre)+' de '+fmtN(l.falta)))+'</div></td>'
        +'<td><button class="btn btn-sm btn-p" onclick="vbSustituir('+i+',\''+cs+'\',\''+nm+'\','
          +(Number(c.precioventa)||0)+','+cubre+','+ub+','+(Number(c.disponible)||0)+')">'
          +'Usar '+fmtN(cubre)+'</button></td>'
        +'</tr>';
    }).filter(Boolean).join('');

    cont.innerHTML='<div style="margin-top:9px;border-top:1px solid var(--border);padding-top:9px">'
      +'<div style="font-size:11.5px;color:var(--text3);margin-bottom:6px">'
      +'\u{1F916} '+arr.length+' sugerencia(s), de la m\u00e1s parecida a la menos:</div>'
      +'<div style="max-height:280px;overflow-y:auto"><table class="tbl">'
      +'<tr><th>Art\u00edculo</th><th style="text-align:right">Precio</th>'
      +'<th style="text-align:right">Stock</th><th></th></tr>'
      + filas + '</table></div></div>';
  }catch(e){
    cont.innerHTML='<div style="padding:9px 0;font-size:12px;color:var(--red)">'
      +'No se pudo consultar: '+npEsc(String(e.message||e).slice(0,120))+'</div>';
  }
}

function vbSustituir(i, code, nombre, precio, cant, bulto, stock){
  var l = VB.lineas[i];
  // Arranca cubriendo lo que falta DESPUES de lo que se sirve del original:
  // si se quedan 24 de 48, el sustituto propone 24, no 48. La cantidad se
  // puede ajustar despues con los botones de bulto.
  var pendiente = Math.max(0, l.pedida - (l.quitarOriginal ? 0 : l.sirve));
  var c = Math.min(Number(cant) || pendiente, pendiente, Number(stock) || Infinity);
  l.sustituto = {itemcode:code, nombre:nombre, precio:Number(precio)||0,
                 cant:Math.max(0, c),
                 bulto:Number(bulto)||1, stock:Number(stock)||0};
  l.decision = 'sustituir';
  vbRender();
}

// Las lineas de cada panel, listas para guardar o cotizar.
function _vbLineas(futuro){
  var out = [];
  (VB ? VB.lineas : []).forEach(function(l){
    if(futuro){
      var auto = Math.min(l.falta, l.porLlegar);
      // Si el vendedor cambio la cantidad a mano, esa manda.
      var c = (_vbEstado(l)==='llega' || l.decision==='futuro')
        ? (l.futuroCant != null ? l.futuroCant : auto) : 0;
      if(c > 0) out.push({code:l.itemcode, nombre:l.nombre, precio:l.precio, cant:c});
    } else {
      // Si se quito el original de la linea, no se manda aunque haya stock.
      if(l.sirve > 0 && !l.quitarOriginal){
        out.push({code:l.itemcode, nombre:l.nombre, precio:l.precio, cant:l.sirve});
      }
      if(l.sustituto && l.sustituto.cant > 0){
        out.push({code:l.sustituto.itemcode, nombre:l.sustituto.nombre,
                  precio:l.sustituto.precio, cant:l.sustituto.cant});
      }
    }
  });
  return out;
}

// Guarda un panel como borrador SIN salir de la pantalla: asi se pueden
// guardar los dos, uno detras de otro, sin perder el analisis. Antes, al
// pasar uno a la cotizacion se cambiaba de pantalla y el otro se perdia.
async function vbGuardar(futuro){
  if(!VB) return;
  var lineas = _vbLineas(futuro);
  if(!lineas.length){ alert('Ese panel no tiene l\u00edneas.'); return; }

  var etiqueta = futuro ? 'futuro' : 'inmediato';
  var btn = document.getElementById('vb-guardar-'+etiqueta);
  if(btn){ btn.disabled = true; btn.textContent = 'Guardando\u2026'; }

  try{
    var cuerpo = {
      usuario: (CU && CU.username) || 'portal',
      cardcode: VB.cardcode || null,
      cardname: VB.cardname || null,
      docdate: hoyLocal(),
      currency: 'USD',
      comments: futuro
        ? ('Pedido futuro \u00b7 por llegar \u00b7 del pedido ' + VB.docnum)
        : ('Disponible ahora \u00b7 del pedido ' + VB.docnum),
      discprcnt: 0,
      lineas: lineas.map(function(x, i){
        return {itemcode:x.code, itemname:x.nombre, quantity:x.cant,
                price:x.precio, discprcnt:0, linetotal:x.cant*x.precio, linenum:i};
      })
    };

    var r = await fetch(SB+'/rest/v1/pedidos_borrador',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
               'Content-Type':'application/json','Prefer':'return=minimal'},
      body: JSON.stringify(cuerpo)
    });
    if(!r.ok) throw new Error((await r.text()).slice(0,160));

    if(btn){
      btn.textContent = '\u2713 Guardado';
      btn.style.background = 'var(--green)';
      btn.style.borderColor = 'var(--green)';
      btn.style.color = '#fff';
      btn.disabled = true;
    }
    _vbAviso('Guardado como borrador. Lo encuentras en <b>Pedidos realizados y en proceso</b>.', 'green');
  }catch(e){
    if(btn){ btn.disabled = false; btn.textContent = 'Guardar'; }
    _vbAviso('No se pudo guardar: ' + String(e.message||e).slice(0,140), 'red');
  }
}

// Guarda los dos de una vez.
async function vbGuardarAmbos(){
  await vbGuardar(false);
  await vbGuardar(true);
}

// Traduce los errores de PostgREST a algo que se entienda. El mensaje crudo
// habla de "schema cache" y nombres de columna: eso no le dice nada a quien
// esta usando el portal.
function _vbErr(e){
  var t = String((e && e.message) || e || '');
  var m = t.match(/Could not find the '(\w+)' column of '(\w+)'/);
  if(m) return 'La tabla <code>'+m[2]+'</code> no tiene la columna <code>'+m[1]+'</code>. '
    + 'Av\u00edsame y lo ajusto.';
  if(/violates row-level security|permission denied/i.test(t))
    return 'No tienes permiso para esta operaci\u00f3n en la base de datos.';
  if(/duplicate key/i.test(t))
    return 'Ya hay una solicitud igual en cola. Espera a que se procese.';
  if(/Failed to fetch|NetworkError/i.test(t))
    return 'Sin conexi\u00f3n con el servidor. Int\u00e9ntalo de nuevo.';
  return 'No se pudo enviar: ' + t.slice(0,150);
}

function _vbAviso(html, color){
  var d = document.getElementById('vb-aviso');
  if(!d) return;
  var c = {green:'#065F46', red:'#991B1B', amber:'#92400E'}[color] || 'var(--text3)';
  var bg = {green:'#ECFDF5', red:'#FEF2F2', amber:'#FFFBEB'}[color] || 'var(--surface2,#F7F7F8)';
  d.style.cssText = 'margin-top:11px;padding:9px 12px;border-radius:9px;font-size:12.5px;'
    + 'background:'+bg+';color:'+c;
  d.innerHTML = html;
}

// Lleva un panel a la cotizacion abierta. Avisa si se pierde el otro, para
// que nadie se quede a medias sin saberlo.
async function vbAlCarrito(futuro){
  if(!VB) return;
  var lineas = _vbLineas(futuro);
  if(!lineas.length){ alert('Ese panel no tiene l\u00edneas.'); return; }

  var otro = _vbLineas(!futuro).length;
  if(otro && !confirm('Se abrir\u00e1 la cotizaci\u00f3n con este panel.\n\n'
      + 'El otro tiene ' + otro + ' l\u00ednea(s) y se perder\u00e1 al cambiar de pantalla.\n'
      + 'Si quieres conservarlo, cancela y pulsa GUARDAR primero.\n\n\u00bfContinuar igual?')) return;

  if(npLineas.length && !confirm('Ya tienes '+npLineas.length+' l\u00ednea(s) en la cotizaci\u00f3n.\n\n'
     +'\u00bfA\u00f1adir estas '+lineas.length+' encima?')) return;

  if(!npCli && VB.cardcode){
    try{
      var c = await q('clientes','select=*&cardcode=eq.'+encodeURIComponent(VB.cardcode)+'&limit=1');
      if(c && c[0]) npSelCliente(c[0]);
    }catch(e){}
  }

  lineas.forEach(function(x){
    try{ npAgregarLineaDirecta(x.code, x.nombre, x.precio, x.cant); }catch(e){}
  });

  var _n = document.getElementById('np-comments');
  if(_n && !_n.value){
    _n.value = futuro
      ? ('Pedido futuro \u00b7 mercanc\u00eda por llegar del pedido ' + VB.docnum)
      : ('Del pedido ' + VB.docnum);
  }

  go('nuevo_pedido', document.getElementById('nav-np'));
}


// ── Enviar a SAP como cotizaciones separadas ──────────────────────────────
// Se crean DOS documentos nuevos y el pedido original NO se toca. Es mas
// limpio que modificar el que ya existe: no hay que anular lineas ni borrar
// filas, y si algo sale mal no se ha estropeado nada.

// Panel 2: crea una COTIZACION nueva en SAP con lo que viene en camino.
// Es un documento aparte, sin riesgo: no toca nada existente.
// Crea UNA cotizacion en SAP con el panel indicado.
//   futuro=false -> lo disponible ahora (con los sustitutos elegidos)
//   futuro=true  -> lo que viene en camino
async function vbCotizarSAP(futuro){
  if(!VB) return;
  var lineas = _vbLineas(futuro);
  if(!lineas.length){ alert('Ese panel no tiene l\u00edneas.'); return; }

  var nombre = futuro ? 'mercanc\u00eda por llegar' : 'disponible ahora';
  if(!confirm('Se crear\u00e1 una COTIZACI\u00d3N en SAP para ' + (VB.cardname||VB.cardcode)
      + '\ncon ' + lineas.length + ' l\u00ednea(s) \u00b7 ' + nombre + '.\n\n'
      + 'El pedido ' + VB.docnum + ' NO se modifica.\n\n\u00bfContinuar?')) return;

  return _vbEnviarCotiz(futuro, true);
}

// El envio en si. 'avisar' controla si se muestra el mensaje: al mandar las
// dos seguidas conviene un solo aviso al final, no dos.
async function _vbEnviarCotiz(futuro, avisar){
  var lineas = _vbLineas(futuro);
  if(!lineas.length) return {ok:false, msg:'panel vacio'};

  var etiqueta = futuro ? 'futuro' : 'ahora';
  var btn = document.getElementById('vb-cot-'+etiqueta);
  if(btn){ btn.disabled = true; btn.textContent = 'Enviando\u2026'; }

  try{
    var r = await fetch(SB+'/rest/v1/pedidos_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
               'Content-Type':'application/json','Prefer':'return=minimal'},
      body: JSON.stringify({
        cardcode: VB.cardcode,
        cardname: VB.cardname,
        docdate: hoyLocal(),
        currency: 'USD',
        comments: (futuro ? 'Por llegar' : 'Disponible') + ' \u00b7 del pedido ' + VB.docnum,
        discprcnt: 0,
        usuario: (CU && CU.username) || 'portal',
        estado: 'pendiente',
        lineas: lineas.map(function(x, i){
          return {itemcode:x.code, itemname:x.nombre, quantity:x.cant,
                  price:x.precio, discprcnt:0, linetotal:x.cant*x.precio, linenum:i};
        })
      })
    });
    if(!r.ok) throw new Error((await r.text()).slice(0,180));

    if(btn){
      btn.textContent = '\u2713 En cola';
      btn.style.background='var(--green)'; btn.style.borderColor='var(--green)'; btn.style.color='#fff';
    }
    if(avisar) _vbAviso('Cotizaci\u00f3n en cola. El sync la crea en SAP en el pr\u00f3ximo ciclo. '
      +'La ver\u00e1s en <b>Pedidos realizados y en proceso</b>.', 'green');
    return {ok:true};
  }catch(e){
    if(btn){ btn.disabled=false; btn.textContent='A cotizaci\u00f3n SAP'; }
    if(avisar) _vbAviso(_vbErr(e), 'red');
    return {ok:false, msg:String(e.message||e)};
  }
}

// Las dos de una vez.
async function vbCotizarAmbas(){
  if(!VB) return;
  var a = _vbLineas(false).length, b = _vbLineas(true).length;
  if(!a && !b){ alert('No hay l\u00edneas que enviar.'); return; }

  if(!confirm('Se crear\u00e1n DOS cotizaciones en SAP para ' + (VB.cardname||VB.cardcode) + ':\n\n'
      + '\u00b7 Disponible ahora: ' + a + ' l\u00ednea(s)\n'
      + '\u00b7 Por llegar: ' + b + ' l\u00ednea(s)\n\n'
      + 'El pedido ' + VB.docnum + ' NO se modifica.\n\n\u00bfContinuar?')) return;

  var r1 = a ? await _vbEnviarCotiz(false, false) : {ok:true};
  var r2 = b ? await _vbEnviarCotiz(true,  false) : {ok:true};

  if(r1.ok && r2.ok){
    _vbAviso('Las dos cotizaciones est\u00e1n en cola. El sync las crea en SAP en el '
      +'pr\u00f3ximo ciclo, como <b>documentos separados</b>.', 'green');
  } else {
    _vbAviso('Una de las dos fall\u00f3: ' + _vbErr(new Error(r1.msg || r2.msg)), 'amber');
  }
}

// ── Ajustar la cantidad por bultos ────────────────────────────────────────
// Todo se vende por bulto, asi que se sube y baja de bulto en bulto. El tope
// es lo que hay: no tiene sentido comprometer mas de lo que existe.
//
// tipo: 'ahora' (lo servible), 'sust' (el sustituto), 'futuro' (por llegar)
function _vbCantCtrl(i, tipo, cant, bulto, tope){
  var ub = Math.max(1, Number(bulto)||1);
  var b  = Math.floor((Number(cant)||0) / ub);
  var resto = (Number(cant)||0) - (b*ub);
  var maxB = Math.floor((Number(tope)||0) / ub);

  return '<div style="display:flex;align-items:center;gap:3px;justify-content:flex-end">'
    +'<button class="btn btn-sm" style="padding:1px 7px;min-width:24px" '
      +'onclick="vbBulto('+i+',\''+tipo+'\',-1)"'+(b<=0?' disabled':'')+'>\u2212</button>'
    +'<input type="number" value="'+(Number(cant)||0)+'" min="0" max="'+(Number(tope)||0)+'" '
      +'onchange="vbCant('+i+',\''+tipo+'\',this.value)" '
      +'style="width:62px;padding:3px 5px;text-align:right;border:1px solid var(--border);'
      +'border-radius:6px;font-size:12.5px">'
    +'<button class="btn btn-sm" style="padding:1px 7px;min-width:24px" '
      +'onclick="vbBulto('+i+',\''+tipo+'\',1)"'+(b>=maxB?' disabled':'')+'>+</button>'
    +'</div>'
    +'<div style="font-size:10px;color:var(--text3);text-align:right;margin-top:2px">'
    + b + ' bulto' + (b===1?'':'s') + ' de ' + ub
    + (resto > 0 ? (' <span style="color:var(--amber)">+'+resto+' suelt'+(resto===1?'a':'as')+'</span>') : '')
    + (maxB > b ? (' \u00b7 hasta ' + maxB) : '')
    + '</div>';
}

// Sube o baja un bulto entero.
function vbBulto(i, tipo, signo){
  var l = VB.lineas[i];
  var ub = Math.max(1, Number(tipo==='sust' ? (l.sustituto&&l.sustituto.bulto) : l.bulto)||1);
  var actual = _vbCantDe(l, tipo);
  // Si venia con unidades sueltas, primero se redondea al bulto mas cercano.
  var b = Math.round(actual / ub);
  vbCant(i, tipo, Math.max(0, (b + signo) * ub));
}

function _vbCantDe(l, tipo){
  if(tipo==='sust')   return l.sustituto ? l.sustituto.cant : 0;
  if(tipo==='futuro') return l.futuroCant != null ? l.futuroCant : Math.min(l.falta, l.porLlegar);
  return l.sirve;
}

// Fija una cantidad concreta, respetando el tope de lo que hay.
function vbCant(i, tipo, valor){
  var l = VB.lineas[i];
  var v = Math.max(0, Math.round(Number(valor)||0));

  if(tipo==='sust' && l.sustituto){
    // Solo su propio stock. Se permite pedir MAS de lo que falta: a veces
    // conviene mandar un bulto completo del reemplazo aunque sobre.
    l.sustituto.cant = Math.min(v, Number(l.sustituto.stock)||v);
  } else if(tipo==='futuro'){
    // Se puede pedir mas de lo que viene en camino: entrara en la siguiente
    // orden de compra. Pero se avisa, para que sea una decision consciente.
    l.futuroCant = v;
  } else {
    // Lo servible no puede pasar del stock actual.
    l.sirveMan = Math.min(v, l.disponible);
    l.sirve = l.sirveMan;
    l.falta = Math.max(0, l.pedida - l.sirve);
    l.porLlegar = Math.min(l.falta, l.enCamino || 0);
  }
  vbRender();
}


// ── Excel del reporte ─────────────────────────────────────────────────────
// Cuatro salidas: cada panel por separado, los agotados, y los reemplazos
// sugeridos junto al articulo que los origino.

async function _vbXlsx(nombre, titulo, subtitulo, columns, rows, valueFn){
  try{
    var buf = await xlsxExport({
      devolver:true, filename:nombre, titulo:titulo, subtitulo:subtitulo,
      columns:columns, rows:rows, valueFn:valueFn
    });
    var blob = new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = nombre;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function(){ URL.revokeObjectURL(a.href); }, 5000);
  }catch(e){ alert('No se pudo generar el Excel: '+(e.message||e)); }
}

// Un panel completo, con lo que dice el pedido original al lado.
async function vbExcelPanel(futuro){
  if(!VB) return;
  var L = VB.lineas.filter(function(l){
    if(futuro) return (_vbEstado(l)==='llega' || l.decision==='futuro')
                      && (l.futuroCant != null ? l.futuroCant : Math.min(l.falta,l.porLlegar)) > 0;
    return (l.sirve > 0 && !l.quitarOriginal) || (l.sustituto && l.sustituto.cant > 0);
  });
  if(!L.length){ alert('Ese panel no tiene l\u00edneas.'); return; }

  // Una fila por articulo: el original y, si lo hay, su reemplazo debajo.
  var filas = [];
  L.forEach(function(l){
    var cant = futuro
      ? (l.futuroCant != null ? l.futuroCant : Math.min(l.falta, l.porLlegar))
      : l.sirve;
    if(!futuro && l.quitarOriginal) cant = 0;
    if(cant > 0){
      filas.push({
        tipo:'Original', itemcode:l.itemcode, nombre:l.nombre,
        pidio:l.cantOriginal||l.pedida, totalPidio:l.totalOriginal||0,
        cant:cant, precio:l.precio, desc:l.descuento||0,
        total:cant*l.precio, stock:l.disponible,
        llegada:futuro?(l.llegada||''):'', oc:futuro?(l.ocs||[]).join(', '):''
      });
    }
    if(!futuro && l.sustituto && l.sustituto.cant > 0){
      var su = l.sustituto;
      filas.push({
        tipo:'Reemplazo de '+l.itemcode, itemcode:su.itemcode, nombre:su.nombre,
        pidio:'', totalPidio:'',
        cant:su.cant, precio:su.precio, desc:0,
        total:su.cant*su.precio, stock:su.stock, llegada:'', oc:''
      });
    }
  });

  var tot = filas.reduce(function(t,f){ return t + (Number(f.total)||0); }, 0);
  var cols = [
    {label:'Tipo',          key:'tipo',       width:22},
    {label:'SKU',           key:'itemcode',   width:16},
    {label:'Descripcion',   key:'nombre',     width:44},
    {label:'Pedido pedia',  key:'pidio',      width:13},
    {label:'Importe pedido',key:'totalPidio', width:15, numFmt:'#,##0.00'},
    {label:futuro?'Se pide':'Se manda', key:'cant', width:12},
    {label:'Precio',        key:'precio',     width:12, numFmt:'#,##0.0000'},
    {label:'Desc %',        key:'desc',       width:9},
    {label:'Total',         key:'total',      width:14, numFmt:'#,##0.00'},
    {label:'Stock hoy',     key:'stock',      width:11}
  ];
  if(futuro){
    cols.push({label:'Llegada', key:'llegada', width:13});
    cols.push({label:'Orden compra', key:'oc', width:16});
  }

  await _vbXlsx(
    'viabilidad-'+VB.docnum+'-'+(futuro?'futuro':'ahora')+'.xlsx',
    'KENNEDY CENTER CORP. - ' + (futuro ? 'MERCANCIA POR LLEGAR' : 'DISPONIBLE AHORA'),
    'Pedido ' + VB.docnum + '  -  ' + (VB.cardname||'') + '  -  Total ' + fmt(tot),
    cols, filas,
    function(r,k){
      if(k==='precio'||k==='total'||k==='totalPidio') return r[k]===''?'':(Number(r[k])||0);
      if(k==='cant'||k==='pidio'||k==='stock')        return r[k]===''?'':(Number(r[k])||0);
      if(k==='desc')    return Number(r.desc)||0;
      if(k==='llegada') return r.llegada ? _plFechaLbl(r.llegada) : '';
      return r[k]||'';
    });
}

// Solo lo agotado o incompleto, para pasarlo a compras.
async function vbExcelAgotados(){
  if(!VB) return;
  var L = VB.lineas.filter(function(l){ return l.falta > 0; });
  if(!L.length){ alert('No hay art\u00edculos sin cubrir.'); return; }

  var filas = L.map(function(l){
    var est = _vbEstado(l);
    return {
      itemcode:l.itemcode, nombre:l.nombre,
      pidio:l.cantOriginal||l.pedida, precio:l.precio,
      totalPidio:l.totalOriginal||0,
      hay:l.disponible, falta:l.falta,
      viene:l.enCamino||0, llegada:l.llegada||'',
      oc:(l.ocs||[]).join(', '),
      estado: est==='parcial' ? 'Incompleto' : (est==='llega' ? 'Por llegar' : 'Agotado'),
      reemplazo: l.sustituto ? (l.sustituto.itemcode+' x'+l.sustituto.cant) : '',
      perdida: Math.max(0, l.falta) * l.precio
    };
  });
  var perd = filas.reduce(function(t,f){ return t + f.perdida; }, 0);

  await _vbXlsx(
    'viabilidad-'+VB.docnum+'-sin-cubrir.xlsx',
    'KENNEDY CENTER CORP. - ARTICULOS SIN CUBRIR',
    'Pedido ' + VB.docnum + '  -  ' + (VB.cardname||'')
      + '  -  ' + filas.length + ' linea(s)  -  Sin cubrir ' + fmt(perd),
    [
      {label:'SKU',            key:'itemcode',  width:16},
      {label:'Descripcion',    key:'nombre',    width:44},
      {label:'Estado',         key:'estado',    width:13},
      {label:'Pedido pedia',   key:'pidio',     width:13},
      {label:'Precio',         key:'precio',    width:12, numFmt:'#,##0.0000'},
      {label:'Importe pedido', key:'totalPidio',width:15, numFmt:'#,##0.00'},
      {label:'Hay hoy',        key:'hay',       width:10},
      {label:'Falta',          key:'falta',     width:10},
      {label:'En camino',      key:'viene',     width:11},
      {label:'Llegada',        key:'llegada',   width:13},
      {label:'Orden compra',   key:'oc',        width:16},
      {label:'Reemplazo elegido', key:'reemplazo', width:22},
      {label:'Sin cubrir ($)', key:'perdida',   width:14, numFmt:'#,##0.00'}
    ], filas,
    function(r,k){
      if(['precio','totalPidio','perdida'].indexOf(k)>=0) return Number(r[k])||0;
      if(['pidio','hay','falta','viene'].indexOf(k)>=0)   return Number(r[k])||0;
      if(k==='llegada') return r.llegada ? _plFechaLbl(r.llegada) : '';
      return r[k]||'';
    });
}

// Las sugerencias de la IA, con el articulo que las origino al lado. Sirve
// para pasarle la lista a alguien que decida sin tener que abrir el portal.
async function vbExcelReemplazos(){
  if(!VB) return;
  var conSug = VB.lineas.filter(function(l){ return l.sugerencias && l.sugerencias.length; });
  if(!conSug.length){
    alert('A\u00fan no has buscado reemplazos.\n\nPulsa "Buscar reemplazo" en las l\u00edneas '
      + 'que te interesen y despu\u00e9s exporta.');
    return;
  }

  var filas = [];
  conSug.forEach(function(l){
    l.sugerencias.forEach(function(su, ix){
      filas.push({
        // El original se repite en cada fila: asi el Excel se puede filtrar y
        // ordenar sin perder la referencia de que reemplaza a que.
        origSku:l.itemcode, origNombre:l.nombre,
        origPidio:l.cantOriginal||l.pedida, origPrecio:l.precio,
        origHay:l.disponible, origFalta:l.falta,
        n:ix+1,
        sku:su.itemcode, nombre:su.nombre, marca:su.marca,
        precio:su.precio,
        dif:su.precio - l.precio,
        stock:su.stock, bulto:su.bulto,
        bultos:Math.floor(su.stock/Math.max(1,su.bulto)),
        cubre: su.stock >= l.falta ? 'Todo' : (su.stock + ' de ' + l.falta),
        razon:su.razon,
        elegido: (l.sustituto && l.sustituto.itemcode===su.itemcode) ? 'SI' : ''
      });
    });
  });

  await _vbXlsx(
    'viabilidad-'+VB.docnum+'-reemplazos.xlsx',
    'KENNEDY CENTER CORP. - REEMPLAZOS SUGERIDOS',
    'Pedido ' + VB.docnum + '  -  ' + (VB.cardname||'')
      + '  -  ' + conSug.length + ' articulo(s) con ' + filas.length + ' sugerencia(s)',
    [
      {label:'SKU original',    key:'origSku',    width:16},
      {label:'Descripcion original', key:'origNombre', width:40},
      {label:'Pedia',           key:'origPidio',  width:9},
      {label:'Precio original', key:'origPrecio', width:14, numFmt:'#,##0.0000'},
      {label:'Hay',             key:'origHay',    width:8},
      {label:'Falta',           key:'origFalta',  width:9},
      {label:'#',               key:'n',          width:5},
      {label:'SKU sugerido',    key:'sku',        width:16},
      {label:'Descripcion sugerida', key:'nombre',width:40},
      {label:'Marca',           key:'marca',      width:18},
      {label:'Precio',          key:'precio',     width:12, numFmt:'#,##0.0000'},
      {label:'Diferencia',      key:'dif',        width:12, numFmt:'#,##0.0000'},
      {label:'Stock',           key:'stock',      width:10},
      {label:'Bultos',          key:'bultos',     width:9},
      {label:'Cubre',           key:'cubre',      width:12},
      {label:'Por que',         key:'razon',      width:38},
      {label:'Elegido',         key:'elegido',    width:9}
    ], filas,
    function(r,k){
      if(['origPrecio','precio','dif'].indexOf(k)>=0) return Number(r[k])||0;
      if(['origPidio','origHay','origFalta','n','stock','bultos'].indexOf(k)>=0) return Number(r[k])||0;
      return r[k]||'';
    });
}


// ════════════════════════════════════════════════════════════════════
//  SUBIR FOTOS TRABAJADAS
//  Para los disenadores: se arrastran las fotos ya editadas y van al
//  bucket y, por medio del sync, tambien a la carpeta de red.
//  Solo administradores (ver el SQL 30-subir-fotos-portal).
// ════════════════════════════════════════════════════════════════════
var SF_COLA = [];

function sfAbrir(){
  // Personal interno: administradores y vendedores. Los clientes no.
  var _rol = String((CU && CU.rol) || '').toLowerCase();
  if(_rol === 'cliente' || !_rol){
    alert('No tienes permiso para subir fotos al cat\u00e1logo.');
    return;
  }
  if(document.getElementById('sf-modal')) return;

  var m=document.createElement('div');
  m.id='sf-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:760px;width:100%;'
    +'max-height:92vh;display:flex;flex-direction:column">'
    +'<div style="padding:15px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px">'
      +'<b style="flex:1;font-size:15px">\u{1F4F8} Subir fotos al cat\u00e1logo</b>'
      +'<button onclick="sfCerrar()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div style="flex:1;overflow-y:auto;padding:18px">'
      +'<div style="font-size:12.5px;color:var(--text3);line-height:1.6;margin-bottom:14px">'
        +'El <b>nombre del archivo debe ser el c\u00f3digo del art\u00edculo</b>: '
        +'<code>753492.jpg</code> es la foto del 753492.<br>'
        +'Van al servidor de im\u00e1genes y tambi\u00e9n a la carpeta de red. '
        +'Si ya hab\u00eda una foto de ese art\u00edculo, <b>se reemplaza</b>.'
      +'</div>'
      +'<div style="background:#FFFBEB;border:1px solid #FDE68A;color:#92400E;'
        +'border-radius:9px;padding:9px 12px;font-size:12px;margin-bottom:14px;line-height:1.5">'
        +'Estas fotos las ve <b>todo el mundo</b>, clientes incluidos. '
        +'Revisa que el nombre sea el c\u00f3digo correcto antes de subir: '
        +'un nombre equivocado pisa la foto de otro art\u00edculo.'
      +'</div>'
      +'<div id="sf-zona" style="border:2px dashed var(--border);border-radius:13px;padding:30px 20px;text-align:center;cursor:pointer">'
        +'<div style="font-size:36px;line-height:1">\u{1F5BC}\uFE0F</div>'
        +'<div style="font-size:14px;font-weight:600;margin-top:8px">Arrastra aqu\u00ed las fotos</div>'
        +'<div style="font-size:12px;color:var(--text3);margin-top:5px">'
          +'o pulsa para elegirlas. Puedes soltar muchas a la vez.</div>'
      +'</div>'
      +'<input type="file" id="sf-file" accept="image/*" multiple style="display:none" onchange="sfElegir(this)">'
      +'<div id="sf-lista" style="margin-top:14px"></div>'
    +'</div>'
    +'<div style="padding:13px 18px;border-top:1px solid var(--border);display:flex;gap:8px;align-items:center">'
      +'<span id="sf-msg" style="flex:1;font-size:12.5px;color:var(--text3)"></span>'
      +'<button class="btn btn-sm" onclick="sfCerrar()">Cerrar</button>'
      +'<button class="btn btn-sm btn-p" id="sf-subir" onclick="sfSubir()" disabled>Subir</button>'
    +'</div></div>';
  document.body.appendChild(m);

  var z=document.getElementById('sf-zona');
  z.onclick=function(){ document.getElementById('sf-file').click(); };
  z.ondragover=function(e){ e.preventDefault(); z.style.borderColor='var(--blue2)'; };
  z.ondragleave=function(){ z.style.borderColor='var(--border)'; };
  z.ondrop=function(e){
    e.preventDefault(); z.style.borderColor='var(--border)';
    sfAnadir(e.dataTransfer.files);
  };
}

function sfCerrar(){
  SF_COLA = [];
  var m=document.getElementById('sf-modal'); if(m) m.remove();
}

function sfElegir(el){
  sfAnadir(el.files);
  el.value='';
}

function sfAnadir(files){
  Array.prototype.slice.call(files||[]).forEach(function(f){
    if(!/^image\//.test(f.type||'')) return;
    // El codigo del articulo es el nombre sin la extension.
    var code = f.name.replace(/\.[^.]+$/,'').trim();
    if(SF_COLA.some(function(x){ return x.file.name === f.name; })) return;
    SF_COLA.push({file:f, code:code, estado:'pendiente', msg:''});
  });
  sfPintar();
  sfVerificar();
}

function sfPintar(){
  var d=document.getElementById('sf-lista'); if(!d) return;
  var b=document.getElementById('sf-subir');
  // Se puede subir cualquier cosa que no este ya subida, aunque el codigo no
  // exista en el catalogo: puede ser un articulo que aun no se ha dado de alta
  // en SAP y la foto ya esta lista. Solo se avisa; no se bloquea.
  if(b) b.disabled = !SF_COLA.some(function(x){ return x.estado!=='ok' && x.estado!=='subiendo'; });

  if(!SF_COLA.length){ d.innerHTML=''; return; }

  d.innerHTML='<table class="tbl">'
    +'<tr><th>Archivo</th><th>Art\u00edculo</th><th>Tama\u00f1o</th><th>Estado</th><th></th></tr>'
    + SF_COLA.map(function(x, i){
        var col = x.estado==='ok' ? 'var(--green)'
                : (x.estado==='error' ? 'var(--red)'
                : (x.estado==='aviso' ? 'var(--amber)' : 'var(--text3)'));
        return '<tr>'
          +'<td style="font-size:11.5px">'+npEsc(x.file.name)+'</td>'
          +'<td style="font-size:11.5px"><b>'+npEsc(x.code)+'</b>'
            + (x.nombreArt ? ('<div style="font-size:10.5px;color:var(--text3)">'+npEsc(String(x.nombreArt).substring(0,34))+'</div>') : '')
            +'</td>'
          +'<td style="font-size:11.5px;text-align:right">'+Math.round(x.file.size/1024)+' KB</td>'
          +'<td style="font-size:11.5px;color:'+col+'">'+npEsc(x.msg || x.estado)+'</td>'
          +'<td>'+(x.estado==='ok' ? '' :
             '<button class="btn btn-sm" style="padding:1px 8px" onclick="sfQuitar('+i+')">\u2715</button>')+'</td>'
          +'</tr>';
      }).join('')
    +'</table>';
}

function sfQuitar(i){ SF_COLA.splice(i,1); sfPintar(); }

// Comprueba que cada codigo exista en el catalogo. Subir una foto con el
// nombre mal escrito no da error, simplemente no la ve nadie: mejor avisar.
async function sfVerificar(){
  var faltan = SF_COLA.filter(function(x){ return x.nombreArt === undefined; });
  if(!faltan.length) return;
  var codes = faltan.map(function(x){ return '"'+x.code.replace(/"/g,'')+'"'; }).join(',');
  try{
    var r = await q('inventario','select=itemcode,itemname&itemcode=in.('+codes+')&limit='+faltan.length);
    var mapa={}; (r||[]).forEach(function(a){ mapa[String(a.itemcode).toUpperCase()]=a.itemname; });
    faltan.forEach(function(x){
      var n = mapa[x.code.toUpperCase()];
      if(n){ x.nombreArt = n; x.estado='listo'; x.msg='listo'; }
      else  { x.nombreArt = ''; x.estado='aviso';
              x.msg='sin alta en SAP \u00b7 se sube igual'; }
    });
  }catch(e){
    faltan.forEach(function(x){ x.nombreArt=''; });
  }
  sfPintar();
}

// La misma regla de saneado que usa el sync: minusculas y todo lo que no sea
// letra, numero, punto, guion o guion bajo pasa a '_'. Si no coincide, el
// portal buscaria la foto en una direccion y estaria guardada en otra.
function _sfClave(nombre){
  return String(nombre||'').toLowerCase().replace(/[^a-z0-9._-]/g, '_');
}

async function sfSubir(){
  var pend = SF_COLA.filter(function(x){ return x.estado!=='ok' && x.estado!=='subiendo'; });
  if(!pend.length) return;

  var conAviso = pend.filter(function(x){ return x.estado==='aviso'; }).length;
  if(conAviso && !confirm(conAviso + ' foto(s) tienen un c\u00f3digo que a\u00fan no existe en SAP.\n\n'
      + 'Se suben igual y quedan guardadas. Apareceran solas en cuanto se de de alta '
      + 'ese art\u00edculo.\n\n\u00bfContinuar?')) return;

  var btn=document.getElementById('sf-subir');
  var msg=document.getElementById('sf-msg');
  if(btn){ btn.disabled=true; btn.textContent='Subiendo\u2026'; }

  // De una en una a proposito: 104 fotos en paralelo saturan la conexion y
  // Storage empieza a rechazar peticiones.
  var ok=0, err=0;
  for(var i=0; i<pend.length; i++){
    var x = pend[i];
    x.estado='subiendo'; x.msg='subiendo\u2026'; sfPintar();
    if(msg) msg.textContent = 'Subiendo ' + (i+1) + ' de ' + pend.length + '\u2026';

    try{
      var clave = _sfClave(x.file.name);
      // encodeURIComponent NO: escapa los puntos y guiones y Storage responde
      // 400. La clave ya viene saneada (solo a-z, 0-9, punto, guion y guion
      // bajo), asi que va tal cual, como en la prueba que si funciono.
      var url = SB + '/storage/v1/object/fotos-items/' + clave;

      // Primero se intenta crear (POST). Si el archivo ya existe, Storage
      // responde 409 y entonces se reemplaza con PUT.
      //
      // NO se usa 'x-upsert:true' en el POST: eso lo convierte en un upsert
      // que exige permiso de UPDATE ademas de INSERT, y ahi fallaba con
      // "violates row-level security policy" aunque el rol fuera correcto.
      var cab = {'apikey':KEY, 'Authorization':'Bearer '+AUTHTOK(),
                 'Content-Type': x.file.type || 'image/jpeg'};

      var r = await fetch(url, {method:'POST', headers:cab, body:x.file});

      // Storage responde HTTP 400 aunque por dentro sea un 409 KeyAlreadyExists:
      // hay que mirar el cuerpo, no solo el codigo. Si ya existe, se reemplaza
      // con PUT, que es la operacion de actualizar.
      if(!r.ok){
        var _txt = await r.text();
        if(/KeyAlreadyExists|Duplicate|already exists/i.test(_txt)){
          r = await fetch(url, {method:'PUT', headers:cab, body:x.file});
          if(!r.ok) throw new Error((await r.text()).slice(0,140));
        } else {
          throw new Error(_txt.slice(0,140));
        }
      }

      // Se anota para que el sync la baje tambien a la carpeta de red.
      await fetch(SB+'/rest/v1/fotos_queue',{
        method:'POST',
        headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
                 'Content-Type':'application/json','Prefer':'return=minimal'},
        body: JSON.stringify({
          archivo: clave,
          itemcode: x.code,
          nombre_orig: x.file.name,     // la carpeta de red usa el nombre tal cual
          estado: 'pendiente',
          subido_por: (CU && CU.username) || 'portal'
        })
      }).catch(function(){});

      x.estado='ok'; x.msg='\u2713 subida'; ok++;
    }catch(e){
      x.estado='error';
      var _t = String(e.message||e);
      x.msg = /row-level security|Unauthorized|AccessDenied/i.test(_t) ? 'sin permiso'
            : /already exists|Duplicate/i.test(_t)                    ? 'ya exist\u00eda'
            : /Invalid key|InvalidKey/i.test(_t)                      ? 'nombre no v\u00e1lido'
            : /Payload too large|entity too large/i.test(_t)          ? 'demasiado grande'
            : _t.slice(0,44);
      err++;
    }
    sfPintar();
  }

  if(btn){ btn.disabled=false; btn.textContent='Subir'; }
  if(msg){
    msg.style.color = err ? 'var(--amber)' : 'var(--green)';
    msg.innerHTML = ok + ' foto(s) subidas'
      + (err ? (' \u00b7 ' + err + ' con error') : '')
      + '<br><span style="font-size:11.5px;color:var(--text3)">'
      + 'Ya se ven en el portal. El sync las copia a la carpeta de red en unos segundos.</span>';
  }
}


// ════════════════════════════════════════════════════════════════════
//  LOG DEL SYNC  (solo administradores)
//  Errores y avisos del proceso que habla con SAP, para no tener que
//  entrar al PC del sync a mirar la ventana.
// ════════════════════════════════════════════════════════════════════
async function slAbrir(){
  if(!(CU && String(CU.rol||'').toLowerCase()==='admin')){
    alert('Solo gerencia puede ver el registro del sync.');
    return;
  }
  if(document.getElementById('sl-modal')) return;

  var m=document.createElement('div');
  m.id='sl-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:900px;width:100%;'
    +'max-height:92vh;display:flex;flex-direction:column">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<b style="flex:1;font-size:15px">\u{1F527} Registro del sync</b>'
      +'<select id="sl-nivel" onchange="slCargar()" style="padding:5px 9px;border:1px solid var(--border);border-radius:8px;font-size:12.5px">'
        +'<option value="">Errores y avisos</option>'
        +'<option value="ERROR">Solo errores</option>'
      +'</select>'
      +'<button class="btn btn-sm" onclick="slCargar()">Actualizar</button>'
      +'<button onclick="slCerrar()" style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="sl-body" style="flex:1;overflow-y:auto;padding:16px 18px;font-size:13px">'
      +'<div class="loading"><div class="spinner"></div></div></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) slCerrar(); });
  slCargar();
}

function slCerrar(){ var m=document.getElementById('sl-modal'); if(m) m.remove(); }

async function slCargar(){
  var c = document.getElementById('sl-body'); if(!c) return;
  var nivel = (document.getElementById('sl-nivel')||{}).value || '';
  c.innerHTML='<div class="loading"><div class="spinner"></div></div>';

  try{
    var f = 'select=id,nivel,mensaje,modulo,creado_en&order=creado_en.desc&limit=200';
    if(nivel) f += '&nivel=eq.' + nivel;
    var r = await q('sync_log', f);

    if(!r || !r.length){
      c.innerHTML='<div style="padding:30px;text-align:center;color:var(--green);line-height:1.6">'
        +'<div style="font-size:30px">\u2713</div>'
        +'<div style="margin-top:8px;font-size:14px;font-weight:600">Sin errores</div>'
        +'<div style="font-size:12.5px;color:var(--text3);margin-top:4px">'
        +'El sync no ha reportado ning\u00fan problema.</div></div>';
      return;
    }

    // Agrupados por dia, que es como se mira esto de verdad
    var porDia = {};
    r.forEach(function(x){
      var d = String(x.creado_en||'').substring(0,10);
      (porDia[d] = porDia[d] || []).push(x);
    });

    c.innerHTML = Object.keys(porDia).sort().reverse().map(function(d){
      return '<div style="font-size:11px;text-transform:uppercase;letter-spacing:.5px;'
        +'color:var(--text3);font-weight:700;margin:14px 0 7px">'+_plFechaLbl(d)
        +' \u00b7 '+porDia[d].length+'</div>'
        + porDia[d].map(function(x){
            var esErr = x.nivel==='ERROR';
            var hora = String(x.creado_en||'').substring(11,19);
            return '<div style="display:flex;gap:9px;padding:7px 0;border-bottom:1px solid var(--border)">'
              +'<span style="flex:0 0 auto;font-size:11px;color:var(--text3);font-variant-numeric:tabular-nums">'+hora+'</span>'
              +'<span style="flex:0 0 auto"><span class="badge" style="background:'
                +(esErr?'#FEE2E2;color:#991B1B':'#FFFBEB;color:#92400E')+'">'
                +(esErr?'error':'aviso')+'</span></span>'
              + (x.modulo ? ('<span style="flex:0 0 auto;font-size:11px;color:var(--text3)">'+npEsc(x.modulo)+'</span>') : '')
              +'<span style="flex:1;min-width:0;font-size:12px;line-height:1.5;word-break:break-word">'
                +npEsc(x.mensaje)+'</span>'
              +'</div>';
          }).join('');
    }).join('')
    + '<div style="font-size:11.5px;color:var(--text3);margin-top:14px;line-height:1.5">'
    + 'Solo se guardan errores y avisos, 30 d\u00edas. Los mensajes repetidos '
    + 'se agrupan: si algo falla en cada ciclo, aparece una vez cada 10 minutos.</div>';
  }catch(e){
    c.innerHTML='<div style="padding:20px;color:var(--red);font-size:13px">'
      + (/does not exist|42P01/i.test(String(e.message))
          ? 'Falta la tabla <code>sync_log</code>. Corre el SQL <b>37-log-sync</b>.'
          : ('No se pudo cargar: '+npEsc(String(e.message||e).slice(0,140))))
      +'</div>';
  }
}


// ── A dónde va el pedido en SAP ───────────────────────────────────────────
// Un cliente solo puede generar cotizaciones: su pedido lo revisa alguien de
// dentro antes de convertirse en orden de venta. El personal interno elige.
function _npDestino(){
  if(CU && String(CU.rol||'').toLowerCase()==='cliente') return 'cotizacion';
  var sel = document.getElementById('np-destino');
  return (sel && sel.value) || 'pedido';
}

// El selector, solo para vendedores y gerencia.
function npPintarDestino(){
  var cont = document.getElementById('np-destino-box');
  if(!cont) return;

  if(CU && String(CU.rol||'').toLowerCase()==='cliente'){
    cont.innerHTML = '<div style="font-size:12.5px;color:var(--text3);line-height:1.5">'
      +'Tu pedido entra como <b>cotizaci\u00f3n</b>. Lo revisamos y te confirmamos '
      +'disponibilidad y precios antes de procesarlo.</div>';
    return;
  }

  cont.innerHTML =
     '<label style="font-size:11px;color:var(--text3);text-transform:uppercase;'
      +'letter-spacing:.4px;display:block;margin-bottom:5px">Enviar a SAP como</label>'
    +'<select id="np-destino" onchange="npDestinoCambio()" '
      +'style="padding:8px 11px;border:1px solid var(--border);border-radius:9px;'
      +'font-size:13.5px;width:100%;max-width:290px">'
      +'<option value="pedido">Pedido de venta</option>'
      +'<option value="cotizacion">Solo cotizaci\u00f3n</option>'
      +'<option value="ambos">Cotizaci\u00f3n y pedido</option>'
    +'</select>'
    +'<div id="np-destino-ayuda" style="font-size:11.5px;color:var(--text3);margin-top:5px;line-height:1.45"></div>';

  // Se recuerda lo que se eligio la ultima vez: casi siempre se repite.
  try{
    var prev = localStorage.getItem('kc_np_destino');
    if(prev) document.getElementById('np-destino').value = prev;
  }catch(e){}
  npDestinoCambio();
}

function npDestinoCambio(){
  var sel = document.getElementById('np-destino');
  var ay  = document.getElementById('np-destino-ayuda');
  if(!sel || !ay) return;
  try{ localStorage.setItem('kc_np_destino', sel.value); }catch(e){}

  ay.innerHTML = {
    pedido:     'Se crea la cotizaci\u00f3n y pasa a <b>pedido de venta</b> autom\u00e1ticamente.',
    cotizacion: 'Se queda en <b>cotizaci\u00f3n</b>. Alguien tendr\u00e1 que convertirla en SAP.',
    ambos:      'Se crea la cotizaci\u00f3n y el pedido, y se avisa de los dos n\u00fameros.'
  }[sel.value] || '';
}


// ── Cabecera de la conversación ───────────────────────────────────────────
// El avatar y el cargo, como en WhatsApp: se sabe con quién hablas de un
// vistazo, sin tener que mirar la lista.
function chPintarCabecera(){
  var t = document.getElementById('ch-titulo');
  var sb = document.getElementById('ch-sub');
  var av = document.getElementById('ch-avatar');
  if(!t) return;

  if(CH_SALA === 'general'){
    t.textContent = 'General';
    if(sb) sb.textContent = 'todo el equipo';
    if(av){
      av.textContent = '';
      av.innerHTML = '<svg width="21" height="21" fill="none" stroke="#fff" stroke-width="1.9" '
        +'viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>'
        +'<circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>';
      av.style.background = 'rgba(255,255,255,.22)';
    }
    return;
  }

  var otro = String(CH_SALA).split('|').filter(function(x){ return x !== chYo(); })[0] || '';
  var u = (CH_USUARIOS||[]).find(function(x){
    return String(x.username||'').toLowerCase() === otro.toLowerCase();
  }) || {};

  t.textContent = u.nombre || otro;
  if(sb) sb.textContent = u.rol ? String(u.rol).toLowerCase() : '';
  if(av){
    var ini = String(u.nombre || otro).trim().split(/\s+/)
      .map(function(w){ return w[0]; }).slice(0,2).join('').toUpperCase();
    av.innerHTML = '';
    av.textContent = ini || '?';
    av.style.background = _chColorDe(u.nombre || otro);
  }
}

// En pantalla estrecha la lista y la conversación no caben a la vez, así que
// se alternan, igual que en el móvil de WhatsApp.
function chVolver(){
  var col = document.getElementById('ch-col');
  var vol = document.getElementById('ch-volver');
  if(col) col.style.display = 'flex';
  if(vol) vol.style.display = 'none';
  var sh = document.getElementById('ch-shell');
  if(sh) sh.dataset.vista = 'lista';
}

function chAjustarVista(){
  var sh = document.getElementById('ch-shell'); if(!sh) return;
  var estrecho = window.innerWidth < 760;
  var col = document.getElementById('ch-col');
  var vol = document.getElementById('ch-volver');
  if(!estrecho){
    if(col){ col.style.display='flex'; col.style.width='238px'; }
    if(vol) vol.style.display='none';
    return;
  }
  // Estrecho: o la lista, o la conversación.
  if(col){ col.style.width='100%'; col.style.display = (sh.dataset.vista==='conv' ? 'none' : 'flex'); }
  if(vol) vol.style.display = (sh.dataset.vista==='conv' ? 'block' : 'none');
}
window.addEventListener('resize', function(){ try{ chAjustarVista(); }catch(e){} });

// El menú de los tres puntos.
function chMenu(){
  var opciones = [];
  if(CH_SALA !== 'general') opciones.push('Ir al chat general');
  opciones.push('Marcar todo como le\u00eddo');
  var elegido = prompt('Opciones:\n\n' + opciones.map(function(o,i){
    return (i+1) + '. ' + o;
  }).join('\n') + '\n\nEscribe el n\u00famero:');
  if(!elegido) return;
  var n = parseInt(elegido, 10);
  var op = opciones[n-1];
  if(op === 'Ir al chat general') chAbrir('general');
  else if(op === 'Marcar todo como le\u00eddo'){
    chMarcarTodo();
  }
}

// Marca TODAS las salas como leidas, en la base y no solo en pantalla.
//
// Hacia falta porque un mensaje puede quedarse marcado como no leido para
// siempre: si su sala tiene un formato que el portal ya no abre, nunca se
// llega a guardar la marca y el aviso se queda ahi.
async function chMarcarTodo(){
  var yo = chYo();
  var btn = document.getElementById('ch-marcar-todo');
  if(btn){ btn.disabled = true; btn.textContent = 'Marcando\u2026'; }

  try{
    // El ultimo mensaje de cada sala, se hayan abierto o no.
    var filas = await q('chat_mensajes', 'select=id,sala&order=id.desc&limit=3000');
    var ultimo = {};
    (filas||[]).forEach(function(m){
      var s = String(m.sala||'');
      var i = Number(m.id)||0;
      if(!ultimo[s] || i > ultimo[s]) ultimo[s] = i;
    });

    var salas = Object.keys(ultimo);
    if(!salas.length){ if(btn){ btn.disabled=false; btn.textContent='Marcar todo como le\u00eddo'; } return; }

    var cuerpo = salas.map(function(s){
      return {usuario: yo, sala: s, ultimo_id: ultimo[s], visto_en: ahoraLocal()};
    });

    var r = await fetch(SB+'/rest/v1/chat_leidos',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
               'Content-Type':'application/json',
               'Prefer':'resolution=merge-duplicates,return=minimal'},
      body: JSON.stringify(cuerpo)
    });
    if(!r.ok) throw new Error((await r.text()).slice(0,140));

    CH_NOLEIDOS = {};
    salas.forEach(function(s){ CH_MARCA[s] = ultimo[s]; });
    chPintarLista(); chPintarBadge();
    if(btn){ btn.textContent = '\u2713 Listo'; }
  }catch(e){
    if(btn){ btn.disabled=false; btn.textContent='Marcar todo como le\u00eddo'; }
    alert('No se pudo marcar: ' + String(e.message||e).slice(0,150));
  }
}


// ── Fechas del pedido ─────────────────────────────────────────────────────
// La del pedido es hoy; la de entrega, una semana despues.
//
// Se llama desde varios sitios porque npInit() solo corre al ENTRAR a la
// pantalla: si se retoma un borrador, se llega desde el reporte de
// viabilidad o se vuelve atras en los pasos, los campos quedaban vacios.
//
// forzar=true las pone siempre (pedido nuevo); forzar=false solo rellena
// las que esten en blanco, para no pisar lo que alguien ya escribio.
function npFechasPorDefecto(forzar){
  var f = document.getElementById('np-fecha');
  var e = document.getElementById('np-entrega');
  if(f && (forzar || !f.value)) f.value = hoyLocal();
  if(e && (forzar || !e.value)) e.value = hoyLocal(Date.now() + 7*86400000);
}

// ── Fechas en hora local, no en UTC ───────────────────────────────────────
// toISOString() devuelve la fecha en UTC. Panama esta en UTC-5, asi que a
// partir de las 7 de la tarde daba la fecha de MAÑANA: los pedidos se
// guardaban con un dia de mas, y eso mueve el periodo contable en SAP.
function hoyLocal(d){
  var f = d ? new Date(d) : new Date();
  // Se descuenta el desfase del navegador para que toISOString devuelva la
  // fecha que la persona ve en su reloj.
  return new Date(f.getTime() - f.getTimezoneOffset()*60000)
           .toISOString().slice(0,10);
}

// Fecha y hora completas en local, para las marcas de tiempo.
function ahoraLocal(){
  var f = new Date();
  return new Date(f.getTime() - f.getTimezoneOffset()*60000).toISOString();
}


// ════════════════════════════════════════════════════════════════════
//  PANELES DEL DASHBOARD
//  Se abren al pulsar los tres bloques de arriba.
// ════════════════════════════════════════════════════════════════════

function _vpModal(id, titulo, ancho){
  var v = document.getElementById(id); if(v) v.remove();
  var m = document.createElement('div');
  m.id = id;
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;'
    +'max-width:'+(ancho||1050)+'px;width:100%;max-height:92vh;display:flex;flex-direction:column">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);'
      +'display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<b style="flex:1;font-size:15px">'+titulo+'</b>'
      +'<span id="'+id+'-extra"></span>'
      +'<button onclick="document.getElementById(\''+id+'\').remove()" '
        +'style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div id="'+id+'-body" style="flex:1;overflow-y:auto;padding:16px 18px;font-size:13px">'
      +'<div class="loading"><div class="spinner"></div></div></div>'
    +'</div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(ev){ if(ev.target===m) m.remove(); });
  return document.getElementById(id+'-body');
}

function _vpVar(act, prev){
  var a = Number(act)||0, p = Number(prev)||0;
  if(!p) return {txt:'\u2014', col:'var(--text3)'};
  var pct = (a - p) / Math.abs(p) * 100;
  return {
    txt: (pct >= 0 ? '\u25B2 ' : '\u25BC ') + Math.abs(pct).toFixed(1) + '%',
    col: pct >= 0 ? 'var(--green)' : 'var(--red)',
    pct: pct
  };
}


// ── 1. Ventas por departamento (al pulsar "Ventas del año") ───────────────
// El mismo reporte que gerencia usa en SAP: año fiscal en curso contra el
// mismo periodo del año pasado.
async function vdepAbrir(){
  if(!(CU && String(CU.rol||'').toLowerCase()==='admin')){
    alert('Solo gerencia puede ver este reporte.');
    return;
  }
  var c = _vpModal('vdep-modal', '\u{1F4CA} Ventas por departamento', 1150);

  try{
    var r = await qAll('ventas_departamento', 'select=*&order=monto.desc');
    if(!r || !r.length){
      c.innerHTML='<div style="padding:26px;text-align:center;color:var(--text3);line-height:1.6">'
        +'A\u00fan no hay datos.<br><span style="font-size:12px">'
        +'El sync los calcula en su pr\u00f3ximo ciclo.</span></div>';
      return;
    }

    // Los totales, de las mismas filas: as\u00ed nunca discrepan de la tabla.
    var T = {cant:0, cantP:0, monto:0, montoP:0, bruto:0, brutoP:0};
    r.forEach(function(x){
      T.cant  += Number(x.cantidad)||0;      T.cantP  += Number(x.cantidad_prev)||0;
      T.monto += Number(x.monto)||0;         T.montoP += Number(x.monto_prev)||0;
      T.bruto += Number(x.bruto)||0;         T.brutoP += Number(x.bruto_prev)||0;
    });
    var vT = _vpVar(T.monto, T.montoP);
    var mT = T.monto > 0 ? (T.bruto / T.monto * 100) : 0;

    var ex = document.getElementById('vdep-modal-extra');
    if(ex && r[0]) ex.innerHTML = '<span style="font-size:11.5px;color:var(--text3)">'
      + 'A\u00f1o fiscal desde ' + _plFechaLbl(String(r[0].desde||'').substring(0,10))
      + ' \u00b7 comparado con el mismo periodo del a\u00f1o pasado</span>';

    c.innerHTML =
       '<div style="overflow-x:auto"><table class="tbl">'
      +'<tr><th>Departamento</th>'
        +'<th style="text-align:right">Unidades</th>'
        +'<th style="text-align:right">Vendido</th>'
        +'<th style="text-align:right">A\u00f1o pasado</th>'
        +'<th style="text-align:right">Variaci\u00f3n</th>'
        +'<th style="text-align:right">Ganancia</th>'
        +'<th style="text-align:right">Margen</th></tr>'
      + r.map(function(x){
          var v = _vpVar(x.monto, x.monto_prev);
          var mo = Number(x.monto)||0, br = Number(x.bruto)||0;
          var mg = mo > 0 ? (br/mo*100) : 0;
          // El margen negativo se marca: suele ser un error de costeo, no una
          // venta a perdida de verdad.
          var colM = mg < 0 ? 'var(--red)' : (mg < 20 ? 'var(--amber)' : 'var(--text)');
          return '<tr>'
            +'<td><b>'+npEsc(x.grupo||'')+'</b></td>'
            +'<td style="text-align:right">'+fmtN(x.cantidad)+'</td>'
            +'<td style="text-align:right;font-weight:600">'+fmt(mo)+'</td>'
            +'<td style="text-align:right;color:var(--text3)">'+fmt(x.monto_prev)+'</td>'
            +'<td style="text-align:right;color:'+v.col+'">'+v.txt+'</td>'
            +'<td style="text-align:right">'+fmt(br)+'</td>'
            +'<td style="text-align:right;font-weight:600;color:'+colM+'">'+mg.toFixed(1)+'%</td>'
            +'</tr>';
        }).join('')
      +'<tr style="background:var(--surface2,#F7F7F8);font-weight:700">'
        +'<td>GRAN TOTAL</td>'
        +'<td style="text-align:right">'+fmtN(T.cant)+'</td>'
        +'<td style="text-align:right">'+fmt(T.monto)+'</td>'
        +'<td style="text-align:right">'+fmt(T.montoP)+'</td>'
        +'<td style="text-align:right;color:'+vT.col+'">'+vT.txt+'</td>'
        +'<td style="text-align:right">'+fmt(T.bruto)+'</td>'
        +'<td style="text-align:right">'+mT.toFixed(1)+'%</td></tr>'
      +'</table></div>'
      +'<div style="display:flex;gap:8px;margin-top:13px;flex-wrap:wrap">'
        +'<button class="btn btn-sm" onclick="vdepExcel()">\u2b07 Excel</button>'
      +'</div>';
  }catch(e){
    c.innerHTML='<div style="padding:20px;color:var(--red)">'
      + (/does not exist|42P01/i.test(String(e.message))
          ? 'Falta la tabla <code>ventas_departamento</code>. La crea el sync.'
          : npEsc(String(e.message||e).slice(0,150)))
      +'</div>';
  }
}

async function vdepExcel(){
  try{
    var r = await qAll('ventas_departamento', 'select=*&order=monto.desc');
    var filas = r.map(function(x){
      var mo=Number(x.monto)||0, br=Number(x.bruto)||0, mp=Number(x.monto_prev)||0;
      return {grupo:x.grupo, cant:Number(x.cantidad)||0, monto:mo, prev:mp,
              varia: mp ? ((mo-mp)/Math.abs(mp)*100) : 0,
              bruto:br, margen: mo>0 ? (br/mo*100) : 0};
    });
    await _vbXlsx('ventas-por-departamento.xlsx',
      'KENNEDY CENTER CORP. - VENTAS POR DEPARTAMENTO',
      'A\u00f1o fiscal en curso contra el mismo periodo del a\u00f1o pasado',
      [{label:'Departamento', key:'grupo',  width:26},
       {label:'Unidades',     key:'cant',   width:14},
       {label:'Vendido',      key:'monto',  width:16, numFmt:'#,##0.00'},
       {label:'Ano pasado',   key:'prev',   width:16, numFmt:'#,##0.00'},
       {label:'Variacion %',  key:'varia',  width:13, numFmt:'#,##0.0'},
       {label:'Ganancia',     key:'bruto',  width:16, numFmt:'#,##0.00'},
       {label:'Margen %',     key:'margen', width:11, numFmt:'#,##0.0'}],
      filas, function(r,k){ return k==='grupo' ? (r.grupo||'') : (Number(r[k])||0); });
  }catch(e){ alert('No se pudo generar: '+(e.message||e)); }
}


// ── 2. Ventas del mes por vendedor ────────────────────────────────────────
async function vmesAbrir(){
  var c = _vpModal('vmes-modal', '\u{1F465} Ventas del mes por vendedor', 820);

  try{
    var hoy = new Date();
    var ini = hoyLocal(new Date(hoy.getFullYear(), hoy.getMonth(), 1));
    var fin = hoyLocal();

    // Mismo criterio que el resto del portal: linetotal menos devoluciones.
    // Usar doctotal daria cifras infladas, porque incluye impuestos y flete.
    var fac = await qAll('facturas',
      'select=slpcode,nombrevendedor,linetotal,docdate,docnum'
      +'&docdate=gte.'+ini+'&docdate=lte.'+fin+'&limit=20000');
    var dev = [];
    try{
      dev = await qAll('devoluciones',
        'select=slpcode,nombrevendedor,linetotal,docdate'
        +'&docdate=gte.'+ini+'&docdate=lte.'+fin+'&limit=8000');
    }catch(e){}

    var por = {};
    function meter(l, signo){
      var nom = String(l.nombrevendedor||'').trim() || ('c\u00f3digo '+(l.slpcode||'?'));
      if(!por[nom]) por[nom] = {venta:0, dev:0, docs:{}};
      por[nom].venta += signo * (Number(l.linetotal)||0);
      if(signo < 0) por[nom].dev += (Number(l.linetotal)||0);
      if(signo > 0 && l.docnum) por[nom].docs[l.docnum] = 1;
    }
    (fac||[]).forEach(function(l){ meter(l, 1); });
    (dev||[]).forEach(function(l){ meter(l, -1); });

    var lista = Object.keys(por).map(function(n){
      return {nombre:n, venta:por[n].venta, dev:por[n].dev,
              facturas:Object.keys(por[n].docs).length};
    }).filter(function(x){ return Math.abs(x.venta) > 0.005; })
      .sort(function(a,b){ return b.venta - a.venta; });

    if(!lista.length){
      c.innerHTML='<div style="padding:26px;text-align:center;color:var(--text3)">'
        +'Sin ventas registradas este mes.</div>';
      return;
    }

    var tot = lista.reduce(function(t,x){ return t + x.venta; }, 0);
    var maxV = Math.max.apply(null, lista.map(function(x){ return x.venta; }));

    var ex = document.getElementById('vmes-modal-extra');
    if(ex) ex.innerHTML = '<span style="font-size:11.5px;color:var(--text3)">'
      + _plFechaLbl(ini) + ' \u2192 ' + _plFechaLbl(fin) + '</span>';

    c.innerHTML =
       '<div style="font-size:22px;font-weight:800;margin-bottom:3px">'+fmt(tot)+'</div>'
      +'<div style="font-size:12px;color:var(--text3);margin-bottom:15px">'
      + lista.length + ' vendedor(es) con venta este mes</div>'
      + lista.map(function(x){
          var pct = tot > 0 ? (x.venta/tot*100) : 0;
          var ancho = maxV > 0 ? (x.venta/maxV*100) : 0;
          return '<div style="margin-bottom:13px">'
            +'<div style="display:flex;gap:9px;align-items:baseline;margin-bottom:4px">'
              +'<span style="flex:1;font-size:13.5px;font-weight:600;text-transform:capitalize">'
              +npEsc(x.nombre)+'</span>'
              +'<span style="font-size:11.5px;color:var(--text3)">'+x.facturas+' fact.</span>'
              + (x.dev > 0.005
                  ? ('<span style="font-size:11.5px;color:var(--red)">\u2212'+fmt(x.dev)+'</span>')
                  : '')
              +'<span style="font-size:14px;font-weight:700;min-width:96px;text-align:right">'
              +fmt(x.venta)+'</span>'
              +'<span style="font-size:11.5px;color:var(--text3);min-width:42px;text-align:right">'
              +pct.toFixed(1)+'%</span>'
            +'</div>'
            +'<div style="height:7px;background:var(--surface2,#F1F2F4);border-radius:4px;overflow:hidden">'
              +'<div style="width:'+ancho+'%;height:100%;background:var(--blue2);border-radius:4px"></div>'
            +'</div></div>';
        }).join('')
      +'<div style="font-size:11.5px;color:var(--text3);margin-top:14px;line-height:1.5">'
      +'Se suma el importe de las l\u00edneas y se restan las devoluciones, '
      +'igual que el resto del portal. Las ventas compartidas van completas a '
      +'cada nombre: para el reparto al 50% usa <b>Reporte de ventas por vendedor</b>.</div>';
  }catch(e){
    c.innerHTML='<div style="padding:20px;color:var(--red)">'
      +npEsc(String(e.message||e).slice(0,150))+'</div>';
  }
}


// ── 3. Este año contra el anterior ────────────────────────────────────────
async function vcompAbrir(){
  var c = _vpModal('vcomp-modal', '\u{1F4C8} Este a\u00f1o vs el anterior', 900);

  try{
    var hoy = new Date();
    var a1 = hoy.getFullYear(), a0 = a1 - 1;
    // Hasta el mismo dia del ano pasado: comparar un ano completo contra uno
    // a medias no dice nada.
    var corte = hoyLocal();
    var corteAnt = hoyLocal(new Date(a0, hoy.getMonth(), hoy.getDate()));

    async function traer(desde, hasta){
      var f = await qAll('facturas',
        'select=docnum,linetotal,docdate&docdate=gte.'+desde+'&docdate=lte.'+hasta+'&limit=40000');
      var d = [];
      try{
        d = await qAll('devoluciones',
          'select=linetotal,docdate&docdate=gte.'+desde+'&docdate=lte.'+hasta+'&limit=10000');
      }catch(e){}
      var docs = {}, venta = 0, devol = 0;
      (f||[]).forEach(function(l){
        venta += Number(l.linetotal)||0;
        if(l.docnum) docs[l.docnum] = 1;
      });
      (d||[]).forEach(function(l){ devol += Number(l.linetotal)||0; });
      return {venta: venta - devol, bruto: venta, devol: devol,
              facturas: Object.keys(docs).length};
    }

    var act = await traer(a1+'-01-01', corte);
    var ant = await traer(a0+'-01-01', corteAnt);

    var ex = document.getElementById('vcomp-modal-extra');
    if(ex) ex.innerHTML = '<span style="font-size:11.5px;color:var(--text3)">'
      +'del 1 de enero al d\u00eda de hoy, en ambos a\u00f1os</span>';

    function bloque(t, a, b, esDinero){
      var v = _vpVar(a, b);
      return '<div style="flex:1;min-width:168px;background:var(--surface2,#F7F7F8);'
        +'border-radius:11px;padding:13px 15px">'
        +'<div style="font-size:10.5px;color:var(--text3);text-transform:uppercase;'
        +'letter-spacing:.4px">'+t+'</div>'
        +'<div style="font-size:21px;font-weight:800;margin-top:3px">'
        +(esDinero?fmt(a):fmtN(a))+'</div>'
        +'<div style="font-size:12px;color:var(--text3);margin-top:2px">'
        +a0+': '+(esDinero?fmt(b):fmtN(b))+'</div>'
        +'<div style="font-size:13px;font-weight:700;color:'+v.col+';margin-top:4px">'+v.txt+'</div>'
        +'</div>';
    }

    var tickProm = act.facturas > 0 ? (act.venta/act.facturas) : 0;
    var tickAnt  = ant.facturas > 0 ? (ant.venta/ant.facturas) : 0;

    c.innerHTML =
       '<div style="display:flex;gap:11px;flex-wrap:wrap;margin-bottom:16px">'
      + bloque('Vendido '+a1,   act.venta,    ant.venta,    true)
      + bloque('Facturas',      act.facturas, ant.facturas, false)
      + bloque('Ticket medio',  tickProm,     tickAnt,      true)
      + bloque('Devoluciones',  act.devol,    ant.devol,    true)
      +'</div>'
      +'<div style="overflow-x:auto"><table class="tbl">'
      +'<tr><th></th><th style="text-align:right">'+a1+'</th>'
        +'<th style="text-align:right">'+a0+'</th>'
        +'<th style="text-align:right">Diferencia</th>'
        +'<th style="text-align:right">Variaci\u00f3n</th></tr>'
      + [['Facturado bruto', act.bruto, ant.bruto, true],
         ['Devoluciones',    act.devol, ant.devol, true],
         ['Venta neta',      act.venta, ant.venta, true],
         ['N\u00famero de facturas', act.facturas, ant.facturas, false],
         ['Ticket medio',    tickProm,  tickAnt,   true]
        ].map(function(f){
          var v = _vpVar(f[1], f[2]);
          var dif = (Number(f[1])||0) - (Number(f[2])||0);
          return '<tr>'
            +'<td><b>'+f[0]+'</b></td>'
            +'<td style="text-align:right;font-weight:600">'+(f[3]?fmt(f[1]):fmtN(f[1]))+'</td>'
            +'<td style="text-align:right;color:var(--text3)">'+(f[3]?fmt(f[2]):fmtN(f[2]))+'</td>'
            +'<td style="text-align:right;color:'+(dif>=0?'var(--green)':'var(--red)')+'">'
              +(dif>=0?'+':'')+(f[3]?fmt(dif):fmtN(dif))+'</td>'
            +'<td style="text-align:right;color:'+v.col+'">'+v.txt+'</td></tr>';
        }).join('')
      +'</table></div>'
      +'<div style="font-size:11.5px;color:var(--text3);margin-top:13px;line-height:1.5">'
      +'Del 1 de enero al d\u00eda de hoy en los dos a\u00f1os, para que la '
      +'comparaci\u00f3n sea justa. La venta neta descuenta las devoluciones.</div>';
  }catch(e){
    c.innerHTML='<div style="padding:20px;color:var(--red)">'
      +npEsc(String(e.message||e).slice(0,150))+'</div>';
  }
}


// ════════════════════════════════════════════════════════════════════
//  CATÁLOGO POR ENTRADA
//  Se eligen una o varias entradas y se arma el catálogo con todas
//  juntas. Es lo habitual: llega un contenedor con mercancía de dos o
//  tres órdenes y se manda un solo catálogo al cliente.
// ════════════════════════════════════════════════════════════════════
var PL_ENT_SEL = {};

function plEntradasAbrir(){
  if(!PL_ROWS || !PL_ROWS.length){ alert('No hay mercanc\u00eda cargada.'); return; }

  // Una entrada = una orden de compra. Se agrupan sus líneas.
  var ent = {};
  PL_ROWS.forEach(function(r){
    var k = String(r.docnum || 'sin');
    if(!ent[k]) ent[k] = {docnum:r.docnum, items:0, pend:0, fecha:null,
                          proveedor:r.proveedor||'', contenedor:r.contenedor||'',
                          depts:{}};
    ent[k].items++;
    ent[k].pend += Number(r.pend)||0;
    if(r.dept) ent[k].depts[r.dept] = 1;
    var f = String(r.fecha||'').substring(0,10);
    if(f && (!ent[k].fecha || f < ent[k].fecha)) ent[k].fecha = f;
  });

  var lista = Object.keys(ent).map(function(k){ return ent[k]; })
    .sort(function(a,b){ return String(a.fecha||'9999').localeCompare(String(b.fecha||'9999')); });

  var prev=document.getElementById('pl-ent'); if(prev) prev.remove();
  var m=document.createElement('div');
  m.id='pl-ent';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;max-width:760px;'
    +'width:100%;max-height:90vh;display:flex;flex-direction:column">'
    +'<div style="padding:14px 18px;border-bottom:1px solid var(--border);display:flex;'
      +'align-items:center;gap:10px">'
      +'<b style="flex:1;font-size:15px">\u{1F4E6} Cat\u00e1logo por entrada</b>'
      +'<button onclick="document.getElementById(\'pl-ent\').remove()" '
        +'style="border:none;background:none;font-size:23px;cursor:pointer;color:var(--text3);line-height:1">&times;</button>'
    +'</div>'
    +'<div style="flex:1;overflow-y:auto;padding:16px 18px">'
      +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:12px;line-height:1.5">'
      +'Marca las entradas que quieres incluir. Puedes juntar varias en un '
      +'mismo cat\u00e1logo: si un contenedor trae mercanc\u00eda de dos \u00f3rdenes, '
      +'se manda uno solo.</div>'
      +'<div style="display:flex;gap:7px;margin-bottom:11px;flex-wrap:wrap">'
        +'<button class="btn btn-sm" onclick="plEntTodas(true)">Marcar todas</button>'
        +'<button class="btn btn-sm" onclick="plEntTodas(false)">Ninguna</button>'
      +'</div>'
      +'<div id="pl-ent-lista"></div>'
    +'</div>'
    +'<div style="padding:13px 18px;border-top:1px solid var(--border);display:flex;gap:8px;align-items:center">'
      +'<span id="pl-ent-res" style="flex:1;font-size:12.5px;color:var(--text3)"></span>'
      +'<button class="btn btn-sm" onclick="document.getElementById(\'pl-ent\').remove()">Cancelar</button>'
      +'<button class="btn btn-sm btn-p" onclick="plEntGenerar()">Continuar</button>'
    +'</div></div>';
  document.body.appendChild(m);

  window._PL_ENT_LISTA = lista;
  // Al abrir, ninguna marcada: se elige a propósito qué va al catálogo.
  PL_ENT_SEL = {};
  plEntPintar();
}

function plEntPintar(){
  var c=document.getElementById('pl-ent-lista'); if(!c) return;
  var lista = window._PL_ENT_LISTA || [];
  var admin = (typeof veCompras==='function') && veCompras();

  c.innerHTML = lista.map(function(e, i){
    var sel = !!PL_ENT_SEL[String(e.docnum)];
    var depts = Object.keys(e.depts);
    // A los vendedores no se les dice el proveedor: solo que son entradas
    // distintas. Se numeran por orden de llegada.
    var titulo = admin
      ? ((e.proveedor || 'Sin proveedor') + ' \u00b7 OC ' + e.docnum)
      : ('Entrada ' + (i+1));
    return '<label style="display:flex;gap:11px;align-items:flex-start;padding:11px 12px;'
      +'border:1px solid '+(sel?'var(--blue2)':'var(--border)')+';border-radius:10px;'
      +'margin-bottom:8px;cursor:pointer;'+(sel?'background:rgba(0,159,227,.06)':'')+'">'
      +'<input type="checkbox"'+(sel?' checked':'')+' style="margin-top:2px" '
        +'onchange="plEntMarcar(\''+e.docnum+'\',this.checked)">'
      +'<div style="flex:1;min-width:0">'
        +'<div style="font-size:13.5px;font-weight:600">'+npEsc(titulo)+'</div>'
        +'<div style="font-size:12px;color:var(--text3);margin-top:2px">'
          + fmtN(e.items)+' art\u00edculo(s) \u00b7 '+fmtN(Math.round(e.pend))+' unidades'
          + (e.fecha ? (' \u00b7 llega ' + _plFechaLbl(e.fecha)) : ' \u00b7 sin fecha')
          + (admin && e.contenedor ? (' \u00b7 ' + npEsc(e.contenedor)) : '')
        +'</div>'
        + (depts.length
            ? ('<div style="font-size:11.5px;color:var(--text3);margin-top:3px">'
               + npEsc(depts.slice(0,4).join(', '))
               + (depts.length>4 ? (' +'+(depts.length-4)) : '') + '</div>')
            : '')
      +'</div></label>';
  }).join('');

  var n = Object.keys(PL_ENT_SEL).filter(function(k){ return PL_ENT_SEL[k]; }).length;
  var arts = PL_ROWS.filter(function(r){ return PL_ENT_SEL[String(r.docnum)]; }).length;
  var res = document.getElementById('pl-ent-res');
  if(res) res.textContent = n
    ? (n + ' entrada(s) \u00b7 ' + arts + ' art\u00edculo(s)')
    : 'No has marcado ninguna entrada';
}

function plEntMarcar(dn, v){ PL_ENT_SEL[String(dn)] = !!v; plEntPintar(); }
function plEntTodas(v){
  (window._PL_ENT_LISTA||[]).forEach(function(e){ PL_ENT_SEL[String(e.docnum)] = !!v; });
  plEntPintar();
}

async function plEntGenerar(){
  var docs = Object.keys(PL_ENT_SEL).filter(function(k){ return PL_ENT_SEL[k]; });
  if(!docs.length){ alert('Marca al menos una entrada.'); return; }
  var m=document.getElementById('pl-ent'); if(m) m.remove();
  await catDesdePorLlegar(null, docs);
}


// ── ¿Es un cliente de NAPA? ───────────────────────────────────────────────
// La marca 'napa' se pone al elegirlo en la pantalla de NAPA, pero hay vías
// que la pierden: retomar un borrador, el reporte de viabilidad, o el
// buscador general.
//
// Por eso se mira también el código. Los de NAPA llevan el prefijo C y no
// existen en kennedydb; si se mandan tal cual, SAP responde "Invalid BP
// code" y el pedido se queda en la cola.
function _npEsNapa(cli){
  if(!cli) return false;
  if(cli.napa === true) return true;
  if(cli.empresa && String(cli.empresa).toLowerCase() === 'napa') return true;
  // El código paraguas ya es de Kennedy: no hay que volver a convertirlo.
  var cc = String(cli.cardcode || '').trim().toUpperCase();
  if(!cc || cc === NAPA_CARDCODE) return false;
  return /^C\d+$/.test(cc);
}
